module.exports = {
  _id: '5d6615769bcb6d0e6d79db79',
  author: 'Brian Caulfield',
  name: 'Graph 0.3 Threshold',
  graphs: {
    ocd: {
      _id: '5d6615769bcb6d0e6d79db7a',
      filenames: {
        edgeList: 'ocd_0.3',
        coordinates: '100_node_centers_mm_coords.txt',
        nodeNames: 'region_names_full_file.txt',
        nodeIds: 'region_names_abbrev_file.txt',
        orbits: 'orca_ocd_0.3',
      },
      nodes: [
        {
          _id: '5d6615769bcb6d0e6d7a06cf',
          id: 0,
          abbrevName: '1',
          fullName: '1_L_Putamen',
          coordinates: {
            x: -29.670103,
            y: -6.28866,
            z: 2.28866,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0719',
              to: 1,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0718',
              to: 2,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0717',
              to: 4,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0716',
              to: 5,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0715',
              to: 6,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0714',
              to: 7,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0713',
              to: 8,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0712',
              to: 9,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0711',
              to: 11,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0710',
              to: 12,
            },
            {
              _id: '5d6615769bcb6d0e6d7a070f',
              to: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d7a070e',
              to: 14,
            },
            {
              _id: '5d6615769bcb6d0e6d7a070d',
              to: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d7a070c',
              to: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d7a070b',
              to: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d7a070a',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0709',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0708',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0707',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0706',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0705',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0704',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0703',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0702',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0701',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0700',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06ff',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06fe',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06fd',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06fc',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06fb',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06fa',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06f9',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06f8',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06f7',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06f6',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06f5',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06f4',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06f3',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06f2',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06f1',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06f0',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06ef',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06ee',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06ed',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06ec',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06eb',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06ea',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06e9',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06e8',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06e7',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06e6',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06e5',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06e4',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06e3',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06e2',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06e1',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06e0',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06df',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06de',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06dd',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06dc',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06db',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06da',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06d9',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06d8',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06d7',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06d6',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06d5',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06d4',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06d3',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06d2',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06d1',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06d0',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0762',
              id: 0,
              frequency: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0761',
              id: 1,
              frequency: 1099,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0760',
              id: 2,
              frequency: 217,
            },
            {
              _id: '5d6615769bcb6d0e6d7a075f',
              id: 3,
              frequency: 2484,
            },
            {
              _id: '5d6615769bcb6d0e6d7a075e',
              id: 4,
              frequency: 4301,
            },
            {
              _id: '5d6615769bcb6d0e6d7a075d',
              id: 5,
              frequency: 2999,
            },
            {
              _id: '5d6615769bcb6d0e6d7a075c',
              id: 6,
              frequency: 1625,
            },
            {
              _id: '5d6615769bcb6d0e6d7a075b',
              id: 7,
              frequency: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a075a',
              id: 8,
              frequency: 1492,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0759',
              id: 9,
              frequency: 6902,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0758',
              id: 10,
              frequency: 20266,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0757',
              id: 11,
              frequency: 2837,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0756',
              id: 12,
              frequency: 26989,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0755',
              id: 13,
              frequency: 9755,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0754',
              id: 14,
              frequency: 52167,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0753',
              id: 15,
              frequency: 7087,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0752',
              id: 16,
              frequency: 4830,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0751',
              id: 17,
              frequency: 4632,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0750',
              id: 18,
              frequency: 2689,
            },
            {
              _id: '5d6615769bcb6d0e6d7a074f',
              id: 19,
              frequency: 6027,
            },
            {
              _id: '5d6615769bcb6d0e6d7a074e',
              id: 20,
              frequency: 2839,
            },
            {
              _id: '5d6615769bcb6d0e6d7a074d',
              id: 21,
              frequency: 712,
            },
            {
              _id: '5d6615769bcb6d0e6d7a074c',
              id: 22,
              frequency: 626,
            },
            {
              _id: '5d6615769bcb6d0e6d7a074b',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d7a074a',
              id: 24,
              frequency: 15491,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0749',
              id: 25,
              frequency: 13451,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0748',
              id: 26,
              frequency: 10778,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0747',
              id: 27,
              frequency: 9470,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0746',
              id: 28,
              frequency: 10298,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0745',
              id: 29,
              frequency: 50258,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0744',
              id: 30,
              frequency: 12805,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0743',
              id: 31,
              frequency: 7038,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0742',
              id: 32,
              frequency: 14474,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0741',
              id: 33,
              frequency: 194,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0740',
              id: 34,
              frequency: 2855,
            },
            {
              _id: '5d6615769bcb6d0e6d7a073f',
              id: 35,
              frequency: 1333,
            },
            {
              _id: '5d6615769bcb6d0e6d7a073e',
              id: 36,
              frequency: 1937,
            },
            {
              _id: '5d6615769bcb6d0e6d7a073d',
              id: 37,
              frequency: 5051,
            },
            {
              _id: '5d6615769bcb6d0e6d7a073c',
              id: 38,
              frequency: 633,
            },
            {
              _id: '5d6615769bcb6d0e6d7a073b',
              id: 39,
              frequency: 9553,
            },
            {
              _id: '5d6615769bcb6d0e6d7a073a',
              id: 40,
              frequency: 54531,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0739',
              id: 41,
              frequency: 12150,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0738',
              id: 42,
              frequency: 2423,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0737',
              id: 43,
              frequency: 58565,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0736',
              id: 44,
              frequency: 1827,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0735',
              id: 45,
              frequency: 16010,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0734',
              id: 46,
              frequency: 47328,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0733',
              id: 47,
              frequency: 16548,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0732',
              id: 48,
              frequency: 51392,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0731',
              id: 49,
              frequency: 568,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0730',
              id: 50,
              frequency: 184,
            },
            {
              _id: '5d6615769bcb6d0e6d7a072f',
              id: 51,
              frequency: 13427,
            },
            {
              _id: '5d6615769bcb6d0e6d7a072e',
              id: 52,
              frequency: 9110,
            },
            {
              _id: '5d6615769bcb6d0e6d7a072d',
              id: 53,
              frequency: 11075,
            },
            {
              _id: '5d6615769bcb6d0e6d7a072c',
              id: 54,
              frequency: 20297,
            },
            {
              _id: '5d6615769bcb6d0e6d7a072b',
              id: 55,
              frequency: 1804,
            },
            {
              _id: '5d6615769bcb6d0e6d7a072a',
              id: 56,
              frequency: 26531,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0729',
              id: 57,
              frequency: 241134,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0728',
              id: 58,
              frequency: 23970,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0727',
              id: 59,
              frequency: 122998,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0726',
              id: 60,
              frequency: 81287,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0725',
              id: 61,
              frequency: 10652,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0724',
              id: 62,
              frequency: 5257,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0723',
              id: 63,
              frequency: 12775,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0722',
              id: 64,
              frequency: 13580,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0721',
              id: 65,
              frequency: 144022,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0720',
              id: 66,
              frequency: 385446,
            },
            {
              _id: '5d6615769bcb6d0e6d7a071f',
              id: 67,
              frequency: 95671,
            },
            {
              _id: '5d6615769bcb6d0e6d7a071e',
              id: 68,
              frequency: 56034,
            },
            {
              _id: '5d6615769bcb6d0e6d7a071d',
              id: 69,
              frequency: 3287,
            },
            {
              _id: '5d6615769bcb6d0e6d7a071c',
              id: 70,
              frequency: 445028,
            },
            {
              _id: '5d6615769bcb6d0e6d7a071b',
              id: 71,
              frequency: 229488,
            },
            {
              _id: '5d6615769bcb6d0e6d7a071a',
              id: 72,
              frequency: 781310,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0631',
          id: 1,
          abbrevName: '2',
          fullName: '2_L_MFG',
          coordinates: {
            x: -37.592357,
            y: 37.363057,
            z: 27.949045,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0685',
              to: 3,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0684',
              to: 4,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0683',
              to: 6,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0682',
              to: 7,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0681',
              to: 8,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0680',
              to: 9,
            },
            {
              _id: '5d6615769bcb6d0e6d7a067f',
              to: 10,
            },
            {
              _id: '5d6615769bcb6d0e6d7a067e',
              to: 11,
            },
            {
              _id: '5d6615769bcb6d0e6d7a067d',
              to: 12,
            },
            {
              _id: '5d6615769bcb6d0e6d7a067c',
              to: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d7a067b',
              to: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d7a067a',
              to: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0679',
              to: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0678',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0677',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0676',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0675',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0674',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0673',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0672',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0671',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0670',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a066f',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a066e',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a066d',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d7a066c',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a066b',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d7a066a',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0669',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0668',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0667',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0666',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0665',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0664',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0663',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0662',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0661',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0660',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a065f',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a065e',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a065d',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a065c',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a065b',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a065a',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0659',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0658',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0657',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0656',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0655',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0654',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0653',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0652',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0651',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0650',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a064f',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a064e',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a064d',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a064c',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a064b',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a064a',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0649',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0648',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0647',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0646',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0645',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0644',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0643',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0642',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0641',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0640',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a063f',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a063e',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a063d',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a063c',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a063b',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a063a',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0639',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0638',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0637',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0636',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0635',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0634',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0633',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0632',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a06ce',
              id: 0,
              frequency: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06cd',
              id: 1,
              frequency: 503,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06cc',
              id: 2,
              frequency: 382,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06cb',
              id: 3,
              frequency: 3188,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06ca',
              id: 4,
              frequency: 2311,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06c9',
              id: 5,
              frequency: 2521,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06c8',
              id: 6,
              frequency: 184,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06c7',
              id: 7,
              frequency: 183,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06c6',
              id: 8,
              frequency: 819,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06c5',
              id: 9,
              frequency: 1419,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06c4',
              id: 10,
              frequency: 14713,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06c3',
              id: 11,
              frequency: 5434,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06c2',
              id: 12,
              frequency: 11690,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06c1',
              id: 13,
              frequency: 20289,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06c0',
              id: 14,
              frequency: 72864,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06bf',
              id: 15,
              frequency: 1710,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06be',
              id: 16,
              frequency: 7549,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06bd',
              id: 17,
              frequency: 828,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06bc',
              id: 18,
              frequency: 1651,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06bb',
              id: 19,
              frequency: 447,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06ba',
              id: 20,
              frequency: 749,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06b9',
              id: 21,
              frequency: 1164,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06b8',
              id: 22,
              frequency: 28,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06b7',
              id: 23,
              frequency: 1,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06b6',
              id: 24,
              frequency: 2636,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06b5',
              id: 25,
              frequency: 2188,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06b4',
              id: 26,
              frequency: 14861,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06b3',
              id: 27,
              frequency: 4453,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06b2',
              id: 28,
              frequency: 4943,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06b1',
              id: 29,
              frequency: 47966,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06b0',
              id: 30,
              frequency: 11557,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06af',
              id: 31,
              frequency: 286,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06ae',
              id: 32,
              frequency: 4160,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06ad',
              id: 33,
              frequency: 1136,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06ac',
              id: 34,
              frequency: 1419,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06ab',
              id: 35,
              frequency: 162,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06aa',
              id: 36,
              frequency: 2389,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06a9',
              id: 37,
              frequency: 651,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06a8',
              id: 38,
              frequency: 540,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06a7',
              id: 39,
              frequency: 733,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06a6',
              id: 40,
              frequency: 7342,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06a5',
              id: 41,
              frequency: 20886,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06a4',
              id: 42,
              frequency: 6591,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06a3',
              id: 43,
              frequency: 22266,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06a2',
              id: 44,
              frequency: 6662,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06a1',
              id: 45,
              frequency: 3936,
            },
            {
              _id: '5d6615769bcb6d0e6d7a06a0',
              id: 46,
              frequency: 37373,
            },
            {
              _id: '5d6615769bcb6d0e6d7a069f',
              id: 47,
              frequency: 12692,
            },
            {
              _id: '5d6615769bcb6d0e6d7a069e',
              id: 48,
              frequency: 65330,
            },
            {
              _id: '5d6615769bcb6d0e6d7a069d',
              id: 49,
              frequency: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a069c',
              id: 50,
              frequency: 158,
            },
            {
              _id: '5d6615769bcb6d0e6d7a069b',
              id: 51,
              frequency: 4377,
            },
            {
              _id: '5d6615769bcb6d0e6d7a069a',
              id: 52,
              frequency: 5172,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0699',
              id: 53,
              frequency: 8574,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0698',
              id: 54,
              frequency: 1234,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0697',
              id: 55,
              frequency: 6139,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0696',
              id: 56,
              frequency: 2504,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0695',
              id: 57,
              frequency: 254552,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0694',
              id: 58,
              frequency: 32997,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0693',
              id: 59,
              frequency: 41526,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0692',
              id: 60,
              frequency: 68572,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0691',
              id: 61,
              frequency: 32757,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0690',
              id: 62,
              frequency: 936,
            },
            {
              _id: '5d6615769bcb6d0e6d7a068f',
              id: 63,
              frequency: 6565,
            },
            {
              _id: '5d6615769bcb6d0e6d7a068e',
              id: 64,
              frequency: 11397,
            },
            {
              _id: '5d6615769bcb6d0e6d7a068d',
              id: 65,
              frequency: 22106,
            },
            {
              _id: '5d6615769bcb6d0e6d7a068c',
              id: 66,
              frequency: 245086,
            },
            {
              _id: '5d6615769bcb6d0e6d7a068b',
              id: 67,
              frequency: 238981,
            },
            {
              _id: '5d6615769bcb6d0e6d7a068a',
              id: 68,
              frequency: 33862,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0689',
              id: 69,
              frequency: 11841,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0688',
              id: 70,
              frequency: 189877,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0687',
              id: 71,
              frequency: 523925,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0686',
              id: 72,
              frequency: 1163755,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a05ad',
          id: 2,
          abbrevName: '3',
          fullName: '3_BI_brainstem',
          coordinates: {
            x: 1.141956,
            y: -25.987382,
            z: -33.438486,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a05e7',
              to: 4,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05e6',
              to: 5,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05e5',
              to: 6,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05e4',
              to: 7,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05e3',
              to: 10,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05e2',
              to: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05e1',
              to: 14,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05e0',
              to: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05df',
              to: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05de',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05dd',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05dc',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05db',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05da',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05d9',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05d8',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05d7',
              to: 28,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05d6',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05d5',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05d4',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05d3',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05d2',
              to: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05d1',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05d0',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05cf',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05ce',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05cd',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05cc',
              to: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05cb',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05ca',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05c9',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05c8',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05c7',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05c6',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05c5',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05c4',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05c3',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05c2',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05c1',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05c0',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05bf',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05be',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05bd',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05bc',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05bb',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05ba',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05b9',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05b8',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05b7',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05b6',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05b5',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05b4',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05b3',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05b2',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05b1',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05b0',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05af',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05ae',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0630',
              id: 0,
              frequency: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a062f',
              id: 1,
              frequency: 1766,
            },
            {
              _id: '5d6615769bcb6d0e6d7a062e',
              id: 2,
              frequency: 318,
            },
            {
              _id: '5d6615769bcb6d0e6d7a062d',
              id: 3,
              frequency: 1393,
            },
            {
              _id: '5d6615769bcb6d0e6d7a062c',
              id: 4,
              frequency: 7726,
            },
            {
              _id: '5d6615769bcb6d0e6d7a062b',
              id: 5,
              frequency: 8090,
            },
            {
              _id: '5d6615769bcb6d0e6d7a062a',
              id: 6,
              frequency: 2907,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0629',
              id: 7,
              frequency: 397,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0628',
              id: 8,
              frequency: 3170,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0627',
              id: 9,
              frequency: 25025,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0626',
              id: 10,
              frequency: 13980,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0625',
              id: 11,
              frequency: 4784,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0624',
              id: 12,
              frequency: 37009,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0623',
              id: 13,
              frequency: 7367,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0622',
              id: 14,
              frequency: 19961,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0621',
              id: 15,
              frequency: 11551,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0620',
              id: 16,
              frequency: 20296,
            },
            {
              _id: '5d6615769bcb6d0e6d7a061f',
              id: 17,
              frequency: 9277,
            },
            {
              _id: '5d6615769bcb6d0e6d7a061e',
              id: 18,
              frequency: 3377,
            },
            {
              _id: '5d6615769bcb6d0e6d7a061d',
              id: 19,
              frequency: 9448,
            },
            {
              _id: '5d6615769bcb6d0e6d7a061c',
              id: 20,
              frequency: 8841,
            },
            {
              _id: '5d6615769bcb6d0e6d7a061b',
              id: 21,
              frequency: 7736,
            },
            {
              _id: '5d6615769bcb6d0e6d7a061a',
              id: 22,
              frequency: 770,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0619',
              id: 23,
              frequency: 93,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0618',
              id: 24,
              frequency: 41604,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0617',
              id: 25,
              frequency: 12849,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0616',
              id: 26,
              frequency: 28644,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0615',
              id: 27,
              frequency: 32577,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0614',
              id: 28,
              frequency: 83248,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0613',
              id: 29,
              frequency: 28019,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0612',
              id: 30,
              frequency: 15061,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0611',
              id: 31,
              frequency: 18030,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0610',
              id: 32,
              frequency: 7905,
            },
            {
              _id: '5d6615769bcb6d0e6d7a060f',
              id: 33,
              frequency: 3458,
            },
            {
              _id: '5d6615769bcb6d0e6d7a060e',
              id: 34,
              frequency: 7885,
            },
            {
              _id: '5d6615769bcb6d0e6d7a060d',
              id: 35,
              frequency: 3205,
            },
            {
              _id: '5d6615769bcb6d0e6d7a060c',
              id: 36,
              frequency: 3439,
            },
            {
              _id: '5d6615769bcb6d0e6d7a060b',
              id: 37,
              frequency: 9921,
            },
            {
              _id: '5d6615769bcb6d0e6d7a060a',
              id: 38,
              frequency: 6527,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0609',
              id: 39,
              frequency: 54544,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0608',
              id: 40,
              frequency: 64327,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0607',
              id: 41,
              frequency: 12292,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0606',
              id: 42,
              frequency: 11392,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0605',
              id: 43,
              frequency: 69361,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0604',
              id: 44,
              frequency: 4283,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0603',
              id: 45,
              frequency: 70608,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0602',
              id: 46,
              frequency: 37428,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0601',
              id: 47,
              frequency: 95778,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0600',
              id: 48,
              frequency: 35269,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05ff',
              id: 49,
              frequency: 1123,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05fe',
              id: 50,
              frequency: 702,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05fd',
              id: 51,
              frequency: 51844,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05fc',
              id: 52,
              frequency: 9672,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05fb',
              id: 53,
              frequency: 17981,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05fa',
              id: 54,
              frequency: 37683,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05f9',
              id: 55,
              frequency: 3552,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05f8',
              id: 56,
              frequency: 221345,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05f7',
              id: 57,
              frequency: 70573,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05f6',
              id: 58,
              frequency: 39299,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05f5',
              id: 59,
              frequency: 231101,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05f4',
              id: 60,
              frequency: 129032,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05f3',
              id: 61,
              frequency: 14703,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05f2',
              id: 62,
              frequency: 25918,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05f1',
              id: 63,
              frequency: 23869,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05f0',
              id: 64,
              frequency: 9319,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05ef',
              id: 65,
              frequency: 482030,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05ee',
              id: 66,
              frequency: 200783,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05ed',
              id: 67,
              frequency: 73769,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05ec',
              id: 68,
              frequency: 97019,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05eb',
              id: 69,
              frequency: 2572,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05ea',
              id: 70,
              frequency: 488671,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05e9',
              id: 71,
              frequency: 101636,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05e8',
              id: 72,
              frequency: 200369,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0519',
          id: 3,
          abbrevName: '4',
          fullName: '4_BI_PCC_precuneous',
          coordinates: {
            x: 0.511041,
            y: -47.804416,
            z: 37.526814,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0563',
              to: 4,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0562',
              to: 5,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0561',
              to: 6,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0560',
              to: 7,
            },
            {
              _id: '5d6615769bcb6d0e6d7a055f',
              to: 8,
            },
            {
              _id: '5d6615769bcb6d0e6d7a055e',
              to: 9,
            },
            {
              _id: '5d6615769bcb6d0e6d7a055d',
              to: 12,
            },
            {
              _id: '5d6615769bcb6d0e6d7a055c',
              to: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d7a055b',
              to: 14,
            },
            {
              _id: '5d6615769bcb6d0e6d7a055a',
              to: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0559',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0558',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0557',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0556',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0555',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0554',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0553',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0552',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0551',
              to: 28,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0550',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a054f',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a054e',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d7a054d',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a054c',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a054b',
              to: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d7a054a',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0549',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0548',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0547',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0546',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0545',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0544',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0543',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0542',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0541',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0540',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a053f',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a053e',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a053d',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a053c',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a053b',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a053a',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0539',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0538',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0537',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0536',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0535',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0534',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0533',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0532',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0531',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0530',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a052f',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a052e',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a052d',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a052c',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a052b',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a052a',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0529',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0528',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0527',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0526',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0525',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0524',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0523',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0522',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0521',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0520',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a051f',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a051e',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a051d',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a051c',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a051b',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a051a',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a05ac',
              id: 0,
              frequency: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05ab',
              id: 1,
              frequency: 1137,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05aa',
              id: 2,
              frequency: 306,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05a9',
              id: 3,
              frequency: 2469,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05a8',
              id: 4,
              frequency: 2826,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05a7',
              id: 5,
              frequency: 4575,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05a6',
              id: 6,
              frequency: 1496,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05a5',
              id: 7,
              frequency: 132,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05a4',
              id: 8,
              frequency: 1557,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05a3',
              id: 9,
              frequency: 7359,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05a2',
              id: 10,
              frequency: 18427,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05a1',
              id: 11,
              frequency: 4329,
            },
            {
              _id: '5d6615769bcb6d0e6d7a05a0',
              id: 12,
              frequency: 29011,
            },
            {
              _id: '5d6615769bcb6d0e6d7a059f',
              id: 13,
              frequency: 13284,
            },
            {
              _id: '5d6615769bcb6d0e6d7a059e',
              id: 14,
              frequency: 49780,
            },
            {
              _id: '5d6615769bcb6d0e6d7a059d',
              id: 15,
              frequency: 3292,
            },
            {
              _id: '5d6615769bcb6d0e6d7a059c',
              id: 16,
              frequency: 5221,
            },
            {
              _id: '5d6615769bcb6d0e6d7a059b',
              id: 17,
              frequency: 9023,
            },
            {
              _id: '5d6615769bcb6d0e6d7a059a',
              id: 18,
              frequency: 948,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0599',
              id: 19,
              frequency: 5021,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0598',
              id: 20,
              frequency: 3582,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0597',
              id: 21,
              frequency: 1351,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0596',
              id: 22,
              frequency: 549,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0595',
              id: 23,
              frequency: 10,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0594',
              id: 24,
              frequency: 7276,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0593',
              id: 25,
              frequency: 19270,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0592',
              id: 26,
              frequency: 14981,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0591',
              id: 27,
              frequency: 6836,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0590',
              id: 28,
              frequency: 20145,
            },
            {
              _id: '5d6615769bcb6d0e6d7a058f',
              id: 29,
              frequency: 26629,
            },
            {
              _id: '5d6615769bcb6d0e6d7a058e',
              id: 30,
              frequency: 16914,
            },
            {
              _id: '5d6615769bcb6d0e6d7a058d',
              id: 31,
              frequency: 7439,
            },
            {
              _id: '5d6615769bcb6d0e6d7a058c',
              id: 32,
              frequency: 11688,
            },
            {
              _id: '5d6615769bcb6d0e6d7a058b',
              id: 33,
              frequency: 586,
            },
            {
              _id: '5d6615769bcb6d0e6d7a058a',
              id: 34,
              frequency: 1994,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0589',
              id: 35,
              frequency: 766,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0588',
              id: 36,
              frequency: 1120,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0587',
              id: 37,
              frequency: 5368,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0586',
              id: 38,
              frequency: 1362,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0585',
              id: 39,
              frequency: 6368,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0584',
              id: 40,
              frequency: 57660,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0583',
              id: 41,
              frequency: 16447,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0582',
              id: 42,
              frequency: 5111,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0581',
              id: 43,
              frequency: 50743,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0580',
              id: 44,
              frequency: 3329,
            },
            {
              _id: '5d6615769bcb6d0e6d7a057f',
              id: 45,
              frequency: 10070,
            },
            {
              _id: '5d6615769bcb6d0e6d7a057e',
              id: 46,
              frequency: 19119,
            },
            {
              _id: '5d6615769bcb6d0e6d7a057d',
              id: 47,
              frequency: 39138,
            },
            {
              _id: '5d6615769bcb6d0e6d7a057c',
              id: 48,
              frequency: 63120,
            },
            {
              _id: '5d6615769bcb6d0e6d7a057b',
              id: 49,
              frequency: 348,
            },
            {
              _id: '5d6615769bcb6d0e6d7a057a',
              id: 50,
              frequency: 174,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0579',
              id: 51,
              frequency: 13788,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0578',
              id: 52,
              frequency: 6994,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0577',
              id: 53,
              frequency: 11903,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0576',
              id: 54,
              frequency: 15855,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0575',
              id: 55,
              frequency: 3181,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0574',
              id: 56,
              frequency: 31146,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0573',
              id: 57,
              frequency: 195441,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0572',
              id: 58,
              frequency: 33970,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0571',
              id: 59,
              frequency: 105032,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0570',
              id: 60,
              frequency: 126441,
            },
            {
              _id: '5d6615769bcb6d0e6d7a056f',
              id: 61,
              frequency: 21522,
            },
            {
              _id: '5d6615769bcb6d0e6d7a056e',
              id: 62,
              frequency: 5111,
            },
            {
              _id: '5d6615769bcb6d0e6d7a056d',
              id: 63,
              frequency: 11100,
            },
            {
              _id: '5d6615769bcb6d0e6d7a056c',
              id: 64,
              frequency: 12286,
            },
            {
              _id: '5d6615769bcb6d0e6d7a056b',
              id: 65,
              frequency: 172318,
            },
            {
              _id: '5d6615769bcb6d0e6d7a056a',
              id: 66,
              frequency: 340189,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0569',
              id: 67,
              frequency: 142024,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0568',
              id: 68,
              frequency: 65388,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0567',
              id: 69,
              frequency: 7447,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0566',
              id: 70,
              frequency: 490053,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0565',
              id: 71,
              frequency: 292457,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0564',
              id: 72,
              frequency: 705813,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a047a',
          id: 4,
          abbrevName: '5',
          fullName: '5_R_MFG',
          coordinates: {
            x: 46.120172,
            y: 13.708155,
            z: 36.017167,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a04cf',
              to: 6,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04ce',
              to: 7,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04cd',
              to: 8,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04cc',
              to: 9,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04cb',
              to: 11,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04ca',
              to: 12,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04c9',
              to: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04c8',
              to: 14,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04c7',
              to: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04c6',
              to: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04c5',
              to: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04c4',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04c3',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04c2',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04c1',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04c0',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04bf',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04be',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04bd',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04bc',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04bb',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04ba',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04b9',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04b8',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04b7',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04b6',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04b5',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04b4',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04b3',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04b2',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04b1',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04b0',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04af',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04ae',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04ad',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04ac',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04ab',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04aa',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04a9',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04a8',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04a7',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04a6',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04a5',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04a4',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04a3',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04a2',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04a1',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04a0',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a049f',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a049e',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a049d',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a049c',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a049b',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a049a',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0499',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0498',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0497',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0496',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0495',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0494',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0493',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0492',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0491',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0490',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a048f',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a048e',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a048d',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a048c',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a048b',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a048a',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0489',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0488',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0487',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0486',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0485',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0484',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0483',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0482',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0481',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0480',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a047f',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a047e',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a047d',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a047c',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a047b',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0518',
              id: 0,
              frequency: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0517',
              id: 1,
              frequency: 273,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0516',
              id: 2,
              frequency: 462,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0515',
              id: 3,
              frequency: 3454,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0514',
              id: 4,
              frequency: 758,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0513',
              id: 5,
              frequency: 2261,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0512',
              id: 6,
              frequency: 146,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0511',
              id: 7,
              frequency: 244,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0510',
              id: 8,
              frequency: 341,
            },
            {
              _id: '5d6615769bcb6d0e6d7a050f',
              id: 9,
              frequency: 357,
            },
            {
              _id: '5d6615769bcb6d0e6d7a050e',
              id: 10,
              frequency: 11629,
            },
            {
              _id: '5d6615769bcb6d0e6d7a050d',
              id: 11,
              frequency: 6894,
            },
            {
              _id: '5d6615769bcb6d0e6d7a050c',
              id: 12,
              frequency: 4726,
            },
            {
              _id: '5d6615769bcb6d0e6d7a050b',
              id: 13,
              frequency: 25674,
            },
            {
              _id: '5d6615769bcb6d0e6d7a050a',
              id: 14,
              frequency: 80752,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0509',
              id: 15,
              frequency: 138,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0508',
              id: 16,
              frequency: 4241,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0507',
              id: 17,
              frequency: 937,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0506',
              id: 18,
              frequency: 619,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0505',
              id: 19,
              frequency: 466,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0504',
              id: 20,
              frequency: 925,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0503',
              id: 21,
              frequency: 1265,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0502',
              id: 22,
              frequency: 11,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0501',
              id: 23,
              frequency: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0500',
              id: 24,
              frequency: 387,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04ff',
              id: 25,
              frequency: 3723,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04fe',
              id: 26,
              frequency: 13865,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04fd',
              id: 27,
              frequency: 820,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04fc',
              id: 28,
              frequency: 2966,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04fb',
              id: 29,
              frequency: 25162,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04fa',
              id: 30,
              frequency: 15743,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04f9',
              id: 31,
              frequency: 222,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04f8',
              id: 32,
              frequency: 4228,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04f7',
              id: 33,
              frequency: 1338,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04f6',
              id: 34,
              frequency: 359,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04f5',
              id: 35,
              frequency: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04f4',
              id: 36,
              frequency: 680,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04f3',
              id: 37,
              frequency: 516,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04f2',
              id: 38,
              frequency: 502,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04f1',
              id: 39,
              frequency: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04f0',
              id: 40,
              frequency: 5425,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04ef',
              id: 41,
              frequency: 20921,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04ee',
              id: 42,
              frequency: 9280,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04ed',
              id: 43,
              frequency: 10753,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04ec',
              id: 44,
              frequency: 8642,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04eb',
              id: 45,
              frequency: 563,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04ea',
              id: 46,
              frequency: 11017,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04e9',
              id: 47,
              frequency: 8249,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04e8',
              id: 48,
              frequency: 76824,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04e7',
              id: 49,
              frequency: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04e6',
              id: 50,
              frequency: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04e5',
              id: 51,
              frequency: 999,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04e4',
              id: 52,
              frequency: 1147,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04e3',
              id: 53,
              frequency: 6338,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04e2',
              id: 54,
              frequency: 838,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04e1',
              id: 55,
              frequency: 8932,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04e0',
              id: 56,
              frequency: 331,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04df',
              id: 57,
              frequency: 252847,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04de',
              id: 58,
              frequency: 40203,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04dd',
              id: 59,
              frequency: 9896,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04dc',
              id: 60,
              frequency: 48162,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04db',
              id: 61,
              frequency: 49359,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04da',
              id: 62,
              frequency: 133,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04d9',
              id: 63,
              frequency: 1904,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04d8',
              id: 64,
              frequency: 7697,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04d7',
              id: 65,
              frequency: 3268,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04d6',
              id: 66,
              frequency: 151802,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04d5',
              id: 67,
              frequency: 317753,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04d4',
              id: 68,
              frequency: 11241,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04d3',
              id: 69,
              frequency: 20194,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04d2',
              id: 70,
              frequency: 59521,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04d1',
              id: 71,
              frequency: 678444,
            },
            {
              _id: '5d6615769bcb6d0e6d7a04d0',
              id: 72,
              frequency: 1307457,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a040c',
          id: 5,
          abbrevName: '6',
          fullName: '6_R_Temporal_pole',
          coordinates: {
            x: 33.909091,
            y: 14.727273,
            z: -34.931818,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0430',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a042f',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a042e',
              to: 8,
            },
            {
              _id: '5d6615769bcb6d0e6d7a042d',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a042c',
              to: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d7a042b',
              to: 14,
            },
            {
              _id: '5d6615769bcb6d0e6d7a042a',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0429',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0428',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0427',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0426',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0425',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0424',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0423',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0422',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0421',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0420',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d7a041f',
              to: 28,
            },
            {
              _id: '5d6615769bcb6d0e6d7a041e',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a041d',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a041c',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a041b',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a041a',
              to: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0419',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0418',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0417',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0416',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0415',
              to: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0414',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0413',
              to: 99,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0412',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0411',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0410',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a040f',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a040e',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a040d',
              to: 63,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0479',
              id: 0,
              frequency: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0478',
              id: 1,
              frequency: 1688,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0477',
              id: 2,
              frequency: 123,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0476',
              id: 3,
              frequency: 618,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0475',
              id: 4,
              frequency: 12966,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0474',
              id: 5,
              frequency: 4988,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0473',
              id: 6,
              frequency: 3488,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0472',
              id: 7,
              frequency: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0471',
              id: 8,
              frequency: 1472,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0470',
              id: 9,
              frequency: 37068,
            },
            {
              _id: '5d6615769bcb6d0e6d7a046f',
              id: 10,
              frequency: 10784,
            },
            {
              _id: '5d6615769bcb6d0e6d7a046e',
              id: 11,
              frequency: 1100,
            },
            {
              _id: '5d6615769bcb6d0e6d7a046d',
              id: 12,
              frequency: 22714,
            },
            {
              _id: '5d6615769bcb6d0e6d7a046c',
              id: 13,
              frequency: 2156,
            },
            {
              _id: '5d6615769bcb6d0e6d7a046b',
              id: 14,
              frequency: 5818,
            },
            {
              _id: '5d6615769bcb6d0e6d7a046a',
              id: 15,
              frequency: 25721,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0469',
              id: 16,
              frequency: 23174,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0468',
              id: 17,
              frequency: 2999,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0467',
              id: 18,
              frequency: 9304,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0466',
              id: 19,
              frequency: 16253,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0465',
              id: 20,
              frequency: 7550,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0464',
              id: 21,
              frequency: 1876,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0463',
              id: 22,
              frequency: 1463,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0462',
              id: 23,
              frequency: 8,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0461',
              id: 24,
              frequency: 85760,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0460',
              id: 25,
              frequency: 9623,
            },
            {
              _id: '5d6615769bcb6d0e6d7a045f',
              id: 26,
              frequency: 10328,
            },
            {
              _id: '5d6615769bcb6d0e6d7a045e',
              id: 27,
              frequency: 87541,
            },
            {
              _id: '5d6615769bcb6d0e6d7a045d',
              id: 28,
              frequency: 94055,
            },
            {
              _id: '5d6615769bcb6d0e6d7a045c',
              id: 29,
              frequency: 49386,
            },
            {
              _id: '5d6615769bcb6d0e6d7a045b',
              id: 30,
              frequency: 6211,
            },
            {
              _id: '5d6615769bcb6d0e6d7a045a',
              id: 31,
              frequency: 31587,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0459',
              id: 32,
              frequency: 9891,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0458',
              id: 33,
              frequency: 276,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0457',
              id: 34,
              frequency: 4164,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0456',
              id: 35,
              frequency: 8894,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0455',
              id: 36,
              frequency: 2643,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0454',
              id: 37,
              frequency: 5172,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0453',
              id: 38,
              frequency: 1682,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0452',
              id: 39,
              frequency: 103911,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0451',
              id: 40,
              frequency: 53821,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0450',
              id: 41,
              frequency: 6157,
            },
            {
              _id: '5d6615769bcb6d0e6d7a044f',
              id: 42,
              frequency: 1226,
            },
            {
              _id: '5d6615769bcb6d0e6d7a044e',
              id: 43,
              frequency: 99159,
            },
            {
              _id: '5d6615769bcb6d0e6d7a044d',
              id: 44,
              frequency: 618,
            },
            {
              _id: '5d6615769bcb6d0e6d7a044c',
              id: 45,
              frequency: 196145,
            },
            {
              _id: '5d6615769bcb6d0e6d7a044b',
              id: 46,
              frequency: 48846,
            },
            {
              _id: '5d6615769bcb6d0e6d7a044a',
              id: 47,
              frequency: 35005,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0449',
              id: 48,
              frequency: 20394,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0448',
              id: 49,
              frequency: 740,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0447',
              id: 50,
              frequency: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0446',
              id: 51,
              frequency: 35402,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0445',
              id: 52,
              frequency: 11827,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0444',
              id: 53,
              frequency: 5303,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0443',
              id: 54,
              frequency: 27315,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0442',
              id: 55,
              frequency: 530,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0441',
              id: 56,
              frequency: 520830,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0440',
              id: 57,
              frequency: 42981,
            },
            {
              _id: '5d6615769bcb6d0e6d7a043f',
              id: 58,
              frequency: 5101,
            },
            {
              _id: '5d6615769bcb6d0e6d7a043e',
              id: 59,
              frequency: 249786,
            },
            {
              _id: '5d6615769bcb6d0e6d7a043d',
              id: 60,
              frequency: 58983,
            },
            {
              _id: '5d6615769bcb6d0e6d7a043c',
              id: 61,
              frequency: 2646,
            },
            {
              _id: '5d6615769bcb6d0e6d7a043b',
              id: 62,
              frequency: 19677,
            },
            {
              _id: '5d6615769bcb6d0e6d7a043a',
              id: 63,
              frequency: 5192,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0439',
              id: 64,
              frequency: 3808,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0438',
              id: 65,
              frequency: 445414,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0437',
              id: 66,
              frequency: 99054,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0436',
              id: 67,
              frequency: 13529,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0435',
              id: 68,
              frequency: 33122,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0434',
              id: 69,
              frequency: 524,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0433',
              id: 70,
              frequency: 191980,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0432',
              id: 71,
              frequency: 20177,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0431',
              id: 72,
              frequency: 37616,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a036b',
          id: 6,
          abbrevName: '7',
          fullName: '7_L_Cerebellum',
          coordinates: {
            x: -37.55,
            y: -69.533333,
            z: -37.85,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a03c2',
              to: 7,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03c1',
              to: 8,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03c0',
              to: 9,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03bf',
              to: 10,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03be',
              to: 11,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03bd',
              to: 12,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03bc',
              to: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03bb',
              to: 14,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03ba',
              to: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03b9',
              to: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03b8',
              to: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03b7',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03b6',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03b5',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03b4',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03b3',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03b2',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03b1',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03b0',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03af',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03ae',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03ad',
              to: 28,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03ac',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03ab',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03aa',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03a9',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03a8',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03a7',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03a6',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03a5',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03a4',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03a3',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03a2',
              to: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03a1',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03a0',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a039f',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a039e',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a039d',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a039c',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a039b',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a039a',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0399',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0398',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0397',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0396',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0395',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0394',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0393',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0392',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0391',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0390',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a038f',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a038e',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a038d',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a038c',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a038b',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a038a',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0389',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0388',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0387',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0386',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0385',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0384',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0383',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0382',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0381',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0380',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a037f',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a037e',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a037d',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a037c',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a037b',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a037a',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0379',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0378',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0377',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0376',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0375',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0374',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0373',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0372',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0371',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0370',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a036f',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a036e',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a036d',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a036c',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a040b',
              id: 0,
              frequency: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a040a',
              id: 1,
              frequency: 197,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0409',
              id: 2,
              frequency: 644,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0408',
              id: 3,
              frequency: 3542,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0407',
              id: 4,
              frequency: 182,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0406',
              id: 5,
              frequency: 2080,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0405',
              id: 6,
              frequency: 128,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0404',
              id: 7,
              frequency: 763,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0403',
              id: 8,
              frequency: 348,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0402',
              id: 9,
              frequency: 116,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0401',
              id: 10,
              frequency: 7025,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0400',
              id: 11,
              frequency: 12446,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03ff',
              id: 12,
              frequency: 4063,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03fe',
              id: 13,
              frequency: 30779,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03fd',
              id: 14,
              frequency: 81592,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03fc',
              id: 15,
              frequency: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03fb',
              id: 16,
              frequency: 1841,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03fa',
              id: 17,
              frequency: 576,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03f9',
              id: 18,
              frequency: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03f8',
              id: 19,
              frequency: 171,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03f7',
              id: 20,
              frequency: 975,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03f6',
              id: 21,
              frequency: 2721,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03f5',
              id: 22,
              frequency: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03f4',
              id: 23,
              frequency: 127,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03f3',
              id: 24,
              frequency: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03f2',
              id: 25,
              frequency: 1090,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03f1',
              id: 26,
              frequency: 18233,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03f0',
              id: 27,
              frequency: 130,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03ef',
              id: 28,
              frequency: 1786,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03ee',
              id: 29,
              frequency: 8625,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03ed',
              id: 30,
              frequency: 16641,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03ec',
              id: 31,
              frequency: 132,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03eb',
              id: 32,
              frequency: 2051,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03ea',
              id: 33,
              frequency: 7304,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03e9',
              id: 34,
              frequency: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03e8',
              id: 35,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03e7',
              id: 36,
              frequency: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03e6',
              id: 37,
              frequency: 890,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03e5',
              id: 38,
              frequency: 759,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03e4',
              id: 39,
              frequency: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03e3',
              id: 40,
              frequency: 5696,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03e2',
              id: 41,
              frequency: 15004,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03e1',
              id: 42,
              frequency: 35130,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03e0',
              id: 43,
              frequency: 4876,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03df',
              id: 44,
              frequency: 16714,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03de',
              id: 45,
              frequency: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03dd',
              id: 46,
              frequency: 1339,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03dc',
              id: 47,
              frequency: 11884,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03db',
              id: 48,
              frequency: 64355,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03da',
              id: 49,
              frequency: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03d9',
              id: 50,
              frequency: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03d8',
              id: 51,
              frequency: 212,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03d7',
              id: 52,
              frequency: 374,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03d6',
              id: 53,
              frequency: 4537,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03d5',
              id: 54,
              frequency: 974,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03d4',
              id: 55,
              frequency: 17661,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03d3',
              id: 56,
              frequency: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03d2',
              id: 57,
              frequency: 160894,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03d1',
              id: 58,
              frequency: 117071,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03d0',
              id: 59,
              frequency: 2120,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03cf',
              id: 60,
              frequency: 36065,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03ce',
              id: 61,
              frequency: 83873,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03cd',
              id: 62,
              frequency: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03cc',
              id: 63,
              frequency: 3225,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03cb',
              id: 64,
              frequency: 3778,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03ca',
              id: 65,
              frequency: 764,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03c9',
              id: 66,
              frequency: 74854,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03c8',
              id: 67,
              frequency: 437011,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03c7',
              id: 68,
              frequency: 15571,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03c6',
              id: 69,
              frequency: 24891,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03c5',
              id: 70,
              frequency: 69500,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03c4',
              id: 71,
              frequency: 754943,
            },
            {
              _id: '5d6615769bcb6d0e6d7a03c3',
              id: 72,
              frequency: 1299430,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a02d2',
          id: 7,
          abbrevName: '8',
          fullName: '8_R_Frontal_pole',
          coordinates: {
            x: 20.994975,
            y: 59.628141,
            z: 18.653266,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0321',
              to: 8,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0320',
              to: 9,
            },
            {
              _id: '5d6615769bcb6d0e6d7a031f',
              to: 11,
            },
            {
              _id: '5d6615769bcb6d0e6d7a031e',
              to: 12,
            },
            {
              _id: '5d6615769bcb6d0e6d7a031d',
              to: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d7a031c',
              to: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d7a031b',
              to: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d7a031a',
              to: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0319',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0318',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0317',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0316',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0315',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0314',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0313',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0312',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0311',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0310',
              to: 28,
            },
            {
              _id: '5d6615769bcb6d0e6d7a030f',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a030e',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a030d',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d7a030c',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a030b',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d7a030a',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0309',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0308',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0307',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0306',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0305',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0304',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0303',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0302',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0301',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0300',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02ff',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02fe',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02fd',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02fc',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02fb',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02fa',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02f9',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02f8',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02f7',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02f6',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02f5',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02f4',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02f3',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02f2',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02f1',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02f0',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02ef',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02ee',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02ed',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02ec',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02eb',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02ea',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02e9',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02e8',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02e7',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02e6',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02e5',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02e4',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02e3',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02e2',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02e1',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02e0',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02df',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02de',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02dd',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02dc',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02db',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02da',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02d9',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02d8',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02d7',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02d6',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02d5',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02d4',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02d3',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a036a',
              id: 0,
              frequency: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0369',
              id: 1,
              frequency: 538,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0368',
              id: 2,
              frequency: 394,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0367',
              id: 3,
              frequency: 3176,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0366',
              id: 4,
              frequency: 1348,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0365',
              id: 5,
              frequency: 2876,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0364',
              id: 6,
              frequency: 617,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0363',
              id: 7,
              frequency: 159,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0362',
              id: 8,
              frequency: 934,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0361',
              id: 9,
              frequency: 1064,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0360',
              id: 10,
              frequency: 14308,
            },
            {
              _id: '5d6615769bcb6d0e6d7a035f',
              id: 11,
              frequency: 5568,
            },
            {
              _id: '5d6615769bcb6d0e6d7a035e',
              id: 12,
              frequency: 13070,
            },
            {
              _id: '5d6615769bcb6d0e6d7a035d',
              id: 13,
              frequency: 21089,
            },
            {
              _id: '5d6615769bcb6d0e6d7a035c',
              id: 14,
              frequency: 71954,
            },
            {
              _id: '5d6615769bcb6d0e6d7a035b',
              id: 15,
              frequency: 822,
            },
            {
              _id: '5d6615769bcb6d0e6d7a035a',
              id: 16,
              frequency: 4124,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0359',
              id: 17,
              frequency: 3355,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0358',
              id: 18,
              frequency: 965,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0357',
              id: 19,
              frequency: 1991,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0356',
              id: 20,
              frequency: 2098,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0355',
              id: 21,
              frequency: 982,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0354',
              id: 22,
              frequency: 215,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0353',
              id: 23,
              frequency: 12,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0352',
              id: 24,
              frequency: 2795,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0351',
              id: 25,
              frequency: 9774,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0350',
              id: 26,
              frequency: 12414,
            },
            {
              _id: '5d6615769bcb6d0e6d7a034f',
              id: 27,
              frequency: 1429,
            },
            {
              _id: '5d6615769bcb6d0e6d7a034e',
              id: 28,
              frequency: 3972,
            },
            {
              _id: '5d6615769bcb6d0e6d7a034d',
              id: 29,
              frequency: 27645,
            },
            {
              _id: '5d6615769bcb6d0e6d7a034c',
              id: 30,
              frequency: 16678,
            },
            {
              _id: '5d6615769bcb6d0e6d7a034b',
              id: 31,
              frequency: 1154,
            },
            {
              _id: '5d6615769bcb6d0e6d7a034a',
              id: 32,
              frequency: 7751,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0349',
              id: 33,
              frequency: 723,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0348',
              id: 34,
              frequency: 735,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0347',
              id: 35,
              frequency: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0346',
              id: 36,
              frequency: 1352,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0345',
              id: 37,
              frequency: 2565,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0344',
              id: 38,
              frequency: 674,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0343',
              id: 39,
              frequency: 1032,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0342',
              id: 40,
              frequency: 25412,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0341',
              id: 41,
              frequency: 18831,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0340',
              id: 42,
              frequency: 5818,
            },
            {
              _id: '5d6615769bcb6d0e6d7a033f',
              id: 43,
              frequency: 14695,
            },
            {
              _id: '5d6615769bcb6d0e6d7a033e',
              id: 44,
              frequency: 6386,
            },
            {
              _id: '5d6615769bcb6d0e6d7a033d',
              id: 45,
              frequency: 1265,
            },
            {
              _id: '5d6615769bcb6d0e6d7a033c',
              id: 46,
              frequency: 22191,
            },
            {
              _id: '5d6615769bcb6d0e6d7a033b',
              id: 47,
              frequency: 14170,
            },
            {
              _id: '5d6615769bcb6d0e6d7a033a',
              id: 48,
              frequency: 71221,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0339',
              id: 49,
              frequency: 177,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0338',
              id: 50,
              frequency: 155,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0337',
              id: 51,
              frequency: 3500,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0336',
              id: 52,
              frequency: 2216,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0335',
              id: 53,
              frequency: 10174,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0334',
              id: 54,
              frequency: 6824,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0333',
              id: 55,
              frequency: 5726,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0332',
              id: 56,
              frequency: 972,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0331',
              id: 57,
              frequency: 243390,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0330',
              id: 58,
              frequency: 32842,
            },
            {
              _id: '5d6615769bcb6d0e6d7a032f',
              id: 59,
              frequency: 24975,
            },
            {
              _id: '5d6615769bcb6d0e6d7a032e',
              id: 60,
              frequency: 79891,
            },
            {
              _id: '5d6615769bcb6d0e6d7a032d',
              id: 61,
              frequency: 36715,
            },
            {
              _id: '5d6615769bcb6d0e6d7a032c',
              id: 62,
              frequency: 1042,
            },
            {
              _id: '5d6615769bcb6d0e6d7a032b',
              id: 63,
              frequency: 7623,
            },
            {
              _id: '5d6615769bcb6d0e6d7a032a',
              id: 64,
              frequency: 11426,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0329',
              id: 65,
              frequency: 20075,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0328',
              id: 66,
              frequency: 233285,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0327',
              id: 67,
              frequency: 245994,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0326',
              id: 68,
              frequency: 39537,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0325',
              id: 69,
              frequency: 14589,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0324',
              id: 70,
              frequency: 223589,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0323',
              id: 71,
              frequency: 541264,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0322',
              id: 72,
              frequency: 1134716,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0236',
          id: 8,
          abbrevName: '9',
          fullName: '9_L_STG_posterior',
          coordinates: {
            x: -61.029289,
            y: -27.656904,
            z: -4.619247,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0288',
              to: 9,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0287',
              to: 11,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0286',
              to: 12,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0285',
              to: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0284',
              to: 14,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0283',
              to: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0282',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0281',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0280',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d7a027f',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a027e',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d7a027d',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a027c',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a027b',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a027a',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0279',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0278',
              to: 28,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0277',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0276',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0275',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0274',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0273',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0272',
              to: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0271',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0270',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a026f',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a026e',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a026d',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a026c',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a026b',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a026a',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0269',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0268',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0267',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0266',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0265',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0264',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0263',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0262',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0261',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0260',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a025f',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a025e',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a025d',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a025c',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a025b',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a025a',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0259',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0258',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0257',
              to: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0256',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0255',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0254',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0253',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0252',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0251',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0250',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a024f',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a024e',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a024d',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a024c',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a024b',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a024a',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0249',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0248',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0247',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0246',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0245',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0244',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0243',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0242',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0241',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0240',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a023f',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a023e',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a023d',
              to: 93,
            },
            {
              _id: '5d6615769bcb6d0e6d7a023c',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a023b',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a023a',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0239',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0238',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0237',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a02d1',
              id: 0,
              frequency: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02d0',
              id: 1,
              frequency: 473,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02cf',
              id: 2,
              frequency: 666,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02ce',
              id: 3,
              frequency: 3250,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02cd',
              id: 4,
              frequency: 789,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02cc',
              id: 5,
              frequency: 4100,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02cb',
              id: 6,
              frequency: 264,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02ca',
              id: 7,
              frequency: 1005,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02c9',
              id: 8,
              frequency: 668,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02c8',
              id: 9,
              frequency: 1048,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02c7',
              id: 10,
              frequency: 11802,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02c6',
              id: 11,
              frequency: 15159,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02c5',
              id: 12,
              frequency: 12193,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02c4',
              id: 13,
              frequency: 24609,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02c3',
              id: 14,
              frequency: 72791,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02c2',
              id: 15,
              frequency: 507,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02c1',
              id: 16,
              frequency: 4797,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02c0',
              id: 17,
              frequency: 2029,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02bf',
              id: 18,
              frequency: 169,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02be',
              id: 19,
              frequency: 409,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02bd',
              id: 20,
              frequency: 1603,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02bc',
              id: 21,
              frequency: 5833,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02bb',
              id: 22,
              frequency: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02ba',
              id: 23,
              frequency: 510,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02b9',
              id: 24,
              frequency: 1085,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02b8',
              id: 25,
              frequency: 2884,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02b7',
              id: 26,
              frequency: 35961,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02b6',
              id: 27,
              frequency: 724,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02b5',
              id: 28,
              frequency: 7212,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02b4',
              id: 29,
              frequency: 14747,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02b3',
              id: 30,
              frequency: 19669,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02b2',
              id: 31,
              frequency: 339,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02b1',
              id: 32,
              frequency: 3051,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02b0',
              id: 33,
              frequency: 13968,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02af',
              id: 34,
              frequency: 960,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02ae',
              id: 35,
              frequency: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02ad',
              id: 36,
              frequency: 613,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02ac',
              id: 37,
              frequency: 767,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02ab',
              id: 38,
              frequency: 1953,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02aa',
              id: 39,
              frequency: 728,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02a9',
              id: 40,
              frequency: 9787,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02a8',
              id: 41,
              frequency: 19867,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02a7',
              id: 42,
              frequency: 45728,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02a6',
              id: 43,
              frequency: 14480,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02a5',
              id: 44,
              frequency: 19603,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02a4',
              id: 45,
              frequency: 842,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02a3',
              id: 46,
              frequency: 8454,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02a2',
              id: 47,
              frequency: 53000,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02a1',
              id: 48,
              frequency: 58393,
            },
            {
              _id: '5d6615769bcb6d0e6d7a02a0',
              id: 49,
              frequency: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a029f',
              id: 50,
              frequency: 106,
            },
            {
              _id: '5d6615769bcb6d0e6d7a029e',
              id: 51,
              frequency: 2655,
            },
            {
              _id: '5d6615769bcb6d0e6d7a029d',
              id: 52,
              frequency: 2472,
            },
            {
              _id: '5d6615769bcb6d0e6d7a029c',
              id: 53,
              frequency: 10115,
            },
            {
              _id: '5d6615769bcb6d0e6d7a029b',
              id: 54,
              frequency: 3922,
            },
            {
              _id: '5d6615769bcb6d0e6d7a029a',
              id: 55,
              frequency: 10726,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0299',
              id: 56,
              frequency: 1185,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0298',
              id: 57,
              frequency: 154988,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0297',
              id: 58,
              frequency: 203215,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0296',
              id: 59,
              frequency: 22235,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0295',
              id: 60,
              frequency: 91321,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0294',
              id: 61,
              frequency: 72224,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0293',
              id: 62,
              frequency: 546,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0292',
              id: 63,
              frequency: 5527,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0291',
              id: 64,
              frequency: 9469,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0290',
              id: 65,
              frequency: 22275,
            },
            {
              _id: '5d6615769bcb6d0e6d7a028f',
              id: 66,
              frequency: 231168,
            },
            {
              _id: '5d6615769bcb6d0e6d7a028e',
              id: 67,
              frequency: 351777,
            },
            {
              _id: '5d6615769bcb6d0e6d7a028d',
              id: 68,
              frequency: 25207,
            },
            {
              _id: '5d6615769bcb6d0e6d7a028c',
              id: 69,
              frequency: 16647,
            },
            {
              _id: '5d6615769bcb6d0e6d7a028b',
              id: 70,
              frequency: 209787,
            },
            {
              _id: '5d6615769bcb6d0e6d7a028a',
              id: 71,
              frequency: 561939,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0289',
              id: 72,
              frequency: 1145289,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a01a0',
          id: 9,
          abbrevName: '10',
          fullName: '10_R_Occ_fusiform_gyrus',
          coordinates: {
            x: 21.575758,
            y: -93.737374,
            z: -5.111111,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a01ec',
              to: 10,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01eb',
              to: 11,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01ea',
              to: 12,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01e9',
              to: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01e8',
              to: 14,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01e7',
              to: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01e6',
              to: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01e5',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01e4',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01e3',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01e2',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01e1',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01e0',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01df',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01de',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01dd',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01dc',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01db',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01da',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01d9',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01d8',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01d7',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01d6',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01d5',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01d4',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01d3',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01d2',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01d1',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01d0',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01cf',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01ce',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01cd',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01cc',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01cb',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01ca',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01c9',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01c8',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01c7',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01c6',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01c5',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01c4',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01c3',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01c2',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01c1',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01c0',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01bf',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01be',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01bd',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01bc',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01bb',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01ba',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01b9',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01b8',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01b7',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01b6',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01b5',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01b4',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01b3',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01b2',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01b1',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01b0',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01af',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01ae',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01ad',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01ac',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01ab',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01aa',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01a9',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01a8',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01a7',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01a6',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01a5',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01a4',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01a3',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01a2',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01a1',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0235',
              id: 0,
              frequency: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0234',
              id: 1,
              frequency: 693,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0233',
              id: 2,
              frequency: 384,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0232',
              id: 3,
              frequency: 3019,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0231',
              id: 4,
              frequency: 1129,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0230',
              id: 5,
              frequency: 3205,
            },
            {
              _id: '5d6615769bcb6d0e6d7a022f',
              id: 6,
              frequency: 1083,
            },
            {
              _id: '5d6615769bcb6d0e6d7a022e',
              id: 7,
              frequency: 269,
            },
            {
              _id: '5d6615769bcb6d0e6d7a022d',
              id: 8,
              frequency: 1344,
            },
            {
              _id: '5d6615769bcb6d0e6d7a022c',
              id: 9,
              frequency: 1612,
            },
            {
              _id: '5d6615769bcb6d0e6d7a022b',
              id: 10,
              frequency: 14867,
            },
            {
              _id: '5d6615769bcb6d0e6d7a022a',
              id: 11,
              frequency: 5289,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0229',
              id: 12,
              frequency: 18033,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0228',
              id: 13,
              frequency: 19719,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0227',
              id: 14,
              frequency: 66604,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0226',
              id: 15,
              frequency: 1408,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0225',
              id: 16,
              frequency: 3392,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0224',
              id: 17,
              frequency: 5444,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0223',
              id: 18,
              frequency: 622,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0222',
              id: 19,
              frequency: 3743,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0221',
              id: 20,
              frequency: 2113,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0220',
              id: 21,
              frequency: 1905,
            },
            {
              _id: '5d6615769bcb6d0e6d7a021f',
              id: 22,
              frequency: 389,
            },
            {
              _id: '5d6615769bcb6d0e6d7a021e',
              id: 23,
              frequency: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d7a021d',
              id: 24,
              frequency: 2440,
            },
            {
              _id: '5d6615769bcb6d0e6d7a021c',
              id: 25,
              frequency: 16415,
            },
            {
              _id: '5d6615769bcb6d0e6d7a021b',
              id: 26,
              frequency: 12651,
            },
            {
              _id: '5d6615769bcb6d0e6d7a021a',
              id: 27,
              frequency: 892,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0219',
              id: 28,
              frequency: 4427,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0218',
              id: 29,
              frequency: 22057,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0217',
              id: 30,
              frequency: 14918,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0216',
              id: 31,
              frequency: 2866,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0215',
              id: 32,
              frequency: 7178,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0214',
              id: 33,
              frequency: 1730,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0213',
              id: 34,
              frequency: 1025,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0212',
              id: 35,
              frequency: 173,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0211',
              id: 36,
              frequency: 711,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0210',
              id: 37,
              frequency: 5547,
            },
            {
              _id: '5d6615769bcb6d0e6d7a020f',
              id: 38,
              frequency: 1444,
            },
            {
              _id: '5d6615769bcb6d0e6d7a020e',
              id: 39,
              frequency: 1554,
            },
            {
              _id: '5d6615769bcb6d0e6d7a020d',
              id: 40,
              frequency: 48794,
            },
            {
              _id: '5d6615769bcb6d0e6d7a020c',
              id: 41,
              frequency: 16489,
            },
            {
              _id: '5d6615769bcb6d0e6d7a020b',
              id: 42,
              frequency: 9219,
            },
            {
              _id: '5d6615769bcb6d0e6d7a020a',
              id: 43,
              frequency: 15142,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0209',
              id: 44,
              frequency: 5084,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0208',
              id: 45,
              frequency: 883,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0207',
              id: 46,
              frequency: 11829,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0206',
              id: 47,
              frequency: 18139,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0205',
              id: 48,
              frequency: 68265,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0204',
              id: 49,
              frequency: 407,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0203',
              id: 50,
              frequency: 330,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0202',
              id: 51,
              frequency: 4619,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0201',
              id: 52,
              frequency: 2692,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0200',
              id: 53,
              frequency: 11287,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01ff',
              id: 54,
              frequency: 12180,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01fe',
              id: 55,
              frequency: 8701,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01fd',
              id: 56,
              frequency: 1719,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01fc',
              id: 57,
              frequency: 229311,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01fb',
              id: 58,
              frequency: 30849,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01fa',
              id: 59,
              frequency: 29996,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01f9',
              id: 60,
              frequency: 94590,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01f8',
              id: 61,
              frequency: 31671,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01f7',
              id: 62,
              frequency: 1780,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01f6',
              id: 63,
              frequency: 11812,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01f5',
              id: 64,
              frequency: 12002,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01f4',
              id: 65,
              frequency: 37220,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01f3',
              id: 66,
              frequency: 250915,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01f2',
              id: 67,
              frequency: 224997,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01f1',
              id: 68,
              frequency: 59517,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01f0',
              id: 69,
              frequency: 12817,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01ef',
              id: 70,
              frequency: 322061,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01ee',
              id: 71,
              frequency: 488797,
            },
            {
              _id: '5d6615769bcb6d0e6d7a01ed',
              id: 72,
              frequency: 1023720,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a012e',
          id: 10,
          abbrevName: '11',
          fullName: '11_R_Cerebellum',
          coordinates: {
            x: 36.666667,
            y: -44.553191,
            z: -45.716312,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0156',
              to: 12,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0155',
              to: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0154',
              to: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0153',
              to: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0152',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0151',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0150',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d7a014f',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a014e',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a014d',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a014c',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a014b',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a014a',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0149',
              to: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0148',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0147',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0146',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0145',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0144',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0143',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0142',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0141',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0140',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a013f',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a013e',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a013d',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a013c',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a013b',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a013a',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0139',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0138',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0137',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0136',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0135',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0134',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0133',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0132',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0131',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0130',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a012f',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a019f',
              id: 0,
              frequency: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a019e',
              id: 1,
              frequency: 1854,
            },
            {
              _id: '5d6615769bcb6d0e6d7a019d',
              id: 2,
              frequency: 103,
            },
            {
              _id: '5d6615769bcb6d0e6d7a019c',
              id: 3,
              frequency: 843,
            },
            {
              _id: '5d6615769bcb6d0e6d7a019b',
              id: 4,
              frequency: 10268,
            },
            {
              _id: '5d6615769bcb6d0e6d7a019a',
              id: 5,
              frequency: 2987,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0199',
              id: 6,
              frequency: 5569,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0198',
              id: 7,
              frequency: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0197',
              id: 8,
              frequency: 2001,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0196',
              id: 9,
              frequency: 34462,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0195',
              id: 10,
              frequency: 10183,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0194',
              id: 11,
              frequency: 864,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0193',
              id: 12,
              frequency: 31275,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0192',
              id: 13,
              frequency: 2532,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0191',
              id: 14,
              frequency: 9826,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0190',
              id: 15,
              frequency: 27602,
            },
            {
              _id: '5d6615769bcb6d0e6d7a018f',
              id: 16,
              frequency: 9747,
            },
            {
              _id: '5d6615769bcb6d0e6d7a018e',
              id: 17,
              frequency: 3929,
            },
            {
              _id: '5d6615769bcb6d0e6d7a018d',
              id: 18,
              frequency: 8083,
            },
            {
              _id: '5d6615769bcb6d0e6d7a018c',
              id: 19,
              frequency: 28451,
            },
            {
              _id: '5d6615769bcb6d0e6d7a018b',
              id: 20,
              frequency: 5163,
            },
            {
              _id: '5d6615769bcb6d0e6d7a018a',
              id: 21,
              frequency: 342,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0189',
              id: 22,
              frequency: 1719,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0188',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0187',
              id: 24,
              frequency: 108954,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0186',
              id: 25,
              frequency: 10969,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0185',
              id: 26,
              frequency: 5262,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0184',
              id: 27,
              frequency: 41679,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0183',
              id: 28,
              frequency: 34807,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0182',
              id: 29,
              frequency: 30558,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0181',
              id: 30,
              frequency: 2956,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0180',
              id: 31,
              frequency: 53204,
            },
            {
              _id: '5d6615769bcb6d0e6d7a017f',
              id: 32,
              frequency: 8852,
            },
            {
              _id: '5d6615769bcb6d0e6d7a017e',
              id: 33,
              frequency: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a017d',
              id: 34,
              frequency: 4366,
            },
            {
              _id: '5d6615769bcb6d0e6d7a017c',
              id: 35,
              frequency: 8671,
            },
            {
              _id: '5d6615769bcb6d0e6d7a017b',
              id: 36,
              frequency: 3244,
            },
            {
              _id: '5d6615769bcb6d0e6d7a017a',
              id: 37,
              frequency: 9643,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0179',
              id: 38,
              frequency: 629,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0178',
              id: 39,
              frequency: 133800,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0177',
              id: 40,
              frequency: 88593,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0176',
              id: 41,
              frequency: 5059,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0175',
              id: 42,
              frequency: 533,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0174',
              id: 43,
              frequency: 56598,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0173',
              id: 44,
              frequency: 414,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0172',
              id: 45,
              frequency: 117995,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0171',
              id: 46,
              frequency: 52454,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0170',
              id: 47,
              frequency: 20266,
            },
            {
              _id: '5d6615769bcb6d0e6d7a016f',
              id: 48,
              frequency: 12831,
            },
            {
              _id: '5d6615769bcb6d0e6d7a016e',
              id: 49,
              frequency: 1925,
            },
            {
              _id: '5d6615769bcb6d0e6d7a016d',
              id: 50,
              frequency: 135,
            },
            {
              _id: '5d6615769bcb6d0e6d7a016c',
              id: 51,
              frequency: 33787,
            },
            {
              _id: '5d6615769bcb6d0e6d7a016b',
              id: 52,
              frequency: 9247,
            },
            {
              _id: '5d6615769bcb6d0e6d7a016a',
              id: 53,
              frequency: 6257,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0169',
              id: 54,
              frequency: 61683,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0168',
              id: 55,
              frequency: 283,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0167',
              id: 56,
              frequency: 386035,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0166',
              id: 57,
              frequency: 44722,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0165',
              id: 58,
              frequency: 4100,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0164',
              id: 59,
              frequency: 228810,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0163',
              id: 60,
              frequency: 52718,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0162',
              id: 61,
              frequency: 2363,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0161',
              id: 62,
              frequency: 25587,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0160',
              id: 63,
              frequency: 8810,
            },
            {
              _id: '5d6615769bcb6d0e6d7a015f',
              id: 64,
              frequency: 4611,
            },
            {
              _id: '5d6615769bcb6d0e6d7a015e',
              id: 65,
              frequency: 538345,
            },
            {
              _id: '5d6615769bcb6d0e6d7a015d',
              id: 66,
              frequency: 120917,
            },
            {
              _id: '5d6615769bcb6d0e6d7a015c',
              id: 67,
              frequency: 15590,
            },
            {
              _id: '5d6615769bcb6d0e6d7a015b',
              id: 68,
              frequency: 54520,
            },
            {
              _id: '5d6615769bcb6d0e6d7a015a',
              id: 69,
              frequency: 513,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0159',
              id: 70,
              frequency: 333933,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0158',
              id: 71,
              frequency: 32236,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0157',
              id: 72,
              frequency: 79676,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a009a',
          id: 11,
          abbrevName: '12',
          fullName: '12_R_Frontal_pole__ifg_pars_triangularis',
          coordinates: {
            x: 45.005525,
            y: 42.685083,
            z: 8.353591,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a00e4',
              to: 12,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00e3',
              to: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00e2',
              to: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00e1',
              to: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00e0',
              to: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00df',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00de',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00dd',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00dc',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00db',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00da',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00d9',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00d8',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00d7',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00d6',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00d5',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00d4',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00d3',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00d2',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00d1',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00d0',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00cf',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00ce',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00cd',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00cc',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00cb',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00ca',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00c9',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00c8',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00c7',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00c6',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00c5',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00c4',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00c3',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00c2',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00c1',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00c0',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00bf',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00be',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00bd',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00bc',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00bb',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00ba',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00b9',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00b8',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00b7',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00b6',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00b5',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00b4',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00b3',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00b2',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00b1',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00b0',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00af',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00ae',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00ad',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00ac',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00ab',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00aa',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00a9',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00a8',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00a7',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00a6',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00a5',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00a4',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00a3',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00a2',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00a1',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00a0',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a009f',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a009e',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a009d',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a009c',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a009b',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a012d',
              id: 0,
              frequency: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a012c',
              id: 1,
              frequency: 713,
            },
            {
              _id: '5d6615769bcb6d0e6d7a012b',
              id: 2,
              frequency: 278,
            },
            {
              _id: '5d6615769bcb6d0e6d7a012a',
              id: 3,
              frequency: 2962,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0129',
              id: 4,
              frequency: 2465,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0128',
              id: 5,
              frequency: 2702,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0127',
              id: 6,
              frequency: 891,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0126',
              id: 7,
              frequency: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0125',
              id: 8,
              frequency: 904,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0124',
              id: 9,
              frequency: 2443,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0123',
              id: 10,
              frequency: 18248,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0122',
              id: 11,
              frequency: 3107,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0121',
              id: 12,
              frequency: 17141,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0120',
              id: 13,
              frequency: 15571,
            },
            {
              _id: '5d6615769bcb6d0e6d7a011f',
              id: 14,
              frequency: 66583,
            },
            {
              _id: '5d6615769bcb6d0e6d7a011e',
              id: 15,
              frequency: 4307,
            },
            {
              _id: '5d6615769bcb6d0e6d7a011d',
              id: 16,
              frequency: 5397,
            },
            {
              _id: '5d6615769bcb6d0e6d7a011c',
              id: 17,
              frequency: 2147,
            },
            {
              _id: '5d6615769bcb6d0e6d7a011b',
              id: 18,
              frequency: 1496,
            },
            {
              _id: '5d6615769bcb6d0e6d7a011a',
              id: 19,
              frequency: 2902,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0119',
              id: 20,
              frequency: 2482,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0118',
              id: 21,
              frequency: 528,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0117',
              id: 22,
              frequency: 286,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0116',
              id: 23,
              frequency: 3,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0115',
              id: 24,
              frequency: 6256,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0114',
              id: 25,
              frequency: 9404,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0113',
              id: 26,
              frequency: 9004,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0112',
              id: 27,
              frequency: 3722,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0111',
              id: 28,
              frequency: 7112,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0110',
              id: 29,
              frequency: 48204,
            },
            {
              _id: '5d6615769bcb6d0e6d7a010f',
              id: 30,
              frequency: 11469,
            },
            {
              _id: '5d6615769bcb6d0e6d7a010e',
              id: 31,
              frequency: 2474,
            },
            {
              _id: '5d6615769bcb6d0e6d7a010d',
              id: 32,
              frequency: 11061,
            },
            {
              _id: '5d6615769bcb6d0e6d7a010c',
              id: 33,
              frequency: 167,
            },
            {
              _id: '5d6615769bcb6d0e6d7a010b',
              id: 34,
              frequency: 1155,
            },
            {
              _id: '5d6615769bcb6d0e6d7a010a',
              id: 35,
              frequency: 588,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0109',
              id: 36,
              frequency: 1241,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0108',
              id: 37,
              frequency: 2595,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0107',
              id: 38,
              frequency: 300,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0106',
              id: 39,
              frequency: 3264,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0105',
              id: 40,
              frequency: 35640,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0104',
              id: 41,
              frequency: 18198,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0103',
              id: 42,
              frequency: 1829,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0102',
              id: 43,
              frequency: 31973,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0101',
              id: 44,
              frequency: 2374,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0100',
              id: 45,
              frequency: 4452,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00ff',
              id: 46,
              frequency: 32907,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00fe',
              id: 47,
              frequency: 10578,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00fd',
              id: 48,
              frequency: 65463,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00fc',
              id: 49,
              frequency: 261,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00fb',
              id: 50,
              frequency: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00fa',
              id: 51,
              frequency: 5057,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00f9',
              id: 52,
              frequency: 5651,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00f8',
              id: 53,
              frequency: 8308,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00f7',
              id: 54,
              frequency: 9490,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00f6',
              id: 55,
              frequency: 2427,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00f5',
              id: 56,
              frequency: 4448,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00f4',
              id: 57,
              frequency: 287935,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00f3',
              id: 58,
              frequency: 14733,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00f2',
              id: 59,
              frequency: 56634,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00f1',
              id: 60,
              frequency: 84933,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00f0',
              id: 61,
              frequency: 18116,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00ef',
              id: 62,
              frequency: 1657,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00ee',
              id: 63,
              frequency: 5410,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00ed',
              id: 64,
              frequency: 11831,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00ec',
              id: 65,
              frequency: 45675,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00eb',
              id: 66,
              frequency: 318978,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00ea',
              id: 67,
              frequency: 148427,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00e9',
              id: 68,
              frequency: 40043,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00e8',
              id: 69,
              frequency: 10183,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00e7',
              id: 70,
              frequency: 284718,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00e6',
              id: 71,
              frequency: 415805,
            },
            {
              _id: '5d6615769bcb6d0e6d7a00e5',
              id: 72,
              frequency: 1049676,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0002',
          id: 12,
          abbrevName: '13',
          fullName: '13_L_LOC_inferior',
          coordinates: {
            x: -42.391489,
            y: -79.225532,
            z: -1.361702,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0050',
              to: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d7a004f',
              to: 14,
            },
            {
              _id: '5d6615769bcb6d0e6d7a004e',
              to: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d7a004d',
              to: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d7a004c',
              to: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d7a004b',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a004a',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0049',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0048',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0047',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0046',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0045',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0044',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0043',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0042',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0041',
              to: 28,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0040',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a003f',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d7a003e',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a003d',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d7a003c',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a003b',
              to: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d7a003a',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0039',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0038',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0037',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0036',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0035',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0034',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0033',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0032',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0031',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0030',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a002f',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a002e',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a002d',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a002c',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a002b',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a002a',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0029',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0028',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0027',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0026',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0025',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0024',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0023',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0022',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0021',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0020',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a001f',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a001e',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a001d',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a001c',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a001b',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a001a',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0019',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0018',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0017',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0016',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0015',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0014',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0013',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0012',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0011',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0010',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a000f',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a000e',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a000d',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a000c',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a000b',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a000a',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0009',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0008',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0007',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0006',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0005',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0004',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0003',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0099',
              id: 0,
              frequency: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0098',
              id: 1,
              frequency: 426,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0097',
              id: 2,
              frequency: 525,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0096',
              id: 3,
              frequency: 3303,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0095',
              id: 4,
              frequency: 761,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0094',
              id: 5,
              frequency: 2855,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0093',
              id: 6,
              frequency: 339,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0092',
              id: 7,
              frequency: 461,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0091',
              id: 8,
              frequency: 1132,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0090',
              id: 9,
              frequency: 677,
            },
            {
              _id: '5d6615769bcb6d0e6d7a008f',
              id: 10,
              frequency: 10967,
            },
            {
              _id: '5d6615769bcb6d0e6d7a008e',
              id: 11,
              frequency: 9326,
            },
            {
              _id: '5d6615769bcb6d0e6d7a008d',
              id: 12,
              frequency: 10488,
            },
            {
              _id: '5d6615769bcb6d0e6d7a008c',
              id: 13,
              frequency: 25115,
            },
            {
              _id: '5d6615769bcb6d0e6d7a008b',
              id: 14,
              frequency: 74834,
            },
            {
              _id: '5d6615769bcb6d0e6d7a008a',
              id: 15,
              frequency: 837,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0089',
              id: 16,
              frequency: 2357,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0088',
              id: 17,
              frequency: 1570,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0087',
              id: 18,
              frequency: 389,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0086',
              id: 19,
              frequency: 531,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0085',
              id: 20,
              frequency: 2294,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0084',
              id: 21,
              frequency: 2443,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0083',
              id: 22,
              frequency: 129,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0082',
              id: 23,
              frequency: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0081',
              id: 24,
              frequency: 1234,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0080',
              id: 25,
              frequency: 3229,
            },
            {
              _id: '5d6615769bcb6d0e6d7a007f',
              id: 26,
              frequency: 15461,
            },
            {
              _id: '5d6615769bcb6d0e6d7a007e',
              id: 27,
              frequency: 421,
            },
            {
              _id: '5d6615769bcb6d0e6d7a007d',
              id: 28,
              frequency: 2726,
            },
            {
              _id: '5d6615769bcb6d0e6d7a007c',
              id: 29,
              frequency: 14721,
            },
            {
              _id: '5d6615769bcb6d0e6d7a007b',
              id: 30,
              frequency: 23660,
            },
            {
              _id: '5d6615769bcb6d0e6d7a007a',
              id: 31,
              frequency: 525,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0079',
              id: 32,
              frequency: 5243,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0078',
              id: 33,
              frequency: 3631,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0077',
              id: 34,
              frequency: 702,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0076',
              id: 35,
              frequency: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0075',
              id: 36,
              frequency: 944,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0074',
              id: 37,
              frequency: 2466,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0073',
              id: 38,
              frequency: 1372,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0072',
              id: 39,
              frequency: 505,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0071',
              id: 40,
              frequency: 14608,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0070',
              id: 41,
              frequency: 15803,
            },
            {
              _id: '5d6615769bcb6d0e6d7a006f',
              id: 42,
              frequency: 19579,
            },
            {
              _id: '5d6615769bcb6d0e6d7a006e',
              id: 43,
              frequency: 7482,
            },
            {
              _id: '5d6615769bcb6d0e6d7a006d',
              id: 44,
              frequency: 11332,
            },
            {
              _id: '5d6615769bcb6d0e6d7a006c',
              id: 45,
              frequency: 447,
            },
            {
              _id: '5d6615769bcb6d0e6d7a006b',
              id: 46,
              frequency: 10525,
            },
            {
              _id: '5d6615769bcb6d0e6d7a006a',
              id: 47,
              frequency: 15427,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0069',
              id: 48,
              frequency: 65093,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0068',
              id: 49,
              frequency: 103,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0067',
              id: 50,
              frequency: 400,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0066',
              id: 51,
              frequency: 3394,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0065',
              id: 52,
              frequency: 1741,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0064',
              id: 53,
              frequency: 13599,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0063',
              id: 54,
              frequency: 2338,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0062',
              id: 55,
              frequency: 12096,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0061',
              id: 56,
              frequency: 451,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0060',
              id: 57,
              frequency: 195977,
            },
            {
              _id: '5d6615769bcb6d0e6d7a005f',
              id: 58,
              frequency: 80974,
            },
            {
              _id: '5d6615769bcb6d0e6d7a005e',
              id: 59,
              frequency: 17911,
            },
            {
              _id: '5d6615769bcb6d0e6d7a005d',
              id: 60,
              frequency: 65573,
            },
            {
              _id: '5d6615769bcb6d0e6d7a005c',
              id: 61,
              frequency: 61078,
            },
            {
              _id: '5d6615769bcb6d0e6d7a005b',
              id: 62,
              frequency: 905,
            },
            {
              _id: '5d6615769bcb6d0e6d7a005a',
              id: 63,
              frequency: 12559,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0059',
              id: 64,
              frequency: 10327,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0058',
              id: 65,
              frequency: 12788,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0057',
              id: 66,
              frequency: 169611,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0056',
              id: 67,
              frequency: 335884,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0055',
              id: 68,
              frequency: 45736,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0054',
              id: 69,
              frequency: 16072,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0053',
              id: 70,
              frequency: 182442,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0052',
              id: 71,
              frequency: 610348,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0051',
              id: 72,
              frequency: 1180834,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79ff6b',
          id: 13,
          abbrevName: '14',
          fullName: '14_L_SFG_mfg',
          coordinates: {
            x: -23.76,
            y: -1.06,
            z: 62.84,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79ffb8',
              to: 14,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffb7',
              to: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffb6',
              to: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffb5',
              to: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffb4',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffb3',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffb2',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffb1',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffb0',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffaf',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffae',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffad',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffac',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffab',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffaa',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffa9',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffa8',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffa7',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffa6',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffa5',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffa4',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffa3',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffa2',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffa1',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffa0',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff9f',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff9e',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff9d',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff9c',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff9b',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff9a',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff99',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff98',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff97',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff96',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff95',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff94',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff93',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff92',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff91',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff90',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff8f',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff8e',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff8d',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff8c',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff8b',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff8a',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff89',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff88',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff87',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff86',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff85',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff84',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff83',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff82',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff81',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff80',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff7f',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff7e',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff7d',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff7c',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff7b',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff7a',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff79',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff78',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff77',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff76',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff75',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff74',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff73',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff72',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff71',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff70',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff6f',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff6e',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff6d',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff6c',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0001',
              id: 0,
              frequency: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0000',
              id: 1,
              frequency: 305,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffff',
              id: 2,
              frequency: 497,
            },
            {
              _id: '5d6615769bcb6d0e6d79fffe',
              id: 3,
              frequency: 3419,
            },
            {
              _id: '5d6615769bcb6d0e6d79fffd',
              id: 4,
              frequency: 901,
            },
            {
              _id: '5d6615769bcb6d0e6d79fffc',
              id: 5,
              frequency: 2365,
            },
            {
              _id: '5d6615769bcb6d0e6d79fffb',
              id: 6,
              frequency: 107,
            },
            {
              _id: '5d6615769bcb6d0e6d79fffa',
              id: 7,
              frequency: 400,
            },
            {
              _id: '5d6615769bcb6d0e6d79fff9',
              id: 8,
              frequency: 591,
            },
            {
              _id: '5d6615769bcb6d0e6d79fff8',
              id: 9,
              frequency: 508,
            },
            {
              _id: '5d6615769bcb6d0e6d79fff7',
              id: 10,
              frequency: 10671,
            },
            {
              _id: '5d6615769bcb6d0e6d79fff6',
              id: 11,
              frequency: 7920,
            },
            {
              _id: '5d6615769bcb6d0e6d79fff5',
              id: 12,
              frequency: 6311,
            },
            {
              _id: '5d6615769bcb6d0e6d79fff4',
              id: 13,
              frequency: 26199,
            },
            {
              _id: '5d6615769bcb6d0e6d79fff3',
              id: 14,
              frequency: 79045,
            },
            {
              _id: '5d6615769bcb6d0e6d79fff2',
              id: 15,
              frequency: 602,
            },
            {
              _id: '5d6615769bcb6d0e6d79fff1',
              id: 16,
              frequency: 4206,
            },
            {
              _id: '5d6615769bcb6d0e6d79fff0',
              id: 17,
              frequency: 567,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffef',
              id: 18,
              frequency: 559,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffee',
              id: 19,
              frequency: 155,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffed',
              id: 20,
              frequency: 894,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffec',
              id: 21,
              frequency: 2050,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffeb',
              id: 22,
              frequency: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffea',
              id: 23,
              frequency: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffe9',
              id: 24,
              frequency: 745,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffe8',
              id: 25,
              frequency: 1176,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffe7',
              id: 26,
              frequency: 14742,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffe6',
              id: 27,
              frequency: 1032,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffe5',
              id: 28,
              frequency: 3378,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffe4',
              id: 29,
              frequency: 24087,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffe3',
              id: 30,
              frequency: 16519,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffe2',
              id: 31,
              frequency: 126,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffe1',
              id: 32,
              frequency: 3307,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffe0',
              id: 33,
              frequency: 2814,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffdf',
              id: 34,
              frequency: 521,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffde',
              id: 35,
              frequency: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffdd',
              id: 36,
              frequency: 1033,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffdc',
              id: 37,
              frequency: 534,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffdb',
              id: 38,
              frequency: 864,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffda',
              id: 39,
              frequency: 219,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffd9',
              id: 40,
              frequency: 3905,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffd8',
              id: 41,
              frequency: 17228,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffd7',
              id: 42,
              frequency: 15615,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffd6',
              id: 43,
              frequency: 11351,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffd5',
              id: 44,
              frequency: 10101,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffd4',
              id: 45,
              frequency: 729,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffd3',
              id: 46,
              frequency: 14190,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffd2',
              id: 47,
              frequency: 10792,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffd1',
              id: 48,
              frequency: 73749,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffd0',
              id: 49,
              frequency: 8,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffcf',
              id: 50,
              frequency: 139,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffce',
              id: 51,
              frequency: 2079,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffcd',
              id: 52,
              frequency: 1389,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffcc',
              id: 53,
              frequency: 7498,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffcb',
              id: 54,
              frequency: 380,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffca',
              id: 55,
              frequency: 13005,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffc9',
              id: 56,
              frequency: 527,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffc8',
              id: 57,
              frequency: 219992,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffc7',
              id: 58,
              frequency: 51032,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffc6',
              id: 59,
              frequency: 14650,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffc5',
              id: 60,
              frequency: 49316,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffc4',
              id: 61,
              frequency: 54316,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffc3',
              id: 62,
              frequency: 382,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffc2',
              id: 63,
              frequency: 5190,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffc1',
              id: 64,
              frequency: 9163,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffc0',
              id: 65,
              frequency: 6241,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffbf',
              id: 66,
              frequency: 145153,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffbe',
              id: 67,
              frequency: 342130,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffbd',
              id: 68,
              frequency: 23095,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffbc',
              id: 69,
              frequency: 18261,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffbb',
              id: 70,
              frequency: 97472,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffba',
              id: 71,
              frequency: 666274,
            },
            {
              _id: '5d6615769bcb6d0e6d79ffb9',
              id: 72,
              frequency: 1268040,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79fee9',
          id: 14,
          abbrevName: '15',
          fullName: '15_R_HC_phc',
          coordinates: {
            x: 24.38835,
            y: -9.572816,
            z: -23.533981,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79ff21',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff20',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff1f',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff1e',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff1d',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff1c',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff1b',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff1a',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff19',
              to: 28,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff18',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff17',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff16',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff15',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff14',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff13',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff12',
              to: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff11',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff10',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff0f',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff0e',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff0d',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff0c',
              to: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff0b',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff0a',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff09',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff08',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff07',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff06',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff05',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff04',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff03',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff02',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff01',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff00',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79feff',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79fefe',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79fefd',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79fefc',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79fefb',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79fefa',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79fef9',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79fef8',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79fef7',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79fef6',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79fef5',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79fef4',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79fef3',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79fef2',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79fef1',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d79fef0',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79feef',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79feee',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79feed',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79feec',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79feeb',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79feea',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79ff6a',
              id: 0,
              frequency: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff69',
              id: 1,
              frequency: 1573,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff68',
              id: 2,
              frequency: 318,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff67',
              id: 3,
              frequency: 1827,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff66',
              id: 4,
              frequency: 5429,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff65',
              id: 5,
              frequency: 6636,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff64',
              id: 6,
              frequency: 3016,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff63',
              id: 7,
              frequency: 196,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff62',
              id: 8,
              frequency: 2471,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff61',
              id: 9,
              frequency: 16551,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff60',
              id: 10,
              frequency: 16359,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff5f',
              id: 11,
              frequency: 5424,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff5e',
              id: 12,
              frequency: 37154,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff5d',
              id: 13,
              frequency: 8916,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff5c',
              id: 14,
              frequency: 31224,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff5b',
              id: 15,
              frequency: 7924,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff5a',
              id: 16,
              frequency: 13260,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff59',
              id: 17,
              frequency: 7364,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff58',
              id: 18,
              frequency: 2049,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff57',
              id: 19,
              frequency: 9564,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff56',
              id: 20,
              frequency: 8498,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff55',
              id: 21,
              frequency: 2371,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff54',
              id: 22,
              frequency: 948,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff53',
              id: 23,
              frequency: 8,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff52',
              id: 24,
              frequency: 27502,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff51',
              id: 25,
              frequency: 16313,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff50',
              id: 26,
              frequency: 25310,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff4f',
              id: 27,
              frequency: 14418,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff4e',
              id: 28,
              frequency: 52434,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff4d',
              id: 29,
              frequency: 27729,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff4c',
              id: 30,
              frequency: 16022,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff4b',
              id: 31,
              frequency: 18822,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff4a',
              id: 32,
              frequency: 11519,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff49',
              id: 33,
              frequency: 1178,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff48',
              id: 34,
              frequency: 4193,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff47',
              id: 35,
              frequency: 2715,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff46',
              id: 36,
              frequency: 2042,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff45',
              id: 37,
              frequency: 8847,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff44',
              id: 38,
              frequency: 3349,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff43',
              id: 39,
              frequency: 34926,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff42',
              id: 40,
              frequency: 82804,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff41',
              id: 41,
              frequency: 13414,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff40',
              id: 42,
              frequency: 7749,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff3f',
              id: 43,
              frequency: 59173,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff3e',
              id: 44,
              frequency: 6502,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff3d',
              id: 45,
              frequency: 36353,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff3c',
              id: 46,
              frequency: 32620,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff3b',
              id: 47,
              frequency: 88730,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff3a',
              id: 48,
              frequency: 44435,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff39',
              id: 49,
              frequency: 1000,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff38',
              id: 50,
              frequency: 234,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff37',
              id: 51,
              frequency: 29025,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff36',
              id: 52,
              frequency: 9085,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff35',
              id: 53,
              frequency: 14576,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff34',
              id: 54,
              frequency: 41186,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff33',
              id: 55,
              frequency: 2211,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff32',
              id: 56,
              frequency: 105885,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff31',
              id: 57,
              frequency: 119985,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff30',
              id: 58,
              frequency: 53873,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff2f',
              id: 59,
              frequency: 186991,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff2e',
              id: 60,
              frequency: 119439,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff2d',
              id: 61,
              frequency: 18218,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff2c',
              id: 62,
              frequency: 16004,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff2b',
              id: 63,
              frequency: 20577,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff2a',
              id: 64,
              frequency: 10851,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff29',
              id: 65,
              frequency: 358092,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff28',
              id: 66,
              frequency: 277358,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff27',
              id: 67,
              frequency: 99795,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff26',
              id: 68,
              frequency: 87512,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff25',
              id: 69,
              frequency: 3040,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff24',
              id: 70,
              frequency: 565576,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff23',
              id: 71,
              frequency: 149570,
            },
            {
              _id: '5d6615769bcb6d0e6d79ff22',
              id: 72,
              frequency: 378576,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79fe56',
          id: 15,
          abbrevName: '16',
          fullName: '16_R_SFG_mfg',
          coordinates: {
            x: 26.505051,
            y: 20.808081,
            z: 53.414141,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79fe9f',
              to: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe9e',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe9d',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe9c',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe9b',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe9a',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe99',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe98',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe97',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe96',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe95',
              to: 28,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe94',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe93',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe92',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe91',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe90',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe8f',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe8e',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe8d',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe8c',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe8b',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe8a',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe89',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe88',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe87',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe86',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe85',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe84',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe83',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe82',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe81',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe80',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe7f',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe7e',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe7d',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe7c',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe7b',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe7a',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe79',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe78',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe77',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe76',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe75',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe74',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe73',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe72',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe71',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe70',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe6f',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe6e',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe6d',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe6c',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe6b',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe6a',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe69',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe68',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe67',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe66',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe65',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe64',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe63',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe62',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe61',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe60',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe5f',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe5e',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe5d',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe5c',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe5b',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe5a',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe59',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe58',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe57',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79fee8',
              id: 0,
              frequency: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79fee7',
              id: 1,
              frequency: 505,
            },
            {
              _id: '5d6615769bcb6d0e6d79fee6',
              id: 2,
              frequency: 441,
            },
            {
              _id: '5d6615769bcb6d0e6d79fee5',
              id: 3,
              frequency: 3214,
            },
            {
              _id: '5d6615769bcb6d0e6d79fee4',
              id: 4,
              frequency: 1074,
            },
            {
              _id: '5d6615769bcb6d0e6d79fee3',
              id: 5,
              frequency: 2907,
            },
            {
              _id: '5d6615769bcb6d0e6d79fee2',
              id: 6,
              frequency: 534,
            },
            {
              _id: '5d6615769bcb6d0e6d79fee1',
              id: 7,
              frequency: 315,
            },
            {
              _id: '5d6615769bcb6d0e6d79fee0',
              id: 8,
              frequency: 1059,
            },
            {
              _id: '5d6615769bcb6d0e6d79fedf',
              id: 9,
              frequency: 958,
            },
            {
              _id: '5d6615769bcb6d0e6d79fede',
              id: 10,
              frequency: 12954,
            },
            {
              _id: '5d6615769bcb6d0e6d79fedd',
              id: 11,
              frequency: 6711,
            },
            {
              _id: '5d6615769bcb6d0e6d79fedc',
              id: 12,
              frequency: 12473,
            },
            {
              _id: '5d6615769bcb6d0e6d79fedb',
              id: 13,
              frequency: 22677,
            },
            {
              _id: '5d6615769bcb6d0e6d79feda',
              id: 14,
              frequency: 72637,
            },
            {
              _id: '5d6615769bcb6d0e6d79fed9',
              id: 15,
              frequency: 1087,
            },
            {
              _id: '5d6615769bcb6d0e6d79fed8',
              id: 16,
              frequency: 3880,
            },
            {
              _id: '5d6615769bcb6d0e6d79fed7',
              id: 17,
              frequency: 2605,
            },
            {
              _id: '5d6615769bcb6d0e6d79fed6',
              id: 18,
              frequency: 465,
            },
            {
              _id: '5d6615769bcb6d0e6d79fed5',
              id: 19,
              frequency: 1651,
            },
            {
              _id: '5d6615769bcb6d0e6d79fed4',
              id: 20,
              frequency: 2098,
            },
            {
              _id: '5d6615769bcb6d0e6d79fed3',
              id: 21,
              frequency: 1689,
            },
            {
              _id: '5d6615769bcb6d0e6d79fed2',
              id: 22,
              frequency: 122,
            },
            {
              _id: '5d6615769bcb6d0e6d79fed1',
              id: 23,
              frequency: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d79fed0',
              id: 24,
              frequency: 1980,
            },
            {
              _id: '5d6615769bcb6d0e6d79fecf',
              id: 25,
              frequency: 6650,
            },
            {
              _id: '5d6615769bcb6d0e6d79fece',
              id: 26,
              frequency: 13196,
            },
            {
              _id: '5d6615769bcb6d0e6d79fecd',
              id: 27,
              frequency: 834,
            },
            {
              _id: '5d6615769bcb6d0e6d79fecc',
              id: 28,
              frequency: 4031,
            },
            {
              _id: '5d6615769bcb6d0e6d79fecb',
              id: 29,
              frequency: 23475,
            },
            {
              _id: '5d6615769bcb6d0e6d79feca',
              id: 30,
              frequency: 17880,
            },
            {
              _id: '5d6615769bcb6d0e6d79fec9',
              id: 31,
              frequency: 1108,
            },
            {
              _id: '5d6615769bcb6d0e6d79fec8',
              id: 32,
              frequency: 6813,
            },
            {
              _id: '5d6615769bcb6d0e6d79fec7',
              id: 33,
              frequency: 2153,
            },
            {
              _id: '5d6615769bcb6d0e6d79fec6',
              id: 34,
              frequency: 709,
            },
            {
              _id: '5d6615769bcb6d0e6d79fec5',
              id: 35,
              frequency: 126,
            },
            {
              _id: '5d6615769bcb6d0e6d79fec4',
              id: 36,
              frequency: 962,
            },
            {
              _id: '5d6615769bcb6d0e6d79fec3',
              id: 37,
              frequency: 3105,
            },
            {
              _id: '5d6615769bcb6d0e6d79fec2',
              id: 38,
              frequency: 1275,
            },
            {
              _id: '5d6615769bcb6d0e6d79fec1',
              id: 39,
              frequency: 883,
            },
            {
              _id: '5d6615769bcb6d0e6d79fec0',
              id: 40,
              frequency: 21902,
            },
            {
              _id: '5d6615769bcb6d0e6d79febf',
              id: 41,
              frequency: 16346,
            },
            {
              _id: '5d6615769bcb6d0e6d79febe',
              id: 42,
              frequency: 11807,
            },
            {
              _id: '5d6615769bcb6d0e6d79febd',
              id: 43,
              frequency: 13352,
            },
            {
              _id: '5d6615769bcb6d0e6d79febc',
              id: 44,
              frequency: 7413,
            },
            {
              _id: '5d6615769bcb6d0e6d79febb',
              id: 45,
              frequency: 766,
            },
            {
              _id: '5d6615769bcb6d0e6d79feba',
              id: 46,
              frequency: 16521,
            },
            {
              _id: '5d6615769bcb6d0e6d79feb9',
              id: 47,
              frequency: 15247,
            },
            {
              _id: '5d6615769bcb6d0e6d79feb8',
              id: 48,
              frequency: 71472,
            },
            {
              _id: '5d6615769bcb6d0e6d79feb7',
              id: 49,
              frequency: 219,
            },
            {
              _id: '5d6615769bcb6d0e6d79feb6',
              id: 50,
              frequency: 291,
            },
            {
              _id: '5d6615769bcb6d0e6d79feb5',
              id: 51,
              frequency: 3055,
            },
            {
              _id: '5d6615769bcb6d0e6d79feb4',
              id: 52,
              frequency: 1746,
            },
            {
              _id: '5d6615769bcb6d0e6d79feb3',
              id: 53,
              frequency: 10811,
            },
            {
              _id: '5d6615769bcb6d0e6d79feb2',
              id: 54,
              frequency: 5517,
            },
            {
              _id: '5d6615769bcb6d0e6d79feb1',
              id: 55,
              frequency: 9952,
            },
            {
              _id: '5d6615769bcb6d0e6d79feb0',
              id: 56,
              frequency: 766,
            },
            {
              _id: '5d6615769bcb6d0e6d79feaf',
              id: 57,
              frequency: 221816,
            },
            {
              _id: '5d6615769bcb6d0e6d79feae',
              id: 58,
              frequency: 44231,
            },
            {
              _id: '5d6615769bcb6d0e6d79fead',
              id: 59,
              frequency: 21004,
            },
            {
              _id: '5d6615769bcb6d0e6d79feac',
              id: 60,
              frequency: 76527,
            },
            {
              _id: '5d6615769bcb6d0e6d79feab',
              id: 61,
              frequency: 42889,
            },
            {
              _id: '5d6615769bcb6d0e6d79feaa',
              id: 62,
              frequency: 1174,
            },
            {
              _id: '5d6615769bcb6d0e6d79fea9',
              id: 63,
              frequency: 10428,
            },
            {
              _id: '5d6615769bcb6d0e6d79fea8',
              id: 64,
              frequency: 10803,
            },
            {
              _id: '5d6615769bcb6d0e6d79fea7',
              id: 65,
              frequency: 18820,
            },
            {
              _id: '5d6615769bcb6d0e6d79fea6',
              id: 66,
              frequency: 209100,
            },
            {
              _id: '5d6615769bcb6d0e6d79fea5',
              id: 67,
              frequency: 280970,
            },
            {
              _id: '5d6615769bcb6d0e6d79fea4',
              id: 68,
              frequency: 44338,
            },
            {
              _id: '5d6615769bcb6d0e6d79fea3',
              id: 69,
              frequency: 15476,
            },
            {
              _id: '5d6615769bcb6d0e6d79fea2',
              id: 70,
              frequency: 215918,
            },
            {
              _id: '5d6615769bcb6d0e6d79fea1',
              id: 71,
              frequency: 565453,
            },
            {
              _id: '5d6615769bcb6d0e6d79fea0',
              id: 72,
              frequency: 1143191,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79fdd3',
          id: 16,
          abbrevName: '17',
          fullName: '17_R_SMG_ant',
          coordinates: {
            x: 23.530686,
            y: -63.574007,
            z: -54.151625,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79fe0c',
              to: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe0b',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe0a',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe09',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe08',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe07',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe06',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe05',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe04',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe03',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe02',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe01',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe00',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdff',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdfe',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdfd',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdfc',
              to: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdfb',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdfa',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdf9',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdf8',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdf7',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdf6',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdf5',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdf4',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdf3',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdf2',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdf1',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdf0',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdef',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdee',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79fded',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdec',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdeb',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdea',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79fde9',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79fde8',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79fde7',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79fde6',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79fde5',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79fde4',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79fde3',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79fde2',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79fde1',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79fde0',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79fddf',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdde',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79fddd',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79fddc',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79fddb',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdda',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdd9',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdd8',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdd7',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdd6',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdd5',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdd4',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79fe55',
              id: 0,
              frequency: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe54',
              id: 1,
              frequency: 1380,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe53',
              id: 2,
              frequency: 229,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe52',
              id: 3,
              frequency: 2049,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe51',
              id: 4,
              frequency: 6931,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe50',
              id: 5,
              frequency: 3664,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe4f',
              id: 6,
              frequency: 1546,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe4e',
              id: 7,
              frequency: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe4d',
              id: 8,
              frequency: 1951,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe4c',
              id: 9,
              frequency: 13079,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe4b',
              id: 10,
              frequency: 17756,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe4a',
              id: 11,
              frequency: 3234,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe49',
              id: 12,
              frequency: 33569,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe48',
              id: 13,
              frequency: 8406,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe47',
              id: 14,
              frequency: 38396,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe46',
              id: 15,
              frequency: 12301,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe45',
              id: 16,
              frequency: 13013,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe44',
              id: 17,
              frequency: 1792,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe43',
              id: 18,
              frequency: 4512,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe42',
              id: 19,
              frequency: 6545,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe41',
              id: 20,
              frequency: 2928,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe40',
              id: 21,
              frequency: 885,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe3f',
              id: 22,
              frequency: 194,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe3e',
              id: 23,
              frequency: 1,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe3d',
              id: 24,
              frequency: 31945,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe3c',
              id: 25,
              frequency: 8898,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe3b',
              id: 26,
              frequency: 17356,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe3a',
              id: 27,
              frequency: 21525,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe39',
              id: 28,
              frequency: 23389,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe38',
              id: 29,
              frequency: 59158,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe37',
              id: 30,
              frequency: 8282,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe36',
              id: 31,
              frequency: 8195,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe35',
              id: 32,
              frequency: 8557,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe34',
              id: 33,
              frequency: 461,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe33',
              id: 34,
              frequency: 2872,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe32',
              id: 35,
              frequency: 2121,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe31',
              id: 36,
              frequency: 3321,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe30',
              id: 37,
              frequency: 4632,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe2f',
              id: 38,
              frequency: 1181,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe2e',
              id: 39,
              frequency: 17536,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe2d',
              id: 40,
              frequency: 47935,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe2c',
              id: 41,
              frequency: 15708,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe2b',
              id: 42,
              frequency: 2881,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe2a',
              id: 43,
              frequency: 66924,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe29',
              id: 44,
              frequency: 1922,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe28',
              id: 45,
              frequency: 40791,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe27',
              id: 46,
              frequency: 74595,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe26',
              id: 47,
              frequency: 33490,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe25',
              id: 48,
              frequency: 36939,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe24',
              id: 49,
              frequency: 676,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe23',
              id: 50,
              frequency: 137,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe22',
              id: 51,
              frequency: 19977,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe21',
              id: 52,
              frequency: 9726,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe20',
              id: 53,
              frequency: 11257,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe1f',
              id: 54,
              frequency: 19089,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe1e',
              id: 55,
              frequency: 1393,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe1d',
              id: 56,
              frequency: 77367,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe1c',
              id: 57,
              frequency: 171879,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe1b',
              id: 58,
              frequency: 30422,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe1a',
              id: 59,
              frequency: 191201,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe19',
              id: 60,
              frequency: 88596,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe18',
              id: 61,
              frequency: 11143,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe17',
              id: 62,
              frequency: 12032,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe16',
              id: 63,
              frequency: 14322,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe15',
              id: 64,
              frequency: 11018,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe14',
              id: 65,
              frequency: 275369,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe13',
              id: 66,
              frequency: 310269,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe12',
              id: 67,
              frequency: 82286,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe11',
              id: 68,
              frequency: 76255,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe10',
              id: 69,
              frequency: 3839,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe0f',
              id: 70,
              frequency: 538789,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe0e',
              id: 71,
              frequency: 168558,
            },
            {
              _id: '5d6615769bcb6d0e6d79fe0d',
              id: 72,
              frequency: 511479,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79fd52',
          id: 17,
          abbrevName: '18',
          fullName: '18_R_Parietal_operuculum_smg_posterior',
          coordinates: {
            x: 58.959184,
            y: -35.183673,
            z: 34.857143,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79fd89',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd88',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd87',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd86',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd85',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd84',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd83',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd82',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd81',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd80',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd7f',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd7e',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd7d',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd7c',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd7b',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd7a',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd79',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd78',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd77',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd76',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd75',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd74',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd73',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd72',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd71',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd70',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd6f',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd6e',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd6d',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd6c',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd6b',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd6a',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd69',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd68',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd67',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd66',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd65',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd64',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd63',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd62',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd61',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd60',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd5f',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd5e',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd5d',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd5c',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd5b',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd5a',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd59',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd58',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd57',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd56',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd55',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd54',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd53',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79fdd2',
              id: 0,
              frequency: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdd1',
              id: 1,
              frequency: 1417,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdd0',
              id: 2,
              frequency: 120,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdcf',
              id: 3,
              frequency: 1960,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdce',
              id: 4,
              frequency: 8882,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdcd',
              id: 5,
              frequency: 1757,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdcc',
              id: 6,
              frequency: 1852,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdcb',
              id: 7,
              frequency: 11,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdca',
              id: 8,
              frequency: 1566,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdc9',
              id: 9,
              frequency: 13793,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdc8',
              id: 10,
              frequency: 18193,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdc7',
              id: 11,
              frequency: 983,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdc6',
              id: 12,
              frequency: 33803,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdc5',
              id: 13,
              frequency: 5561,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdc4',
              id: 14,
              frequency: 37125,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdc3',
              id: 15,
              frequency: 18340,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdc2',
              id: 16,
              frequency: 5372,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdc1',
              id: 17,
              frequency: 2198,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdc0',
              id: 18,
              frequency: 9203,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdbf',
              id: 19,
              frequency: 8985,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdbe',
              id: 20,
              frequency: 1142,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdbd',
              id: 21,
              frequency: 126,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdbc',
              id: 22,
              frequency: 407,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdbb',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdba',
              id: 24,
              frequency: 49403,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdb9',
              id: 25,
              frequency: 12196,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdb8',
              id: 26,
              frequency: 3143,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdb7',
              id: 27,
              frequency: 27560,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdb6',
              id: 28,
              frequency: 7719,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdb5',
              id: 29,
              frequency: 69979,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdb4',
              id: 30,
              frequency: 4847,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdb3',
              id: 31,
              frequency: 8855,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdb2',
              id: 32,
              frequency: 10223,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdb1',
              id: 33,
              frequency: 11,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdb0',
              id: 34,
              frequency: 1957,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdaf',
              id: 35,
              frequency: 3091,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdae',
              id: 36,
              frequency: 3998,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdad',
              id: 37,
              frequency: 4026,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdac',
              id: 38,
              frequency: 129,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdab',
              id: 39,
              frequency: 24132,
            },
            {
              _id: '5d6615769bcb6d0e6d79fdaa',
              id: 40,
              frequency: 60169,
            },
            {
              _id: '5d6615769bcb6d0e6d79fda9',
              id: 41,
              frequency: 8719,
            },
            {
              _id: '5d6615769bcb6d0e6d79fda8',
              id: 42,
              frequency: 261,
            },
            {
              _id: '5d6615769bcb6d0e6d79fda7',
              id: 43,
              frequency: 59002,
            },
            {
              _id: '5d6615769bcb6d0e6d79fda6',
              id: 44,
              frequency: 328,
            },
            {
              _id: '5d6615769bcb6d0e6d79fda5',
              id: 45,
              frequency: 53510,
            },
            {
              _id: '5d6615769bcb6d0e6d79fda4',
              id: 46,
              frequency: 110503,
            },
            {
              _id: '5d6615769bcb6d0e6d79fda3',
              id: 47,
              frequency: 5316,
            },
            {
              _id: '5d6615769bcb6d0e6d79fda2',
              id: 48,
              frequency: 27943,
            },
            {
              _id: '5d6615769bcb6d0e6d79fda1',
              id: 49,
              frequency: 525,
            },
            {
              _id: '5d6615769bcb6d0e6d79fda0',
              id: 50,
              frequency: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd9f',
              id: 51,
              frequency: 17012,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd9e',
              id: 52,
              frequency: 12677,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd9d',
              id: 53,
              frequency: 5691,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd9c',
              id: 54,
              frequency: 20959,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd9b',
              id: 55,
              frequency: 399,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd9a',
              id: 56,
              frequency: 81772,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd99',
              id: 57,
              frequency: 190524,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd98',
              id: 58,
              frequency: 4256,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd97',
              id: 59,
              frequency: 217815,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd96',
              id: 60,
              frequency: 53078,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd95',
              id: 61,
              frequency: 3330,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd94',
              id: 62,
              frequency: 10336,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd93',
              id: 63,
              frequency: 10130,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd92',
              id: 64,
              frequency: 9334,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd91',
              id: 65,
              frequency: 280266,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd90',
              id: 66,
              frequency: 319575,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd8f',
              id: 67,
              frequency: 39662,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd8e',
              id: 68,
              frequency: 63019,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd8d',
              id: 69,
              frequency: 1855,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd8c',
              id: 70,
              frequency: 538484,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd8b',
              id: 71,
              frequency: 124960,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd8a',
              id: 72,
              frequency: 501978,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79fcbe',
          id: 18,
          abbrevName: '19',
          fullName: '19_L_Cerebellum_anterior',
          coordinates: {
            x: -19.05098,
            y: -45.639216,
            z: -37.929412,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79fd08',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd07',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd06',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd05',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd04',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd03',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd02',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd01',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd00',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcff',
              to: 28,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcfe',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcfd',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcfc',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcfb',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcfa',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcf9',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcf8',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcf7',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcf6',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcf5',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcf4',
              to: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcf3',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcf2',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcf1',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcf0',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcef',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcee',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79fced',
              to: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcec',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79fceb',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcea',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79fce9',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79fce8',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79fce7',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79fce6',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79fce5',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79fce4',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79fce3',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79fce2',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79fce1',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79fce0',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcdf',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcde',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcdd',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcdc',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcdb',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcda',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcd9',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcd8',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcd7',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcd6',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcd5',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcd4',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcd3',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcd2',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcd1',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcd0',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79fccf',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcce',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79fccd',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79fccc',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79fccb',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcca',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcc9',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcc8',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcc7',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcc6',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcc5',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcc4',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcc3',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcc2',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcc1',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcc0',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcbf',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79fd51',
              id: 0,
              frequency: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd50',
              id: 1,
              frequency: 313,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd4f',
              id: 2,
              frequency: 762,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd4e',
              id: 3,
              frequency: 3424,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd4d',
              id: 4,
              frequency: 291,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd4c',
              id: 5,
              frequency: 3058,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd4b',
              id: 6,
              frequency: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd4a',
              id: 7,
              frequency: 1393,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd49',
              id: 8,
              frequency: 682,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd48',
              id: 9,
              frequency: 447,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd47',
              id: 10,
              frequency: 7997,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd46',
              id: 11,
              frequency: 17623,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd45',
              id: 12,
              frequency: 8032,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd44',
              id: 13,
              frequency: 29155,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd43',
              id: 14,
              frequency: 77409,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd42',
              id: 15,
              frequency: 135,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd41',
              id: 16,
              frequency: 1486,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd40',
              id: 17,
              frequency: 738,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd3f',
              id: 18,
              frequency: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd3e',
              id: 19,
              frequency: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd3d',
              id: 20,
              frequency: 952,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd3c',
              id: 21,
              frequency: 5130,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd3b',
              id: 22,
              frequency: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd3a',
              id: 23,
              frequency: 619,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd39',
              id: 24,
              frequency: 297,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd38',
              id: 25,
              frequency: 1105,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd37',
              id: 26,
              frequency: 26433,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd36',
              id: 27,
              frequency: 137,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd35',
              id: 28,
              frequency: 3442,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd34',
              id: 29,
              frequency: 5076,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd33',
              id: 30,
              frequency: 20679,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd32',
              id: 31,
              frequency: 117,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd31',
              id: 32,
              frequency: 1810,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd30',
              id: 33,
              frequency: 18944,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd2f',
              id: 34,
              frequency: 524,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd2e',
              id: 35,
              frequency: 1,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd2d',
              id: 36,
              frequency: 211,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd2c',
              id: 37,
              frequency: 643,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd2b',
              id: 38,
              frequency: 2452,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd2a',
              id: 39,
              frequency: 123,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd29',
              id: 40,
              frequency: 4457,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd28',
              id: 41,
              frequency: 13744,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd27',
              id: 42,
              frequency: 65255,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd26',
              id: 43,
              frequency: 6714,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd25',
              id: 44,
              frequency: 23591,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd24',
              id: 45,
              frequency: 167,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd23',
              id: 46,
              frequency: 4100,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd22',
              id: 47,
              frequency: 31639,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd21',
              id: 48,
              frequency: 48586,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd20',
              id: 49,
              frequency: 2,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd1f',
              id: 50,
              frequency: 144,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd1e',
              id: 51,
              frequency: 1397,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd1d',
              id: 52,
              frequency: 525,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd1c',
              id: 53,
              frequency: 12141,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd1b',
              id: 54,
              frequency: 526,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd1a',
              id: 55,
              frequency: 18358,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd19',
              id: 56,
              frequency: 296,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd18',
              id: 57,
              frequency: 119725,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd17',
              id: 58,
              frequency: 228548,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd16',
              id: 59,
              frequency: 7802,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd15',
              id: 60,
              frequency: 68260,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd14',
              id: 61,
              frequency: 94325,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd13',
              id: 62,
              frequency: 576,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd12',
              id: 63,
              frequency: 6535,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd11',
              id: 64,
              frequency: 6593,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd10',
              id: 65,
              frequency: 10085,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd0f',
              id: 66,
              frequency: 142093,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd0e',
              id: 67,
              frequency: 431391,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd0d',
              id: 68,
              frequency: 26692,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd0c',
              id: 69,
              frequency: 21632,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd0b',
              id: 70,
              frequency: 140323,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd0a',
              id: 71,
              frequency: 668253,
            },
            {
              _id: '5d6615769bcb6d0e6d79fd09',
              id: 72,
              frequency: 1223239,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79fc2d',
          id: 19,
          abbrevName: '20',
          fullName: '20_R_Frontal_pole',
          coordinates: {
            x: 36.891304,
            y: 42.76087,
            z: -12.956522,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79fc74',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc73',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc72',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc71',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc70',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc6f',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc6e',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc6d',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc6c',
              to: 28,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc6b',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc6a',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc69',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc68',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc67',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc66',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc65',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc64',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc63',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc62',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc61',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc60',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc5f',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc5e',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc5d',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc5c',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc5b',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc5a',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc59',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc58',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc57',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc56',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc55',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc54',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc53',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc52',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc51',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc50',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc4f',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc4e',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc4d',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc4c',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc4b',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc4a',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc49',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc48',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc47',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc46',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc45',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc44',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc43',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc42',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc41',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc40',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc3f',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc3e',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc3d',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc3c',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc3b',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc3a',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc39',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc38',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc37',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc36',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc35',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc34',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc33',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc32',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc31',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc30',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc2f',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc2e',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79fcbd',
              id: 0,
              frequency: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcbc',
              id: 1,
              frequency: 379,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcbb',
              id: 2,
              frequency: 479,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcba',
              id: 3,
              frequency: 3349,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcb9',
              id: 4,
              frequency: 858,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcb8',
              id: 5,
              frequency: 2674,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcb7',
              id: 6,
              frequency: 223,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcb6',
              id: 7,
              frequency: 252,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcb5',
              id: 8,
              frequency: 706,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcb4',
              id: 9,
              frequency: 556,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcb3',
              id: 10,
              frequency: 11933,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcb2',
              id: 11,
              frequency: 7868,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcb1',
              id: 12,
              frequency: 8477,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcb0',
              id: 13,
              frequency: 24702,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcaf',
              id: 14,
              frequency: 76914,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcae',
              id: 15,
              frequency: 526,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcad',
              id: 16,
              frequency: 3317,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcac',
              id: 17,
              frequency: 2176,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcab',
              id: 18,
              frequency: 378,
            },
            {
              _id: '5d6615769bcb6d0e6d79fcaa',
              id: 19,
              frequency: 613,
            },
            {
              _id: '5d6615769bcb6d0e6d79fca9',
              id: 20,
              frequency: 1598,
            },
            {
              _id: '5d6615769bcb6d0e6d79fca8',
              id: 21,
              frequency: 1390,
            },
            {
              _id: '5d6615769bcb6d0e6d79fca7',
              id: 22,
              frequency: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79fca6',
              id: 23,
              frequency: 14,
            },
            {
              _id: '5d6615769bcb6d0e6d79fca5',
              id: 24,
              frequency: 688,
            },
            {
              _id: '5d6615769bcb6d0e6d79fca4',
              id: 25,
              frequency: 6541,
            },
            {
              _id: '5d6615769bcb6d0e6d79fca3',
              id: 26,
              frequency: 15342,
            },
            {
              _id: '5d6615769bcb6d0e6d79fca2',
              id: 27,
              frequency: 664,
            },
            {
              _id: '5d6615769bcb6d0e6d79fca1',
              id: 28,
              frequency: 2500,
            },
            {
              _id: '5d6615769bcb6d0e6d79fca0',
              id: 29,
              frequency: 17434,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc9f',
              id: 30,
              frequency: 21282,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc9e',
              id: 31,
              frequency: 392,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc9d',
              id: 32,
              frequency: 4564,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc9c',
              id: 33,
              frequency: 1574,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc9b',
              id: 34,
              frequency: 754,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc9a',
              id: 35,
              frequency: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc99',
              id: 36,
              frequency: 1073,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc98',
              id: 37,
              frequency: 1453,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc97',
              id: 38,
              frequency: 686,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc96',
              id: 39,
              frequency: 155,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc95',
              id: 40,
              frequency: 9506,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc94',
              id: 41,
              frequency: 22070,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc93',
              id: 42,
              frequency: 11153,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc92',
              id: 43,
              frequency: 8907,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc91',
              id: 44,
              frequency: 10254,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc90',
              id: 45,
              frequency: 645,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc8f',
              id: 46,
              frequency: 13655,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc8e',
              id: 47,
              frequency: 12719,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc8d',
              id: 48,
              frequency: 73485,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc8c',
              id: 49,
              frequency: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc8b',
              id: 50,
              frequency: 139,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc8a',
              id: 51,
              frequency: 2255,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc89',
              id: 52,
              frequency: 1994,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc88',
              id: 53,
              frequency: 8694,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc87',
              id: 54,
              frequency: 1087,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc86',
              id: 55,
              frequency: 7063,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc85',
              id: 56,
              frequency: 450,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc84',
              id: 57,
              frequency: 225678,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc83',
              id: 58,
              frequency: 58909,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc82',
              id: 59,
              frequency: 16688,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc81',
              id: 60,
              frequency: 60289,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc80',
              id: 61,
              frequency: 52850,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc7f',
              id: 62,
              frequency: 383,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc7e',
              id: 63,
              frequency: 6886,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc7d',
              id: 64,
              frequency: 8476,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc7c',
              id: 65,
              frequency: 8628,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc7b',
              id: 66,
              frequency: 177990,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc7a',
              id: 67,
              frequency: 319883,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc79',
              id: 68,
              frequency: 28671,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc78',
              id: 69,
              frequency: 18156,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc77',
              id: 70,
              frequency: 137932,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc76',
              id: 71,
              frequency: 624619,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc75',
              id: 72,
              frequency: 1227415,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79fb9d',
          id: 20,
          abbrevName: '21',
          fullName: '21_R_Precuneous_lingual',
          coordinates: {
            x: 13.379845,
            y: -59.348837,
            z: 9.534884,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79fbe3',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbe2',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbe1',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbe0',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbdf',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbde',
              to: 28,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbdd',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbdc',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbdb',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbda',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbd9',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbd8',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbd7',
              to: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbd6',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbd5',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbd4',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbd3',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbd2',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbd1',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbd0',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbcf',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbce',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbcd',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbcc',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbcb',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbca',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbc9',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbc8',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbc7',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbc6',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbc5',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbc4',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbc3',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbc2',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbc1',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbc0',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbbf',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbbe',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbbd',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbbc',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbbb',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbba',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbb9',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbb8',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbb7',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbb6',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbb5',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbb4',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbb3',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbb2',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbb1',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbb0',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbaf',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbae',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbad',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbac',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbab',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbaa',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79fba9',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79fba8',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79fba7',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79fba6',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79fba5',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79fba4',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79fba3',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79fba2',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79fba1',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79fba0',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb9f',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb9e',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79fc2c',
              id: 0,
              frequency: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc2b',
              id: 1,
              frequency: 471,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc2a',
              id: 2,
              frequency: 563,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc29',
              id: 3,
              frequency: 3265,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc28',
              id: 4,
              frequency: 296,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc27',
              id: 5,
              frequency: 3240,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc26',
              id: 6,
              frequency: 328,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc25',
              id: 7,
              frequency: 488,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc24',
              id: 8,
              frequency: 1149,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc23',
              id: 9,
              frequency: 796,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc22',
              id: 10,
              frequency: 10071,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc21',
              id: 11,
              frequency: 10268,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc20',
              id: 12,
              frequency: 12684,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc1f',
              id: 13,
              frequency: 26418,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc1e',
              id: 14,
              frequency: 72562,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc1d',
              id: 15,
              frequency: 155,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc1c',
              id: 16,
              frequency: 1091,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc1b',
              id: 17,
              frequency: 4869,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc1a',
              id: 18,
              frequency: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc19',
              id: 19,
              frequency: 420,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc18',
              id: 20,
              frequency: 1449,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc17',
              id: 21,
              frequency: 2378,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc16',
              id: 22,
              frequency: 101,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc15',
              id: 23,
              frequency: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc14',
              id: 24,
              frequency: 341,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc13',
              id: 25,
              frequency: 8661,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc12',
              id: 26,
              frequency: 16378,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc11',
              id: 27,
              frequency: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc10',
              id: 28,
              frequency: 3399,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc0f',
              id: 29,
              frequency: 4336,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc0e',
              id: 30,
              frequency: 22969,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc0d',
              id: 31,
              frequency: 507,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc0c',
              id: 32,
              frequency: 4323,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc0b',
              id: 33,
              frequency: 3625,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc0a',
              id: 34,
              frequency: 196,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc09',
              id: 35,
              frequency: 6,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc08',
              id: 36,
              frequency: 259,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc07',
              id: 37,
              frequency: 2117,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc06',
              id: 38,
              frequency: 1883,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc05',
              id: 39,
              frequency: 214,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc04',
              id: 40,
              frequency: 16655,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc03',
              id: 41,
              frequency: 17561,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc02',
              id: 42,
              frequency: 21442,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc01',
              id: 43,
              frequency: 7186,
            },
            {
              _id: '5d6615769bcb6d0e6d79fc00',
              id: 44,
              frequency: 14285,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbff',
              id: 45,
              frequency: 243,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbfe',
              id: 46,
              frequency: 2851,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbfd',
              id: 47,
              frequency: 27371,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbfc',
              id: 48,
              frequency: 64843,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbfb',
              id: 49,
              frequency: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbfa',
              id: 50,
              frequency: 277,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbf9',
              id: 51,
              frequency: 2004,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbf8',
              id: 52,
              frequency: 571,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbf7',
              id: 53,
              frequency: 11355,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbf6',
              id: 54,
              frequency: 1938,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbf5',
              id: 55,
              frequency: 12448,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbf4',
              id: 56,
              frequency: 711,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbf3',
              id: 57,
              frequency: 164258,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbf2',
              id: 58,
              frequency: 86481,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbf1',
              id: 59,
              frequency: 10567,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbf0',
              id: 60,
              frequency: 76862,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbef',
              id: 61,
              frequency: 70286,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbee',
              id: 62,
              frequency: 1475,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbed',
              id: 63,
              frequency: 11837,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbec',
              id: 64,
              frequency: 8983,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbeb',
              id: 65,
              frequency: 21573,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbea',
              id: 66,
              frequency: 157532,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbe9',
              id: 67,
              frequency: 365491,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbe8',
              id: 68,
              frequency: 52088,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbe7',
              id: 69,
              frequency: 18668,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbe6',
              id: 70,
              frequency: 237682,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbe5',
              id: 71,
              frequency: 620259,
            },
            {
              _id: '5d6615769bcb6d0e6d79fbe4',
              id: 72,
              frequency: 1118820,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79fb0e',
          id: 21,
          abbrevName: '22',
          fullName: '22_L_Thalamus',
          coordinates: {
            x: -10.568421,
            y: -18.315789,
            z: 7.284211,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79fb53',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb52',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb51',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb50',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb4f',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb4e',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb4d',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb4c',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb4b',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb4a',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb49',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb48',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb47',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb46',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb45',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb44',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb43',
              to: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb42',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb41',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb40',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb3f',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb3e',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb3d',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb3c',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb3b',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb3a',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb39',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb38',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb37',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb36',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb35',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb34',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb33',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb32',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb31',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb30',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb2f',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb2e',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb2d',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb2c',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb2b',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb2a',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb29',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb28',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb27',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb26',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb25',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb24',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb23',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb22',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb21',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb20',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb1f',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb1e',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb1d',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb1c',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb1b',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb1a',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb19',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb18',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb17',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb16',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb15',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb14',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb13',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb12',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb11',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb10',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb0f',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79fb9c',
              id: 0,
              frequency: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb9b',
              id: 1,
              frequency: 357,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb9a',
              id: 2,
              frequency: 632,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb99',
              id: 3,
              frequency: 3373,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb98',
              id: 4,
              frequency: 673,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb97',
              id: 5,
              frequency: 2643,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb96',
              id: 6,
              frequency: 176,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb95',
              id: 7,
              frequency: 860,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb94',
              id: 8,
              frequency: 1069,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb93',
              id: 9,
              frequency: 516,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb92',
              id: 10,
              frequency: 8100,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb91',
              id: 11,
              frequency: 12383,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb90',
              id: 12,
              frequency: 9446,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb8f',
              id: 13,
              frequency: 28270,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb8e',
              id: 14,
              frequency: 75967,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb8d',
              id: 15,
              frequency: 691,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb8c',
              id: 16,
              frequency: 3358,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb8b',
              id: 17,
              frequency: 786,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb8a',
              id: 18,
              frequency: 252,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb89',
              id: 19,
              frequency: 257,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb88',
              id: 20,
              frequency: 812,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb87',
              id: 21,
              frequency: 3246,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb86',
              id: 22,
              frequency: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb85',
              id: 23,
              frequency: 209,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb84',
              id: 24,
              frequency: 774,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb83',
              id: 25,
              frequency: 869,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb82',
              id: 26,
              frequency: 17059,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb81',
              id: 27,
              frequency: 497,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb80',
              id: 28,
              frequency: 2965,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb7f',
              id: 29,
              frequency: 13294,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb7e',
              id: 30,
              frequency: 18648,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb7d',
              id: 31,
              frequency: 173,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb7c',
              id: 32,
              frequency: 1989,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb7b',
              id: 33,
              frequency: 9263,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb7a',
              id: 34,
              frequency: 600,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb79',
              id: 35,
              frequency: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb78',
              id: 36,
              frequency: 941,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb77',
              id: 37,
              frequency: 1486,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb76',
              id: 38,
              frequency: 2296,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb75',
              id: 39,
              frequency: 367,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb74',
              id: 40,
              frequency: 7961,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb73',
              id: 41,
              frequency: 14018,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb72',
              id: 42,
              frequency: 38327,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb71',
              id: 43,
              frequency: 6588,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb70',
              id: 44,
              frequency: 15597,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb6f',
              id: 45,
              frequency: 397,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb6e',
              id: 46,
              frequency: 11574,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb6d',
              id: 47,
              frequency: 20701,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb6c',
              id: 48,
              frequency: 58032,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb6b',
              id: 49,
              frequency: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb6a',
              id: 50,
              frequency: 417,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb69',
              id: 51,
              frequency: 2593,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb68',
              id: 52,
              frequency: 850,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb67',
              id: 53,
              frequency: 11452,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb66',
              id: 54,
              frequency: 1625,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb65',
              id: 55,
              frequency: 17131,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb64',
              id: 56,
              frequency: 318,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb63',
              id: 57,
              frequency: 144288,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb62',
              id: 58,
              frequency: 121066,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb61',
              id: 59,
              frequency: 12722,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb60',
              id: 60,
              frequency: 56259,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb5f',
              id: 61,
              frequency: 75900,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb5e',
              id: 62,
              frequency: 739,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb5d',
              id: 63,
              frequency: 12710,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb5c',
              id: 64,
              frequency: 7509,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb5b',
              id: 65,
              frequency: 9789,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb5a',
              id: 66,
              frequency: 119184,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb59',
              id: 67,
              frequency: 404755,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb58',
              id: 68,
              frequency: 46144,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb57',
              id: 69,
              frequency: 19859,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb56',
              id: 70,
              frequency: 176702,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb55',
              id: 71,
              frequency: 664512,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb54',
              id: 72,
              frequency: 1188571,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79fa89',
          id: 22,
          abbrevName: '23',
          fullName: '23_L_SFG_anterior',
          coordinates: {
            x: -57.193133,
            y: -37.450644,
            z: 35.896996,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79fac4',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d79fac3',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d79fac2',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d79fac1',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d79fac0',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d79fabf',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d79fabe',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d79fabd',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d79fabc',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d79fabb',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d79faba',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d79fab9',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d79fab8',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79fab7',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79fab6',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79fab5',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d79fab4',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d79fab3',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79fab2',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79fab1',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79fab0',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79faaf',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79faae',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79faad',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79faac',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79faab',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79faaa',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79faa9',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79faa8',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79faa7',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79faa6',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79faa5',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79faa4',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79faa3',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79faa2',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79faa1',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79faa0',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa9f',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa9e',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa9d',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa9c',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa9b',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa9a',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa99',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa98',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa97',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa96',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa95',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa94',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa93',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa92',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa91',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa90',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa8f',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa8e',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa8d',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa8c',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa8b',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa8a',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79fb0d',
              id: 0,
              frequency: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb0c',
              id: 1,
              frequency: 1051,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb0b',
              id: 2,
              frequency: 250,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb0a',
              id: 3,
              frequency: 2525,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb09',
              id: 4,
              frequency: 5179,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb08',
              id: 5,
              frequency: 2839,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb07',
              id: 6,
              frequency: 973,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb06',
              id: 7,
              frequency: 114,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb05',
              id: 8,
              frequency: 1731,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb04',
              id: 9,
              frequency: 6538,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb03',
              id: 10,
              frequency: 17759,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb02',
              id: 11,
              frequency: 3077,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb01',
              id: 12,
              frequency: 26857,
            },
            {
              _id: '5d6615769bcb6d0e6d79fb00',
              id: 13,
              frequency: 11754,
            },
            {
              _id: '5d6615769bcb6d0e6d79faff',
              id: 14,
              frequency: 52580,
            },
            {
              _id: '5d6615769bcb6d0e6d79fafe',
              id: 15,
              frequency: 9371,
            },
            {
              _id: '5d6615769bcb6d0e6d79fafd',
              id: 16,
              frequency: 8000,
            },
            {
              _id: '5d6615769bcb6d0e6d79fafc',
              id: 17,
              frequency: 1759,
            },
            {
              _id: '5d6615769bcb6d0e6d79fafb',
              id: 18,
              frequency: 4127,
            },
            {
              _id: '5d6615769bcb6d0e6d79fafa',
              id: 19,
              frequency: 2959,
            },
            {
              _id: '5d6615769bcb6d0e6d79faf9',
              id: 20,
              frequency: 1721,
            },
            {
              _id: '5d6615769bcb6d0e6d79faf8',
              id: 21,
              frequency: 1055,
            },
            {
              _id: '5d6615769bcb6d0e6d79faf7',
              id: 22,
              frequency: 281,
            },
            {
              _id: '5d6615769bcb6d0e6d79faf6',
              id: 23,
              frequency: 9,
            },
            {
              _id: '5d6615769bcb6d0e6d79faf5',
              id: 24,
              frequency: 18198,
            },
            {
              _id: '5d6615769bcb6d0e6d79faf4',
              id: 25,
              frequency: 4837,
            },
            {
              _id: '5d6615769bcb6d0e6d79faf3',
              id: 26,
              frequency: 10966,
            },
            {
              _id: '5d6615769bcb6d0e6d79faf2',
              id: 27,
              frequency: 12378,
            },
            {
              _id: '5d6615769bcb6d0e6d79faf1',
              id: 28,
              frequency: 8962,
            },
            {
              _id: '5d6615769bcb6d0e6d79faf0',
              id: 29,
              frequency: 60345,
            },
            {
              _id: '5d6615769bcb6d0e6d79faef',
              id: 30,
              frequency: 9701,
            },
            {
              _id: '5d6615769bcb6d0e6d79faee',
              id: 31,
              frequency: 3103,
            },
            {
              _id: '5d6615769bcb6d0e6d79faed',
              id: 32,
              frequency: 7508,
            },
            {
              _id: '5d6615769bcb6d0e6d79faec',
              id: 33,
              frequency: 551,
            },
            {
              _id: '5d6615769bcb6d0e6d79faeb',
              id: 34,
              frequency: 3228,
            },
            {
              _id: '5d6615769bcb6d0e6d79faea',
              id: 35,
              frequency: 1173,
            },
            {
              _id: '5d6615769bcb6d0e6d79fae9',
              id: 36,
              frequency: 3636,
            },
            {
              _id: '5d6615769bcb6d0e6d79fae8',
              id: 37,
              frequency: 3589,
            },
            {
              _id: '5d6615769bcb6d0e6d79fae7',
              id: 38,
              frequency: 891,
            },
            {
              _id: '5d6615769bcb6d0e6d79fae6',
              id: 39,
              frequency: 8203,
            },
            {
              _id: '5d6615769bcb6d0e6d79fae5',
              id: 40,
              frequency: 37380,
            },
            {
              _id: '5d6615769bcb6d0e6d79fae4',
              id: 41,
              frequency: 14863,
            },
            {
              _id: '5d6615769bcb6d0e6d79fae3',
              id: 42,
              frequency: 3501,
            },
            {
              _id: '5d6615769bcb6d0e6d79fae2',
              id: 43,
              frequency: 42611,
            },
            {
              _id: '5d6615769bcb6d0e6d79fae1',
              id: 44,
              frequency: 2750,
            },
            {
              _id: '5d6615769bcb6d0e6d79fae0',
              id: 45,
              frequency: 19657,
            },
            {
              _id: '5d6615769bcb6d0e6d79fadf',
              id: 46,
              frequency: 66435,
            },
            {
              _id: '5d6615769bcb6d0e6d79fade',
              id: 47,
              frequency: 15383,
            },
            {
              _id: '5d6615769bcb6d0e6d79fadd',
              id: 48,
              frequency: 48849,
            },
            {
              _id: '5d6615769bcb6d0e6d79fadc',
              id: 49,
              frequency: 312,
            },
            {
              _id: '5d6615769bcb6d0e6d79fadb',
              id: 50,
              frequency: 375,
            },
            {
              _id: '5d6615769bcb6d0e6d79fada',
              id: 51,
              frequency: 15064,
            },
            {
              _id: '5d6615769bcb6d0e6d79fad9',
              id: 52,
              frequency: 10840,
            },
            {
              _id: '5d6615769bcb6d0e6d79fad8',
              id: 53,
              frequency: 10080,
            },
            {
              _id: '5d6615769bcb6d0e6d79fad7',
              id: 54,
              frequency: 10590,
            },
            {
              _id: '5d6615769bcb6d0e6d79fad6',
              id: 55,
              frequency: 3569,
            },
            {
              _id: '5d6615769bcb6d0e6d79fad5',
              id: 56,
              frequency: 24284,
            },
            {
              _id: '5d6615769bcb6d0e6d79fad4',
              id: 57,
              frequency: 224423,
            },
            {
              _id: '5d6615769bcb6d0e6d79fad3',
              id: 58,
              frequency: 17561,
            },
            {
              _id: '5d6615769bcb6d0e6d79fad2',
              id: 59,
              frequency: 131559,
            },
            {
              _id: '5d6615769bcb6d0e6d79fad1',
              id: 60,
              frequency: 83292,
            },
            {
              _id: '5d6615769bcb6d0e6d79fad0',
              id: 61,
              frequency: 14001,
            },
            {
              _id: '5d6615769bcb6d0e6d79facf',
              id: 62,
              frequency: 5848,
            },
            {
              _id: '5d6615769bcb6d0e6d79face',
              id: 63,
              frequency: 14756,
            },
            {
              _id: '5d6615769bcb6d0e6d79facd',
              id: 64,
              frequency: 11747,
            },
            {
              _id: '5d6615769bcb6d0e6d79facc',
              id: 65,
              frequency: 136960,
            },
            {
              _id: '5d6615769bcb6d0e6d79facb',
              id: 66,
              frequency: 320577,
            },
            {
              _id: '5d6615769bcb6d0e6d79faca',
              id: 67,
              frequency: 121755,
            },
            {
              _id: '5d6615769bcb6d0e6d79fac9',
              id: 68,
              frequency: 73008,
            },
            {
              _id: '5d6615769bcb6d0e6d79fac8',
              id: 69,
              frequency: 3575,
            },
            {
              _id: '5d6615769bcb6d0e6d79fac7',
              id: 70,
              frequency: 460179,
            },
            {
              _id: '5d6615769bcb6d0e6d79fac6',
              id: 71,
              frequency: 273134,
            },
            {
              _id: '5d6615769bcb6d0e6d79fac5',
              id: 72,
              frequency: 775044,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79f9f8',
          id: 23,
          abbrevName: '24',
          fullName: '24_R_MTG_mtg_posterior',
          coordinates: {
            x: 61.072961,
            y: -29.914163,
            z: 0.995708,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79fa3f',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa3e',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa3d',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa3c',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa3b',
              to: 28,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa3a',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa39',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa38',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa37',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa36',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa35',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa34',
              to: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa33',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa32',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa31',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa30',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa2f',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa2e',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa2d',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa2c',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa2b',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa2a',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa29',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa28',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa27',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa26',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa25',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa24',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa23',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa22',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa21',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa20',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa1f',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa1e',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa1d',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa1c',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa1b',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa1a',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa19',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa18',
              to: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa17',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa16',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa15',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa14',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa13',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa12',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa11',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa10',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa0f',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa0e',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa0d',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa0c',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa0b',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa0a',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa09',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa08',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa07',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa06',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa05',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa04',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa03',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa02',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa01',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa00',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9ff',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9fe',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9fd',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9fc',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9fb',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9fa',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9f9',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79fa88',
              id: 0,
              frequency: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa87',
              id: 1,
              frequency: 251,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa86',
              id: 2,
              frequency: 700,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa85',
              id: 3,
              frequency: 3486,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa84',
              id: 4,
              frequency: 394,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa83',
              id: 5,
              frequency: 2443,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa82',
              id: 6,
              frequency: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa81',
              id: 7,
              frequency: 791,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa80',
              id: 8,
              frequency: 379,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa7f',
              id: 9,
              frequency: 300,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa7e',
              id: 10,
              frequency: 7986,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa7d',
              id: 11,
              frequency: 15535,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa7c',
              id: 12,
              frequency: 5827,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa7b',
              id: 13,
              frequency: 29557,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa7a',
              id: 14,
              frequency: 79697,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa79',
              id: 15,
              frequency: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa78',
              id: 16,
              frequency: 2940,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa77',
              id: 17,
              frequency: 937,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa76',
              id: 18,
              frequency: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa75',
              id: 19,
              frequency: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa74',
              id: 20,
              frequency: 379,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa73',
              id: 21,
              frequency: 2678,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa72',
              id: 22,
              frequency: 1,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa71',
              id: 23,
              frequency: 133,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa70',
              id: 24,
              frequency: 139,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa6f',
              id: 25,
              frequency: 1334,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa6e',
              id: 26,
              frequency: 23950,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa6d',
              id: 27,
              frequency: 228,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa6c',
              id: 28,
              frequency: 2025,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa6b',
              id: 29,
              frequency: 8627,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa6a',
              id: 30,
              frequency: 17525,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa69',
              id: 31,
              frequency: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa68',
              id: 32,
              frequency: 1080,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa67',
              id: 33,
              frequency: 7547,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa66',
              id: 34,
              frequency: 397,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa65',
              id: 35,
              frequency: 3,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa64',
              id: 36,
              frequency: 292,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa63',
              id: 37,
              frequency: 184,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa62',
              id: 38,
              frequency: 1035,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa61',
              id: 39,
              frequency: 10,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa60',
              id: 40,
              frequency: 1450,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa5f',
              id: 41,
              frequency: 19734,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa5e',
              id: 42,
              frequency: 41012,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa5d',
              id: 43,
              frequency: 5768,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa5c',
              id: 44,
              frequency: 26054,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa5b',
              id: 45,
              frequency: 273,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa5a',
              id: 46,
              frequency: 6374,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa59',
              id: 47,
              frequency: 23567,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa58',
              id: 48,
              frequency: 50101,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa57',
              id: 49,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa56',
              id: 50,
              frequency: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa55',
              id: 51,
              frequency: 791,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa54',
              id: 52,
              frequency: 933,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa53',
              id: 53,
              frequency: 5905,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa52',
              id: 54,
              frequency: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa51',
              id: 55,
              frequency: 13761,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa50',
              id: 56,
              frequency: 206,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa4f',
              id: 57,
              frequency: 133278,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa4e',
              id: 58,
              frequency: 181385,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa4d',
              id: 59,
              frequency: 7504,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa4c',
              id: 60,
              frequency: 50304,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa4b',
              id: 61,
              frequency: 96455,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa4a',
              id: 62,
              frequency: 260,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa49',
              id: 63,
              frequency: 2781,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa48',
              id: 64,
              frequency: 6446,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa47',
              id: 65,
              frequency: 5346,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa46',
              id: 66,
              frequency: 134782,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa45',
              id: 67,
              frequency: 444216,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa44',
              id: 68,
              frequency: 15045,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa43',
              id: 69,
              frequency: 21674,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa42',
              id: 70,
              frequency: 94302,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa41',
              id: 71,
              frequency: 690120,
            },
            {
              _id: '5d6615769bcb6d0e6d79fa40',
              id: 72,
              frequency: 1271798,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79f96f',
          id: 24,
          abbrevName: '25',
          fullName: '25_L_Frontal_pole',
          coordinates: {
            x: -39.700483,
            y: 47.004831,
            z: 7.613527,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79f9ae',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9ad',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9ac',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9ab',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9aa',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9a9',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9a8',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9a7',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9a6',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9a5',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9a4',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9a3',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9a2',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9a1',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9a0',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d79f99f',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d79f99e',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79f99d',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79f99c',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79f99b',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79f99a',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79f999',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79f998',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79f997',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79f996',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79f995',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79f994',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79f993',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79f992',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79f991',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79f990',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79f98f',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79f98e',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79f98d',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79f98c',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79f98b',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79f98a',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79f989',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79f988',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79f987',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79f986',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79f985',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79f984',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79f983',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79f982',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79f981',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79f980',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79f97f',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79f97e',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79f97d',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79f97c',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79f97b',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79f97a',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79f979',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79f978',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79f977',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79f976',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79f975',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79f974',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79f973',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79f972',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79f971',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79f970',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79f9f7',
              id: 0,
              frequency: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9f6',
              id: 1,
              frequency: 700,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9f5',
              id: 2,
              frequency: 358,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9f4',
              id: 3,
              frequency: 2963,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9f3',
              id: 4,
              frequency: 3136,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9f2',
              id: 5,
              frequency: 2671,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9f1',
              id: 6,
              frequency: 301,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9f0',
              id: 7,
              frequency: 197,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9ef',
              id: 8,
              frequency: 1549,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9ee',
              id: 9,
              frequency: 2791,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9ed',
              id: 10,
              frequency: 14973,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9ec',
              id: 11,
              frequency: 4986,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9eb',
              id: 12,
              frequency: 17979,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9ea',
              id: 13,
              frequency: 18077,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9e9',
              id: 14,
              frequency: 65300,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9e8',
              id: 15,
              frequency: 4001,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9e7',
              id: 16,
              frequency: 7473,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9e6',
              id: 17,
              frequency: 1015,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9e5',
              id: 18,
              frequency: 2321,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9e4',
              id: 19,
              frequency: 581,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9e3',
              id: 20,
              frequency: 994,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9e2',
              id: 21,
              frequency: 1265,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9e1',
              id: 22,
              frequency: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9e0',
              id: 23,
              frequency: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9df',
              id: 24,
              frequency: 6500,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9de',
              id: 25,
              frequency: 2218,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9dd',
              id: 26,
              frequency: 13491,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9dc',
              id: 27,
              frequency: 5945,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9db',
              id: 28,
              frequency: 6065,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9da',
              id: 29,
              frequency: 49557,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9d9',
              id: 30,
              frequency: 11638,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9d8',
              id: 31,
              frequency: 667,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9d7',
              id: 32,
              frequency: 4395,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9d6',
              id: 33,
              frequency: 1169,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9d5',
              id: 34,
              frequency: 1596,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9d4',
              id: 35,
              frequency: 228,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9d3',
              id: 36,
              frequency: 3643,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9d2',
              id: 37,
              frequency: 1505,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9d1',
              id: 38,
              frequency: 938,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9d0',
              id: 39,
              frequency: 1639,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9cf',
              id: 40,
              frequency: 13749,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9ce',
              id: 41,
              frequency: 17829,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9cd',
              id: 42,
              frequency: 6670,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9cc',
              id: 43,
              frequency: 27236,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9cb',
              id: 44,
              frequency: 5835,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9ca',
              id: 45,
              frequency: 7692,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9c9',
              id: 46,
              frequency: 50088,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9c8',
              id: 47,
              frequency: 14069,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9c7',
              id: 48,
              frequency: 61099,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9c6',
              id: 49,
              frequency: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9c5',
              id: 50,
              frequency: 447,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9c4',
              id: 51,
              frequency: 9077,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9c3',
              id: 52,
              frequency: 5439,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9c2',
              id: 53,
              frequency: 10819,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9c1',
              id: 54,
              frequency: 1826,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9c0',
              id: 55,
              frequency: 6503,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9bf',
              id: 56,
              frequency: 6737,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9be',
              id: 57,
              frequency: 235972,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9bd',
              id: 58,
              frequency: 29457,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9bc',
              id: 59,
              frequency: 66377,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9bb',
              id: 60,
              frequency: 72451,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9ba',
              id: 61,
              frequency: 28644,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9b9',
              id: 62,
              frequency: 3468,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9b8',
              id: 63,
              frequency: 14959,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9b7',
              id: 64,
              frequency: 13201,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9b6',
              id: 65,
              frequency: 55190,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9b5',
              id: 66,
              frequency: 252988,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9b4',
              id: 67,
              frequency: 209217,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9b3',
              id: 68,
              frequency: 67703,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9b2',
              id: 69,
              frequency: 8965,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9b1',
              id: 70,
              frequency: 316149,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9b0',
              id: 71,
              frequency: 445161,
            },
            {
              _id: '5d6615769bcb6d0e6d79f9af',
              id: 72,
              frequency: 1007426,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79f8e1',
          id: 25,
          abbrevName: '26',
          fullName: '26_BI_PCC_middle',
          coordinates: {
            x: 0.666667,
            y: -22.9,
            z: 43.25,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79f925',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d79f924',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d79f923',
              to: 28,
            },
            {
              _id: '5d6615769bcb6d0e6d79f922',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d79f921',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d79f920',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d79f91f',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d79f91e',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d79f91d',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d79f91c',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d79f91b',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d79f91a',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d79f919',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79f918',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79f917',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79f916',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d79f915',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d79f914',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79f913',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79f912',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79f911',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79f910',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79f90f',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79f90e',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79f90d',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79f90c',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79f90b',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79f90a',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79f909',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79f908',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79f907',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79f906',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79f905',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79f904',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79f903',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79f902',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79f901',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79f900',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8ff',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8fe',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8fd',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8fc',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8fb',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8fa',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8f9',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8f8',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8f7',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8f6',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8f5',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8f4',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8f3',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8f2',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8f1',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8f0',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8ef',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8ee',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8ed',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8ec',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8eb',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8ea',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8e9',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8e8',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8e7',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8e6',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8e5',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8e4',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8e3',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8e2',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79f96e',
              id: 0,
              frequency: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79f96d',
              id: 1,
              frequency: 147,
            },
            {
              _id: '5d6615769bcb6d0e6d79f96c',
              id: 2,
              frequency: 591,
            },
            {
              _id: '5d6615769bcb6d0e6d79f96b',
              id: 3,
              frequency: 3595,
            },
            {
              _id: '5d6615769bcb6d0e6d79f96a',
              id: 4,
              frequency: 114,
            },
            {
              _id: '5d6615769bcb6d0e6d79f969',
              id: 5,
              frequency: 2013,
            },
            {
              _id: '5d6615769bcb6d0e6d79f968',
              id: 6,
              frequency: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79f967',
              id: 7,
              frequency: 474,
            },
            {
              _id: '5d6615769bcb6d0e6d79f966',
              id: 8,
              frequency: 142,
            },
            {
              _id: '5d6615769bcb6d0e6d79f965',
              id: 9,
              frequency: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79f964',
              id: 10,
              frequency: 7542,
            },
            {
              _id: '5d6615769bcb6d0e6d79f963',
              id: 11,
              frequency: 10539,
            },
            {
              _id: '5d6615769bcb6d0e6d79f962',
              id: 12,
              frequency: 1769,
            },
            {
              _id: '5d6615769bcb6d0e6d79f961',
              id: 13,
              frequency: 30690,
            },
            {
              _id: '5d6615769bcb6d0e6d79f960',
              id: 14,
              frequency: 83877,
            },
            {
              _id: '5d6615769bcb6d0e6d79f95f',
              id: 15,
              frequency: 9,
            },
            {
              _id: '5d6615769bcb6d0e6d79f95e',
              id: 16,
              frequency: 1108,
            },
            {
              _id: '5d6615769bcb6d0e6d79f95d',
              id: 17,
              frequency: 842,
            },
            {
              _id: '5d6615769bcb6d0e6d79f95c',
              id: 18,
              frequency: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d79f95b',
              id: 19,
              frequency: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79f95a',
              id: 20,
              frequency: 1129,
            },
            {
              _id: '5d6615769bcb6d0e6d79f959',
              id: 21,
              frequency: 1942,
            },
            {
              _id: '5d6615769bcb6d0e6d79f958',
              id: 22,
              frequency: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d79f957',
              id: 23,
              frequency: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79f956',
              id: 24,
              frequency: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d79f955',
              id: 25,
              frequency: 2256,
            },
            {
              _id: '5d6615769bcb6d0e6d79f954',
              id: 26,
              frequency: 15057,
            },
            {
              _id: '5d6615769bcb6d0e6d79f953',
              id: 27,
              frequency: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d79f952',
              id: 28,
              frequency: 1270,
            },
            {
              _id: '5d6615769bcb6d0e6d79f951',
              id: 29,
              frequency: 5515,
            },
            {
              _id: '5d6615769bcb6d0e6d79f950',
              id: 30,
              frequency: 22300,
            },
            {
              _id: '5d6615769bcb6d0e6d79f94f',
              id: 31,
              frequency: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d79f94e',
              id: 32,
              frequency: 3071,
            },
            {
              _id: '5d6615769bcb6d0e6d79f94d',
              id: 33,
              frequency: 3418,
            },
            {
              _id: '5d6615769bcb6d0e6d79f94c',
              id: 34,
              frequency: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79f94b',
              id: 35,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79f94a',
              id: 36,
              frequency: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79f949',
              id: 37,
              frequency: 255,
            },
            {
              _id: '5d6615769bcb6d0e6d79f948',
              id: 38,
              frequency: 500,
            },
            {
              _id: '5d6615769bcb6d0e6d79f947',
              id: 39,
              frequency: 12,
            },
            {
              _id: '5d6615769bcb6d0e6d79f946',
              id: 40,
              frequency: 2265,
            },
            {
              _id: '5d6615769bcb6d0e6d79f945',
              id: 41,
              frequency: 17953,
            },
            {
              _id: '5d6615769bcb6d0e6d79f944',
              id: 42,
              frequency: 20879,
            },
            {
              _id: '5d6615769bcb6d0e6d79f943',
              id: 43,
              frequency: 3292,
            },
            {
              _id: '5d6615769bcb6d0e6d79f942',
              id: 44,
              frequency: 14997,
            },
            {
              _id: '5d6615769bcb6d0e6d79f941',
              id: 45,
              frequency: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d79f940',
              id: 46,
              frequency: 888,
            },
            {
              _id: '5d6615769bcb6d0e6d79f93f',
              id: 47,
              frequency: 6269,
            },
            {
              _id: '5d6615769bcb6d0e6d79f93e',
              id: 48,
              frequency: 72558,
            },
            {
              _id: '5d6615769bcb6d0e6d79f93d',
              id: 49,
              frequency: 5,
            },
            {
              _id: '5d6615769bcb6d0e6d79f93c',
              id: 50,
              frequency: 11,
            },
            {
              _id: '5d6615769bcb6d0e6d79f93b',
              id: 51,
              frequency: 164,
            },
            {
              _id: '5d6615769bcb6d0e6d79f93a',
              id: 52,
              frequency: 166,
            },
            {
              _id: '5d6615769bcb6d0e6d79f939',
              id: 53,
              frequency: 3996,
            },
            {
              _id: '5d6615769bcb6d0e6d79f938',
              id: 54,
              frequency: 184,
            },
            {
              _id: '5d6615769bcb6d0e6d79f937',
              id: 55,
              frequency: 14159,
            },
            {
              _id: '5d6615769bcb6d0e6d79f936',
              id: 56,
              frequency: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d79f935',
              id: 57,
              frequency: 186459,
            },
            {
              _id: '5d6615769bcb6d0e6d79f934',
              id: 58,
              frequency: 80538,
            },
            {
              _id: '5d6615769bcb6d0e6d79f933',
              id: 59,
              frequency: 1285,
            },
            {
              _id: '5d6615769bcb6d0e6d79f932',
              id: 60,
              frequency: 27537,
            },
            {
              _id: '5d6615769bcb6d0e6d79f931',
              id: 61,
              frequency: 79046,
            },
            {
              _id: '5d6615769bcb6d0e6d79f930',
              id: 62,
              frequency: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d79f92f',
              id: 63,
              frequency: 631,
            },
            {
              _id: '5d6615769bcb6d0e6d79f92e',
              id: 64,
              frequency: 3727,
            },
            {
              _id: '5d6615769bcb6d0e6d79f92d',
              id: 65,
              frequency: 479,
            },
            {
              _id: '5d6615769bcb6d0e6d79f92c',
              id: 66,
              frequency: 71677,
            },
            {
              _id: '5d6615769bcb6d0e6d79f92b',
              id: 67,
              frequency: 429683,
            },
            {
              _id: '5d6615769bcb6d0e6d79f92a',
              id: 68,
              frequency: 3262,
            },
            {
              _id: '5d6615769bcb6d0e6d79f929',
              id: 69,
              frequency: 25395,
            },
            {
              _id: '5d6615769bcb6d0e6d79f928',
              id: 70,
              frequency: 15524,
            },
            {
              _id: '5d6615769bcb6d0e6d79f927',
              id: 71,
              frequency: 774508,
            },
            {
              _id: '5d6615769bcb6d0e6d79f926',
              id: 72,
              frequency: 1351454,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79f851',
          id: 26,
          abbrevName: '27',
          fullName: '27_L_Frontal_pole',
          coordinates: {
            x: 51.325843,
            y: 6.94382,
            z: -22.359551,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79f897',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d79f896',
              to: 28,
            },
            {
              _id: '5d6615769bcb6d0e6d79f895',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d79f894',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d79f893',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d79f892',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d79f891',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d79f890',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d79f88f',
              to: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d79f88e',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d79f88d',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d79f88c',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d79f88b',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79f88a',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79f889',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79f888',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d79f887',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d79f886',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79f885',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79f884',
              to: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d79f883',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79f882',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79f881',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79f880',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79f87f',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79f87e',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79f87d',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79f87c',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79f87b',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79f87a',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79f879',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79f878',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79f877',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79f876',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79f875',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79f874',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79f873',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79f872',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79f871',
              to: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d79f870',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79f86f',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79f86e',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79f86d',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79f86c',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79f86b',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79f86a',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79f869',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79f868',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79f867',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79f866',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79f865',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79f864',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79f863',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79f862',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79f861',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79f860',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79f85f',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79f85e',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79f85d',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79f85c',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d79f85b',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79f85a',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79f859',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79f858',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79f857',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79f856',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79f855',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79f854',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79f853',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79f852',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79f8e0',
              id: 0,
              frequency: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8df',
              id: 1,
              frequency: 133,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8de',
              id: 2,
              frequency: 856,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8dd',
              id: 3,
              frequency: 3609,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8dc',
              id: 4,
              frequency: 118,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8db',
              id: 5,
              frequency: 1380,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8da',
              id: 6,
              frequency: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8d9',
              id: 7,
              frequency: 1447,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8d8',
              id: 8,
              frequency: 318,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8d7',
              id: 9,
              frequency: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8d6',
              id: 10,
              frequency: 4696,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8d5',
              id: 11,
              frequency: 21049,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8d4',
              id: 12,
              frequency: 2895,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8d3',
              id: 13,
              frequency: 33169,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8d2',
              id: 14,
              frequency: 82750,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8d1',
              id: 15,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8d0',
              id: 16,
              frequency: 922,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8cf',
              id: 17,
              frequency: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8ce',
              id: 18,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8cd',
              id: 19,
              frequency: 14,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8cc',
              id: 20,
              frequency: 189,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8cb',
              id: 21,
              frequency: 2439,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8ca',
              id: 22,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8c9',
              id: 23,
              frequency: 536,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8c8',
              id: 24,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8c7',
              id: 25,
              frequency: 204,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8c6',
              id: 26,
              frequency: 20280,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8c5',
              id: 27,
              frequency: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8c4',
              id: 28,
              frequency: 494,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8c3',
              id: 29,
              frequency: 2849,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8c2',
              id: 30,
              frequency: 8657,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8c1',
              id: 31,
              frequency: 9,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8c0',
              id: 32,
              frequency: 477,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8bf',
              id: 33,
              frequency: 18032,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8be',
              id: 34,
              frequency: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8bd',
              id: 35,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8bc',
              id: 36,
              frequency: 146,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8bb',
              id: 37,
              frequency: 115,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8ba',
              id: 38,
              frequency: 869,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8b9',
              id: 39,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8b8',
              id: 40,
              frequency: 633,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8b7',
              id: 41,
              frequency: 14018,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8b6',
              id: 42,
              frequency: 75297,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8b5',
              id: 43,
              frequency: 1463,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8b4',
              id: 44,
              frequency: 38474,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8b3',
              id: 45,
              frequency: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8b2',
              id: 46,
              frequency: 2055,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8b1',
              id: 47,
              frequency: 11055,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8b0',
              id: 48,
              frequency: 29143,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8af',
              id: 49,
              frequency: 6,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8ae',
              id: 50,
              frequency: 93,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8ad',
              id: 51,
              frequency: 368,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8ac',
              id: 52,
              frequency: 153,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8ab',
              id: 53,
              frequency: 5836,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8aa',
              id: 54,
              frequency: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8a9',
              id: 55,
              frequency: 19619,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8a8',
              id: 56,
              frequency: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8a7',
              id: 57,
              frequency: 88960,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8a6',
              id: 58,
              frequency: 274743,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8a5',
              id: 59,
              frequency: 2089,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8a4',
              id: 60,
              frequency: 27041,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8a3',
              id: 61,
              frequency: 126174,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8a2',
              id: 62,
              frequency: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8a1',
              id: 63,
              frequency: 3453,
            },
            {
              _id: '5d6615769bcb6d0e6d79f8a0',
              id: 64,
              frequency: 4499,
            },
            {
              _id: '5d6615769bcb6d0e6d79f89f',
              id: 65,
              frequency: 792,
            },
            {
              _id: '5d6615769bcb6d0e6d79f89e',
              id: 66,
              frequency: 69737,
            },
            {
              _id: '5d6615769bcb6d0e6d79f89d',
              id: 67,
              frequency: 519377,
            },
            {
              _id: '5d6615769bcb6d0e6d79f89c',
              id: 68,
              frequency: 11185,
            },
            {
              _id: '5d6615769bcb6d0e6d79f89b',
              id: 69,
              frequency: 24459,
            },
            {
              _id: '5d6615769bcb6d0e6d79f89a',
              id: 70,
              frequency: 45193,
            },
            {
              _id: '5d6615769bcb6d0e6d79f899',
              id: 71,
              frequency: 764228,
            },
            {
              _id: '5d6615769bcb6d0e6d79f898',
              id: 72,
              frequency: 1322606,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79f7d8',
          id: 27,
          abbrevName: '28',
          fullName: '28_L_HC_amygdala',
          coordinates: {
            x: -23.698925,
            y: -10.860215,
            z: -23.655914,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79f807',
              to: 28,
            },
            {
              _id: '5d6615769bcb6d0e6d79f806',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d79f805',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d79f804',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d79f803',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d79f802',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d79f801',
              to: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d79f800',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7ff',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7fe',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7fd',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7fc',
              to: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7fb',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7fa',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7f9',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7f8',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7f7',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7f6',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7f5',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7f4',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7f3',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7f2',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7f1',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7f0',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7ef',
              to: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7ee',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7ed',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7ec',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7eb',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7ea',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7e9',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7e8',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7e7',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7e6',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7e5',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7e4',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7e3',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7e2',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7e1',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7e0',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7df',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7de',
              to: 93,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7dd',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7dc',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7db',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7da',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7d9',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79f850',
              id: 0,
              frequency: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79f84f',
              id: 1,
              frequency: 1651,
            },
            {
              _id: '5d6615769bcb6d0e6d79f84e',
              id: 2,
              frequency: 374,
            },
            {
              _id: '5d6615769bcb6d0e6d79f84d',
              id: 3,
              frequency: 1642,
            },
            {
              _id: '5d6615769bcb6d0e6d79f84c',
              id: 4,
              frequency: 6110,
            },
            {
              _id: '5d6615769bcb6d0e6d79f84b',
              id: 5,
              frequency: 9142,
            },
            {
              _id: '5d6615769bcb6d0e6d79f84a',
              id: 6,
              frequency: 2855,
            },
            {
              _id: '5d6615769bcb6d0e6d79f849',
              id: 7,
              frequency: 542,
            },
            {
              _id: '5d6615769bcb6d0e6d79f848',
              id: 8,
              frequency: 2313,
            },
            {
              _id: '5d6615769bcb6d0e6d79f847',
              id: 9,
              frequency: 20491,
            },
            {
              _id: '5d6615769bcb6d0e6d79f846',
              id: 10,
              frequency: 15861,
            },
            {
              _id: '5d6615769bcb6d0e6d79f845',
              id: 11,
              frequency: 6476,
            },
            {
              _id: '5d6615769bcb6d0e6d79f844',
              id: 12,
              frequency: 37192,
            },
            {
              _id: '5d6615769bcb6d0e6d79f843',
              id: 13,
              frequency: 8610,
            },
            {
              _id: '5d6615769bcb6d0e6d79f842',
              id: 14,
              frequency: 26036,
            },
            {
              _id: '5d6615769bcb6d0e6d79f841',
              id: 15,
              frequency: 9110,
            },
            {
              _id: '5d6615769bcb6d0e6d79f840',
              id: 16,
              frequency: 21631,
            },
            {
              _id: '5d6615769bcb6d0e6d79f83f',
              id: 17,
              frequency: 3860,
            },
            {
              _id: '5d6615769bcb6d0e6d79f83e',
              id: 18,
              frequency: 2243,
            },
            {
              _id: '5d6615769bcb6d0e6d79f83d',
              id: 19,
              frequency: 7150,
            },
            {
              _id: '5d6615769bcb6d0e6d79f83c',
              id: 20,
              frequency: 12397,
            },
            {
              _id: '5d6615769bcb6d0e6d79f83b',
              id: 21,
              frequency: 10734,
            },
            {
              _id: '5d6615769bcb6d0e6d79f83a',
              id: 22,
              frequency: 734,
            },
            {
              _id: '5d6615769bcb6d0e6d79f839',
              id: 23,
              frequency: 303,
            },
            {
              _id: '5d6615769bcb6d0e6d79f838',
              id: 24,
              frequency: 29288,
            },
            {
              _id: '5d6615769bcb6d0e6d79f837',
              id: 25,
              frequency: 9495,
            },
            {
              _id: '5d6615769bcb6d0e6d79f836',
              id: 26,
              frequency: 38654,
            },
            {
              _id: '5d6615769bcb6d0e6d79f835',
              id: 27,
              frequency: 21164,
            },
            {
              _id: '5d6615769bcb6d0e6d79f834',
              id: 28,
              frequency: 97877,
            },
            {
              _id: '5d6615769bcb6d0e6d79f833',
              id: 29,
              frequency: 33532,
            },
            {
              _id: '5d6615769bcb6d0e6d79f832',
              id: 30,
              frequency: 16097,
            },
            {
              _id: '5d6615769bcb6d0e6d79f831',
              id: 31,
              frequency: 17796,
            },
            {
              _id: '5d6615769bcb6d0e6d79f830',
              id: 32,
              frequency: 10020,
            },
            {
              _id: '5d6615769bcb6d0e6d79f82f',
              id: 33,
              frequency: 6203,
            },
            {
              _id: '5d6615769bcb6d0e6d79f82e',
              id: 34,
              frequency: 4094,
            },
            {
              _id: '5d6615769bcb6d0e6d79f82d',
              id: 35,
              frequency: 3000,
            },
            {
              _id: '5d6615769bcb6d0e6d79f82c',
              id: 36,
              frequency: 1720,
            },
            {
              _id: '5d6615769bcb6d0e6d79f82b',
              id: 37,
              frequency: 7281,
            },
            {
              _id: '5d6615769bcb6d0e6d79f82a',
              id: 38,
              frequency: 6388,
            },
            {
              _id: '5d6615769bcb6d0e6d79f829',
              id: 39,
              frequency: 44700,
            },
            {
              _id: '5d6615769bcb6d0e6d79f828',
              id: 40,
              frequency: 67011,
            },
            {
              _id: '5d6615769bcb6d0e6d79f827',
              id: 41,
              frequency: 12962,
            },
            {
              _id: '5d6615769bcb6d0e6d79f826',
              id: 42,
              frequency: 15358,
            },
            {
              _id: '5d6615769bcb6d0e6d79f825',
              id: 43,
              frequency: 78159,
            },
            {
              _id: '5d6615769bcb6d0e6d79f824',
              id: 44,
              frequency: 5886,
            },
            {
              _id: '5d6615769bcb6d0e6d79f823',
              id: 45,
              frequency: 48746,
            },
            {
              _id: '5d6615769bcb6d0e6d79f822',
              id: 46,
              frequency: 29740,
            },
            {
              _id: '5d6615769bcb6d0e6d79f821',
              id: 47,
              frequency: 131606,
            },
            {
              _id: '5d6615769bcb6d0e6d79f820',
              id: 48,
              frequency: 46602,
            },
            {
              _id: '5d6615769bcb6d0e6d79f81f',
              id: 49,
              frequency: 995,
            },
            {
              _id: '5d6615769bcb6d0e6d79f81e',
              id: 50,
              frequency: 338,
            },
            {
              _id: '5d6615769bcb6d0e6d79f81d',
              id: 51,
              frequency: 32076,
            },
            {
              _id: '5d6615769bcb6d0e6d79f81c',
              id: 52,
              frequency: 9430,
            },
            {
              _id: '5d6615769bcb6d0e6d79f81b',
              id: 53,
              frequency: 13388,
            },
            {
              _id: '5d6615769bcb6d0e6d79f81a',
              id: 54,
              frequency: 40583,
            },
            {
              _id: '5d6615769bcb6d0e6d79f819',
              id: 55,
              frequency: 4086,
            },
            {
              _id: '5d6615769bcb6d0e6d79f818',
              id: 56,
              frequency: 156192,
            },
            {
              _id: '5d6615769bcb6d0e6d79f817',
              id: 57,
              frequency: 92972,
            },
            {
              _id: '5d6615769bcb6d0e6d79f816',
              id: 58,
              frequency: 65738,
            },
            {
              _id: '5d6615769bcb6d0e6d79f815',
              id: 59,
              frequency: 207723,
            },
            {
              _id: '5d6615769bcb6d0e6d79f814',
              id: 60,
              frequency: 138510,
            },
            {
              _id: '5d6615769bcb6d0e6d79f813',
              id: 61,
              frequency: 17918,
            },
            {
              _id: '5d6615769bcb6d0e6d79f812',
              id: 62,
              frequency: 16632,
            },
            {
              _id: '5d6615769bcb6d0e6d79f811',
              id: 63,
              frequency: 15803,
            },
            {
              _id: '5d6615769bcb6d0e6d79f810',
              id: 64,
              frequency: 10160,
            },
            {
              _id: '5d6615769bcb6d0e6d79f80f',
              id: 65,
              frequency: 420917,
            },
            {
              _id: '5d6615769bcb6d0e6d79f80e',
              id: 66,
              frequency: 257020,
            },
            {
              _id: '5d6615769bcb6d0e6d79f80d',
              id: 67,
              frequency: 95320,
            },
            {
              _id: '5d6615769bcb6d0e6d79f80c',
              id: 68,
              frequency: 80850,
            },
            {
              _id: '5d6615769bcb6d0e6d79f80b',
              id: 69,
              frequency: 3286,
            },
            {
              _id: '5d6615769bcb6d0e6d79f80a',
              id: 70,
              frequency: 533755,
            },
            {
              _id: '5d6615769bcb6d0e6d79f809',
              id: 71,
              frequency: 128987,
            },
            {
              _id: '5d6615769bcb6d0e6d79f808',
              id: 72,
              frequency: 292291,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79f763',
          id: 28,
          abbrevName: '29',
          fullName: '29_L_IFG_anterior_mtg_anteriror',
          coordinates: {
            x: -53.974843,
            y: -5.295597,
            z: -29.63522,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79f78e',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d79f78d',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d79f78c',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d79f78b',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d79f78a',
              to: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d79f789',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d79f788',
              to: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d79f787',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79f786',
              to: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d79f785',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79f784',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79f783',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79f782',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79f781',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79f780',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79f77f',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79f77e',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79f77d',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79f77c',
              to: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d79f77b',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79f77a',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79f779',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79f778',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79f777',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79f776',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79f775',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79f774',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79f773',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79f772',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79f771',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79f770',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79f76f',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79f76e',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79f76d',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d79f76c',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79f76b',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79f76a',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79f769',
              to: 93,
            },
            {
              _id: '5d6615769bcb6d0e6d79f768',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79f767',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79f766',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79f765',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79f764',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79f7d7',
              id: 0,
              frequency: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7d6',
              id: 1,
              frequency: 1696,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7d5',
              id: 2,
              frequency: 367,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7d4',
              id: 3,
              frequency: 1344,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7d3',
              id: 4,
              frequency: 9817,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7d2',
              id: 5,
              frequency: 10013,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7d1',
              id: 6,
              frequency: 934,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7d0',
              id: 7,
              frequency: 661,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7cf',
              id: 8,
              frequency: 2465,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7ce',
              id: 9,
              frequency: 26758,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7cd',
              id: 10,
              frequency: 15767,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7cc',
              id: 11,
              frequency: 5842,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7cb',
              id: 12,
              frequency: 33829,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7ca',
              id: 13,
              frequency: 7252,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7c9',
              id: 14,
              frequency: 18754,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7c8',
              id: 15,
              frequency: 5678,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7c7',
              id: 16,
              frequency: 42484,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7c6',
              id: 17,
              frequency: 1214,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7c5',
              id: 18,
              frequency: 3238,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7c4',
              id: 19,
              frequency: 1417,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7c3',
              id: 20,
              frequency: 4585,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7c2',
              id: 21,
              frequency: 16110,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7c1',
              id: 22,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7c0',
              id: 23,
              frequency: 487,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7bf',
              id: 24,
              frequency: 17726,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7be',
              id: 25,
              frequency: 2217,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7bd',
              id: 26,
              frequency: 48594,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7bc',
              id: 27,
              frequency: 56151,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7bb',
              id: 28,
              frequency: 136269,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7ba',
              id: 29,
              frequency: 52998,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7b9',
              id: 30,
              frequency: 15329,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7b8',
              id: 31,
              frequency: 4248,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7b7',
              id: 32,
              frequency: 4758,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7b6',
              id: 33,
              frequency: 7652,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7b5',
              id: 34,
              frequency: 7580,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7b4',
              id: 35,
              frequency: 2276,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7b3',
              id: 36,
              frequency: 4549,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7b2',
              id: 37,
              frequency: 2353,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7b1',
              id: 38,
              frequency: 7626,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7b0',
              id: 39,
              frequency: 23303,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7af',
              id: 40,
              frequency: 18874,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7ae',
              id: 41,
              frequency: 17429,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7ad',
              id: 42,
              frequency: 15770,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7ac',
              id: 43,
              frequency: 110807,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7ab',
              id: 44,
              frequency: 4322,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7aa',
              id: 45,
              frequency: 111580,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7a9',
              id: 46,
              frequency: 53052,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7a8',
              id: 47,
              frequency: 125595,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7a7',
              id: 48,
              frequency: 41410,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7a6',
              id: 49,
              frequency: 487,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7a5',
              id: 50,
              frequency: 253,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7a4',
              id: 51,
              frequency: 42162,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7a3',
              id: 52,
              frequency: 12646,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7a2',
              id: 53,
              frequency: 16420,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7a1',
              id: 54,
              frequency: 11314,
            },
            {
              _id: '5d6615769bcb6d0e6d79f7a0',
              id: 55,
              frequency: 3994,
            },
            {
              _id: '5d6615769bcb6d0e6d79f79f',
              id: 56,
              frequency: 277645,
            },
            {
              _id: '5d6615769bcb6d0e6d79f79e',
              id: 57,
              frequency: 85912,
            },
            {
              _id: '5d6615769bcb6d0e6d79f79d',
              id: 58,
              frequency: 51707,
            },
            {
              _id: '5d6615769bcb6d0e6d79f79c',
              id: 59,
              frequency: 276088,
            },
            {
              _id: '5d6615769bcb6d0e6d79f79b',
              id: 60,
              frequency: 134997,
            },
            {
              _id: '5d6615769bcb6d0e6d79f79a',
              id: 61,
              frequency: 15701,
            },
            {
              _id: '5d6615769bcb6d0e6d79f799',
              id: 62,
              frequency: 22761,
            },
            {
              _id: '5d6615769bcb6d0e6d79f798',
              id: 63,
              frequency: 15503,
            },
            {
              _id: '5d6615769bcb6d0e6d79f797',
              id: 64,
              frequency: 8962,
            },
            {
              _id: '5d6615769bcb6d0e6d79f796',
              id: 65,
              frequency: 470558,
            },
            {
              _id: '5d6615769bcb6d0e6d79f795',
              id: 66,
              frequency: 216346,
            },
            {
              _id: '5d6615769bcb6d0e6d79f794',
              id: 67,
              frequency: 76497,
            },
            {
              _id: '5d6615769bcb6d0e6d79f793',
              id: 68,
              frequency: 75732,
            },
            {
              _id: '5d6615769bcb6d0e6d79f792',
              id: 69,
              frequency: 2456,
            },
            {
              _id: '5d6615769bcb6d0e6d79f791',
              id: 70,
              frequency: 428116,
            },
            {
              _id: '5d6615769bcb6d0e6d79f790',
              id: 71,
              frequency: 92070,
            },
            {
              _id: '5d6615769bcb6d0e6d79f78f',
              id: 72,
              frequency: 184470,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79f6db',
          id: 29,
          abbrevName: '30',
          fullName: '30_R_Caudate',
          coordinates: {
            x: 13.531532,
            y: 12.45045,
            z: 4.900901,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79f719',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d79f718',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d79f717',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d79f716',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d79f715',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d79f714',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d79f713',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d79f712',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d79f711',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79f710',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79f70f',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79f70e',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d79f70d',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79f70c',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79f70b',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79f70a',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79f709',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79f708',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79f707',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79f706',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79f705',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79f704',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79f703',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79f702',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79f701',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79f700',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6ff',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6fe',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6fd',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6fc',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6fb',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6fa',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6f9',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6f8',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6f7',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6f6',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6f5',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6f4',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6f3',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6f2',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6f1',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6f0',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6ef',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6ee',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6ed',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6ec',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6eb',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6ea',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6e9',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6e8',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6e7',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6e6',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6e5',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6e4',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6e3',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6e2',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6e1',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6e0',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6df',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6de',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6dd',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6dc',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79f762',
              id: 0,
              frequency: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d79f761',
              id: 1,
              frequency: 408,
            },
            {
              _id: '5d6615769bcb6d0e6d79f760',
              id: 2,
              frequency: 503,
            },
            {
              _id: '5d6615769bcb6d0e6d79f75f',
              id: 3,
              frequency: 3325,
            },
            {
              _id: '5d6615769bcb6d0e6d79f75e',
              id: 4,
              frequency: 554,
            },
            {
              _id: '5d6615769bcb6d0e6d79f75d',
              id: 5,
              frequency: 2943,
            },
            {
              _id: '5d6615769bcb6d0e6d79f75c',
              id: 6,
              frequency: 284,
            },
            {
              _id: '5d6615769bcb6d0e6d79f75b',
              id: 7,
              frequency: 339,
            },
            {
              _id: '5d6615769bcb6d0e6d79f75a',
              id: 8,
              frequency: 763,
            },
            {
              _id: '5d6615769bcb6d0e6d79f759',
              id: 9,
              frequency: 579,
            },
            {
              _id: '5d6615769bcb6d0e6d79f758',
              id: 10,
              frequency: 11045,
            },
            {
              _id: '5d6615769bcb6d0e6d79f757',
              id: 11,
              frequency: 8257,
            },
            {
              _id: '5d6615769bcb6d0e6d79f756',
              id: 12,
              frequency: 9991,
            },
            {
              _id: '5d6615769bcb6d0e6d79f755',
              id: 13,
              frequency: 25727,
            },
            {
              _id: '5d6615769bcb6d0e6d79f754',
              id: 14,
              frequency: 75413,
            },
            {
              _id: '5d6615769bcb6d0e6d79f753',
              id: 15,
              frequency: 397,
            },
            {
              _id: '5d6615769bcb6d0e6d79f752',
              id: 16,
              frequency: 2330,
            },
            {
              _id: '5d6615769bcb6d0e6d79f751',
              id: 17,
              frequency: 3566,
            },
            {
              _id: '5d6615769bcb6d0e6d79f750',
              id: 18,
              frequency: 169,
            },
            {
              _id: '5d6615769bcb6d0e6d79f74f',
              id: 19,
              frequency: 570,
            },
            {
              _id: '5d6615769bcb6d0e6d79f74e',
              id: 20,
              frequency: 1480,
            },
            {
              _id: '5d6615769bcb6d0e6d79f74d',
              id: 21,
              frequency: 1849,
            },
            {
              _id: '5d6615769bcb6d0e6d79f74c',
              id: 22,
              frequency: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79f74b',
              id: 23,
              frequency: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79f74a',
              id: 24,
              frequency: 823,
            },
            {
              _id: '5d6615769bcb6d0e6d79f749',
              id: 25,
              frequency: 7987,
            },
            {
              _id: '5d6615769bcb6d0e6d79f748',
              id: 26,
              frequency: 15355,
            },
            {
              _id: '5d6615769bcb6d0e6d79f747',
              id: 27,
              frequency: 234,
            },
            {
              _id: '5d6615769bcb6d0e6d79f746',
              id: 28,
              frequency: 2681,
            },
            {
              _id: '5d6615769bcb6d0e6d79f745',
              id: 29,
              frequency: 10502,
            },
            {
              _id: '5d6615769bcb6d0e6d79f744',
              id: 30,
              frequency: 21968,
            },
            {
              _id: '5d6615769bcb6d0e6d79f743',
              id: 31,
              frequency: 409,
            },
            {
              _id: '5d6615769bcb6d0e6d79f742',
              id: 32,
              frequency: 4769,
            },
            {
              _id: '5d6615769bcb6d0e6d79f741',
              id: 33,
              frequency: 2099,
            },
            {
              _id: '5d6615769bcb6d0e6d79f740',
              id: 34,
              frequency: 490,
            },
            {
              _id: '5d6615769bcb6d0e6d79f73f',
              id: 35,
              frequency: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d79f73e',
              id: 36,
              frequency: 487,
            },
            {
              _id: '5d6615769bcb6d0e6d79f73d',
              id: 37,
              frequency: 1638,
            },
            {
              _id: '5d6615769bcb6d0e6d79f73c',
              id: 38,
              frequency: 1009,
            },
            {
              _id: '5d6615769bcb6d0e6d79f73b',
              id: 39,
              frequency: 245,
            },
            {
              _id: '5d6615769bcb6d0e6d79f73a',
              id: 40,
              frequency: 13685,
            },
            {
              _id: '5d6615769bcb6d0e6d79f739',
              id: 41,
              frequency: 19403,
            },
            {
              _id: '5d6615769bcb6d0e6d79f738',
              id: 42,
              frequency: 14306,
            },
            {
              _id: '5d6615769bcb6d0e6d79f737',
              id: 43,
              frequency: 7748,
            },
            {
              _id: '5d6615769bcb6d0e6d79f736',
              id: 44,
              frequency: 10216,
            },
            {
              _id: '5d6615769bcb6d0e6d79f735',
              id: 45,
              frequency: 238,
            },
            {
              _id: '5d6615769bcb6d0e6d79f734',
              id: 46,
              frequency: 8254,
            },
            {
              _id: '5d6615769bcb6d0e6d79f733',
              id: 47,
              frequency: 17738,
            },
            {
              _id: '5d6615769bcb6d0e6d79f732',
              id: 48,
              frequency: 75428,
            },
            {
              _id: '5d6615769bcb6d0e6d79f731',
              id: 49,
              frequency: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79f730',
              id: 50,
              frequency: 166,
            },
            {
              _id: '5d6615769bcb6d0e6d79f72f',
              id: 51,
              frequency: 2163,
            },
            {
              _id: '5d6615769bcb6d0e6d79f72e',
              id: 52,
              frequency: 965,
            },
            {
              _id: '5d6615769bcb6d0e6d79f72d',
              id: 53,
              frequency: 7759,
            },
            {
              _id: '5d6615769bcb6d0e6d79f72c',
              id: 54,
              frequency: 1529,
            },
            {
              _id: '5d6615769bcb6d0e6d79f72b',
              id: 55,
              frequency: 10099,
            },
            {
              _id: '5d6615769bcb6d0e6d79f72a',
              id: 56,
              frequency: 370,
            },
            {
              _id: '5d6615769bcb6d0e6d79f729',
              id: 57,
              frequency: 205244,
            },
            {
              _id: '5d6615769bcb6d0e6d79f728',
              id: 58,
              frequency: 59583,
            },
            {
              _id: '5d6615769bcb6d0e6d79f727',
              id: 59,
              frequency: 12811,
            },
            {
              _id: '5d6615769bcb6d0e6d79f726',
              id: 60,
              frequency: 69428,
            },
            {
              _id: '5d6615769bcb6d0e6d79f725',
              id: 61,
              frequency: 57626,
            },
            {
              _id: '5d6615769bcb6d0e6d79f724',
              id: 62,
              frequency: 492,
            },
            {
              _id: '5d6615769bcb6d0e6d79f723',
              id: 63,
              frequency: 7145,
            },
            {
              _id: '5d6615769bcb6d0e6d79f722',
              id: 64,
              frequency: 7383,
            },
            {
              _id: '5d6615769bcb6d0e6d79f721',
              id: 65,
              frequency: 11993,
            },
            {
              _id: '5d6615769bcb6d0e6d79f720',
              id: 66,
              frequency: 158920,
            },
            {
              _id: '5d6615769bcb6d0e6d79f71f',
              id: 67,
              frequency: 334170,
            },
            {
              _id: '5d6615769bcb6d0e6d79f71e',
              id: 68,
              frequency: 34679,
            },
            {
              _id: '5d6615769bcb6d0e6d79f71d',
              id: 69,
              frequency: 20258,
            },
            {
              _id: '5d6615769bcb6d0e6d79f71c',
              id: 70,
              frequency: 178879,
            },
            {
              _id: '5d6615769bcb6d0e6d79f71b',
              id: 71,
              frequency: 638784,
            },
            {
              _id: '5d6615769bcb6d0e6d79f71a',
              id: 72,
              frequency: 1184696,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79f656',
          id: 30,
          abbrevName: '31',
          fullName: '31_R_Cerebellum_posterior',
          coordinates: {
            x: 17.234783,
            y: -79.686957,
            z: -36.295652,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79f691',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d79f690',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d79f68f',
              to: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d79f68e',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d79f68d',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d79f68c',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d79f68b',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79f68a',
              to: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d79f689',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79f688',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79f687',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d79f686',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79f685',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79f684',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79f683',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79f682',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79f681',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79f680',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79f67f',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79f67e',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79f67d',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79f67c',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79f67b',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79f67a',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79f679',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79f678',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79f677',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79f676',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79f675',
              to: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d79f674',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79f673',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79f672',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79f671',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79f670',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79f66f',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79f66e',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79f66d',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79f66c',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79f66b',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79f66a',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79f669',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79f668',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79f667',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79f666',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79f665',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79f664',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79f663',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79f662',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79f661',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79f660',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d79f65f',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79f65e',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79f65d',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79f65c',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79f65b',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79f65a',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79f659',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79f658',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79f657',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79f6da',
              id: 0,
              frequency: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6d9',
              id: 1,
              frequency: 708,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6d8',
              id: 2,
              frequency: 652,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6d7',
              id: 3,
              frequency: 3003,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6d6',
              id: 4,
              frequency: 661,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6d5',
              id: 5,
              frequency: 5319,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6d4',
              id: 6,
              frequency: 576,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6d3',
              id: 7,
              frequency: 1015,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6d2',
              id: 8,
              frequency: 1467,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6d1',
              id: 9,
              frequency: 2402,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6d0',
              id: 10,
              frequency: 11205,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6cf',
              id: 11,
              frequency: 13861,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6ce',
              id: 12,
              frequency: 20361,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6cd',
              id: 13,
              frequency: 24001,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6cc',
              id: 14,
              frequency: 63463,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6cb',
              id: 15,
              frequency: 385,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6ca',
              id: 16,
              frequency: 2818,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6c9',
              id: 17,
              frequency: 4364,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6c8',
              id: 18,
              frequency: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6c7',
              id: 19,
              frequency: 750,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6c6',
              id: 20,
              frequency: 2395,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6c5',
              id: 21,
              frequency: 7267,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6c4',
              id: 22,
              frequency: 143,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6c3',
              id: 23,
              frequency: 344,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6c2',
              id: 24,
              frequency: 1021,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6c1',
              id: 25,
              frequency: 5481,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6c0',
              id: 26,
              frequency: 31055,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6bf',
              id: 27,
              frequency: 730,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6be',
              id: 28,
              frequency: 14514,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6bd',
              id: 29,
              frequency: 6430,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6bc',
              id: 30,
              frequency: 21796,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6bb',
              id: 31,
              frequency: 1386,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6ba',
              id: 32,
              frequency: 3338,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6b9',
              id: 33,
              frequency: 12118,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6b8',
              id: 34,
              frequency: 842,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6b7',
              id: 35,
              frequency: 125,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6b6',
              id: 36,
              frequency: 304,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6b5',
              id: 37,
              frequency: 3059,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6b4',
              id: 38,
              frequency: 3924,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6b3',
              id: 39,
              frequency: 1285,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6b2',
              id: 40,
              frequency: 20792,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6b1',
              id: 41,
              frequency: 16697,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6b0',
              id: 42,
              frequency: 45239,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6af',
              id: 43,
              frequency: 19495,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6ae',
              id: 44,
              frequency: 17163,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6ad',
              id: 45,
              frequency: 1061,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6ac',
              id: 46,
              frequency: 4173,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6ab',
              id: 47,
              frequency: 75486,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6aa',
              id: 48,
              frequency: 51763,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6a9',
              id: 49,
              frequency: 346,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6a8',
              id: 50,
              frequency: 312,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6a7',
              id: 51,
              frequency: 4943,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6a6',
              id: 52,
              frequency: 1397,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6a5',
              id: 53,
              frequency: 17028,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6a4',
              id: 54,
              frequency: 9342,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6a3',
              id: 55,
              frequency: 13394,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6a2',
              id: 56,
              frequency: 4957,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6a1',
              id: 57,
              frequency: 106319,
            },
            {
              _id: '5d6615769bcb6d0e6d79f6a0',
              id: 58,
              frequency: 159491,
            },
            {
              _id: '5d6615769bcb6d0e6d79f69f',
              id: 59,
              frequency: 28562,
            },
            {
              _id: '5d6615769bcb6d0e6d79f69e',
              id: 60,
              frequency: 130004,
            },
            {
              _id: '5d6615769bcb6d0e6d79f69d',
              id: 61,
              frequency: 74171,
            },
            {
              _id: '5d6615769bcb6d0e6d79f69c',
              id: 62,
              frequency: 3100,
            },
            {
              _id: '5d6615769bcb6d0e6d79f69b',
              id: 63,
              frequency: 12506,
            },
            {
              _id: '5d6615769bcb6d0e6d79f69a',
              id: 64,
              frequency: 9784,
            },
            {
              _id: '5d6615769bcb6d0e6d79f699',
              id: 65,
              frequency: 65228,
            },
            {
              _id: '5d6615769bcb6d0e6d79f698',
              id: 66,
              frequency: 222885,
            },
            {
              _id: '5d6615769bcb6d0e6d79f697',
              id: 67,
              frequency: 340282,
            },
            {
              _id: '5d6615769bcb6d0e6d79f696',
              id: 68,
              frequency: 66544,
            },
            {
              _id: '5d6615769bcb6d0e6d79f695',
              id: 69,
              frequency: 16316,
            },
            {
              _id: '5d6615769bcb6d0e6d79f694',
              id: 70,
              frequency: 378785,
            },
            {
              _id: '5d6615769bcb6d0e6d79f693',
              id: 71,
              frequency: 506246,
            },
            {
              _id: '5d6615769bcb6d0e6d79f692',
              id: 72,
              frequency: 938791,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79f5db',
          id: 31,
          abbrevName: '32',
          fullName: '32_R_LOC_superior',
          coordinates: {
            x: 40.051282,
            y: -69.641026,
            z: 35.521368,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79f60c',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d79f60b',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d79f60a',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d79f609',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d79f608',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79f607',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79f606',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d79f605',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79f604',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79f603',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79f602',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79f601',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79f600',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5ff',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5fe',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5fd',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5fc',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5fb',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5fa',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5f9',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5f8',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5f7',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5f6',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5f5',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5f4',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5f3',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5f2',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5f1',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5f0',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5ef',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5ee',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5ed',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5ec',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5eb',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5ea',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5e9',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5e8',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5e7',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5e6',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5e5',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5e4',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5e3',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5e2',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5e1',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5e0',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5df',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5de',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5dd',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5dc',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79f655',
              id: 0,
              frequency: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79f654',
              id: 1,
              frequency: 1209,
            },
            {
              _id: '5d6615769bcb6d0e6d79f653',
              id: 2,
              frequency: 242,
            },
            {
              _id: '5d6615769bcb6d0e6d79f652',
              id: 3,
              frequency: 2386,
            },
            {
              _id: '5d6615769bcb6d0e6d79f651',
              id: 4,
              frequency: 3525,
            },
            {
              _id: '5d6615769bcb6d0e6d79f650',
              id: 5,
              frequency: 3375,
            },
            {
              _id: '5d6615769bcb6d0e6d79f64f',
              id: 6,
              frequency: 2460,
            },
            {
              _id: '5d6615769bcb6d0e6d79f64e',
              id: 7,
              frequency: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79f64d',
              id: 8,
              frequency: 1906,
            },
            {
              _id: '5d6615769bcb6d0e6d79f64c',
              id: 9,
              frequency: 7430,
            },
            {
              _id: '5d6615769bcb6d0e6d79f64b',
              id: 10,
              frequency: 17671,
            },
            {
              _id: '5d6615769bcb6d0e6d79f64a',
              id: 11,
              frequency: 2617,
            },
            {
              _id: '5d6615769bcb6d0e6d79f649',
              id: 12,
              frequency: 31095,
            },
            {
              _id: '5d6615769bcb6d0e6d79f648',
              id: 13,
              frequency: 11705,
            },
            {
              _id: '5d6615769bcb6d0e6d79f647',
              id: 14,
              frequency: 47793,
            },
            {
              _id: '5d6615769bcb6d0e6d79f646',
              id: 15,
              frequency: 6325,
            },
            {
              _id: '5d6615769bcb6d0e6d79f645',
              id: 16,
              frequency: 4001,
            },
            {
              _id: '5d6615769bcb6d0e6d79f644',
              id: 17,
              frequency: 7837,
            },
            {
              _id: '5d6615769bcb6d0e6d79f643',
              id: 18,
              frequency: 2028,
            },
            {
              _id: '5d6615769bcb6d0e6d79f642',
              id: 19,
              frequency: 9594,
            },
            {
              _id: '5d6615769bcb6d0e6d79f641',
              id: 20,
              frequency: 2973,
            },
            {
              _id: '5d6615769bcb6d0e6d79f640',
              id: 21,
              frequency: 732,
            },
            {
              _id: '5d6615769bcb6d0e6d79f63f',
              id: 22,
              frequency: 1200,
            },
            {
              _id: '5d6615769bcb6d0e6d79f63e',
              id: 23,
              frequency: 5,
            },
            {
              _id: '5d6615769bcb6d0e6d79f63d',
              id: 24,
              frequency: 16812,
            },
            {
              _id: '5d6615769bcb6d0e6d79f63c',
              id: 25,
              frequency: 22612,
            },
            {
              _id: '5d6615769bcb6d0e6d79f63b',
              id: 26,
              frequency: 7555,
            },
            {
              _id: '5d6615769bcb6d0e6d79f63a',
              id: 27,
              frequency: 5784,
            },
            {
              _id: '5d6615769bcb6d0e6d79f639',
              id: 28,
              frequency: 10374,
            },
            {
              _id: '5d6615769bcb6d0e6d79f638',
              id: 29,
              frequency: 28856,
            },
            {
              _id: '5d6615769bcb6d0e6d79f637',
              id: 30,
              frequency: 11899,
            },
            {
              _id: '5d6615769bcb6d0e6d79f636',
              id: 31,
              frequency: 11304,
            },
            {
              _id: '5d6615769bcb6d0e6d79f635',
              id: 32,
              frequency: 11864,
            },
            {
              _id: '5d6615769bcb6d0e6d79f634',
              id: 33,
              frequency: 316,
            },
            {
              _id: '5d6615769bcb6d0e6d79f633',
              id: 34,
              frequency: 2432,
            },
            {
              _id: '5d6615769bcb6d0e6d79f632',
              id: 35,
              frequency: 1711,
            },
            {
              _id: '5d6615769bcb6d0e6d79f631',
              id: 36,
              frequency: 1903,
            },
            {
              _id: '5d6615769bcb6d0e6d79f630',
              id: 37,
              frequency: 8938,
            },
            {
              _id: '5d6615769bcb6d0e6d79f62f',
              id: 38,
              frequency: 921,
            },
            {
              _id: '5d6615769bcb6d0e6d79f62e',
              id: 39,
              frequency: 14035,
            },
            {
              _id: '5d6615769bcb6d0e6d79f62d',
              id: 40,
              frequency: 84057,
            },
            {
              _id: '5d6615769bcb6d0e6d79f62c',
              id: 41,
              frequency: 13268,
            },
            {
              _id: '5d6615769bcb6d0e6d79f62b',
              id: 42,
              frequency: 2506,
            },
            {
              _id: '5d6615769bcb6d0e6d79f62a',
              id: 43,
              frequency: 38879,
            },
            {
              _id: '5d6615769bcb6d0e6d79f629',
              id: 44,
              frequency: 1687,
            },
            {
              _id: '5d6615769bcb6d0e6d79f628',
              id: 45,
              frequency: 10434,
            },
            {
              _id: '5d6615769bcb6d0e6d79f627',
              id: 46,
              frequency: 36722,
            },
            {
              _id: '5d6615769bcb6d0e6d79f626',
              id: 47,
              frequency: 17079,
            },
            {
              _id: '5d6615769bcb6d0e6d79f625',
              id: 48,
              frequency: 55092,
            },
            {
              _id: '5d6615769bcb6d0e6d79f624',
              id: 49,
              frequency: 1041,
            },
            {
              _id: '5d6615769bcb6d0e6d79f623',
              id: 50,
              frequency: 268,
            },
            {
              _id: '5d6615769bcb6d0e6d79f622',
              id: 51,
              frequency: 15159,
            },
            {
              _id: '5d6615769bcb6d0e6d79f621',
              id: 52,
              frequency: 6474,
            },
            {
              _id: '5d6615769bcb6d0e6d79f620',
              id: 53,
              frequency: 10618,
            },
            {
              _id: '5d6615769bcb6d0e6d79f61f',
              id: 54,
              frequency: 33603,
            },
            {
              _id: '5d6615769bcb6d0e6d79f61e',
              id: 55,
              frequency: 2512,
            },
            {
              _id: '5d6615769bcb6d0e6d79f61d',
              id: 56,
              frequency: 26123,
            },
            {
              _id: '5d6615769bcb6d0e6d79f61c',
              id: 57,
              frequency: 204145,
            },
            {
              _id: '5d6615769bcb6d0e6d79f61b',
              id: 58,
              frequency: 12468,
            },
            {
              _id: '5d6615769bcb6d0e6d79f61a',
              id: 59,
              frequency: 110722,
            },
            {
              _id: '5d6615769bcb6d0e6d79f619',
              id: 60,
              frequency: 105098,
            },
            {
              _id: '5d6615769bcb6d0e6d79f618',
              id: 61,
              frequency: 13259,
            },
            {
              _id: '5d6615769bcb6d0e6d79f617',
              id: 62,
              frequency: 6879,
            },
            {
              _id: '5d6615769bcb6d0e6d79f616',
              id: 63,
              frequency: 14173,
            },
            {
              _id: '5d6615769bcb6d0e6d79f615',
              id: 64,
              frequency: 11667,
            },
            {
              _id: '5d6615769bcb6d0e6d79f614',
              id: 65,
              frequency: 173034,
            },
            {
              _id: '5d6615769bcb6d0e6d79f613',
              id: 66,
              frequency: 309059,
            },
            {
              _id: '5d6615769bcb6d0e6d79f612',
              id: 67,
              frequency: 106876,
            },
            {
              _id: '5d6615769bcb6d0e6d79f611',
              id: 68,
              frequency: 82970,
            },
            {
              _id: '5d6615769bcb6d0e6d79f610',
              id: 69,
              frequency: 6515,
            },
            {
              _id: '5d6615769bcb6d0e6d79f60f',
              id: 70,
              frequency: 532132,
            },
            {
              _id: '5d6615769bcb6d0e6d79f60e',
              id: 71,
              frequency: 271489,
            },
            {
              _id: '5d6615769bcb6d0e6d79f60d',
              id: 72,
              frequency: 670797,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79f556',
          id: 32,
          abbrevName: '33',
          fullName: '33_R_Angular_gyrus_loc_superior',
          coordinates: {
            x: 54.052863,
            y: -53.418502,
            z: 17.23348,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79f591',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d79f590',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d79f58f',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d79f58e',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d79f58d',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79f58c',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79f58b',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79f58a',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d79f589',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79f588',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79f587',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79f586',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79f585',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79f584',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79f583',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79f582',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79f581',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79f580',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79f57f',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79f57e',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79f57d',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79f57c',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79f57b',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79f57a',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79f579',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79f578',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79f577',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79f576',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79f575',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79f574',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79f573',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79f572',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79f571',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79f570',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79f56f',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79f56e',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79f56d',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79f56c',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79f56b',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79f56a',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79f569',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79f568',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79f567',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79f566',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79f565',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79f564',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79f563',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79f562',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79f561',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d79f560',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79f55f',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79f55e',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79f55d',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79f55c',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79f55b',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79f55a',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79f559',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79f558',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79f557',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79f5da',
              id: 0,
              frequency: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5d9',
              id: 1,
              frequency: 433,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5d8',
              id: 2,
              frequency: 526,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5d7',
              id: 3,
              frequency: 3302,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5d6',
              id: 4,
              frequency: 467,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5d5',
              id: 5,
              frequency: 3364,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5d4',
              id: 6,
              frequency: 423,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5d3',
              id: 7,
              frequency: 457,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5d2',
              id: 8,
              frequency: 687,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5d1',
              id: 9,
              frequency: 569,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5d0',
              id: 10,
              frequency: 11955,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5cf',
              id: 11,
              frequency: 9537,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5ce',
              id: 12,
              frequency: 10489,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5cd',
              id: 13,
              frequency: 24791,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5cc',
              id: 14,
              frequency: 74951,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5cb',
              id: 15,
              frequency: 367,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5ca',
              id: 16,
              frequency: 2164,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5c9',
              id: 17,
              frequency: 4298,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5c8',
              id: 18,
              frequency: 193,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5c7',
              id: 19,
              frequency: 675,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5c6',
              id: 20,
              frequency: 2072,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5c5',
              id: 21,
              frequency: 2619,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5c4',
              id: 22,
              frequency: 135,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5c3',
              id: 23,
              frequency: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5c2',
              id: 24,
              frequency: 745,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5c1',
              id: 25,
              frequency: 8874,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5c0',
              id: 26,
              frequency: 17450,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5bf',
              id: 27,
              frequency: 180,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5be',
              id: 28,
              frequency: 3219,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5bd',
              id: 29,
              frequency: 10770,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5bc',
              id: 30,
              frequency: 25030,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5bb',
              id: 31,
              frequency: 562,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5ba',
              id: 32,
              frequency: 5758,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5b9',
              id: 33,
              frequency: 3515,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5b8',
              id: 34,
              frequency: 493,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5b7',
              id: 35,
              frequency: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5b6',
              id: 36,
              frequency: 425,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5b5',
              id: 37,
              frequency: 2094,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5b4',
              id: 38,
              frequency: 1404,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5b3',
              id: 39,
              frequency: 350,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5b2',
              id: 40,
              frequency: 18033,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5b1',
              id: 41,
              frequency: 18644,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5b0',
              id: 42,
              frequency: 21926,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5af',
              id: 43,
              frequency: 8701,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5ae',
              id: 44,
              frequency: 10870,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5ad',
              id: 45,
              frequency: 159,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5ac',
              id: 46,
              frequency: 6020,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5ab',
              id: 47,
              frequency: 24344,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5aa',
              id: 48,
              frequency: 69874,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5a9',
              id: 49,
              frequency: 129,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5a8',
              id: 50,
              frequency: 126,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5a7',
              id: 51,
              frequency: 1504,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5a6',
              id: 52,
              frequency: 1141,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5a5',
              id: 53,
              frequency: 11177,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5a4',
              id: 54,
              frequency: 4293,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5a3',
              id: 55,
              frequency: 9645,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5a2',
              id: 56,
              frequency: 315,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5a1',
              id: 57,
              frequency: 198233,
            },
            {
              _id: '5d6615769bcb6d0e6d79f5a0',
              id: 58,
              frequency: 92444,
            },
            {
              _id: '5d6615769bcb6d0e6d79f59f',
              id: 59,
              frequency: 10033,
            },
            {
              _id: '5d6615769bcb6d0e6d79f59e',
              id: 60,
              frequency: 84009,
            },
            {
              _id: '5d6615769bcb6d0e6d79f59d',
              id: 61,
              frequency: 57742,
            },
            {
              _id: '5d6615769bcb6d0e6d79f59c',
              id: 62,
              frequency: 435,
            },
            {
              _id: '5d6615769bcb6d0e6d79f59b',
              id: 63,
              frequency: 5660,
            },
            {
              _id: '5d6615769bcb6d0e6d79f59a',
              id: 64,
              frequency: 8876,
            },
            {
              _id: '5d6615769bcb6d0e6d79f599',
              id: 65,
              frequency: 12588,
            },
            {
              _id: '5d6615769bcb6d0e6d79f598',
              id: 66,
              frequency: 197057,
            },
            {
              _id: '5d6615769bcb6d0e6d79f597',
              id: 67,
              frequency: 323467,
            },
            {
              _id: '5d6615769bcb6d0e6d79f596',
              id: 68,
              frequency: 25927,
            },
            {
              _id: '5d6615769bcb6d0e6d79f595',
              id: 69,
              frequency: 18546,
            },
            {
              _id: '5d6615769bcb6d0e6d79f594',
              id: 70,
              frequency: 179710,
            },
            {
              _id: '5d6615769bcb6d0e6d79f593',
              id: 71,
              frequency: 609886,
            },
            {
              _id: '5d6615769bcb6d0e6d79f592',
              id: 72,
              frequency: 1183788,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79f4df',
          id: 33,
          abbrevName: '34',
          fullName: '34_R_Precentral_gyrus_postcentral_gyrus_BA6',
          coordinates: {
            x: 59.232227,
            y: -3.175355,
            z: 21.137441,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79f50c',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d79f50b',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d79f50a',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d79f509',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d79f508',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79f507',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79f506',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79f505',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d79f504',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79f503',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79f502',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79f501',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79f500',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4ff',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4fe',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4fd',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4fc',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4fb',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4fa',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4f9',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4f8',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4f7',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4f6',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4f5',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4f4',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4f3',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4f2',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4f1',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4f0',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4ef',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4ee',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4ed',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4ec',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4eb',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4ea',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4e9',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4e8',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4e7',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4e6',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4e5',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4e4',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4e3',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4e2',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4e1',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4e0',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79f555',
              id: 0,
              frequency: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79f554',
              id: 1,
              frequency: 1289,
            },
            {
              _id: '5d6615769bcb6d0e6d79f553',
              id: 2,
              frequency: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79f552',
              id: 3,
              frequency: 2180,
            },
            {
              _id: '5d6615769bcb6d0e6d79f551',
              id: 4,
              frequency: 7119,
            },
            {
              _id: '5d6615769bcb6d0e6d79f550',
              id: 5,
              frequency: 1538,
            },
            {
              _id: '5d6615769bcb6d0e6d79f54f',
              id: 6,
              frequency: 2355,
            },
            {
              _id: '5d6615769bcb6d0e6d79f54e',
              id: 7,
              frequency: 14,
            },
            {
              _id: '5d6615769bcb6d0e6d79f54d',
              id: 8,
              frequency: 981,
            },
            {
              _id: '5d6615769bcb6d0e6d79f54c',
              id: 9,
              frequency: 10271,
            },
            {
              _id: '5d6615769bcb6d0e6d79f54b',
              id: 10,
              frequency: 21021,
            },
            {
              _id: '5d6615769bcb6d0e6d79f54a',
              id: 11,
              frequency: 620,
            },
            {
              _id: '5d6615769bcb6d0e6d79f549',
              id: 12,
              frequency: 30921,
            },
            {
              _id: '5d6615769bcb6d0e6d79f548',
              id: 13,
              frequency: 5186,
            },
            {
              _id: '5d6615769bcb6d0e6d79f547',
              id: 14,
              frequency: 44296,
            },
            {
              _id: '5d6615769bcb6d0e6d79f546',
              id: 15,
              frequency: 13636,
            },
            {
              _id: '5d6615769bcb6d0e6d79f545',
              id: 16,
              frequency: 3484,
            },
            {
              _id: '5d6615769bcb6d0e6d79f544',
              id: 17,
              frequency: 2454,
            },
            {
              _id: '5d6615769bcb6d0e6d79f543',
              id: 18,
              frequency: 7324,
            },
            {
              _id: '5d6615769bcb6d0e6d79f542',
              id: 19,
              frequency: 12187,
            },
            {
              _id: '5d6615769bcb6d0e6d79f541',
              id: 20,
              frequency: 1341,
            },
            {
              _id: '5d6615769bcb6d0e6d79f540',
              id: 21,
              frequency: 177,
            },
            {
              _id: '5d6615769bcb6d0e6d79f53f',
              id: 22,
              frequency: 867,
            },
            {
              _id: '5d6615769bcb6d0e6d79f53e',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79f53d',
              id: 24,
              frequency: 34332,
            },
            {
              _id: '5d6615769bcb6d0e6d79f53c',
              id: 25,
              frequency: 16454,
            },
            {
              _id: '5d6615769bcb6d0e6d79f53b',
              id: 26,
              frequency: 2109,
            },
            {
              _id: '5d6615769bcb6d0e6d79f53a',
              id: 27,
              frequency: 19780,
            },
            {
              _id: '5d6615769bcb6d0e6d79f539',
              id: 28,
              frequency: 7125,
            },
            {
              _id: '5d6615769bcb6d0e6d79f538',
              id: 29,
              frequency: 73171,
            },
            {
              _id: '5d6615769bcb6d0e6d79f537',
              id: 30,
              frequency: 2998,
            },
            {
              _id: '5d6615769bcb6d0e6d79f536',
              id: 31,
              frequency: 12617,
            },
            {
              _id: '5d6615769bcb6d0e6d79f535',
              id: 32,
              frequency: 15935,
            },
            {
              _id: '5d6615769bcb6d0e6d79f534',
              id: 33,
              frequency: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d79f533',
              id: 34,
              frequency: 1348,
            },
            {
              _id: '5d6615769bcb6d0e6d79f532',
              id: 35,
              frequency: 3082,
            },
            {
              _id: '5d6615769bcb6d0e6d79f531',
              id: 36,
              frequency: 2020,
            },
            {
              _id: '5d6615769bcb6d0e6d79f530',
              id: 37,
              frequency: 3448,
            },
            {
              _id: '5d6615769bcb6d0e6d79f52f',
              id: 38,
              frequency: 187,
            },
            {
              _id: '5d6615769bcb6d0e6d79f52e',
              id: 39,
              frequency: 19397,
            },
            {
              _id: '5d6615769bcb6d0e6d79f52d',
              id: 40,
              frequency: 72053,
            },
            {
              _id: '5d6615769bcb6d0e6d79f52c',
              id: 41,
              frequency: 5883,
            },
            {
              _id: '5d6615769bcb6d0e6d79f52b',
              id: 42,
              frequency: 296,
            },
            {
              _id: '5d6615769bcb6d0e6d79f52a',
              id: 43,
              frequency: 69300,
            },
            {
              _id: '5d6615769bcb6d0e6d79f529',
              id: 44,
              frequency: 221,
            },
            {
              _id: '5d6615769bcb6d0e6d79f528',
              id: 45,
              frequency: 34041,
            },
            {
              _id: '5d6615769bcb6d0e6d79f527',
              id: 46,
              frequency: 88772,
            },
            {
              _id: '5d6615769bcb6d0e6d79f526',
              id: 47,
              frequency: 4446,
            },
            {
              _id: '5d6615769bcb6d0e6d79f525',
              id: 48,
              frequency: 29578,
            },
            {
              _id: '5d6615769bcb6d0e6d79f524',
              id: 49,
              frequency: 609,
            },
            {
              _id: '5d6615769bcb6d0e6d79f523',
              id: 50,
              frequency: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79f522',
              id: 51,
              frequency: 10206,
            },
            {
              _id: '5d6615769bcb6d0e6d79f521',
              id: 52,
              frequency: 13091,
            },
            {
              _id: '5d6615769bcb6d0e6d79f520',
              id: 53,
              frequency: 3306,
            },
            {
              _id: '5d6615769bcb6d0e6d79f51f',
              id: 54,
              frequency: 31895,
            },
            {
              _id: '5d6615769bcb6d0e6d79f51e',
              id: 55,
              frequency: 546,
            },
            {
              _id: '5d6615769bcb6d0e6d79f51d',
              id: 56,
              frequency: 49638,
            },
            {
              _id: '5d6615769bcb6d0e6d79f51c',
              id: 57,
              frequency: 238885,
            },
            {
              _id: '5d6615769bcb6d0e6d79f51b',
              id: 58,
              frequency: 1933,
            },
            {
              _id: '5d6615769bcb6d0e6d79f51a',
              id: 59,
              frequency: 179650,
            },
            {
              _id: '5d6615769bcb6d0e6d79f519',
              id: 60,
              frequency: 50899,
            },
            {
              _id: '5d6615769bcb6d0e6d79f518',
              id: 61,
              frequency: 1894,
            },
            {
              _id: '5d6615769bcb6d0e6d79f517',
              id: 62,
              frequency: 4852,
            },
            {
              _id: '5d6615769bcb6d0e6d79f516',
              id: 63,
              frequency: 4234,
            },
            {
              _id: '5d6615769bcb6d0e6d79f515',
              id: 64,
              frequency: 10071,
            },
            {
              _id: '5d6615769bcb6d0e6d79f514',
              id: 65,
              frequency: 206086,
            },
            {
              _id: '5d6615769bcb6d0e6d79f513',
              id: 66,
              frequency: 395908,
            },
            {
              _id: '5d6615769bcb6d0e6d79f512',
              id: 67,
              frequency: 29169,
            },
            {
              _id: '5d6615769bcb6d0e6d79f511',
              id: 68,
              frequency: 42576,
            },
            {
              _id: '5d6615769bcb6d0e6d79f510',
              id: 69,
              frequency: 1391,
            },
            {
              _id: '5d6615769bcb6d0e6d79f50f',
              id: 70,
              frequency: 500049,
            },
            {
              _id: '5d6615769bcb6d0e6d79f50e',
              id: 71,
              frequency: 133733,
            },
            {
              _id: '5d6615769bcb6d0e6d79f50d',
              id: 72,
              frequency: 645168,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79f45f',
          id: 34,
          abbrevName: '35',
          fullName: '35_R_Thalamus',
          coordinates: {
            x: 11.402062,
            y: -17.360825,
            z: 7.835052,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79f495',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d79f494',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d79f493',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d79f492',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79f491',
              to: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d79f490',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79f48f',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79f48e',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d79f48d',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d79f48c',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79f48b',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79f48a',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79f489',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79f488',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79f487',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79f486',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79f485',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79f484',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79f483',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79f482',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79f481',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79f480',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79f47f',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79f47e',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79f47d',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79f47c',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79f47b',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79f47a',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79f479',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79f478',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79f477',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79f476',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79f475',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79f474',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79f473',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79f472',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79f471',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79f470',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79f46f',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79f46e',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79f46d',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79f46c',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79f46b',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79f46a',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79f469',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79f468',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79f467',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79f466',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79f465',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79f464',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79f463',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79f462',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79f461',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79f460',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79f4de',
              id: 0,
              frequency: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4dd',
              id: 1,
              frequency: 567,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4dc',
              id: 2,
              frequency: 518,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4db',
              id: 3,
              frequency: 3137,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4da',
              id: 4,
              frequency: 1613,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4d9',
              id: 5,
              frequency: 3301,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4d8',
              id: 6,
              frequency: 321,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4d7',
              id: 7,
              frequency: 549,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4d6',
              id: 8,
              frequency: 1361,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4d5',
              id: 9,
              frequency: 1561,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4d4',
              id: 10,
              frequency: 11346,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4d3',
              id: 11,
              frequency: 9184,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4d2',
              id: 12,
              frequency: 15413,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4d1',
              id: 13,
              frequency: 23497,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4d0',
              id: 14,
              frequency: 69110,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4cf',
              id: 15,
              frequency: 2040,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4ce',
              id: 16,
              frequency: 6363,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4cd',
              id: 17,
              frequency: 995,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4cc',
              id: 18,
              frequency: 438,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4cb',
              id: 19,
              frequency: 563,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4ca',
              id: 20,
              frequency: 1369,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4c9',
              id: 21,
              frequency: 3136,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4c8',
              id: 22,
              frequency: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4c7',
              id: 23,
              frequency: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4c6',
              id: 24,
              frequency: 2313,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4c5',
              id: 25,
              frequency: 1988,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4c4',
              id: 26,
              frequency: 19829,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4c3',
              id: 27,
              frequency: 2150,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4c2',
              id: 28,
              frequency: 6278,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4c1',
              id: 29,
              frequency: 25324,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4c0',
              id: 30,
              frequency: 15955,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4bf',
              id: 31,
              frequency: 613,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4be',
              id: 32,
              frequency: 3204,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4bd',
              id: 33,
              frequency: 4897,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4bc',
              id: 34,
              frequency: 1379,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4bb',
              id: 35,
              frequency: 252,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4ba',
              id: 36,
              frequency: 1712,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4b9',
              id: 37,
              frequency: 2175,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4b8',
              id: 38,
              frequency: 2184,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4b7',
              id: 39,
              frequency: 1085,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4b6',
              id: 40,
              frequency: 14487,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4b5',
              id: 41,
              frequency: 17237,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4b4',
              id: 42,
              frequency: 23558,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4b3',
              id: 43,
              frequency: 14117,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4b2',
              id: 44,
              frequency: 10370,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4b1',
              id: 45,
              frequency: 2640,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4b0',
              id: 46,
              frequency: 26368,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4af',
              id: 47,
              frequency: 28273,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4ae',
              id: 48,
              frequency: 62162,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4ad',
              id: 49,
              frequency: 116,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4ac',
              id: 50,
              frequency: 315,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4ab',
              id: 51,
              frequency: 5832,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4aa',
              id: 52,
              frequency: 2441,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4a9',
              id: 53,
              frequency: 12284,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4a8',
              id: 54,
              frequency: 2909,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4a7',
              id: 55,
              frequency: 11971,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4a6',
              id: 56,
              frequency: 2354,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4a5',
              id: 57,
              frequency: 176098,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4a4',
              id: 58,
              frequency: 83493,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4a3',
              id: 59,
              frequency: 35786,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4a2',
              id: 60,
              frequency: 83913,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4a1',
              id: 61,
              frequency: 53022,
            },
            {
              _id: '5d6615769bcb6d0e6d79f4a0',
              id: 62,
              frequency: 1867,
            },
            {
              _id: '5d6615769bcb6d0e6d79f49f',
              id: 63,
              frequency: 13707,
            },
            {
              _id: '5d6615769bcb6d0e6d79f49e',
              id: 64,
              frequency: 9486,
            },
            {
              _id: '5d6615769bcb6d0e6d79f49d',
              id: 65,
              frequency: 33469,
            },
            {
              _id: '5d6615769bcb6d0e6d79f49c',
              id: 66,
              frequency: 184617,
            },
            {
              _id: '5d6615769bcb6d0e6d79f49b',
              id: 67,
              frequency: 307359,
            },
            {
              _id: '5d6615769bcb6d0e6d79f49a',
              id: 68,
              frequency: 62011,
            },
            {
              _id: '5d6615769bcb6d0e6d79f499',
              id: 69,
              frequency: 15775,
            },
            {
              _id: '5d6615769bcb6d0e6d79f498',
              id: 70,
              frequency: 286720,
            },
            {
              _id: '5d6615769bcb6d0e6d79f497',
              id: 71,
              frequency: 553459,
            },
            {
              _id: '5d6615769bcb6d0e6d79f496',
              id: 72,
              frequency: 1059590,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79f3ff',
          id: 35,
          abbrevName: '36',
          fullName: '36_BI_Frontal_medial_cortex',
          coordinates: {
            x: 0.070352,
            y: 45.819095,
            z: -20.38191,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79f415',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79f414',
              to: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d79f413',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79f412',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79f411',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79f410',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79f40f',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79f40e',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79f40d',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79f40c',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d79f40b',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79f40a',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79f409',
              to: 99,
            },
            {
              _id: '5d6615769bcb6d0e6d79f408',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79f407',
              to: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d79f406',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79f405',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79f404',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79f403',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79f402',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79f401',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79f400',
              to: 60,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79f45e',
              id: 0,
              frequency: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d79f45d',
              id: 1,
              frequency: 1486,
            },
            {
              _id: '5d6615769bcb6d0e6d79f45c',
              id: 2,
              frequency: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79f45b',
              id: 3,
              frequency: 442,
            },
            {
              _id: '5d6615769bcb6d0e6d79f45a',
              id: 4,
              frequency: 16896,
            },
            {
              _id: '5d6615769bcb6d0e6d79f459',
              id: 5,
              frequency: 3655,
            },
            {
              _id: '5d6615769bcb6d0e6d79f458',
              id: 6,
              frequency: 2258,
            },
            {
              _id: '5d6615769bcb6d0e6d79f457',
              id: 7,
              frequency: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d79f456',
              id: 8,
              frequency: 1015,
            },
            {
              _id: '5d6615769bcb6d0e6d79f455',
              id: 9,
              frequency: 35196,
            },
            {
              _id: '5d6615769bcb6d0e6d79f454',
              id: 10,
              frequency: 9219,
            },
            {
              _id: '5d6615769bcb6d0e6d79f453',
              id: 11,
              frequency: 639,
            },
            {
              _id: '5d6615769bcb6d0e6d79f452',
              id: 12,
              frequency: 16324,
            },
            {
              _id: '5d6615769bcb6d0e6d79f451',
              id: 13,
              frequency: 1283,
            },
            {
              _id: '5d6615769bcb6d0e6d79f450',
              id: 14,
              frequency: 3499,
            },
            {
              _id: '5d6615769bcb6d0e6d79f44f',
              id: 15,
              frequency: 28774,
            },
            {
              _id: '5d6615769bcb6d0e6d79f44e',
              id: 16,
              frequency: 30499,
            },
            {
              _id: '5d6615769bcb6d0e6d79f44d',
              id: 17,
              frequency: 1891,
            },
            {
              _id: '5d6615769bcb6d0e6d79f44c',
              id: 18,
              frequency: 12623,
            },
            {
              _id: '5d6615769bcb6d0e6d79f44b',
              id: 19,
              frequency: 14871,
            },
            {
              _id: '5d6615769bcb6d0e6d79f44a',
              id: 20,
              frequency: 4058,
            },
            {
              _id: '5d6615769bcb6d0e6d79f449',
              id: 21,
              frequency: 1174,
            },
            {
              _id: '5d6615769bcb6d0e6d79f448',
              id: 22,
              frequency: 712,
            },
            {
              _id: '5d6615769bcb6d0e6d79f447',
              id: 23,
              frequency: 6,
            },
            {
              _id: '5d6615769bcb6d0e6d79f446',
              id: 24,
              frequency: 84484,
            },
            {
              _id: '5d6615769bcb6d0e6d79f445',
              id: 25,
              frequency: 6606,
            },
            {
              _id: '5d6615769bcb6d0e6d79f444',
              id: 26,
              frequency: 8412,
            },
            {
              _id: '5d6615769bcb6d0e6d79f443',
              id: 27,
              frequency: 141745,
            },
            {
              _id: '5d6615769bcb6d0e6d79f442',
              id: 28,
              frequency: 70764,
            },
            {
              _id: '5d6615769bcb6d0e6d79f441',
              id: 29,
              frequency: 60520,
            },
            {
              _id: '5d6615769bcb6d0e6d79f440',
              id: 30,
              frequency: 3915,
            },
            {
              _id: '5d6615769bcb6d0e6d79f43f',
              id: 31,
              frequency: 20972,
            },
            {
              _id: '5d6615769bcb6d0e6d79f43e',
              id: 32,
              frequency: 7007,
            },
            {
              _id: '5d6615769bcb6d0e6d79f43d',
              id: 33,
              frequency: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79f43c',
              id: 34,
              frequency: 5215,
            },
            {
              _id: '5d6615769bcb6d0e6d79f43b',
              id: 35,
              frequency: 9483,
            },
            {
              _id: '5d6615769bcb6d0e6d79f43a',
              id: 36,
              frequency: 4668,
            },
            {
              _id: '5d6615769bcb6d0e6d79f439',
              id: 37,
              frequency: 2734,
            },
            {
              _id: '5d6615769bcb6d0e6d79f438',
              id: 38,
              frequency: 838,
            },
            {
              _id: '5d6615769bcb6d0e6d79f437',
              id: 39,
              frequency: 72481,
            },
            {
              _id: '5d6615769bcb6d0e6d79f436',
              id: 40,
              frequency: 33111,
            },
            {
              _id: '5d6615769bcb6d0e6d79f435',
              id: 41,
              frequency: 6131,
            },
            {
              _id: '5d6615769bcb6d0e6d79f434',
              id: 42,
              frequency: 547,
            },
            {
              _id: '5d6615769bcb6d0e6d79f433',
              id: 43,
              frequency: 95743,
            },
            {
              _id: '5d6615769bcb6d0e6d79f432',
              id: 44,
              frequency: 303,
            },
            {
              _id: '5d6615769bcb6d0e6d79f431',
              id: 45,
              frequency: 299829,
            },
            {
              _id: '5d6615769bcb6d0e6d79f430',
              id: 46,
              frequency: 66405,
            },
            {
              _id: '5d6615769bcb6d0e6d79f42f',
              id: 47,
              frequency: 19243,
            },
            {
              _id: '5d6615769bcb6d0e6d79f42e',
              id: 48,
              frequency: 13233,
            },
            {
              _id: '5d6615769bcb6d0e6d79f42d',
              id: 49,
              frequency: 378,
            },
            {
              _id: '5d6615769bcb6d0e6d79f42c',
              id: 50,
              frequency: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79f42b',
              id: 51,
              frequency: 30516,
            },
            {
              _id: '5d6615769bcb6d0e6d79f42a',
              id: 52,
              frequency: 13894,
            },
            {
              _id: '5d6615769bcb6d0e6d79f429',
              id: 53,
              frequency: 3466,
            },
            {
              _id: '5d6615769bcb6d0e6d79f428',
              id: 54,
              frequency: 12295,
            },
            {
              _id: '5d6615769bcb6d0e6d79f427',
              id: 55,
              frequency: 283,
            },
            {
              _id: '5d6615769bcb6d0e6d79f426',
              id: 56,
              frequency: 547330,
            },
            {
              _id: '5d6615769bcb6d0e6d79f425',
              id: 57,
              frequency: 35598,
            },
            {
              _id: '5d6615769bcb6d0e6d79f424',
              id: 58,
              frequency: 2492,
            },
            {
              _id: '5d6615769bcb6d0e6d79f423',
              id: 59,
              frequency: 238773,
            },
            {
              _id: '5d6615769bcb6d0e6d79f422',
              id: 60,
              frequency: 37854,
            },
            {
              _id: '5d6615769bcb6d0e6d79f421',
              id: 61,
              frequency: 1311,
            },
            {
              _id: '5d6615769bcb6d0e6d79f420',
              id: 62,
              frequency: 12664,
            },
            {
              _id: '5d6615769bcb6d0e6d79f41f',
              id: 63,
              frequency: 3108,
            },
            {
              _id: '5d6615769bcb6d0e6d79f41e',
              id: 64,
              frequency: 2249,
            },
            {
              _id: '5d6615769bcb6d0e6d79f41d',
              id: 65,
              frequency: 332574,
            },
            {
              _id: '5d6615769bcb6d0e6d79f41c',
              id: 66,
              frequency: 67434,
            },
            {
              _id: '5d6615769bcb6d0e6d79f41b',
              id: 67,
              frequency: 6570,
            },
            {
              _id: '5d6615769bcb6d0e6d79f41a',
              id: 68,
              frequency: 18528,
            },
            {
              _id: '5d6615769bcb6d0e6d79f419',
              id: 69,
              frequency: 233,
            },
            {
              _id: '5d6615769bcb6d0e6d79f418',
              id: 70,
              frequency: 113783,
            },
            {
              _id: '5d6615769bcb6d0e6d79f417',
              id: 71,
              frequency: 10200,
            },
            {
              _id: '5d6615769bcb6d0e6d79f416',
              id: 72,
              frequency: 18877,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79f380',
          id: 36,
          abbrevName: '37',
          fullName: '37_L_Frontal_Operculum_frontal_orbital_Insula',
          coordinates: {
            x: -42.095238,
            y: 19.180952,
            z: 1.52381,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79f3b5',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3b4',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3b3',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3b2',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3b1',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3b0',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3af',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3ae',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3ad',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3ac',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3ab',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3aa',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3a9',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3a8',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3a7',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3a6',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3a5',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3a4',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3a3',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3a2',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3a1',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3a0',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79f39f',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79f39e',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79f39d',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79f39c',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79f39b',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79f39a',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79f399',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79f398',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79f397',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79f396',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79f395',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79f394',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79f393',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79f392',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79f391',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79f390',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79f38f',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79f38e',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79f38d',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79f38c',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79f38b',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79f38a',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79f389',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79f388',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79f387',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79f386',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79f385',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79f384',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79f383',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79f382',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79f381',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79f3fe',
              id: 0,
              frequency: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3fd',
              id: 1,
              frequency: 814,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3fc',
              id: 2,
              frequency: 324,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3fb',
              id: 3,
              frequency: 2836,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3fa',
              id: 4,
              frequency: 3429,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3f9',
              id: 5,
              frequency: 2809,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3f8',
              id: 6,
              frequency: 688,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3f7',
              id: 7,
              frequency: 151,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3f6',
              id: 8,
              frequency: 1634,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3f5',
              id: 9,
              frequency: 3493,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3f4',
              id: 10,
              frequency: 15971,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3f3',
              id: 11,
              frequency: 4341,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3f2',
              id: 12,
              frequency: 21129,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3f1',
              id: 13,
              frequency: 16137,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3f0',
              id: 14,
              frequency: 61531,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3ef',
              id: 15,
              frequency: 5127,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3ee',
              id: 16,
              frequency: 7432,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3ed',
              id: 17,
              frequency: 2189,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3ec',
              id: 18,
              frequency: 2622,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3eb',
              id: 19,
              frequency: 2298,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3ea',
              id: 20,
              frequency: 1453,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3e9',
              id: 21,
              frequency: 1113,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3e8',
              id: 22,
              frequency: 152,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3e7',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3e6',
              id: 24,
              frequency: 10023,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3e5',
              id: 25,
              frequency: 6594,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3e4',
              id: 26,
              frequency: 12114,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3e3',
              id: 27,
              frequency: 6160,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3e2',
              id: 28,
              frequency: 6501,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3e1',
              id: 29,
              frequency: 49209,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3e0',
              id: 30,
              frequency: 11503,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3df',
              id: 31,
              frequency: 1730,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3de',
              id: 32,
              frequency: 6109,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3dd',
              id: 33,
              frequency: 954,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3dc',
              id: 34,
              frequency: 1746,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3db',
              id: 35,
              frequency: 503,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3da',
              id: 36,
              frequency: 3331,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3d9',
              id: 37,
              frequency: 2860,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3d8',
              id: 38,
              frequency: 907,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3d7',
              id: 39,
              frequency: 3592,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3d6',
              id: 40,
              frequency: 28198,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3d5',
              id: 41,
              frequency: 17634,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3d4',
              id: 42,
              frequency: 5089,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3d3',
              id: 43,
              frequency: 28620,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3d2',
              id: 44,
              frequency: 4605,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3d1',
              id: 45,
              frequency: 8512,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3d0',
              id: 46,
              frequency: 52364,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3cf',
              id: 47,
              frequency: 14941,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3ce',
              id: 48,
              frequency: 57131,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3cd',
              id: 49,
              frequency: 227,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3cc',
              id: 50,
              frequency: 309,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3cb',
              id: 51,
              frequency: 10083,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3ca',
              id: 52,
              frequency: 5802,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3c9',
              id: 53,
              frequency: 11388,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3c8',
              id: 54,
              frequency: 7639,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3c7',
              id: 55,
              frequency: 4630,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3c6',
              id: 56,
              frequency: 8673,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3c5',
              id: 57,
              frequency: 229287,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3c4',
              id: 58,
              frequency: 25414,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3c3',
              id: 59,
              frequency: 77681,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3c2',
              id: 60,
              frequency: 81541,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3c1',
              id: 61,
              frequency: 23068,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3c0',
              id: 62,
              frequency: 4148,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3bf',
              id: 63,
              frequency: 15040,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3be',
              id: 64,
              frequency: 12984,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3bd',
              id: 65,
              frequency: 72383,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3bc',
              id: 66,
              frequency: 281877,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3bb',
              id: 67,
              frequency: 181373,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3ba',
              id: 68,
              frequency: 71166,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3b9',
              id: 69,
              frequency: 8257,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3b8',
              id: 70,
              frequency: 370777,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3b7',
              id: 71,
              frequency: 390830,
            },
            {
              _id: '5d6615769bcb6d0e6d79f3b6',
              id: 72,
              frequency: 937360,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79f2fd',
          id: 37,
          abbrevName: '38',
          fullName: '38_L_ITG_temporoocciptial',
          coordinates: {
            x: -50.040609,
            y: -56.13198,
            z: -15.269036,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79f336',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d79f335',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79f334',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79f333',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79f332',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d79f331',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d79f330',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79f32f',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79f32e',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79f32d',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79f32c',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79f32b',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79f32a',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79f329',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79f328',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79f327',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79f326',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79f325',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79f324',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79f323',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79f322',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79f321',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79f320',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79f31f',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79f31e',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79f31d',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79f31c',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79f31b',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79f31a',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79f319',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79f318',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79f317',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79f316',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79f315',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79f314',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79f313',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79f312',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79f311',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79f310',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79f30f',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79f30e',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79f30d',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79f30c',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79f30b',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79f30a',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79f309',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79f308',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79f307',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79f306',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79f305',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79f304',
              to: 93,
            },
            {
              _id: '5d6615769bcb6d0e6d79f303',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79f302',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79f301',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79f300',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2ff',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2fe',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79f37f',
              id: 0,
              frequency: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79f37e',
              id: 1,
              frequency: 193,
            },
            {
              _id: '5d6615769bcb6d0e6d79f37d',
              id: 2,
              frequency: 643,
            },
            {
              _id: '5d6615769bcb6d0e6d79f37c',
              id: 3,
              frequency: 3543,
            },
            {
              _id: '5d6615769bcb6d0e6d79f37b',
              id: 4,
              frequency: 315,
            },
            {
              _id: '5d6615769bcb6d0e6d79f37a',
              id: 5,
              frequency: 2207,
            },
            {
              _id: '5d6615769bcb6d0e6d79f379',
              id: 6,
              frequency: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79f378',
              id: 7,
              frequency: 885,
            },
            {
              _id: '5d6615769bcb6d0e6d79f377',
              id: 8,
              frequency: 297,
            },
            {
              _id: '5d6615769bcb6d0e6d79f376',
              id: 9,
              frequency: 187,
            },
            {
              _id: '5d6615769bcb6d0e6d79f375',
              id: 10,
              frequency: 7806,
            },
            {
              _id: '5d6615769bcb6d0e6d79f374',
              id: 11,
              frequency: 12622,
            },
            {
              _id: '5d6615769bcb6d0e6d79f373',
              id: 12,
              frequency: 3478,
            },
            {
              _id: '5d6615769bcb6d0e6d79f372',
              id: 13,
              frequency: 29971,
            },
            {
              _id: '5d6615769bcb6d0e6d79f371',
              id: 14,
              frequency: 82102,
            },
            {
              _id: '5d6615769bcb6d0e6d79f370',
              id: 15,
              frequency: 210,
            },
            {
              _id: '5d6615769bcb6d0e6d79f36f',
              id: 16,
              frequency: 2322,
            },
            {
              _id: '5d6615769bcb6d0e6d79f36e',
              id: 17,
              frequency: 411,
            },
            {
              _id: '5d6615769bcb6d0e6d79f36d',
              id: 18,
              frequency: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79f36c',
              id: 19,
              frequency: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79f36b',
              id: 20,
              frequency: 856,
            },
            {
              _id: '5d6615769bcb6d0e6d79f36a',
              id: 21,
              frequency: 3351,
            },
            {
              _id: '5d6615769bcb6d0e6d79f369',
              id: 22,
              frequency: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d79f368',
              id: 23,
              frequency: 368,
            },
            {
              _id: '5d6615769bcb6d0e6d79f367',
              id: 24,
              frequency: 110,
            },
            {
              _id: '5d6615769bcb6d0e6d79f366',
              id: 25,
              frequency: 760,
            },
            {
              _id: '5d6615769bcb6d0e6d79f365',
              id: 26,
              frequency: 20007,
            },
            {
              _id: '5d6615769bcb6d0e6d79f364',
              id: 27,
              frequency: 245,
            },
            {
              _id: '5d6615769bcb6d0e6d79f363',
              id: 28,
              frequency: 2333,
            },
            {
              _id: '5d6615769bcb6d0e6d79f362',
              id: 29,
              frequency: 10962,
            },
            {
              _id: '5d6615769bcb6d0e6d79f361',
              id: 30,
              frequency: 18517,
            },
            {
              _id: '5d6615769bcb6d0e6d79f360',
              id: 31,
              frequency: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79f35f',
              id: 32,
              frequency: 1971,
            },
            {
              _id: '5d6615769bcb6d0e6d79f35e',
              id: 33,
              frequency: 9499,
            },
            {
              _id: '5d6615769bcb6d0e6d79f35d',
              id: 34,
              frequency: 128,
            },
            {
              _id: '5d6615769bcb6d0e6d79f35c',
              id: 35,
              frequency: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d79f35b',
              id: 36,
              frequency: 256,
            },
            {
              _id: '5d6615769bcb6d0e6d79f35a',
              id: 37,
              frequency: 423,
            },
            {
              _id: '5d6615769bcb6d0e6d79f359',
              id: 38,
              frequency: 779,
            },
            {
              _id: '5d6615769bcb6d0e6d79f358',
              id: 39,
              frequency: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79f357',
              id: 40,
              frequency: 2677,
            },
            {
              _id: '5d6615769bcb6d0e6d79f356',
              id: 41,
              frequency: 15501,
            },
            {
              _id: '5d6615769bcb6d0e6d79f355',
              id: 42,
              frequency: 41262,
            },
            {
              _id: '5d6615769bcb6d0e6d79f354',
              id: 43,
              frequency: 5837,
            },
            {
              _id: '5d6615769bcb6d0e6d79f353',
              id: 44,
              frequency: 14377,
            },
            {
              _id: '5d6615769bcb6d0e6d79f352',
              id: 45,
              frequency: 133,
            },
            {
              _id: '5d6615769bcb6d0e6d79f351',
              id: 46,
              frequency: 4018,
            },
            {
              _id: '5d6615769bcb6d0e6d79f350',
              id: 47,
              frequency: 10935,
            },
            {
              _id: '5d6615769bcb6d0e6d79f34f',
              id: 48,
              frequency: 68976,
            },
            {
              _id: '5d6615769bcb6d0e6d79f34e',
              id: 49,
              frequency: 12,
            },
            {
              _id: '5d6615769bcb6d0e6d79f34d',
              id: 50,
              frequency: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79f34c',
              id: 51,
              frequency: 615,
            },
            {
              _id: '5d6615769bcb6d0e6d79f34b',
              id: 52,
              frequency: 531,
            },
            {
              _id: '5d6615769bcb6d0e6d79f34a',
              id: 53,
              frequency: 5007,
            },
            {
              _id: '5d6615769bcb6d0e6d79f349',
              id: 54,
              frequency: 346,
            },
            {
              _id: '5d6615769bcb6d0e6d79f348',
              id: 55,
              frequency: 17033,
            },
            {
              _id: '5d6615769bcb6d0e6d79f347',
              id: 56,
              frequency: 113,
            },
            {
              _id: '5d6615769bcb6d0e6d79f346',
              id: 57,
              frequency: 177113,
            },
            {
              _id: '5d6615769bcb6d0e6d79f345',
              id: 58,
              frequency: 130865,
            },
            {
              _id: '5d6615769bcb6d0e6d79f344',
              id: 59,
              frequency: 4900,
            },
            {
              _id: '5d6615769bcb6d0e6d79f343',
              id: 60,
              frequency: 37476,
            },
            {
              _id: '5d6615769bcb6d0e6d79f342',
              id: 61,
              frequency: 76846,
            },
            {
              _id: '5d6615769bcb6d0e6d79f341',
              id: 62,
              frequency: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79f340',
              id: 63,
              frequency: 2389,
            },
            {
              _id: '5d6615769bcb6d0e6d79f33f',
              id: 64,
              frequency: 4416,
            },
            {
              _id: '5d6615769bcb6d0e6d79f33e',
              id: 65,
              frequency: 1597,
            },
            {
              _id: '5d6615769bcb6d0e6d79f33d',
              id: 66,
              frequency: 88507,
            },
            {
              _id: '5d6615769bcb6d0e6d79f33c',
              id: 67,
              frequency: 418041,
            },
            {
              _id: '5d6615769bcb6d0e6d79f33b',
              id: 68,
              frequency: 11624,
            },
            {
              _id: '5d6615769bcb6d0e6d79f33a',
              id: 69,
              frequency: 24162,
            },
            {
              _id: '5d6615769bcb6d0e6d79f339',
              id: 70,
              frequency: 50155,
            },
            {
              _id: '5d6615769bcb6d0e6d79f338',
              id: 71,
              frequency: 744318,
            },
            {
              _id: '5d6615769bcb6d0e6d79f337',
              id: 72,
              frequency: 1317384,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79f27f',
          id: 38,
          abbrevName: '39',
          fullName: '39_L_SPL',
          coordinates: {
            x: -36.4,
            y: -48.161702,
            z: 52.885106,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79f2b3',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2b2',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2b1',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2b0',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2af',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2ae',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2ad',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2ac',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2ab',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2aa',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2a9',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2a8',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2a7',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2a6',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2a5',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2a4',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2a3',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2a2',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2a1',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2a0',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79f29f',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79f29e',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79f29d',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79f29c',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79f29b',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79f29a',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79f299',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79f298',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79f297',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79f296',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79f295',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79f294',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79f293',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79f292',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79f291',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79f290',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79f28f',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79f28e',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79f28d',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79f28c',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79f28b',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79f28a',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79f289',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79f288',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79f287',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79f286',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79f285',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79f284',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79f283',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79f282',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79f281',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79f280',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79f2fc',
              id: 0,
              frequency: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2fb',
              id: 1,
              frequency: 560,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2fa',
              id: 2,
              frequency: 362,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2f9',
              id: 3,
              frequency: 3124,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2f8',
              id: 4,
              frequency: 2458,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2f7',
              id: 5,
              frequency: 2694,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2f6',
              id: 6,
              frequency: 216,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2f5',
              id: 7,
              frequency: 182,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2f4',
              id: 8,
              frequency: 832,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2f3',
              id: 9,
              frequency: 1787,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2f2',
              id: 10,
              frequency: 15462,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2f1',
              id: 11,
              frequency: 4930,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2f0',
              id: 12,
              frequency: 13330,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2ef',
              id: 13,
              frequency: 19278,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2ee',
              id: 14,
              frequency: 70894,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2ed',
              id: 15,
              frequency: 2786,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2ec',
              id: 16,
              frequency: 7429,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2eb',
              id: 17,
              frequency: 932,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2ea',
              id: 18,
              frequency: 1664,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2e9',
              id: 19,
              frequency: 400,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2e8',
              id: 20,
              frequency: 949,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2e7',
              id: 21,
              frequency: 1277,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2e6',
              id: 22,
              frequency: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2e5',
              id: 23,
              frequency: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2e4',
              id: 24,
              frequency: 3683,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2e3',
              id: 25,
              frequency: 2311,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2e2',
              id: 26,
              frequency: 14282,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2e1',
              id: 27,
              frequency: 4494,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2e0',
              id: 28,
              frequency: 6030,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2df',
              id: 29,
              frequency: 48703,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2de',
              id: 30,
              frequency: 11970,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2dd',
              id: 31,
              frequency: 444,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2dc',
              id: 32,
              frequency: 4795,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2db',
              id: 33,
              frequency: 944,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2da',
              id: 34,
              frequency: 1768,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2d9',
              id: 35,
              frequency: 128,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2d8',
              id: 36,
              frequency: 2008,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2d7',
              id: 37,
              frequency: 849,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2d6',
              id: 38,
              frequency: 635,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2d5',
              id: 39,
              frequency: 967,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2d4',
              id: 40,
              frequency: 9495,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2d3',
              id: 41,
              frequency: 20379,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2d2',
              id: 42,
              frequency: 6473,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2d1',
              id: 43,
              frequency: 25111,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2d0',
              id: 44,
              frequency: 5204,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2cf',
              id: 45,
              frequency: 4677,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2ce',
              id: 46,
              frequency: 36310,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2cd',
              id: 47,
              frequency: 13512,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2cc',
              id: 48,
              frequency: 66320,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2cb',
              id: 49,
              frequency: 14,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2ca',
              id: 50,
              frequency: 143,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2c9',
              id: 51,
              frequency: 4939,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2c8',
              id: 52,
              frequency: 5980,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2c7',
              id: 53,
              frequency: 8295,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2c6',
              id: 54,
              frequency: 906,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2c5',
              id: 55,
              frequency: 6329,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2c4',
              id: 56,
              frequency: 3492,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2c3',
              id: 57,
              frequency: 261367,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2c2',
              id: 58,
              frequency: 29188,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2c1',
              id: 59,
              frequency: 50811,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2c0',
              id: 60,
              frequency: 77223,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2bf',
              id: 61,
              frequency: 29267,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2be',
              id: 62,
              frequency: 1049,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2bd',
              id: 63,
              frequency: 6062,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2bc',
              id: 64,
              frequency: 10682,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2bb',
              id: 65,
              frequency: 29666,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2ba',
              id: 66,
              frequency: 258454,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2b9',
              id: 67,
              frequency: 217582,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2b8',
              id: 68,
              frequency: 36059,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2b7',
              id: 69,
              frequency: 11790,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2b6',
              id: 70,
              frequency: 221897,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2b5',
              id: 71,
              frequency: 497600,
            },
            {
              _id: '5d6615769bcb6d0e6d79f2b4',
              id: 72,
              frequency: 1125111,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79f200',
          id: 39,
          abbrevName: '40',
          fullName: '40_L_LOC_superior_occipital_pole',
          coordinates: {
            x: -29.522936,
            y: -85.412844,
            z: 23.394495,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79f235',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79f234',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79f233',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d79f232',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d79f231',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79f230',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79f22f',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79f22e',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79f22d',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79f22c',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79f22b',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79f22a',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79f229',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79f228',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79f227',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79f226',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79f225',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79f224',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79f223',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79f222',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79f221',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79f220',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79f21f',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79f21e',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79f21d',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79f21c',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79f21b',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79f21a',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79f219',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79f218',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79f217',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79f216',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79f215',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79f214',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79f213',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79f212',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79f211',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79f210',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79f20f',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79f20e',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79f20d',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79f20c',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79f20b',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79f20a',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79f209',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79f208',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79f207',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79f206',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79f205',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79f204',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79f203',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79f202',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79f201',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79f27e',
              id: 0,
              frequency: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79f27d',
              id: 1,
              frequency: 486,
            },
            {
              _id: '5d6615769bcb6d0e6d79f27c',
              id: 2,
              frequency: 348,
            },
            {
              _id: '5d6615769bcb6d0e6d79f27b',
              id: 3,
              frequency: 3222,
            },
            {
              _id: '5d6615769bcb6d0e6d79f27a',
              id: 4,
              frequency: 1588,
            },
            {
              _id: '5d6615769bcb6d0e6d79f279',
              id: 5,
              frequency: 2469,
            },
            {
              _id: '5d6615769bcb6d0e6d79f278',
              id: 6,
              frequency: 480,
            },
            {
              _id: '5d6615769bcb6d0e6d79f277',
              id: 7,
              frequency: 145,
            },
            {
              _id: '5d6615769bcb6d0e6d79f276',
              id: 8,
              frequency: 673,
            },
            {
              _id: '5d6615769bcb6d0e6d79f275',
              id: 9,
              frequency: 944,
            },
            {
              _id: '5d6615769bcb6d0e6d79f274',
              id: 10,
              frequency: 16017,
            },
            {
              _id: '5d6615769bcb6d0e6d79f273',
              id: 11,
              frequency: 4413,
            },
            {
              _id: '5d6615769bcb6d0e6d79f272',
              id: 12,
              frequency: 10496,
            },
            {
              _id: '5d6615769bcb6d0e6d79f271',
              id: 13,
              frequency: 19623,
            },
            {
              _id: '5d6615769bcb6d0e6d79f270',
              id: 14,
              frequency: 74589,
            },
            {
              _id: '5d6615769bcb6d0e6d79f26f',
              id: 15,
              frequency: 1639,
            },
            {
              _id: '5d6615769bcb6d0e6d79f26e',
              id: 16,
              frequency: 5515,
            },
            {
              _id: '5d6615769bcb6d0e6d79f26d',
              id: 17,
              frequency: 2198,
            },
            {
              _id: '5d6615769bcb6d0e6d79f26c',
              id: 18,
              frequency: 1280,
            },
            {
              _id: '5d6615769bcb6d0e6d79f26b',
              id: 19,
              frequency: 1976,
            },
            {
              _id: '5d6615769bcb6d0e6d79f26a',
              id: 20,
              frequency: 1325,
            },
            {
              _id: '5d6615769bcb6d0e6d79f269',
              id: 21,
              frequency: 832,
            },
            {
              _id: '5d6615769bcb6d0e6d79f268',
              id: 22,
              frequency: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79f267',
              id: 23,
              frequency: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d79f266',
              id: 24,
              frequency: 2065,
            },
            {
              _id: '5d6615769bcb6d0e6d79f265',
              id: 25,
              frequency: 10476,
            },
            {
              _id: '5d6615769bcb6d0e6d79f264',
              id: 26,
              frequency: 10433,
            },
            {
              _id: '5d6615769bcb6d0e6d79f263',
              id: 27,
              frequency: 1805,
            },
            {
              _id: '5d6615769bcb6d0e6d79f262',
              id: 28,
              frequency: 3883,
            },
            {
              _id: '5d6615769bcb6d0e6d79f261',
              id: 29,
              frequency: 39843,
            },
            {
              _id: '5d6615769bcb6d0e6d79f260',
              id: 30,
              frequency: 11844,
            },
            {
              _id: '5d6615769bcb6d0e6d79f25f',
              id: 31,
              frequency: 1108,
            },
            {
              _id: '5d6615769bcb6d0e6d79f25e',
              id: 32,
              frequency: 7064,
            },
            {
              _id: '5d6615769bcb6d0e6d79f25d',
              id: 33,
              frequency: 696,
            },
            {
              _id: '5d6615769bcb6d0e6d79f25c',
              id: 34,
              frequency: 834,
            },
            {
              _id: '5d6615769bcb6d0e6d79f25b',
              id: 35,
              frequency: 269,
            },
            {
              _id: '5d6615769bcb6d0e6d79f25a',
              id: 36,
              frequency: 1306,
            },
            {
              _id: '5d6615769bcb6d0e6d79f259',
              id: 37,
              frequency: 1816,
            },
            {
              _id: '5d6615769bcb6d0e6d79f258',
              id: 38,
              frequency: 623,
            },
            {
              _id: '5d6615769bcb6d0e6d79f257',
              id: 39,
              frequency: 779,
            },
            {
              _id: '5d6615769bcb6d0e6d79f256',
              id: 40,
              frequency: 20639,
            },
            {
              _id: '5d6615769bcb6d0e6d79f255',
              id: 41,
              frequency: 19857,
            },
            {
              _id: '5d6615769bcb6d0e6d79f254',
              id: 42,
              frequency: 4915,
            },
            {
              _id: '5d6615769bcb6d0e6d79f253',
              id: 43,
              frequency: 19431,
            },
            {
              _id: '5d6615769bcb6d0e6d79f252',
              id: 44,
              frequency: 4867,
            },
            {
              _id: '5d6615769bcb6d0e6d79f251',
              id: 45,
              frequency: 1496,
            },
            {
              _id: '5d6615769bcb6d0e6d79f250',
              id: 46,
              frequency: 23372,
            },
            {
              _id: '5d6615769bcb6d0e6d79f24f',
              id: 47,
              frequency: 10337,
            },
            {
              _id: '5d6615769bcb6d0e6d79f24e',
              id: 48,
              frequency: 69885,
            },
            {
              _id: '5d6615769bcb6d0e6d79f24d',
              id: 49,
              frequency: 166,
            },
            {
              _id: '5d6615769bcb6d0e6d79f24c',
              id: 50,
              frequency: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79f24b',
              id: 51,
              frequency: 2555,
            },
            {
              _id: '5d6615769bcb6d0e6d79f24a',
              id: 52,
              frequency: 3841,
            },
            {
              _id: '5d6615769bcb6d0e6d79f249',
              id: 53,
              frequency: 7862,
            },
            {
              _id: '5d6615769bcb6d0e6d79f248',
              id: 54,
              frequency: 4572,
            },
            {
              _id: '5d6615769bcb6d0e6d79f247',
              id: 55,
              frequency: 5515,
            },
            {
              _id: '5d6615769bcb6d0e6d79f246',
              id: 56,
              frequency: 958,
            },
            {
              _id: '5d6615769bcb6d0e6d79f245',
              id: 57,
              frequency: 291216,
            },
            {
              _id: '5d6615769bcb6d0e6d79f244',
              id: 58,
              frequency: 21570,
            },
            {
              _id: '5d6615769bcb6d0e6d79f243',
              id: 59,
              frequency: 26773,
            },
            {
              _id: '5d6615769bcb6d0e6d79f242',
              id: 60,
              frequency: 69475,
            },
            {
              _id: '5d6615769bcb6d0e6d79f241',
              id: 61,
              frequency: 27399,
            },
            {
              _id: '5d6615769bcb6d0e6d79f240',
              id: 62,
              frequency: 558,
            },
            {
              _id: '5d6615769bcb6d0e6d79f23f',
              id: 63,
              frequency: 4319,
            },
            {
              _id: '5d6615769bcb6d0e6d79f23e',
              id: 64,
              frequency: 12440,
            },
            {
              _id: '5d6615769bcb6d0e6d79f23d',
              id: 65,
              frequency: 12769,
            },
            {
              _id: '5d6615769bcb6d0e6d79f23c',
              id: 66,
              frequency: 262365,
            },
            {
              _id: '5d6615769bcb6d0e6d79f23b',
              id: 67,
              frequency: 211668,
            },
            {
              _id: '5d6615769bcb6d0e6d79f23a',
              id: 68,
              frequency: 26011,
            },
            {
              _id: '5d6615769bcb6d0e6d79f239',
              id: 69,
              frequency: 12039,
            },
            {
              _id: '5d6615769bcb6d0e6d79f238',
              id: 70,
              frequency: 157550,
            },
            {
              _id: '5d6615769bcb6d0e6d79f237',
              id: 71,
              frequency: 530668,
            },
            {
              _id: '5d6615769bcb6d0e6d79f236',
              id: 72,
              frequency: 1205431,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79f1ae',
          id: 40,
          abbrevName: '41',
          fullName: '41_BI_Brainstem',
          coordinates: {
            x: 3.032727,
            y: -45.098182,
            z: -55.098182,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79f1b6',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1b5',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1b4',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1b3',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1b2',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1b1',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1b0',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1af',
              to: 91,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79f1ff',
              id: 0,
              frequency: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1fe',
              id: 1,
              frequency: 1036,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1fd',
              id: 2,
              frequency: 7,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1fc',
              id: 3,
              frequency: 129,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1fb',
              id: 4,
              frequency: 12209,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1fa',
              id: 5,
              frequency: 356,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1f9',
              id: 6,
              frequency: 3861,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1f8',
              id: 7,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1f7',
              id: 8,
              frequency: 174,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1f6',
              id: 9,
              frequency: 28942,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1f5',
              id: 10,
              frequency: 3450,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1f4',
              id: 11,
              frequency: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1f3',
              id: 12,
              frequency: 6211,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1f2',
              id: 13,
              frequency: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1f1',
              id: 14,
              frequency: 591,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1f0',
              id: 15,
              frequency: 38902,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1ef',
              id: 16,
              frequency: 1553,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1ee',
              id: 17,
              frequency: 1636,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1ed',
              id: 18,
              frequency: 13877,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1ec',
              id: 19,
              frequency: 32368,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1eb',
              id: 20,
              frequency: 554,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1ea',
              id: 21,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1e9',
              id: 22,
              frequency: 2363,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1e8',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1e7',
              id: 24,
              frequency: 105051,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1e6',
              id: 25,
              frequency: 6237,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1e5',
              id: 26,
              frequency: 140,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1e4',
              id: 27,
              frequency: 119377,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1e3',
              id: 28,
              frequency: 4351,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1e2',
              id: 29,
              frequency: 15569,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1e1',
              id: 30,
              frequency: 225,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1e0',
              id: 31,
              frequency: 58241,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1df',
              id: 32,
              frequency: 5550,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1de',
              id: 33,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1dd',
              id: 34,
              frequency: 2632,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1dc',
              id: 35,
              frequency: 11926,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1db',
              id: 36,
              frequency: 636,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1da',
              id: 37,
              frequency: 1426,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1d9',
              id: 38,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1d8',
              id: 39,
              frequency: 130923,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1d7',
              id: 40,
              frequency: 28688,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1d6',
              id: 41,
              frequency: 346,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1d5',
              id: 42,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1d4',
              id: 43,
              frequency: 35493,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1d3',
              id: 44,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1d2',
              id: 45,
              frequency: 236220,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1d1',
              id: 46,
              frequency: 17566,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1d0',
              id: 47,
              frequency: 386,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1cf',
              id: 48,
              frequency: 784,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1ce',
              id: 49,
              frequency: 145,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1cd',
              id: 50,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1cc',
              id: 51,
              frequency: 6914,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1cb',
              id: 52,
              frequency: 7537,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1ca',
              id: 53,
              frequency: 308,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1c9',
              id: 54,
              frequency: 12634,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1c8',
              id: 55,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1c7',
              id: 56,
              frequency: 517795,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1c6',
              id: 57,
              frequency: 6641,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1c5',
              id: 58,
              frequency: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1c4',
              id: 59,
              frequency: 114566,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1c3',
              id: 60,
              frequency: 2886,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1c2',
              id: 61,
              frequency: 5,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1c1',
              id: 62,
              frequency: 2291,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1c0',
              id: 63,
              frequency: 233,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1bf',
              id: 64,
              frequency: 206,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1be',
              id: 65,
              frequency: 148583,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1bd',
              id: 66,
              frequency: 16623,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1bc',
              id: 67,
              frequency: 154,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1bb',
              id: 68,
              frequency: 1630,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1ba',
              id: 69,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1b9',
              id: 70,
              frequency: 23259,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1b8',
              id: 71,
              frequency: 352,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1b7',
              id: 72,
              frequency: 1849,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79f134',
          id: 41,
          abbrevName: '42',
          fullName: '42_R_SFG__mfg',
          coordinates: {
            x: 26.206573,
            y: -6.131455,
            z: 64.206573,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79f164',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d79f163',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d79f162',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d79f161',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79f160',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79f15f',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79f15e',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79f15d',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79f15c',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79f15b',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79f15a',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79f159',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79f158',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79f157',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79f156',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79f155',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79f154',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79f153',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79f152',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79f151',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79f150',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79f14f',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79f14e',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79f14d',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79f14c',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79f14b',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79f14a',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79f149',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79f148',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79f147',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79f146',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79f145',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79f144',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79f143',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79f142',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79f141',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79f140',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79f13f',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79f13e',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79f13d',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79f13c',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79f13b',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79f13a',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79f139',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79f138',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79f137',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79f136',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79f135',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79f1ad',
              id: 0,
              frequency: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1ac',
              id: 1,
              frequency: 562,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1ab',
              id: 2,
              frequency: 348,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1aa',
              id: 3,
              frequency: 3138,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1a9',
              id: 4,
              frequency: 1666,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1a8',
              id: 5,
              frequency: 2852,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1a7',
              id: 6,
              frequency: 484,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1a6',
              id: 7,
              frequency: 186,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1a5',
              id: 8,
              frequency: 850,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1a4',
              id: 9,
              frequency: 1559,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1a3',
              id: 10,
              frequency: 16292,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1a2',
              id: 11,
              frequency: 4499,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1a1',
              id: 12,
              frequency: 12901,
            },
            {
              _id: '5d6615769bcb6d0e6d79f1a0',
              id: 13,
              frequency: 18980,
            },
            {
              _id: '5d6615769bcb6d0e6d79f19f',
              id: 14,
              frequency: 71619,
            },
            {
              _id: '5d6615769bcb6d0e6d79f19e',
              id: 15,
              frequency: 2316,
            },
            {
              _id: '5d6615769bcb6d0e6d79f19d',
              id: 16,
              frequency: 4372,
            },
            {
              _id: '5d6615769bcb6d0e6d79f19c',
              id: 17,
              frequency: 2064,
            },
            {
              _id: '5d6615769bcb6d0e6d79f19b',
              id: 18,
              frequency: 970,
            },
            {
              _id: '5d6615769bcb6d0e6d79f19a',
              id: 19,
              frequency: 1362,
            },
            {
              _id: '5d6615769bcb6d0e6d79f199',
              id: 20,
              frequency: 2021,
            },
            {
              _id: '5d6615769bcb6d0e6d79f198',
              id: 21,
              frequency: 1397,
            },
            {
              _id: '5d6615769bcb6d0e6d79f197',
              id: 22,
              frequency: 134,
            },
            {
              _id: '5d6615769bcb6d0e6d79f196',
              id: 23,
              frequency: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d79f195',
              id: 24,
              frequency: 3394,
            },
            {
              _id: '5d6615769bcb6d0e6d79f194',
              id: 25,
              frequency: 7122,
            },
            {
              _id: '5d6615769bcb6d0e6d79f193',
              id: 26,
              frequency: 10843,
            },
            {
              _id: '5d6615769bcb6d0e6d79f192',
              id: 27,
              frequency: 1970,
            },
            {
              _id: '5d6615769bcb6d0e6d79f191',
              id: 28,
              frequency: 6223,
            },
            {
              _id: '5d6615769bcb6d0e6d79f190',
              id: 29,
              frequency: 36422,
            },
            {
              _id: '5d6615769bcb6d0e6d79f18f',
              id: 30,
              frequency: 15450,
            },
            {
              _id: '5d6615769bcb6d0e6d79f18e',
              id: 31,
              frequency: 1045,
            },
            {
              _id: '5d6615769bcb6d0e6d79f18d',
              id: 32,
              frequency: 8712,
            },
            {
              _id: '5d6615769bcb6d0e6d79f18c',
              id: 33,
              frequency: 881,
            },
            {
              _id: '5d6615769bcb6d0e6d79f18b',
              id: 34,
              frequency: 945,
            },
            {
              _id: '5d6615769bcb6d0e6d79f18a',
              id: 35,
              frequency: 204,
            },
            {
              _id: '5d6615769bcb6d0e6d79f189',
              id: 36,
              frequency: 1152,
            },
            {
              _id: '5d6615769bcb6d0e6d79f188',
              id: 37,
              frequency: 1913,
            },
            {
              _id: '5d6615769bcb6d0e6d79f187',
              id: 38,
              frequency: 875,
            },
            {
              _id: '5d6615769bcb6d0e6d79f186',
              id: 39,
              frequency: 1287,
            },
            {
              _id: '5d6615769bcb6d0e6d79f185',
              id: 40,
              frequency: 19940,
            },
            {
              _id: '5d6615769bcb6d0e6d79f184',
              id: 41,
              frequency: 17232,
            },
            {
              _id: '5d6615769bcb6d0e6d79f183',
              id: 42,
              frequency: 6468,
            },
            {
              _id: '5d6615769bcb6d0e6d79f182',
              id: 43,
              frequency: 24774,
            },
            {
              _id: '5d6615769bcb6d0e6d79f181',
              id: 44,
              frequency: 4040,
            },
            {
              _id: '5d6615769bcb6d0e6d79f180',
              id: 45,
              frequency: 2413,
            },
            {
              _id: '5d6615769bcb6d0e6d79f17f',
              id: 46,
              frequency: 22452,
            },
            {
              _id: '5d6615769bcb6d0e6d79f17e',
              id: 47,
              frequency: 12307,
            },
            {
              _id: '5d6615769bcb6d0e6d79f17d',
              id: 48,
              frequency: 74406,
            },
            {
              _id: '5d6615769bcb6d0e6d79f17c',
              id: 49,
              frequency: 148,
            },
            {
              _id: '5d6615769bcb6d0e6d79f17b',
              id: 50,
              frequency: 134,
            },
            {
              _id: '5d6615769bcb6d0e6d79f17a',
              id: 51,
              frequency: 4244,
            },
            {
              _id: '5d6615769bcb6d0e6d79f179',
              id: 52,
              frequency: 3877,
            },
            {
              _id: '5d6615769bcb6d0e6d79f178',
              id: 53,
              frequency: 9160,
            },
            {
              _id: '5d6615769bcb6d0e6d79f177',
              id: 54,
              frequency: 3645,
            },
            {
              _id: '5d6615769bcb6d0e6d79f176',
              id: 55,
              frequency: 6760,
            },
            {
              _id: '5d6615769bcb6d0e6d79f175',
              id: 56,
              frequency: 2417,
            },
            {
              _id: '5d6615769bcb6d0e6d79f174',
              id: 57,
              frequency: 277035,
            },
            {
              _id: '5d6615769bcb6d0e6d79f173',
              id: 58,
              frequency: 24063,
            },
            {
              _id: '5d6615769bcb6d0e6d79f172',
              id: 59,
              frequency: 36388,
            },
            {
              _id: '5d6615769bcb6d0e6d79f171',
              id: 60,
              frequency: 79397,
            },
            {
              _id: '5d6615769bcb6d0e6d79f170',
              id: 61,
              frequency: 27638,
            },
            {
              _id: '5d6615769bcb6d0e6d79f16f',
              id: 62,
              frequency: 1160,
            },
            {
              _id: '5d6615769bcb6d0e6d79f16e',
              id: 63,
              frequency: 6228,
            },
            {
              _id: '5d6615769bcb6d0e6d79f16d',
              id: 64,
              frequency: 13034,
            },
            {
              _id: '5d6615769bcb6d0e6d79f16c',
              id: 65,
              frequency: 27724,
            },
            {
              _id: '5d6615769bcb6d0e6d79f16b',
              id: 66,
              frequency: 273768,
            },
            {
              _id: '5d6615769bcb6d0e6d79f16a',
              id: 67,
              frequency: 206096,
            },
            {
              _id: '5d6615769bcb6d0e6d79f169',
              id: 68,
              frequency: 33773,
            },
            {
              _id: '5d6615769bcb6d0e6d79f168',
              id: 69,
              frequency: 11316,
            },
            {
              _id: '5d6615769bcb6d0e6d79f167',
              id: 70,
              frequency: 206212,
            },
            {
              _id: '5d6615769bcb6d0e6d79f166',
              id: 71,
              frequency: 498950,
            },
            {
              _id: '5d6615769bcb6d0e6d79f165',
              id: 72,
              frequency: 1143270,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79f0bf',
          id: 42,
          abbrevName: '43',
          fullName: '43_R_Planum_polare_operculum',
          coordinates: {
            x: 50.172249,
            y: -1.655502,
            z: -3.311005,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79f0ea',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0e9',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0e8',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0e7',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0e6',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0e5',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0e4',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0e3',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0e2',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0e1',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0e0',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0df',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0de',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0dd',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0dc',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0db',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0da',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0d9',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0d8',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0d7',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0d6',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0d5',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0d4',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0d3',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0d2',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0d1',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0d0',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0cf',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0ce',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0cd',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0cc',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0cb',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0ca',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0c9',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0c8',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0c7',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0c6',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0c5',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0c4',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0c3',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0c2',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0c1',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0c0',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79f133',
              id: 0,
              frequency: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79f132',
              id: 1,
              frequency: 921,
            },
            {
              _id: '5d6615769bcb6d0e6d79f131',
              id: 2,
              frequency: 285,
            },
            {
              _id: '5d6615769bcb6d0e6d79f130',
              id: 3,
              frequency: 2718,
            },
            {
              _id: '5d6615769bcb6d0e6d79f12f',
              id: 4,
              frequency: 2841,
            },
            {
              _id: '5d6615769bcb6d0e6d79f12e',
              id: 5,
              frequency: 3487,
            },
            {
              _id: '5d6615769bcb6d0e6d79f12d',
              id: 6,
              frequency: 897,
            },
            {
              _id: '5d6615769bcb6d0e6d79f12c',
              id: 7,
              frequency: 104,
            },
            {
              _id: '5d6615769bcb6d0e6d79f12b',
              id: 8,
              frequency: 1280,
            },
            {
              _id: '5d6615769bcb6d0e6d79f12a',
              id: 9,
              frequency: 4840,
            },
            {
              _id: '5d6615769bcb6d0e6d79f129',
              id: 10,
              frequency: 19028,
            },
            {
              _id: '5d6615769bcb6d0e6d79f128',
              id: 11,
              frequency: 3784,
            },
            {
              _id: '5d6615769bcb6d0e6d79f127',
              id: 12,
              frequency: 22921,
            },
            {
              _id: '5d6615769bcb6d0e6d79f126',
              id: 13,
              frequency: 13780,
            },
            {
              _id: '5d6615769bcb6d0e6d79f125',
              id: 14,
              frequency: 58408,
            },
            {
              _id: '5d6615769bcb6d0e6d79f124',
              id: 15,
              frequency: 4532,
            },
            {
              _id: '5d6615769bcb6d0e6d79f123',
              id: 16,
              frequency: 5199,
            },
            {
              _id: '5d6615769bcb6d0e6d79f122',
              id: 17,
              frequency: 4562,
            },
            {
              _id: '5d6615769bcb6d0e6d79f121',
              id: 18,
              frequency: 1249,
            },
            {
              _id: '5d6615769bcb6d0e6d79f120',
              id: 19,
              frequency: 2578,
            },
            {
              _id: '5d6615769bcb6d0e6d79f11f',
              id: 20,
              frequency: 2888,
            },
            {
              _id: '5d6615769bcb6d0e6d79f11e',
              id: 21,
              frequency: 1129,
            },
            {
              _id: '5d6615769bcb6d0e6d79f11d',
              id: 22,
              frequency: 349,
            },
            {
              _id: '5d6615769bcb6d0e6d79f11c',
              id: 23,
              frequency: 1,
            },
            {
              _id: '5d6615769bcb6d0e6d79f11b',
              id: 24,
              frequency: 8340,
            },
            {
              _id: '5d6615769bcb6d0e6d79f11a',
              id: 25,
              frequency: 11484,
            },
            {
              _id: '5d6615769bcb6d0e6d79f119',
              id: 26,
              frequency: 13479,
            },
            {
              _id: '5d6615769bcb6d0e6d79f118',
              id: 27,
              frequency: 5632,
            },
            {
              _id: '5d6615769bcb6d0e6d79f117',
              id: 28,
              frequency: 11328,
            },
            {
              _id: '5d6615769bcb6d0e6d79f116',
              id: 29,
              frequency: 38800,
            },
            {
              _id: '5d6615769bcb6d0e6d79f115',
              id: 30,
              frequency: 15668,
            },
            {
              _id: '5d6615769bcb6d0e6d79f114',
              id: 31,
              frequency: 3484,
            },
            {
              _id: '5d6615769bcb6d0e6d79f113',
              id: 32,
              frequency: 11142,
            },
            {
              _id: '5d6615769bcb6d0e6d79f112',
              id: 33,
              frequency: 342,
            },
            {
              _id: '5d6615769bcb6d0e6d79f111',
              id: 34,
              frequency: 2507,
            },
            {
              _id: '5d6615769bcb6d0e6d79f110',
              id: 35,
              frequency: 411,
            },
            {
              _id: '5d6615769bcb6d0e6d79f10f',
              id: 36,
              frequency: 1180,
            },
            {
              _id: '5d6615769bcb6d0e6d79f10e',
              id: 37,
              frequency: 3562,
            },
            {
              _id: '5d6615769bcb6d0e6d79f10d',
              id: 38,
              frequency: 749,
            },
            {
              _id: '5d6615769bcb6d0e6d79f10c',
              id: 39,
              frequency: 3728,
            },
            {
              _id: '5d6615769bcb6d0e6d79f10b',
              id: 40,
              frequency: 37591,
            },
            {
              _id: '5d6615769bcb6d0e6d79f10a',
              id: 41,
              frequency: 17503,
            },
            {
              _id: '5d6615769bcb6d0e6d79f109',
              id: 42,
              frequency: 3943,
            },
            {
              _id: '5d6615769bcb6d0e6d79f108',
              id: 43,
              frequency: 47990,
            },
            {
              _id: '5d6615769bcb6d0e6d79f107',
              id: 44,
              frequency: 2624,
            },
            {
              _id: '5d6615769bcb6d0e6d79f106',
              id: 45,
              frequency: 8224,
            },
            {
              _id: '5d6615769bcb6d0e6d79f105',
              id: 46,
              frequency: 27716,
            },
            {
              _id: '5d6615769bcb6d0e6d79f104',
              id: 47,
              frequency: 19419,
            },
            {
              _id: '5d6615769bcb6d0e6d79f103',
              id: 48,
              frequency: 65828,
            },
            {
              _id: '5d6615769bcb6d0e6d79f102',
              id: 49,
              frequency: 156,
            },
            {
              _id: '5d6615769bcb6d0e6d79f101',
              id: 50,
              frequency: 100,
            },
            {
              _id: '5d6615769bcb6d0e6d79f100',
              id: 51,
              frequency: 9781,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0ff',
              id: 52,
              frequency: 6768,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0fe',
              id: 53,
              frequency: 11675,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0fd',
              id: 54,
              frequency: 6787,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0fc',
              id: 55,
              frequency: 3169,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0fb',
              id: 56,
              frequency: 16090,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0fa',
              id: 57,
              frequency: 247911,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0f9',
              id: 58,
              frequency: 28637,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0f8',
              id: 59,
              frequency: 88635,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0f7',
              id: 60,
              frequency: 100100,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0f6',
              id: 61,
              frequency: 18321,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0f5',
              id: 62,
              frequency: 3643,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0f4',
              id: 63,
              frequency: 9705,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0f3',
              id: 64,
              frequency: 12640,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0f2',
              id: 65,
              frequency: 103830,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0f1',
              id: 66,
              frequency: 349469,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0f0',
              id: 67,
              frequency: 142181,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0ef',
              id: 68,
              frequency: 52506,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0ee',
              id: 69,
              frequency: 8175,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0ed',
              id: 70,
              frequency: 386097,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0ec',
              id: 71,
              frequency: 333173,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0eb',
              id: 72,
              frequency: 885859,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79f059',
          id: 43,
          abbrevName: '44',
          fullName: '44_L_Cerebellum_maybe_other',
          coordinates: {
            x: -39.711712,
            y: -47.63964,
            z: -46.216216,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79f075',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79f074',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79f073',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79f072',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79f071',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79f070',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79f06f',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79f06e',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79f06d',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79f06c',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79f06b',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79f06a',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79f069',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79f068',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79f067',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79f066',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79f065',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79f064',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79f063',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79f062',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79f061',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79f060',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79f05f',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79f05e',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79f05d',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79f05c',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79f05b',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79f05a',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79f0be',
              id: 0,
              frequency: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0bd',
              id: 1,
              frequency: 1658,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0bc',
              id: 2,
              frequency: 192,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0bb',
              id: 3,
              frequency: 1638,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0ba',
              id: 4,
              frequency: 7727,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0b9',
              id: 5,
              frequency: 3873,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0b8',
              id: 6,
              frequency: 4039,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0b7',
              id: 7,
              frequency: 93,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0b6',
              id: 8,
              frequency: 2269,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0b5',
              id: 9,
              frequency: 18826,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0b4',
              id: 10,
              frequency: 14541,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0b3',
              id: 11,
              frequency: 2316,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0b2',
              id: 12,
              frequency: 38264,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0b1',
              id: 13,
              frequency: 6417,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0b0',
              id: 14,
              frequency: 27164,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0af',
              id: 15,
              frequency: 17236,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0ae',
              id: 16,
              frequency: 11429,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0ad',
              id: 17,
              frequency: 4643,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0ac',
              id: 18,
              frequency: 5116,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0ab',
              id: 19,
              frequency: 17907,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0aa',
              id: 20,
              frequency: 4940,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0a9',
              id: 21,
              frequency: 1091,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0a8',
              id: 22,
              frequency: 1763,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0a7',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0a6',
              id: 24,
              frequency: 60017,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0a5',
              id: 25,
              frequency: 12635,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0a4',
              id: 26,
              frequency: 11124,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0a3',
              id: 27,
              frequency: 22173,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0a2',
              id: 28,
              frequency: 27954,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0a1',
              id: 29,
              frequency: 43398,
            },
            {
              _id: '5d6615769bcb6d0e6d79f0a0',
              id: 30,
              frequency: 6138,
            },
            {
              _id: '5d6615769bcb6d0e6d79f09f',
              id: 31,
              frequency: 25677,
            },
            {
              _id: '5d6615769bcb6d0e6d79f09e',
              id: 32,
              frequency: 8787,
            },
            {
              _id: '5d6615769bcb6d0e6d79f09d',
              id: 33,
              frequency: 423,
            },
            {
              _id: '5d6615769bcb6d0e6d79f09c',
              id: 34,
              frequency: 3790,
            },
            {
              _id: '5d6615769bcb6d0e6d79f09b',
              id: 35,
              frequency: 4415,
            },
            {
              _id: '5d6615769bcb6d0e6d79f09a',
              id: 36,
              frequency: 3367,
            },
            {
              _id: '5d6615769bcb6d0e6d79f099',
              id: 37,
              frequency: 9447,
            },
            {
              _id: '5d6615769bcb6d0e6d79f098',
              id: 38,
              frequency: 1825,
            },
            {
              _id: '5d6615769bcb6d0e6d79f097',
              id: 39,
              frequency: 56347,
            },
            {
              _id: '5d6615769bcb6d0e6d79f096',
              id: 40,
              frequency: 94326,
            },
            {
              _id: '5d6615769bcb6d0e6d79f095',
              id: 41,
              frequency: 9336,
            },
            {
              _id: '5d6615769bcb6d0e6d79f094',
              id: 42,
              frequency: 2950,
            },
            {
              _id: '5d6615769bcb6d0e6d79f093',
              id: 43,
              frequency: 49997,
            },
            {
              _id: '5d6615769bcb6d0e6d79f092',
              id: 44,
              frequency: 1152,
            },
            {
              _id: '5d6615769bcb6d0e6d79f091',
              id: 45,
              frequency: 52184,
            },
            {
              _id: '5d6615769bcb6d0e6d79f090',
              id: 46,
              frequency: 74164,
            },
            {
              _id: '5d6615769bcb6d0e6d79f08f',
              id: 47,
              frequency: 36580,
            },
            {
              _id: '5d6615769bcb6d0e6d79f08e',
              id: 48,
              frequency: 27756,
            },
            {
              _id: '5d6615769bcb6d0e6d79f08d',
              id: 49,
              frequency: 1801,
            },
            {
              _id: '5d6615769bcb6d0e6d79f08c',
              id: 50,
              frequency: 260,
            },
            {
              _id: '5d6615769bcb6d0e6d79f08b',
              id: 51,
              frequency: 26849,
            },
            {
              _id: '5d6615769bcb6d0e6d79f08a',
              id: 52,
              frequency: 8965,
            },
            {
              _id: '5d6615769bcb6d0e6d79f089',
              id: 53,
              frequency: 9714,
            },
            {
              _id: '5d6615769bcb6d0e6d79f088',
              id: 54,
              frequency: 60619,
            },
            {
              _id: '5d6615769bcb6d0e6d79f087',
              id: 55,
              frequency: 1598,
            },
            {
              _id: '5d6615769bcb6d0e6d79f086',
              id: 56,
              frequency: 124376,
            },
            {
              _id: '5d6615769bcb6d0e6d79f085',
              id: 57,
              frequency: 107332,
            },
            {
              _id: '5d6615769bcb6d0e6d79f084',
              id: 58,
              frequency: 18152,
            },
            {
              _id: '5d6615769bcb6d0e6d79f083',
              id: 59,
              frequency: 201372,
            },
            {
              _id: '5d6615769bcb6d0e6d79f082',
              id: 60,
              frequency: 88645,
            },
            {
              _id: '5d6615769bcb6d0e6d79f081',
              id: 61,
              frequency: 7323,
            },
            {
              _id: '5d6615769bcb6d0e6d79f080',
              id: 62,
              frequency: 16906,
            },
            {
              _id: '5d6615769bcb6d0e6d79f07f',
              id: 63,
              frequency: 13727,
            },
            {
              _id: '5d6615769bcb6d0e6d79f07e',
              id: 64,
              frequency: 9127,
            },
            {
              _id: '5d6615769bcb6d0e6d79f07d',
              id: 65,
              frequency: 394788,
            },
            {
              _id: '5d6615769bcb6d0e6d79f07c',
              id: 66,
              frequency: 234545,
            },
            {
              _id: '5d6615769bcb6d0e6d79f07b',
              id: 67,
              frequency: 53872,
            },
            {
              _id: '5d6615769bcb6d0e6d79f07a',
              id: 68,
              frequency: 84971,
            },
            {
              _id: '5d6615769bcb6d0e6d79f079',
              id: 69,
              frequency: 2318,
            },
            {
              _id: '5d6615769bcb6d0e6d79f078',
              id: 70,
              frequency: 571379,
            },
            {
              _id: '5d6615769bcb6d0e6d79f077',
              id: 71,
              frequency: 116390,
            },
            {
              _id: '5d6615769bcb6d0e6d79f076',
              id: 72,
              frequency: 317677,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79efe8',
          id: 44,
          abbrevName: '45',
          fullName: '45_L_Precentral_gyrus_postcentral_gyrus',
          coordinates: {
            x: -58.374384,
            y: -9.152709,
            z: 23.901478,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79f00f',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79f00e',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79f00d',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79f00c',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79f00b',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79f00a',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79f009',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79f008',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79f007',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79f006',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79f005',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79f004',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79f003',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79f002',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79f001',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79f000',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79efff',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79effe',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79effd',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79effc',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79effb',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79effa',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79eff9',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79eff8',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79eff7',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79eff6',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79eff5',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79eff4',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79eff3',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79eff2',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79eff1',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79eff0',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79efef',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79efee',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79efed',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79efec',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79efeb',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79efea',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79efe9',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79f058',
              id: 0,
              frequency: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79f057',
              id: 1,
              frequency: 1292,
            },
            {
              _id: '5d6615769bcb6d0e6d79f056',
              id: 2,
              frequency: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d79f055',
              id: 3,
              frequency: 2190,
            },
            {
              _id: '5d6615769bcb6d0e6d79f054',
              id: 4,
              frequency: 6520,
            },
            {
              _id: '5d6615769bcb6d0e6d79f053',
              id: 5,
              frequency: 1428,
            },
            {
              _id: '5d6615769bcb6d0e6d79f052',
              id: 6,
              frequency: 2684,
            },
            {
              _id: '5d6615769bcb6d0e6d79f051',
              id: 7,
              frequency: 1,
            },
            {
              _id: '5d6615769bcb6d0e6d79f050',
              id: 8,
              frequency: 860,
            },
            {
              _id: '5d6615769bcb6d0e6d79f04f',
              id: 9,
              frequency: 10023,
            },
            {
              _id: '5d6615769bcb6d0e6d79f04e',
              id: 10,
              frequency: 21692,
            },
            {
              _id: '5d6615769bcb6d0e6d79f04d',
              id: 11,
              frequency: 457,
            },
            {
              _id: '5d6615769bcb6d0e6d79f04c',
              id: 12,
              frequency: 30862,
            },
            {
              _id: '5d6615769bcb6d0e6d79f04b',
              id: 13,
              frequency: 4891,
            },
            {
              _id: '5d6615769bcb6d0e6d79f04a',
              id: 14,
              frequency: 44767,
            },
            {
              _id: '5d6615769bcb6d0e6d79f049',
              id: 15,
              frequency: 14905,
            },
            {
              _id: '5d6615769bcb6d0e6d79f048',
              id: 16,
              frequency: 2846,
            },
            {
              _id: '5d6615769bcb6d0e6d79f047',
              id: 17,
              frequency: 2057,
            },
            {
              _id: '5d6615769bcb6d0e6d79f046',
              id: 18,
              frequency: 5647,
            },
            {
              _id: '5d6615769bcb6d0e6d79f045',
              id: 19,
              frequency: 12485,
            },
            {
              _id: '5d6615769bcb6d0e6d79f044',
              id: 20,
              frequency: 1870,
            },
            {
              _id: '5d6615769bcb6d0e6d79f043',
              id: 21,
              frequency: 9,
            },
            {
              _id: '5d6615769bcb6d0e6d79f042',
              id: 22,
              frequency: 1359,
            },
            {
              _id: '5d6615769bcb6d0e6d79f041',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79f040',
              id: 24,
              frequency: 33329,
            },
            {
              _id: '5d6615769bcb6d0e6d79f03f',
              id: 25,
              frequency: 18454,
            },
            {
              _id: '5d6615769bcb6d0e6d79f03e',
              id: 26,
              frequency: 1554,
            },
            {
              _id: '5d6615769bcb6d0e6d79f03d',
              id: 27,
              frequency: 17507,
            },
            {
              _id: '5d6615769bcb6d0e6d79f03c',
              id: 28,
              frequency: 7079,
            },
            {
              _id: '5d6615769bcb6d0e6d79f03b',
              id: 29,
              frequency: 71522,
            },
            {
              _id: '5d6615769bcb6d0e6d79f03a',
              id: 30,
              frequency: 2183,
            },
            {
              _id: '5d6615769bcb6d0e6d79f039',
              id: 31,
              frequency: 14334,
            },
            {
              _id: '5d6615769bcb6d0e6d79f038',
              id: 32,
              frequency: 18432,
            },
            {
              _id: '5d6615769bcb6d0e6d79f037',
              id: 33,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79f036',
              id: 34,
              frequency: 952,
            },
            {
              _id: '5d6615769bcb6d0e6d79f035',
              id: 35,
              frequency: 3256,
            },
            {
              _id: '5d6615769bcb6d0e6d79f034',
              id: 36,
              frequency: 1369,
            },
            {
              _id: '5d6615769bcb6d0e6d79f033',
              id: 37,
              frequency: 3670,
            },
            {
              _id: '5d6615769bcb6d0e6d79f032',
              id: 38,
              frequency: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d79f031',
              id: 39,
              frequency: 22206,
            },
            {
              _id: '5d6615769bcb6d0e6d79f030',
              id: 40,
              frequency: 85696,
            },
            {
              _id: '5d6615769bcb6d0e6d79f02f',
              id: 41,
              frequency: 5450,
            },
            {
              _id: '5d6615769bcb6d0e6d79f02e',
              id: 42,
              frequency: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d79f02d',
              id: 43,
              frequency: 69282,
            },
            {
              _id: '5d6615769bcb6d0e6d79f02c',
              id: 44,
              frequency: 168,
            },
            {
              _id: '5d6615769bcb6d0e6d79f02b',
              id: 45,
              frequency: 28658,
            },
            {
              _id: '5d6615769bcb6d0e6d79f02a',
              id: 46,
              frequency: 72853,
            },
            {
              _id: '5d6615769bcb6d0e6d79f029',
              id: 47,
              frequency: 3663,
            },
            {
              _id: '5d6615769bcb6d0e6d79f028',
              id: 48,
              frequency: 29694,
            },
            {
              _id: '5d6615769bcb6d0e6d79f027',
              id: 49,
              frequency: 575,
            },
            {
              _id: '5d6615769bcb6d0e6d79f026',
              id: 50,
              frequency: 2,
            },
            {
              _id: '5d6615769bcb6d0e6d79f025',
              id: 51,
              frequency: 8468,
            },
            {
              _id: '5d6615769bcb6d0e6d79f024',
              id: 52,
              frequency: 13388,
            },
            {
              _id: '5d6615769bcb6d0e6d79f023',
              id: 53,
              frequency: 2294,
            },
            {
              _id: '5d6615769bcb6d0e6d79f022',
              id: 54,
              frequency: 34505,
            },
            {
              _id: '5d6615769bcb6d0e6d79f021',
              id: 55,
              frequency: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79f020',
              id: 56,
              frequency: 45902,
            },
            {
              _id: '5d6615769bcb6d0e6d79f01f',
              id: 57,
              frequency: 253340,
            },
            {
              _id: '5d6615769bcb6d0e6d79f01e',
              id: 58,
              frequency: 924,
            },
            {
              _id: '5d6615769bcb6d0e6d79f01d',
              id: 59,
              frequency: 176880,
            },
            {
              _id: '5d6615769bcb6d0e6d79f01c',
              id: 60,
              frequency: 48962,
            },
            {
              _id: '5d6615769bcb6d0e6d79f01b',
              id: 61,
              frequency: 1451,
            },
            {
              _id: '5d6615769bcb6d0e6d79f01a',
              id: 62,
              frequency: 4207,
            },
            {
              _id: '5d6615769bcb6d0e6d79f019',
              id: 63,
              frequency: 3007,
            },
            {
              _id: '5d6615769bcb6d0e6d79f018',
              id: 64,
              frequency: 9530,
            },
            {
              _id: '5d6615769bcb6d0e6d79f017',
              id: 65,
              frequency: 200709,
            },
            {
              _id: '5d6615769bcb6d0e6d79f016',
              id: 66,
              frequency: 406264,
            },
            {
              _id: '5d6615769bcb6d0e6d79f015',
              id: 67,
              frequency: 23319,
            },
            {
              _id: '5d6615769bcb6d0e6d79f014',
              id: 68,
              frequency: 38899,
            },
            {
              _id: '5d6615769bcb6d0e6d79f013',
              id: 69,
              frequency: 1561,
            },
            {
              _id: '5d6615769bcb6d0e6d79f012',
              id: 70,
              frequency: 499066,
            },
            {
              _id: '5d6615769bcb6d0e6d79f011',
              id: 71,
              frequency: 130988,
            },
            {
              _id: '5d6615769bcb6d0e6d79f010',
              id: 72,
              frequency: 655909,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79ef6e',
          id: 45,
          abbrevName: '46',
          fullName: '46_L_Precuneous_pcc',
          coordinates: {
            x: -9.727599,
            y: -62.043011,
            z: 11.111111,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79ef9e',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef9d',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef9c',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef9b',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef9a',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef99',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef98',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef97',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef96',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef95',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef94',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef93',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef92',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef91',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef90',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef8f',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef8e',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef8d',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef8c',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef8b',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef8a',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef89',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef88',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef87',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef86',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef85',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef84',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef83',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef82',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef81',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef80',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef7f',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef7e',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef7d',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef7c',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef7b',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef7a',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef79',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef78',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef77',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef76',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef75',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef74',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef73',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef72',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef71',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef70',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef6f',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79efe7',
              id: 0,
              frequency: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79efe6',
              id: 1,
              frequency: 680,
            },
            {
              _id: '5d6615769bcb6d0e6d79efe5',
              id: 2,
              frequency: 458,
            },
            {
              _id: '5d6615769bcb6d0e6d79efe4',
              id: 3,
              frequency: 3028,
            },
            {
              _id: '5d6615769bcb6d0e6d79efe3',
              id: 4,
              frequency: 1122,
            },
            {
              _id: '5d6615769bcb6d0e6d79efe2',
              id: 5,
              frequency: 3915,
            },
            {
              _id: '5d6615769bcb6d0e6d79efe1',
              id: 6,
              frequency: 500,
            },
            {
              _id: '5d6615769bcb6d0e6d79efe0',
              id: 7,
              frequency: 264,
            },
            {
              _id: '5d6615769bcb6d0e6d79efdf',
              id: 8,
              frequency: 1215,
            },
            {
              _id: '5d6615769bcb6d0e6d79efde',
              id: 9,
              frequency: 2147,
            },
            {
              _id: '5d6615769bcb6d0e6d79efdd',
              id: 10,
              frequency: 13909,
            },
            {
              _id: '5d6615769bcb6d0e6d79efdc',
              id: 11,
              frequency: 7699,
            },
            {
              _id: '5d6615769bcb6d0e6d79efdb',
              id: 12,
              frequency: 18093,
            },
            {
              _id: '5d6615769bcb6d0e6d79efda',
              id: 13,
              frequency: 21366,
            },
            {
              _id: '5d6615769bcb6d0e6d79efd9',
              id: 14,
              frequency: 65955,
            },
            {
              _id: '5d6615769bcb6d0e6d79efd8',
              id: 15,
              frequency: 915,
            },
            {
              _id: '5d6615769bcb6d0e6d79efd7',
              id: 16,
              frequency: 3864,
            },
            {
              _id: '5d6615769bcb6d0e6d79efd6',
              id: 17,
              frequency: 6486,
            },
            {
              _id: '5d6615769bcb6d0e6d79efd5',
              id: 18,
              frequency: 197,
            },
            {
              _id: '5d6615769bcb6d0e6d79efd4',
              id: 19,
              frequency: 1168,
            },
            {
              _id: '5d6615769bcb6d0e6d79efd3',
              id: 20,
              frequency: 1643,
            },
            {
              _id: '5d6615769bcb6d0e6d79efd2',
              id: 21,
              frequency: 1814,
            },
            {
              _id: '5d6615769bcb6d0e6d79efd1',
              id: 22,
              frequency: 156,
            },
            {
              _id: '5d6615769bcb6d0e6d79efd0',
              id: 23,
              frequency: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d79efcf',
              id: 24,
              frequency: 1931,
            },
            {
              _id: '5d6615769bcb6d0e6d79efce',
              id: 25,
              frequency: 12706,
            },
            {
              _id: '5d6615769bcb6d0e6d79efcd',
              id: 26,
              frequency: 17818,
            },
            {
              _id: '5d6615769bcb6d0e6d79efcc',
              id: 27,
              frequency: 1109,
            },
            {
              _id: '5d6615769bcb6d0e6d79efcb',
              id: 28,
              frequency: 8208,
            },
            {
              _id: '5d6615769bcb6d0e6d79efca',
              id: 29,
              frequency: 14553,
            },
            {
              _id: '5d6615769bcb6d0e6d79efc9',
              id: 30,
              frequency: 21392,
            },
            {
              _id: '5d6615769bcb6d0e6d79efc8',
              id: 31,
              frequency: 1160,
            },
            {
              _id: '5d6615769bcb6d0e6d79efc7',
              id: 32,
              frequency: 5748,
            },
            {
              _id: '5d6615769bcb6d0e6d79efc6',
              id: 33,
              frequency: 1565,
            },
            {
              _id: '5d6615769bcb6d0e6d79efc5',
              id: 34,
              frequency: 897,
            },
            {
              _id: '5d6615769bcb6d0e6d79efc4',
              id: 35,
              frequency: 109,
            },
            {
              _id: '5d6615769bcb6d0e6d79efc3',
              id: 36,
              frequency: 711,
            },
            {
              _id: '5d6615769bcb6d0e6d79efc2',
              id: 37,
              frequency: 2319,
            },
            {
              _id: '5d6615769bcb6d0e6d79efc1',
              id: 38,
              frequency: 1454,
            },
            {
              _id: '5d6615769bcb6d0e6d79efc0',
              id: 39,
              frequency: 1002,
            },
            {
              _id: '5d6615769bcb6d0e6d79efbf',
              id: 40,
              frequency: 24138,
            },
            {
              _id: '5d6615769bcb6d0e6d79efbe',
              id: 41,
              frequency: 21568,
            },
            {
              _id: '5d6615769bcb6d0e6d79efbd',
              id: 42,
              frequency: 11600,
            },
            {
              _id: '5d6615769bcb6d0e6d79efbc',
              id: 43,
              frequency: 18358,
            },
            {
              _id: '5d6615769bcb6d0e6d79efbb',
              id: 44,
              frequency: 9599,
            },
            {
              _id: '5d6615769bcb6d0e6d79efba',
              id: 45,
              frequency: 2061,
            },
            {
              _id: '5d6615769bcb6d0e6d79efb9',
              id: 46,
              frequency: 11298,
            },
            {
              _id: '5d6615769bcb6d0e6d79efb8',
              id: 47,
              frequency: 35054,
            },
            {
              _id: '5d6615769bcb6d0e6d79efb7',
              id: 48,
              frequency: 68908,
            },
            {
              _id: '5d6615769bcb6d0e6d79efb6',
              id: 49,
              frequency: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79efb5',
              id: 50,
              frequency: 102,
            },
            {
              _id: '5d6615769bcb6d0e6d79efb4',
              id: 51,
              frequency: 4995,
            },
            {
              _id: '5d6615769bcb6d0e6d79efb3',
              id: 52,
              frequency: 3072,
            },
            {
              _id: '5d6615769bcb6d0e6d79efb2',
              id: 53,
              frequency: 11426,
            },
            {
              _id: '5d6615769bcb6d0e6d79efb1',
              id: 54,
              frequency: 3742,
            },
            {
              _id: '5d6615769bcb6d0e6d79efb0',
              id: 55,
              frequency: 6562,
            },
            {
              _id: '5d6615769bcb6d0e6d79efaf',
              id: 56,
              frequency: 4114,
            },
            {
              _id: '5d6615769bcb6d0e6d79efae',
              id: 57,
              frequency: 194956,
            },
            {
              _id: '5d6615769bcb6d0e6d79efad',
              id: 58,
              frequency: 63077,
            },
            {
              _id: '5d6615769bcb6d0e6d79efac',
              id: 59,
              frequency: 37758,
            },
            {
              _id: '5d6615769bcb6d0e6d79efab',
              id: 60,
              frequency: 103450,
            },
            {
              _id: '5d6615769bcb6d0e6d79efaa',
              id: 61,
              frequency: 47960,
            },
            {
              _id: '5d6615769bcb6d0e6d79efa9',
              id: 62,
              frequency: 2267,
            },
            {
              _id: '5d6615769bcb6d0e6d79efa8',
              id: 63,
              frequency: 10209,
            },
            {
              _id: '5d6615769bcb6d0e6d79efa7',
              id: 64,
              frequency: 10747,
            },
            {
              _id: '5d6615769bcb6d0e6d79efa6',
              id: 65,
              frequency: 52174,
            },
            {
              _id: '5d6615769bcb6d0e6d79efa5',
              id: 66,
              frequency: 242197,
            },
            {
              _id: '5d6615769bcb6d0e6d79efa4',
              id: 67,
              frequency: 273742,
            },
            {
              _id: '5d6615769bcb6d0e6d79efa3',
              id: 68,
              frequency: 55279,
            },
            {
              _id: '5d6615769bcb6d0e6d79efa2',
              id: 69,
              frequency: 14205,
            },
            {
              _id: '5d6615769bcb6d0e6d79efa1',
              id: 70,
              frequency: 327386,
            },
            {
              _id: '5d6615769bcb6d0e6d79efa0',
              id: 71,
              frequency: 499568,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef9f',
              id: 72,
              frequency: 1001600,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79eef3',
          id: 46,
          abbrevName: '47',
          fullName: '47_R_frontal_pole/MFG',
          coordinates: {
            x: 37.418182,
            y: 38.484848,
            z: 29.793939,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79ef24',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef23',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef22',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef21',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef20',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef1f',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef1e',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef1d',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef1c',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef1b',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef1a',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef19',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef18',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef17',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef16',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef15',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef14',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef13',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef12',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef11',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef10',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef0f',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef0e',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef0d',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef0c',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef0b',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef0a',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef09',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef08',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef07',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef06',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef05',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef04',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef03',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef02',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef01',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef00',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79eeff',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79eefe',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79eefd',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79eefc',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79eefb',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79eefa',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79eef9',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79eef8',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79eef7',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79eef6',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79eef5',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79eef4',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79ef6d',
              id: 0,
              frequency: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef6c',
              id: 1,
              frequency: 285,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef6b',
              id: 2,
              frequency: 479,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef6a',
              id: 3,
              frequency: 3437,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef69',
              id: 4,
              frequency: 953,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef68',
              id: 5,
              frequency: 2309,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef67',
              id: 6,
              frequency: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef66',
              id: 7,
              frequency: 304,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef65',
              id: 8,
              frequency: 354,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef64',
              id: 9,
              frequency: 485,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef63',
              id: 10,
              frequency: 11245,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef62',
              id: 11,
              frequency: 7444,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef61',
              id: 12,
              frequency: 5409,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef60',
              id: 13,
              frequency: 25873,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef5f',
              id: 14,
              frequency: 79943,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef5e',
              id: 15,
              frequency: 307,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef5d',
              id: 16,
              frequency: 5127,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef5c',
              id: 17,
              frequency: 528,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef5b',
              id: 18,
              frequency: 665,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef5a',
              id: 19,
              frequency: 156,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef59',
              id: 20,
              frequency: 745,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef58',
              id: 21,
              frequency: 1594,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef57',
              id: 22,
              frequency: 12,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef56',
              id: 23,
              frequency: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef55',
              id: 24,
              frequency: 573,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef54',
              id: 25,
              frequency: 1213,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef53',
              id: 26,
              frequency: 15982,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef52',
              id: 27,
              frequency: 1251,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef51',
              id: 28,
              frequency: 3550,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef50',
              id: 29,
              frequency: 28957,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef4f',
              id: 30,
              frequency: 14994,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef4e',
              id: 31,
              frequency: 116,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef4d',
              id: 32,
              frequency: 3103,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef4c',
              id: 33,
              frequency: 1948,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef4b',
              id: 34,
              frequency: 541,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef4a',
              id: 35,
              frequency: 14,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef49',
              id: 36,
              frequency: 798,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef48',
              id: 37,
              frequency: 226,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef47',
              id: 38,
              frequency: 490,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef46',
              id: 39,
              frequency: 160,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef45',
              id: 40,
              frequency: 3000,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef44',
              id: 41,
              frequency: 20511,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef43',
              id: 42,
              frequency: 11877,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef42',
              id: 43,
              frequency: 12856,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef41',
              id: 44,
              frequency: 9185,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef40',
              id: 45,
              frequency: 923,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef3f',
              id: 46,
              frequency: 14414,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef3e',
              id: 47,
              frequency: 9988,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef3d',
              id: 48,
              frequency: 73722,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef3c',
              id: 49,
              frequency: 1,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef3b',
              id: 50,
              frequency: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef3a',
              id: 51,
              frequency: 1290,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef39',
              id: 52,
              frequency: 1771,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef38',
              id: 53,
              frequency: 5909,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef37',
              id: 54,
              frequency: 290,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef36',
              id: 55,
              frequency: 10291,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef35',
              id: 56,
              frequency: 530,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef34',
              id: 57,
              frequency: 234250,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef33',
              id: 58,
              frequency: 47870,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef32',
              id: 59,
              frequency: 13442,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef31',
              id: 60,
              frequency: 51138,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef30',
              id: 61,
              frequency: 51618,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef2f',
              id: 62,
              frequency: 254,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef2e',
              id: 63,
              frequency: 2141,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef2d',
              id: 64,
              frequency: 6991,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef2c',
              id: 65,
              frequency: 5517,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef2b',
              id: 66,
              frequency: 154030,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef2a',
              id: 67,
              frequency: 328948,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef29',
              id: 68,
              frequency: 13027,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef28',
              id: 69,
              frequency: 20304,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef27',
              id: 70,
              frequency: 75744,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef26',
              id: 71,
              frequency: 669990,
            },
            {
              _id: '5d6615769bcb6d0e6d79ef25',
              id: 72,
              frequency: 1289575,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79eea6',
          id: 47,
          abbrevName: '48',
          fullName:
            '48_L_Temporal_fusiform_cortex_anterior__temporal_fusiform_posterior',
          coordinates: {
            x: -31.82069,
            y: 2.027586,
            z: -41.02069,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79eea9',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79eea8',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79eea7',
              to: 88,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79eef2',
              id: 0,
              frequency: 11,
            },
            {
              _id: '5d6615769bcb6d0e6d79eef1',
              id: 1,
              frequency: 587,
            },
            {
              _id: '5d6615769bcb6d0e6d79eef0',
              id: 2,
              frequency: 2,
            },
            {
              _id: '5d6615769bcb6d0e6d79eeef',
              id: 3,
              frequency: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79eeee',
              id: 4,
              frequency: 10925,
            },
            {
              _id: '5d6615769bcb6d0e6d79eeed',
              id: 5,
              frequency: 119,
            },
            {
              _id: '5d6615769bcb6d0e6d79eeec',
              id: 6,
              frequency: 2163,
            },
            {
              _id: '5d6615769bcb6d0e6d79eeeb',
              id: 7,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79eeea',
              id: 8,
              frequency: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d79eee9',
              id: 9,
              frequency: 16180,
            },
            {
              _id: '5d6615769bcb6d0e6d79eee8',
              id: 10,
              frequency: 1935,
            },
            {
              _id: '5d6615769bcb6d0e6d79eee7',
              id: 11,
              frequency: 1,
            },
            {
              _id: '5d6615769bcb6d0e6d79eee6',
              id: 12,
              frequency: 1878,
            },
            {
              _id: '5d6615769bcb6d0e6d79eee5',
              id: 13,
              frequency: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d79eee4',
              id: 14,
              frequency: 148,
            },
            {
              _id: '5d6615769bcb6d0e6d79eee3',
              id: 15,
              frequency: 51499,
            },
            {
              _id: '5d6615769bcb6d0e6d79eee2',
              id: 16,
              frequency: 1152,
            },
            {
              _id: '5d6615769bcb6d0e6d79eee1',
              id: 17,
              frequency: 272,
            },
            {
              _id: '5d6615769bcb6d0e6d79eee0',
              id: 18,
              frequency: 15577,
            },
            {
              _id: '5d6615769bcb6d0e6d79eedf',
              id: 19,
              frequency: 21728,
            },
            {
              _id: '5d6615769bcb6d0e6d79eede',
              id: 20,
              frequency: 236,
            },
            {
              _id: '5d6615769bcb6d0e6d79eedd',
              id: 21,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79eedc',
              id: 22,
              frequency: 1861,
            },
            {
              _id: '5d6615769bcb6d0e6d79eedb',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79eeda',
              id: 24,
              frequency: 73549,
            },
            {
              _id: '5d6615769bcb6d0e6d79eed9',
              id: 25,
              frequency: 2145,
            },
            {
              _id: '5d6615769bcb6d0e6d79eed8',
              id: 26,
              frequency: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d79eed7',
              id: 27,
              frequency: 166524,
            },
            {
              _id: '5d6615769bcb6d0e6d79eed6',
              id: 28,
              frequency: 2493,
            },
            {
              _id: '5d6615769bcb6d0e6d79eed5',
              id: 29,
              frequency: 22237,
            },
            {
              _id: '5d6615769bcb6d0e6d79eed4',
              id: 30,
              frequency: 4,
            },
            {
              _id: '5d6615769bcb6d0e6d79eed3',
              id: 31,
              frequency: 32676,
            },
            {
              _id: '5d6615769bcb6d0e6d79eed2',
              id: 32,
              frequency: 3404,
            },
            {
              _id: '5d6615769bcb6d0e6d79eed1',
              id: 33,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79eed0',
              id: 34,
              frequency: 522,
            },
            {
              _id: '5d6615769bcb6d0e6d79eecf',
              id: 35,
              frequency: 10816,
            },
            {
              _id: '5d6615769bcb6d0e6d79eece',
              id: 36,
              frequency: 197,
            },
            {
              _id: '5d6615769bcb6d0e6d79eecd',
              id: 37,
              frequency: 327,
            },
            {
              _id: '5d6615769bcb6d0e6d79eecc',
              id: 38,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79eecb',
              id: 39,
              frequency: 77071,
            },
            {
              _id: '5d6615769bcb6d0e6d79eeca',
              id: 40,
              frequency: 10569,
            },
            {
              _id: '5d6615769bcb6d0e6d79eec9',
              id: 41,
              frequency: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79eec8',
              id: 42,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79eec7',
              id: 43,
              frequency: 31826,
            },
            {
              _id: '5d6615769bcb6d0e6d79eec6',
              id: 44,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79eec5',
              id: 45,
              frequency: 191243,
            },
            {
              _id: '5d6615769bcb6d0e6d79eec4',
              id: 46,
              frequency: 14265,
            },
            {
              _id: '5d6615769bcb6d0e6d79eec3',
              id: 47,
              frequency: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d79eec2',
              id: 48,
              frequency: 383,
            },
            {
              _id: '5d6615769bcb6d0e6d79eec1',
              id: 49,
              frequency: 6,
            },
            {
              _id: '5d6615769bcb6d0e6d79eec0',
              id: 50,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79eebf',
              id: 51,
              frequency: 1523,
            },
            {
              _id: '5d6615769bcb6d0e6d79eebe',
              id: 52,
              frequency: 3330,
            },
            {
              _id: '5d6615769bcb6d0e6d79eebd',
              id: 53,
              frequency: 10,
            },
            {
              _id: '5d6615769bcb6d0e6d79eebc',
              id: 54,
              frequency: 3541,
            },
            {
              _id: '5d6615769bcb6d0e6d79eebb',
              id: 55,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79eeba',
              id: 56,
              frequency: 301922,
            },
            {
              _id: '5d6615769bcb6d0e6d79eeb9',
              id: 57,
              frequency: 3448,
            },
            {
              _id: '5d6615769bcb6d0e6d79eeb8',
              id: 58,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79eeb7',
              id: 59,
              frequency: 47710,
            },
            {
              _id: '5d6615769bcb6d0e6d79eeb6',
              id: 60,
              frequency: 569,
            },
            {
              _id: '5d6615769bcb6d0e6d79eeb5',
              id: 61,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79eeb4',
              id: 62,
              frequency: 229,
            },
            {
              _id: '5d6615769bcb6d0e6d79eeb3',
              id: 63,
              frequency: 10,
            },
            {
              _id: '5d6615769bcb6d0e6d79eeb2',
              id: 64,
              frequency: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79eeb1',
              id: 65,
              frequency: 38895,
            },
            {
              _id: '5d6615769bcb6d0e6d79eeb0',
              id: 66,
              frequency: 4630,
            },
            {
              _id: '5d6615769bcb6d0e6d79eeaf',
              id: 67,
              frequency: 8,
            },
            {
              _id: '5d6615769bcb6d0e6d79eeae',
              id: 68,
              frequency: 199,
            },
            {
              _id: '5d6615769bcb6d0e6d79eead',
              id: 69,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79eeac',
              id: 70,
              frequency: 3752,
            },
            {
              _id: '5d6615769bcb6d0e6d79eeab',
              id: 71,
              frequency: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79eeaa',
              id: 72,
              frequency: 266,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79ee2d',
          id: 48,
          abbrevName: '49',
          fullName: '49_R_ITG_temporooccipital',
          coordinates: {
            x: 52.654028,
            y: -51.516588,
            z: -14.540284,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79ee5c',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee5b',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee5a',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee59',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee58',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee57',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee56',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee55',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee54',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee53',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee52',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee51',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee50',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee4f',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee4e',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee4d',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee4c',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee4b',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee4a',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee49',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee48',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee47',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee46',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee45',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee44',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee43',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee42',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee41',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee40',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee3f',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee3e',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee3d',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee3c',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee3b',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee3a',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee39',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee38',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee37',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee36',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee35',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee34',
              to: 93,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee33',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee32',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee31',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee30',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee2f',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee2e',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79eea5',
              id: 0,
              frequency: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79eea4',
              id: 1,
              frequency: 273,
            },
            {
              _id: '5d6615769bcb6d0e6d79eea3',
              id: 2,
              frequency: 721,
            },
            {
              _id: '5d6615769bcb6d0e6d79eea2',
              id: 3,
              frequency: 3465,
            },
            {
              _id: '5d6615769bcb6d0e6d79eea1',
              id: 4,
              frequency: 332,
            },
            {
              _id: '5d6615769bcb6d0e6d79eea0',
              id: 5,
              frequency: 2792,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee9f',
              id: 6,
              frequency: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee9e',
              id: 7,
              frequency: 1267,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee9d',
              id: 8,
              frequency: 609,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee9c',
              id: 9,
              frequency: 303,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee9b',
              id: 10,
              frequency: 7491,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee9a',
              id: 11,
              frequency: 15650,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee99',
              id: 12,
              frequency: 6671,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee98',
              id: 13,
              frequency: 29789,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee97',
              id: 14,
              frequency: 78874,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee96',
              id: 15,
              frequency: 192,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee95',
              id: 16,
              frequency: 1727,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee94',
              id: 17,
              frequency: 1058,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee93',
              id: 18,
              frequency: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee92',
              id: 19,
              frequency: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee91',
              id: 20,
              frequency: 927,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee90',
              id: 21,
              frequency: 5109,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee8f',
              id: 22,
              frequency: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee8e',
              id: 23,
              frequency: 775,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee8d',
              id: 24,
              frequency: 192,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee8c',
              id: 25,
              frequency: 1523,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee8b',
              id: 26,
              frequency: 20873,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee8a',
              id: 27,
              frequency: 156,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee89',
              id: 28,
              frequency: 2370,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee88',
              id: 29,
              frequency: 6637,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee87',
              id: 30,
              frequency: 24613,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee86',
              id: 31,
              frequency: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee85',
              id: 32,
              frequency: 1662,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee84',
              id: 33,
              frequency: 16152,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee83',
              id: 34,
              frequency: 454,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee82',
              id: 35,
              frequency: 5,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee81',
              id: 36,
              frequency: 310,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee80',
              id: 37,
              frequency: 607,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee7f',
              id: 38,
              frequency: 1814,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee7e',
              id: 39,
              frequency: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee7d',
              id: 40,
              frequency: 3752,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee7c',
              id: 41,
              frequency: 13119,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee7b',
              id: 42,
              frequency: 58195,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee7a',
              id: 43,
              frequency: 4395,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee79',
              id: 44,
              frequency: 17987,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee78',
              id: 45,
              frequency: 207,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee77',
              id: 46,
              frequency: 5403,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee76',
              id: 47,
              frequency: 21537,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee75',
              id: 48,
              frequency: 54422,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee74',
              id: 49,
              frequency: 6,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee73',
              id: 50,
              frequency: 170,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee72',
              id: 51,
              frequency: 1341,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee71',
              id: 52,
              frequency: 563,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee70',
              id: 53,
              frequency: 10370,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee6f',
              id: 54,
              frequency: 342,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee6e',
              id: 55,
              frequency: 19164,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee6d',
              id: 56,
              frequency: 164,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee6c',
              id: 57,
              frequency: 128983,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee6b',
              id: 58,
              frequency: 186512,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee6a',
              id: 59,
              frequency: 7047,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee69',
              id: 60,
              frequency: 59469,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee68',
              id: 61,
              frequency: 88504,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee67',
              id: 62,
              frequency: 316,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee66',
              id: 63,
              frequency: 6323,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee65',
              id: 64,
              frequency: 5445,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee64',
              id: 65,
              frequency: 5894,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee63',
              id: 66,
              frequency: 116981,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee62',
              id: 67,
              frequency: 435664,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee61',
              id: 68,
              frequency: 24025,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee60',
              id: 69,
              frequency: 22807,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee5f',
              id: 70,
              frequency: 116010,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee5e',
              id: 71,
              frequency: 697985,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee5d',
              id: 72,
              frequency: 1250410,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79edbd',
          id: 49,
          abbrevName: '50',
          fullName: '50_R_SPL_angular',
          coordinates: {
            x: 41.555556,
            y: -49.62963,
            z: 49.62963,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79ede3',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79ede2',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79ede1',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79ede0',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79eddf',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79edde',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79eddd',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79eddc',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79eddb',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79edda',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79edd9',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79edd8',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79edd7',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79edd6',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79edd5',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79edd4',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79edd3',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79edd2',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79edd1',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79edd0',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79edcf',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79edce',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79edcd',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79edcc',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79edcb',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79edca',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79edc9',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79edc8',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79edc7',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79edc6',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79edc5',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79edc4',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79edc3',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79edc2',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79edc1',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79edc0',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79edbf',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79edbe',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79ee2c',
              id: 0,
              frequency: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee2b',
              id: 1,
              frequency: 992,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee2a',
              id: 2,
              frequency: 248,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee29',
              id: 3,
              frequency: 2602,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee28',
              id: 4,
              frequency: 4983,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee27',
              id: 5,
              frequency: 2594,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee26',
              id: 6,
              frequency: 879,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee25',
              id: 7,
              frequency: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee24',
              id: 8,
              frequency: 1725,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee23',
              id: 9,
              frequency: 5680,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee22',
              id: 10,
              frequency: 17358,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee21',
              id: 11,
              frequency: 2810,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee20',
              id: 12,
              frequency: 25499,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee1f',
              id: 13,
              frequency: 12552,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee1e',
              id: 14,
              frequency: 54878,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee1d',
              id: 15,
              frequency: 7514,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee1c',
              id: 16,
              frequency: 7045,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee1b',
              id: 17,
              frequency: 1992,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee1a',
              id: 18,
              frequency: 4818,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee19',
              id: 19,
              frequency: 3635,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee18',
              id: 20,
              frequency: 1470,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee17',
              id: 21,
              frequency: 512,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee16',
              id: 22,
              frequency: 141,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee15',
              id: 23,
              frequency: 6,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee14',
              id: 24,
              frequency: 18690,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee13',
              id: 25,
              frequency: 8062,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee12',
              id: 26,
              frequency: 8019,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee11',
              id: 27,
              frequency: 10180,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee10',
              id: 28,
              frequency: 7918,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee0f',
              id: 29,
              frequency: 57517,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee0e',
              id: 30,
              frequency: 10453,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee0d',
              id: 31,
              frequency: 2414,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee0c',
              id: 32,
              frequency: 7968,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee0b',
              id: 33,
              frequency: 177,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee0a',
              id: 34,
              frequency: 2013,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee09',
              id: 35,
              frequency: 936,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee08',
              id: 36,
              frequency: 4039,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee07',
              id: 37,
              frequency: 3264,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee06',
              id: 38,
              frequency: 445,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee05',
              id: 39,
              frequency: 7152,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee04',
              id: 40,
              frequency: 34295,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee03',
              id: 41,
              frequency: 15279,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee02',
              id: 42,
              frequency: 1835,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee01',
              id: 43,
              frequency: 36959,
            },
            {
              _id: '5d6615769bcb6d0e6d79ee00',
              id: 44,
              frequency: 2298,
            },
            {
              _id: '5d6615769bcb6d0e6d79edff',
              id: 45,
              frequency: 16880,
            },
            {
              _id: '5d6615769bcb6d0e6d79edfe',
              id: 46,
              frequency: 75453,
            },
            {
              _id: '5d6615769bcb6d0e6d79edfd',
              id: 47,
              frequency: 10252,
            },
            {
              _id: '5d6615769bcb6d0e6d79edfc',
              id: 48,
              frequency: 50608,
            },
            {
              _id: '5d6615769bcb6d0e6d79edfb',
              id: 49,
              frequency: 347,
            },
            {
              _id: '5d6615769bcb6d0e6d79edfa',
              id: 50,
              frequency: 200,
            },
            {
              _id: '5d6615769bcb6d0e6d79edf9',
              id: 51,
              frequency: 13113,
            },
            {
              _id: '5d6615769bcb6d0e6d79edf8',
              id: 52,
              frequency: 8076,
            },
            {
              _id: '5d6615769bcb6d0e6d79edf7',
              id: 53,
              frequency: 10297,
            },
            {
              _id: '5d6615769bcb6d0e6d79edf6',
              id: 54,
              frequency: 9117,
            },
            {
              _id: '5d6615769bcb6d0e6d79edf5',
              id: 55,
              frequency: 2167,
            },
            {
              _id: '5d6615769bcb6d0e6d79edf4',
              id: 56,
              frequency: 18796,
            },
            {
              _id: '5d6615769bcb6d0e6d79edf3',
              id: 57,
              frequency: 235410,
            },
            {
              _id: '5d6615769bcb6d0e6d79edf2',
              id: 58,
              frequency: 13825,
            },
            {
              _id: '5d6615769bcb6d0e6d79edf1',
              id: 59,
              frequency: 116888,
            },
            {
              _id: '5d6615769bcb6d0e6d79edf0',
              id: 60,
              frequency: 79708,
            },
            {
              _id: '5d6615769bcb6d0e6d79edef',
              id: 61,
              frequency: 14706,
            },
            {
              _id: '5d6615769bcb6d0e6d79edee',
              id: 62,
              frequency: 6122,
            },
            {
              _id: '5d6615769bcb6d0e6d79eded',
              id: 63,
              frequency: 13992,
            },
            {
              _id: '5d6615769bcb6d0e6d79edec',
              id: 64,
              frequency: 12145,
            },
            {
              _id: '5d6615769bcb6d0e6d79edeb',
              id: 65,
              frequency: 119439,
            },
            {
              _id: '5d6615769bcb6d0e6d79edea',
              id: 66,
              frequency: 305096,
            },
            {
              _id: '5d6615769bcb6d0e6d79ede9',
              id: 67,
              frequency: 121027,
            },
            {
              _id: '5d6615769bcb6d0e6d79ede8',
              id: 68,
              frequency: 76179,
            },
            {
              _id: '5d6615769bcb6d0e6d79ede7',
              id: 69,
              frequency: 6129,
            },
            {
              _id: '5d6615769bcb6d0e6d79ede6',
              id: 70,
              frequency: 441840,
            },
            {
              _id: '5d6615769bcb6d0e6d79ede5',
              id: 71,
              frequency: 305989,
            },
            {
              _id: '5d6615769bcb6d0e6d79ede4',
              id: 72,
              frequency: 814816,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79ed51',
          id: 50,
          abbrevName: '51',
          fullName: '51_R_Pallidum',
          coordinates: {
            x: 27.306931,
            y: -2,
            z: 1.762376,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79ed73',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed72',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed71',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed70',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed6f',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed6e',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed6d',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed6c',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed6b',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed6a',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed69',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed68',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed67',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed66',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed65',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed64',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed63',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed62',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed61',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed60',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed5f',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed5e',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed5d',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed5c',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed5b',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed5a',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed59',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed58',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed57',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed56',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed55',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed54',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed53',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed52',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79edbc',
              id: 0,
              frequency: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79edbb',
              id: 1,
              frequency: 1117,
            },
            {
              _id: '5d6615769bcb6d0e6d79edba',
              id: 2,
              frequency: 184,
            },
            {
              _id: '5d6615769bcb6d0e6d79edb9',
              id: 3,
              frequency: 2444,
            },
            {
              _id: '5d6615769bcb6d0e6d79edb8',
              id: 4,
              frequency: 4894,
            },
            {
              _id: '5d6615769bcb6d0e6d79edb7',
              id: 5,
              frequency: 2630,
            },
            {
              _id: '5d6615769bcb6d0e6d79edb6',
              id: 6,
              frequency: 1503,
            },
            {
              _id: '5d6615769bcb6d0e6d79edb5',
              id: 7,
              frequency: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79edb4',
              id: 8,
              frequency: 1305,
            },
            {
              _id: '5d6615769bcb6d0e6d79edb3',
              id: 9,
              frequency: 7477,
            },
            {
              _id: '5d6615769bcb6d0e6d79edb2',
              id: 10,
              frequency: 20354,
            },
            {
              _id: '5d6615769bcb6d0e6d79edb1',
              id: 11,
              frequency: 1805,
            },
            {
              _id: '5d6615769bcb6d0e6d79edb0',
              id: 12,
              frequency: 27415,
            },
            {
              _id: '5d6615769bcb6d0e6d79edaf',
              id: 13,
              frequency: 9292,
            },
            {
              _id: '5d6615769bcb6d0e6d79edae',
              id: 14,
              frequency: 51045,
            },
            {
              _id: '5d6615769bcb6d0e6d79edad',
              id: 15,
              frequency: 8455,
            },
            {
              _id: '5d6615769bcb6d0e6d79edac',
              id: 16,
              frequency: 4947,
            },
            {
              _id: '5d6615769bcb6d0e6d79edab',
              id: 17,
              frequency: 3500,
            },
            {
              _id: '5d6615769bcb6d0e6d79edaa',
              id: 18,
              frequency: 3603,
            },
            {
              _id: '5d6615769bcb6d0e6d79eda9',
              id: 19,
              frequency: 5570,
            },
            {
              _id: '5d6615769bcb6d0e6d79eda8',
              id: 20,
              frequency: 2730,
            },
            {
              _id: '5d6615769bcb6d0e6d79eda7',
              id: 21,
              frequency: 643,
            },
            {
              _id: '5d6615769bcb6d0e6d79eda6',
              id: 22,
              frequency: 610,
            },
            {
              _id: '5d6615769bcb6d0e6d79eda5',
              id: 23,
              frequency: 1,
            },
            {
              _id: '5d6615769bcb6d0e6d79eda4',
              id: 24,
              frequency: 18412,
            },
            {
              _id: '5d6615769bcb6d0e6d79eda3',
              id: 25,
              frequency: 12455,
            },
            {
              _id: '5d6615769bcb6d0e6d79eda2',
              id: 26,
              frequency: 6698,
            },
            {
              _id: '5d6615769bcb6d0e6d79eda1',
              id: 27,
              frequency: 12313,
            },
            {
              _id: '5d6615769bcb6d0e6d79eda0',
              id: 28,
              frequency: 10477,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed9f',
              id: 29,
              frequency: 57597,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed9e',
              id: 30,
              frequency: 8579,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed9d',
              id: 31,
              frequency: 6390,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed9c',
              id: 32,
              frequency: 13973,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed9b',
              id: 33,
              frequency: 164,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed9a',
              id: 34,
              frequency: 2108,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed99',
              id: 35,
              frequency: 1374,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed98',
              id: 36,
              frequency: 1878,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed97',
              id: 37,
              frequency: 4371,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed96',
              id: 38,
              frequency: 520,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed95',
              id: 39,
              frequency: 10680,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed94',
              id: 40,
              frequency: 52262,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed93',
              id: 41,
              frequency: 11755,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed92',
              id: 42,
              frequency: 1476,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed91',
              id: 43,
              frequency: 61601,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed90',
              id: 44,
              frequency: 1106,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed8f',
              id: 45,
              frequency: 18969,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed8e',
              id: 46,
              frequency: 58202,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed8d',
              id: 47,
              frequency: 10783,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed8c',
              id: 48,
              frequency: 51949,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed8b',
              id: 49,
              frequency: 489,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed8a',
              id: 50,
              frequency: 162,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed89',
              id: 51,
              frequency: 12232,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed88',
              id: 52,
              frequency: 9744,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed87',
              id: 53,
              frequency: 7672,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed86',
              id: 54,
              frequency: 16951,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed85',
              id: 55,
              frequency: 1972,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed84',
              id: 56,
              frequency: 30669,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed83',
              id: 57,
              frequency: 249283,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed82',
              id: 58,
              frequency: 8648,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed81',
              id: 59,
              frequency: 133728,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed80',
              id: 60,
              frequency: 79361,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed7f',
              id: 61,
              frequency: 7289,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed7e',
              id: 62,
              frequency: 5021,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed7d',
              id: 63,
              frequency: 8391,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed7c',
              id: 64,
              frequency: 12910,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed7b',
              id: 65,
              frequency: 155132,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed7a',
              id: 66,
              frequency: 375779,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed79',
              id: 67,
              frequency: 78124,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed78',
              id: 68,
              frequency: 54285,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed77',
              id: 69,
              frequency: 3561,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed76',
              id: 70,
              frequency: 454527,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed75',
              id: 71,
              frequency: 228989,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed74',
              id: 72,
              frequency: 757100,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79ecda',
          id: 51,
          abbrevName: '52',
          fullName: '52_L_Occipital_pole',
          coordinates: {
            x: -15.835749,
            y: -97.536232,
            z: -2.144928,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79ed07',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed06',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed05',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed04',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed03',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed02',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed01',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed00',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecff',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecfe',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecfd',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecfc',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecfb',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecfa',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecf9',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecf8',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecf7',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecf6',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecf5',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecf4',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecf3',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecf2',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecf1',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecf0',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecef',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecee',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79eced',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecec',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79eceb',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecea',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79ece9',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79ece8',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79ece7',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79ece6',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79ece5',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79ece4',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79ece3',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79ece2',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79ece1',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79ece0',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecdf',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecde',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecdd',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecdc',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecdb',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79ed50',
              id: 0,
              frequency: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed4f',
              id: 1,
              frequency: 227,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed4e',
              id: 2,
              frequency: 582,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed4d',
              id: 3,
              frequency: 3513,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed4c',
              id: 4,
              frequency: 270,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed4b',
              id: 5,
              frequency: 2343,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed4a',
              id: 6,
              frequency: 153,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed49',
              id: 7,
              frequency: 517,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed48',
              id: 8,
              frequency: 353,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed47',
              id: 9,
              frequency: 124,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed46',
              id: 10,
              frequency: 8677,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed45',
              id: 11,
              frequency: 10605,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed44',
              id: 12,
              frequency: 4352,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed43',
              id: 13,
              frequency: 29037,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed42',
              id: 14,
              frequency: 81326,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed41',
              id: 15,
              frequency: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed40',
              id: 16,
              frequency: 1587,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed3f',
              id: 17,
              frequency: 1557,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed3e',
              id: 18,
              frequency: 113,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed3d',
              id: 19,
              frequency: 251,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed3c',
              id: 20,
              frequency: 1284,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed3b',
              id: 21,
              frequency: 2344,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed3a',
              id: 22,
              frequency: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed39',
              id: 23,
              frequency: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed38',
              id: 24,
              frequency: 117,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed37',
              id: 25,
              frequency: 3642,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed36',
              id: 26,
              frequency: 15793,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed35',
              id: 27,
              frequency: 153,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed34',
              id: 28,
              frequency: 1520,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed33',
              id: 29,
              frequency: 9538,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed32',
              id: 30,
              frequency: 22603,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed31',
              id: 31,
              frequency: 111,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed30',
              id: 32,
              frequency: 3422,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed2f',
              id: 33,
              frequency: 4203,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed2e',
              id: 34,
              frequency: 200,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed2d',
              id: 35,
              frequency: 5,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed2c',
              id: 36,
              frequency: 297,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed2b',
              id: 37,
              frequency: 712,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed2a',
              id: 38,
              frequency: 720,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed29',
              id: 39,
              frequency: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed28',
              id: 40,
              frequency: 6032,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed27',
              id: 41,
              frequency: 17018,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed26',
              id: 42,
              frequency: 22590,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed25',
              id: 43,
              frequency: 3965,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed24',
              id: 44,
              frequency: 13980,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed23',
              id: 45,
              frequency: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed22',
              id: 46,
              frequency: 3654,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed21',
              id: 47,
              frequency: 11271,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed20',
              id: 48,
              frequency: 66819,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed1f',
              id: 49,
              frequency: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed1e',
              id: 50,
              frequency: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed1d',
              id: 51,
              frequency: 513,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed1c',
              id: 52,
              frequency: 531,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed1b',
              id: 53,
              frequency: 6931,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed1a',
              id: 54,
              frequency: 1112,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed19',
              id: 55,
              frequency: 14192,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed18',
              id: 56,
              frequency: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed17',
              id: 57,
              frequency: 184875,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed16',
              id: 58,
              frequency: 90307,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed15',
              id: 59,
              frequency: 3298,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed14',
              id: 60,
              frequency: 45108,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed13',
              id: 61,
              frequency: 75107,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed12',
              id: 62,
              frequency: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed11',
              id: 63,
              frequency: 2664,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed10',
              id: 64,
              frequency: 5877,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed0f',
              id: 65,
              frequency: 897,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed0e',
              id: 66,
              frequency: 111031,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed0d',
              id: 67,
              frequency: 402599,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed0c',
              id: 68,
              frequency: 12345,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed0b',
              id: 69,
              frequency: 22621,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed0a',
              id: 70,
              frequency: 64188,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed09',
              id: 71,
              frequency: 722097,
            },
            {
              _id: '5d6615769bcb6d0e6d79ed08',
              id: 72,
              frequency: 1304897,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79ec65',
          id: 52,
          abbrevName: '53',
          fullName: '53_L_SPL',
          coordinates: {
            x: -12.327869,
            y: -49.606557,
            z: 64.245902,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79ec90',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec8f',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec8e',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec8d',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec8c',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec8b',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec8a',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec89',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec88',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec87',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec86',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec85',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec84',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec83',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec82',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec81',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec80',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec7f',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec7e',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec7d',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec7c',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec7b',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec7a',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec79',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec78',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec77',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec76',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec75',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec74',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec73',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec72',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec71',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec70',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec6f',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec6e',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec6d',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec6c',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec6b',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec6a',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec69',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec68',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec67',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec66',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79ecd9',
              id: 0,
              frequency: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecd8',
              id: 1,
              frequency: 240,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecd7',
              id: 2,
              frequency: 516,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecd6',
              id: 3,
              frequency: 3489,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecd5',
              id: 4,
              frequency: 638,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecd4',
              id: 5,
              frequency: 2198,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecd3',
              id: 6,
              frequency: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecd2',
              id: 7,
              frequency: 441,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecd1',
              id: 8,
              frequency: 424,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecd0',
              id: 9,
              frequency: 342,
            },
            {
              _id: '5d6615769bcb6d0e6d79eccf',
              id: 10,
              frequency: 9920,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecce',
              id: 11,
              frequency: 8315,
            },
            {
              _id: '5d6615769bcb6d0e6d79eccd',
              id: 12,
              frequency: 4197,
            },
            {
              _id: '5d6615769bcb6d0e6d79eccc',
              id: 13,
              frequency: 27455,
            },
            {
              _id: '5d6615769bcb6d0e6d79eccb',
              id: 14,
              frequency: 81269,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecca',
              id: 15,
              frequency: 344,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecc9',
              id: 16,
              frequency: 3640,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecc8',
              id: 17,
              frequency: 428,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecc7',
              id: 18,
              frequency: 512,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecc6',
              id: 19,
              frequency: 111,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecc5',
              id: 20,
              frequency: 811,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecc4',
              id: 21,
              frequency: 2080,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecc3',
              id: 22,
              frequency: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecc2',
              id: 23,
              frequency: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecc1',
              id: 24,
              frequency: 515,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecc0',
              id: 25,
              frequency: 876,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecbf',
              id: 26,
              frequency: 14238,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecbe',
              id: 27,
              frequency: 535,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecbd',
              id: 28,
              frequency: 2927,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecbc',
              id: 29,
              frequency: 20990,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecbb',
              id: 30,
              frequency: 16717,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecba',
              id: 31,
              frequency: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecb9',
              id: 32,
              frequency: 3096,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecb8',
              id: 33,
              frequency: 3116,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecb7',
              id: 34,
              frequency: 321,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecb6',
              id: 35,
              frequency: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecb5',
              id: 36,
              frequency: 797,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecb4',
              id: 37,
              frequency: 390,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecb3',
              id: 38,
              frequency: 748,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecb2',
              id: 39,
              frequency: 164,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecb1',
              id: 40,
              frequency: 2693,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecb0',
              id: 41,
              frequency: 16186,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecaf',
              id: 42,
              frequency: 17367,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecae',
              id: 43,
              frequency: 10155,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecad',
              id: 44,
              frequency: 10605,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecac',
              id: 45,
              frequency: 410,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecab',
              id: 46,
              frequency: 9109,
            },
            {
              _id: '5d6615769bcb6d0e6d79ecaa',
              id: 47,
              frequency: 8975,
            },
            {
              _id: '5d6615769bcb6d0e6d79eca9',
              id: 48,
              frequency: 75571,
            },
            {
              _id: '5d6615769bcb6d0e6d79eca8',
              id: 49,
              frequency: 5,
            },
            {
              _id: '5d6615769bcb6d0e6d79eca7',
              id: 50,
              frequency: 125,
            },
            {
              _id: '5d6615769bcb6d0e6d79eca6',
              id: 51,
              frequency: 1246,
            },
            {
              _id: '5d6615769bcb6d0e6d79eca5',
              id: 52,
              frequency: 903,
            },
            {
              _id: '5d6615769bcb6d0e6d79eca4',
              id: 53,
              frequency: 6146,
            },
            {
              _id: '5d6615769bcb6d0e6d79eca3',
              id: 54,
              frequency: 327,
            },
            {
              _id: '5d6615769bcb6d0e6d79eca2',
              id: 55,
              frequency: 14544,
            },
            {
              _id: '5d6615769bcb6d0e6d79eca1',
              id: 56,
              frequency: 281,
            },
            {
              _id: '5d6615769bcb6d0e6d79eca0',
              id: 57,
              frequency: 220740,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec9f',
              id: 58,
              frequency: 53967,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec9e',
              id: 59,
              frequency: 8646,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec9d',
              id: 60,
              frequency: 40429,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec9c',
              id: 61,
              frequency: 58320,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec9b',
              id: 62,
              frequency: 218,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec9a',
              id: 63,
              frequency: 3623,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec99',
              id: 64,
              frequency: 8149,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec98',
              id: 65,
              frequency: 3514,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec97',
              id: 66,
              frequency: 123213,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec96',
              id: 67,
              frequency: 361478,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec95',
              id: 68,
              frequency: 14648,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec94',
              id: 69,
              frequency: 19935,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec93',
              id: 70,
              frequency: 54600,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec92',
              id: 71,
              frequency: 704125,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec91',
              id: 72,
              frequency: 1311677,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79ebf7',
          id: 53,
          abbrevName: '54',
          fullName: '54_R_Frontal_pole',
          coordinates: {
            x: 15.73913,
            y: 46.550725,
            z: 40.434783,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79ec1b',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec1a',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec19',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec18',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec17',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec16',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec15',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec14',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec13',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec12',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec11',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec10',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec0f',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec0e',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec0d',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec0c',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec0b',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec0a',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec09',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec08',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec07',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec06',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec05',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec04',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec03',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec02',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec01',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec00',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebff',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebfe',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebfd',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebfc',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebfb',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebfa',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebf9',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebf8',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79ec64',
              id: 0,
              frequency: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec63',
              id: 1,
              frequency: 1058,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec62',
              id: 2,
              frequency: 227,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec61',
              id: 3,
              frequency: 2548,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec60',
              id: 4,
              frequency: 3700,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec5f',
              id: 5,
              frequency: 3067,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec5e',
              id: 6,
              frequency: 1363,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec5d',
              id: 7,
              frequency: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec5c',
              id: 8,
              frequency: 1290,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec5b',
              id: 9,
              frequency: 6194,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec5a',
              id: 10,
              frequency: 19337,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec59',
              id: 11,
              frequency: 2310,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec58',
              id: 12,
              frequency: 26654,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec57',
              id: 13,
              frequency: 11837,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec56',
              id: 14,
              frequency: 53340,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec55',
              id: 15,
              frequency: 6712,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec54',
              id: 16,
              frequency: 4967,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec53',
              id: 17,
              frequency: 5774,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec52',
              id: 18,
              frequency: 2838,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec51',
              id: 19,
              frequency: 5319,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec50',
              id: 20,
              frequency: 2332,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec4f',
              id: 21,
              frequency: 330,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec4e',
              id: 22,
              frequency: 514,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec4d',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec4c',
              id: 24,
              frequency: 16268,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec4b',
              id: 25,
              frequency: 20226,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec4a',
              id: 26,
              frequency: 7289,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec49',
              id: 27,
              frequency: 6591,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec48',
              id: 28,
              frequency: 10251,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec47',
              id: 29,
              frequency: 42929,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec46',
              id: 30,
              frequency: 10427,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec45',
              id: 31,
              frequency: 5675,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec44',
              id: 32,
              frequency: 12929,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec43',
              id: 33,
              frequency: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec42',
              id: 34,
              frequency: 2614,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec41',
              id: 35,
              frequency: 652,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec40',
              id: 36,
              frequency: 1648,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec3f',
              id: 37,
              frequency: 3987,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec3e',
              id: 38,
              frequency: 386,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec3d',
              id: 39,
              frequency: 7418,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec3c',
              id: 40,
              frequency: 55796,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec3b',
              id: 41,
              frequency: 14768,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec3a',
              id: 42,
              frequency: 1159,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec39',
              id: 43,
              frequency: 46995,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec38',
              id: 44,
              frequency: 1548,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec37',
              id: 45,
              frequency: 11584,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec36',
              id: 46,
              frequency: 41628,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec35',
              id: 47,
              frequency: 14444,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec34',
              id: 48,
              frequency: 56186,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec33',
              id: 49,
              frequency: 210,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec32',
              id: 50,
              frequency: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec31',
              id: 51,
              frequency: 11026,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec30',
              id: 52,
              frequency: 8327,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec2f',
              id: 53,
              frequency: 8430,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec2e',
              id: 54,
              frequency: 12699,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec2d',
              id: 55,
              frequency: 1395,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec2c',
              id: 56,
              frequency: 21720,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec2b',
              id: 57,
              frequency: 244535,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec2a',
              id: 58,
              frequency: 10567,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec29',
              id: 59,
              frequency: 106444,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec28',
              id: 60,
              frequency: 100812,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec27',
              id: 61,
              frequency: 11973,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec26',
              id: 62,
              frequency: 4299,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec25',
              id: 63,
              frequency: 7814,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec24',
              id: 64,
              frequency: 12124,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec23',
              id: 65,
              frequency: 137521,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec22',
              id: 66,
              frequency: 348015,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec21',
              id: 67,
              frequency: 101981,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec20',
              id: 68,
              frequency: 57395,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec1f',
              id: 69,
              frequency: 6817,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec1e',
              id: 70,
              frequency: 453289,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec1d',
              id: 71,
              frequency: 295872,
            },
            {
              _id: '5d6615769bcb6d0e6d79ec1c',
              id: 72,
              frequency: 784047,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79eb84',
          id: 54,
          abbrevName: '55',
          fullName: '55_R_Angular_gyrus_spl',
          coordinates: {
            x: 8.045249,
            y: -28.932127,
            z: 70.027149,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79ebad',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebac',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebab',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebaa',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79eba9',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79eba8',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79eba7',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79eba6',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79eba5',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79eba4',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79eba3',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79eba2',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79eba1',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79eba0',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb9f',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb9e',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb9d',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb9c',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb9b',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb9a',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb99',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb98',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb97',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb96',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb95',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb94',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb93',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb92',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb91',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb90',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb8f',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb8e',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb8d',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb8c',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb8b',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb8a',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb89',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb88',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb87',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb86',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb85',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79ebf6',
              id: 0,
              frequency: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebf5',
              id: 1,
              frequency: 240,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebf4',
              id: 2,
              frequency: 516,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebf3',
              id: 3,
              frequency: 3489,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebf2',
              id: 4,
              frequency: 638,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebf1',
              id: 5,
              frequency: 2198,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebf0',
              id: 6,
              frequency: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebef',
              id: 7,
              frequency: 441,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebee',
              id: 8,
              frequency: 424,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebed',
              id: 9,
              frequency: 342,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebec',
              id: 10,
              frequency: 9920,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebeb',
              id: 11,
              frequency: 8315,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebea',
              id: 12,
              frequency: 4197,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebe9',
              id: 13,
              frequency: 27455,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebe8',
              id: 14,
              frequency: 81269,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebe7',
              id: 15,
              frequency: 344,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebe6',
              id: 16,
              frequency: 3640,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebe5',
              id: 17,
              frequency: 428,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebe4',
              id: 18,
              frequency: 512,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebe3',
              id: 19,
              frequency: 111,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebe2',
              id: 20,
              frequency: 811,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebe1',
              id: 21,
              frequency: 2080,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebe0',
              id: 22,
              frequency: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebdf',
              id: 23,
              frequency: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebde',
              id: 24,
              frequency: 515,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebdd',
              id: 25,
              frequency: 876,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebdc',
              id: 26,
              frequency: 14238,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebdb',
              id: 27,
              frequency: 535,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebda',
              id: 28,
              frequency: 2927,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebd9',
              id: 29,
              frequency: 20990,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebd8',
              id: 30,
              frequency: 16717,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebd7',
              id: 31,
              frequency: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebd6',
              id: 32,
              frequency: 3096,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebd5',
              id: 33,
              frequency: 3116,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebd4',
              id: 34,
              frequency: 321,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebd3',
              id: 35,
              frequency: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebd2',
              id: 36,
              frequency: 797,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebd1',
              id: 37,
              frequency: 390,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebd0',
              id: 38,
              frequency: 748,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebcf',
              id: 39,
              frequency: 164,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebce',
              id: 40,
              frequency: 2693,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebcd',
              id: 41,
              frequency: 16186,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebcc',
              id: 42,
              frequency: 17367,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebcb',
              id: 43,
              frequency: 10155,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebca',
              id: 44,
              frequency: 10605,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebc9',
              id: 45,
              frequency: 410,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebc8',
              id: 46,
              frequency: 9109,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebc7',
              id: 47,
              frequency: 8975,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebc6',
              id: 48,
              frequency: 75571,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebc5',
              id: 49,
              frequency: 5,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebc4',
              id: 50,
              frequency: 125,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebc3',
              id: 51,
              frequency: 1246,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebc2',
              id: 52,
              frequency: 903,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebc1',
              id: 53,
              frequency: 6146,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebc0',
              id: 54,
              frequency: 327,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebbf',
              id: 55,
              frequency: 14544,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebbe',
              id: 56,
              frequency: 281,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebbd',
              id: 57,
              frequency: 220740,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebbc',
              id: 58,
              frequency: 53967,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebbb',
              id: 59,
              frequency: 8646,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebba',
              id: 60,
              frequency: 40429,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebb9',
              id: 61,
              frequency: 58320,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebb8',
              id: 62,
              frequency: 218,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebb7',
              id: 63,
              frequency: 3623,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebb6',
              id: 64,
              frequency: 8149,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebb5',
              id: 65,
              frequency: 3514,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebb4',
              id: 66,
              frequency: 123213,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebb3',
              id: 67,
              frequency: 361478,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebb2',
              id: 68,
              frequency: 14648,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebb1',
              id: 69,
              frequency: 19935,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebb0',
              id: 70,
              frequency: 54600,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebaf',
              id: 71,
              frequency: 704125,
            },
            {
              _id: '5d6615769bcb6d0e6d79ebae',
              id: 72,
              frequency: 1311677,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79eb10',
          id: 55,
          abbrevName: '56',
          fullName: '56_L_Frontal_pole',
          coordinates: {
            x: -34.913043,
            y: 38.913043,
            z: -14.326087,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79eb3a',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb39',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb38',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb37',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb36',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb35',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb34',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb33',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb32',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb31',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb30',
              to: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb2f',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb2e',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb2d',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb2c',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb2b',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb2a',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb29',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb28',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb27',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb26',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb25',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb24',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb23',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb22',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb21',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb20',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb1f',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb1e',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb1d',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb1c',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb1b',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb1a',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb19',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb18',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb17',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb16',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb15',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb14',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb13',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb12',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb11',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79eb83',
              id: 0,
              frequency: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb82',
              id: 1,
              frequency: 594,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb81',
              id: 2,
              frequency: 531,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb80',
              id: 3,
              frequency: 3124,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb7f',
              id: 4,
              frequency: 1162,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb7e',
              id: 5,
              frequency: 3868,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb7d',
              id: 6,
              frequency: 677,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb7c',
              id: 7,
              frequency: 439,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb7b',
              id: 8,
              frequency: 1138,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb7a',
              id: 9,
              frequency: 1289,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb79',
              id: 10,
              frequency: 13414,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb78',
              id: 11,
              frequency: 10784,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb77',
              id: 12,
              frequency: 15466,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb76',
              id: 13,
              frequency: 21719,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb75',
              id: 14,
              frequency: 69398,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb74',
              id: 15,
              frequency: 1025,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb73',
              id: 16,
              frequency: 4585,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb72',
              id: 17,
              frequency: 3937,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb71',
              id: 18,
              frequency: 478,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb70',
              id: 19,
              frequency: 1567,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb6f',
              id: 20,
              frequency: 2287,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb6e',
              id: 21,
              frequency: 2690,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb6d',
              id: 22,
              frequency: 213,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb6c',
              id: 23,
              frequency: 7,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb6b',
              id: 24,
              frequency: 2318,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb6a',
              id: 25,
              frequency: 7423,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb69',
              id: 26,
              frequency: 25735,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb68',
              id: 27,
              frequency: 846,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb67',
              id: 28,
              frequency: 5566,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb66',
              id: 29,
              frequency: 17343,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb65',
              id: 30,
              frequency: 21327,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb64',
              id: 31,
              frequency: 1160,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb63',
              id: 32,
              frequency: 6035,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb62',
              id: 33,
              frequency: 3709,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb61',
              id: 34,
              frequency: 1321,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb60',
              id: 35,
              frequency: 216,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb5f',
              id: 36,
              frequency: 1041,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb5e',
              id: 37,
              frequency: 3130,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb5d',
              id: 38,
              frequency: 1718,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb5c',
              id: 39,
              frequency: 1455,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb5b',
              id: 40,
              frequency: 26879,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb5a',
              id: 41,
              frequency: 20315,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb59',
              id: 42,
              frequency: 22541,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb58',
              id: 43,
              frequency: 11487,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb57',
              id: 44,
              frequency: 14721,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb56',
              id: 45,
              frequency: 1149,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb55',
              id: 46,
              frequency: 14867,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb54',
              id: 47,
              frequency: 40831,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb53',
              id: 48,
              frequency: 57992,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb52',
              id: 49,
              frequency: 275,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb51',
              id: 50,
              frequency: 151,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb50',
              id: 51,
              frequency: 4340,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb4f',
              id: 52,
              frequency: 3135,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb4e',
              id: 53,
              frequency: 15113,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb4d',
              id: 54,
              frequency: 9332,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb4c',
              id: 55,
              frequency: 6450,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb4b',
              id: 56,
              frequency: 1254,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb4a',
              id: 57,
              frequency: 186332,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb49',
              id: 58,
              frequency: 126647,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb48',
              id: 59,
              frequency: 31774,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb47',
              id: 60,
              frequency: 92940,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb46',
              id: 61,
              frequency: 55906,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb45',
              id: 62,
              frequency: 1056,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb44',
              id: 63,
              frequency: 10476,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb43',
              id: 64,
              frequency: 11382,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb42',
              id: 65,
              frequency: 27143,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb41',
              id: 66,
              frequency: 249469,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb40',
              id: 67,
              frequency: 291935,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb3f',
              id: 68,
              frequency: 45974,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb3e',
              id: 69,
              frequency: 13286,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb3d',
              id: 70,
              frequency: 271160,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb3c',
              id: 71,
              frequency: 505980,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb3b',
              id: 72,
              frequency: 1082373,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79eaa0',
          id: 56,
          abbrevName: '57',
          fullName: '57_L_Precentral_gyrus_postcentral_gyrus',
          coordinates: {
            x: -45.175573,
            y: -15.847328,
            z: 49.267176,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79eac6',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d79eac5',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79eac4',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79eac3',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79eac2',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79eac1',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79eac0',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79eabf',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79eabe',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79eabd',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79eabc',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79eabb',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaba',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79eab9',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79eab8',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79eab7',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79eab6',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79eab5',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79eab4',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79eab3',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79eab2',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79eab1',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79eab0',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaaf',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaae',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaad',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaac',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaab',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaaa',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaa9',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaa8',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaa7',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaa6',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaa5',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaa4',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaa3',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaa2',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaa1',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79eb0f',
              id: 0,
              frequency: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb0e',
              id: 1,
              frequency: 440,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb0d',
              id: 2,
              frequency: 380,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb0c',
              id: 3,
              frequency: 3275,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb0b',
              id: 4,
              frequency: 1280,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb0a',
              id: 5,
              frequency: 2509,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb09',
              id: 6,
              frequency: 375,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb08',
              id: 7,
              frequency: 159,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb07',
              id: 8,
              frequency: 689,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb06',
              id: 9,
              frequency: 810,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb05',
              id: 10,
              frequency: 14987,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb04',
              id: 11,
              frequency: 5184,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb03',
              id: 12,
              frequency: 9263,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb02',
              id: 13,
              frequency: 21075,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb01',
              id: 14,
              frequency: 75922,
            },
            {
              _id: '5d6615769bcb6d0e6d79eb00',
              id: 15,
              frequency: 1512,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaff',
              id: 16,
              frequency: 4330,
            },
            {
              _id: '5d6615769bcb6d0e6d79eafe',
              id: 17,
              frequency: 1720,
            },
            {
              _id: '5d6615769bcb6d0e6d79eafd',
              id: 18,
              frequency: 957,
            },
            {
              _id: '5d6615769bcb6d0e6d79eafc',
              id: 19,
              frequency: 1134,
            },
            {
              _id: '5d6615769bcb6d0e6d79eafb',
              id: 20,
              frequency: 1493,
            },
            {
              _id: '5d6615769bcb6d0e6d79eafa',
              id: 21,
              frequency: 925,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaf9',
              id: 22,
              frequency: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaf8',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaf7',
              id: 24,
              frequency: 1940,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaf6',
              id: 25,
              frequency: 7778,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaf5',
              id: 26,
              frequency: 12040,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaf4',
              id: 27,
              frequency: 1289,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaf3',
              id: 28,
              frequency: 3901,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaf2',
              id: 29,
              frequency: 32870,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaf1',
              id: 30,
              frequency: 14525,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaf0',
              id: 31,
              frequency: 629,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaef',
              id: 32,
              frequency: 6860,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaee',
              id: 33,
              frequency: 808,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaed',
              id: 34,
              frequency: 793,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaec',
              id: 35,
              frequency: 168,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaeb',
              id: 36,
              frequency: 1090,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaea',
              id: 37,
              frequency: 1534,
            },
            {
              _id: '5d6615769bcb6d0e6d79eae9',
              id: 38,
              frequency: 669,
            },
            {
              _id: '5d6615769bcb6d0e6d79eae8',
              id: 39,
              frequency: 716,
            },
            {
              _id: '5d6615769bcb6d0e6d79eae7',
              id: 40,
              frequency: 15520,
            },
            {
              _id: '5d6615769bcb6d0e6d79eae6',
              id: 41,
              frequency: 20406,
            },
            {
              _id: '5d6615769bcb6d0e6d79eae5',
              id: 42,
              frequency: 5828,
            },
            {
              _id: '5d6615769bcb6d0e6d79eae4',
              id: 43,
              frequency: 16593,
            },
            {
              _id: '5d6615769bcb6d0e6d79eae3',
              id: 44,
              frequency: 6197,
            },
            {
              _id: '5d6615769bcb6d0e6d79eae2',
              id: 45,
              frequency: 1031,
            },
            {
              _id: '5d6615769bcb6d0e6d79eae1',
              id: 46,
              frequency: 17669,
            },
            {
              _id: '5d6615769bcb6d0e6d79eae0',
              id: 47,
              frequency: 9958,
            },
            {
              _id: '5d6615769bcb6d0e6d79eadf',
              id: 48,
              frequency: 74280,
            },
            {
              _id: '5d6615769bcb6d0e6d79eade',
              id: 49,
              frequency: 128,
            },
            {
              _id: '5d6615769bcb6d0e6d79eadd',
              id: 50,
              frequency: 108,
            },
            {
              _id: '5d6615769bcb6d0e6d79eadc',
              id: 51,
              frequency: 2599,
            },
            {
              _id: '5d6615769bcb6d0e6d79eadb',
              id: 52,
              frequency: 3274,
            },
            {
              _id: '5d6615769bcb6d0e6d79eada',
              id: 53,
              frequency: 8574,
            },
            {
              _id: '5d6615769bcb6d0e6d79ead9',
              id: 54,
              frequency: 3106,
            },
            {
              _id: '5d6615769bcb6d0e6d79ead8',
              id: 55,
              frequency: 5753,
            },
            {
              _id: '5d6615769bcb6d0e6d79ead7',
              id: 56,
              frequency: 760,
            },
            {
              _id: '5d6615769bcb6d0e6d79ead6',
              id: 57,
              frequency: 281798,
            },
            {
              _id: '5d6615769bcb6d0e6d79ead5',
              id: 58,
              frequency: 27845,
            },
            {
              _id: '5d6615769bcb6d0e6d79ead4',
              id: 59,
              frequency: 23349,
            },
            {
              _id: '5d6615769bcb6d0e6d79ead3',
              id: 60,
              frequency: 63708,
            },
            {
              _id: '5d6615769bcb6d0e6d79ead2',
              id: 61,
              frequency: 33568,
            },
            {
              _id: '5d6615769bcb6d0e6d79ead1',
              id: 62,
              frequency: 552,
            },
            {
              _id: '5d6615769bcb6d0e6d79ead0',
              id: 63,
              frequency: 4811,
            },
            {
              _id: '5d6615769bcb6d0e6d79eacf',
              id: 64,
              frequency: 12227,
            },
            {
              _id: '5d6615769bcb6d0e6d79eace',
              id: 65,
              frequency: 10652,
            },
            {
              _id: '5d6615769bcb6d0e6d79eacd',
              id: 66,
              frequency: 235722,
            },
            {
              _id: '5d6615769bcb6d0e6d79eacc',
              id: 67,
              frequency: 241541,
            },
            {
              _id: '5d6615769bcb6d0e6d79eacb',
              id: 68,
              frequency: 26460,
            },
            {
              _id: '5d6615769bcb6d0e6d79eaca',
              id: 69,
              frequency: 12943,
            },
            {
              _id: '5d6615769bcb6d0e6d79eac9',
              id: 70,
              frequency: 136991,
            },
            {
              _id: '5d6615769bcb6d0e6d79eac8',
              id: 71,
              frequency: 562074,
            },
            {
              _id: '5d6615769bcb6d0e6d79eac7',
              id: 72,
              frequency: 1226998,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79ea32',
          id: 57,
          abbrevName: '58',
          fullName: '58_R_Occipital_Fusiform',
          coordinates: {
            x: 23.955224,
            y: -65.223881,
            z: -15.402985,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79ea56',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea55',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea54',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea53',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea52',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea51',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea50',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea4f',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea4e',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea4d',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea4c',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea4b',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea4a',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea49',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea48',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea47',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea46',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea45',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea44',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea43',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea42',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea41',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea40',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea3f',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea3e',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea3d',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea3c',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea3b',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea3a',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea39',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea38',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea37',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea36',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea35',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea34',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea33',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79ea9f',
              id: 0,
              frequency: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea9e',
              id: 1,
              frequency: 489,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea9d',
              id: 2,
              frequency: 502,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea9c',
              id: 3,
              frequency: 3239,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea9b',
              id: 4,
              frequency: 774,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea9a',
              id: 5,
              frequency: 3441,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea99',
              id: 6,
              frequency: 464,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea98',
              id: 7,
              frequency: 455,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea97',
              id: 8,
              frequency: 893,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea96',
              id: 9,
              frequency: 826,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea95',
              id: 10,
              frequency: 12703,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea94',
              id: 11,
              frequency: 8940,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea93',
              id: 12,
              frequency: 12062,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea92',
              id: 13,
              frequency: 23425,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea91',
              id: 14,
              frequency: 73175,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea90',
              id: 15,
              frequency: 938,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea8f',
              id: 16,
              frequency: 2514,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea8e',
              id: 17,
              frequency: 4186,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea8d',
              id: 18,
              frequency: 559,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea8c',
              id: 19,
              frequency: 775,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea8b',
              id: 20,
              frequency: 2049,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea8a',
              id: 21,
              frequency: 2796,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea89',
              id: 22,
              frequency: 124,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea88',
              id: 23,
              frequency: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea87',
              id: 24,
              frequency: 1737,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea86',
              id: 25,
              frequency: 8125,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea85',
              id: 26,
              frequency: 16623,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea84',
              id: 27,
              frequency: 311,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea83',
              id: 28,
              frequency: 3708,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea82',
              id: 29,
              frequency: 13987,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea81',
              id: 30,
              frequency: 24592,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea80',
              id: 31,
              frequency: 644,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea7f',
              id: 32,
              frequency: 5740,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea7e',
              id: 33,
              frequency: 3501,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea7d',
              id: 34,
              frequency: 1143,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea7c',
              id: 35,
              frequency: 105,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea7b',
              id: 36,
              frequency: 748,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea7a',
              id: 37,
              frequency: 2125,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea79',
              id: 38,
              frequency: 1659,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea78',
              id: 39,
              frequency: 701,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea77',
              id: 40,
              frequency: 19722,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea76',
              id: 41,
              frequency: 16483,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea75',
              id: 42,
              frequency: 19967,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea74',
              id: 43,
              frequency: 10141,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea73',
              id: 44,
              frequency: 9346,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea72',
              id: 45,
              frequency: 434,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea71',
              id: 46,
              frequency: 9465,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea70',
              id: 47,
              frequency: 24044,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea6f',
              id: 48,
              frequency: 67013,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea6e',
              id: 49,
              frequency: 114,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea6d',
              id: 50,
              frequency: 210,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea6c',
              id: 51,
              frequency: 3036,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea6b',
              id: 52,
              frequency: 2315,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea6a',
              id: 53,
              frequency: 13785,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea69',
              id: 54,
              frequency: 5020,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea68',
              id: 55,
              frequency: 10987,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea67',
              id: 56,
              frequency: 595,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea66',
              id: 57,
              frequency: 196707,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea65',
              id: 58,
              frequency: 83566,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea64',
              id: 59,
              frequency: 19685,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea63',
              id: 60,
              frequency: 88882,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea62',
              id: 61,
              frequency: 53766,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea61',
              id: 62,
              frequency: 722,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea60',
              id: 63,
              frequency: 7603,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea5f',
              id: 64,
              frequency: 10185,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea5e',
              id: 65,
              frequency: 16511,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea5d',
              id: 66,
              frequency: 223351,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea5c',
              id: 67,
              frequency: 308410,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea5b',
              id: 68,
              frequency: 34440,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea5a',
              id: 69,
              frequency: 15821,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea59',
              id: 70,
              frequency: 204170,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea58',
              id: 71,
              frequency: 563568,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea57',
              id: 72,
              frequency: 1156897,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e9c8',
          id: 58,
          abbrevName: '59',
          fullName: '59_BI_Paracingulate_ACC',
          coordinates: {
            x: 0.510823,
            y: 45.186147,
            z: 3.549784,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e9e8',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9e7',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9e6',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9e5',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9e4',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9e3',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9e2',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9e1',
              to: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9e0',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9df',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9de',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9dd',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9dc',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9db',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9da',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9d9',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9d8',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9d7',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9d6',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9d5',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9d4',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9d3',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9d2',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9d1',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9d0',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9cf',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9ce',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9cd',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9cc',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9cb',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9ca',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9c9',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79ea31',
              id: 0,
              frequency: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea30',
              id: 1,
              frequency: 1315,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea2f',
              id: 2,
              frequency: 347,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea2e',
              id: 3,
              frequency: 2209,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea2d',
              id: 4,
              frequency: 4129,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea2c',
              id: 5,
              frequency: 5593,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea2b',
              id: 6,
              frequency: 1231,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea2a',
              id: 7,
              frequency: 231,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea29',
              id: 8,
              frequency: 2362,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea28',
              id: 9,
              frequency: 11275,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea27',
              id: 10,
              frequency: 16802,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea26',
              id: 11,
              frequency: 5413,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea25',
              id: 12,
              frequency: 33123,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea24',
              id: 13,
              frequency: 12771,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea23',
              id: 14,
              frequency: 41225,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea22',
              id: 15,
              frequency: 3069,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea21',
              id: 16,
              frequency: 8725,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea20',
              id: 17,
              frequency: 7789,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea1f',
              id: 18,
              frequency: 1795,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea1e',
              id: 19,
              frequency: 4243,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea1d',
              id: 20,
              frequency: 3770,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea1c',
              id: 21,
              frequency: 2577,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea1b',
              id: 22,
              frequency: 376,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea1a',
              id: 23,
              frequency: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea19',
              id: 24,
              frequency: 10367,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea18',
              id: 25,
              frequency: 13665,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea17',
              id: 26,
              frequency: 20673,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea16',
              id: 27,
              frequency: 12754,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea15',
              id: 28,
              frequency: 33508,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea14',
              id: 29,
              frequency: 28405,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea13',
              id: 30,
              frequency: 17314,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea12',
              id: 31,
              frequency: 7365,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea11',
              id: 32,
              frequency: 9192,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea10',
              id: 33,
              frequency: 1415,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea0f',
              id: 34,
              frequency: 2353,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea0e',
              id: 35,
              frequency: 578,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea0d',
              id: 36,
              frequency: 2611,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea0c',
              id: 37,
              frequency: 5488,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea0b',
              id: 38,
              frequency: 2732,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea0a',
              id: 39,
              frequency: 7123,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea09',
              id: 40,
              frequency: 45263,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea08',
              id: 41,
              frequency: 16016,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea07',
              id: 42,
              frequency: 9097,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea06',
              id: 43,
              frequency: 55906,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea05',
              id: 44,
              frequency: 5328,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea04',
              id: 45,
              frequency: 22354,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea03',
              id: 46,
              frequency: 30998,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea02',
              id: 47,
              frequency: 60577,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea01',
              id: 48,
              frequency: 59465,
            },
            {
              _id: '5d6615769bcb6d0e6d79ea00',
              id: 49,
              frequency: 395,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9ff',
              id: 50,
              frequency: 331,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9fe',
              id: 51,
              frequency: 23684,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9fd',
              id: 52,
              frequency: 6607,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9fc',
              id: 53,
              frequency: 14967,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9fb',
              id: 54,
              frequency: 11449,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9fa',
              id: 55,
              frequency: 3924,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9f9',
              id: 56,
              frequency: 64002,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9f8',
              id: 57,
              frequency: 154989,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9f7',
              id: 58,
              frequency: 46565,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9f6',
              id: 59,
              frequency: 147207,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9f5',
              id: 60,
              frequency: 130005,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9f4',
              id: 61,
              frequency: 24299,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9f3',
              id: 62,
              frequency: 11786,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9f2',
              id: 63,
              frequency: 19412,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9f1',
              id: 64,
              frequency: 12509,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9f0',
              id: 65,
              frequency: 258324,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9ef',
              id: 66,
              frequency: 292001,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9ee',
              id: 67,
              frequency: 142868,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9ed',
              id: 68,
              frequency: 95315,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9ec',
              id: 69,
              frequency: 6977,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9eb',
              id: 70,
              frequency: 541995,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9ea',
              id: 71,
              frequency: 249044,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9e9',
              id: 72,
              frequency: 539251,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e961',
          id: 59,
          abbrevName: '60',
          fullName: '60_R_ITG_posterior_mtg_posterior',
          coordinates: {
            x: 59.098901,
            y: -22.901099,
            z: -20.967033,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e97e',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79e97d',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79e97c',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79e97b',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79e97a',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79e979',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79e978',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79e977',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79e976',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79e975',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79e974',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79e973',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79e972',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79e971',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79e970',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79e96f',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79e96e',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79e96d',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79e96c',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e96b',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79e96a',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d79e969',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e968',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79e967',
              to: 93,
            },
            {
              _id: '5d6615769bcb6d0e6d79e966',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79e965',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79e964',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79e963',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79e962',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e9c7',
              id: 0,
              frequency: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9c6',
              id: 1,
              frequency: 1531,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9c5',
              id: 2,
              frequency: 444,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9c4',
              id: 3,
              frequency: 1902,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9c3',
              id: 4,
              frequency: 4444,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9c2',
              id: 5,
              frequency: 7498,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9c1',
              id: 6,
              frequency: 1238,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9c0',
              id: 7,
              frequency: 677,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9bf',
              id: 8,
              frequency: 4299,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9be',
              id: 9,
              frequency: 16472,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9bd',
              id: 10,
              frequency: 13852,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9bc',
              id: 11,
              frequency: 7235,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9bb',
              id: 12,
              frequency: 37080,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9ba',
              id: 13,
              frequency: 13247,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9b9',
              id: 14,
              frequency: 31235,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9b8',
              id: 15,
              frequency: 1851,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9b7',
              id: 16,
              frequency: 12009,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9b6',
              id: 17,
              frequency: 8957,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9b5',
              id: 18,
              frequency: 921,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9b4',
              id: 19,
              frequency: 4199,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9b3',
              id: 20,
              frequency: 4179,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9b2',
              id: 21,
              frequency: 7971,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9b1',
              id: 22,
              frequency: 338,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9b0',
              id: 23,
              frequency: 344,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9af',
              id: 24,
              frequency: 6606,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9ae',
              id: 25,
              frequency: 11440,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9ad',
              id: 26,
              frequency: 27461,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9ac',
              id: 27,
              frequency: 15412,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9ab',
              id: 28,
              frequency: 56476,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9aa',
              id: 29,
              frequency: 20636,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9a9',
              id: 30,
              frequency: 19448,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9a8',
              id: 31,
              frequency: 10303,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9a7',
              id: 32,
              frequency: 6139,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9a6',
              id: 33,
              frequency: 6761,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9a5',
              id: 34,
              frequency: 3577,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9a4',
              id: 35,
              frequency: 357,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9a3',
              id: 36,
              frequency: 2934,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9a2',
              id: 37,
              frequency: 7541,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9a1',
              id: 38,
              frequency: 9670,
            },
            {
              _id: '5d6615769bcb6d0e6d79e9a0',
              id: 39,
              frequency: 6165,
            },
            {
              _id: '5d6615769bcb6d0e6d79e99f',
              id: 40,
              frequency: 46149,
            },
            {
              _id: '5d6615769bcb6d0e6d79e99e',
              id: 41,
              frequency: 14886,
            },
            {
              _id: '5d6615769bcb6d0e6d79e99d',
              id: 42,
              frequency: 22465,
            },
            {
              _id: '5d6615769bcb6d0e6d79e99c',
              id: 43,
              frequency: 54111,
            },
            {
              _id: '5d6615769bcb6d0e6d79e99b',
              id: 44,
              frequency: 6527,
            },
            {
              _id: '5d6615769bcb6d0e6d79e99a',
              id: 45,
              frequency: 34569,
            },
            {
              _id: '5d6615769bcb6d0e6d79e999',
              id: 46,
              frequency: 25493,
            },
            {
              _id: '5d6615769bcb6d0e6d79e998',
              id: 47,
              frequency: 91589,
            },
            {
              _id: '5d6615769bcb6d0e6d79e997',
              id: 48,
              frequency: 46518,
            },
            {
              _id: '5d6615769bcb6d0e6d79e996',
              id: 49,
              frequency: 436,
            },
            {
              _id: '5d6615769bcb6d0e6d79e995',
              id: 50,
              frequency: 1363,
            },
            {
              _id: '5d6615769bcb6d0e6d79e994',
              id: 51,
              frequency: 38858,
            },
            {
              _id: '5d6615769bcb6d0e6d79e993',
              id: 52,
              frequency: 4777,
            },
            {
              _id: '5d6615769bcb6d0e6d79e992',
              id: 53,
              frequency: 25807,
            },
            {
              _id: '5d6615769bcb6d0e6d79e991',
              id: 54,
              frequency: 9652,
            },
            {
              _id: '5d6615769bcb6d0e6d79e990',
              id: 55,
              frequency: 7319,
            },
            {
              _id: '5d6615769bcb6d0e6d79e98f',
              id: 56,
              frequency: 118507,
            },
            {
              _id: '5d6615769bcb6d0e6d79e98e',
              id: 57,
              frequency: 99198,
            },
            {
              _id: '5d6615769bcb6d0e6d79e98d',
              id: 58,
              frequency: 59844,
            },
            {
              _id: '5d6615769bcb6d0e6d79e98c',
              id: 59,
              frequency: 157127,
            },
            {
              _id: '5d6615769bcb6d0e6d79e98b',
              id: 60,
              frequency: 145224,
            },
            {
              _id: '5d6615769bcb6d0e6d79e98a',
              id: 61,
              frequency: 32197,
            },
            {
              _id: '5d6615769bcb6d0e6d79e989',
              id: 62,
              frequency: 33319,
            },
            {
              _id: '5d6615769bcb6d0e6d79e988',
              id: 63,
              frequency: 39898,
            },
            {
              _id: '5d6615769bcb6d0e6d79e987',
              id: 64,
              frequency: 12755,
            },
            {
              _id: '5d6615769bcb6d0e6d79e986',
              id: 65,
              frequency: 373443,
            },
            {
              _id: '5d6615769bcb6d0e6d79e985',
              id: 66,
              frequency: 214698,
            },
            {
              _id: '5d6615769bcb6d0e6d79e984',
              id: 67,
              frequency: 149024,
            },
            {
              _id: '5d6615769bcb6d0e6d79e983',
              id: 68,
              frequency: 155916,
            },
            {
              _id: '5d6615769bcb6d0e6d79e982',
              id: 69,
              frequency: 6810,
            },
            {
              _id: '5d6615769bcb6d0e6d79e981',
              id: 70,
              frequency: 560373,
            },
            {
              _id: '5d6615769bcb6d0e6d79e980',
              id: 71,
              frequency: 220099,
            },
            {
              _id: '5d6615769bcb6d0e6d79e97f',
              id: 72,
              frequency: 353111,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e8f6',
          id: 60,
          abbrevName: '61',
          fullName: '61_R_Occipital_pole_loc_superior',
          coordinates: {
            x: 27.957447,
            y: -87.617021,
            z: 20.87234,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e917',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79e916',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79e915',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79e914',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79e913',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79e912',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79e911',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79e910',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79e90f',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79e90e',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79e90d',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79e90c',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79e90b',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79e90a',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79e909',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79e908',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79e907',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79e906',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79e905',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79e904',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79e903',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79e902',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e901',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79e900',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8ff',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8fe',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8fd',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8fc',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8fb',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8fa',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8f9',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8f8',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8f7',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e960',
              id: 0,
              frequency: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79e95f',
              id: 1,
              frequency: 789,
            },
            {
              _id: '5d6615769bcb6d0e6d79e95e',
              id: 2,
              frequency: 346,
            },
            {
              _id: '5d6615769bcb6d0e6d79e95d',
              id: 3,
              frequency: 2894,
            },
            {
              _id: '5d6615769bcb6d0e6d79e95c',
              id: 4,
              frequency: 2327,
            },
            {
              _id: '5d6615769bcb6d0e6d79e95b',
              id: 5,
              frequency: 3123,
            },
            {
              _id: '5d6615769bcb6d0e6d79e95a',
              id: 6,
              frequency: 1107,
            },
            {
              _id: '5d6615769bcb6d0e6d79e959',
              id: 7,
              frequency: 127,
            },
            {
              _id: '5d6615769bcb6d0e6d79e958',
              id: 8,
              frequency: 1553,
            },
            {
              _id: '5d6615769bcb6d0e6d79e957',
              id: 9,
              frequency: 2606,
            },
            {
              _id: '5d6615769bcb6d0e6d79e956',
              id: 10,
              frequency: 16235,
            },
            {
              _id: '5d6615769bcb6d0e6d79e955',
              id: 11,
              frequency: 5117,
            },
            {
              _id: '5d6615769bcb6d0e6d79e954',
              id: 12,
              frequency: 20328,
            },
            {
              _id: '5d6615769bcb6d0e6d79e953',
              id: 13,
              frequency: 16719,
            },
            {
              _id: '5d6615769bcb6d0e6d79e952',
              id: 14,
              frequency: 63357,
            },
            {
              _id: '5d6615769bcb6d0e6d79e951',
              id: 15,
              frequency: 3466,
            },
            {
              _id: '5d6615769bcb6d0e6d79e950',
              id: 16,
              frequency: 4763,
            },
            {
              _id: '5d6615769bcb6d0e6d79e94f',
              id: 17,
              frequency: 4485,
            },
            {
              _id: '5d6615769bcb6d0e6d79e94e',
              id: 18,
              frequency: 1717,
            },
            {
              _id: '5d6615769bcb6d0e6d79e94d',
              id: 19,
              frequency: 4135,
            },
            {
              _id: '5d6615769bcb6d0e6d79e94c',
              id: 20,
              frequency: 2074,
            },
            {
              _id: '5d6615769bcb6d0e6d79e94b',
              id: 21,
              frequency: 942,
            },
            {
              _id: '5d6615769bcb6d0e6d79e94a',
              id: 22,
              frequency: 321,
            },
            {
              _id: '5d6615769bcb6d0e6d79e949',
              id: 23,
              frequency: 1,
            },
            {
              _id: '5d6615769bcb6d0e6d79e948',
              id: 24,
              frequency: 7120,
            },
            {
              _id: '5d6615769bcb6d0e6d79e947',
              id: 25,
              frequency: 12422,
            },
            {
              _id: '5d6615769bcb6d0e6d79e946',
              id: 26,
              frequency: 12935,
            },
            {
              _id: '5d6615769bcb6d0e6d79e945',
              id: 27,
              frequency: 2326,
            },
            {
              _id: '5d6615769bcb6d0e6d79e944',
              id: 28,
              frequency: 5368,
            },
            {
              _id: '5d6615769bcb6d0e6d79e943',
              id: 29,
              frequency: 32436,
            },
            {
              _id: '5d6615769bcb6d0e6d79e942',
              id: 30,
              frequency: 16753,
            },
            {
              _id: '5d6615769bcb6d0e6d79e941',
              id: 31,
              frequency: 2991,
            },
            {
              _id: '5d6615769bcb6d0e6d79e940',
              id: 32,
              frequency: 9016,
            },
            {
              _id: '5d6615769bcb6d0e6d79e93f',
              id: 33,
              frequency: 556,
            },
            {
              _id: '5d6615769bcb6d0e6d79e93e',
              id: 34,
              frequency: 1738,
            },
            {
              _id: '5d6615769bcb6d0e6d79e93d',
              id: 35,
              frequency: 640,
            },
            {
              _id: '5d6615769bcb6d0e6d79e93c',
              id: 36,
              frequency: 2205,
            },
            {
              _id: '5d6615769bcb6d0e6d79e93b',
              id: 37,
              frequency: 4801,
            },
            {
              _id: '5d6615769bcb6d0e6d79e93a',
              id: 38,
              frequency: 823,
            },
            {
              _id: '5d6615769bcb6d0e6d79e939',
              id: 39,
              frequency: 3935,
            },
            {
              _id: '5d6615769bcb6d0e6d79e938',
              id: 40,
              frequency: 46021,
            },
            {
              _id: '5d6615769bcb6d0e6d79e937',
              id: 41,
              frequency: 17692,
            },
            {
              _id: '5d6615769bcb6d0e6d79e936',
              id: 42,
              frequency: 5505,
            },
            {
              _id: '5d6615769bcb6d0e6d79e935',
              id: 43,
              frequency: 19155,
            },
            {
              _id: '5d6615769bcb6d0e6d79e934',
              id: 44,
              frequency: 4994,
            },
            {
              _id: '5d6615769bcb6d0e6d79e933',
              id: 45,
              frequency: 3488,
            },
            {
              _id: '5d6615769bcb6d0e6d79e932',
              id: 46,
              frequency: 30751,
            },
            {
              _id: '5d6615769bcb6d0e6d79e931',
              id: 47,
              frequency: 19883,
            },
            {
              _id: '5d6615769bcb6d0e6d79e930',
              id: 48,
              frequency: 59368,
            },
            {
              _id: '5d6615769bcb6d0e6d79e92f',
              id: 49,
              frequency: 418,
            },
            {
              _id: '5d6615769bcb6d0e6d79e92e',
              id: 50,
              frequency: 229,
            },
            {
              _id: '5d6615769bcb6d0e6d79e92d',
              id: 51,
              frequency: 8160,
            },
            {
              _id: '5d6615769bcb6d0e6d79e92c',
              id: 52,
              frequency: 5200,
            },
            {
              _id: '5d6615769bcb6d0e6d79e92b',
              id: 53,
              frequency: 12863,
            },
            {
              _id: '5d6615769bcb6d0e6d79e92a',
              id: 54,
              frequency: 12906,
            },
            {
              _id: '5d6615769bcb6d0e6d79e929',
              id: 55,
              frequency: 3285,
            },
            {
              _id: '5d6615769bcb6d0e6d79e928',
              id: 56,
              frequency: 4027,
            },
            {
              _id: '5d6615769bcb6d0e6d79e927',
              id: 57,
              frequency: 244284,
            },
            {
              _id: '5d6615769bcb6d0e6d79e926',
              id: 58,
              frequency: 41408,
            },
            {
              _id: '5d6615769bcb6d0e6d79e925',
              id: 59,
              frequency: 61013,
            },
            {
              _id: '5d6615769bcb6d0e6d79e924',
              id: 60,
              frequency: 84749,
            },
            {
              _id: '5d6615769bcb6d0e6d79e923',
              id: 61,
              frequency: 28823,
            },
            {
              _id: '5d6615769bcb6d0e6d79e922',
              id: 62,
              frequency: 2841,
            },
            {
              _id: '5d6615769bcb6d0e6d79e921',
              id: 63,
              frequency: 13985,
            },
            {
              _id: '5d6615769bcb6d0e6d79e920',
              id: 64,
              frequency: 12829,
            },
            {
              _id: '5d6615769bcb6d0e6d79e91f',
              id: 65,
              frequency: 54551,
            },
            {
              _id: '5d6615769bcb6d0e6d79e91e',
              id: 66,
              frequency: 281520,
            },
            {
              _id: '5d6615769bcb6d0e6d79e91d',
              id: 67,
              frequency: 185158,
            },
            {
              _id: '5d6615769bcb6d0e6d79e91c',
              id: 68,
              frequency: 67515,
            },
            {
              _id: '5d6615769bcb6d0e6d79e91b',
              id: 69,
              frequency: 8756,
            },
            {
              _id: '5d6615769bcb6d0e6d79e91a',
              id: 70,
              frequency: 356915,
            },
            {
              _id: '5d6615769bcb6d0e6d79e919',
              id: 71,
              frequency: 412868,
            },
            {
              _id: '5d6615769bcb6d0e6d79e918',
              id: 72,
              frequency: 972386,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e88c',
          id: 61,
          abbrevName: '62',
          fullName: '62_LOC_temp_occ_fusiform',
          coordinates: {
            x: -22.214765,
            y: -68.899329,
            z: -15.90604,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e8ac',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8ab',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8aa',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8a9',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8a8',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8a7',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8a6',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8a5',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8a4',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8a3',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8a2',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8a1',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8a0',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79e89f',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79e89e',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79e89d',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79e89c',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79e89b',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79e89a',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79e899',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e898',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79e897',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79e896',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e895',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e894',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79e893',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79e892',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79e891',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79e890',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79e88f',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79e88e',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79e88d',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e8f5',
              id: 0,
              frequency: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8f4',
              id: 1,
              frequency: 359,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8f3',
              id: 2,
              frequency: 453,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8f2',
              id: 3,
              frequency: 3375,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8f1',
              id: 4,
              frequency: 445,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8f0',
              id: 5,
              frequency: 2820,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8ef',
              id: 6,
              frequency: 329,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8ee',
              id: 7,
              frequency: 206,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8ed',
              id: 8,
              frequency: 437,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8ec',
              id: 9,
              frequency: 436,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8eb',
              id: 10,
              frequency: 12535,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8ea',
              id: 11,
              frequency: 6805,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8e9',
              id: 12,
              frequency: 7502,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8e8',
              id: 13,
              frequency: 24730,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8e7',
              id: 14,
              frequency: 77995,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8e6',
              id: 15,
              frequency: 469,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8e5',
              id: 16,
              frequency: 2169,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8e4',
              id: 17,
              frequency: 2230,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8e3',
              id: 18,
              frequency: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8e2',
              id: 19,
              frequency: 644,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8e1',
              id: 20,
              frequency: 2655,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8e0',
              id: 21,
              frequency: 1473,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8df',
              id: 22,
              frequency: 127,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8de',
              id: 23,
              frequency: 9,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8dd',
              id: 24,
              frequency: 397,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8dc',
              id: 25,
              frequency: 7058,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8db',
              id: 26,
              frequency: 14497,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8da',
              id: 27,
              frequency: 178,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8d9',
              id: 28,
              frequency: 3035,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8d8',
              id: 29,
              frequency: 13013,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8d7',
              id: 30,
              frequency: 21115,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8d6',
              id: 31,
              frequency: 542,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8d5',
              id: 32,
              frequency: 6500,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8d4',
              id: 33,
              frequency: 949,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8d3',
              id: 34,
              frequency: 463,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8d2',
              id: 35,
              frequency: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8d1',
              id: 36,
              frequency: 181,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8d0',
              id: 37,
              frequency: 1456,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8cf',
              id: 38,
              frequency: 385,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8ce',
              id: 39,
              frequency: 178,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8cd',
              id: 40,
              frequency: 14138,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8cc',
              id: 41,
              frequency: 20805,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8cb',
              id: 42,
              frequency: 8015,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8ca',
              id: 43,
              frequency: 9978,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8c9',
              id: 44,
              frequency: 7926,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8c8',
              id: 45,
              frequency: 233,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8c7',
              id: 46,
              frequency: 4720,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8c6',
              id: 47,
              frequency: 12194,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8c5',
              id: 48,
              frequency: 83314,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8c4',
              id: 49,
              frequency: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8c3',
              id: 50,
              frequency: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8c2',
              id: 51,
              frequency: 883,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8c1',
              id: 52,
              frequency: 1419,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8c0',
              id: 53,
              frequency: 7355,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8bf',
              id: 54,
              frequency: 1911,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8be',
              id: 55,
              frequency: 7561,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8bd',
              id: 56,
              frequency: 224,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8bc',
              id: 57,
              frequency: 245066,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8bb',
              id: 58,
              frequency: 42406,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8ba',
              id: 59,
              frequency: 9084,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8b9',
              id: 60,
              frequency: 67020,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8b8',
              id: 61,
              frequency: 48856,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8b7',
              id: 62,
              frequency: 281,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8b6',
              id: 63,
              frequency: 2622,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8b5',
              id: 64,
              frequency: 7217,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8b4',
              id: 65,
              frequency: 7195,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8b3',
              id: 66,
              frequency: 179824,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8b2',
              id: 67,
              frequency: 303863,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8b1',
              id: 68,
              frequency: 17333,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8b0',
              id: 69,
              frequency: 20307,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8af',
              id: 70,
              frequency: 116282,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8ae',
              id: 71,
              frequency: 642343,
            },
            {
              _id: '5d6615769bcb6d0e6d79e8ad',
              id: 72,
              frequency: 1249655,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e828',
          id: 62,
          abbrevName: '63',
          fullName: '63_R_Frontal_oribital_cortex__frontal_operculum',
          coordinates: {
            x: 42.985507,
            y: 20.299517,
            z: -0.328502,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e842',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79e841',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79e840',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79e83f',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79e83e',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79e83d',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79e83c',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79e83b',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79e83a',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79e839',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79e838',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79e837',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79e836',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79e835',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79e834',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79e833',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e832',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79e831',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79e830',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e82f',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79e82e',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79e82d',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79e82c',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79e82b',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79e82a',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79e829',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e88b',
              id: 0,
              frequency: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79e88a',
              id: 1,
              frequency: 1055,
            },
            {
              _id: '5d6615769bcb6d0e6d79e889',
              id: 2,
              frequency: 231,
            },
            {
              _id: '5d6615769bcb6d0e6d79e888',
              id: 3,
              frequency: 2544,
            },
            {
              _id: '5d6615769bcb6d0e6d79e887',
              id: 4,
              frequency: 4273,
            },
            {
              _id: '5d6615769bcb6d0e6d79e886',
              id: 5,
              frequency: 2712,
            },
            {
              _id: '5d6615769bcb6d0e6d79e885',
              id: 6,
              frequency: 1564,
            },
            {
              _id: '5d6615769bcb6d0e6d79e884',
              id: 7,
              frequency: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79e883',
              id: 8,
              frequency: 1732,
            },
            {
              _id: '5d6615769bcb6d0e6d79e882',
              id: 9,
              frequency: 6027,
            },
            {
              _id: '5d6615769bcb6d0e6d79e881',
              id: 10,
              frequency: 18382,
            },
            {
              _id: '5d6615769bcb6d0e6d79e880',
              id: 11,
              frequency: 2618,
            },
            {
              _id: '5d6615769bcb6d0e6d79e87f',
              id: 12,
              frequency: 26756,
            },
            {
              _id: '5d6615769bcb6d0e6d79e87e',
              id: 13,
              frequency: 11438,
            },
            {
              _id: '5d6615769bcb6d0e6d79e87d',
              id: 14,
              frequency: 53406,
            },
            {
              _id: '5d6615769bcb6d0e6d79e87c',
              id: 15,
              frequency: 8464,
            },
            {
              _id: '5d6615769bcb6d0e6d79e87b',
              id: 16,
              frequency: 4988,
            },
            {
              _id: '5d6615769bcb6d0e6d79e87a',
              id: 17,
              frequency: 2744,
            },
            {
              _id: '5d6615769bcb6d0e6d79e879',
              id: 18,
              frequency: 3678,
            },
            {
              _id: '5d6615769bcb6d0e6d79e878',
              id: 19,
              frequency: 5154,
            },
            {
              _id: '5d6615769bcb6d0e6d79e877',
              id: 20,
              frequency: 2838,
            },
            {
              _id: '5d6615769bcb6d0e6d79e876',
              id: 21,
              frequency: 620,
            },
            {
              _id: '5d6615769bcb6d0e6d79e875',
              id: 22,
              frequency: 592,
            },
            {
              _id: '5d6615769bcb6d0e6d79e874',
              id: 23,
              frequency: 5,
            },
            {
              _id: '5d6615769bcb6d0e6d79e873',
              id: 24,
              frequency: 18538,
            },
            {
              _id: '5d6615769bcb6d0e6d79e872',
              id: 25,
              frequency: 10861,
            },
            {
              _id: '5d6615769bcb6d0e6d79e871',
              id: 26,
              frequency: 7325,
            },
            {
              _id: '5d6615769bcb6d0e6d79e870',
              id: 27,
              frequency: 8110,
            },
            {
              _id: '5d6615769bcb6d0e6d79e86f',
              id: 28,
              frequency: 8612,
            },
            {
              _id: '5d6615769bcb6d0e6d79e86e',
              id: 29,
              frequency: 50456,
            },
            {
              _id: '5d6615769bcb6d0e6d79e86d',
              id: 30,
              frequency: 11276,
            },
            {
              _id: '5d6615769bcb6d0e6d79e86c',
              id: 31,
              frequency: 5575,
            },
            {
              _id: '5d6615769bcb6d0e6d79e86b',
              id: 32,
              frequency: 11727,
            },
            {
              _id: '5d6615769bcb6d0e6d79e86a',
              id: 33,
              frequency: 205,
            },
            {
              _id: '5d6615769bcb6d0e6d79e869',
              id: 34,
              frequency: 1526,
            },
            {
              _id: '5d6615769bcb6d0e6d79e868',
              id: 35,
              frequency: 1398,
            },
            {
              _id: '5d6615769bcb6d0e6d79e867',
              id: 36,
              frequency: 2673,
            },
            {
              _id: '5d6615769bcb6d0e6d79e866',
              id: 37,
              frequency: 5577,
            },
            {
              _id: '5d6615769bcb6d0e6d79e865',
              id: 38,
              frequency: 500,
            },
            {
              _id: '5d6615769bcb6d0e6d79e864',
              id: 39,
              frequency: 11048,
            },
            {
              _id: '5d6615769bcb6d0e6d79e863',
              id: 40,
              frequency: 56504,
            },
            {
              _id: '5d6615769bcb6d0e6d79e862',
              id: 41,
              frequency: 12742,
            },
            {
              _id: '5d6615769bcb6d0e6d79e861',
              id: 42,
              frequency: 1973,
            },
            {
              _id: '5d6615769bcb6d0e6d79e860',
              id: 43,
              frequency: 41360,
            },
            {
              _id: '5d6615769bcb6d0e6d79e85f',
              id: 44,
              frequency: 1655,
            },
            {
              _id: '5d6615769bcb6d0e6d79e85e',
              id: 45,
              frequency: 12798,
            },
            {
              _id: '5d6615769bcb6d0e6d79e85d',
              id: 46,
              frequency: 55696,
            },
            {
              _id: '5d6615769bcb6d0e6d79e85c',
              id: 47,
              frequency: 10934,
            },
            {
              _id: '5d6615769bcb6d0e6d79e85b',
              id: 48,
              frequency: 52628,
            },
            {
              _id: '5d6615769bcb6d0e6d79e85a',
              id: 49,
              frequency: 588,
            },
            {
              _id: '5d6615769bcb6d0e6d79e859',
              id: 50,
              frequency: 238,
            },
            {
              _id: '5d6615769bcb6d0e6d79e858',
              id: 51,
              frequency: 12961,
            },
            {
              _id: '5d6615769bcb6d0e6d79e857',
              id: 52,
              frequency: 7578,
            },
            {
              _id: '5d6615769bcb6d0e6d79e856',
              id: 53,
              frequency: 10453,
            },
            {
              _id: '5d6615769bcb6d0e6d79e855',
              id: 54,
              frequency: 18957,
            },
            {
              _id: '5d6615769bcb6d0e6d79e854',
              id: 55,
              frequency: 2133,
            },
            {
              _id: '5d6615769bcb6d0e6d79e853',
              id: 56,
              frequency: 19160,
            },
            {
              _id: '5d6615769bcb6d0e6d79e852',
              id: 57,
              frequency: 235697,
            },
            {
              _id: '5d6615769bcb6d0e6d79e851',
              id: 58,
              frequency: 13922,
            },
            {
              _id: '5d6615769bcb6d0e6d79e850',
              id: 59,
              frequency: 112851,
            },
            {
              _id: '5d6615769bcb6d0e6d79e84f',
              id: 60,
              frequency: 80910,
            },
            {
              _id: '5d6615769bcb6d0e6d79e84e',
              id: 61,
              frequency: 12906,
            },
            {
              _id: '5d6615769bcb6d0e6d79e84d',
              id: 62,
              frequency: 6336,
            },
            {
              _id: '5d6615769bcb6d0e6d79e84c',
              id: 63,
              frequency: 14434,
            },
            {
              _id: '5d6615769bcb6d0e6d79e84b',
              id: 64,
              frequency: 12872,
            },
            {
              _id: '5d6615769bcb6d0e6d79e84a',
              id: 65,
              frequency: 128771,
            },
            {
              _id: '5d6615769bcb6d0e6d79e849',
              id: 66,
              frequency: 333974,
            },
            {
              _id: '5d6615769bcb6d0e6d79e848',
              id: 67,
              frequency: 109942,
            },
            {
              _id: '5d6615769bcb6d0e6d79e847',
              id: 68,
              frequency: 73029,
            },
            {
              _id: '5d6615769bcb6d0e6d79e846',
              id: 69,
              frequency: 5144,
            },
            {
              _id: '5d6615769bcb6d0e6d79e845',
              id: 70,
              frequency: 455626,
            },
            {
              _id: '5d6615769bcb6d0e6d79e844',
              id: 71,
              frequency: 274446,
            },
            {
              _id: '5d6615769bcb6d0e6d79e843',
              id: 72,
              frequency: 793119,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e7c2',
          id: 63,
          abbrevName: '64',
          fullName: '64_L_Heschles',
          coordinates: {
            x: -45.182796,
            y: -25.096774,
            z: 14.236559,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e7de',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7dd',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7dc',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7db',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7da',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7d9',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7d8',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7d7',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7d6',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7d5',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7d4',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7d3',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7d2',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7d1',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7d0',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7cf',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7ce',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7cd',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7cc',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7cb',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7ca',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7c9',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7c8',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7c7',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7c6',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7c5',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7c4',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7c3',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e827',
              id: 0,
              frequency: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79e826',
              id: 1,
              frequency: 709,
            },
            {
              _id: '5d6615769bcb6d0e6d79e825',
              id: 2,
              frequency: 346,
            },
            {
              _id: '5d6615769bcb6d0e6d79e824',
              id: 3,
              frequency: 2975,
            },
            {
              _id: '5d6615769bcb6d0e6d79e823',
              id: 4,
              frequency: 2049,
            },
            {
              _id: '5d6615769bcb6d0e6d79e822',
              id: 5,
              frequency: 3364,
            },
            {
              _id: '5d6615769bcb6d0e6d79e821',
              id: 6,
              frequency: 648,
            },
            {
              _id: '5d6615769bcb6d0e6d79e820',
              id: 7,
              frequency: 150,
            },
            {
              _id: '5d6615769bcb6d0e6d79e81f',
              id: 8,
              frequency: 1069,
            },
            {
              _id: '5d6615769bcb6d0e6d79e81e',
              id: 9,
              frequency: 2570,
            },
            {
              _id: '5d6615769bcb6d0e6d79e81d',
              id: 10,
              frequency: 16919,
            },
            {
              _id: '5d6615769bcb6d0e6d79e81c',
              id: 11,
              frequency: 4926,
            },
            {
              _id: '5d6615769bcb6d0e6d79e81b',
              id: 12,
              frequency: 17504,
            },
            {
              _id: '5d6615769bcb6d0e6d79e81a',
              id: 13,
              frequency: 17378,
            },
            {
              _id: '5d6615769bcb6d0e6d79e819',
              id: 14,
              frequency: 66106,
            },
            {
              _id: '5d6615769bcb6d0e6d79e818',
              id: 15,
              frequency: 2845,
            },
            {
              _id: '5d6615769bcb6d0e6d79e817',
              id: 16,
              frequency: 4465,
            },
            {
              _id: '5d6615769bcb6d0e6d79e816',
              id: 17,
              frequency: 3566,
            },
            {
              _id: '5d6615769bcb6d0e6d79e815',
              id: 18,
              frequency: 1438,
            },
            {
              _id: '5d6615769bcb6d0e6d79e814',
              id: 19,
              frequency: 1672,
            },
            {
              _id: '5d6615769bcb6d0e6d79e813',
              id: 20,
              frequency: 2324,
            },
            {
              _id: '5d6615769bcb6d0e6d79e812',
              id: 21,
              frequency: 1397,
            },
            {
              _id: '5d6615769bcb6d0e6d79e811',
              id: 22,
              frequency: 210,
            },
            {
              _id: '5d6615769bcb6d0e6d79e810',
              id: 23,
              frequency: 2,
            },
            {
              _id: '5d6615769bcb6d0e6d79e80f',
              id: 24,
              frequency: 5843,
            },
            {
              _id: '5d6615769bcb6d0e6d79e80e',
              id: 25,
              frequency: 8511,
            },
            {
              _id: '5d6615769bcb6d0e6d79e80d',
              id: 26,
              frequency: 14950,
            },
            {
              _id: '5d6615769bcb6d0e6d79e80c',
              id: 27,
              frequency: 2615,
            },
            {
              _id: '5d6615769bcb6d0e6d79e80b',
              id: 28,
              frequency: 8195,
            },
            {
              _id: '5d6615769bcb6d0e6d79e80a',
              id: 29,
              frequency: 33151,
            },
            {
              _id: '5d6615769bcb6d0e6d79e809',
              id: 30,
              frequency: 18398,
            },
            {
              _id: '5d6615769bcb6d0e6d79e808',
              id: 31,
              frequency: 1499,
            },
            {
              _id: '5d6615769bcb6d0e6d79e807',
              id: 32,
              frequency: 8935,
            },
            {
              _id: '5d6615769bcb6d0e6d79e806',
              id: 33,
              frequency: 621,
            },
            {
              _id: '5d6615769bcb6d0e6d79e805',
              id: 34,
              frequency: 1887,
            },
            {
              _id: '5d6615769bcb6d0e6d79e804',
              id: 35,
              frequency: 353,
            },
            {
              _id: '5d6615769bcb6d0e6d79e803',
              id: 36,
              frequency: 1356,
            },
            {
              _id: '5d6615769bcb6d0e6d79e802',
              id: 37,
              frequency: 2426,
            },
            {
              _id: '5d6615769bcb6d0e6d79e801',
              id: 38,
              frequency: 701,
            },
            {
              _id: '5d6615769bcb6d0e6d79e800',
              id: 39,
              frequency: 2434,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7ff',
              id: 40,
              frequency: 25223,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7fe',
              id: 41,
              frequency: 17973,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7fd',
              id: 42,
              frequency: 5767,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7fc',
              id: 43,
              frequency: 31034,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7fb',
              id: 44,
              frequency: 4328,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7fa',
              id: 45,
              frequency: 3707,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7f9',
              id: 46,
              frequency: 25894,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7f8',
              id: 47,
              frequency: 18891,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7f7',
              id: 48,
              frequency: 71069,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7f6',
              id: 49,
              frequency: 231,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7f5',
              id: 50,
              frequency: 163,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7f4',
              id: 51,
              frequency: 6545,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7f3',
              id: 52,
              frequency: 5061,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7f2',
              id: 53,
              frequency: 10630,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7f1',
              id: 54,
              frequency: 6559,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7f0',
              id: 55,
              frequency: 4833,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7ef',
              id: 56,
              frequency: 5286,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7ee',
              id: 57,
              frequency: 249164,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7ed',
              id: 58,
              frequency: 35963,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7ec',
              id: 59,
              frequency: 53412,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7eb',
              id: 60,
              frequency: 93697,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7ea',
              id: 61,
              frequency: 28128,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7e9',
              id: 62,
              frequency: 1850,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7e8',
              id: 63,
              frequency: 7831,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7e7',
              id: 64,
              frequency: 12208,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7e6',
              id: 65,
              frequency: 52642,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7e5',
              id: 66,
              frequency: 302242,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7e4',
              id: 67,
              frequency: 194921,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7e3',
              id: 68,
              frequency: 45830,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7e2',
              id: 69,
              frequency: 10510,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7e1',
              id: 70,
              frequency: 295333,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7e0',
              id: 71,
              frequency: 432229,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7df',
              id: 72,
              frequency: 1031758,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e75d',
          id: 64,
          abbrevName: '65',
          fullName: '65_L_MTG_temporooccipital__loc_inferio',
          coordinates: {
            x: -1.55814,
            y: 26.27907,
            z: 55.534884,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e778',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79e777',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79e776',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79e775',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79e774',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79e773',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79e772',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79e771',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79e770',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79e76f',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79e76e',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79e76d',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79e76c',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79e76b',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79e76a',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79e769',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e768',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79e767',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79e766',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e765',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79e764',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79e763',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79e762',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79e761',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79e760',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79e75f',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79e75e',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e7c1',
              id: 0,
              frequency: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7c0',
              id: 1,
              frequency: 766,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7bf',
              id: 2,
              frequency: 336,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7be',
              id: 3,
              frequency: 2904,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7bd',
              id: 4,
              frequency: 2852,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7bc',
              id: 5,
              frequency: 2943,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7bb',
              id: 6,
              frequency: 791,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7ba',
              id: 7,
              frequency: 158,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7b9',
              id: 8,
              frequency: 1510,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7b8',
              id: 9,
              frequency: 2821,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7b7',
              id: 10,
              frequency: 16115,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7b6',
              id: 11,
              frequency: 4693,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7b5',
              id: 12,
              frequency: 19601,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7b4',
              id: 13,
              frequency: 16684,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7b3',
              id: 14,
              frequency: 63785,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7b2',
              id: 15,
              frequency: 3435,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7b1',
              id: 16,
              frequency: 5864,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7b0',
              id: 17,
              frequency: 3094,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7af',
              id: 18,
              frequency: 2348,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7ae',
              id: 19,
              frequency: 3167,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7ad',
              id: 20,
              frequency: 1939,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7ac',
              id: 21,
              frequency: 1028,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7ab',
              id: 22,
              frequency: 146,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7aa',
              id: 23,
              frequency: 1,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7a9',
              id: 24,
              frequency: 8622,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7a8',
              id: 25,
              frequency: 9953,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7a7',
              id: 26,
              frequency: 11395,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7a6',
              id: 27,
              frequency: 4065,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7a5',
              id: 28,
              frequency: 5932,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7a4',
              id: 29,
              frequency: 40589,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7a3',
              id: 30,
              frequency: 14352,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7a2',
              id: 31,
              frequency: 1950,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7a1',
              id: 32,
              frequency: 8161,
            },
            {
              _id: '5d6615769bcb6d0e6d79e7a0',
              id: 33,
              frequency: 1134,
            },
            {
              _id: '5d6615769bcb6d0e6d79e79f',
              id: 34,
              frequency: 1707,
            },
            {
              _id: '5d6615769bcb6d0e6d79e79e',
              id: 35,
              frequency: 457,
            },
            {
              _id: '5d6615769bcb6d0e6d79e79d',
              id: 36,
              frequency: 2719,
            },
            {
              _id: '5d6615769bcb6d0e6d79e79c',
              id: 37,
              frequency: 3438,
            },
            {
              _id: '5d6615769bcb6d0e6d79e79b',
              id: 38,
              frequency: 937,
            },
            {
              _id: '5d6615769bcb6d0e6d79e79a',
              id: 39,
              frequency: 3492,
            },
            {
              _id: '5d6615769bcb6d0e6d79e799',
              id: 40,
              frequency: 29580,
            },
            {
              _id: '5d6615769bcb6d0e6d79e798',
              id: 41,
              frequency: 16599,
            },
            {
              _id: '5d6615769bcb6d0e6d79e797',
              id: 42,
              frequency: 5678,
            },
            {
              _id: '5d6615769bcb6d0e6d79e796',
              id: 43,
              frequency: 24651,
            },
            {
              _id: '5d6615769bcb6d0e6d79e795',
              id: 44,
              frequency: 5062,
            },
            {
              _id: '5d6615769bcb6d0e6d79e794',
              id: 45,
              frequency: 5368,
            },
            {
              _id: '5d6615769bcb6d0e6d79e793',
              id: 46,
              frequency: 44501,
            },
            {
              _id: '5d6615769bcb6d0e6d79e792',
              id: 47,
              frequency: 15514,
            },
            {
              _id: '5d6615769bcb6d0e6d79e791',
              id: 48,
              frequency: 60146,
            },
            {
              _id: '5d6615769bcb6d0e6d79e790',
              id: 49,
              frequency: 387,
            },
            {
              _id: '5d6615769bcb6d0e6d79e78f',
              id: 50,
              frequency: 425,
            },
            {
              _id: '5d6615769bcb6d0e6d79e78e',
              id: 51,
              frequency: 8608,
            },
            {
              _id: '5d6615769bcb6d0e6d79e78d',
              id: 52,
              frequency: 5241,
            },
            {
              _id: '5d6615769bcb6d0e6d79e78c',
              id: 53,
              frequency: 12466,
            },
            {
              _id: '5d6615769bcb6d0e6d79e78b',
              id: 54,
              frequency: 9694,
            },
            {
              _id: '5d6615769bcb6d0e6d79e78a',
              id: 55,
              frequency: 4374,
            },
            {
              _id: '5d6615769bcb6d0e6d79e789',
              id: 56,
              frequency: 5489,
            },
            {
              _id: '5d6615769bcb6d0e6d79e788',
              id: 57,
              frequency: 232364,
            },
            {
              _id: '5d6615769bcb6d0e6d79e787',
              id: 58,
              frequency: 30503,
            },
            {
              _id: '5d6615769bcb6d0e6d79e786',
              id: 59,
              frequency: 64763,
            },
            {
              _id: '5d6615769bcb6d0e6d79e785',
              id: 60,
              frequency: 84828,
            },
            {
              _id: '5d6615769bcb6d0e6d79e784',
              id: 61,
              frequency: 24915,
            },
            {
              _id: '5d6615769bcb6d0e6d79e783',
              id: 62,
              frequency: 3288,
            },
            {
              _id: '5d6615769bcb6d0e6d79e782',
              id: 63,
              frequency: 14786,
            },
            {
              _id: '5d6615769bcb6d0e6d79e781',
              id: 64,
              frequency: 13692,
            },
            {
              _id: '5d6615769bcb6d0e6d79e780',
              id: 65,
              frequency: 57575,
            },
            {
              _id: '5d6615769bcb6d0e6d79e77f',
              id: 66,
              frequency: 289470,
            },
            {
              _id: '5d6615769bcb6d0e6d79e77e',
              id: 67,
              frequency: 190843,
            },
            {
              _id: '5d6615769bcb6d0e6d79e77d',
              id: 68,
              frequency: 61348,
            },
            {
              _id: '5d6615769bcb6d0e6d79e77c',
              id: 69,
              frequency: 8125,
            },
            {
              _id: '5d6615769bcb6d0e6d79e77b',
              id: 70,
              frequency: 340395,
            },
            {
              _id: '5d6615769bcb6d0e6d79e77a',
              id: 71,
              frequency: 409268,
            },
            {
              _id: '5d6615769bcb6d0e6d79e779',
              id: 72,
              frequency: 983837,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e6f6',
          id: 65,
          abbrevName: '66',
          fullName: '66_R_Frontal_pole',
          coordinates: {
            x: 19.393939,
            y: 62.787879,
            z: -7.414141,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e713',
              to: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d79e712',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79e711',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79e710',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79e70f',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79e70e',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79e70d',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79e70c',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79e70b',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79e70a',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79e709',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79e708',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79e707',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79e706',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79e705',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79e704',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79e703',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79e702',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e701',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79e700',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6ff',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6fe',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6fd',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6fc',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6fb',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6fa',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6f9',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6f8',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6f7',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e75c',
              id: 0,
              frequency: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e75b',
              id: 1,
              frequency: 690,
            },
            {
              _id: '5d6615769bcb6d0e6d79e75a',
              id: 2,
              frequency: 474,
            },
            {
              _id: '5d6615769bcb6d0e6d79e759',
              id: 3,
              frequency: 3012,
            },
            {
              _id: '5d6615769bcb6d0e6d79e758',
              id: 4,
              frequency: 1634,
            },
            {
              _id: '5d6615769bcb6d0e6d79e757',
              id: 5,
              frequency: 3974,
            },
            {
              _id: '5d6615769bcb6d0e6d79e756',
              id: 6,
              frequency: 838,
            },
            {
              _id: '5d6615769bcb6d0e6d79e755',
              id: 7,
              frequency: 351,
            },
            {
              _id: '5d6615769bcb6d0e6d79e754',
              id: 8,
              frequency: 1342,
            },
            {
              _id: '5d6615769bcb6d0e6d79e753',
              id: 9,
              frequency: 1992,
            },
            {
              _id: '5d6615769bcb6d0e6d79e752',
              id: 10,
              frequency: 14198,
            },
            {
              _id: '5d6615769bcb6d0e6d79e751',
              id: 11,
              frequency: 8905,
            },
            {
              _id: '5d6615769bcb6d0e6d79e750',
              id: 12,
              frequency: 18207,
            },
            {
              _id: '5d6615769bcb6d0e6d79e74f',
              id: 13,
              frequency: 20005,
            },
            {
              _id: '5d6615769bcb6d0e6d79e74e',
              id: 14,
              frequency: 66023,
            },
            {
              _id: '5d6615769bcb6d0e6d79e74d',
              id: 15,
              frequency: 1601,
            },
            {
              _id: '5d6615769bcb6d0e6d79e74c',
              id: 16,
              frequency: 5165,
            },
            {
              _id: '5d6615769bcb6d0e6d79e74b',
              id: 17,
              frequency: 4115,
            },
            {
              _id: '5d6615769bcb6d0e6d79e74a',
              id: 18,
              frequency: 984,
            },
            {
              _id: '5d6615769bcb6d0e6d79e749',
              id: 19,
              frequency: 2296,
            },
            {
              _id: '5d6615769bcb6d0e6d79e748',
              id: 20,
              frequency: 2685,
            },
            {
              _id: '5d6615769bcb6d0e6d79e747',
              id: 21,
              frequency: 2315,
            },
            {
              _id: '5d6615769bcb6d0e6d79e746',
              id: 22,
              frequency: 192,
            },
            {
              _id: '5d6615769bcb6d0e6d79e745',
              id: 23,
              frequency: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d79e744',
              id: 24,
              frequency: 4009,
            },
            {
              _id: '5d6615769bcb6d0e6d79e743',
              id: 25,
              frequency: 7170,
            },
            {
              _id: '5d6615769bcb6d0e6d79e742',
              id: 26,
              frequency: 21216,
            },
            {
              _id: '5d6615769bcb6d0e6d79e741',
              id: 27,
              frequency: 1582,
            },
            {
              _id: '5d6615769bcb6d0e6d79e740',
              id: 28,
              frequency: 7599,
            },
            {
              _id: '5d6615769bcb6d0e6d79e73f',
              id: 29,
              frequency: 23081,
            },
            {
              _id: '5d6615769bcb6d0e6d79e73e',
              id: 30,
              frequency: 20947,
            },
            {
              _id: '5d6615769bcb6d0e6d79e73d',
              id: 31,
              frequency: 1973,
            },
            {
              _id: '5d6615769bcb6d0e6d79e73c',
              id: 32,
              frequency: 8304,
            },
            {
              _id: '5d6615769bcb6d0e6d79e73b',
              id: 33,
              frequency: 2558,
            },
            {
              _id: '5d6615769bcb6d0e6d79e73a',
              id: 34,
              frequency: 1532,
            },
            {
              _id: '5d6615769bcb6d0e6d79e739',
              id: 35,
              frequency: 275,
            },
            {
              _id: '5d6615769bcb6d0e6d79e738',
              id: 36,
              frequency: 1616,
            },
            {
              _id: '5d6615769bcb6d0e6d79e737',
              id: 37,
              frequency: 3517,
            },
            {
              _id: '5d6615769bcb6d0e6d79e736',
              id: 38,
              frequency: 1722,
            },
            {
              _id: '5d6615769bcb6d0e6d79e735',
              id: 39,
              frequency: 2598,
            },
            {
              _id: '5d6615769bcb6d0e6d79e734',
              id: 40,
              frequency: 29178,
            },
            {
              _id: '5d6615769bcb6d0e6d79e733',
              id: 41,
              frequency: 17082,
            },
            {
              _id: '5d6615769bcb6d0e6d79e732',
              id: 42,
              frequency: 17044,
            },
            {
              _id: '5d6615769bcb6d0e6d79e731',
              id: 43,
              frequency: 17081,
            },
            {
              _id: '5d6615769bcb6d0e6d79e730',
              id: 44,
              frequency: 10698,
            },
            {
              _id: '5d6615769bcb6d0e6d79e72f',
              id: 45,
              frequency: 2072,
            },
            {
              _id: '5d6615769bcb6d0e6d79e72e',
              id: 46,
              frequency: 23078,
            },
            {
              _id: '5d6615769bcb6d0e6d79e72d',
              id: 47,
              frequency: 40284,
            },
            {
              _id: '5d6615769bcb6d0e6d79e72c',
              id: 48,
              frequency: 60123,
            },
            {
              _id: '5d6615769bcb6d0e6d79e72b',
              id: 49,
              frequency: 332,
            },
            {
              _id: '5d6615769bcb6d0e6d79e72a',
              id: 50,
              frequency: 270,
            },
            {
              _id: '5d6615769bcb6d0e6d79e729',
              id: 51,
              frequency: 6405,
            },
            {
              _id: '5d6615769bcb6d0e6d79e728',
              id: 52,
              frequency: 3288,
            },
            {
              _id: '5d6615769bcb6d0e6d79e727',
              id: 53,
              frequency: 14544,
            },
            {
              _id: '5d6615769bcb6d0e6d79e726',
              id: 54,
              frequency: 12603,
            },
            {
              _id: '5d6615769bcb6d0e6d79e725',
              id: 55,
              frequency: 6147,
            },
            {
              _id: '5d6615769bcb6d0e6d79e724',
              id: 56,
              frequency: 2770,
            },
            {
              _id: '5d6615769bcb6d0e6d79e723',
              id: 57,
              frequency: 192409,
            },
            {
              _id: '5d6615769bcb6d0e6d79e722',
              id: 58,
              frequency: 97074,
            },
            {
              _id: '5d6615769bcb6d0e6d79e721',
              id: 59,
              frequency: 41943,
            },
            {
              _id: '5d6615769bcb6d0e6d79e720',
              id: 60,
              frequency: 99449,
            },
            {
              _id: '5d6615769bcb6d0e6d79e71f',
              id: 61,
              frequency: 46299,
            },
            {
              _id: '5d6615769bcb6d0e6d79e71e',
              id: 62,
              frequency: 1932,
            },
            {
              _id: '5d6615769bcb6d0e6d79e71d',
              id: 63,
              frequency: 13140,
            },
            {
              _id: '5d6615769bcb6d0e6d79e71c',
              id: 64,
              frequency: 11994,
            },
            {
              _id: '5d6615769bcb6d0e6d79e71b',
              id: 65,
              frequency: 44222,
            },
            {
              _id: '5d6615769bcb6d0e6d79e71a',
              id: 66,
              frequency: 262967,
            },
            {
              _id: '5d6615769bcb6d0e6d79e719',
              id: 67,
              frequency: 255489,
            },
            {
              _id: '5d6615769bcb6d0e6d79e718',
              id: 68,
              frequency: 54694,
            },
            {
              _id: '5d6615769bcb6d0e6d79e717',
              id: 69,
              frequency: 12195,
            },
            {
              _id: '5d6615769bcb6d0e6d79e716',
              id: 70,
              frequency: 322582,
            },
            {
              _id: '5d6615769bcb6d0e6d79e715',
              id: 71,
              frequency: 466282,
            },
            {
              _id: '5d6615769bcb6d0e6d79e714',
              id: 72,
              frequency: 1015684,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e6a2',
          id: 66,
          abbrevName: '67',
          fullName: '67_L_Frontal_orbital',
          coordinates: {
            x: -7.508982,
            y: 20.51497,
            z: -16.45509,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e6ac',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6ab',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6aa',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6a9',
              to: 99,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6a8',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6a7',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6a6',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6a5',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6a4',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6a3',
              to: 69,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e6f5',
              id: 0,
              frequency: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6f4',
              id: 1,
              frequency: 1146,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6f3',
              id: 2,
              frequency: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6f2',
              id: 3,
              frequency: 195,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6f1',
              id: 4,
              frequency: 13640,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6f0',
              id: 5,
              frequency: 742,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6ef',
              id: 6,
              frequency: 3583,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6ee',
              id: 7,
              frequency: 1,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6ed',
              id: 8,
              frequency: 273,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6ec',
              id: 9,
              frequency: 30784,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6eb',
              id: 10,
              frequency: 5108,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6ea',
              id: 11,
              frequency: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6e9',
              id: 12,
              frequency: 8262,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6e8',
              id: 13,
              frequency: 222,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6e7',
              id: 14,
              frequency: 1077,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6e6',
              id: 15,
              frequency: 41599,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6e5',
              id: 16,
              frequency: 5457,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6e4',
              id: 17,
              frequency: 1240,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6e3',
              id: 18,
              frequency: 13091,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6e2',
              id: 19,
              frequency: 28332,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6e1',
              id: 20,
              frequency: 1337,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6e0',
              id: 21,
              frequency: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6df',
              id: 22,
              frequency: 2509,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6de',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6dd',
              id: 24,
              frequency: 107322,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6dc',
              id: 25,
              frequency: 6711,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6db',
              id: 26,
              frequency: 344,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6da',
              id: 27,
              frequency: 130354,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6d9',
              id: 28,
              frequency: 14928,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6d8',
              id: 29,
              frequency: 37089,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6d7',
              id: 30,
              frequency: 277,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6d6',
              id: 31,
              frequency: 46104,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6d5',
              id: 32,
              frequency: 6133,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6d4',
              id: 33,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6d3',
              id: 34,
              frequency: 1430,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6d2',
              id: 35,
              frequency: 13581,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6d1',
              id: 36,
              frequency: 1450,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6d0',
              id: 37,
              frequency: 1721,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6cf',
              id: 38,
              frequency: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6ce',
              id: 39,
              frequency: 120975,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6cd',
              id: 40,
              frequency: 32523,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6cc',
              id: 41,
              frequency: 1022,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6cb',
              id: 42,
              frequency: 6,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6ca',
              id: 43,
              frequency: 68084,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6c9',
              id: 44,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6c8',
              id: 45,
              frequency: 256984,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6c7',
              id: 46,
              frequency: 33771,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6c6',
              id: 47,
              frequency: 988,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6c5',
              id: 48,
              frequency: 2948,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6c4',
              id: 49,
              frequency: 185,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6c3',
              id: 50,
              frequency: 7,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6c2',
              id: 51,
              frequency: 9754,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6c1',
              id: 52,
              frequency: 6944,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6c0',
              id: 53,
              frequency: 280,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6bf',
              id: 54,
              frequency: 14788,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6be',
              id: 55,
              frequency: 12,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6bd',
              id: 56,
              frequency: 535778,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6bc',
              id: 57,
              frequency: 13751,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6bb',
              id: 58,
              frequency: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6ba',
              id: 59,
              frequency: 133310,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6b9',
              id: 60,
              frequency: 7860,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6b8',
              id: 61,
              frequency: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6b7',
              id: 62,
              frequency: 3466,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6b6',
              id: 63,
              frequency: 292,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6b5',
              id: 64,
              frequency: 555,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6b4',
              id: 65,
              frequency: 191336,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6b3',
              id: 66,
              frequency: 27482,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6b2',
              id: 67,
              frequency: 397,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6b1',
              id: 68,
              frequency: 3709,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6b0',
              id: 69,
              frequency: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6af',
              id: 70,
              frequency: 37646,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6ae',
              id: 71,
              frequency: 1479,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6ad',
              id: 72,
              frequency: 4002,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e63b',
          id: 67,
          abbrevName: '68',
          fullName: '68_L_MTG_temporooccipital_smg_angular',
          coordinates: {
            x: -56.381818,
            y: -53.563636,
            z: 10.836364,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e658',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d79e657',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79e656',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79e655',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79e654',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79e653',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79e652',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79e651',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79e650',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79e64f',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79e64e',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79e64d',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79e64c',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79e64b',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79e64a',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79e649',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79e648',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e647',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79e646',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79e645',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e644',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e643',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79e642',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79e641',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79e640',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79e63f',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79e63e',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79e63d',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79e63c',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e6a1',
              id: 0,
              frequency: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79e6a0',
              id: 1,
              frequency: 224,
            },
            {
              _id: '5d6615769bcb6d0e6d79e69f',
              id: 2,
              frequency: 672,
            },
            {
              _id: '5d6615769bcb6d0e6d79e69e',
              id: 3,
              frequency: 3514,
            },
            {
              _id: '5d6615769bcb6d0e6d79e69d',
              id: 4,
              frequency: 394,
            },
            {
              _id: '5d6615769bcb6d0e6d79e69c',
              id: 5,
              frequency: 2307,
            },
            {
              _id: '5d6615769bcb6d0e6d79e69b',
              id: 6,
              frequency: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d79e69a',
              id: 7,
              frequency: 800,
            },
            {
              _id: '5d6615769bcb6d0e6d79e699',
              id: 8,
              frequency: 400,
            },
            {
              _id: '5d6615769bcb6d0e6d79e698',
              id: 9,
              frequency: 199,
            },
            {
              _id: '5d6615769bcb6d0e6d79e697',
              id: 10,
              frequency: 7715,
            },
            {
              _id: '5d6615769bcb6d0e6d79e696',
              id: 11,
              frequency: 14121,
            },
            {
              _id: '5d6615769bcb6d0e6d79e695',
              id: 12,
              frequency: 4781,
            },
            {
              _id: '5d6615769bcb6d0e6d79e694',
              id: 13,
              frequency: 29838,
            },
            {
              _id: '5d6615769bcb6d0e6d79e693',
              id: 14,
              frequency: 80821,
            },
            {
              _id: '5d6615769bcb6d0e6d79e692',
              id: 15,
              frequency: 127,
            },
            {
              _id: '5d6615769bcb6d0e6d79e691',
              id: 16,
              frequency: 2409,
            },
            {
              _id: '5d6615769bcb6d0e6d79e690',
              id: 17,
              frequency: 1006,
            },
            {
              _id: '5d6615769bcb6d0e6d79e68f',
              id: 18,
              frequency: 176,
            },
            {
              _id: '5d6615769bcb6d0e6d79e68e',
              id: 19,
              frequency: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79e68d',
              id: 20,
              frequency: 534,
            },
            {
              _id: '5d6615769bcb6d0e6d79e68c',
              id: 21,
              frequency: 2685,
            },
            {
              _id: '5d6615769bcb6d0e6d79e68b',
              id: 22,
              frequency: 4,
            },
            {
              _id: '5d6615769bcb6d0e6d79e68a',
              id: 23,
              frequency: 187,
            },
            {
              _id: '5d6615769bcb6d0e6d79e689',
              id: 24,
              frequency: 288,
            },
            {
              _id: '5d6615769bcb6d0e6d79e688',
              id: 25,
              frequency: 1602,
            },
            {
              _id: '5d6615769bcb6d0e6d79e687',
              id: 26,
              frequency: 18755,
            },
            {
              _id: '5d6615769bcb6d0e6d79e686',
              id: 27,
              frequency: 157,
            },
            {
              _id: '5d6615769bcb6d0e6d79e685',
              id: 28,
              frequency: 1474,
            },
            {
              _id: '5d6615769bcb6d0e6d79e684',
              id: 29,
              frequency: 9729,
            },
            {
              _id: '5d6615769bcb6d0e6d79e683',
              id: 30,
              frequency: 21383,
            },
            {
              _id: '5d6615769bcb6d0e6d79e682',
              id: 31,
              frequency: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79e681',
              id: 32,
              frequency: 1725,
            },
            {
              _id: '5d6615769bcb6d0e6d79e680',
              id: 33,
              frequency: 8192,
            },
            {
              _id: '5d6615769bcb6d0e6d79e67f',
              id: 34,
              frequency: 518,
            },
            {
              _id: '5d6615769bcb6d0e6d79e67e',
              id: 35,
              frequency: 8,
            },
            {
              _id: '5d6615769bcb6d0e6d79e67d',
              id: 36,
              frequency: 438,
            },
            {
              _id: '5d6615769bcb6d0e6d79e67c',
              id: 37,
              frequency: 219,
            },
            {
              _id: '5d6615769bcb6d0e6d79e67b',
              id: 38,
              frequency: 1155,
            },
            {
              _id: '5d6615769bcb6d0e6d79e67a',
              id: 39,
              frequency: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d79e679',
              id: 40,
              frequency: 2168,
            },
            {
              _id: '5d6615769bcb6d0e6d79e678',
              id: 41,
              frequency: 17241,
            },
            {
              _id: '5d6615769bcb6d0e6d79e677',
              id: 42,
              frequency: 38793,
            },
            {
              _id: '5d6615769bcb6d0e6d79e676',
              id: 43,
              frequency: 3801,
            },
            {
              _id: '5d6615769bcb6d0e6d79e675',
              id: 44,
              frequency: 20499,
            },
            {
              _id: '5d6615769bcb6d0e6d79e674',
              id: 45,
              frequency: 123,
            },
            {
              _id: '5d6615769bcb6d0e6d79e673',
              id: 46,
              frequency: 6521,
            },
            {
              _id: '5d6615769bcb6d0e6d79e672',
              id: 47,
              frequency: 15939,
            },
            {
              _id: '5d6615769bcb6d0e6d79e671',
              id: 48,
              frequency: 52923,
            },
            {
              _id: '5d6615769bcb6d0e6d79e670',
              id: 49,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79e66f',
              id: 50,
              frequency: 103,
            },
            {
              _id: '5d6615769bcb6d0e6d79e66e',
              id: 51,
              frequency: 902,
            },
            {
              _id: '5d6615769bcb6d0e6d79e66d',
              id: 52,
              frequency: 927,
            },
            {
              _id: '5d6615769bcb6d0e6d79e66c',
              id: 53,
              frequency: 7757,
            },
            {
              _id: '5d6615769bcb6d0e6d79e66b',
              id: 54,
              frequency: 134,
            },
            {
              _id: '5d6615769bcb6d0e6d79e66a',
              id: 55,
              frequency: 15275,
            },
            {
              _id: '5d6615769bcb6d0e6d79e669',
              id: 56,
              frequency: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79e668',
              id: 57,
              frequency: 142352,
            },
            {
              _id: '5d6615769bcb6d0e6d79e667',
              id: 58,
              frequency: 152847,
            },
            {
              _id: '5d6615769bcb6d0e6d79e666',
              id: 59,
              frequency: 6006,
            },
            {
              _id: '5d6615769bcb6d0e6d79e665',
              id: 60,
              frequency: 45871,
            },
            {
              _id: '5d6615769bcb6d0e6d79e664',
              id: 61,
              frequency: 90263,
            },
            {
              _id: '5d6615769bcb6d0e6d79e663',
              id: 62,
              frequency: 128,
            },
            {
              _id: '5d6615769bcb6d0e6d79e662',
              id: 63,
              frequency: 3307,
            },
            {
              _id: '5d6615769bcb6d0e6d79e661',
              id: 64,
              frequency: 6164,
            },
            {
              _id: '5d6615769bcb6d0e6d79e660',
              id: 65,
              frequency: 2835,
            },
            {
              _id: '5d6615769bcb6d0e6d79e65f',
              id: 66,
              frequency: 118765,
            },
            {
              _id: '5d6615769bcb6d0e6d79e65e',
              id: 67,
              frequency: 441736,
            },
            {
              _id: '5d6615769bcb6d0e6d79e65d',
              id: 68,
              frequency: 14001,
            },
            {
              _id: '5d6615769bcb6d0e6d79e65c',
              id: 69,
              frequency: 21936,
            },
            {
              _id: '5d6615769bcb6d0e6d79e65b',
              id: 70,
              frequency: 72802,
            },
            {
              _id: '5d6615769bcb6d0e6d79e65a',
              id: 71,
              frequency: 709611,
            },
            {
              _id: '5d6615769bcb6d0e6d79e659',
              id: 72,
              frequency: 1294816,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e5db',
          id: 68,
          abbrevName: '69',
          fullName: '69_BI_ACC_M_AMCC',
          coordinates: {
            x: 0.349776,
            y: 8.547085,
            z: 39.408072,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e5f1',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5f0',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5ef',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5ee',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5ed',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5ec',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5eb',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5ea',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5e9',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5e8',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5e7',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5e6',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5e5',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5e4',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5e3',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5e2',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5e1',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5e0',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5df',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5de',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5dd',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5dc',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e63a',
              id: 0,
              frequency: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e639',
              id: 1,
              frequency: 584,
            },
            {
              _id: '5d6615769bcb6d0e6d79e638',
              id: 2,
              frequency: 372,
            },
            {
              _id: '5d6615769bcb6d0e6d79e637',
              id: 3,
              frequency: 3114,
            },
            {
              _id: '5d6615769bcb6d0e6d79e636',
              id: 4,
              frequency: 1553,
            },
            {
              _id: '5d6615769bcb6d0e6d79e635',
              id: 5,
              frequency: 3125,
            },
            {
              _id: '5d6615769bcb6d0e6d79e634',
              id: 6,
              frequency: 396,
            },
            {
              _id: '5d6615769bcb6d0e6d79e633',
              id: 7,
              frequency: 225,
            },
            {
              _id: '5d6615769bcb6d0e6d79e632',
              id: 8,
              frequency: 843,
            },
            {
              _id: '5d6615769bcb6d0e6d79e631',
              id: 9,
              frequency: 1832,
            },
            {
              _id: '5d6615769bcb6d0e6d79e630',
              id: 10,
              frequency: 15807,
            },
            {
              _id: '5d6615769bcb6d0e6d79e62f',
              id: 11,
              frequency: 5099,
            },
            {
              _id: '5d6615769bcb6d0e6d79e62e',
              id: 12,
              frequency: 13927,
            },
            {
              _id: '5d6615769bcb6d0e6d79e62d',
              id: 13,
              frequency: 19631,
            },
            {
              _id: '5d6615769bcb6d0e6d79e62c',
              id: 14,
              frequency: 70329,
            },
            {
              _id: '5d6615769bcb6d0e6d79e62b',
              id: 15,
              frequency: 2233,
            },
            {
              _id: '5d6615769bcb6d0e6d79e62a',
              id: 16,
              frequency: 4711,
            },
            {
              _id: '5d6615769bcb6d0e6d79e629',
              id: 17,
              frequency: 2300,
            },
            {
              _id: '5d6615769bcb6d0e6d79e628',
              id: 18,
              frequency: 757,
            },
            {
              _id: '5d6615769bcb6d0e6d79e627',
              id: 19,
              frequency: 782,
            },
            {
              _id: '5d6615769bcb6d0e6d79e626',
              id: 20,
              frequency: 2095,
            },
            {
              _id: '5d6615769bcb6d0e6d79e625',
              id: 21,
              frequency: 1814,
            },
            {
              _id: '5d6615769bcb6d0e6d79e624',
              id: 22,
              frequency: 131,
            },
            {
              _id: '5d6615769bcb6d0e6d79e623',
              id: 23,
              frequency: 10,
            },
            {
              _id: '5d6615769bcb6d0e6d79e622',
              id: 24,
              frequency: 3628,
            },
            {
              _id: '5d6615769bcb6d0e6d79e621',
              id: 25,
              frequency: 6827,
            },
            {
              _id: '5d6615769bcb6d0e6d79e620',
              id: 26,
              frequency: 13550,
            },
            {
              _id: '5d6615769bcb6d0e6d79e61f',
              id: 27,
              frequency: 1981,
            },
            {
              _id: '5d6615769bcb6d0e6d79e61e',
              id: 28,
              frequency: 7611,
            },
            {
              _id: '5d6615769bcb6d0e6d79e61d',
              id: 29,
              frequency: 33147,
            },
            {
              _id: '5d6615769bcb6d0e6d79e61c',
              id: 30,
              frequency: 16413,
            },
            {
              _id: '5d6615769bcb6d0e6d79e61b',
              id: 31,
              frequency: 957,
            },
            {
              _id: '5d6615769bcb6d0e6d79e61a',
              id: 32,
              frequency: 7077,
            },
            {
              _id: '5d6615769bcb6d0e6d79e619',
              id: 33,
              frequency: 1265,
            },
            {
              _id: '5d6615769bcb6d0e6d79e618',
              id: 34,
              frequency: 974,
            },
            {
              _id: '5d6615769bcb6d0e6d79e617',
              id: 35,
              frequency: 135,
            },
            {
              _id: '5d6615769bcb6d0e6d79e616',
              id: 36,
              frequency: 828,
            },
            {
              _id: '5d6615769bcb6d0e6d79e615',
              id: 37,
              frequency: 1643,
            },
            {
              _id: '5d6615769bcb6d0e6d79e614',
              id: 38,
              frequency: 933,
            },
            {
              _id: '5d6615769bcb6d0e6d79e613',
              id: 39,
              frequency: 1170,
            },
            {
              _id: '5d6615769bcb6d0e6d79e612',
              id: 40,
              frequency: 17587,
            },
            {
              _id: '5d6615769bcb6d0e6d79e611',
              id: 41,
              frequency: 18855,
            },
            {
              _id: '5d6615769bcb6d0e6d79e610',
              id: 42,
              frequency: 8263,
            },
            {
              _id: '5d6615769bcb6d0e6d79e60f',
              id: 43,
              frequency: 28288,
            },
            {
              _id: '5d6615769bcb6d0e6d79e60e',
              id: 44,
              frequency: 3966,
            },
            {
              _id: '5d6615769bcb6d0e6d79e60d',
              id: 45,
              frequency: 2513,
            },
            {
              _id: '5d6615769bcb6d0e6d79e60c',
              id: 46,
              frequency: 20174,
            },
            {
              _id: '5d6615769bcb6d0e6d79e60b',
              id: 47,
              frequency: 15014,
            },
            {
              _id: '5d6615769bcb6d0e6d79e60a',
              id: 48,
              frequency: 75307,
            },
            {
              _id: '5d6615769bcb6d0e6d79e609',
              id: 49,
              frequency: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d79e608',
              id: 50,
              frequency: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79e607',
              id: 51,
              frequency: 4211,
            },
            {
              _id: '5d6615769bcb6d0e6d79e606',
              id: 52,
              frequency: 3284,
            },
            {
              _id: '5d6615769bcb6d0e6d79e605',
              id: 53,
              frequency: 9996,
            },
            {
              _id: '5d6615769bcb6d0e6d79e604',
              id: 54,
              frequency: 2198,
            },
            {
              _id: '5d6615769bcb6d0e6d79e603',
              id: 55,
              frequency: 7392,
            },
            {
              _id: '5d6615769bcb6d0e6d79e602',
              id: 56,
              frequency: 3314,
            },
            {
              _id: '5d6615769bcb6d0e6d79e601',
              id: 57,
              frequency: 253282,
            },
            {
              _id: '5d6615769bcb6d0e6d79e600',
              id: 58,
              frequency: 32246,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5ff',
              id: 59,
              frequency: 36310,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5fe',
              id: 60,
              frequency: 89049,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5fd',
              id: 61,
              frequency: 30258,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5fc',
              id: 62,
              frequency: 1425,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5fb',
              id: 63,
              frequency: 6139,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5fa',
              id: 64,
              frequency: 10918,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5f9',
              id: 65,
              frequency: 36393,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5f8',
              id: 66,
              frequency: 271081,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5f7',
              id: 67,
              frequency: 220845,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5f6',
              id: 68,
              frequency: 34719,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5f5',
              id: 69,
              frequency: 14219,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5f4',
              id: 70,
              frequency: 230431,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5f3',
              id: 71,
              frequency: 500295,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5f2',
              id: 72,
              frequency: 1110742,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e578',
          id: 69,
          abbrevName: '70',
          fullName: '70_R_LOC_inferior',
          coordinates: {
            x: 45.423256,
            y: -75.060465,
            z: -0.669767,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e591',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79e590',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79e58f',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79e58e',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79e58d',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79e58c',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79e58b',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79e58a',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79e589',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79e588',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79e587',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79e586',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79e585',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79e584',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e583',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79e582',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79e581',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e580',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e57f',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79e57e',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79e57d',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79e57c',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79e57b',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79e57a',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79e579',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e5da',
              id: 0,
              frequency: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5d9',
              id: 1,
              frequency: 845,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5d8',
              id: 2,
              frequency: 472,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5d7',
              id: 3,
              frequency: 2849,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5d6',
              id: 4,
              frequency: 1477,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5d5',
              id: 5,
              frequency: 4056,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5d4',
              id: 6,
              frequency: 1048,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5d3',
              id: 7,
              frequency: 484,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5d2',
              id: 8,
              frequency: 2416,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5d1',
              id: 9,
              frequency: 3101,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5d0',
              id: 10,
              frequency: 12875,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5cf',
              id: 11,
              frequency: 8130,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5ce',
              id: 12,
              frequency: 23341,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5cd',
              id: 13,
              frequency: 20048,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5cc',
              id: 14,
              frequency: 59898,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5cb',
              id: 15,
              frequency: 1571,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5ca',
              id: 16,
              frequency: 2919,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5c9',
              id: 17,
              frequency: 5716,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5c8',
              id: 18,
              frequency: 538,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5c7',
              id: 19,
              frequency: 2329,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5c6',
              id: 20,
              frequency: 3137,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5c5',
              id: 21,
              frequency: 3093,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5c4',
              id: 22,
              frequency: 464,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5c3',
              id: 23,
              frequency: 115,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5c2',
              id: 24,
              frequency: 4438,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5c1',
              id: 25,
              frequency: 10521,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5c0',
              id: 26,
              frequency: 17285,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5bf',
              id: 27,
              frequency: 1150,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5be',
              id: 28,
              frequency: 6879,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5bd',
              id: 29,
              frequency: 12444,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5bc',
              id: 30,
              frequency: 22507,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5bb',
              id: 31,
              frequency: 3036,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5ba',
              id: 32,
              frequency: 6936,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5b9',
              id: 33,
              frequency: 4293,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5b8',
              id: 34,
              frequency: 1715,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5b7',
              id: 35,
              frequency: 215,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5b6',
              id: 36,
              frequency: 1347,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5b5',
              id: 37,
              frequency: 7446,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5b4',
              id: 38,
              frequency: 3211,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5b3',
              id: 39,
              frequency: 3038,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5b2',
              id: 40,
              frequency: 43317,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5b1',
              id: 41,
              frequency: 14734,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5b0',
              id: 42,
              frequency: 19919,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5af',
              id: 43,
              frequency: 12828,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5ae',
              id: 44,
              frequency: 7957,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5ad',
              id: 45,
              frequency: 2744,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5ac',
              id: 46,
              frequency: 16229,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5ab',
              id: 47,
              frequency: 34424,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5aa',
              id: 48,
              frequency: 61304,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5a9',
              id: 49,
              frequency: 505,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5a8',
              id: 50,
              frequency: 964,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5a7',
              id: 51,
              frequency: 10506,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5a6',
              id: 52,
              frequency: 2443,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5a5',
              id: 53,
              frequency: 18235,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5a4',
              id: 54,
              frequency: 11521,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5a3',
              id: 55,
              frequency: 9271,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5a2',
              id: 56,
              frequency: 6311,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5a1',
              id: 57,
              frequency: 170680,
            },
            {
              _id: '5d6615769bcb6d0e6d79e5a0',
              id: 58,
              frequency: 72934,
            },
            {
              _id: '5d6615769bcb6d0e6d79e59f',
              id: 59,
              frequency: 50300,
            },
            {
              _id: '5d6615769bcb6d0e6d79e59e',
              id: 60,
              frequency: 101186,
            },
            {
              _id: '5d6615769bcb6d0e6d79e59d',
              id: 61,
              frequency: 44643,
            },
            {
              _id: '5d6615769bcb6d0e6d79e59c',
              id: 62,
              frequency: 5995,
            },
            {
              _id: '5d6615769bcb6d0e6d79e59b',
              id: 63,
              frequency: 27508,
            },
            {
              _id: '5d6615769bcb6d0e6d79e59a',
              id: 64,
              frequency: 11685,
            },
            {
              _id: '5d6615769bcb6d0e6d79e599',
              id: 65,
              frequency: 79339,
            },
            {
              _id: '5d6615769bcb6d0e6d79e598',
              id: 66,
              frequency: 218896,
            },
            {
              _id: '5d6615769bcb6d0e6d79e597',
              id: 67,
              frequency: 253930,
            },
            {
              _id: '5d6615769bcb6d0e6d79e596',
              id: 68,
              frequency: 102241,
            },
            {
              _id: '5d6615769bcb6d0e6d79e595',
              id: 69,
              frequency: 12167,
            },
            {
              _id: '5d6615769bcb6d0e6d79e594',
              id: 70,
              frequency: 426928,
            },
            {
              _id: '5d6615769bcb6d0e6d79e593',
              id: 71,
              frequency: 445123,
            },
            {
              _id: '5d6615769bcb6d0e6d79e592',
              id: 72,
              frequency: 878708,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e519',
          id: 70,
          abbrevName: '71',
          fullName: '71_R_PostcentraL_precentral',
          coordinates: {
            x: 48.042194,
            y: -13.544304,
            z: 46.78481,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e52e',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d79e52d',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79e52c',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79e52b',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79e52a',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79e529',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79e528',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79e527',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79e526',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79e525',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79e524',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e523',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79e522',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79e521',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e520',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e51f',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79e51e',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79e51d',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79e51c',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79e51b',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79e51a',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e577',
              id: 0,
              frequency: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79e576',
              id: 1,
              frequency: 844,
            },
            {
              _id: '5d6615769bcb6d0e6d79e575',
              id: 2,
              frequency: 202,
            },
            {
              _id: '5d6615769bcb6d0e6d79e574',
              id: 3,
              frequency: 2801,
            },
            {
              _id: '5d6615769bcb6d0e6d79e573',
              id: 4,
              frequency: 3248,
            },
            {
              _id: '5d6615769bcb6d0e6d79e572',
              id: 5,
              frequency: 2375,
            },
            {
              _id: '5d6615769bcb6d0e6d79e571',
              id: 6,
              frequency: 1329,
            },
            {
              _id: '5d6615769bcb6d0e6d79e570',
              id: 7,
              frequency: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d79e56f',
              id: 8,
              frequency: 826,
            },
            {
              _id: '5d6615769bcb6d0e6d79e56e',
              id: 9,
              frequency: 3532,
            },
            {
              _id: '5d6615769bcb6d0e6d79e56d',
              id: 10,
              frequency: 20953,
            },
            {
              _id: '5d6615769bcb6d0e6d79e56c',
              id: 11,
              frequency: 1843,
            },
            {
              _id: '5d6615769bcb6d0e6d79e56b',
              id: 12,
              frequency: 20004,
            },
            {
              _id: '5d6615769bcb6d0e6d79e56a',
              id: 13,
              frequency: 11534,
            },
            {
              _id: '5d6615769bcb6d0e6d79e569',
              id: 14,
              frequency: 62655,
            },
            {
              _id: '5d6615769bcb6d0e6d79e568',
              id: 15,
              frequency: 6154,
            },
            {
              _id: '5d6615769bcb6d0e6d79e567',
              id: 16,
              frequency: 4777,
            },
            {
              _id: '5d6615769bcb6d0e6d79e566',
              id: 17,
              frequency: 2635,
            },
            {
              _id: '5d6615769bcb6d0e6d79e565',
              id: 18,
              frequency: 2278,
            },
            {
              _id: '5d6615769bcb6d0e6d79e564',
              id: 19,
              frequency: 5364,
            },
            {
              _id: '5d6615769bcb6d0e6d79e563',
              id: 20,
              frequency: 2239,
            },
            {
              _id: '5d6615769bcb6d0e6d79e562',
              id: 21,
              frequency: 396,
            },
            {
              _id: '5d6615769bcb6d0e6d79e561',
              id: 22,
              frequency: 463,
            },
            {
              _id: '5d6615769bcb6d0e6d79e560',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79e55f',
              id: 24,
              frequency: 9632,
            },
            {
              _id: '5d6615769bcb6d0e6d79e55e',
              id: 25,
              frequency: 13917,
            },
            {
              _id: '5d6615769bcb6d0e6d79e55d',
              id: 26,
              frequency: 5866,
            },
            {
              _id: '5d6615769bcb6d0e6d79e55c',
              id: 27,
              frequency: 5510,
            },
            {
              _id: '5d6615769bcb6d0e6d79e55b',
              id: 28,
              frequency: 7714,
            },
            {
              _id: '5d6615769bcb6d0e6d79e55a',
              id: 29,
              frequency: 59162,
            },
            {
              _id: '5d6615769bcb6d0e6d79e559',
              id: 30,
              frequency: 7537,
            },
            {
              _id: '5d6615769bcb6d0e6d79e558',
              id: 31,
              frequency: 4651,
            },
            {
              _id: '5d6615769bcb6d0e6d79e557',
              id: 32,
              frequency: 14752,
            },
            {
              _id: '5d6615769bcb6d0e6d79e556',
              id: 33,
              frequency: 131,
            },
            {
              _id: '5d6615769bcb6d0e6d79e555',
              id: 34,
              frequency: 1243,
            },
            {
              _id: '5d6615769bcb6d0e6d79e554',
              id: 35,
              frequency: 1070,
            },
            {
              _id: '5d6615769bcb6d0e6d79e553',
              id: 36,
              frequency: 1298,
            },
            {
              _id: '5d6615769bcb6d0e6d79e552',
              id: 37,
              frequency: 2819,
            },
            {
              _id: '5d6615769bcb6d0e6d79e551',
              id: 38,
              frequency: 372,
            },
            {
              _id: '5d6615769bcb6d0e6d79e550',
              id: 39,
              frequency: 5177,
            },
            {
              _id: '5d6615769bcb6d0e6d79e54f',
              id: 40,
              frequency: 49439,
            },
            {
              _id: '5d6615769bcb6d0e6d79e54e',
              id: 41,
              frequency: 13646,
            },
            {
              _id: '5d6615769bcb6d0e6d79e54d',
              id: 42,
              frequency: 1249,
            },
            {
              _id: '5d6615769bcb6d0e6d79e54c',
              id: 43,
              frequency: 46037,
            },
            {
              _id: '5d6615769bcb6d0e6d79e54b',
              id: 44,
              frequency: 991,
            },
            {
              _id: '5d6615769bcb6d0e6d79e54a',
              id: 45,
              frequency: 7407,
            },
            {
              _id: '5d6615769bcb6d0e6d79e549',
              id: 46,
              frequency: 40375,
            },
            {
              _id: '5d6615769bcb6d0e6d79e548',
              id: 47,
              frequency: 8492,
            },
            {
              _id: '5d6615769bcb6d0e6d79e547',
              id: 48,
              frequency: 55781,
            },
            {
              _id: '5d6615769bcb6d0e6d79e546',
              id: 49,
              frequency: 366,
            },
            {
              _id: '5d6615769bcb6d0e6d79e545',
              id: 50,
              frequency: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d79e544',
              id: 51,
              frequency: 5538,
            },
            {
              _id: '5d6615769bcb6d0e6d79e543',
              id: 52,
              frequency: 8705,
            },
            {
              _id: '5d6615769bcb6d0e6d79e542',
              id: 53,
              frequency: 6107,
            },
            {
              _id: '5d6615769bcb6d0e6d79e541',
              id: 54,
              frequency: 16176,
            },
            {
              _id: '5d6615769bcb6d0e6d79e540',
              id: 55,
              frequency: 1789,
            },
            {
              _id: '5d6615769bcb6d0e6d79e53f',
              id: 56,
              frequency: 8378,
            },
            {
              _id: '5d6615769bcb6d0e6d79e53e',
              id: 57,
              frequency: 305828,
            },
            {
              _id: '5d6615769bcb6d0e6d79e53d',
              id: 58,
              frequency: 7254,
            },
            {
              _id: '5d6615769bcb6d0e6d79e53c',
              id: 59,
              frequency: 77377,
            },
            {
              _id: '5d6615769bcb6d0e6d79e53b',
              id: 60,
              frequency: 79152,
            },
            {
              _id: '5d6615769bcb6d0e6d79e53a',
              id: 61,
              frequency: 9148,
            },
            {
              _id: '5d6615769bcb6d0e6d79e539',
              id: 62,
              frequency: 1827,
            },
            {
              _id: '5d6615769bcb6d0e6d79e538',
              id: 63,
              frequency: 4021,
            },
            {
              _id: '5d6615769bcb6d0e6d79e537',
              id: 64,
              frequency: 12731,
            },
            {
              _id: '5d6615769bcb6d0e6d79e536',
              id: 65,
              frequency: 65822,
            },
            {
              _id: '5d6615769bcb6d0e6d79e535',
              id: 66,
              frequency: 390556,
            },
            {
              _id: '5d6615769bcb6d0e6d79e534',
              id: 67,
              frequency: 91443,
            },
            {
              _id: '5d6615769bcb6d0e6d79e533',
              id: 68,
              frequency: 35392,
            },
            {
              _id: '5d6615769bcb6d0e6d79e532',
              id: 69,
              frequency: 5685,
            },
            {
              _id: '5d6615769bcb6d0e6d79e531',
              id: 70,
              frequency: 322433,
            },
            {
              _id: '5d6615769bcb6d0e6d79e530',
              id: 71,
              frequency: 317256,
            },
            {
              _id: '5d6615769bcb6d0e6d79e52f',
              id: 72,
              frequency: 991479,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e4bb',
          id: 71,
          abbrevName: '72',
          fullName: '72_R_Planum_polare_central_operculum',
          coordinates: {
            x: -50.432432,
            y: 0.054054,
            z: -4.648649,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e4cf',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4ce',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4cd',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4cc',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4cb',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4ca',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4c9',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4c8',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4c7',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4c6',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4c5',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4c4',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4c3',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4c2',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4c1',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4c0',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4bf',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4be',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4bd',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4bc',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e518',
              id: 0,
              frequency: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79e517',
              id: 1,
              frequency: 732,
            },
            {
              _id: '5d6615769bcb6d0e6d79e516',
              id: 2,
              frequency: 362,
            },
            {
              _id: '5d6615769bcb6d0e6d79e515',
              id: 3,
              frequency: 2959,
            },
            {
              _id: '5d6615769bcb6d0e6d79e514',
              id: 4,
              frequency: 1530,
            },
            {
              _id: '5d6615769bcb6d0e6d79e513',
              id: 5,
              frequency: 3590,
            },
            {
              _id: '5d6615769bcb6d0e6d79e512',
              id: 6,
              frequency: 782,
            },
            {
              _id: '5d6615769bcb6d0e6d79e511',
              id: 7,
              frequency: 157,
            },
            {
              _id: '5d6615769bcb6d0e6d79e510',
              id: 8,
              frequency: 1241,
            },
            {
              _id: '5d6615769bcb6d0e6d79e50f',
              id: 9,
              frequency: 2707,
            },
            {
              _id: '5d6615769bcb6d0e6d79e50e',
              id: 10,
              frequency: 16928,
            },
            {
              _id: '5d6615769bcb6d0e6d79e50d',
              id: 11,
              frequency: 5441,
            },
            {
              _id: '5d6615769bcb6d0e6d79e50c',
              id: 12,
              frequency: 18146,
            },
            {
              _id: '5d6615769bcb6d0e6d79e50b',
              id: 13,
              frequency: 17607,
            },
            {
              _id: '5d6615769bcb6d0e6d79e50a',
              id: 14,
              frequency: 65355,
            },
            {
              _id: '5d6615769bcb6d0e6d79e509',
              id: 15,
              frequency: 1802,
            },
            {
              _id: '5d6615769bcb6d0e6d79e508',
              id: 16,
              frequency: 3504,
            },
            {
              _id: '5d6615769bcb6d0e6d79e507',
              id: 17,
              frequency: 3824,
            },
            {
              _id: '5d6615769bcb6d0e6d79e506',
              id: 18,
              frequency: 467,
            },
            {
              _id: '5d6615769bcb6d0e6d79e505',
              id: 19,
              frequency: 1729,
            },
            {
              _id: '5d6615769bcb6d0e6d79e504',
              id: 20,
              frequency: 3795,
            },
            {
              _id: '5d6615769bcb6d0e6d79e503',
              id: 21,
              frequency: 1451,
            },
            {
              _id: '5d6615769bcb6d0e6d79e502',
              id: 22,
              frequency: 359,
            },
            {
              _id: '5d6615769bcb6d0e6d79e501',
              id: 23,
              frequency: 2,
            },
            {
              _id: '5d6615769bcb6d0e6d79e500',
              id: 24,
              frequency: 3962,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4ff',
              id: 25,
              frequency: 8921,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4fe',
              id: 26,
              frequency: 15137,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4fd',
              id: 27,
              frequency: 1897,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4fc',
              id: 28,
              frequency: 8536,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4fb',
              id: 29,
              frequency: 24507,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4fa',
              id: 30,
              frequency: 21401,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4f9',
              id: 31,
              frequency: 2328,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4f8',
              id: 32,
              frequency: 10551,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4f7',
              id: 33,
              frequency: 621,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4f6',
              id: 34,
              frequency: 1350,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4f5',
              id: 35,
              frequency: 253,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4f4',
              id: 36,
              frequency: 698,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4f3',
              id: 37,
              frequency: 4138,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4f2',
              id: 38,
              frequency: 833,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4f1',
              id: 39,
              frequency: 2044,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4f0',
              id: 40,
              frequency: 31352,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4ef',
              id: 41,
              frequency: 17833,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4ee',
              id: 42,
              frequency: 6334,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4ed',
              id: 43,
              frequency: 32846,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4ec',
              id: 44,
              frequency: 4959,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4eb',
              id: 45,
              frequency: 2813,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4ea',
              id: 46,
              frequency: 16083,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4e9',
              id: 47,
              frequency: 19201,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4e8',
              id: 48,
              frequency: 73400,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4e7',
              id: 49,
              frequency: 202,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4e6',
              id: 50,
              frequency: 134,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4e5',
              id: 51,
              frequency: 6186,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4e4',
              id: 52,
              frequency: 3694,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4e3',
              id: 53,
              frequency: 14622,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4e2',
              id: 54,
              frequency: 6551,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4e1',
              id: 55,
              frequency: 4819,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4e0',
              id: 56,
              frequency: 6012,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4df',
              id: 57,
              frequency: 235385,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4de',
              id: 58,
              frequency: 43675,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4dd',
              id: 59,
              frequency: 46083,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4dc',
              id: 60,
              frequency: 98269,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4db',
              id: 61,
              frequency: 30177,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4da',
              id: 62,
              frequency: 2824,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4d9',
              id: 63,
              frequency: 10768,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4d8',
              id: 64,
              frequency: 12293,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4d7',
              id: 65,
              frequency: 59984,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4d6',
              id: 66,
              frequency: 310895,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4d5',
              id: 67,
              frequency: 204714,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4d4',
              id: 68,
              frequency: 49594,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4d3',
              id: 69,
              frequency: 11752,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4d2',
              id: 70,
              frequency: 304453,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4d1',
              id: 71,
              frequency: 426686,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4d0',
              id: 72,
              frequency: 1015321,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e45c',
          id: 72,
          abbrevName: '73',
          fullName: '73_L_Frontal_pole',
          coordinates: {
            x: -15.54717,
            y: 53.566038,
            z: 30.358491,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e471',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79e470',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79e46f',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79e46e',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79e46d',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79e46c',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79e46b',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79e46a',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79e469',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79e468',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e467',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79e466',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79e465',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e464',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e463',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79e462',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79e461',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79e460',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79e45f',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79e45e',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79e45d',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e4ba',
              id: 0,
              frequency: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4b9',
              id: 1,
              frequency: 1359,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4b8',
              id: 2,
              frequency: 215,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4b7',
              id: 3,
              frequency: 2131,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4b6',
              id: 4,
              frequency: 5241,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4b5',
              id: 5,
              frequency: 3705,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4b4',
              id: 6,
              frequency: 2053,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4b3',
              id: 7,
              frequency: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4b2',
              id: 8,
              frequency: 1773,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4b1',
              id: 9,
              frequency: 11681,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4b0',
              id: 10,
              frequency: 18877,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4af',
              id: 11,
              frequency: 2675,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4ae',
              id: 12,
              frequency: 33142,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4ad',
              id: 13,
              frequency: 8806,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4ac',
              id: 14,
              frequency: 40830,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4ab',
              id: 15,
              frequency: 8839,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4aa',
              id: 16,
              frequency: 5582,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4a9',
              id: 17,
              frequency: 7824,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4a8',
              id: 18,
              frequency: 4130,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4a7',
              id: 19,
              frequency: 9067,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4a6',
              id: 20,
              frequency: 2735,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4a5',
              id: 21,
              frequency: 1044,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4a4',
              id: 22,
              frequency: 805,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4a3',
              id: 23,
              frequency: 3,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4a2',
              id: 24,
              frequency: 29227,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4a1',
              id: 25,
              frequency: 20131,
            },
            {
              _id: '5d6615769bcb6d0e6d79e4a0',
              id: 26,
              frequency: 10101,
            },
            {
              _id: '5d6615769bcb6d0e6d79e49f',
              id: 27,
              frequency: 12928,
            },
            {
              _id: '5d6615769bcb6d0e6d79e49e',
              id: 28,
              frequency: 19682,
            },
            {
              _id: '5d6615769bcb6d0e6d79e49d',
              id: 29,
              frequency: 42396,
            },
            {
              _id: '5d6615769bcb6d0e6d79e49c',
              id: 30,
              frequency: 11542,
            },
            {
              _id: '5d6615769bcb6d0e6d79e49b',
              id: 31,
              frequency: 9974,
            },
            {
              _id: '5d6615769bcb6d0e6d79e49a',
              id: 32,
              frequency: 13270,
            },
            {
              _id: '5d6615769bcb6d0e6d79e499',
              id: 33,
              frequency: 376,
            },
            {
              _id: '5d6615769bcb6d0e6d79e498',
              id: 34,
              frequency: 3298,
            },
            {
              _id: '5d6615769bcb6d0e6d79e497',
              id: 35,
              frequency: 1485,
            },
            {
              _id: '5d6615769bcb6d0e6d79e496',
              id: 36,
              frequency: 2295,
            },
            {
              _id: '5d6615769bcb6d0e6d79e495',
              id: 37,
              frequency: 5754,
            },
            {
              _id: '5d6615769bcb6d0e6d79e494',
              id: 38,
              frequency: 1024,
            },
            {
              _id: '5d6615769bcb6d0e6d79e493',
              id: 39,
              frequency: 19636,
            },
            {
              _id: '5d6615769bcb6d0e6d79e492',
              id: 40,
              frequency: 67995,
            },
            {
              _id: '5d6615769bcb6d0e6d79e491',
              id: 41,
              frequency: 10757,
            },
            {
              _id: '5d6615769bcb6d0e6d79e490',
              id: 42,
              frequency: 3005,
            },
            {
              _id: '5d6615769bcb6d0e6d79e48f',
              id: 43,
              frequency: 64784,
            },
            {
              _id: '5d6615769bcb6d0e6d79e48e',
              id: 44,
              frequency: 1130,
            },
            {
              _id: '5d6615769bcb6d0e6d79e48d',
              id: 45,
              frequency: 24439,
            },
            {
              _id: '5d6615769bcb6d0e6d79e48c',
              id: 46,
              frequency: 48796,
            },
            {
              _id: '5d6615769bcb6d0e6d79e48b',
              id: 47,
              frequency: 29025,
            },
            {
              _id: '5d6615769bcb6d0e6d79e48a',
              id: 48,
              frequency: 45126,
            },
            {
              _id: '5d6615769bcb6d0e6d79e489',
              id: 49,
              frequency: 616,
            },
            {
              _id: '5d6615769bcb6d0e6d79e488',
              id: 50,
              frequency: 230,
            },
            {
              _id: '5d6615769bcb6d0e6d79e487',
              id: 51,
              frequency: 19254,
            },
            {
              _id: '5d6615769bcb6d0e6d79e486',
              id: 52,
              frequency: 9418,
            },
            {
              _id: '5d6615769bcb6d0e6d79e485',
              id: 53,
              frequency: 10239,
            },
            {
              _id: '5d6615769bcb6d0e6d79e484',
              id: 54,
              frequency: 24309,
            },
            {
              _id: '5d6615769bcb6d0e6d79e483',
              id: 55,
              frequency: 1709,
            },
            {
              _id: '5d6615769bcb6d0e6d79e482',
              id: 56,
              frequency: 61192,
            },
            {
              _id: '5d6615769bcb6d0e6d79e481',
              id: 57,
              frequency: 186199,
            },
            {
              _id: '5d6615769bcb6d0e6d79e480',
              id: 58,
              frequency: 21076,
            },
            {
              _id: '5d6615769bcb6d0e6d79e47f',
              id: 59,
              frequency: 161542,
            },
            {
              _id: '5d6615769bcb6d0e6d79e47e',
              id: 60,
              frequency: 97499,
            },
            {
              _id: '5d6615769bcb6d0e6d79e47d',
              id: 61,
              frequency: 10320,
            },
            {
              _id: '5d6615769bcb6d0e6d79e47c',
              id: 62,
              frequency: 8925,
            },
            {
              _id: '5d6615769bcb6d0e6d79e47b',
              id: 63,
              frequency: 12441,
            },
            {
              _id: '5d6615769bcb6d0e6d79e47a',
              id: 64,
              frequency: 12332,
            },
            {
              _id: '5d6615769bcb6d0e6d79e479',
              id: 65,
              frequency: 255598,
            },
            {
              _id: '5d6615769bcb6d0e6d79e478',
              id: 66,
              frequency: 341609,
            },
            {
              _id: '5d6615769bcb6d0e6d79e477',
              id: 67,
              frequency: 81400,
            },
            {
              _id: '5d6615769bcb6d0e6d79e476',
              id: 68,
              frequency: 69624,
            },
            {
              _id: '5d6615769bcb6d0e6d79e475',
              id: 69,
              frequency: 3735,
            },
            {
              _id: '5d6615769bcb6d0e6d79e474',
              id: 70,
              frequency: 533564,
            },
            {
              _id: '5d6615769bcb6d0e6d79e473',
              id: 71,
              frequency: 187342,
            },
            {
              _id: '5d6615769bcb6d0e6d79e472',
              id: 72,
              frequency: 554405,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e3ff',
          id: 73,
          abbrevName: '74',
          fullName: '74_R_Cerebellum_posterior',
          coordinates: {
            x: 40.693878,
            y: -67.714286,
            z: -37.322449,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e412',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79e411',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79e410',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79e40f',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79e40e',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79e40d',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79e40c',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79e40b',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e40a',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79e409',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79e408',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79e407',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e406',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e405',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79e404',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79e403',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79e402',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79e401',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79e400',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e45b',
              id: 0,
              frequency: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d79e45a',
              id: 1,
              frequency: 1453,
            },
            {
              _id: '5d6615769bcb6d0e6d79e459',
              id: 2,
              frequency: 321,
            },
            {
              _id: '5d6615769bcb6d0e6d79e458',
              id: 3,
              frequency: 2025,
            },
            {
              _id: '5d6615769bcb6d0e6d79e457',
              id: 4,
              frequency: 4346,
            },
            {
              _id: '5d6615769bcb6d0e6d79e456',
              id: 5,
              frequency: 5507,
            },
            {
              _id: '5d6615769bcb6d0e6d79e455',
              id: 6,
              frequency: 2171,
            },
            {
              _id: '5d6615769bcb6d0e6d79e454',
              id: 7,
              frequency: 217,
            },
            {
              _id: '5d6615769bcb6d0e6d79e453',
              id: 8,
              frequency: 2766,
            },
            {
              _id: '5d6615769bcb6d0e6d79e452',
              id: 9,
              frequency: 13615,
            },
            {
              _id: '5d6615769bcb6d0e6d79e451',
              id: 10,
              frequency: 16763,
            },
            {
              _id: '5d6615769bcb6d0e6d79e450',
              id: 11,
              frequency: 5019,
            },
            {
              _id: '5d6615769bcb6d0e6d79e44f',
              id: 12,
              frequency: 35501,
            },
            {
              _id: '5d6615769bcb6d0e6d79e44e',
              id: 13,
              frequency: 10818,
            },
            {
              _id: '5d6615769bcb6d0e6d79e44d',
              id: 14,
              frequency: 36340,
            },
            {
              _id: '5d6615769bcb6d0e6d79e44c',
              id: 15,
              frequency: 4567,
            },
            {
              _id: '5d6615769bcb6d0e6d79e44b',
              id: 16,
              frequency: 8090,
            },
            {
              _id: '5d6615769bcb6d0e6d79e44a',
              id: 17,
              frequency: 9054,
            },
            {
              _id: '5d6615769bcb6d0e6d79e449',
              id: 18,
              frequency: 1899,
            },
            {
              _id: '5d6615769bcb6d0e6d79e448',
              id: 19,
              frequency: 7924,
            },
            {
              _id: '5d6615769bcb6d0e6d79e447',
              id: 20,
              frequency: 5027,
            },
            {
              _id: '5d6615769bcb6d0e6d79e446',
              id: 21,
              frequency: 3057,
            },
            {
              _id: '5d6615769bcb6d0e6d79e445',
              id: 22,
              frequency: 958,
            },
            {
              _id: '5d6615769bcb6d0e6d79e444',
              id: 23,
              frequency: 8,
            },
            {
              _id: '5d6615769bcb6d0e6d79e443',
              id: 24,
              frequency: 17566,
            },
            {
              _id: '5d6615769bcb6d0e6d79e442',
              id: 25,
              frequency: 18291,
            },
            {
              _id: '5d6615769bcb6d0e6d79e441',
              id: 26,
              frequency: 23179,
            },
            {
              _id: '5d6615769bcb6d0e6d79e440',
              id: 27,
              frequency: 13403,
            },
            {
              _id: '5d6615769bcb6d0e6d79e43f',
              id: 28,
              frequency: 33871,
            },
            {
              _id: '5d6615769bcb6d0e6d79e43e',
              id: 29,
              frequency: 24357,
            },
            {
              _id: '5d6615769bcb6d0e6d79e43d',
              id: 30,
              frequency: 14371,
            },
            {
              _id: '5d6615769bcb6d0e6d79e43c',
              id: 31,
              frequency: 12665,
            },
            {
              _id: '5d6615769bcb6d0e6d79e43b',
              id: 32,
              frequency: 10462,
            },
            {
              _id: '5d6615769bcb6d0e6d79e43a',
              id: 33,
              frequency: 1685,
            },
            {
              _id: '5d6615769bcb6d0e6d79e439',
              id: 34,
              frequency: 3236,
            },
            {
              _id: '5d6615769bcb6d0e6d79e438',
              id: 35,
              frequency: 1263,
            },
            {
              _id: '5d6615769bcb6d0e6d79e437',
              id: 36,
              frequency: 2200,
            },
            {
              _id: '5d6615769bcb6d0e6d79e436',
              id: 37,
              frequency: 8904,
            },
            {
              _id: '5d6615769bcb6d0e6d79e435',
              id: 38,
              frequency: 2649,
            },
            {
              _id: '5d6615769bcb6d0e6d79e434',
              id: 39,
              frequency: 18276,
            },
            {
              _id: '5d6615769bcb6d0e6d79e433',
              id: 40,
              frequency: 68837,
            },
            {
              _id: '5d6615769bcb6d0e6d79e432',
              id: 41,
              frequency: 14538,
            },
            {
              _id: '5d6615769bcb6d0e6d79e431',
              id: 42,
              frequency: 8159,
            },
            {
              _id: '5d6615769bcb6d0e6d79e430',
              id: 43,
              frequency: 60734,
            },
            {
              _id: '5d6615769bcb6d0e6d79e42f',
              id: 44,
              frequency: 3906,
            },
            {
              _id: '5d6615769bcb6d0e6d79e42e',
              id: 45,
              frequency: 23539,
            },
            {
              _id: '5d6615769bcb6d0e6d79e42d',
              id: 46,
              frequency: 27455,
            },
            {
              _id: '5d6615769bcb6d0e6d79e42c',
              id: 47,
              frequency: 57157,
            },
            {
              _id: '5d6615769bcb6d0e6d79e42b',
              id: 48,
              frequency: 47372,
            },
            {
              _id: '5d6615769bcb6d0e6d79e42a',
              id: 49,
              frequency: 978,
            },
            {
              _id: '5d6615769bcb6d0e6d79e429',
              id: 50,
              frequency: 418,
            },
            {
              _id: '5d6615769bcb6d0e6d79e428',
              id: 51,
              frequency: 27038,
            },
            {
              _id: '5d6615769bcb6d0e6d79e427',
              id: 52,
              frequency: 6890,
            },
            {
              _id: '5d6615769bcb6d0e6d79e426',
              id: 53,
              frequency: 19386,
            },
            {
              _id: '5d6615769bcb6d0e6d79e425',
              id: 54,
              frequency: 26221,
            },
            {
              _id: '5d6615769bcb6d0e6d79e424',
              id: 55,
              frequency: 2761,
            },
            {
              _id: '5d6615769bcb6d0e6d79e423',
              id: 56,
              frequency: 81362,
            },
            {
              _id: '5d6615769bcb6d0e6d79e422',
              id: 57,
              frequency: 134711,
            },
            {
              _id: '5d6615769bcb6d0e6d79e421',
              id: 58,
              frequency: 44838,
            },
            {
              _id: '5d6615769bcb6d0e6d79e420',
              id: 59,
              frequency: 156481,
            },
            {
              _id: '5d6615769bcb6d0e6d79e41f',
              id: 60,
              frequency: 124564,
            },
            {
              _id: '5d6615769bcb6d0e6d79e41e',
              id: 61,
              frequency: 21103,
            },
            {
              _id: '5d6615769bcb6d0e6d79e41d',
              id: 62,
              frequency: 16831,
            },
            {
              _id: '5d6615769bcb6d0e6d79e41c',
              id: 63,
              frequency: 24056,
            },
            {
              _id: '5d6615769bcb6d0e6d79e41b',
              id: 64,
              frequency: 12249,
            },
            {
              _id: '5d6615769bcb6d0e6d79e41a',
              id: 65,
              frequency: 307017,
            },
            {
              _id: '5d6615769bcb6d0e6d79e419',
              id: 66,
              frequency: 292812,
            },
            {
              _id: '5d6615769bcb6d0e6d79e418',
              id: 67,
              frequency: 119222,
            },
            {
              _id: '5d6615769bcb6d0e6d79e417',
              id: 68,
              frequency: 101672,
            },
            {
              _id: '5d6615769bcb6d0e6d79e416',
              id: 69,
              frequency: 5222,
            },
            {
              _id: '5d6615769bcb6d0e6d79e415',
              id: 70,
              frequency: 558878,
            },
            {
              _id: '5d6615769bcb6d0e6d79e414',
              id: 71,
              frequency: 198004,
            },
            {
              _id: '5d6615769bcb6d0e6d79e413',
              id: 72,
              frequency: 459593,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e39e',
          id: 74,
          abbrevName: '75',
          fullName: '75_L_LOC_superior',
          coordinates: {
            x: -14.808664,
            y: -73.263538,
            z: 45.906137,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e3b5',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3b4',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3b3',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3b2',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3b1',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3b0',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3af',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3ae',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3ad',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3ac',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3ab',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3aa',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3a9',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3a8',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3a7',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3a6',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3a5',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3a4',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3a3',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3a2',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3a1',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3a0',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79e39f',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e3fe',
              id: 0,
              frequency: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3fd',
              id: 1,
              frequency: 287,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3fc',
              id: 2,
              frequency: 479,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3fb',
              id: 3,
              frequency: 3437,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3fa',
              id: 4,
              frequency: 875,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3f9',
              id: 5,
              frequency: 2302,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3f8',
              id: 6,
              frequency: 111,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3f7',
              id: 7,
              frequency: 375,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3f6',
              id: 8,
              frequency: 490,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3f5',
              id: 9,
              frequency: 459,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3f4',
              id: 10,
              frequency: 11322,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3f3',
              id: 11,
              frequency: 7424,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3f2',
              id: 12,
              frequency: 5326,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3f1',
              id: 13,
              frequency: 25700,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3f0',
              id: 14,
              frequency: 80065,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3ef',
              id: 15,
              frequency: 694,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3ee',
              id: 16,
              frequency: 4263,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3ed',
              id: 17,
              frequency: 564,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3ec',
              id: 18,
              frequency: 699,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3eb',
              id: 19,
              frequency: 154,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3ea',
              id: 20,
              frequency: 901,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3e9',
              id: 21,
              frequency: 1913,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3e8',
              id: 22,
              frequency: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3e7',
              id: 23,
              frequency: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3e6',
              id: 24,
              frequency: 838,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3e5',
              id: 25,
              frequency: 1530,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3e4',
              id: 26,
              frequency: 14068,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3e3',
              id: 27,
              frequency: 874,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3e2',
              id: 28,
              frequency: 3291,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3e1',
              id: 29,
              frequency: 26586,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3e0',
              id: 30,
              frequency: 15786,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3df',
              id: 31,
              frequency: 111,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3de',
              id: 32,
              frequency: 3590,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3dd',
              id: 33,
              frequency: 2631,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3dc',
              id: 34,
              frequency: 560,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3db',
              id: 35,
              frequency: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3da',
              id: 36,
              frequency: 992,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3d9',
              id: 37,
              frequency: 512,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3d8',
              id: 38,
              frequency: 797,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3d7',
              id: 39,
              frequency: 275,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3d6',
              id: 40,
              frequency: 3863,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3d5',
              id: 41,
              frequency: 17459,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3d4',
              id: 42,
              frequency: 14376,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3d3',
              id: 43,
              frequency: 12174,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3d2',
              id: 44,
              frequency: 9131,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3d1',
              id: 45,
              frequency: 627,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3d0',
              id: 46,
              frequency: 12493,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3cf',
              id: 47,
              frequency: 9642,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3ce',
              id: 48,
              frequency: 75474,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3cd',
              id: 49,
              frequency: 10,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3cc',
              id: 50,
              frequency: 136,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3cb',
              id: 51,
              frequency: 1680,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3ca',
              id: 52,
              frequency: 1797,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3c9',
              id: 53,
              frequency: 7040,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3c8',
              id: 54,
              frequency: 441,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3c7',
              id: 55,
              frequency: 12416,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3c6',
              id: 56,
              frequency: 406,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3c5',
              id: 57,
              frequency: 239428,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3c4',
              id: 58,
              frequency: 46808,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3c3',
              id: 59,
              frequency: 12787,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3c2',
              id: 60,
              frequency: 47416,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3c1',
              id: 61,
              frequency: 50168,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3c0',
              id: 62,
              frequency: 263,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3bf',
              id: 63,
              frequency: 3905,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3be',
              id: 64,
              frequency: 9376,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3bd',
              id: 65,
              frequency: 4967,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3bc',
              id: 66,
              frequency: 154245,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3bb',
              id: 67,
              frequency: 327166,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3ba',
              id: 68,
              frequency: 17199,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3b9',
              id: 69,
              frequency: 17717,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3b8',
              id: 70,
              frequency: 71252,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3b7',
              id: 71,
              frequency: 666520,
            },
            {
              _id: '5d6615769bcb6d0e6d79e3b6',
              id: 72,
              frequency: 1294644,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e33e',
          id: 75,
          abbrevName: '76',
          fullName: '76_BI_Lingual_gyrus_intracalcarine',
          coordinates: {
            x: 1.066079,
            y: -81.982379,
            z: -1.092511,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e354',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79e353',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79e352',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79e351',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79e350',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79e34f',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79e34e',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79e34d',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79e34c',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e34b',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79e34a',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79e349',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79e348',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e347',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e346',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79e345',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79e344',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79e343',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79e342',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79e341',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79e340',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79e33f',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e39d',
              id: 0,
              frequency: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79e39c',
              id: 1,
              frequency: 136,
            },
            {
              _id: '5d6615769bcb6d0e6d79e39b',
              id: 2,
              frequency: 583,
            },
            {
              _id: '5d6615769bcb6d0e6d79e39a',
              id: 3,
              frequency: 3603,
            },
            {
              _id: '5d6615769bcb6d0e6d79e399',
              id: 4,
              frequency: 182,
            },
            {
              _id: '5d6615769bcb6d0e6d79e398',
              id: 5,
              frequency: 1941,
            },
            {
              _id: '5d6615769bcb6d0e6d79e397',
              id: 6,
              frequency: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79e396',
              id: 7,
              frequency: 495,
            },
            {
              _id: '5d6615769bcb6d0e6d79e395',
              id: 8,
              frequency: 93,
            },
            {
              _id: '5d6615769bcb6d0e6d79e394',
              id: 9,
              frequency: 116,
            },
            {
              _id: '5d6615769bcb6d0e6d79e393',
              id: 10,
              frequency: 7347,
            },
            {
              _id: '5d6615769bcb6d0e6d79e392',
              id: 11,
              frequency: 10043,
            },
            {
              _id: '5d6615769bcb6d0e6d79e391',
              id: 12,
              frequency: 1451,
            },
            {
              _id: '5d6615769bcb6d0e6d79e390',
              id: 13,
              frequency: 30899,
            },
            {
              _id: '5d6615769bcb6d0e6d79e38f',
              id: 14,
              frequency: 84143,
            },
            {
              _id: '5d6615769bcb6d0e6d79e38e',
              id: 15,
              frequency: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d79e38d',
              id: 16,
              frequency: 1730,
            },
            {
              _id: '5d6615769bcb6d0e6d79e38c',
              id: 17,
              frequency: 373,
            },
            {
              _id: '5d6615769bcb6d0e6d79e38b',
              id: 18,
              frequency: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d79e38a',
              id: 19,
              frequency: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d79e389',
              id: 20,
              frequency: 1109,
            },
            {
              _id: '5d6615769bcb6d0e6d79e388',
              id: 21,
              frequency: 2110,
            },
            {
              _id: '5d6615769bcb6d0e6d79e387',
              id: 22,
              frequency: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d79e386',
              id: 23,
              frequency: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d79e385',
              id: 24,
              frequency: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d79e384',
              id: 25,
              frequency: 894,
            },
            {
              _id: '5d6615769bcb6d0e6d79e383',
              id: 26,
              frequency: 15183,
            },
            {
              _id: '5d6615769bcb6d0e6d79e382',
              id: 27,
              frequency: 130,
            },
            {
              _id: '5d6615769bcb6d0e6d79e381',
              id: 28,
              frequency: 1726,
            },
            {
              _id: '5d6615769bcb6d0e6d79e380',
              id: 29,
              frequency: 8736,
            },
            {
              _id: '5d6615769bcb6d0e6d79e37f',
              id: 30,
              frequency: 19646,
            },
            {
              _id: '5d6615769bcb6d0e6d79e37e',
              id: 31,
              frequency: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79e37d',
              id: 32,
              frequency: 2797,
            },
            {
              _id: '5d6615769bcb6d0e6d79e37c',
              id: 33,
              frequency: 3711,
            },
            {
              _id: '5d6615769bcb6d0e6d79e37b',
              id: 34,
              frequency: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79e37a',
              id: 35,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79e379',
              id: 36,
              frequency: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79e378',
              id: 37,
              frequency: 125,
            },
            {
              _id: '5d6615769bcb6d0e6d79e377',
              id: 38,
              frequency: 307,
            },
            {
              _id: '5d6615769bcb6d0e6d79e376',
              id: 39,
              frequency: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d79e375',
              id: 40,
              frequency: 1406,
            },
            {
              _id: '5d6615769bcb6d0e6d79e374',
              id: 41,
              frequency: 16385,
            },
            {
              _id: '5d6615769bcb6d0e6d79e373',
              id: 42,
              frequency: 20455,
            },
            {
              _id: '5d6615769bcb6d0e6d79e372',
              id: 43,
              frequency: 4936,
            },
            {
              _id: '5d6615769bcb6d0e6d79e371',
              id: 44,
              frequency: 13912,
            },
            {
              _id: '5d6615769bcb6d0e6d79e370',
              id: 45,
              frequency: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79e36f',
              id: 46,
              frequency: 1339,
            },
            {
              _id: '5d6615769bcb6d0e6d79e36e',
              id: 47,
              frequency: 6136,
            },
            {
              _id: '5d6615769bcb6d0e6d79e36d',
              id: 48,
              frequency: 74951,
            },
            {
              _id: '5d6615769bcb6d0e6d79e36c',
              id: 49,
              frequency: 2,
            },
            {
              _id: '5d6615769bcb6d0e6d79e36b',
              id: 50,
              frequency: 1,
            },
            {
              _id: '5d6615769bcb6d0e6d79e36a',
              id: 51,
              frequency: 212,
            },
            {
              _id: '5d6615769bcb6d0e6d79e369',
              id: 52,
              frequency: 374,
            },
            {
              _id: '5d6615769bcb6d0e6d79e368',
              id: 53,
              frequency: 2787,
            },
            {
              _id: '5d6615769bcb6d0e6d79e367',
              id: 54,
              frequency: 146,
            },
            {
              _id: '5d6615769bcb6d0e6d79e366',
              id: 55,
              frequency: 15954,
            },
            {
              _id: '5d6615769bcb6d0e6d79e365',
              id: 56,
              frequency: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d79e364',
              id: 57,
              frequency: 189650,
            },
            {
              _id: '5d6615769bcb6d0e6d79e363',
              id: 58,
              frequency: 69770,
            },
            {
              _id: '5d6615769bcb6d0e6d79e362',
              id: 59,
              frequency: 2120,
            },
            {
              _id: '5d6615769bcb6d0e6d79e361',
              id: 60,
              frequency: 25371,
            },
            {
              _id: '5d6615769bcb6d0e6d79e360',
              id: 61,
              frequency: 76127,
            },
            {
              _id: '5d6615769bcb6d0e6d79e35f',
              id: 62,
              frequency: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d79e35e',
              id: 63,
              frequency: 262,
            },
            {
              _id: '5d6615769bcb6d0e6d79e35d',
              id: 64,
              frequency: 2837,
            },
            {
              _id: '5d6615769bcb6d0e6d79e35c',
              id: 65,
              frequency: 764,
            },
            {
              _id: '5d6615769bcb6d0e6d79e35b',
              id: 66,
              frequency: 62597,
            },
            {
              _id: '5d6615769bcb6d0e6d79e35a',
              id: 67,
              frequency: 428283,
            },
            {
              _id: '5d6615769bcb6d0e6d79e359',
              id: 68,
              frequency: 1912,
            },
            {
              _id: '5d6615769bcb6d0e6d79e358',
              id: 69,
              frequency: 26129,
            },
            {
              _id: '5d6615769bcb6d0e6d79e357',
              id: 70,
              frequency: 10800,
            },
            {
              _id: '5d6615769bcb6d0e6d79e356',
              id: 71,
              frequency: 784179,
            },
            {
              _id: '5d6615769bcb6d0e6d79e355',
              id: 72,
              frequency: 1355579,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e2e4',
          id: 76,
          abbrevName: '77',
          fullName: '77_L_MGC_sfg',
          coordinates: {
            x: -28.557078,
            y: 22.931507,
            z: 48.913242,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e2f4',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2f3',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2f2',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2f1',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2f0',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2ef',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2ee',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2ed',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2ec',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2eb',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2ea',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2e9',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2e8',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2e7',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2e6',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2e5',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e33d',
              id: 0,
              frequency: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d79e33c',
              id: 1,
              frequency: 1445,
            },
            {
              _id: '5d6615769bcb6d0e6d79e33b',
              id: 2,
              frequency: 156,
            },
            {
              _id: '5d6615769bcb6d0e6d79e33a',
              id: 3,
              frequency: 1989,
            },
            {
              _id: '5d6615769bcb6d0e6d79e339',
              id: 4,
              frequency: 6301,
            },
            {
              _id: '5d6615769bcb6d0e6d79e338',
              id: 5,
              frequency: 2745,
            },
            {
              _id: '5d6615769bcb6d0e6d79e337',
              id: 6,
              frequency: 2484,
            },
            {
              _id: '5d6615769bcb6d0e6d79e336',
              id: 7,
              frequency: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79e335',
              id: 8,
              frequency: 1662,
            },
            {
              _id: '5d6615769bcb6d0e6d79e334',
              id: 9,
              frequency: 13542,
            },
            {
              _id: '5d6615769bcb6d0e6d79e333',
              id: 10,
              frequency: 19166,
            },
            {
              _id: '5d6615769bcb6d0e6d79e332',
              id: 11,
              frequency: 1549,
            },
            {
              _id: '5d6615769bcb6d0e6d79e331',
              id: 12,
              frequency: 34345,
            },
            {
              _id: '5d6615769bcb6d0e6d79e330',
              id: 13,
              frequency: 6763,
            },
            {
              _id: '5d6615769bcb6d0e6d79e32f',
              id: 14,
              frequency: 37407,
            },
            {
              _id: '5d6615769bcb6d0e6d79e32e',
              id: 15,
              frequency: 12295,
            },
            {
              _id: '5d6615769bcb6d0e6d79e32d',
              id: 16,
              frequency: 4294,
            },
            {
              _id: '5d6615769bcb6d0e6d79e32c',
              id: 17,
              frequency: 6369,
            },
            {
              _id: '5d6615769bcb6d0e6d79e32b',
              id: 18,
              frequency: 4878,
            },
            {
              _id: '5d6615769bcb6d0e6d79e32a',
              id: 19,
              frequency: 12365,
            },
            {
              _id: '5d6615769bcb6d0e6d79e329',
              id: 20,
              frequency: 2360,
            },
            {
              _id: '5d6615769bcb6d0e6d79e328',
              id: 21,
              frequency: 574,
            },
            {
              _id: '5d6615769bcb6d0e6d79e327',
              id: 22,
              frequency: 1063,
            },
            {
              _id: '5d6615769bcb6d0e6d79e326',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79e325',
              id: 24,
              frequency: 37375,
            },
            {
              _id: '5d6615769bcb6d0e6d79e324',
              id: 25,
              frequency: 23363,
            },
            {
              _id: '5d6615769bcb6d0e6d79e323',
              id: 26,
              frequency: 6022,
            },
            {
              _id: '5d6615769bcb6d0e6d79e322',
              id: 27,
              frequency: 16321,
            },
            {
              _id: '5d6615769bcb6d0e6d79e321',
              id: 28,
              frequency: 12518,
            },
            {
              _id: '5d6615769bcb6d0e6d79e320',
              id: 29,
              frequency: 46615,
            },
            {
              _id: '5d6615769bcb6d0e6d79e31f',
              id: 30,
              frequency: 7441,
            },
            {
              _id: '5d6615769bcb6d0e6d79e31e',
              id: 31,
              frequency: 13378,
            },
            {
              _id: '5d6615769bcb6d0e6d79e31d',
              id: 32,
              frequency: 14701,
            },
            {
              _id: '5d6615769bcb6d0e6d79e31c',
              id: 33,
              frequency: 160,
            },
            {
              _id: '5d6615769bcb6d0e6d79e31b',
              id: 34,
              frequency: 3001,
            },
            {
              _id: '5d6615769bcb6d0e6d79e31a',
              id: 35,
              frequency: 2466,
            },
            {
              _id: '5d6615769bcb6d0e6d79e319',
              id: 36,
              frequency: 2426,
            },
            {
              _id: '5d6615769bcb6d0e6d79e318',
              id: 37,
              frequency: 6254,
            },
            {
              _id: '5d6615769bcb6d0e6d79e317',
              id: 38,
              frequency: 459,
            },
            {
              _id: '5d6615769bcb6d0e6d79e316',
              id: 39,
              frequency: 25666,
            },
            {
              _id: '5d6615769bcb6d0e6d79e315',
              id: 40,
              frequency: 80853,
            },
            {
              _id: '5d6615769bcb6d0e6d79e314',
              id: 41,
              frequency: 8466,
            },
            {
              _id: '5d6615769bcb6d0e6d79e313',
              id: 42,
              frequency: 1352,
            },
            {
              _id: '5d6615769bcb6d0e6d79e312',
              id: 43,
              frequency: 65416,
            },
            {
              _id: '5d6615769bcb6d0e6d79e311',
              id: 44,
              frequency: 639,
            },
            {
              _id: '5d6615769bcb6d0e6d79e310',
              id: 45,
              frequency: 33732,
            },
            {
              _id: '5d6615769bcb6d0e6d79e30f',
              id: 46,
              frequency: 56376,
            },
            {
              _id: '5d6615769bcb6d0e6d79e30e',
              id: 47,
              frequency: 14373,
            },
            {
              _id: '5d6615769bcb6d0e6d79e30d',
              id: 48,
              frequency: 37882,
            },
            {
              _id: '5d6615769bcb6d0e6d79e30c',
              id: 49,
              frequency: 578,
            },
            {
              _id: '5d6615769bcb6d0e6d79e30b',
              id: 50,
              frequency: 233,
            },
            {
              _id: '5d6615769bcb6d0e6d79e30a',
              id: 51,
              frequency: 21003,
            },
            {
              _id: '5d6615769bcb6d0e6d79e309',
              id: 52,
              frequency: 11829,
            },
            {
              _id: '5d6615769bcb6d0e6d79e308',
              id: 53,
              frequency: 6712,
            },
            {
              _id: '5d6615769bcb6d0e6d79e307',
              id: 54,
              frequency: 28068,
            },
            {
              _id: '5d6615769bcb6d0e6d79e306',
              id: 55,
              frequency: 911,
            },
            {
              _id: '5d6615769bcb6d0e6d79e305',
              id: 56,
              frequency: 77064,
            },
            {
              _id: '5d6615769bcb6d0e6d79e304',
              id: 57,
              frequency: 190337,
            },
            {
              _id: '5d6615769bcb6d0e6d79e303',
              id: 58,
              frequency: 8844,
            },
            {
              _id: '5d6615769bcb6d0e6d79e302',
              id: 59,
              frequency: 190389,
            },
            {
              _id: '5d6615769bcb6d0e6d79e301',
              id: 60,
              frequency: 79370,
            },
            {
              _id: '5d6615769bcb6d0e6d79e300',
              id: 61,
              frequency: 5416,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2ff',
              id: 62,
              frequency: 8759,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2fe',
              id: 63,
              frequency: 11999,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2fd',
              id: 64,
              frequency: 10654,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2fc',
              id: 65,
              frequency: 286693,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2fb',
              id: 66,
              frequency: 338862,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2fa',
              id: 67,
              frequency: 54643,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2f9',
              id: 68,
              frequency: 63846,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2f8',
              id: 69,
              frequency: 2052,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2f7',
              id: 70,
              frequency: 541928,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2f6',
              id: 71,
              frequency: 146829,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2f5',
              id: 72,
              frequency: 499874,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e287',
          id: 77,
          abbrevName: '78',
          fullName: '78_R_Orbital_frontal_Cortex',
          coordinates: {
            x: 18.62585,
            y: 21.020408,
            z: -19.047619,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e29a',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79e299',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79e298',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79e297',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79e296',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79e295',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79e294',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e293',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79e292',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d79e291',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e290',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e28f',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79e28e',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79e28d',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79e28c',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79e28b',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79e28a',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79e289',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79e288',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e2e3',
              id: 0,
              frequency: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2e2',
              id: 1,
              frequency: 1137,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2e1',
              id: 2,
              frequency: 438,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2e0',
              id: 3,
              frequency: 2488,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2df',
              id: 4,
              frequency: 2797,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2de',
              id: 5,
              frequency: 5818,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2dd',
              id: 6,
              frequency: 1863,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2dc',
              id: 7,
              frequency: 300,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2db',
              id: 8,
              frequency: 2171,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2da',
              id: 9,
              frequency: 6597,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2d9',
              id: 10,
              frequency: 15022,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2d8',
              id: 11,
              frequency: 8228,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2d7',
              id: 12,
              frequency: 30615,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2d6',
              id: 13,
              frequency: 15494,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2d5',
              id: 14,
              frequency: 49128,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2d4',
              id: 15,
              frequency: 3038,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2d3',
              id: 16,
              frequency: 7847,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2d2',
              id: 17,
              frequency: 7109,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2d1',
              id: 18,
              frequency: 1166,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2d0',
              id: 19,
              frequency: 4123,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2cf',
              id: 20,
              frequency: 5935,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2ce',
              id: 21,
              frequency: 2663,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2cd',
              id: 22,
              frequency: 837,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2cc',
              id: 23,
              frequency: 11,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2cb',
              id: 24,
              frequency: 10907,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2ca',
              id: 25,
              frequency: 11861,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2c9',
              id: 26,
              frequency: 26549,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2c8',
              id: 27,
              frequency: 4330,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2c7',
              id: 28,
              frequency: 23626,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2c6',
              id: 29,
              frequency: 19206,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2c5',
              id: 30,
              frequency: 19841,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2c4',
              id: 31,
              frequency: 6733,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2c3',
              id: 32,
              frequency: 8301,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2c2',
              id: 33,
              frequency: 1800,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2c1',
              id: 34,
              frequency: 2531,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2c0',
              id: 35,
              frequency: 942,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2bf',
              id: 36,
              frequency: 2062,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2be',
              id: 37,
              frequency: 6943,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2bd',
              id: 38,
              frequency: 2978,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2bc',
              id: 39,
              frequency: 11681,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2bb',
              id: 40,
              frequency: 59371,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2ba',
              id: 41,
              frequency: 16359,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2b9',
              id: 42,
              frequency: 14045,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2b8',
              id: 43,
              frequency: 27431,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2b7',
              id: 44,
              frequency: 11026,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2b6',
              id: 45,
              frequency: 9491,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2b5',
              id: 46,
              frequency: 26215,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2b4',
              id: 47,
              frequency: 77812,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2b3',
              id: 48,
              frequency: 52163,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2b2',
              id: 49,
              frequency: 932,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2b1',
              id: 50,
              frequency: 284,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2b0',
              id: 51,
              frequency: 15549,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2af',
              id: 52,
              frequency: 5402,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2ae',
              id: 53,
              frequency: 17914,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2ad',
              id: 54,
              frequency: 29587,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2ac',
              id: 55,
              frequency: 4511,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2ab',
              id: 56,
              frequency: 21509,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2aa',
              id: 57,
              frequency: 139711,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2a9',
              id: 58,
              frequency: 86333,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2a8',
              id: 59,
              frequency: 97550,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2a7',
              id: 60,
              frequency: 133136,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2a6',
              id: 61,
              frequency: 39174,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2a5',
              id: 62,
              frequency: 7368,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2a4',
              id: 63,
              frequency: 18823,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2a3',
              id: 64,
              frequency: 12288,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2a2',
              id: 65,
              frequency: 161240,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2a1',
              id: 66,
              frequency: 280086,
            },
            {
              _id: '5d6615769bcb6d0e6d79e2a0',
              id: 67,
              frequency: 195731,
            },
            {
              _id: '5d6615769bcb6d0e6d79e29f',
              id: 68,
              frequency: 91147,
            },
            {
              _id: '5d6615769bcb6d0e6d79e29e',
              id: 69,
              frequency: 7671,
            },
            {
              _id: '5d6615769bcb6d0e6d79e29d',
              id: 70,
              frequency: 534658,
            },
            {
              _id: '5d6615769bcb6d0e6d79e29c',
              id: 71,
              frequency: 309242,
            },
            {
              _id: '5d6615769bcb6d0e6d79e29b',
              id: 72,
              frequency: 683731,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e22b',
          id: 78,
          abbrevName: '79',
          fullName: '79_BI_Cerebellum_anterior_culmen',
          coordinates: {
            x: 4.773333,
            y: -56.357333,
            z: -29.226667,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e23d',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d79e23c',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79e23b',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79e23a',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79e239',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79e238',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e237',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79e236',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79e235',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d79e234',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e233',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e232',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79e231',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79e230',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79e22f',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79e22e',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79e22d',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79e22c',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e286',
              id: 0,
              frequency: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79e285',
              id: 1,
              frequency: 723,
            },
            {
              _id: '5d6615769bcb6d0e6d79e284',
              id: 2,
              frequency: 583,
            },
            {
              _id: '5d6615769bcb6d0e6d79e283',
              id: 3,
              frequency: 2987,
            },
            {
              _id: '5d6615769bcb6d0e6d79e282',
              id: 4,
              frequency: 945,
            },
            {
              _id: '5d6615769bcb6d0e6d79e281',
              id: 5,
              frequency: 4823,
            },
            {
              _id: '5d6615769bcb6d0e6d79e280',
              id: 6,
              frequency: 624,
            },
            {
              _id: '5d6615769bcb6d0e6d79e27f',
              id: 7,
              frequency: 816,
            },
            {
              _id: '5d6615769bcb6d0e6d79e27e',
              id: 8,
              frequency: 1695,
            },
            {
              _id: '5d6615769bcb6d0e6d79e27d',
              id: 9,
              frequency: 2344,
            },
            {
              _id: '5d6615769bcb6d0e6d79e27c',
              id: 10,
              frequency: 11679,
            },
            {
              _id: '5d6615769bcb6d0e6d79e27b',
              id: 11,
              frequency: 11470,
            },
            {
              _id: '5d6615769bcb6d0e6d79e27a',
              id: 12,
              frequency: 20420,
            },
            {
              _id: '5d6615769bcb6d0e6d79e279',
              id: 13,
              frequency: 23001,
            },
            {
              _id: '5d6615769bcb6d0e6d79e278',
              id: 14,
              frequency: 63483,
            },
            {
              _id: '5d6615769bcb6d0e6d79e277',
              id: 15,
              frequency: 701,
            },
            {
              _id: '5d6615769bcb6d0e6d79e276',
              id: 16,
              frequency: 3111,
            },
            {
              _id: '5d6615769bcb6d0e6d79e275',
              id: 17,
              frequency: 5419,
            },
            {
              _id: '5d6615769bcb6d0e6d79e274',
              id: 18,
              frequency: 121,
            },
            {
              _id: '5d6615769bcb6d0e6d79e273',
              id: 19,
              frequency: 1102,
            },
            {
              _id: '5d6615769bcb6d0e6d79e272',
              id: 20,
              frequency: 2853,
            },
            {
              _id: '5d6615769bcb6d0e6d79e271',
              id: 21,
              frequency: 5656,
            },
            {
              _id: '5d6615769bcb6d0e6d79e270',
              id: 22,
              frequency: 165,
            },
            {
              _id: '5d6615769bcb6d0e6d79e26f',
              id: 23,
              frequency: 219,
            },
            {
              _id: '5d6615769bcb6d0e6d79e26e',
              id: 24,
              frequency: 1657,
            },
            {
              _id: '5d6615769bcb6d0e6d79e26d',
              id: 25,
              frequency: 7874,
            },
            {
              _id: '5d6615769bcb6d0e6d79e26c',
              id: 26,
              frequency: 25246,
            },
            {
              _id: '5d6615769bcb6d0e6d79e26b',
              id: 27,
              frequency: 889,
            },
            {
              _id: '5d6615769bcb6d0e6d79e26a',
              id: 28,
              frequency: 9710,
            },
            {
              _id: '5d6615769bcb6d0e6d79e269',
              id: 29,
              frequency: 7748,
            },
            {
              _id: '5d6615769bcb6d0e6d79e268',
              id: 30,
              frequency: 23727,
            },
            {
              _id: '5d6615769bcb6d0e6d79e267',
              id: 31,
              frequency: 1391,
            },
            {
              _id: '5d6615769bcb6d0e6d79e266',
              id: 32,
              frequency: 4235,
            },
            {
              _id: '5d6615769bcb6d0e6d79e265',
              id: 33,
              frequency: 8933,
            },
            {
              _id: '5d6615769bcb6d0e6d79e264',
              id: 34,
              frequency: 1587,
            },
            {
              _id: '5d6615769bcb6d0e6d79e263',
              id: 35,
              frequency: 122,
            },
            {
              _id: '5d6615769bcb6d0e6d79e262',
              id: 36,
              frequency: 521,
            },
            {
              _id: '5d6615769bcb6d0e6d79e261',
              id: 37,
              frequency: 3959,
            },
            {
              _id: '5d6615769bcb6d0e6d79e260',
              id: 38,
              frequency: 4004,
            },
            {
              _id: '5d6615769bcb6d0e6d79e25f',
              id: 39,
              frequency: 1746,
            },
            {
              _id: '5d6615769bcb6d0e6d79e25e',
              id: 40,
              frequency: 26037,
            },
            {
              _id: '5d6615769bcb6d0e6d79e25d',
              id: 41,
              frequency: 14992,
            },
            {
              _id: '5d6615769bcb6d0e6d79e25c',
              id: 42,
              frequency: 34237,
            },
            {
              _id: '5d6615769bcb6d0e6d79e25b',
              id: 43,
              frequency: 13361,
            },
            {
              _id: '5d6615769bcb6d0e6d79e25a',
              id: 44,
              frequency: 12974,
            },
            {
              _id: '5d6615769bcb6d0e6d79e259',
              id: 45,
              frequency: 1634,
            },
            {
              _id: '5d6615769bcb6d0e6d79e258',
              id: 46,
              frequency: 7423,
            },
            {
              _id: '5d6615769bcb6d0e6d79e257',
              id: 47,
              frequency: 56934,
            },
            {
              _id: '5d6615769bcb6d0e6d79e256',
              id: 48,
              frequency: 59092,
            },
            {
              _id: '5d6615769bcb6d0e6d79e255',
              id: 49,
              frequency: 245,
            },
            {
              _id: '5d6615769bcb6d0e6d79e254',
              id: 50,
              frequency: 405,
            },
            {
              _id: '5d6615769bcb6d0e6d79e253',
              id: 51,
              frequency: 7341,
            },
            {
              _id: '5d6615769bcb6d0e6d79e252',
              id: 52,
              frequency: 1887,
            },
            {
              _id: '5d6615769bcb6d0e6d79e251',
              id: 53,
              frequency: 16480,
            },
            {
              _id: '5d6615769bcb6d0e6d79e250',
              id: 54,
              frequency: 7421,
            },
            {
              _id: '5d6615769bcb6d0e6d79e24f',
              id: 55,
              frequency: 13933,
            },
            {
              _id: '5d6615769bcb6d0e6d79e24e',
              id: 56,
              frequency: 4275,
            },
            {
              _id: '5d6615769bcb6d0e6d79e24d',
              id: 57,
              frequency: 134904,
            },
            {
              _id: '5d6615769bcb6d0e6d79e24c',
              id: 58,
              frequency: 121477,
            },
            {
              _id: '5d6615769bcb6d0e6d79e24b',
              id: 59,
              frequency: 38344,
            },
            {
              _id: '5d6615769bcb6d0e6d79e24a',
              id: 60,
              frequency: 118849,
            },
            {
              _id: '5d6615769bcb6d0e6d79e249',
              id: 61,
              frequency: 61549,
            },
            {
              _id: '5d6615769bcb6d0e6d79e248',
              id: 62,
              frequency: 3096,
            },
            {
              _id: '5d6615769bcb6d0e6d79e247',
              id: 63,
              frequency: 16998,
            },
            {
              _id: '5d6615769bcb6d0e6d79e246',
              id: 64,
              frequency: 10004,
            },
            {
              _id: '5d6615769bcb6d0e6d79e245',
              id: 65,
              frequency: 60974,
            },
            {
              _id: '5d6615769bcb6d0e6d79e244',
              id: 66,
              frequency: 214945,
            },
            {
              _id: '5d6615769bcb6d0e6d79e243',
              id: 67,
              frequency: 314775,
            },
            {
              _id: '5d6615769bcb6d0e6d79e242',
              id: 68,
              frequency: 74986,
            },
            {
              _id: '5d6615769bcb6d0e6d79e241',
              id: 69,
              frequency: 15478,
            },
            {
              _id: '5d6615769bcb6d0e6d79e240',
              id: 70,
              frequency: 379054,
            },
            {
              _id: '5d6615769bcb6d0e6d79e23f',
              id: 71,
              frequency: 497743,
            },
            {
              _id: '5d6615769bcb6d0e6d79e23e',
              id: 72,
              frequency: 943467,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e1d3',
          id: 79,
          abbrevName: '80',
          fullName: '80_L_Frontal_pole',
          coordinates: {
            x: -20.545455,
            y: 61.593583,
            z: -7.336898,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e1e1',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1e0',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1df',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1de',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1dd',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1dc',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1db',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1da',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1d9',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1d8',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1d7',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1d6',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1d5',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1d4',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e22a',
              id: 0,
              frequency: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d79e229',
              id: 1,
              frequency: 1349,
            },
            {
              _id: '5d6615769bcb6d0e6d79e228',
              id: 2,
              frequency: 276,
            },
            {
              _id: '5d6615769bcb6d0e6d79e227',
              id: 3,
              frequency: 2139,
            },
            {
              _id: '5d6615769bcb6d0e6d79e226',
              id: 4,
              frequency: 5144,
            },
            {
              _id: '5d6615769bcb6d0e6d79e225',
              id: 5,
              frequency: 5146,
            },
            {
              _id: '5d6615769bcb6d0e6d79e224',
              id: 6,
              frequency: 1868,
            },
            {
              _id: '5d6615769bcb6d0e6d79e223',
              id: 7,
              frequency: 155,
            },
            {
              _id: '5d6615769bcb6d0e6d79e222',
              id: 8,
              frequency: 1580,
            },
            {
              _id: '5d6615769bcb6d0e6d79e221',
              id: 9,
              frequency: 11843,
            },
            {
              _id: '5d6615769bcb6d0e6d79e220',
              id: 10,
              frequency: 19231,
            },
            {
              _id: '5d6615769bcb6d0e6d79e21f',
              id: 11,
              frequency: 4646,
            },
            {
              _id: '5d6615769bcb6d0e6d79e21e',
              id: 12,
              frequency: 32772,
            },
            {
              _id: '5d6615769bcb6d0e6d79e21d',
              id: 13,
              frequency: 9011,
            },
            {
              _id: '5d6615769bcb6d0e6d79e21c',
              id: 14,
              frequency: 40928,
            },
            {
              _id: '5d6615769bcb6d0e6d79e21b',
              id: 15,
              frequency: 8325,
            },
            {
              _id: '5d6615769bcb6d0e6d79e21a',
              id: 16,
              frequency: 9097,
            },
            {
              _id: '5d6615769bcb6d0e6d79e219',
              id: 17,
              frequency: 7238,
            },
            {
              _id: '5d6615769bcb6d0e6d79e218',
              id: 18,
              frequency: 3712,
            },
            {
              _id: '5d6615769bcb6d0e6d79e217',
              id: 19,
              frequency: 6056,
            },
            {
              _id: '5d6615769bcb6d0e6d79e216',
              id: 20,
              frequency: 4011,
            },
            {
              _id: '5d6615769bcb6d0e6d79e215',
              id: 21,
              frequency: 1923,
            },
            {
              _id: '5d6615769bcb6d0e6d79e214',
              id: 22,
              frequency: 632,
            },
            {
              _id: '5d6615769bcb6d0e6d79e213',
              id: 23,
              frequency: 5,
            },
            {
              _id: '5d6615769bcb6d0e6d79e212',
              id: 24,
              frequency: 23356,
            },
            {
              _id: '5d6615769bcb6d0e6d79e211',
              id: 25,
              frequency: 14506,
            },
            {
              _id: '5d6615769bcb6d0e6d79e210',
              id: 26,
              frequency: 22371,
            },
            {
              _id: '5d6615769bcb6d0e6d79e20f',
              id: 27,
              frequency: 14346,
            },
            {
              _id: '5d6615769bcb6d0e6d79e20e',
              id: 28,
              frequency: 33944,
            },
            {
              _id: '5d6615769bcb6d0e6d79e20d',
              id: 29,
              frequency: 41492,
            },
            {
              _id: '5d6615769bcb6d0e6d79e20c',
              id: 30,
              frequency: 14218,
            },
            {
              _id: '5d6615769bcb6d0e6d79e20b',
              id: 31,
              frequency: 9746,
            },
            {
              _id: '5d6615769bcb6d0e6d79e20a',
              id: 32,
              frequency: 13296,
            },
            {
              _id: '5d6615769bcb6d0e6d79e209',
              id: 33,
              frequency: 685,
            },
            {
              _id: '5d6615769bcb6d0e6d79e208',
              id: 34,
              frequency: 4425,
            },
            {
              _id: '5d6615769bcb6d0e6d79e207',
              id: 35,
              frequency: 1480,
            },
            {
              _id: '5d6615769bcb6d0e6d79e206',
              id: 36,
              frequency: 2041,
            },
            {
              _id: '5d6615769bcb6d0e6d79e205',
              id: 37,
              frequency: 5116,
            },
            {
              _id: '5d6615769bcb6d0e6d79e204',
              id: 38,
              frequency: 1983,
            },
            {
              _id: '5d6615769bcb6d0e6d79e203',
              id: 39,
              frequency: 17944,
            },
            {
              _id: '5d6615769bcb6d0e6d79e202',
              id: 40,
              frequency: 60641,
            },
            {
              _id: '5d6615769bcb6d0e6d79e201',
              id: 41,
              frequency: 11487,
            },
            {
              _id: '5d6615769bcb6d0e6d79e200',
              id: 42,
              frequency: 6871,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1ff',
              id: 43,
              frequency: 70772,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1fe',
              id: 44,
              frequency: 3862,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1fd',
              id: 45,
              frequency: 25373,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1fc',
              id: 46,
              frequency: 41797,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1fb',
              id: 47,
              frequency: 61590,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1fa',
              id: 48,
              frequency: 48913,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1f9',
              id: 49,
              frequency: 460,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1f8',
              id: 50,
              frequency: 192,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1f7',
              id: 51,
              frequency: 18631,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1f6',
              id: 52,
              frequency: 10958,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1f5',
              id: 53,
              frequency: 12436,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1f4',
              id: 54,
              frequency: 22454,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1f3',
              id: 55,
              frequency: 2124,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1f2',
              id: 56,
              frequency: 64880,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1f1',
              id: 57,
              frequency: 177818,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1f0',
              id: 58,
              frequency: 53659,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1ef',
              id: 59,
              frequency: 167274,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1ee',
              id: 60,
              frequency: 106780,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1ed',
              id: 61,
              frequency: 13088,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1ec',
              id: 62,
              frequency: 7012,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1eb',
              id: 63,
              frequency: 11344,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1ea',
              id: 64,
              frequency: 11146,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1e9',
              id: 65,
              frequency: 256261,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1e8',
              id: 66,
              frequency: 358153,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1e7',
              id: 67,
              frequency: 93569,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1e6',
              id: 68,
              frequency: 58611,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1e5',
              id: 69,
              frequency: 3771,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1e4',
              id: 70,
              frequency: 524469,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1e3',
              id: 71,
              frequency: 181048,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1e2',
              id: 72,
              frequency: 558213,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e17b',
          id: 80,
          abbrevName: '81',
          fullName: '81_L_LOC_superior_angular_gyrus',
          coordinates: {
            x: 34.173077,
            y: -31.5,
            z: 59.480769,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e189',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d79e188',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79e187',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79e186',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e185',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79e184',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79e183',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e182',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e181',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79e180',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79e17f',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79e17e',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79e17d',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79e17c',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e1d2',
              id: 0,
              frequency: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1d1',
              id: 1,
              frequency: 858,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1d0',
              id: 2,
              frequency: 229,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1cf',
              id: 3,
              frequency: 2774,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1ce',
              id: 4,
              frequency: 3721,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1cd',
              id: 5,
              frequency: 2525,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1cc',
              id: 6,
              frequency: 969,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1cb',
              id: 7,
              frequency: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1ca',
              id: 8,
              frequency: 1058,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1c9',
              id: 9,
              frequency: 4037,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1c8',
              id: 10,
              frequency: 19539,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1c7',
              id: 11,
              frequency: 2311,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1c6',
              id: 12,
              frequency: 20943,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1c5',
              id: 13,
              frequency: 12548,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1c4',
              id: 14,
              frequency: 61139,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1c3',
              id: 15,
              frequency: 6342,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1c2',
              id: 16,
              frequency: 5848,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1c1',
              id: 17,
              frequency: 2316,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1c0',
              id: 18,
              frequency: 2720,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1bf',
              id: 19,
              frequency: 3674,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1be',
              id: 20,
              frequency: 1763,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1bd',
              id: 21,
              frequency: 702,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1bc',
              id: 22,
              frequency: 269,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1bb',
              id: 23,
              frequency: 8,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1ba',
              id: 24,
              frequency: 10482,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1b9',
              id: 25,
              frequency: 9495,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1b8',
              id: 26,
              frequency: 7286,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1b7',
              id: 27,
              frequency: 7260,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1b6',
              id: 28,
              frequency: 8278,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1b5',
              id: 29,
              frequency: 60266,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1b4',
              id: 30,
              frequency: 8810,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1b3',
              id: 31,
              frequency: 3151,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1b2',
              id: 32,
              frequency: 11676,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1b1',
              id: 33,
              frequency: 279,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1b0',
              id: 34,
              frequency: 1444,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1af',
              id: 35,
              frequency: 996,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1ae',
              id: 36,
              frequency: 1992,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1ad',
              id: 37,
              frequency: 2524,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1ac',
              id: 38,
              frequency: 587,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1ab',
              id: 39,
              frequency: 4891,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1aa',
              id: 40,
              frequency: 37340,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1a9',
              id: 41,
              frequency: 14898,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1a8',
              id: 42,
              frequency: 2317,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1a7',
              id: 43,
              frequency: 44498,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1a6',
              id: 44,
              frequency: 1375,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1a5',
              id: 45,
              frequency: 10185,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1a4',
              id: 46,
              frequency: 50872,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1a3',
              id: 47,
              frequency: 9615,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1a2',
              id: 48,
              frequency: 55948,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1a1',
              id: 49,
              frequency: 263,
            },
            {
              _id: '5d6615769bcb6d0e6d79e1a0',
              id: 50,
              frequency: 116,
            },
            {
              _id: '5d6615769bcb6d0e6d79e19f',
              id: 51,
              frequency: 7742,
            },
            {
              _id: '5d6615769bcb6d0e6d79e19e',
              id: 52,
              frequency: 8144,
            },
            {
              _id: '5d6615769bcb6d0e6d79e19d',
              id: 53,
              frequency: 7688,
            },
            {
              _id: '5d6615769bcb6d0e6d79e19c',
              id: 54,
              frequency: 10392,
            },
            {
              _id: '5d6615769bcb6d0e6d79e19b',
              id: 55,
              frequency: 2943,
            },
            {
              _id: '5d6615769bcb6d0e6d79e19a',
              id: 56,
              frequency: 11190,
            },
            {
              _id: '5d6615769bcb6d0e6d79e199',
              id: 57,
              frequency: 283281,
            },
            {
              _id: '5d6615769bcb6d0e6d79e198',
              id: 58,
              frequency: 9873,
            },
            {
              _id: '5d6615769bcb6d0e6d79e197',
              id: 59,
              frequency: 87757,
            },
            {
              _id: '5d6615769bcb6d0e6d79e196',
              id: 60,
              frequency: 81550,
            },
            {
              _id: '5d6615769bcb6d0e6d79e195',
              id: 61,
              frequency: 11809,
            },
            {
              _id: '5d6615769bcb6d0e6d79e194',
              id: 62,
              frequency: 2745,
            },
            {
              _id: '5d6615769bcb6d0e6d79e193',
              id: 63,
              frequency: 6395,
            },
            {
              _id: '5d6615769bcb6d0e6d79e192',
              id: 64,
              frequency: 12820,
            },
            {
              _id: '5d6615769bcb6d0e6d79e191',
              id: 65,
              frequency: 78542,
            },
            {
              _id: '5d6615769bcb6d0e6d79e190',
              id: 66,
              frequency: 355247,
            },
            {
              _id: '5d6615769bcb6d0e6d79e18f',
              id: 67,
              frequency: 109396,
            },
            {
              _id: '5d6615769bcb6d0e6d79e18e',
              id: 68,
              frequency: 46175,
            },
            {
              _id: '5d6615769bcb6d0e6d79e18d',
              id: 69,
              frequency: 6103,
            },
            {
              _id: '5d6615769bcb6d0e6d79e18c',
              id: 70,
              frequency: 348837,
            },
            {
              _id: '5d6615769bcb6d0e6d79e18b',
              id: 71,
              frequency: 331566,
            },
            {
              _id: '5d6615769bcb6d0e6d79e18a',
              id: 72,
              frequency: 950756,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e120',
          id: 81,
          abbrevName: '82',
          fullName: '82_L_Temporal_pole',
          coordinates: {
            x: -37.980392,
            y: 15.098039,
            z: -25.568627,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e131',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d79e130',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79e12f',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e12e',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79e12d',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79e12c',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d79e12b',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e12a',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e129',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79e128',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79e127',
              to: 93,
            },
            {
              _id: '5d6615769bcb6d0e6d79e126',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79e125',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79e124',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79e123',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79e122',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79e121',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e17a',
              id: 0,
              frequency: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e179',
              id: 1,
              frequency: 478,
            },
            {
              _id: '5d6615769bcb6d0e6d79e178',
              id: 2,
              frequency: 759,
            },
            {
              _id: '5d6615769bcb6d0e6d79e177',
              id: 3,
              frequency: 3246,
            },
            {
              _id: '5d6615769bcb6d0e6d79e176',
              id: 4,
              frequency: 620,
            },
            {
              _id: '5d6615769bcb6d0e6d79e175',
              id: 5,
              frequency: 4454,
            },
            {
              _id: '5d6615769bcb6d0e6d79e174',
              id: 6,
              frequency: 247,
            },
            {
              _id: '5d6615769bcb6d0e6d79e173',
              id: 7,
              frequency: 1426,
            },
            {
              _id: '5d6615769bcb6d0e6d79e172',
              id: 8,
              frequency: 676,
            },
            {
              _id: '5d6615769bcb6d0e6d79e171',
              id: 9,
              frequency: 1123,
            },
            {
              _id: '5d6615769bcb6d0e6d79e170',
              id: 10,
              frequency: 10828,
            },
            {
              _id: '5d6615769bcb6d0e6d79e16f',
              id: 11,
              frequency: 18422,
            },
            {
              _id: '5d6615769bcb6d0e6d79e16e',
              id: 12,
              frequency: 12954,
            },
            {
              _id: '5d6615769bcb6d0e6d79e16d',
              id: 13,
              frequency: 25670,
            },
            {
              _id: '5d6615769bcb6d0e6d79e16c',
              id: 14,
              frequency: 71962,
            },
            {
              _id: '5d6615769bcb6d0e6d79e16b',
              id: 15,
              frequency: 358,
            },
            {
              _id: '5d6615769bcb6d0e6d79e16a',
              id: 16,
              frequency: 4401,
            },
            {
              _id: '5d6615769bcb6d0e6d79e169',
              id: 17,
              frequency: 669,
            },
            {
              _id: '5d6615769bcb6d0e6d79e168',
              id: 18,
              frequency: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79e167',
              id: 19,
              frequency: 267,
            },
            {
              _id: '5d6615769bcb6d0e6d79e166',
              id: 20,
              frequency: 1905,
            },
            {
              _id: '5d6615769bcb6d0e6d79e165',
              id: 21,
              frequency: 7681,
            },
            {
              _id: '5d6615769bcb6d0e6d79e164',
              id: 22,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79e163',
              id: 23,
              frequency: 994,
            },
            {
              _id: '5d6615769bcb6d0e6d79e162',
              id: 24,
              frequency: 894,
            },
            {
              _id: '5d6615769bcb6d0e6d79e161',
              id: 25,
              frequency: 2087,
            },
            {
              _id: '5d6615769bcb6d0e6d79e160',
              id: 26,
              frequency: 42273,
            },
            {
              _id: '5d6615769bcb6d0e6d79e15f',
              id: 27,
              frequency: 508,
            },
            {
              _id: '5d6615769bcb6d0e6d79e15e',
              id: 28,
              frequency: 9228,
            },
            {
              _id: '5d6615769bcb6d0e6d79e15d',
              id: 29,
              frequency: 10662,
            },
            {
              _id: '5d6615769bcb6d0e6d79e15c',
              id: 30,
              frequency: 15910,
            },
            {
              _id: '5d6615769bcb6d0e6d79e15b',
              id: 31,
              frequency: 356,
            },
            {
              _id: '5d6615769bcb6d0e6d79e15a',
              id: 32,
              frequency: 2636,
            },
            {
              _id: '5d6615769bcb6d0e6d79e159',
              id: 33,
              frequency: 22002,
            },
            {
              _id: '5d6615769bcb6d0e6d79e158',
              id: 34,
              frequency: 543,
            },
            {
              _id: '5d6615769bcb6d0e6d79e157',
              id: 35,
              frequency: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d79e156',
              id: 36,
              frequency: 335,
            },
            {
              _id: '5d6615769bcb6d0e6d79e155',
              id: 37,
              frequency: 559,
            },
            {
              _id: '5d6615769bcb6d0e6d79e154',
              id: 38,
              frequency: 2753,
            },
            {
              _id: '5d6615769bcb6d0e6d79e153',
              id: 39,
              frequency: 670,
            },
            {
              _id: '5d6615769bcb6d0e6d79e152',
              id: 40,
              frequency: 8601,
            },
            {
              _id: '5d6615769bcb6d0e6d79e151',
              id: 41,
              frequency: 18254,
            },
            {
              _id: '5d6615769bcb6d0e6d79e150',
              id: 42,
              frequency: 63329,
            },
            {
              _id: '5d6615769bcb6d0e6d79e14f',
              id: 43,
              frequency: 14262,
            },
            {
              _id: '5d6615769bcb6d0e6d79e14e',
              id: 44,
              frequency: 25979,
            },
            {
              _id: '5d6615769bcb6d0e6d79e14d',
              id: 45,
              frequency: 671,
            },
            {
              _id: '5d6615769bcb6d0e6d79e14c',
              id: 46,
              frequency: 5876,
            },
            {
              _id: '5d6615769bcb6d0e6d79e14b',
              id: 47,
              frequency: 69575,
            },
            {
              _id: '5d6615769bcb6d0e6d79e14a',
              id: 48,
              frequency: 52502,
            },
            {
              _id: '5d6615769bcb6d0e6d79e149',
              id: 49,
              frequency: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79e148',
              id: 50,
              frequency: 101,
            },
            {
              _id: '5d6615769bcb6d0e6d79e147',
              id: 51,
              frequency: 2545,
            },
            {
              _id: '5d6615769bcb6d0e6d79e146',
              id: 52,
              frequency: 1805,
            },
            {
              _id: '5d6615769bcb6d0e6d79e145',
              id: 53,
              frequency: 9050,
            },
            {
              _id: '5d6615769bcb6d0e6d79e144',
              id: 54,
              frequency: 4046,
            },
            {
              _id: '5d6615769bcb6d0e6d79e143',
              id: 55,
              frequency: 12753,
            },
            {
              _id: '5d6615769bcb6d0e6d79e142',
              id: 56,
              frequency: 1360,
            },
            {
              _id: '5d6615769bcb6d0e6d79e141',
              id: 57,
              frequency: 126929,
            },
            {
              _id: '5d6615769bcb6d0e6d79e140',
              id: 58,
              frequency: 260440,
            },
            {
              _id: '5d6615769bcb6d0e6d79e13f',
              id: 59,
              frequency: 20454,
            },
            {
              _id: '5d6615769bcb6d0e6d79e13e',
              id: 60,
              frequency: 96289,
            },
            {
              _id: '5d6615769bcb6d0e6d79e13d',
              id: 61,
              frequency: 84801,
            },
            {
              _id: '5d6615769bcb6d0e6d79e13c',
              id: 62,
              frequency: 693,
            },
            {
              _id: '5d6615769bcb6d0e6d79e13b',
              id: 63,
              frequency: 5307,
            },
            {
              _id: '5d6615769bcb6d0e6d79e13a',
              id: 64,
              frequency: 8892,
            },
            {
              _id: '5d6615769bcb6d0e6d79e139',
              id: 65,
              frequency: 26036,
            },
            {
              _id: '5d6615769bcb6d0e6d79e138',
              id: 66,
              frequency: 222300,
            },
            {
              _id: '5d6615769bcb6d0e6d79e137',
              id: 67,
              frequency: 377214,
            },
            {
              _id: '5d6615769bcb6d0e6d79e136',
              id: 68,
              frequency: 27876,
            },
            {
              _id: '5d6615769bcb6d0e6d79e135',
              id: 69,
              frequency: 17887,
            },
            {
              _id: '5d6615769bcb6d0e6d79e134',
              id: 70,
              frequency: 230243,
            },
            {
              _id: '5d6615769bcb6d0e6d79e133',
              id: 71,
              frequency: 568062,
            },
            {
              _id: '5d6615769bcb6d0e6d79e132',
              id: 72,
              frequency: 1121729,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e0c9',
          id: 82,
          abbrevName: '83',
          fullName:
            '83_R_Temporal_fusiform_posterior__temporal_occiptal_fusiform',
          coordinates: {
            x: 28.222222,
            y: -36.572391,
            z: -18.707071,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e0d6',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0d5',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0d4',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0d3',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0d2',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0d1',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0d0',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0cf',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0ce',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0cd',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0cc',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0cb',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0ca',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e11f',
              id: 0,
              frequency: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79e11e',
              id: 1,
              frequency: 954,
            },
            {
              _id: '5d6615769bcb6d0e6d79e11d',
              id: 2,
              frequency: 698,
            },
            {
              _id: '5d6615769bcb6d0e6d79e11c',
              id: 3,
              frequency: 2705,
            },
            {
              _id: '5d6615769bcb6d0e6d79e11b',
              id: 4,
              frequency: 1654,
            },
            {
              _id: '5d6615769bcb6d0e6d79e11a',
              id: 5,
              frequency: 6978,
            },
            {
              _id: '5d6615769bcb6d0e6d79e119',
              id: 6,
              frequency: 364,
            },
            {
              _id: '5d6615769bcb6d0e6d79e118',
              id: 7,
              frequency: 1354,
            },
            {
              _id: '5d6615769bcb6d0e6d79e117',
              id: 8,
              frequency: 2565,
            },
            {
              _id: '5d6615769bcb6d0e6d79e116',
              id: 9,
              frequency: 5392,
            },
            {
              _id: '5d6615769bcb6d0e6d79e115',
              id: 10,
              frequency: 11868,
            },
            {
              _id: '5d6615769bcb6d0e6d79e114',
              id: 11,
              frequency: 15670,
            },
            {
              _id: '5d6615769bcb6d0e6d79e113',
              id: 12,
              frequency: 27126,
            },
            {
              _id: '5d6615769bcb6d0e6d79e112',
              id: 13,
              frequency: 21136,
            },
            {
              _id: '5d6615769bcb6d0e6d79e111',
              id: 14,
              frequency: 53721,
            },
            {
              _id: '5d6615769bcb6d0e6d79e110',
              id: 15,
              frequency: 528,
            },
            {
              _id: '5d6615769bcb6d0e6d79e10f',
              id: 16,
              frequency: 7765,
            },
            {
              _id: '5d6615769bcb6d0e6d79e10e',
              id: 17,
              frequency: 1520,
            },
            {
              _id: '5d6615769bcb6d0e6d79e10d',
              id: 18,
              frequency: 100,
            },
            {
              _id: '5d6615769bcb6d0e6d79e10c',
              id: 19,
              frequency: 337,
            },
            {
              _id: '5d6615769bcb6d0e6d79e10b',
              id: 20,
              frequency: 1804,
            },
            {
              _id: '5d6615769bcb6d0e6d79e10a',
              id: 21,
              frequency: 10217,
            },
            {
              _id: '5d6615769bcb6d0e6d79e109',
              id: 22,
              frequency: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d79e108',
              id: 23,
              frequency: 720,
            },
            {
              _id: '5d6615769bcb6d0e6d79e107',
              id: 24,
              frequency: 1839,
            },
            {
              _id: '5d6615769bcb6d0e6d79e106',
              id: 25,
              frequency: 3047,
            },
            {
              _id: '5d6615769bcb6d0e6d79e105',
              id: 26,
              frequency: 41829,
            },
            {
              _id: '5d6615769bcb6d0e6d79e104',
              id: 27,
              frequency: 3068,
            },
            {
              _id: '5d6615769bcb6d0e6d79e103',
              id: 28,
              frequency: 30156,
            },
            {
              _id: '5d6615769bcb6d0e6d79e102',
              id: 29,
              frequency: 9419,
            },
            {
              _id: '5d6615769bcb6d0e6d79e101',
              id: 30,
              frequency: 18414,
            },
            {
              _id: '5d6615769bcb6d0e6d79e100',
              id: 31,
              frequency: 897,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0ff',
              id: 32,
              frequency: 2112,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0fe',
              id: 33,
              frequency: 18848,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0fd',
              id: 34,
              frequency: 2723,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0fc',
              id: 35,
              frequency: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0fb',
              id: 36,
              frequency: 875,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0fa',
              id: 37,
              frequency: 1940,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0f9',
              id: 38,
              frequency: 8488,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0f8',
              id: 39,
              frequency: 2549,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0f7',
              id: 40,
              frequency: 13092,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0f6',
              id: 41,
              frequency: 16006,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0f5',
              id: 42,
              frequency: 53675,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0f4',
              id: 43,
              frequency: 29110,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0f3',
              id: 44,
              frequency: 23387,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0f2',
              id: 45,
              frequency: 6260,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0f1',
              id: 46,
              frequency: 9271,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0f0',
              id: 47,
              frequency: 118353,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0ef',
              id: 48,
              frequency: 41719,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0ee',
              id: 49,
              frequency: 166,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0ed',
              id: 50,
              frequency: 912,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0ec',
              id: 51,
              frequency: 15728,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0eb',
              id: 52,
              frequency: 3034,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0ea',
              id: 53,
              frequency: 25294,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0e9',
              id: 54,
              frequency: 5284,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0e8',
              id: 55,
              frequency: 14069,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0e7',
              id: 56,
              frequency: 18769,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0e6',
              id: 57,
              frequency: 83594,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0e5',
              id: 58,
              frequency: 188090,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0e4',
              id: 59,
              frequency: 70910,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0e3',
              id: 60,
              frequency: 145432,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0e2',
              id: 61,
              frequency: 72269,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0e1',
              id: 62,
              frequency: 8751,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0e0',
              id: 63,
              frequency: 27932,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0df',
              id: 64,
              frequency: 12659,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0de',
              id: 65,
              frequency: 139369,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0dd',
              id: 66,
              frequency: 241258,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0dc',
              id: 67,
              frequency: 306198,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0db',
              id: 68,
              frequency: 102724,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0da',
              id: 69,
              frequency: 10947,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0d9',
              id: 70,
              frequency: 486261,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0d8',
              id: 71,
              frequency: 397138,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0d7',
              id: 72,
              frequency: 752279,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e071',
          id: 83,
          abbrevName: '84',
          fullName: '84_R_Precuneous__cuneal_cortex',
          coordinates: {
            x: 14.669145,
            y: -73.97026,
            z: 42.156134,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e07f',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79e07e',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79e07d',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79e07c',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79e07b',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e07a',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e079',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79e078',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79e077',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79e076',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79e075',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79e074',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79e073',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79e072',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e0c8',
              id: 0,
              frequency: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0c7',
              id: 1,
              frequency: 284,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0c6',
              id: 2,
              frequency: 470,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0c5',
              id: 3,
              frequency: 3446,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0c4',
              id: 4,
              frequency: 621,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0c3',
              id: 5,
              frequency: 2365,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0c2',
              id: 6,
              frequency: 181,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0c1',
              id: 7,
              frequency: 283,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0c0',
              id: 8,
              frequency: 420,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0bf',
              id: 9,
              frequency: 352,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0be',
              id: 10,
              frequency: 11477,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0bd',
              id: 11,
              frequency: 7108,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0bc',
              id: 12,
              frequency: 5155,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0bb',
              id: 13,
              frequency: 25825,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0ba',
              id: 14,
              frequency: 80348,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0b9',
              id: 15,
              frequency: 376,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0b8',
              id: 16,
              frequency: 3446,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0b7',
              id: 17,
              frequency: 992,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0b6',
              id: 18,
              frequency: 453,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0b5',
              id: 19,
              frequency: 422,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0b4',
              id: 20,
              frequency: 1317,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0b3',
              id: 21,
              frequency: 1518,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0b2',
              id: 22,
              frequency: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0b1',
              id: 23,
              frequency: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0b0',
              id: 24,
              frequency: 599,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0af',
              id: 25,
              frequency: 3867,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0ae',
              id: 26,
              frequency: 13364,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0ad',
              id: 27,
              frequency: 427,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0ac',
              id: 28,
              frequency: 2912,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0ab',
              id: 29,
              frequency: 20360,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0aa',
              id: 30,
              frequency: 17535,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0a9',
              id: 31,
              frequency: 238,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0a8',
              id: 32,
              frequency: 4761,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0a7',
              id: 33,
              frequency: 1670,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0a6',
              id: 34,
              frequency: 327,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0a5',
              id: 35,
              frequency: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0a4',
              id: 36,
              frequency: 496,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0a3',
              id: 37,
              frequency: 824,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0a2',
              id: 38,
              frequency: 676,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0a1',
              id: 39,
              frequency: 212,
            },
            {
              _id: '5d6615769bcb6d0e6d79e0a0',
              id: 40,
              frequency: 6906,
            },
            {
              _id: '5d6615769bcb6d0e6d79e09f',
              id: 41,
              frequency: 19539,
            },
            {
              _id: '5d6615769bcb6d0e6d79e09e',
              id: 42,
              frequency: 10851,
            },
            {
              _id: '5d6615769bcb6d0e6d79e09d',
              id: 43,
              frequency: 10036,
            },
            {
              _id: '5d6615769bcb6d0e6d79e09c',
              id: 44,
              frequency: 8814,
            },
            {
              _id: '5d6615769bcb6d0e6d79e09b',
              id: 45,
              frequency: 333,
            },
            {
              _id: '5d6615769bcb6d0e6d79e09a',
              id: 46,
              frequency: 8413,
            },
            {
              _id: '5d6615769bcb6d0e6d79e099',
              id: 47,
              frequency: 8717,
            },
            {
              _id: '5d6615769bcb6d0e6d79e098',
              id: 48,
              frequency: 79125,
            },
            {
              _id: '5d6615769bcb6d0e6d79e097',
              id: 49,
              frequency: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79e096',
              id: 50,
              frequency: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d79e095',
              id: 51,
              frequency: 1130,
            },
            {
              _id: '5d6615769bcb6d0e6d79e094',
              id: 52,
              frequency: 1014,
            },
            {
              _id: '5d6615769bcb6d0e6d79e093',
              id: 53,
              frequency: 6942,
            },
            {
              _id: '5d6615769bcb6d0e6d79e092',
              id: 54,
              frequency: 1001,
            },
            {
              _id: '5d6615769bcb6d0e6d79e091',
              id: 55,
              frequency: 10011,
            },
            {
              _id: '5d6615769bcb6d0e6d79e090',
              id: 56,
              frequency: 208,
            },
            {
              _id: '5d6615769bcb6d0e6d79e08f',
              id: 57,
              frequency: 247015,
            },
            {
              _id: '5d6615769bcb6d0e6d79e08e',
              id: 58,
              frequency: 42243,
            },
            {
              _id: '5d6615769bcb6d0e6d79e08d',
              id: 59,
              frequency: 9212,
            },
            {
              _id: '5d6615769bcb6d0e6d79e08c',
              id: 60,
              frequency: 49432,
            },
            {
              _id: '5d6615769bcb6d0e6d79e08b',
              id: 61,
              frequency: 50663,
            },
            {
              _id: '5d6615769bcb6d0e6d79e08a',
              id: 62,
              frequency: 194,
            },
            {
              _id: '5d6615769bcb6d0e6d79e089',
              id: 63,
              frequency: 3098,
            },
            {
              _id: '5d6615769bcb6d0e6d79e088',
              id: 64,
              frequency: 8228,
            },
            {
              _id: '5d6615769bcb6d0e6d79e087',
              id: 65,
              frequency: 3649,
            },
            {
              _id: '5d6615769bcb6d0e6d79e086',
              id: 66,
              frequency: 150036,
            },
            {
              _id: '5d6615769bcb6d0e6d79e085',
              id: 67,
              frequency: 322935,
            },
            {
              _id: '5d6615769bcb6d0e6d79e084',
              id: 68,
              frequency: 14357,
            },
            {
              _id: '5d6615769bcb6d0e6d79e083',
              id: 69,
              frequency: 19674,
            },
            {
              _id: '5d6615769bcb6d0e6d79e082',
              id: 70,
              frequency: 69496,
            },
            {
              _id: '5d6615769bcb6d0e6d79e081',
              id: 71,
              frequency: 677087,
            },
            {
              _id: '5d6615769bcb6d0e6d79e080',
              id: 72,
              frequency: 1297644,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79e01a',
          id: 84,
          abbrevName: '85',
          fullName: '85_L_IFG_pars_opercularis__precentral',
          coordinates: {
            x: -47.138075,
            y: 11.991632,
            z: 31.330544,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79e027',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79e026',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79e025',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79e024',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79e023',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79e022',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79e021',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79e020',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79e01f',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79e01e',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79e01d',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79e01c',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79e01b',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e070',
              id: 0,
              frequency: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d79e06f',
              id: 1,
              frequency: 348,
            },
            {
              _id: '5d6615769bcb6d0e6d79e06e',
              id: 2,
              frequency: 452,
            },
            {
              _id: '5d6615769bcb6d0e6d79e06d',
              id: 3,
              frequency: 3376,
            },
            {
              _id: '5d6615769bcb6d0e6d79e06c',
              id: 4,
              frequency: 909,
            },
            {
              _id: '5d6615769bcb6d0e6d79e06b',
              id: 5,
              frequency: 2448,
            },
            {
              _id: '5d6615769bcb6d0e6d79e06a',
              id: 6,
              frequency: 256,
            },
            {
              _id: '5d6615769bcb6d0e6d79e069',
              id: 7,
              frequency: 210,
            },
            {
              _id: '5d6615769bcb6d0e6d79e068',
              id: 8,
              frequency: 538,
            },
            {
              _id: '5d6615769bcb6d0e6d79e067',
              id: 9,
              frequency: 511,
            },
            {
              _id: '5d6615769bcb6d0e6d79e066',
              id: 10,
              frequency: 12610,
            },
            {
              _id: '5d6615769bcb6d0e6d79e065',
              id: 11,
              frequency: 7041,
            },
            {
              _id: '5d6615769bcb6d0e6d79e064',
              id: 12,
              frequency: 7071,
            },
            {
              _id: '5d6615769bcb6d0e6d79e063',
              id: 13,
              frequency: 24160,
            },
            {
              _id: '5d6615769bcb6d0e6d79e062',
              id: 14,
              frequency: 78325,
            },
            {
              _id: '5d6615769bcb6d0e6d79e061',
              id: 15,
              frequency: 541,
            },
            {
              _id: '5d6615769bcb6d0e6d79e060',
              id: 16,
              frequency: 4021,
            },
            {
              _id: '5d6615769bcb6d0e6d79e05f',
              id: 17,
              frequency: 1308,
            },
            {
              _id: '5d6615769bcb6d0e6d79e05e',
              id: 18,
              frequency: 426,
            },
            {
              _id: '5d6615769bcb6d0e6d79e05d',
              id: 19,
              frequency: 720,
            },
            {
              _id: '5d6615769bcb6d0e6d79e05c',
              id: 20,
              frequency: 1561,
            },
            {
              _id: '5d6615769bcb6d0e6d79e05b',
              id: 21,
              frequency: 1151,
            },
            {
              _id: '5d6615769bcb6d0e6d79e05a',
              id: 22,
              frequency: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d79e059',
              id: 23,
              frequency: 1,
            },
            {
              _id: '5d6615769bcb6d0e6d79e058',
              id: 24,
              frequency: 721,
            },
            {
              _id: '5d6615769bcb6d0e6d79e057',
              id: 25,
              frequency: 4610,
            },
            {
              _id: '5d6615769bcb6d0e6d79e056',
              id: 26,
              frequency: 16358,
            },
            {
              _id: '5d6615769bcb6d0e6d79e055',
              id: 27,
              frequency: 981,
            },
            {
              _id: '5d6615769bcb6d0e6d79e054',
              id: 28,
              frequency: 3331,
            },
            {
              _id: '5d6615769bcb6d0e6d79e053',
              id: 29,
              frequency: 26540,
            },
            {
              _id: '5d6615769bcb6d0e6d79e052',
              id: 30,
              frequency: 16370,
            },
            {
              _id: '5d6615769bcb6d0e6d79e051',
              id: 31,
              frequency: 405,
            },
            {
              _id: '5d6615769bcb6d0e6d79e050',
              id: 32,
              frequency: 5384,
            },
            {
              _id: '5d6615769bcb6d0e6d79e04f',
              id: 33,
              frequency: 1446,
            },
            {
              _id: '5d6615769bcb6d0e6d79e04e',
              id: 34,
              frequency: 441,
            },
            {
              _id: '5d6615769bcb6d0e6d79e04d',
              id: 35,
              frequency: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79e04c',
              id: 36,
              frequency: 831,
            },
            {
              _id: '5d6615769bcb6d0e6d79e04b',
              id: 37,
              frequency: 1114,
            },
            {
              _id: '5d6615769bcb6d0e6d79e04a',
              id: 38,
              frequency: 483,
            },
            {
              _id: '5d6615769bcb6d0e6d79e049',
              id: 39,
              frequency: 304,
            },
            {
              _id: '5d6615769bcb6d0e6d79e048',
              id: 40,
              frequency: 9687,
            },
            {
              _id: '5d6615769bcb6d0e6d79e047',
              id: 41,
              frequency: 21987,
            },
            {
              _id: '5d6615769bcb6d0e6d79e046',
              id: 42,
              frequency: 8359,
            },
            {
              _id: '5d6615769bcb6d0e6d79e045',
              id: 43,
              frequency: 12602,
            },
            {
              _id: '5d6615769bcb6d0e6d79e044',
              id: 44,
              frequency: 9045,
            },
            {
              _id: '5d6615769bcb6d0e6d79e043',
              id: 45,
              frequency: 769,
            },
            {
              _id: '5d6615769bcb6d0e6d79e042',
              id: 46,
              frequency: 13661,
            },
            {
              _id: '5d6615769bcb6d0e6d79e041',
              id: 47,
              frequency: 9898,
            },
            {
              _id: '5d6615769bcb6d0e6d79e040',
              id: 48,
              frequency: 72596,
            },
            {
              _id: '5d6615769bcb6d0e6d79e03f',
              id: 49,
              frequency: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79e03e',
              id: 50,
              frequency: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79e03d',
              id: 51,
              frequency: 1547,
            },
            {
              _id: '5d6615769bcb6d0e6d79e03c',
              id: 52,
              frequency: 1792,
            },
            {
              _id: '5d6615769bcb6d0e6d79e03b',
              id: 53,
              frequency: 8560,
            },
            {
              _id: '5d6615769bcb6d0e6d79e03a',
              id: 54,
              frequency: 2190,
            },
            {
              _id: '5d6615769bcb6d0e6d79e039',
              id: 55,
              frequency: 6595,
            },
            {
              _id: '5d6615769bcb6d0e6d79e038',
              id: 56,
              frequency: 425,
            },
            {
              _id: '5d6615769bcb6d0e6d79e037',
              id: 57,
              frequency: 243603,
            },
            {
              _id: '5d6615769bcb6d0e6d79e036',
              id: 58,
              frequency: 47772,
            },
            {
              _id: '5d6615769bcb6d0e6d79e035',
              id: 59,
              frequency: 13525,
            },
            {
              _id: '5d6615769bcb6d0e6d79e034',
              id: 60,
              frequency: 57210,
            },
            {
              _id: '5d6615769bcb6d0e6d79e033',
              id: 61,
              frequency: 47412,
            },
            {
              _id: '5d6615769bcb6d0e6d79e032',
              id: 62,
              frequency: 330,
            },
            {
              _id: '5d6615769bcb6d0e6d79e031',
              id: 63,
              frequency: 4013,
            },
            {
              _id: '5d6615769bcb6d0e6d79e030',
              id: 64,
              frequency: 9481,
            },
            {
              _id: '5d6615769bcb6d0e6d79e02f',
              id: 65,
              frequency: 6396,
            },
            {
              _id: '5d6615769bcb6d0e6d79e02e',
              id: 66,
              frequency: 189797,
            },
            {
              _id: '5d6615769bcb6d0e6d79e02d',
              id: 67,
              frequency: 304555,
            },
            {
              _id: '5d6615769bcb6d0e6d79e02c',
              id: 68,
              frequency: 19490,
            },
            {
              _id: '5d6615769bcb6d0e6d79e02b',
              id: 69,
              frequency: 17499,
            },
            {
              _id: '5d6615769bcb6d0e6d79e02a',
              id: 70,
              frequency: 102736,
            },
            {
              _id: '5d6615769bcb6d0e6d79e029',
              id: 71,
              frequency: 625763,
            },
            {
              _id: '5d6615769bcb6d0e6d79e028',
              id: 72,
              frequency: 1263443,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79dfc7',
          id: 85,
          abbrevName: '86',
          fullName: '86_L_LOC_superior',
          coordinates: {
            x: -43.357401,
            y: -66.707581,
            z: 35.855596,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79dfd0',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfcf',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfce',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfcd',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfcc',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfcb',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfca',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfc9',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfc8',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79e019',
              id: 0,
              frequency: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79e018',
              id: 1,
              frequency: 1578,
            },
            {
              _id: '5d6615769bcb6d0e6d79e017',
              id: 2,
              frequency: 148,
            },
            {
              _id: '5d6615769bcb6d0e6d79e016',
              id: 3,
              frequency: 1743,
            },
            {
              _id: '5d6615769bcb6d0e6d79e015',
              id: 4,
              frequency: 7291,
            },
            {
              _id: '5d6615769bcb6d0e6d79e014',
              id: 5,
              frequency: 3270,
            },
            {
              _id: '5d6615769bcb6d0e6d79e013',
              id: 6,
              frequency: 2817,
            },
            {
              _id: '5d6615769bcb6d0e6d79e012',
              id: 7,
              frequency: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d79e011',
              id: 8,
              frequency: 1513,
            },
            {
              _id: '5d6615769bcb6d0e6d79e010',
              id: 9,
              frequency: 17883,
            },
            {
              _id: '5d6615769bcb6d0e6d79e00f',
              id: 10,
              frequency: 18986,
            },
            {
              _id: '5d6615769bcb6d0e6d79e00e',
              id: 11,
              frequency: 1753,
            },
            {
              _id: '5d6615769bcb6d0e6d79e00d',
              id: 12,
              frequency: 35488,
            },
            {
              _id: '5d6615769bcb6d0e6d79e00c',
              id: 13,
              frequency: 5275,
            },
            {
              _id: '5d6615769bcb6d0e6d79e00b',
              id: 14,
              frequency: 30759,
            },
            {
              _id: '5d6615769bcb6d0e6d79e00a',
              id: 15,
              frequency: 14293,
            },
            {
              _id: '5d6615769bcb6d0e6d79e009',
              id: 16,
              frequency: 5631,
            },
            {
              _id: '5d6615769bcb6d0e6d79e008',
              id: 17,
              frequency: 8243,
            },
            {
              _id: '5d6615769bcb6d0e6d79e007',
              id: 18,
              frequency: 5382,
            },
            {
              _id: '5d6615769bcb6d0e6d79e006',
              id: 19,
              frequency: 12845,
            },
            {
              _id: '5d6615769bcb6d0e6d79e005',
              id: 20,
              frequency: 2737,
            },
            {
              _id: '5d6615769bcb6d0e6d79e004',
              id: 21,
              frequency: 607,
            },
            {
              _id: '5d6615769bcb6d0e6d79e003',
              id: 22,
              frequency: 1278,
            },
            {
              _id: '5d6615769bcb6d0e6d79e002',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79e001',
              id: 24,
              frequency: 41082,
            },
            {
              _id: '5d6615769bcb6d0e6d79e000',
              id: 25,
              frequency: 20727,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfff',
              id: 26,
              frequency: 8993,
            },
            {
              _id: '5d6615769bcb6d0e6d79dffe',
              id: 27,
              frequency: 25959,
            },
            {
              _id: '5d6615769bcb6d0e6d79dffd',
              id: 28,
              frequency: 21953,
            },
            {
              _id: '5d6615769bcb6d0e6d79dffc',
              id: 29,
              frequency: 46992,
            },
            {
              _id: '5d6615769bcb6d0e6d79dffb',
              id: 30,
              frequency: 7828,
            },
            {
              _id: '5d6615769bcb6d0e6d79dffa',
              id: 31,
              frequency: 17940,
            },
            {
              _id: '5d6615769bcb6d0e6d79dff9',
              id: 32,
              frequency: 15042,
            },
            {
              _id: '5d6615769bcb6d0e6d79dff8',
              id: 33,
              frequency: 152,
            },
            {
              _id: '5d6615769bcb6d0e6d79dff7',
              id: 34,
              frequency: 4370,
            },
            {
              _id: '5d6615769bcb6d0e6d79dff6',
              id: 35,
              frequency: 3137,
            },
            {
              _id: '5d6615769bcb6d0e6d79dff5',
              id: 36,
              frequency: 2249,
            },
            {
              _id: '5d6615769bcb6d0e6d79dff4',
              id: 37,
              frequency: 6124,
            },
            {
              _id: '5d6615769bcb6d0e6d79dff3',
              id: 38,
              frequency: 433,
            },
            {
              _id: '5d6615769bcb6d0e6d79dff2',
              id: 39,
              frequency: 35437,
            },
            {
              _id: '5d6615769bcb6d0e6d79dff1',
              id: 40,
              frequency: 83386,
            },
            {
              _id: '5d6615769bcb6d0e6d79dff0',
              id: 41,
              frequency: 7656,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfef',
              id: 42,
              frequency: 1187,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfee',
              id: 43,
              frequency: 83120,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfed',
              id: 44,
              frequency: 537,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfec',
              id: 45,
              frequency: 48344,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfeb',
              id: 46,
              frequency: 51411,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfea',
              id: 47,
              frequency: 25758,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfe9',
              id: 48,
              frequency: 33897,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfe8',
              id: 49,
              frequency: 583,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfe7',
              id: 50,
              frequency: 109,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfe6',
              id: 51,
              frequency: 23233,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfe5',
              id: 52,
              frequency: 13364,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfe4',
              id: 53,
              frequency: 7554,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfe3',
              id: 54,
              frequency: 31691,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfe2',
              id: 55,
              frequency: 456,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfe1',
              id: 56,
              frequency: 126978,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfe0',
              id: 57,
              frequency: 160343,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfdf',
              id: 58,
              frequency: 14151,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfde',
              id: 59,
              frequency: 226107,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfdd',
              id: 60,
              frequency: 76504,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfdc',
              id: 61,
              frequency: 5120,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfdb',
              id: 62,
              frequency: 8787,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfda',
              id: 63,
              frequency: 10356,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfd9',
              id: 64,
              frequency: 9241,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfd8',
              id: 65,
              frequency: 359438,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfd7',
              id: 66,
              frequency: 328866,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfd6',
              id: 67,
              frequency: 45908,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfd5',
              id: 68,
              frequency: 52513,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfd4',
              id: 69,
              frequency: 1341,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfd3',
              id: 70,
              frequency: 527590,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfd2',
              id: 71,
              frequency: 100625,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfd1',
              id: 72,
              frequency: 388368,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79df75',
          id: 86,
          abbrevName: '87',
          fullName: '87_L_Cerebellum',
          coordinates: {
            x: -22.35249,
            y: -61.938697,
            z: -55.969349,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79df7d',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79df7c',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79df7b',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79df7a',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79df79',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79df78',
              to: 93,
            },
            {
              _id: '5d6615769bcb6d0e6d79df77',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79df76',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79dfc6',
              id: 0,
              frequency: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfc5',
              id: 1,
              frequency: 1558,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfc4',
              id: 2,
              frequency: 239,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfc3',
              id: 3,
              frequency: 1714,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfc2',
              id: 4,
              frequency: 9240,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfc1',
              id: 5,
              frequency: 4779,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfc0',
              id: 6,
              frequency: 1698,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfbf',
              id: 7,
              frequency: 219,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfbe',
              id: 8,
              frequency: 2081,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfbd',
              id: 9,
              frequency: 18456,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfbc',
              id: 10,
              frequency: 16729,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfbb',
              id: 11,
              frequency: 3878,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfba',
              id: 12,
              frequency: 35463,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfb9',
              id: 13,
              frequency: 6166,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfb8',
              id: 14,
              frequency: 29448,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfb7',
              id: 15,
              frequency: 16336,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfb6',
              id: 16,
              frequency: 21493,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfb5',
              id: 17,
              frequency: 2171,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfb4',
              id: 18,
              frequency: 5131,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfb3',
              id: 19,
              frequency: 7824,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfb2',
              id: 20,
              frequency: 3433,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfb1',
              id: 21,
              frequency: 3444,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfb0',
              id: 22,
              frequency: 130,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfaf',
              id: 23,
              frequency: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfae',
              id: 24,
              frequency: 42391,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfad',
              id: 25,
              frequency: 8381,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfac',
              id: 26,
              frequency: 27106,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfab',
              id: 27,
              frequency: 36322,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfaa',
              id: 28,
              frequency: 39473,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfa9',
              id: 29,
              frequency: 59272,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfa8',
              id: 30,
              frequency: 7179,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfa7',
              id: 31,
              frequency: 10092,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfa6',
              id: 32,
              frequency: 6977,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfa5',
              id: 33,
              frequency: 2302,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfa4',
              id: 34,
              frequency: 5512,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfa3',
              id: 35,
              frequency: 3319,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfa2',
              id: 36,
              frequency: 5197,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfa1',
              id: 37,
              frequency: 4522,
            },
            {
              _id: '5d6615769bcb6d0e6d79dfa0',
              id: 38,
              frequency: 2871,
            },
            {
              _id: '5d6615769bcb6d0e6d79df9f',
              id: 39,
              frequency: 24978,
            },
            {
              _id: '5d6615769bcb6d0e6d79df9e',
              id: 40,
              frequency: 46738,
            },
            {
              _id: '5d6615769bcb6d0e6d79df9d',
              id: 41,
              frequency: 14501,
            },
            {
              _id: '5d6615769bcb6d0e6d79df9c',
              id: 42,
              frequency: 7018,
            },
            {
              _id: '5d6615769bcb6d0e6d79df9b',
              id: 43,
              frequency: 73146,
            },
            {
              _id: '5d6615769bcb6d0e6d79df9a',
              id: 44,
              frequency: 1391,
            },
            {
              _id: '5d6615769bcb6d0e6d79df99',
              id: 45,
              frequency: 73044,
            },
            {
              _id: '5d6615769bcb6d0e6d79df98',
              id: 46,
              frequency: 86811,
            },
            {
              _id: '5d6615769bcb6d0e6d79df97',
              id: 47,
              frequency: 59092,
            },
            {
              _id: '5d6615769bcb6d0e6d79df96',
              id: 48,
              frequency: 28257,
            },
            {
              _id: '5d6615769bcb6d0e6d79df95',
              id: 49,
              frequency: 571,
            },
            {
              _id: '5d6615769bcb6d0e6d79df94',
              id: 50,
              frequency: 394,
            },
            {
              _id: '5d6615769bcb6d0e6d79df93',
              id: 51,
              frequency: 27655,
            },
            {
              _id: '5d6615769bcb6d0e6d79df92',
              id: 52,
              frequency: 12622,
            },
            {
              _id: '5d6615769bcb6d0e6d79df91',
              id: 53,
              frequency: 11873,
            },
            {
              _id: '5d6615769bcb6d0e6d79df90',
              id: 54,
              frequency: 21232,
            },
            {
              _id: '5d6615769bcb6d0e6d79df8f',
              id: 55,
              frequency: 1318,
            },
            {
              _id: '5d6615769bcb6d0e6d79df8e',
              id: 56,
              frequency: 138980,
            },
            {
              _id: '5d6615769bcb6d0e6d79df8d',
              id: 57,
              frequency: 142599,
            },
            {
              _id: '5d6615769bcb6d0e6d79df8c',
              id: 58,
              frequency: 45217,
            },
            {
              _id: '5d6615769bcb6d0e6d79df8b',
              id: 59,
              frequency: 244176,
            },
            {
              _id: '5d6615769bcb6d0e6d79df8a',
              id: 60,
              frequency: 79111,
            },
            {
              _id: '5d6615769bcb6d0e6d79df89',
              id: 61,
              frequency: 7453,
            },
            {
              _id: '5d6615769bcb6d0e6d79df88',
              id: 62,
              frequency: 14915,
            },
            {
              _id: '5d6615769bcb6d0e6d79df87',
              id: 63,
              frequency: 15745,
            },
            {
              _id: '5d6615769bcb6d0e6d79df86',
              id: 64,
              frequency: 8737,
            },
            {
              _id: '5d6615769bcb6d0e6d79df85',
              id: 65,
              frequency: 364996,
            },
            {
              _id: '5d6615769bcb6d0e6d79df84',
              id: 66,
              frequency: 271224,
            },
            {
              _id: '5d6615769bcb6d0e6d79df83',
              id: 67,
              frequency: 57919,
            },
            {
              _id: '5d6615769bcb6d0e6d79df82',
              id: 68,
              frequency: 70788,
            },
            {
              _id: '5d6615769bcb6d0e6d79df81',
              id: 69,
              frequency: 1899,
            },
            {
              _id: '5d6615769bcb6d0e6d79df80',
              id: 70,
              frequency: 532165,
            },
            {
              _id: '5d6615769bcb6d0e6d79df7f',
              id: 71,
              frequency: 110324,
            },
            {
              _id: '5d6615769bcb6d0e6d79df7e',
              id: 72,
              frequency: 360774,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79df22',
          id: 87,
          abbrevName: '88',
          fullName: '88_L_IFG_pars_opercularis_juxtapositional_lobule_smc',
          coordinates: {
            x: 1.178378,
            y: -1.718919,
            z: 60.972973,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79df2b',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79df2a',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79df29',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79df28',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79df27',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79df26',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79df25',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79df24',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79df23',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79df74',
              id: 0,
              frequency: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d79df73',
              id: 1,
              frequency: 589,
            },
            {
              _id: '5d6615769bcb6d0e6d79df72',
              id: 2,
              frequency: 380,
            },
            {
              _id: '5d6615769bcb6d0e6d79df71',
              id: 3,
              frequency: 3106,
            },
            {
              _id: '5d6615769bcb6d0e6d79df70',
              id: 4,
              frequency: 1823,
            },
            {
              _id: '5d6615769bcb6d0e6d79df6f',
              id: 5,
              frequency: 3076,
            },
            {
              _id: '5d6615769bcb6d0e6d79df6e',
              id: 6,
              frequency: 398,
            },
            {
              _id: '5d6615769bcb6d0e6d79df6d',
              id: 7,
              frequency: 244,
            },
            {
              _id: '5d6615769bcb6d0e6d79df6c',
              id: 8,
              frequency: 944,
            },
            {
              _id: '5d6615769bcb6d0e6d79df6b',
              id: 9,
              frequency: 1817,
            },
            {
              _id: '5d6615769bcb6d0e6d79df6a',
              id: 10,
              frequency: 15309,
            },
            {
              _id: '5d6615769bcb6d0e6d79df69',
              id: 11,
              frequency: 5347,
            },
            {
              _id: '5d6615769bcb6d0e6d79df68',
              id: 12,
              frequency: 14307,
            },
            {
              _id: '5d6615769bcb6d0e6d79df67',
              id: 13,
              frequency: 19734,
            },
            {
              _id: '5d6615769bcb6d0e6d79df66',
              id: 14,
              frequency: 69959,
            },
            {
              _id: '5d6615769bcb6d0e6d79df65',
              id: 15,
              frequency: 2508,
            },
            {
              _id: '5d6615769bcb6d0e6d79df64',
              id: 16,
              frequency: 5150,
            },
            {
              _id: '5d6615769bcb6d0e6d79df63',
              id: 17,
              frequency: 1906,
            },
            {
              _id: '5d6615769bcb6d0e6d79df62',
              id: 18,
              frequency: 940,
            },
            {
              _id: '5d6615769bcb6d0e6d79df61',
              id: 19,
              frequency: 755,
            },
            {
              _id: '5d6615769bcb6d0e6d79df60',
              id: 20,
              frequency: 1954,
            },
            {
              _id: '5d6615769bcb6d0e6d79df5f',
              id: 21,
              frequency: 1921,
            },
            {
              _id: '5d6615769bcb6d0e6d79df5e',
              id: 22,
              frequency: 130,
            },
            {
              _id: '5d6615769bcb6d0e6d79df5d',
              id: 23,
              frequency: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d79df5c',
              id: 24,
              frequency: 3578,
            },
            {
              _id: '5d6615769bcb6d0e6d79df5b',
              id: 25,
              frequency: 4905,
            },
            {
              _id: '5d6615769bcb6d0e6d79df5a',
              id: 26,
              frequency: 14022,
            },
            {
              _id: '5d6615769bcb6d0e6d79df59',
              id: 27,
              frequency: 2622,
            },
            {
              _id: '5d6615769bcb6d0e6d79df58',
              id: 28,
              frequency: 7119,
            },
            {
              _id: '5d6615769bcb6d0e6d79df57',
              id: 29,
              frequency: 36133,
            },
            {
              _id: '5d6615769bcb6d0e6d79df56',
              id: 30,
              frequency: 16080,
            },
            {
              _id: '5d6615769bcb6d0e6d79df55',
              id: 31,
              frequency: 797,
            },
            {
              _id: '5d6615769bcb6d0e6d79df54',
              id: 32,
              frequency: 6616,
            },
            {
              _id: '5d6615769bcb6d0e6d79df53',
              id: 33,
              frequency: 1405,
            },
            {
              _id: '5d6615769bcb6d0e6d79df52',
              id: 34,
              frequency: 1175,
            },
            {
              _id: '5d6615769bcb6d0e6d79df51',
              id: 35,
              frequency: 214,
            },
            {
              _id: '5d6615769bcb6d0e6d79df50',
              id: 36,
              frequency: 1298,
            },
            {
              _id: '5d6615769bcb6d0e6d79df4f',
              id: 37,
              frequency: 1756,
            },
            {
              _id: '5d6615769bcb6d0e6d79df4e',
              id: 38,
              frequency: 1049,
            },
            {
              _id: '5d6615769bcb6d0e6d79df4d',
              id: 39,
              frequency: 1424,
            },
            {
              _id: '5d6615769bcb6d0e6d79df4c',
              id: 40,
              frequency: 16984,
            },
            {
              _id: '5d6615769bcb6d0e6d79df4b',
              id: 41,
              frequency: 18060,
            },
            {
              _id: '5d6615769bcb6d0e6d79df4a',
              id: 42,
              frequency: 8964,
            },
            {
              _id: '5d6615769bcb6d0e6d79df49',
              id: 43,
              frequency: 24526,
            },
            {
              _id: '5d6615769bcb6d0e6d79df48',
              id: 44,
              frequency: 4982,
            },
            {
              _id: '5d6615769bcb6d0e6d79df47',
              id: 45,
              frequency: 3093,
            },
            {
              _id: '5d6615769bcb6d0e6d79df46',
              id: 46,
              frequency: 24795,
            },
            {
              _id: '5d6615769bcb6d0e6d79df45',
              id: 47,
              frequency: 16048,
            },
            {
              _id: '5d6615769bcb6d0e6d79df44',
              id: 48,
              frequency: 71711,
            },
            {
              _id: '5d6615769bcb6d0e6d79df43',
              id: 49,
              frequency: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d79df42',
              id: 50,
              frequency: 145,
            },
            {
              _id: '5d6615769bcb6d0e6d79df41',
              id: 51,
              frequency: 4996,
            },
            {
              _id: '5d6615769bcb6d0e6d79df40',
              id: 52,
              frequency: 4084,
            },
            {
              _id: '5d6615769bcb6d0e6d79df3f',
              id: 53,
              frequency: 9987,
            },
            {
              _id: '5d6615769bcb6d0e6d79df3e',
              id: 54,
              frequency: 2819,
            },
            {
              _id: '5d6615769bcb6d0e6d79df3d',
              id: 55,
              frequency: 7918,
            },
            {
              _id: '5d6615769bcb6d0e6d79df3c',
              id: 56,
              frequency: 3219,
            },
            {
              _id: '5d6615769bcb6d0e6d79df3b',
              id: 57,
              frequency: 244635,
            },
            {
              _id: '5d6615769bcb6d0e6d79df3a',
              id: 58,
              frequency: 32825,
            },
            {
              _id: '5d6615769bcb6d0e6d79df39',
              id: 59,
              frequency: 42326,
            },
            {
              _id: '5d6615769bcb6d0e6d79df38',
              id: 60,
              frequency: 86316,
            },
            {
              _id: '5d6615769bcb6d0e6d79df37',
              id: 61,
              frequency: 32011,
            },
            {
              _id: '5d6615769bcb6d0e6d79df36',
              id: 62,
              frequency: 1484,
            },
            {
              _id: '5d6615769bcb6d0e6d79df35',
              id: 63,
              frequency: 7249,
            },
            {
              _id: '5d6615769bcb6d0e6d79df34',
              id: 64,
              frequency: 12016,
            },
            {
              _id: '5d6615769bcb6d0e6d79df33',
              id: 65,
              frequency: 34438,
            },
            {
              _id: '5d6615769bcb6d0e6d79df32',
              id: 66,
              frequency: 261940,
            },
            {
              _id: '5d6615769bcb6d0e6d79df31',
              id: 67,
              frequency: 229944,
            },
            {
              _id: '5d6615769bcb6d0e6d79df30',
              id: 68,
              frequency: 39423,
            },
            {
              _id: '5d6615769bcb6d0e6d79df2f',
              id: 69,
              frequency: 12128,
            },
            {
              _id: '5d6615769bcb6d0e6d79df2e',
              id: 70,
              frequency: 240925,
            },
            {
              _id: '5d6615769bcb6d0e6d79df2d',
              id: 71,
              frequency: 496657,
            },
            {
              _id: '5d6615769bcb6d0e6d79df2c',
              id: 72,
              frequency: 1102649,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79ded6',
          id: 88,
          abbrevName: '89',
          fullName: '89_R_Temporal_fusiform_cortex_anterior__itg_anterior',
          coordinates: {
            x: 40.509804,
            y: -5.895425,
            z: -39.869281,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79ded8',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79ded7',
              to: 91,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79df21',
              id: 0,
              frequency: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d79df20',
              id: 1,
              frequency: 1218,
            },
            {
              _id: '5d6615769bcb6d0e6d79df1f',
              id: 2,
              frequency: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d79df1e',
              id: 3,
              frequency: 236,
            },
            {
              _id: '5d6615769bcb6d0e6d79df1d',
              id: 4,
              frequency: 14002,
            },
            {
              _id: '5d6615769bcb6d0e6d79df1c',
              id: 5,
              frequency: 2008,
            },
            {
              _id: '5d6615769bcb6d0e6d79df1b',
              id: 6,
              frequency: 3384,
            },
            {
              _id: '5d6615769bcb6d0e6d79df1a',
              id: 7,
              frequency: 8,
            },
            {
              _id: '5d6615769bcb6d0e6d79df19',
              id: 8,
              frequency: 524,
            },
            {
              _id: '5d6615769bcb6d0e6d79df18',
              id: 9,
              frequency: 32345,
            },
            {
              _id: '5d6615769bcb6d0e6d79df17',
              id: 10,
              frequency: 6250,
            },
            {
              _id: '5d6615769bcb6d0e6d79df16',
              id: 11,
              frequency: 182,
            },
            {
              _id: '5d6615769bcb6d0e6d79df15',
              id: 12,
              frequency: 9354,
            },
            {
              _id: '5d6615769bcb6d0e6d79df14',
              id: 13,
              frequency: 492,
            },
            {
              _id: '5d6615769bcb6d0e6d79df13',
              id: 14,
              frequency: 1342,
            },
            {
              _id: '5d6615769bcb6d0e6d79df12',
              id: 15,
              frequency: 40469,
            },
            {
              _id: '5d6615769bcb6d0e6d79df11',
              id: 16,
              frequency: 14521,
            },
            {
              _id: '5d6615769bcb6d0e6d79df10',
              id: 17,
              frequency: 1022,
            },
            {
              _id: '5d6615769bcb6d0e6d79df0f',
              id: 18,
              frequency: 12914,
            },
            {
              _id: '5d6615769bcb6d0e6d79df0e',
              id: 19,
              frequency: 21531,
            },
            {
              _id: '5d6615769bcb6d0e6d79df0d',
              id: 20,
              frequency: 4642,
            },
            {
              _id: '5d6615769bcb6d0e6d79df0c',
              id: 21,
              frequency: 377,
            },
            {
              _id: '5d6615769bcb6d0e6d79df0b',
              id: 22,
              frequency: 1729,
            },
            {
              _id: '5d6615769bcb6d0e6d79df0a',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79df09',
              id: 24,
              frequency: 96593,
            },
            {
              _id: '5d6615769bcb6d0e6d79df08',
              id: 25,
              frequency: 5436,
            },
            {
              _id: '5d6615769bcb6d0e6d79df07',
              id: 26,
              frequency: 2865,
            },
            {
              _id: '5d6615769bcb6d0e6d79df06',
              id: 27,
              frequency: 144010,
            },
            {
              _id: '5d6615769bcb6d0e6d79df05',
              id: 28,
              frequency: 45914,
            },
            {
              _id: '5d6615769bcb6d0e6d79df04',
              id: 29,
              frequency: 45759,
            },
            {
              _id: '5d6615769bcb6d0e6d79df03',
              id: 30,
              frequency: 1317,
            },
            {
              _id: '5d6615769bcb6d0e6d79df02',
              id: 31,
              frequency: 40535,
            },
            {
              _id: '5d6615769bcb6d0e6d79df01',
              id: 32,
              frequency: 8067,
            },
            {
              _id: '5d6615769bcb6d0e6d79df00',
              id: 33,
              frequency: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d79deff',
              id: 34,
              frequency: 2469,
            },
            {
              _id: '5d6615769bcb6d0e6d79defe',
              id: 35,
              frequency: 12419,
            },
            {
              _id: '5d6615769bcb6d0e6d79defd',
              id: 36,
              frequency: 2078,
            },
            {
              _id: '5d6615769bcb6d0e6d79defc',
              id: 37,
              frequency: 2727,
            },
            {
              _id: '5d6615769bcb6d0e6d79defb',
              id: 38,
              frequency: 157,
            },
            {
              _id: '5d6615769bcb6d0e6d79defa',
              id: 39,
              frequency: 120858,
            },
            {
              _id: '5d6615769bcb6d0e6d79def9',
              id: 40,
              frequency: 31982,
            },
            {
              _id: '5d6615769bcb6d0e6d79def8',
              id: 41,
              frequency: 2630,
            },
            {
              _id: '5d6615769bcb6d0e6d79def7',
              id: 42,
              frequency: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79def6',
              id: 43,
              frequency: 85069,
            },
            {
              _id: '5d6615769bcb6d0e6d79def5',
              id: 44,
              frequency: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d79def4',
              id: 45,
              frequency: 250327,
            },
            {
              _id: '5d6615769bcb6d0e6d79def3',
              id: 46,
              frequency: 31263,
            },
            {
              _id: '5d6615769bcb6d0e6d79def2',
              id: 47,
              frequency: 6043,
            },
            {
              _id: '5d6615769bcb6d0e6d79def1',
              id: 48,
              frequency: 7110,
            },
            {
              _id: '5d6615769bcb6d0e6d79def0',
              id: 49,
              frequency: 288,
            },
            {
              _id: '5d6615769bcb6d0e6d79deef',
              id: 50,
              frequency: 9,
            },
            {
              _id: '5d6615769bcb6d0e6d79deee',
              id: 51,
              frequency: 17693,
            },
            {
              _id: '5d6615769bcb6d0e6d79deed',
              id: 52,
              frequency: 8544,
            },
            {
              _id: '5d6615769bcb6d0e6d79deec',
              id: 53,
              frequency: 1425,
            },
            {
              _id: '5d6615769bcb6d0e6d79deeb',
              id: 54,
              frequency: 14919,
            },
            {
              _id: '5d6615769bcb6d0e6d79deea',
              id: 55,
              frequency: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d79dee9',
              id: 56,
              frequency: 558519,
            },
            {
              _id: '5d6615769bcb6d0e6d79dee8',
              id: 57,
              frequency: 16987,
            },
            {
              _id: '5d6615769bcb6d0e6d79dee7',
              id: 58,
              frequency: 363,
            },
            {
              _id: '5d6615769bcb6d0e6d79dee6',
              id: 59,
              frequency: 155365,
            },
            {
              _id: '5d6615769bcb6d0e6d79dee5',
              id: 60,
              frequency: 16988,
            },
            {
              _id: '5d6615769bcb6d0e6d79dee4',
              id: 61,
              frequency: 289,
            },
            {
              _id: '5d6615769bcb6d0e6d79dee3',
              id: 62,
              frequency: 7232,
            },
            {
              _id: '5d6615769bcb6d0e6d79dee2',
              id: 63,
              frequency: 1109,
            },
            {
              _id: '5d6615769bcb6d0e6d79dee1',
              id: 64,
              frequency: 967,
            },
            {
              _id: '5d6615769bcb6d0e6d79dee0',
              id: 65,
              frequency: 212715,
            },
            {
              _id: '5d6615769bcb6d0e6d79dedf',
              id: 66,
              frequency: 33972,
            },
            {
              _id: '5d6615769bcb6d0e6d79dede',
              id: 67,
              frequency: 1763,
            },
            {
              _id: '5d6615769bcb6d0e6d79dedd',
              id: 68,
              frequency: 6734,
            },
            {
              _id: '5d6615769bcb6d0e6d79dedc',
              id: 69,
              frequency: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79dedb',
              id: 70,
              frequency: 44736,
            },
            {
              _id: '5d6615769bcb6d0e6d79deda',
              id: 71,
              frequency: 2836,
            },
            {
              _id: '5d6615769bcb6d0e6d79ded9',
              id: 72,
              frequency: 5096,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79de82',
          id: 89,
          abbrevName: '90',
          fullName: '90_L_Temporal_fusiform_gyrus_posterior_pcc_phc_hc',
          coordinates: {
            x: -23.992395,
            y: -38.197719,
            z: -14.768061,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79de8c',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79de8b',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79de8a',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79de89',
              to: 93,
            },
            {
              _id: '5d6615769bcb6d0e6d79de88',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79de87',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79de86',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79de85',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79de84',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79de83',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79ded5',
              id: 0,
              frequency: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d79ded4',
              id: 1,
              frequency: 579,
            },
            {
              _id: '5d6615769bcb6d0e6d79ded3',
              id: 2,
              frequency: 773,
            },
            {
              _id: '5d6615769bcb6d0e6d79ded2',
              id: 3,
              frequency: 3143,
            },
            {
              _id: '5d6615769bcb6d0e6d79ded1',
              id: 4,
              frequency: 455,
            },
            {
              _id: '5d6615769bcb6d0e6d79ded0',
              id: 5,
              frequency: 4767,
            },
            {
              _id: '5d6615769bcb6d0e6d79decf',
              id: 6,
              frequency: 122,
            },
            {
              _id: '5d6615769bcb6d0e6d79dece',
              id: 7,
              frequency: 1709,
            },
            {
              _id: '5d6615769bcb6d0e6d79decd',
              id: 8,
              frequency: 1552,
            },
            {
              _id: '5d6615769bcb6d0e6d79decc',
              id: 9,
              frequency: 1700,
            },
            {
              _id: '5d6615769bcb6d0e6d79decb',
              id: 10,
              frequency: 8611,
            },
            {
              _id: '5d6615769bcb6d0e6d79deca',
              id: 11,
              frequency: 17455,
            },
            {
              _id: '5d6615769bcb6d0e6d79dec9',
              id: 12,
              frequency: 17235,
            },
            {
              _id: '5d6615769bcb6d0e6d79dec8',
              id: 13,
              frequency: 27214,
            },
            {
              _id: '5d6615769bcb6d0e6d79dec7',
              id: 14,
              frequency: 67186,
            },
            {
              _id: '5d6615769bcb6d0e6d79dec6',
              id: 15,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79dec5',
              id: 16,
              frequency: 2228,
            },
            {
              _id: '5d6615769bcb6d0e6d79dec4',
              id: 17,
              frequency: 3682,
            },
            {
              _id: '5d6615769bcb6d0e6d79dec3',
              id: 18,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79dec2',
              id: 19,
              frequency: 294,
            },
            {
              _id: '5d6615769bcb6d0e6d79dec1',
              id: 20,
              frequency: 363,
            },
            {
              _id: '5d6615769bcb6d0e6d79dec0',
              id: 21,
              frequency: 9043,
            },
            {
              _id: '5d6615769bcb6d0e6d79debf',
              id: 22,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79debe',
              id: 23,
              frequency: 1379,
            },
            {
              _id: '5d6615769bcb6d0e6d79debd',
              id: 24,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79debc',
              id: 25,
              frequency: 4717,
            },
            {
              _id: '5d6615769bcb6d0e6d79debb',
              id: 26,
              frequency: 28047,
            },
            {
              _id: '5d6615769bcb6d0e6d79deba',
              id: 27,
              frequency: 519,
            },
            {
              _id: '5d6615769bcb6d0e6d79deb9',
              id: 28,
              frequency: 10693,
            },
            {
              _id: '5d6615769bcb6d0e6d79deb8',
              id: 29,
              frequency: 4132,
            },
            {
              _id: '5d6615769bcb6d0e6d79deb7',
              id: 30,
              frequency: 19421,
            },
            {
              _id: '5d6615769bcb6d0e6d79deb6',
              id: 31,
              frequency: 341,
            },
            {
              _id: '5d6615769bcb6d0e6d79deb5',
              id: 32,
              frequency: 876,
            },
            {
              _id: '5d6615769bcb6d0e6d79deb4',
              id: 33,
              frequency: 25087,
            },
            {
              _id: '5d6615769bcb6d0e6d79deb3',
              id: 34,
              frequency: 458,
            },
            {
              _id: '5d6615769bcb6d0e6d79deb2',
              id: 35,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79deb1',
              id: 36,
              frequency: 271,
            },
            {
              _id: '5d6615769bcb6d0e6d79deb0',
              id: 37,
              frequency: 868,
            },
            {
              _id: '5d6615769bcb6d0e6d79deaf',
              id: 38,
              frequency: 5550,
            },
            {
              _id: '5d6615769bcb6d0e6d79deae',
              id: 39,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79dead',
              id: 40,
              frequency: 7455,
            },
            {
              _id: '5d6615769bcb6d0e6d79deac',
              id: 41,
              frequency: 12683,
            },
            {
              _id: '5d6615769bcb6d0e6d79deab',
              id: 42,
              frequency: 71634,
            },
            {
              _id: '5d6615769bcb6d0e6d79deaa',
              id: 43,
              frequency: 11521,
            },
            {
              _id: '5d6615769bcb6d0e6d79dea9',
              id: 44,
              frequency: 21023,
            },
            {
              _id: '5d6615769bcb6d0e6d79dea8',
              id: 45,
              frequency: 807,
            },
            {
              _id: '5d6615769bcb6d0e6d79dea7',
              id: 46,
              frequency: 2064,
            },
            {
              _id: '5d6615769bcb6d0e6d79dea6',
              id: 47,
              frequency: 75633,
            },
            {
              _id: '5d6615769bcb6d0e6d79dea5',
              id: 48,
              frequency: 44536,
            },
            {
              _id: '5d6615769bcb6d0e6d79dea4',
              id: 49,
              frequency: 11,
            },
            {
              _id: '5d6615769bcb6d0e6d79dea3',
              id: 50,
              frequency: 505,
            },
            {
              _id: '5d6615769bcb6d0e6d79dea2',
              id: 51,
              frequency: 4813,
            },
            {
              _id: '5d6615769bcb6d0e6d79dea1',
              id: 52,
              frequency: 982,
            },
            {
              _id: '5d6615769bcb6d0e6d79dea0',
              id: 53,
              frequency: 15325,
            },
            {
              _id: '5d6615769bcb6d0e6d79de9f',
              id: 54,
              frequency: 576,
            },
            {
              _id: '5d6615769bcb6d0e6d79de9e',
              id: 55,
              frequency: 19650,
            },
            {
              _id: '5d6615769bcb6d0e6d79de9d',
              id: 56,
              frequency: 3111,
            },
            {
              _id: '5d6615769bcb6d0e6d79de9c',
              id: 57,
              frequency: 81468,
            },
            {
              _id: '5d6615769bcb6d0e6d79de9b',
              id: 58,
              frequency: 211355,
            },
            {
              _id: '5d6615769bcb6d0e6d79de9a',
              id: 59,
              frequency: 21317,
            },
            {
              _id: '5d6615769bcb6d0e6d79de99',
              id: 60,
              frequency: 107527,
            },
            {
              _id: '5d6615769bcb6d0e6d79de98',
              id: 61,
              frequency: 90359,
            },
            {
              _id: '5d6615769bcb6d0e6d79de97',
              id: 62,
              frequency: 2803,
            },
            {
              _id: '5d6615769bcb6d0e6d79de96',
              id: 63,
              frequency: 16915,
            },
            {
              _id: '5d6615769bcb6d0e6d79de95',
              id: 64,
              frequency: 9444,
            },
            {
              _id: '5d6615769bcb6d0e6d79de94',
              id: 65,
              frequency: 47825,
            },
            {
              _id: '5d6615769bcb6d0e6d79de93',
              id: 66,
              frequency: 173266,
            },
            {
              _id: '5d6615769bcb6d0e6d79de92',
              id: 67,
              frequency: 408813,
            },
            {
              _id: '5d6615769bcb6d0e6d79de91',
              id: 68,
              frequency: 69360,
            },
            {
              _id: '5d6615769bcb6d0e6d79de90',
              id: 69,
              frequency: 17446,
            },
            {
              _id: '5d6615769bcb6d0e6d79de8f',
              id: 70,
              frequency: 329128,
            },
            {
              _id: '5d6615769bcb6d0e6d79de8e',
              id: 71,
              frequency: 570846,
            },
            {
              _id: '5d6615769bcb6d0e6d79de8d',
              id: 72,
              frequency: 1004034,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79de30',
          id: 90,
          abbrevName: '91',
          fullName: '91_BI_Occipital_pole_cuneal_cortex',
          coordinates: {
            x: 0.280374,
            y: -88,
            z: 21.981308,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79de38',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79de37',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79de36',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79de35',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79de34',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79de33',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79de32',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79de31',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79de81',
              id: 0,
              frequency: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79de80',
              id: 1,
              frequency: 439,
            },
            {
              _id: '5d6615769bcb6d0e6d79de7f',
              id: 2,
              frequency: 379,
            },
            {
              _id: '5d6615769bcb6d0e6d79de7e',
              id: 3,
              frequency: 3276,
            },
            {
              _id: '5d6615769bcb6d0e6d79de7d',
              id: 4,
              frequency: 1317,
            },
            {
              _id: '5d6615769bcb6d0e6d79de7c',
              id: 5,
              frequency: 2489,
            },
            {
              _id: '5d6615769bcb6d0e6d79de7b',
              id: 6,
              frequency: 395,
            },
            {
              _id: '5d6615769bcb6d0e6d79de7a',
              id: 7,
              frequency: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d79de79',
              id: 8,
              frequency: 646,
            },
            {
              _id: '5d6615769bcb6d0e6d79de78',
              id: 9,
              frequency: 796,
            },
            {
              _id: '5d6615769bcb6d0e6d79de77',
              id: 10,
              frequency: 15156,
            },
            {
              _id: '5d6615769bcb6d0e6d79de76',
              id: 11,
              frequency: 5355,
            },
            {
              _id: '5d6615769bcb6d0e6d79de75',
              id: 12,
              frequency: 9189,
            },
            {
              _id: '5d6615769bcb6d0e6d79de74',
              id: 13,
              frequency: 20910,
            },
            {
              _id: '5d6615769bcb6d0e6d79de73',
              id: 14,
              frequency: 76003,
            },
            {
              _id: '5d6615769bcb6d0e6d79de72',
              id: 15,
              frequency: 1152,
            },
            {
              _id: '5d6615769bcb6d0e6d79de71',
              id: 16,
              frequency: 4247,
            },
            {
              _id: '5d6615769bcb6d0e6d79de70',
              id: 17,
              frequency: 1686,
            },
            {
              _id: '5d6615769bcb6d0e6d79de6f',
              id: 18,
              frequency: 811,
            },
            {
              _id: '5d6615769bcb6d0e6d79de6e',
              id: 19,
              frequency: 1335,
            },
            {
              _id: '5d6615769bcb6d0e6d79de6d',
              id: 20,
              frequency: 1867,
            },
            {
              _id: '5d6615769bcb6d0e6d79de6c',
              id: 21,
              frequency: 438,
            },
            {
              _id: '5d6615769bcb6d0e6d79de6b',
              id: 22,
              frequency: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79de6a',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79de69',
              id: 24,
              frequency: 1537,
            },
            {
              _id: '5d6615769bcb6d0e6d79de68',
              id: 25,
              frequency: 7481,
            },
            {
              _id: '5d6615769bcb6d0e6d79de67',
              id: 26,
              frequency: 14251,
            },
            {
              _id: '5d6615769bcb6d0e6d79de66',
              id: 27,
              frequency: 1528,
            },
            {
              _id: '5d6615769bcb6d0e6d79de65',
              id: 28,
              frequency: 3679,
            },
            {
              _id: '5d6615769bcb6d0e6d79de64',
              id: 29,
              frequency: 33341,
            },
            {
              _id: '5d6615769bcb6d0e6d79de63',
              id: 30,
              frequency: 15000,
            },
            {
              _id: '5d6615769bcb6d0e6d79de62',
              id: 31,
              frequency: 772,
            },
            {
              _id: '5d6615769bcb6d0e6d79de61',
              id: 32,
              frequency: 7715,
            },
            {
              _id: '5d6615769bcb6d0e6d79de60',
              id: 33,
              frequency: 196,
            },
            {
              _id: '5d6615769bcb6d0e6d79de5f',
              id: 34,
              frequency: 795,
            },
            {
              _id: '5d6615769bcb6d0e6d79de5e',
              id: 35,
              frequency: 121,
            },
            {
              _id: '5d6615769bcb6d0e6d79de5d',
              id: 36,
              frequency: 1160,
            },
            {
              _id: '5d6615769bcb6d0e6d79de5c',
              id: 37,
              frequency: 1526,
            },
            {
              _id: '5d6615769bcb6d0e6d79de5b',
              id: 38,
              frequency: 237,
            },
            {
              _id: '5d6615769bcb6d0e6d79de5a',
              id: 39,
              frequency: 622,
            },
            {
              _id: '5d6615769bcb6d0e6d79de59',
              id: 40,
              frequency: 15515,
            },
            {
              _id: '5d6615769bcb6d0e6d79de58',
              id: 41,
              frequency: 22641,
            },
            {
              _id: '5d6615769bcb6d0e6d79de57',
              id: 42,
              frequency: 2701,
            },
            {
              _id: '5d6615769bcb6d0e6d79de56',
              id: 43,
              frequency: 16358,
            },
            {
              _id: '5d6615769bcb6d0e6d79de55',
              id: 44,
              frequency: 7111,
            },
            {
              _id: '5d6615769bcb6d0e6d79de54',
              id: 45,
              frequency: 1221,
            },
            {
              _id: '5d6615769bcb6d0e6d79de53',
              id: 46,
              frequency: 18942,
            },
            {
              _id: '5d6615769bcb6d0e6d79de52',
              id: 47,
              frequency: 9544,
            },
            {
              _id: '5d6615769bcb6d0e6d79de51',
              id: 48,
              frequency: 71977,
            },
            {
              _id: '5d6615769bcb6d0e6d79de50',
              id: 49,
              frequency: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d79de4f',
              id: 50,
              frequency: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79de4e',
              id: 51,
              frequency: 2497,
            },
            {
              _id: '5d6615769bcb6d0e6d79de4d',
              id: 52,
              frequency: 3537,
            },
            {
              _id: '5d6615769bcb6d0e6d79de4c',
              id: 53,
              frequency: 8793,
            },
            {
              _id: '5d6615769bcb6d0e6d79de4b',
              id: 54,
              frequency: 3385,
            },
            {
              _id: '5d6615769bcb6d0e6d79de4a',
              id: 55,
              frequency: 2883,
            },
            {
              _id: '5d6615769bcb6d0e6d79de49',
              id: 56,
              frequency: 780,
            },
            {
              _id: '5d6615769bcb6d0e6d79de48',
              id: 57,
              frequency: 279637,
            },
            {
              _id: '5d6615769bcb6d0e6d79de47',
              id: 58,
              frequency: 32008,
            },
            {
              _id: '5d6615769bcb6d0e6d79de46',
              id: 59,
              frequency: 22992,
            },
            {
              _id: '5d6615769bcb6d0e6d79de45',
              id: 60,
              frequency: 63617,
            },
            {
              _id: '5d6615769bcb6d0e6d79de44',
              id: 61,
              frequency: 35642,
            },
            {
              _id: '5d6615769bcb6d0e6d79de43',
              id: 62,
              frequency: 467,
            },
            {
              _id: '5d6615769bcb6d0e6d79de42',
              id: 63,
              frequency: 4456,
            },
            {
              _id: '5d6615769bcb6d0e6d79de41',
              id: 64,
              frequency: 11936,
            },
            {
              _id: '5d6615769bcb6d0e6d79de40',
              id: 65,
              frequency: 10600,
            },
            {
              _id: '5d6615769bcb6d0e6d79de3f',
              id: 66,
              frequency: 243019,
            },
            {
              _id: '5d6615769bcb6d0e6d79de3e',
              id: 67,
              frequency: 242919,
            },
            {
              _id: '5d6615769bcb6d0e6d79de3d',
              id: 68,
              frequency: 24236,
            },
            {
              _id: '5d6615769bcb6d0e6d79de3c',
              id: 69,
              frequency: 13103,
            },
            {
              _id: '5d6615769bcb6d0e6d79de3b',
              id: 70,
              frequency: 134256,
            },
            {
              _id: '5d6615769bcb6d0e6d79de3a',
              id: 71,
              frequency: 557323,
            },
            {
              _id: '5d6615769bcb6d0e6d79de39',
              id: 72,
              frequency: 1229669,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79dddf',
          id: 91,
          abbrevName: '92',
          fullName: '92_BI_Brainstem',
          coordinates: {
            x: 2.840183,
            y: -38.255708,
            z: -12.200913,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79dde6',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79dde5',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79dde4',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79dde3',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79dde2',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79dde1',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79dde0',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79de2f',
              id: 0,
              frequency: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79de2e',
              id: 1,
              frequency: 285,
            },
            {
              _id: '5d6615769bcb6d0e6d79de2d',
              id: 2,
              frequency: 730,
            },
            {
              _id: '5d6615769bcb6d0e6d79de2c',
              id: 3,
              frequency: 3456,
            },
            {
              _id: '5d6615769bcb6d0e6d79de2b',
              id: 4,
              frequency: 216,
            },
            {
              _id: '5d6615769bcb6d0e6d79de2a',
              id: 5,
              frequency: 2664,
            },
            {
              _id: '5d6615769bcb6d0e6d79de29',
              id: 6,
              frequency: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79de28',
              id: 7,
              frequency: 1188,
            },
            {
              _id: '5d6615769bcb6d0e6d79de27',
              id: 8,
              frequency: 728,
            },
            {
              _id: '5d6615769bcb6d0e6d79de26',
              id: 9,
              frequency: 258,
            },
            {
              _id: '5d6615769bcb6d0e6d79de25',
              id: 10,
              frequency: 6269,
            },
            {
              _id: '5d6615769bcb6d0e6d79de24',
              id: 11,
              frequency: 15575,
            },
            {
              _id: '5d6615769bcb6d0e6d79de23',
              id: 12,
              frequency: 7773,
            },
            {
              _id: '5d6615769bcb6d0e6d79de22',
              id: 13,
              frequency: 30986,
            },
            {
              _id: '5d6615769bcb6d0e6d79de21',
              id: 14,
              frequency: 77831,
            },
            {
              _id: '5d6615769bcb6d0e6d79de20',
              id: 15,
              frequency: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d79de1f',
              id: 16,
              frequency: 1006,
            },
            {
              _id: '5d6615769bcb6d0e6d79de1e',
              id: 17,
              frequency: 2022,
            },
            {
              _id: '5d6615769bcb6d0e6d79de1d',
              id: 18,
              frequency: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d79de1c',
              id: 19,
              frequency: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d79de1b',
              id: 20,
              frequency: 682,
            },
            {
              _id: '5d6615769bcb6d0e6d79de1a',
              id: 21,
              frequency: 4172,
            },
            {
              _id: '5d6615769bcb6d0e6d79de19',
              id: 22,
              frequency: 12,
            },
            {
              _id: '5d6615769bcb6d0e6d79de18',
              id: 23,
              frequency: 467,
            },
            {
              _id: '5d6615769bcb6d0e6d79de17',
              id: 24,
              frequency: 299,
            },
            {
              _id: '5d6615769bcb6d0e6d79de16',
              id: 25,
              frequency: 3673,
            },
            {
              _id: '5d6615769bcb6d0e6d79de15',
              id: 26,
              frequency: 16749,
            },
            {
              _id: '5d6615769bcb6d0e6d79de14',
              id: 27,
              frequency: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d79de13',
              id: 28,
              frequency: 1602,
            },
            {
              _id: '5d6615769bcb6d0e6d79de12',
              id: 29,
              frequency: 2861,
            },
            {
              _id: '5d6615769bcb6d0e6d79de11',
              id: 30,
              frequency: 21689,
            },
            {
              _id: '5d6615769bcb6d0e6d79de10',
              id: 31,
              frequency: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d79de0f',
              id: 32,
              frequency: 1368,
            },
            {
              _id: '5d6615769bcb6d0e6d79de0e',
              id: 33,
              frequency: 14306,
            },
            {
              _id: '5d6615769bcb6d0e6d79de0d',
              id: 34,
              frequency: 311,
            },
            {
              _id: '5d6615769bcb6d0e6d79de0c',
              id: 35,
              frequency: 1,
            },
            {
              _id: '5d6615769bcb6d0e6d79de0b',
              id: 36,
              frequency: 241,
            },
            {
              _id: '5d6615769bcb6d0e6d79de0a',
              id: 37,
              frequency: 653,
            },
            {
              _id: '5d6615769bcb6d0e6d79de09',
              id: 38,
              frequency: 2131,
            },
            {
              _id: '5d6615769bcb6d0e6d79de08',
              id: 39,
              frequency: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d79de07',
              id: 40,
              frequency: 4507,
            },
            {
              _id: '5d6615769bcb6d0e6d79de06',
              id: 41,
              frequency: 11875,
            },
            {
              _id: '5d6615769bcb6d0e6d79de05',
              id: 42,
              frequency: 54423,
            },
            {
              _id: '5d6615769bcb6d0e6d79de04',
              id: 43,
              frequency: 2273,
            },
            {
              _id: '5d6615769bcb6d0e6d79de03',
              id: 44,
              frequency: 21122,
            },
            {
              _id: '5d6615769bcb6d0e6d79de02',
              id: 45,
              frequency: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d79de01',
              id: 46,
              frequency: 3796,
            },
            {
              _id: '5d6615769bcb6d0e6d79de00',
              id: 47,
              frequency: 26448,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddff',
              id: 48,
              frequency: 50178,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddfe',
              id: 49,
              frequency: 14,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddfd',
              id: 50,
              frequency: 186,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddfc',
              id: 51,
              frequency: 1162,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddfb',
              id: 52,
              frequency: 240,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddfa',
              id: 53,
              frequency: 8460,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddf9',
              id: 54,
              frequency: 294,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddf8',
              id: 55,
              frequency: 20829,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddf7',
              id: 56,
              frequency: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddf6',
              id: 57,
              frequency: 108016,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddf5',
              id: 58,
              frequency: 169141,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddf4',
              id: 59,
              frequency: 5451,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddf3',
              id: 60,
              frequency: 55493,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddf2',
              id: 61,
              frequency: 96720,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddf1',
              id: 62,
              frequency: 364,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddf0',
              id: 63,
              frequency: 8051,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddef',
              id: 64,
              frequency: 4906,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddee',
              id: 65,
              frequency: 6131,
            },
            {
              _id: '5d6615769bcb6d0e6d79dded',
              id: 66,
              frequency: 91868,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddec',
              id: 67,
              frequency: 463366,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddeb',
              id: 68,
              frequency: 33363,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddea',
              id: 69,
              frequency: 23546,
            },
            {
              _id: '5d6615769bcb6d0e6d79dde9',
              id: 70,
              frequency: 150328,
            },
            {
              _id: '5d6615769bcb6d0e6d79dde8',
              id: 71,
              frequency: 713244,
            },
            {
              _id: '5d6615769bcb6d0e6d79dde7',
              id: 72,
              frequency: 1216991,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79dd8f',
          id: 92,
          abbrevName: '93',
          fullName: '93_R_LOC__R_SPL',
          coordinates: {
            x: 16.382222,
            y: -55.386667,
            z: 62.24,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79dd95',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd94',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd93',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd92',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd91',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd90',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79ddde',
              id: 0,
              frequency: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d79dddd',
              id: 1,
              frequency: 405,
            },
            {
              _id: '5d6615769bcb6d0e6d79dddc',
              id: 2,
              frequency: 434,
            },
            {
              _id: '5d6615769bcb6d0e6d79dddb',
              id: 3,
              frequency: 3307,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddda',
              id: 4,
              frequency: 1346,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddd9',
              id: 5,
              frequency: 2574,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddd8',
              id: 6,
              frequency: 183,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddd7',
              id: 7,
              frequency: 315,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddd6',
              id: 8,
              frequency: 711,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddd5',
              id: 9,
              frequency: 897,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddd4',
              id: 10,
              frequency: 13178,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddd3',
              id: 11,
              frequency: 6485,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddd2',
              id: 12,
              frequency: 8828,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddd1',
              id: 13,
              frequency: 22975,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddd0',
              id: 14,
              frequency: 76220,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddcf',
              id: 15,
              frequency: 1271,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddce',
              id: 16,
              frequency: 5250,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddcd',
              id: 17,
              frequency: 700,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddcc',
              id: 18,
              frequency: 1025,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddcb',
              id: 19,
              frequency: 317,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddca',
              id: 20,
              frequency: 1073,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddc9',
              id: 21,
              frequency: 1840,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddc8',
              id: 22,
              frequency: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddc7',
              id: 23,
              frequency: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddc6',
              id: 24,
              frequency: 1830,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddc5',
              id: 25,
              frequency: 1688,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddc4',
              id: 26,
              frequency: 14277,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddc3',
              id: 27,
              frequency: 1673,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddc2',
              id: 28,
              frequency: 4791,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddc1',
              id: 29,
              frequency: 34411,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddc0',
              id: 30,
              frequency: 15168,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddbf',
              id: 31,
              frequency: 253,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddbe',
              id: 32,
              frequency: 4512,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddbd',
              id: 33,
              frequency: 1967,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddbc',
              id: 34,
              frequency: 741,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddbb',
              id: 35,
              frequency: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddba',
              id: 36,
              frequency: 1249,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddb9',
              id: 37,
              frequency: 878,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddb8',
              id: 38,
              frequency: 942,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddb7',
              id: 39,
              frequency: 581,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddb6',
              id: 40,
              frequency: 7323,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddb5',
              id: 41,
              frequency: 17798,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddb4',
              id: 42,
              frequency: 11887,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddb3',
              id: 43,
              frequency: 17306,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddb2',
              id: 44,
              frequency: 7176,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddb1',
              id: 45,
              frequency: 1495,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddb0',
              id: 46,
              frequency: 19458,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddaf',
              id: 47,
              frequency: 11816,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddae',
              id: 48,
              frequency: 72152,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddad',
              id: 49,
              frequency: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddac',
              id: 50,
              frequency: 127,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddab',
              id: 51,
              frequency: 2924,
            },
            {
              _id: '5d6615769bcb6d0e6d79ddaa',
              id: 52,
              frequency: 2864,
            },
            {
              _id: '5d6615769bcb6d0e6d79dda9',
              id: 53,
              frequency: 8823,
            },
            {
              _id: '5d6615769bcb6d0e6d79dda8',
              id: 54,
              frequency: 946,
            },
            {
              _id: '5d6615769bcb6d0e6d79dda7',
              id: 55,
              frequency: 10531,
            },
            {
              _id: '5d6615769bcb6d0e6d79dda6',
              id: 56,
              frequency: 1132,
            },
            {
              _id: '5d6615769bcb6d0e6d79dda5',
              id: 57,
              frequency: 246300,
            },
            {
              _id: '5d6615769bcb6d0e6d79dda4',
              id: 58,
              frequency: 41159,
            },
            {
              _id: '5d6615769bcb6d0e6d79dda3',
              id: 59,
              frequency: 24547,
            },
            {
              _id: '5d6615769bcb6d0e6d79dda2',
              id: 60,
              frequency: 64006,
            },
            {
              _id: '5d6615769bcb6d0e6d79dda1',
              id: 61,
              frequency: 41680,
            },
            {
              _id: '5d6615769bcb6d0e6d79dda0',
              id: 62,
              frequency: 712,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd9f',
              id: 63,
              frequency: 5960,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd9e',
              id: 64,
              frequency: 11156,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd9d',
              id: 65,
              frequency: 13075,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd9c',
              id: 66,
              frequency: 205182,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd9b',
              id: 67,
              frequency: 281491,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd9a',
              id: 68,
              frequency: 27213,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd99',
              id: 69,
              frequency: 14597,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd98',
              id: 70,
              frequency: 136330,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd97',
              id: 71,
              frequency: 590845,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd96',
              id: 72,
              frequency: 1224535,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79dd45',
          id: 93,
          abbrevName: '94',
          fullName: '94_L_ITG_posterior_ifg_temporooccipital',
          coordinates: {
            x: -49.82716,
            y: -31.283951,
            z: -24.148148,
          },
          edges: [],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79dd8e',
              id: 0,
              frequency: 9,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd8d',
              id: 1,
              frequency: 636,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd8c',
              id: 2,
              frequency: 5,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd8b',
              id: 3,
              frequency: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd8a',
              id: 4,
              frequency: 7218,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd89',
              id: 5,
              frequency: 238,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd88',
              id: 6,
              frequency: 3549,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd87',
              id: 7,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd86',
              id: 8,
              frequency: 194,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd85',
              id: 9,
              frequency: 19334,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd84',
              id: 10,
              frequency: 786,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd83',
              id: 11,
              frequency: 10,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd82',
              id: 12,
              frequency: 1838,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd81',
              id: 13,
              frequency: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd80',
              id: 14,
              frequency: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd7f',
              id: 15,
              frequency: 23443,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd7e',
              id: 16,
              frequency: 548,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd7d',
              id: 17,
              frequency: 1151,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd7c',
              id: 18,
              frequency: 5762,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd7b',
              id: 19,
              frequency: 33564,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd7a',
              id: 20,
              frequency: 510,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd79',
              id: 21,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd78',
              id: 22,
              frequency: 4004,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd77',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd76',
              id: 24,
              frequency: 78223,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd75',
              id: 25,
              frequency: 1760,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd74',
              id: 26,
              frequency: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd73',
              id: 27,
              frequency: 71004,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd72',
              id: 28,
              frequency: 2623,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd71',
              id: 29,
              frequency: 2958,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd70',
              id: 30,
              frequency: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd6f',
              id: 31,
              frequency: 62598,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd6e',
              id: 32,
              frequency: 797,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd6d',
              id: 33,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd6c',
              id: 34,
              frequency: 1556,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd6b',
              id: 35,
              frequency: 11750,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd6a',
              id: 36,
              frequency: 437,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd69',
              id: 37,
              frequency: 1852,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd68',
              id: 38,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd67',
              id: 39,
              frequency: 119605,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd66',
              id: 40,
              frequency: 11001,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd65',
              id: 41,
              frequency: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd64',
              id: 42,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd63',
              id: 43,
              frequency: 7767,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd62',
              id: 44,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd61',
              id: 45,
              frequency: 154145,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd60',
              id: 46,
              frequency: 4720,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd5f',
              id: 47,
              frequency: 243,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd5e',
              id: 48,
              frequency: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd5d',
              id: 49,
              frequency: 212,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd5c',
              id: 50,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd5b',
              id: 51,
              frequency: 6826,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd5a',
              id: 52,
              frequency: 1181,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd59',
              id: 53,
              frequency: 212,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd58',
              id: 54,
              frequency: 6904,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd57',
              id: 55,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd56',
              id: 56,
              frequency: 370639,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd55',
              id: 57,
              frequency: 604,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd54',
              id: 58,
              frequency: 10,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd53',
              id: 59,
              frequency: 31624,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd52',
              id: 60,
              frequency: 619,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd51',
              id: 61,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd50',
              id: 62,
              frequency: 3763,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd4f',
              id: 63,
              frequency: 282,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd4e',
              id: 64,
              frequency: 12,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd4d',
              id: 65,
              frequency: 49153,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd4c',
              id: 66,
              frequency: 1600,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd4b',
              id: 67,
              frequency: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd4a',
              id: 68,
              frequency: 570,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd49',
              id: 69,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd48',
              id: 70,
              frequency: 2994,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd47',
              id: 71,
              frequency: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd46',
              id: 72,
              frequency: 71,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79dcf6',
          id: 94,
          abbrevName: '95',
          fullName: '95_BI_Paracingulate_ACC',
          coordinates: {
            x: 0.406639,
            y: 34.033195,
            z: 26.755187,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79dcfb',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcfa',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcf9',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcf8',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcf7',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79dd44',
              id: 0,
              frequency: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd43',
              id: 1,
              frequency: 509,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd42',
              id: 2,
              frequency: 448,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd41',
              id: 3,
              frequency: 3207,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd40',
              id: 4,
              frequency: 1363,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd3f',
              id: 5,
              frequency: 2917,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd3e',
              id: 6,
              frequency: 451,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd3d',
              id: 7,
              frequency: 296,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd3c',
              id: 8,
              frequency: 1155,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd3b',
              id: 9,
              frequency: 1030,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd3a',
              id: 10,
              frequency: 13010,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd39',
              id: 11,
              frequency: 7222,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd38',
              id: 12,
              frequency: 12514,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd37',
              id: 13,
              frequency: 22300,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd36',
              id: 14,
              frequency: 72522,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd35',
              id: 15,
              frequency: 792,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd34',
              id: 16,
              frequency: 4057,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd33',
              id: 17,
              frequency: 2685,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd32',
              id: 18,
              frequency: 971,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd31',
              id: 19,
              frequency: 1566,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd30',
              id: 20,
              frequency: 1733,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd2f',
              id: 21,
              frequency: 1609,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd2e',
              id: 22,
              frequency: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd2d',
              id: 23,
              frequency: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd2c',
              id: 24,
              frequency: 2505,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd2b',
              id: 25,
              frequency: 6788,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd2a',
              id: 26,
              frequency: 13103,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd29',
              id: 27,
              frequency: 1159,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd28',
              id: 28,
              frequency: 3685,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd27',
              id: 29,
              frequency: 23695,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd26',
              id: 30,
              frequency: 20627,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd25',
              id: 31,
              frequency: 861,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd24',
              id: 32,
              frequency: 6471,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd23',
              id: 33,
              frequency: 1921,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd22',
              id: 34,
              frequency: 929,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd21',
              id: 35,
              frequency: 99,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd20',
              id: 36,
              frequency: 1655,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd1f',
              id: 37,
              frequency: 2520,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd1e',
              id: 38,
              frequency: 1284,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd1d',
              id: 39,
              frequency: 859,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd1c',
              id: 40,
              frequency: 17333,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd1b',
              id: 41,
              frequency: 17174,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd1a',
              id: 42,
              frequency: 12108,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd19',
              id: 43,
              frequency: 12484,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd18',
              id: 44,
              frequency: 8566,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd17',
              id: 45,
              frequency: 1248,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd16',
              id: 46,
              frequency: 24544,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd15',
              id: 47,
              frequency: 15680,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd14',
              id: 48,
              frequency: 67892,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd13',
              id: 49,
              frequency: 190,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd12',
              id: 50,
              frequency: 295,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd11',
              id: 51,
              frequency: 4190,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd10',
              id: 52,
              frequency: 2222,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd0f',
              id: 53,
              frequency: 12662,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd0e',
              id: 54,
              frequency: 4949,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd0d',
              id: 55,
              frequency: 8410,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd0c',
              id: 56,
              frequency: 956,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd0b',
              id: 57,
              frequency: 215904,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd0a',
              id: 58,
              frequency: 54603,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd09',
              id: 59,
              frequency: 25213,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd08',
              id: 60,
              frequency: 72971,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd07',
              id: 61,
              frequency: 44731,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd06',
              id: 62,
              frequency: 1395,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd05',
              id: 63,
              frequency: 12000,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd04',
              id: 64,
              frequency: 11716,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd03',
              id: 65,
              frequency: 19594,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd02',
              id: 66,
              frequency: 218312,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd01',
              id: 67,
              frequency: 283833,
            },
            {
              _id: '5d6615769bcb6d0e6d79dd00',
              id: 68,
              frequency: 46473,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcff',
              id: 69,
              frequency: 14049,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcfe',
              id: 70,
              frequency: 213089,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcfd',
              id: 71,
              frequency: 550119,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcfc',
              id: 72,
              frequency: 1145163,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79dca9',
          id: 95,
          abbrevName: '96',
          fullName: '96_R_Heschels__parietal_operculum_BA41',
          coordinates: {
            x: 45.586207,
            y: -21.425287,
            z: 15.011494,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79dcac',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcab',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcaa',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79dcf5',
              id: 0,
              frequency: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcf4',
              id: 1,
              frequency: 905,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcf3',
              id: 2,
              frequency: 262,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcf2',
              id: 3,
              frequency: 2741,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcf1',
              id: 4,
              frequency: 3020,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcf0',
              id: 5,
              frequency: 2871,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcef',
              id: 6,
              frequency: 1157,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcee',
              id: 7,
              frequency: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79dced',
              id: 8,
              frequency: 1454,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcec',
              id: 9,
              frequency: 4214,
            },
            {
              _id: '5d6615769bcb6d0e6d79dceb',
              id: 10,
              frequency: 18434,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcea',
              id: 11,
              frequency: 2979,
            },
            {
              _id: '5d6615769bcb6d0e6d79dce9',
              id: 12,
              frequency: 22736,
            },
            {
              _id: '5d6615769bcb6d0e6d79dce8',
              id: 13,
              frequency: 13732,
            },
            {
              _id: '5d6615769bcb6d0e6d79dce7',
              id: 14,
              frequency: 59291,
            },
            {
              _id: '5d6615769bcb6d0e6d79dce6',
              id: 15,
              frequency: 5032,
            },
            {
              _id: '5d6615769bcb6d0e6d79dce5',
              id: 16,
              frequency: 4353,
            },
            {
              _id: '5d6615769bcb6d0e6d79dce4',
              id: 17,
              frequency: 3806,
            },
            {
              _id: '5d6615769bcb6d0e6d79dce3',
              id: 18,
              frequency: 2027,
            },
            {
              _id: '5d6615769bcb6d0e6d79dce2',
              id: 19,
              frequency: 3999,
            },
            {
              _id: '5d6615769bcb6d0e6d79dce1',
              id: 20,
              frequency: 2487,
            },
            {
              _id: '5d6615769bcb6d0e6d79dce0',
              id: 21,
              frequency: 677,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcdf',
              id: 22,
              frequency: 401,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcde',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcdd',
              id: 24,
              frequency: 10856,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcdc',
              id: 25,
              frequency: 13867,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcdb',
              id: 26,
              frequency: 8734,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcda',
              id: 27,
              frequency: 4804,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcd9',
              id: 28,
              frequency: 7795,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcd8',
              id: 29,
              frequency: 41381,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcd7',
              id: 30,
              frequency: 12368,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcd6',
              id: 31,
              frequency: 4105,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcd5',
              id: 32,
              frequency: 11875,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcd4',
              id: 33,
              frequency: 246,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcd3',
              id: 34,
              frequency: 1468,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcd2',
              id: 35,
              frequency: 616,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcd1',
              id: 36,
              frequency: 1882,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcd0',
              id: 37,
              frequency: 4445,
            },
            {
              _id: '5d6615769bcb6d0e6d79dccf',
              id: 38,
              frequency: 527,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcce',
              id: 39,
              frequency: 4905,
            },
            {
              _id: '5d6615769bcb6d0e6d79dccd',
              id: 40,
              frequency: 46758,
            },
            {
              _id: '5d6615769bcb6d0e6d79dccc',
              id: 41,
              frequency: 15373,
            },
            {
              _id: '5d6615769bcb6d0e6d79dccb',
              id: 42,
              frequency: 2426,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcca',
              id: 43,
              frequency: 36949,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcc9',
              id: 44,
              frequency: 2230,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcc8',
              id: 45,
              frequency: 7279,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcc7',
              id: 46,
              frequency: 37455,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcc6',
              id: 47,
              frequency: 12329,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcc5',
              id: 48,
              frequency: 63815,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcc4',
              id: 49,
              frequency: 396,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcc3',
              id: 50,
              frequency: 224,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcc2',
              id: 51,
              frequency: 9843,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcc1',
              id: 52,
              frequency: 5897,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcc0',
              id: 53,
              frequency: 9453,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcbf',
              id: 54,
              frequency: 11366,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcbe',
              id: 55,
              frequency: 2632,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcbd',
              id: 56,
              frequency: 11483,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcbc',
              id: 57,
              frequency: 264115,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcbb',
              id: 58,
              frequency: 14984,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcba',
              id: 59,
              frequency: 83559,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcb9',
              id: 60,
              frequency: 84392,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcb8',
              id: 61,
              frequency: 16097,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcb7',
              id: 62,
              frequency: 3963,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcb6',
              id: 63,
              frequency: 10990,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcb5',
              id: 64,
              frequency: 13534,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcb4',
              id: 65,
              frequency: 89203,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcb3',
              id: 66,
              frequency: 324273,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcb2',
              id: 67,
              frequency: 132015,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcb1',
              id: 68,
              frequency: 64338,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcb0',
              id: 69,
              frequency: 7515,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcaf',
              id: 70,
              frequency: 389092,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcae',
              id: 71,
              frequency: 346647,
            },
            {
              _id: '5d6615769bcb6d0e6d79dcad',
              id: 72,
              frequency: 901633,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79dc5c',
          id: 96,
          abbrevName: '97',
          fullName: '97_L_BI_Frontal_pole_BA10',
          coordinates: {
            x: -3.131579,
            y: 63.815789,
            z: 7.236842,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79dc5f',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc5e',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc5d',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79dca8',
              id: 0,
              frequency: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d79dca7',
              id: 1,
              frequency: 1136,
            },
            {
              _id: '5d6615769bcb6d0e6d79dca6',
              id: 2,
              frequency: 399,
            },
            {
              _id: '5d6615769bcb6d0e6d79dca5',
              id: 3,
              frequency: 2451,
            },
            {
              _id: '5d6615769bcb6d0e6d79dca4',
              id: 4,
              frequency: 2896,
            },
            {
              _id: '5d6615769bcb6d0e6d79dca3',
              id: 5,
              frequency: 6032,
            },
            {
              _id: '5d6615769bcb6d0e6d79dca2',
              id: 6,
              frequency: 946,
            },
            {
              _id: '5d6615769bcb6d0e6d79dca1',
              id: 7,
              frequency: 238,
            },
            {
              _id: '5d6615769bcb6d0e6d79dca0',
              id: 8,
              frequency: 1465,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc9f',
              id: 9,
              frequency: 8309,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc9e',
              id: 10,
              frequency: 17806,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc9d',
              id: 11,
              frequency: 7179,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc9c',
              id: 12,
              frequency: 29216,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc9b',
              id: 13,
              frequency: 14454,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc9a',
              id: 14,
              frequency: 48429,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc99',
              id: 15,
              frequency: 2359,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc98',
              id: 16,
              frequency: 9332,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc97',
              id: 17,
              frequency: 5008,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc96',
              id: 18,
              frequency: 660,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc95',
              id: 19,
              frequency: 2134,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc94',
              id: 20,
              frequency: 4194,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc93',
              id: 21,
              frequency: 2821,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc92',
              id: 22,
              frequency: 165,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc91',
              id: 23,
              frequency: 10,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc90',
              id: 24,
              frequency: 5003,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc8f',
              id: 25,
              frequency: 9661,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc8e',
              id: 26,
              frequency: 31518,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc8d',
              id: 27,
              frequency: 8416,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc8c',
              id: 28,
              frequency: 36012,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc8b',
              id: 29,
              frequency: 28938,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc8a',
              id: 30,
              frequency: 18323,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc89',
              id: 31,
              frequency: 5036,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc88',
              id: 32,
              frequency: 8802,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc87',
              id: 33,
              frequency: 1354,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc86',
              id: 34,
              frequency: 1884,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc85',
              id: 35,
              frequency: 461,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc84',
              id: 36,
              frequency: 966,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc83',
              id: 37,
              frequency: 2804,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc82',
              id: 38,
              frequency: 1979,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc81',
              id: 39,
              frequency: 4890,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc80',
              id: 40,
              frequency: 33244,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc7f',
              id: 41,
              frequency: 20118,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc7e',
              id: 42,
              frequency: 10798,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc7d',
              id: 43,
              frequency: 63383,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc7c',
              id: 44,
              frequency: 8648,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc7b',
              id: 45,
              frequency: 12895,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc7a',
              id: 46,
              frequency: 17256,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc79',
              id: 47,
              frequency: 75479,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc78',
              id: 48,
              frequency: 64618,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc77',
              id: 49,
              frequency: 297,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc76',
              id: 50,
              frequency: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc75',
              id: 51,
              frequency: 13455,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc74',
              id: 52,
              frequency: 6457,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc73',
              id: 53,
              frequency: 12356,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc72',
              id: 54,
              frequency: 10656,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc71',
              id: 55,
              frequency: 3828,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc70',
              id: 56,
              frequency: 39960,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc6f',
              id: 57,
              frequency: 161966,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc6e',
              id: 58,
              frequency: 74798,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc6d',
              id: 59,
              frequency: 112349,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc6c',
              id: 60,
              frequency: 140672,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc6b',
              id: 61,
              frequency: 32095,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc6a',
              id: 62,
              frequency: 5703,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc69',
              id: 63,
              frequency: 9819,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc68',
              id: 64,
              frequency: 12174,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc67',
              id: 65,
              frequency: 193285,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc66',
              id: 66,
              frequency: 339982,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc65',
              id: 67,
              frequency: 176587,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc64',
              id: 68,
              frequency: 62086,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc63',
              id: 69,
              frequency: 8581,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc62',
              id: 70,
              frequency: 490620,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc61',
              id: 71,
              frequency: 290586,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc60',
              id: 72,
              frequency: 675690,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79dc10',
          id: 97,
          abbrevName: '98',
          fullName: '98_L_Caudate_accumbens_putamen',
          coordinates: {
            x: -15.074627,
            y: 11.164179,
            z: 3.19403,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79dc12',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc11',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79dc5b',
              id: 0,
              frequency: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc5a',
              id: 1,
              frequency: 560,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc59',
              id: 2,
              frequency: 416,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc58',
              id: 3,
              frequency: 3154,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc57',
              id: 4,
              frequency: 1344,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc56',
              id: 5,
              frequency: 2936,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc55',
              id: 6,
              frequency: 550,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc54',
              id: 7,
              frequency: 205,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc53',
              id: 8,
              frequency: 1174,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc52',
              id: 9,
              frequency: 1219,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc51',
              id: 10,
              frequency: 13440,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc50',
              id: 11,
              frequency: 6084,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc4f',
              id: 12,
              frequency: 14158,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc4e',
              id: 13,
              frequency: 21745,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc4d',
              id: 14,
              frequency: 70736,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc4c',
              id: 15,
              frequency: 1030,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc4b',
              id: 16,
              frequency: 3839,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc4a',
              id: 17,
              frequency: 3251,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc49',
              id: 18,
              frequency: 774,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc48',
              id: 19,
              frequency: 1772,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc47',
              id: 20,
              frequency: 2153,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc46',
              id: 21,
              frequency: 1221,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc45',
              id: 22,
              frequency: 144,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc44',
              id: 23,
              frequency: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc43',
              id: 24,
              frequency: 2962,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc42',
              id: 25,
              frequency: 9110,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc41',
              id: 26,
              frequency: 12837,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc40',
              id: 27,
              frequency: 1249,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc3f',
              id: 28,
              frequency: 3667,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc3e',
              id: 29,
              frequency: 22382,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc3d',
              id: 30,
              frequency: 17945,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc3c',
              id: 31,
              frequency: 1102,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc3b',
              id: 32,
              frequency: 6704,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc3a',
              id: 33,
              frequency: 1113,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc39',
              id: 34,
              frequency: 1100,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc38',
              id: 35,
              frequency: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc37',
              id: 36,
              frequency: 1329,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc36',
              id: 37,
              frequency: 2834,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc35',
              id: 38,
              frequency: 914,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc34',
              id: 39,
              frequency: 1045,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc33',
              id: 40,
              frequency: 24039,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc32',
              id: 41,
              frequency: 18771,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc31',
              id: 42,
              frequency: 7398,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc30',
              id: 43,
              frequency: 12542,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc2f',
              id: 44,
              frequency: 7596,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc2e',
              id: 45,
              frequency: 1245,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc2d',
              id: 46,
              frequency: 21638,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc2c',
              id: 47,
              frequency: 15023,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc2b',
              id: 48,
              frequency: 72430,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc2a',
              id: 49,
              frequency: 172,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc29',
              id: 50,
              frequency: 246,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc28',
              id: 51,
              frequency: 4489,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc27',
              id: 52,
              frequency: 2428,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc26',
              id: 53,
              frequency: 10772,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc25',
              id: 54,
              frequency: 5063,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc24',
              id: 55,
              frequency: 7066,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc23',
              id: 56,
              frequency: 1244,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc22',
              id: 57,
              frequency: 228640,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc21',
              id: 58,
              frequency: 35985,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc20',
              id: 59,
              frequency: 29196,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc1f',
              id: 60,
              frequency: 77443,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc1e',
              id: 61,
              frequency: 40144,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc1d',
              id: 62,
              frequency: 1428,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc1c',
              id: 63,
              frequency: 10930,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc1b',
              id: 64,
              frequency: 10998,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc1a',
              id: 65,
              frequency: 24823,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc19',
              id: 66,
              frequency: 212610,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc18',
              id: 67,
              frequency: 263239,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc17',
              id: 68,
              frequency: 52160,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc16',
              id: 69,
              frequency: 14571,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc15',
              id: 70,
              frequency: 251596,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc14',
              id: 71,
              frequency: 544722,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc13',
              id: 72,
              frequency: 1102921,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79dbc5',
          id: 98,
          abbrevName: '99',
          fullName: '99_L_Cerebellum_Crus',
          coordinates: {
            x: -12.514286,
            y: -79.077551,
            z: -37.469388,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d79dbc6',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79dc0f',
              id: 0,
              frequency: 93,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc0e',
              id: 1,
              frequency: 119,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc0d',
              id: 2,
              frequency: 659,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc0c',
              id: 3,
              frequency: 3619,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc0b',
              id: 4,
              frequency: 182,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc0a',
              id: 5,
              frequency: 1742,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc09',
              id: 6,
              frequency: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc08',
              id: 7,
              frequency: 784,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc07',
              id: 8,
              frequency: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc06',
              id: 9,
              frequency: 116,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc05',
              id: 10,
              frequency: 6390,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc04',
              id: 11,
              frequency: 12891,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc03',
              id: 12,
              frequency: 1322,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc02',
              id: 13,
              frequency: 31835,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc01',
              id: 14,
              frequency: 84256,
            },
            {
              _id: '5d6615769bcb6d0e6d79dc00',
              id: 15,
              frequency: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbff',
              id: 16,
              frequency: 1872,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbfe',
              id: 17,
              frequency: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbfd',
              id: 18,
              frequency: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbfc',
              id: 19,
              frequency: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbfb',
              id: 20,
              frequency: 622,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbfa',
              id: 21,
              frequency: 2523,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbf9',
              id: 22,
              frequency: 3,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbf8',
              id: 23,
              frequency: 127,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbf7',
              id: 24,
              frequency: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbf6',
              id: 25,
              frequency: 227,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbf5',
              id: 26,
              frequency: 17853,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbf4',
              id: 27,
              frequency: 130,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbf3',
              id: 28,
              frequency: 1810,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbf2',
              id: 29,
              frequency: 8776,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbf1',
              id: 30,
              frequency: 16316,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbf0',
              id: 31,
              frequency: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbef',
              id: 32,
              frequency: 1508,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbee',
              id: 33,
              frequency: 7625,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbed',
              id: 34,
              frequency: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbec',
              id: 35,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbeb',
              id: 36,
              frequency: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbea',
              id: 37,
              frequency: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbe9',
              id: 38,
              frequency: 314,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbe8',
              id: 39,
              frequency: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbe7',
              id: 40,
              frequency: 614,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbe6',
              id: 41,
              frequency: 15194,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbe5',
              id: 42,
              frequency: 36616,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbe4',
              id: 43,
              frequency: 4968,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbe3',
              id: 44,
              frequency: 17554,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbe2',
              id: 45,
              frequency: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbe1',
              id: 46,
              frequency: 1339,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbe0',
              id: 47,
              frequency: 6379,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbdf',
              id: 48,
              frequency: 64388,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbde',
              id: 49,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbdd',
              id: 50,
              frequency: 1,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbdc',
              id: 51,
              frequency: 212,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbdb',
              id: 52,
              frequency: 374,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbda',
              id: 53,
              frequency: 2504,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbd9',
              id: 54,
              frequency: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbd8',
              id: 55,
              frequency: 18186,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbd7',
              id: 56,
              frequency: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbd6',
              id: 57,
              frequency: 162489,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbd5',
              id: 58,
              frequency: 122883,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbd4',
              id: 59,
              frequency: 2120,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbd3',
              id: 60,
              frequency: 22713,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbd2',
              id: 61,
              frequency: 87912,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbd1',
              id: 62,
              frequency: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbd0',
              id: 63,
              frequency: 246,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbcf',
              id: 64,
              frequency: 2674,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbce',
              id: 65,
              frequency: 764,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbcd',
              id: 66,
              frequency: 56659,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbcc',
              id: 67,
              frequency: 457019,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbcb',
              id: 68,
              frequency: 1839,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbca',
              id: 69,
              frequency: 26301,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbc9',
              id: 70,
              frequency: 10209,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbc8',
              id: 71,
              frequency: 789455,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbc7',
              id: 72,
              frequency: 1356057,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d79db7b',
          id: 99,
          abbrevName: '100',
          fullName: '100_L_Postcentral_precentral',
          coordinates: {
            x: -25.484444,
            y: -26.533333,
            z: 66.915556,
          },
          edges: [],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d79dbc4',
              id: 0,
              frequency: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbc3',
              id: 1,
              frequency: 1163,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbc2',
              id: 2,
              frequency: 356,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbc1',
              id: 3,
              frequency: 2419,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbc0',
              id: 4,
              frequency: 3466,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbbf',
              id: 5,
              frequency: 5143,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbbe',
              id: 6,
              frequency: 1160,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbbd',
              id: 7,
              frequency: 203,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbbc',
              id: 8,
              frequency: 1902,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbbb',
              id: 9,
              frequency: 8278,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbba',
              id: 10,
              frequency: 17109,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbb9',
              id: 11,
              frequency: 5815,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbb8',
              id: 12,
              frequency: 30003,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbb7',
              id: 13,
              frequency: 13749,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbb6',
              id: 14,
              frequency: 47758,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbb5',
              id: 15,
              frequency: 3711,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbb4',
              id: 16,
              frequency: 7863,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbb3',
              id: 17,
              frequency: 6760,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbb2',
              id: 18,
              frequency: 2084,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbb1',
              id: 19,
              frequency: 3436,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbb0',
              id: 20,
              frequency: 3548,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbaf',
              id: 21,
              frequency: 2111,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbae',
              id: 22,
              frequency: 248,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbad',
              id: 23,
              frequency: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbac',
              id: 24,
              frequency: 12489,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbab',
              id: 25,
              frequency: 12706,
            },
            {
              _id: '5d6615769bcb6d0e6d79dbaa',
              id: 26,
              frequency: 21313,
            },
            {
              _id: '5d6615769bcb6d0e6d79dba9',
              id: 27,
              frequency: 8097,
            },
            {
              _id: '5d6615769bcb6d0e6d79dba8',
              id: 28,
              frequency: 26912,
            },
            {
              _id: '5d6615769bcb6d0e6d79dba7',
              id: 29,
              frequency: 31101,
            },
            {
              _id: '5d6615769bcb6d0e6d79dba6',
              id: 30,
              frequency: 17489,
            },
            {
              _id: '5d6615769bcb6d0e6d79dba5',
              id: 31,
              frequency: 4836,
            },
            {
              _id: '5d6615769bcb6d0e6d79dba4',
              id: 32,
              frequency: 9413,
            },
            {
              _id: '5d6615769bcb6d0e6d79dba3',
              id: 33,
              frequency: 1137,
            },
            {
              _id: '5d6615769bcb6d0e6d79dba2',
              id: 34,
              frequency: 1943,
            },
            {
              _id: '5d6615769bcb6d0e6d79dba1',
              id: 35,
              frequency: 667,
            },
            {
              _id: '5d6615769bcb6d0e6d79dba0',
              id: 36,
              frequency: 2276,
            },
            {
              _id: '5d6615769bcb6d0e6d79db9f',
              id: 37,
              frequency: 4136,
            },
            {
              _id: '5d6615769bcb6d0e6d79db9e',
              id: 38,
              frequency: 2008,
            },
            {
              _id: '5d6615769bcb6d0e6d79db9d',
              id: 39,
              frequency: 8426,
            },
            {
              _id: '5d6615769bcb6d0e6d79db9c',
              id: 40,
              frequency: 41057,
            },
            {
              _id: '5d6615769bcb6d0e6d79db9b',
              id: 41,
              frequency: 16400,
            },
            {
              _id: '5d6615769bcb6d0e6d79db9a',
              id: 42,
              frequency: 8537,
            },
            {
              _id: '5d6615769bcb6d0e6d79db99',
              id: 43,
              frequency: 51682,
            },
            {
              _id: '5d6615769bcb6d0e6d79db98',
              id: 44,
              frequency: 6073,
            },
            {
              _id: '5d6615769bcb6d0e6d79db97',
              id: 45,
              frequency: 13662,
            },
            {
              _id: '5d6615769bcb6d0e6d79db96',
              id: 46,
              frequency: 32536,
            },
            {
              _id: '5d6615769bcb6d0e6d79db95',
              id: 47,
              frequency: 56886,
            },
            {
              _id: '5d6615769bcb6d0e6d79db94',
              id: 48,
              frequency: 60087,
            },
            {
              _id: '5d6615769bcb6d0e6d79db93',
              id: 49,
              frequency: 412,
            },
            {
              _id: '5d6615769bcb6d0e6d79db92',
              id: 50,
              frequency: 171,
            },
            {
              _id: '5d6615769bcb6d0e6d79db91',
              id: 51,
              frequency: 15826,
            },
            {
              _id: '5d6615769bcb6d0e6d79db90',
              id: 52,
              frequency: 6094,
            },
            {
              _id: '5d6615769bcb6d0e6d79db8f',
              id: 53,
              frequency: 13517,
            },
            {
              _id: '5d6615769bcb6d0e6d79db8e',
              id: 54,
              frequency: 13431,
            },
            {
              _id: '5d6615769bcb6d0e6d79db8d',
              id: 55,
              frequency: 3729,
            },
            {
              _id: '5d6615769bcb6d0e6d79db8c',
              id: 56,
              frequency: 36991,
            },
            {
              _id: '5d6615769bcb6d0e6d79db8b',
              id: 57,
              frequency: 172861,
            },
            {
              _id: '5d6615769bcb6d0e6d79db8a',
              id: 58,
              frequency: 54785,
            },
            {
              _id: '5d6615769bcb6d0e6d79db89',
              id: 59,
              frequency: 115996,
            },
            {
              _id: '5d6615769bcb6d0e6d79db88',
              id: 60,
              frequency: 123534,
            },
            {
              _id: '5d6615769bcb6d0e6d79db87',
              id: 61,
              frequency: 26306,
            },
            {
              _id: '5d6615769bcb6d0e6d79db86',
              id: 62,
              frequency: 8221,
            },
            {
              _id: '5d6615769bcb6d0e6d79db85',
              id: 63,
              frequency: 15133,
            },
            {
              _id: '5d6615769bcb6d0e6d79db84',
              id: 64,
              frequency: 12903,
            },
            {
              _id: '5d6615769bcb6d0e6d79db83',
              id: 65,
              frequency: 192857,
            },
            {
              _id: '5d6615769bcb6d0e6d79db82',
              id: 66,
              frequency: 313089,
            },
            {
              _id: '5d6615769bcb6d0e6d79db81',
              id: 67,
              frequency: 158073,
            },
            {
              _id: '5d6615769bcb6d0e6d79db80',
              id: 68,
              frequency: 79639,
            },
            {
              _id: '5d6615769bcb6d0e6d79db7f',
              id: 69,
              frequency: 7446,
            },
            {
              _id: '5d6615769bcb6d0e6d79db7e',
              id: 70,
              frequency: 507433,
            },
            {
              _id: '5d6615769bcb6d0e6d79db7d',
              id: 71,
              frequency: 285831,
            },
            {
              _id: '5d6615769bcb6d0e6d79db7c',
              id: 72,
              frequency: 663514,
            },
          ],
        },
      ],
    },
    con: {
      _id: '5d6615769bcb6d0e6d7a0763',
      filenames: {
        edgeList: 'con_0.3',
        coordinates: '100_node_centers_mm_coords.txt',
        nodeNames: 'region_names_full_file.txt',
        nodeIds: 'region_names_abbrev_file.txt',
        orbits: 'orca_con_0.3',
      },
      nodes: [
        {
          _id: '5d6615769bcb6d0e6d7a2d81',
          id: 0,
          abbrevName: '1',
          fullName: '1_L_Putamen',
          coordinates: {
            x: -29.670103,
            y: -6.28866,
            z: 2.28866,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a2dae',
              to: 1,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dad',
              to: 2,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dac',
              to: 8,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dab',
              to: 11,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2daa',
              to: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2da9',
              to: 14,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2da8',
              to: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2da7',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2da6',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2da5',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2da4',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2da3',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2da2',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2da1',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2da0',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d9f',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d9e',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d9d',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d9c',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d9b',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d9a',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d99',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d98',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d97',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d96',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d95',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d94',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d93',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d92',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d91',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d90',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d8f',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d8e',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d8d',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d8c',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d8b',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d8a',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d89',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d88',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d87',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d86',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d85',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d84',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d83',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d82',
              to: 97,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a2df7',
              id: 0,
              frequency: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2df6',
              id: 1,
              frequency: 1058,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2df5',
              id: 2,
              frequency: 310,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2df4',
              id: 3,
              frequency: 680,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2df3',
              id: 4,
              frequency: 11619,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2df2',
              id: 5,
              frequency: 9472,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2df1',
              id: 6,
              frequency: 4922,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2df0',
              id: 7,
              frequency: 309,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2def',
              id: 8,
              frequency: 2601,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dee',
              id: 9,
              frequency: 8604,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ded',
              id: 10,
              frequency: 14064,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dec',
              id: 11,
              frequency: 3662,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2deb',
              id: 12,
              frequency: 8907,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dea',
              id: 13,
              frequency: 5079,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2de9',
              id: 14,
              frequency: 5140,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2de8',
              id: 15,
              frequency: 73776,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2de7',
              id: 16,
              frequency: 55204,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2de6',
              id: 17,
              frequency: 41585,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2de5',
              id: 18,
              frequency: 25924,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2de4',
              id: 19,
              frequency: 63035,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2de3',
              id: 20,
              frequency: 27292,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2de2',
              id: 21,
              frequency: 7869,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2de1',
              id: 22,
              frequency: 6667,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2de0',
              id: 23,
              frequency: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ddf',
              id: 24,
              frequency: 80689,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dde',
              id: 25,
              frequency: 38771,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ddd',
              id: 26,
              frequency: 37904,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ddc',
              id: 27,
              frequency: 51963,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ddb',
              id: 28,
              frequency: 54875,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dda',
              id: 29,
              frequency: 111426,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dd9',
              id: 30,
              frequency: 42613,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dd8',
              id: 31,
              frequency: 40699,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dd7',
              id: 32,
              frequency: 32230,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dd6',
              id: 33,
              frequency: 1708,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dd5',
              id: 34,
              frequency: 20228,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dd4',
              id: 35,
              frequency: 13317,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dd3',
              id: 36,
              frequency: 11903,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dd2',
              id: 37,
              frequency: 33676,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dd1',
              id: 38,
              frequency: 5843,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dd0',
              id: 39,
              frequency: 37957,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dcf',
              id: 40,
              frequency: 82916,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dce',
              id: 41,
              frequency: 19470,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dcd',
              id: 42,
              frequency: 6980,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dcc',
              id: 43,
              frequency: 65217,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dcb',
              id: 44,
              frequency: 5504,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dca',
              id: 45,
              frequency: 48828,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dc9',
              id: 46,
              frequency: 53215,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dc8',
              id: 47,
              frequency: 36223,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dc7',
              id: 48,
              frequency: 81894,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dc6',
              id: 49,
              frequency: 2803,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dc5',
              id: 50,
              frequency: 733,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dc4',
              id: 51,
              frequency: 43892,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dc3',
              id: 52,
              frequency: 18005,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dc2',
              id: 53,
              frequency: 29798,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dc1',
              id: 54,
              frequency: 17424,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dc0',
              id: 55,
              frequency: 2390,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dbf',
              id: 56,
              frequency: 36779,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dbe',
              id: 57,
              frequency: 85019,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dbd',
              id: 58,
              frequency: 13059,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dbc',
              id: 59,
              frequency: 94012,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dbb',
              id: 60,
              frequency: 72604,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2dba',
              id: 61,
              frequency: 17813,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2db9',
              id: 62,
              frequency: 9986,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2db8',
              id: 63,
              frequency: 15248,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2db7',
              id: 64,
              frequency: 14673,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2db6',
              id: 65,
              frequency: 50304,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2db5',
              id: 66,
              frequency: 72114,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2db4',
              id: 67,
              frequency: 39609,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2db3',
              id: 68,
              frequency: 28834,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2db2',
              id: 69,
              frequency: 3945,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2db1',
              id: 70,
              frequency: 43048,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2db0',
              id: 71,
              frequency: 34272,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2daf',
              id: 72,
              frequency: 23667,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a2d08',
          id: 1,
          abbrevName: '2',
          fullName: '2_L_MFG',
          coordinates: {
            x: -37.592357,
            y: 37.363057,
            z: 27.949045,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a2d37',
              to: 4,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d36',
              to: 6,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d35',
              to: 7,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d34',
              to: 10,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d33',
              to: 11,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d32',
              to: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d31',
              to: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d30',
              to: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d2f',
              to: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d2e',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d2d',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d2c',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d2b',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d2a',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d29',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d28',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d27',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d26',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d25',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d24',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d23',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d22',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d21',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d20',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d1f',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d1e',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d1d',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d1c',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d1b',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d1a',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d19',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d18',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d17',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d16',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d15',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d14',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d13',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d12',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d11',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d10',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d0f',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d0e',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d0d',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d0c',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d0b',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d0a',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d09',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a2d80',
              id: 0,
              frequency: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d7f',
              id: 1,
              frequency: 992,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d7e',
              id: 2,
              frequency: 383,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d7d',
              id: 3,
              frequency: 745,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d7c',
              id: 4,
              frequency: 12223,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d7b',
              id: 5,
              frequency: 10950,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d7a',
              id: 6,
              frequency: 3073,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d79',
              id: 7,
              frequency: 629,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d78',
              id: 8,
              frequency: 2605,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d77',
              id: 9,
              frequency: 8425,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d76',
              id: 10,
              frequency: 15014,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d75',
              id: 11,
              frequency: 4789,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d74',
              id: 12,
              frequency: 7725,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d73',
              id: 13,
              frequency: 6153,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d72',
              id: 14,
              frequency: 5725,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d71',
              id: 15,
              frequency: 66608,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d70',
              id: 16,
              frequency: 70241,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d6f',
              id: 17,
              frequency: 41641,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d6e',
              id: 18,
              frequency: 29284,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d6d',
              id: 19,
              frequency: 40676,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d6c',
              id: 20,
              frequency: 22594,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d6b',
              id: 21,
              frequency: 16181,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d6a',
              id: 22,
              frequency: 2551,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d69',
              id: 23,
              frequency: 171,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d68',
              id: 24,
              frequency: 74999,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d67',
              id: 25,
              frequency: 34786,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d66',
              id: 26,
              frequency: 52407,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d65',
              id: 27,
              frequency: 68230,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d64',
              id: 28,
              frequency: 68156,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d63',
              id: 29,
              frequency: 132963,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d62',
              id: 30,
              frequency: 53694,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d61',
              id: 31,
              frequency: 19978,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d60',
              id: 32,
              frequency: 25635,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d5f',
              id: 33,
              frequency: 4688,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d5e',
              id: 34,
              frequency: 24873,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d5d',
              id: 35,
              frequency: 9084,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d5c',
              id: 36,
              frequency: 13826,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d5b',
              id: 37,
              frequency: 23786,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d5a',
              id: 38,
              frequency: 9650,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d59',
              id: 39,
              frequency: 28647,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d58',
              id: 40,
              frequency: 51016,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d57',
              id: 41,
              frequency: 24609,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d56',
              id: 42,
              frequency: 13484,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d55',
              id: 43,
              frequency: 77574,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d54',
              id: 44,
              frequency: 7902,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d53',
              id: 45,
              frequency: 57613,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d52',
              id: 46,
              frequency: 53722,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d51',
              id: 47,
              frequency: 41314,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d50',
              id: 48,
              frequency: 99118,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d4f',
              id: 49,
              frequency: 1652,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d4e',
              id: 50,
              frequency: 1290,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d4d',
              id: 51,
              frequency: 49381,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d4c',
              id: 52,
              frequency: 21961,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d4b',
              id: 53,
              frequency: 34802,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d4a',
              id: 54,
              frequency: 9048,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d49',
              id: 55,
              frequency: 4761,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d48',
              id: 56,
              frequency: 43331,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d47',
              id: 57,
              frequency: 97503,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d46',
              id: 58,
              frequency: 17079,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d45',
              id: 59,
              frequency: 93132,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d44',
              id: 60,
              frequency: 75695,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d43',
              id: 61,
              frequency: 23000,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d42',
              id: 62,
              frequency: 10568,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d41',
              id: 63,
              frequency: 14702,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d40',
              id: 64,
              frequency: 17224,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d3f',
              id: 65,
              frequency: 43298,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d3e',
              id: 66,
              frequency: 74975,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d3d',
              id: 67,
              frequency: 50316,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d3c',
              id: 68,
              frequency: 24880,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d3b',
              id: 69,
              frequency: 4300,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d3a',
              id: 70,
              frequency: 32968,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d39',
              id: 71,
              frequency: 42643,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d38',
              id: 72,
              frequency: 26236,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a2c8f',
          id: 2,
          abbrevName: '3',
          fullName: '3_BI_brainstem',
          coordinates: {
            x: 1.141956,
            y: -25.987382,
            z: -33.438486,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a2cbe',
              to: 4,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cbd',
              to: 5,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cbc',
              to: 6,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cbb',
              to: 10,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cba',
              to: 14,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cb9',
              to: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cb8',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cb7',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cb6',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cb5',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cb4',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cb3',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cb2',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cb1',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cb0',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2caf',
              to: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cae',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cad',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cac',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cab',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2caa',
              to: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ca9',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ca8',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ca7',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ca6',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ca5',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ca4',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ca3',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ca2',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ca1',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ca0',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c9f',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c9e',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c9d',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c9c',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c9b',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c9a',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c99',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c98',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c97',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c96',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c95',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c94',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c93',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c92',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c91',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c90',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a2d07',
              id: 0,
              frequency: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d06',
              id: 1,
              frequency: 1079,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d05',
              id: 2,
              frequency: 466,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d04',
              id: 3,
              frequency: 662,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d03',
              id: 4,
              frequency: 12140,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d02',
              id: 5,
              frequency: 13268,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d01',
              id: 6,
              frequency: 4132,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2d00',
              id: 7,
              frequency: 1311,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cff',
              id: 8,
              frequency: 3396,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cfe',
              id: 9,
              frequency: 9129,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cfd',
              id: 10,
              frequency: 13583,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cfc',
              id: 11,
              frequency: 5803,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cfb',
              id: 12,
              frequency: 8535,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cfa',
              id: 13,
              frequency: 5897,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cf9',
              id: 14,
              frequency: 4285,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cf8',
              id: 15,
              frequency: 67541,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cf7',
              id: 16,
              frequency: 85088,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cf6',
              id: 17,
              frequency: 52808,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cf5',
              id: 18,
              frequency: 21080,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cf4',
              id: 19,
              frequency: 53217,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cf3',
              id: 20,
              frequency: 29428,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cf2',
              id: 21,
              frequency: 34187,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cf1',
              id: 22,
              frequency: 3812,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cf0',
              id: 23,
              frequency: 1342,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cef',
              id: 24,
              frequency: 74028,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cee',
              id: 25,
              frequency: 37387,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ced',
              id: 26,
              frequency: 66226,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cec',
              id: 27,
              frequency: 65611,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ceb',
              id: 28,
              frequency: 81197,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cea',
              id: 29,
              frequency: 106479,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ce9',
              id: 30,
              frequency: 58589,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ce8',
              id: 31,
              frequency: 30495,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ce7',
              id: 32,
              frequency: 25241,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ce6',
              id: 33,
              frequency: 11754,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ce5',
              id: 34,
              frequency: 27010,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ce4',
              id: 35,
              frequency: 11972,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ce3',
              id: 36,
              frequency: 16251,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ce2',
              id: 37,
              frequency: 35758,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ce1',
              id: 38,
              frequency: 19547,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ce0',
              id: 39,
              frequency: 34251,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cdf',
              id: 40,
              frequency: 68227,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cde',
              id: 41,
              frequency: 27733,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cdd',
              id: 42,
              frequency: 23044,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cdc',
              id: 43,
              frequency: 66403,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cdb',
              id: 44,
              frequency: 9753,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cda',
              id: 45,
              frequency: 59537,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cd9',
              id: 46,
              frequency: 50604,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cd8',
              id: 47,
              frequency: 55263,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cd7',
              id: 48,
              frequency: 84133,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cd6',
              id: 49,
              frequency: 3086,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cd5',
              id: 50,
              frequency: 2452,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cd4',
              id: 51,
              frequency: 59690,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cd3',
              id: 52,
              frequency: 18186,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cd2',
              id: 53,
              frequency: 41301,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cd1',
              id: 54,
              frequency: 14689,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cd0',
              id: 55,
              frequency: 7075,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ccf',
              id: 56,
              frequency: 45158,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cce',
              id: 57,
              frequency: 69757,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ccd',
              id: 58,
              frequency: 18884,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ccc',
              id: 59,
              frequency: 95221,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ccb',
              id: 60,
              frequency: 83496,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cca',
              id: 61,
              frequency: 24766,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cc9',
              id: 62,
              frequency: 13464,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cc8',
              id: 63,
              frequency: 20761,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cc7',
              id: 64,
              frequency: 15177,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cc6',
              id: 65,
              frequency: 49812,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cc5',
              id: 66,
              frequency: 62164,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cc4',
              id: 67,
              frequency: 46343,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cc3',
              id: 68,
              frequency: 31313,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cc2',
              id: 69,
              frequency: 3759,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cc1',
              id: 70,
              frequency: 36100,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cc0',
              id: 71,
              frequency: 31921,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2cbf',
              id: 72,
              frequency: 15939,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a2c1c',
          id: 3,
          abbrevName: '4',
          fullName: '4_BI_PCC_precuneous',
          coordinates: {
            x: 0.511041,
            y: -47.804416,
            z: 37.526814,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a2c45',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c44',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c43',
              to: 5,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c42',
              to: 6,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c41',
              to: 7,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c40',
              to: 8,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c3f',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c3e',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c3d',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c3c',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c3b',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c3a',
              to: 14,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c39',
              to: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c38',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c37',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c36',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c35',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c34',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c33',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c32',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c31',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c30',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c2f',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c2e',
              to: 28,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c2d',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c2c',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c2b',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c2a',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c29',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c28',
              to: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c27',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c26',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c25',
              to: 99,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c24',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c23',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c22',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c21',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c20',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c1f',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c1e',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c1d',
              to: 85,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a2c8e',
              id: 0,
              frequency: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c8d',
              id: 1,
              frequency: 986,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c8c',
              id: 2,
              frequency: 269,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c8b',
              id: 3,
              frequency: 551,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c8a',
              id: 4,
              frequency: 13043,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c89',
              id: 5,
              frequency: 8468,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c88',
              id: 6,
              frequency: 4531,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c87',
              id: 7,
              frequency: 342,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c86',
              id: 8,
              frequency: 1829,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c85',
              id: 9,
              frequency: 9068,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c84',
              id: 10,
              frequency: 12852,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c83',
              id: 11,
              frequency: 2813,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c82',
              id: 12,
              frequency: 7231,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c81',
              id: 13,
              frequency: 3839,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c80',
              id: 14,
              frequency: 3666,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c7f',
              id: 15,
              frequency: 97677,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c7e',
              id: 16,
              frequency: 71663,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c7d',
              id: 17,
              frequency: 33666,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c7c',
              id: 18,
              frequency: 26582,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c7b',
              id: 19,
              frequency: 64519,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c7a',
              id: 20,
              frequency: 23313,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c79',
              id: 21,
              frequency: 10411,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c78',
              id: 22,
              frequency: 5487,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c77',
              id: 23,
              frequency: 101,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c76',
              id: 24,
              frequency: 89346,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c75',
              id: 25,
              frequency: 37473,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c74',
              id: 26,
              frequency: 40392,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c73',
              id: 27,
              frequency: 79639,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c72',
              id: 28,
              frequency: 62597,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c71',
              id: 29,
              frequency: 124266,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c70',
              id: 30,
              frequency: 32306,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c6f',
              id: 31,
              frequency: 38754,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c6e',
              id: 32,
              frequency: 29576,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c6d',
              id: 33,
              frequency: 1942,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c6c',
              id: 34,
              frequency: 17262,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c6b',
              id: 35,
              frequency: 17427,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c6a',
              id: 36,
              frequency: 11303,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c69',
              id: 37,
              frequency: 23361,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c68',
              id: 38,
              frequency: 4784,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c67',
              id: 39,
              frequency: 42115,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c66',
              id: 40,
              frequency: 72278,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c65',
              id: 41,
              frequency: 23184,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c64',
              id: 42,
              frequency: 6398,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c63',
              id: 43,
              frequency: 73154,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c62',
              id: 44,
              frequency: 3662,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c61',
              id: 45,
              frequency: 66295,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c60',
              id: 46,
              frequency: 51953,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c5f',
              id: 47,
              frequency: 27371,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c5e',
              id: 48,
              frequency: 63178,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c5d',
              id: 49,
              frequency: 1784,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c5c',
              id: 50,
              frequency: 531,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c5b',
              id: 51,
              frequency: 34510,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c5a',
              id: 52,
              frequency: 19225,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c59',
              id: 53,
              frequency: 19415,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c58',
              id: 54,
              frequency: 14572,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c57',
              id: 55,
              frequency: 2310,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c56',
              id: 56,
              frequency: 47844,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c55',
              id: 57,
              frequency: 71201,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c54',
              id: 58,
              frequency: 8493,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c53',
              id: 59,
              frequency: 91795,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c52',
              id: 60,
              frequency: 57523,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c51',
              id: 61,
              frequency: 11889,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c50',
              id: 62,
              frequency: 6900,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c4f',
              id: 63,
              frequency: 8421,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c4e',
              id: 64,
              frequency: 9259,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c4d',
              id: 65,
              frequency: 43432,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c4c',
              id: 66,
              frequency: 56716,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c4b',
              id: 67,
              frequency: 26309,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c4a',
              id: 68,
              frequency: 19438,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c49',
              id: 69,
              frequency: 2409,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c48',
              id: 70,
              frequency: 31034,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c47',
              id: 71,
              frequency: 23261,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c46',
              id: 72,
              frequency: 14496,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a2b98',
          id: 4,
          abbrevName: '5',
          fullName: '5_R_MFG',
          coordinates: {
            x: 46.120172,
            y: 13.708155,
            z: 36.017167,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a2bd2',
              to: 6,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bd1',
              to: 7,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bd0',
              to: 11,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bcf',
              to: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bce',
              to: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bcd',
              to: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bcc',
              to: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bcb',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bca',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bc9',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bc8',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bc7',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bc6',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bc5',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bc4',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bc3',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bc2',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bc1',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bc0',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bbf',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bbe',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bbd',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bbc',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bbb',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bba',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bb9',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bb8',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bb7',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bb6',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bb5',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bb4',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bb3',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bb2',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bb1',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bb0',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2baf',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bae',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bad',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bac',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bab',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2baa',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ba9',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ba8',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ba7',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ba6',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ba5',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ba4',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ba3',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ba2',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ba1',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ba0',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b9f',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b9e',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b9d',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b9c',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b9b',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b9a',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b99',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a2c1b',
              id: 0,
              frequency: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c1a',
              id: 1,
              frequency: 941,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c19',
              id: 2,
              frequency: 685,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c18',
              id: 3,
              frequency: 1085,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c17',
              id: 4,
              frequency: 8303,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c16',
              id: 5,
              frequency: 14440,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c15',
              id: 6,
              frequency: 2331,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c14',
              id: 7,
              frequency: 1682,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c13',
              id: 8,
              frequency: 3504,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c12',
              id: 9,
              frequency: 6080,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c11',
              id: 10,
              frequency: 15703,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c10',
              id: 11,
              frequency: 11283,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c0f',
              id: 12,
              frequency: 9184,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c0e',
              id: 13,
              frequency: 12118,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c0d',
              id: 14,
              frequency: 9137,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c0c',
              id: 15,
              frequency: 35235,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c0b',
              id: 16,
              frequency: 72848,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c0a',
              id: 17,
              frequency: 38487,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c09',
              id: 18,
              frequency: 16814,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c08',
              id: 19,
              frequency: 20940,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c07',
              id: 20,
              frequency: 23444,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c06',
              id: 21,
              frequency: 31108,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c05',
              id: 22,
              frequency: 1971,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c04',
              id: 23,
              frequency: 926,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c03',
              id: 24,
              frequency: 43016,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c02',
              id: 25,
              frequency: 25121,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c01',
              id: 26,
              frequency: 87537,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2c00',
              id: 27,
              frequency: 32096,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bff',
              id: 28,
              frequency: 68927,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bfe',
              id: 29,
              frequency: 104616,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bfd',
              id: 30,
              frequency: 91981,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bfc',
              id: 31,
              frequency: 12216,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bfb',
              id: 32,
              frequency: 22309,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bfa',
              id: 33,
              frequency: 17099,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bf9',
              id: 34,
              frequency: 21576,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bf8',
              id: 35,
              frequency: 3932,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bf7',
              id: 36,
              frequency: 15247,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bf6',
              id: 37,
              frequency: 23596,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bf5',
              id: 38,
              frequency: 19824,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bf4',
              id: 39,
              frequency: 16671,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bf3',
              id: 40,
              frequency: 47400,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bf2',
              id: 41,
              frequency: 35644,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bf1',
              id: 42,
              frequency: 46130,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bf0',
              id: 43,
              frequency: 59612,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bef',
              id: 44,
              frequency: 25541,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bee',
              id: 45,
              frequency: 28711,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bed',
              id: 46,
              frequency: 43966,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bec',
              id: 47,
              frequency: 74635,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2beb',
              id: 48,
              frequency: 134421,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bea',
              id: 49,
              frequency: 1713,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2be9',
              id: 50,
              frequency: 2468,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2be8',
              id: 51,
              frequency: 46678,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2be7',
              id: 52,
              frequency: 14030,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2be6',
              id: 53,
              frequency: 61475,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2be5',
              id: 54,
              frequency: 8677,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2be4',
              id: 55,
              frequency: 11842,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2be3',
              id: 56,
              frequency: 22576,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2be2',
              id: 57,
              frequency: 109701,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2be1',
              id: 58,
              frequency: 50200,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2be0',
              id: 59,
              frequency: 76097,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bdf',
              id: 60,
              frequency: 118991,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bde',
              id: 61,
              frequency: 71378,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bdd',
              id: 62,
              frequency: 10825,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bdc',
              id: 63,
              frequency: 25771,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bdb',
              id: 64,
              frequency: 22469,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bda',
              id: 65,
              frequency: 42878,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bd9',
              id: 66,
              frequency: 86361,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bd8',
              id: 67,
              frequency: 121153,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bd7',
              id: 68,
              frequency: 40518,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bd6',
              id: 69,
              frequency: 12375,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bd5',
              id: 70,
              frequency: 48626,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bd4',
              id: 71,
              frequency: 87254,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2bd3',
              id: 72,
              frequency: 43737,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a2b25',
          id: 5,
          abbrevName: '6',
          fullName: '6_R_Temporal_pole',
          coordinates: {
            x: 33.909091,
            y: 14.727273,
            z: -34.931818,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a2b4e',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b4d',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b4c',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b4b',
              to: 7,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b4a',
              to: 8,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b49',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b48',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b47',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b46',
              to: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b45',
              to: 14,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b44',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b43',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b42',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b41',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b40',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b3f',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b3e',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b3d',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b3c',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b3b',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b3a',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b39',
              to: 28,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b38',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b37',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b36',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b35',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b34',
              to: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b33',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b32',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b31',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b30',
              to: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b2f',
              to: 99,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b2e',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b2d',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b2c',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b2b',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b2a',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b29',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b28',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b27',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b26',
              to: 63,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a2b97',
              id: 0,
              frequency: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b96',
              id: 1,
              frequency: 975,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b95',
              id: 2,
              frequency: 303,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b94',
              id: 3,
              frequency: 600,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b93',
              id: 4,
              frequency: 12276,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b92',
              id: 5,
              frequency: 9353,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b91',
              id: 6,
              frequency: 4459,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b90',
              id: 7,
              frequency: 571,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b8f',
              id: 8,
              frequency: 1819,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b8e',
              id: 9,
              frequency: 9025,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b8d',
              id: 10,
              frequency: 13711,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b8c',
              id: 11,
              frequency: 3138,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b8b',
              id: 12,
              frequency: 7124,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b8a',
              id: 13,
              frequency: 4434,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b89',
              id: 14,
              frequency: 4198,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b88',
              id: 15,
              frequency: 85868,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b87',
              id: 16,
              frequency: 76481,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b86',
              id: 17,
              frequency: 29890,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b85',
              id: 18,
              frequency: 24179,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b84',
              id: 19,
              frequency: 62149,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b83',
              id: 20,
              frequency: 29511,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b82',
              id: 21,
              frequency: 17442,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b81',
              id: 22,
              frequency: 4964,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b80',
              id: 23,
              frequency: 305,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b7f',
              id: 24,
              frequency: 83890,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b7e',
              id: 25,
              frequency: 36625,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b7d',
              id: 26,
              frequency: 44028,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b7c',
              id: 27,
              frequency: 72775,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b7b',
              id: 28,
              frequency: 74020,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b7a',
              id: 29,
              frequency: 131486,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b79',
              id: 30,
              frequency: 35887,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b78',
              id: 31,
              frequency: 38184,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b77',
              id: 32,
              frequency: 31643,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b76',
              id: 33,
              frequency: 3800,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b75',
              id: 34,
              frequency: 15776,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b74',
              id: 35,
              frequency: 15701,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b73',
              id: 36,
              frequency: 9491,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b72',
              id: 37,
              frequency: 23329,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b71',
              id: 38,
              frequency: 7483,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b70',
              id: 39,
              frequency: 41653,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b6f',
              id: 40,
              frequency: 68105,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b6e',
              id: 41,
              frequency: 25289,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b6d',
              id: 42,
              frequency: 9662,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b6c',
              id: 43,
              frequency: 81247,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b6b',
              id: 44,
              frequency: 3726,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b6a',
              id: 45,
              frequency: 61809,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b69',
              id: 46,
              frequency: 46482,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b68',
              id: 47,
              frequency: 30534,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b67',
              id: 48,
              frequency: 73469,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b66',
              id: 49,
              frequency: 2280,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b65',
              id: 50,
              frequency: 599,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b64',
              id: 51,
              frequency: 34051,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b63',
              id: 52,
              frequency: 20200,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b62',
              id: 53,
              frequency: 20020,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b61',
              id: 54,
              frequency: 15065,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b60',
              id: 55,
              frequency: 4358,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b5f',
              id: 56,
              frequency: 48491,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b5e',
              id: 57,
              frequency: 81586,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b5d',
              id: 58,
              frequency: 8983,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b5c',
              id: 59,
              frequency: 89676,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b5b',
              id: 60,
              frequency: 63264,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b5a',
              id: 61,
              frequency: 12775,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b59',
              id: 62,
              frequency: 7213,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b58',
              id: 63,
              frequency: 8017,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b57',
              id: 64,
              frequency: 10719,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b56',
              id: 65,
              frequency: 42815,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b55',
              id: 66,
              frequency: 63091,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b54',
              id: 67,
              frequency: 31193,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b53',
              id: 68,
              frequency: 18526,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b52',
              id: 69,
              frequency: 2498,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b51',
              id: 70,
              frequency: 30042,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b50',
              id: 71,
              frequency: 28348,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b4f',
              id: 72,
              frequency: 17762,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a2a9e',
          id: 6,
          abbrevName: '7',
          fullName: '7_L_Cerebellum',
          coordinates: {
            x: -37.55,
            y: -69.533333,
            z: -37.85,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a2adb',
              to: 7,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ada',
              to: 8,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ad9',
              to: 9,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ad8',
              to: 10,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ad7',
              to: 11,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ad6',
              to: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ad5',
              to: 14,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ad4',
              to: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ad3',
              to: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ad2',
              to: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ad1',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ad0',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2acf',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ace',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2acd',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2acc',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2acb',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2aca',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ac9',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ac8',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ac7',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ac6',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ac5',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ac4',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ac3',
              to: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ac2',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ac1',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ac0',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2abf',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2abe',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2abd',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2abc',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2abb',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2aba',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ab9',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ab8',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ab7',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ab6',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ab5',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ab4',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ab3',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ab2',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ab1',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ab0',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2aaf',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2aae',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2aad',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2aac',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2aab',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2aaa',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2aa9',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2aa8',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2aa7',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2aa6',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2aa5',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2aa4',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2aa3',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2aa2',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2aa1',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2aa0',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a9f',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a2b24',
              id: 0,
              frequency: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b23',
              id: 1,
              frequency: 888,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b22',
              id: 2,
              frequency: 877,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b21',
              id: 3,
              frequency: 1203,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b20',
              id: 4,
              frequency: 7168,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b1f',
              id: 5,
              frequency: 16021,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b1e',
              id: 6,
              frequency: 1557,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b1d',
              id: 7,
              frequency: 2953,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b1c',
              id: 8,
              frequency: 3570,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b1b',
              id: 9,
              frequency: 5504,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b1a',
              id: 10,
              frequency: 16083,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b19',
              id: 11,
              frequency: 15821,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b18',
              id: 12,
              frequency: 8794,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b17',
              id: 13,
              frequency: 14750,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b16',
              id: 14,
              frequency: 10156,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b15',
              id: 15,
              frequency: 19620,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b14',
              id: 16,
              frequency: 75838,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b13',
              id: 17,
              frequency: 35438,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b12',
              id: 18,
              frequency: 8266,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b11',
              id: 19,
              frequency: 13572,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b10',
              id: 20,
              frequency: 18562,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b0f',
              id: 21,
              frequency: 51860,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b0e',
              id: 22,
              frequency: 1049,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b0d',
              id: 23,
              frequency: 2800,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b0c',
              id: 24,
              frequency: 24032,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b0b',
              id: 25,
              frequency: 23319,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b0a',
              id: 26,
              frequency: 128598,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b09',
              id: 27,
              frequency: 30686,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b08',
              id: 28,
              frequency: 74662,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b07',
              id: 29,
              frequency: 92704,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b06',
              id: 30,
              frequency: 104715,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b05',
              id: 31,
              frequency: 7973,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b04',
              id: 32,
              frequency: 17064,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b03',
              id: 33,
              frequency: 37063,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b02',
              id: 34,
              frequency: 21067,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b01',
              id: 35,
              frequency: 1999,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2b00',
              id: 36,
              frequency: 13018,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2aff',
              id: 37,
              frequency: 17088,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2afe',
              id: 38,
              frequency: 25416,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2afd',
              id: 39,
              frequency: 9006,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2afc',
              id: 40,
              frequency: 34412,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2afb',
              id: 41,
              frequency: 46809,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2afa',
              id: 42,
              frequency: 78437,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2af9',
              id: 43,
              frequency: 61152,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2af8',
              id: 44,
              frequency: 41844,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2af7',
              id: 45,
              frequency: 27156,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2af6',
              id: 46,
              frequency: 38091,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2af5',
              id: 47,
              frequency: 88786,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2af4',
              id: 48,
              frequency: 147242,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2af3',
              id: 49,
              frequency: 851,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2af2',
              id: 50,
              frequency: 2706,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2af1',
              id: 51,
              frequency: 45382,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2af0',
              id: 52,
              frequency: 14115,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2aef',
              id: 53,
              frequency: 68202,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2aee',
              id: 54,
              frequency: 5410,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2aed',
              id: 55,
              frequency: 19323,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2aec',
              id: 56,
              frequency: 22390,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2aeb',
              id: 57,
              frequency: 111758,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2aea',
              id: 58,
              frequency: 74714,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ae9',
              id: 59,
              frequency: 72246,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ae8',
              id: 60,
              frequency: 123727,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ae7',
              id: 61,
              frequency: 100110,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ae6',
              id: 62,
              frequency: 11114,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ae5',
              id: 63,
              frequency: 29831,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ae4',
              id: 64,
              frequency: 23277,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ae3',
              id: 65,
              frequency: 38293,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ae2',
              id: 66,
              frequency: 90886,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ae1',
              id: 67,
              frequency: 158164,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ae0',
              id: 68,
              frequency: 40235,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2adf',
              id: 69,
              frequency: 14685,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2ade',
              id: 70,
              frequency: 46774,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2add',
              id: 71,
              frequency: 101403,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2adc',
              id: 72,
              frequency: 48497,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a2a28',
          id: 7,
          abbrevName: '8',
          fullName: '8_R_Frontal_pole',
          coordinates: {
            x: 20.994975,
            y: 59.628141,
            z: 18.653266,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a2a54',
              to: 8,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a53',
              to: 11,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a52',
              to: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a51',
              to: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a50',
              to: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a4f',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a4e',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a4d',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a4c',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a4b',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a4a',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a49',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a48',
              to: 28,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a47',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a46',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a45',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a44',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a43',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a42',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a41',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a40',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a3f',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a3e',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a3d',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a3c',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a3b',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a3a',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a39',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a38',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a37',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a36',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a35',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a34',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a33',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a32',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a31',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a30',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a2f',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a2e',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a2d',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a2c',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a2b',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a2a',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a29',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a2a9d',
              id: 0,
              frequency: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a9c',
              id: 1,
              frequency: 916,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a9b',
              id: 2,
              frequency: 429,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a9a',
              id: 3,
              frequency: 747,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a99',
              id: 4,
              frequency: 13694,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a98',
              id: 5,
              frequency: 10994,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a97',
              id: 6,
              frequency: 2378,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a96',
              id: 7,
              frequency: 782,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a95',
              id: 8,
              frequency: 2256,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a94',
              id: 9,
              frequency: 7737,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a93',
              id: 10,
              frequency: 14680,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a92',
              id: 11,
              frequency: 5765,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a91',
              id: 12,
              frequency: 6891,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a90',
              id: 13,
              frequency: 6287,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a8f',
              id: 14,
              frequency: 5590,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a8e',
              id: 15,
              frequency: 73848,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a8d',
              id: 16,
              frequency: 107677,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a8c',
              id: 17,
              frequency: 29213,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a8b',
              id: 18,
              frequency: 26811,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a8a',
              id: 19,
              frequency: 30381,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a89',
              id: 20,
              frequency: 18041,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a88',
              id: 21,
              frequency: 19483,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a87',
              id: 22,
              frequency: 1366,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a86',
              id: 23,
              frequency: 426,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a85',
              id: 24,
              frequency: 61984,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a84',
              id: 25,
              frequency: 27098,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a83',
              id: 26,
              frequency: 71222,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a82',
              id: 27,
              frequency: 99861,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a81',
              id: 28,
              frequency: 69244,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a80',
              id: 29,
              frequency: 155374,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a7f',
              id: 30,
              frequency: 54213,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a7e',
              id: 31,
              frequency: 15349,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a7d',
              id: 32,
              frequency: 22571,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a7c',
              id: 33,
              frequency: 6184,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a7b',
              id: 34,
              frequency: 27510,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a7a',
              id: 35,
              frequency: 10707,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a79',
              id: 36,
              frequency: 17393,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a78',
              id: 37,
              frequency: 16992,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a77',
              id: 38,
              frequency: 9183,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a76',
              id: 39,
              frequency: 24660,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a75',
              id: 40,
              frequency: 40954,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a74',
              id: 41,
              frequency: 32094,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a73',
              id: 42,
              frequency: 17137,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a72',
              id: 43,
              frequency: 83023,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a71',
              id: 44,
              frequency: 10741,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a70',
              id: 45,
              frequency: 70838,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a6f',
              id: 46,
              frequency: 61918,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a6e',
              id: 47,
              frequency: 41613,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a6d',
              id: 48,
              frequency: 92891,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a6c',
              id: 49,
              frequency: 1166,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a6b',
              id: 50,
              frequency: 1086,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a6a',
              id: 51,
              frequency: 42034,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a69',
              id: 52,
              frequency: 23346,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a68',
              id: 53,
              frequency: 33510,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a67',
              id: 54,
              frequency: 6627,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a66',
              id: 55,
              frequency: 4763,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a65',
              id: 56,
              frequency: 42263,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a64',
              id: 57,
              frequency: 96628,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a63',
              id: 58,
              frequency: 23195,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a62',
              id: 59,
              frequency: 91893,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a61',
              id: 60,
              frequency: 70111,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a60',
              id: 61,
              frequency: 27090,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a5f',
              id: 62,
              frequency: 7821,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a5e',
              id: 63,
              frequency: 12479,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a5d',
              id: 64,
              frequency: 13893,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a5c',
              id: 65,
              frequency: 34770,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a5b',
              id: 66,
              frequency: 68498,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a5a',
              id: 67,
              frequency: 51819,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a59',
              id: 68,
              frequency: 21230,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a58',
              id: 69,
              frequency: 4340,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a57',
              id: 70,
              frequency: 29572,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a56',
              id: 71,
              frequency: 41299,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a55',
              id: 72,
              frequency: 24882,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a299f',
          id: 8,
          abbrevName: '9',
          fullName: '9_L_STG_posterior',
          coordinates: {
            x: -61.029289,
            y: -27.656904,
            z: -4.619247,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a29de',
              to: 9,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29dd',
              to: 12,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29dc',
              to: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29db',
              to: 14,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29da',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29d9',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29d8',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29d7',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29d6',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29d5',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29d4',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29d3',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29d2',
              to: 28,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29d1',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29d0',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29cf',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29ce',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29cd',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29cc',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29cb',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29ca',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29c9',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29c8',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29c7',
              to: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29c6',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29c5',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29c4',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29c3',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29c2',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29c1',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29c0',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29bf',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29be',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29bd',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29bc',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29bb',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29ba',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29b9',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29b8',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29b7',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29b6',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29b5',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29b4',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29b3',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29b2',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29b1',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29b0',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29af',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29ae',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29ad',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29ac',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29ab',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29aa',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29a9',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29a8',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29a7',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29a6',
              to: 93,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29a5',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29a4',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29a3',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29a2',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29a1',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29a0',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a2a27',
              id: 0,
              frequency: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a26',
              id: 1,
              frequency: 854,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a25',
              id: 2,
              frequency: 970,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a24',
              id: 3,
              frequency: 1308,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a23',
              id: 4,
              frequency: 5791,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a22',
              id: 5,
              frequency: 16965,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a21',
              id: 6,
              frequency: 1923,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a20',
              id: 7,
              frequency: 3894,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a1f',
              id: 8,
              frequency: 3069,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a1e',
              id: 9,
              frequency: 4180,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a1d',
              id: 10,
              frequency: 16231,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a1c',
              id: 11,
              frequency: 18093,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a1b',
              id: 12,
              frequency: 8942,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a1a',
              id: 13,
              frequency: 16152,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a19',
              id: 14,
              frequency: 11977,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a18',
              id: 15,
              frequency: 20089,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a17',
              id: 16,
              frequency: 70058,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a16',
              id: 17,
              frequency: 36992,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a15',
              id: 18,
              frequency: 5878,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a14',
              id: 19,
              frequency: 13590,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a13',
              id: 20,
              frequency: 25879,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a12',
              id: 21,
              frequency: 66381,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a11',
              id: 22,
              frequency: 1143,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a10',
              id: 23,
              frequency: 5796,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a0f',
              id: 24,
              frequency: 19490,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a0e',
              id: 25,
              frequency: 25697,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a0d',
              id: 26,
              frequency: 135937,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a0c',
              id: 27,
              frequency: 18412,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a0b',
              id: 28,
              frequency: 66163,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a0a',
              id: 29,
              frequency: 79705,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a09',
              id: 30,
              frequency: 114530,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a08',
              id: 31,
              frequency: 7848,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a07',
              id: 32,
              frequency: 19173,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a06',
              id: 33,
              frequency: 54209,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a05',
              id: 34,
              frequency: 20275,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a04',
              id: 35,
              frequency: 3752,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a03',
              id: 36,
              frequency: 7971,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a02',
              id: 37,
              frequency: 20205,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a01',
              id: 38,
              frequency: 28560,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2a00',
              id: 39,
              frequency: 9492,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29ff',
              id: 40,
              frequency: 43510,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29fe',
              id: 41,
              frequency: 46971,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29fd',
              id: 42,
              frequency: 97490,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29fc',
              id: 43,
              frequency: 48439,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29fb',
              id: 44,
              frequency: 48376,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29fa',
              id: 45,
              frequency: 16532,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29f9',
              id: 46,
              frequency: 31529,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29f8',
              id: 47,
              frequency: 106706,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29f7',
              id: 48,
              frequency: 153935,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29f6',
              id: 49,
              frequency: 1376,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29f5',
              id: 50,
              frequency: 1877,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29f4',
              id: 51,
              frequency: 32108,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29f3',
              id: 52,
              frequency: 13906,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29f2',
              id: 53,
              frequency: 64365,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29f1',
              id: 54,
              frequency: 8661,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29f0',
              id: 55,
              frequency: 24018,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29ef',
              id: 56,
              frequency: 11999,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29ee',
              id: 57,
              frequency: 125128,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29ed',
              id: 58,
              frequency: 94528,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29ec',
              id: 59,
              frequency: 58764,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29eb',
              id: 60,
              frequency: 133099,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29ea',
              id: 61,
              frequency: 105635,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29e9',
              id: 62,
              frequency: 7167,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29e8',
              id: 63,
              frequency: 22642,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29e7',
              id: 64,
              frequency: 21637,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29e6',
              id: 65,
              frequency: 30126,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29e5',
              id: 66,
              frequency: 98219,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29e4',
              id: 67,
              frequency: 184289,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29e3',
              id: 68,
              frequency: 37077,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29e2',
              id: 69,
              frequency: 14507,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29e1',
              id: 70,
              frequency: 51784,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29e0',
              id: 71,
              frequency: 121230,
            },
            {
              _id: '5d6615769bcb6d0e6d7a29df',
              id: 72,
              frequency: 64307,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a291c',
          id: 9,
          abbrevName: '10',
          fullName: '10_R_Occ_fusiform_gyrus',
          coordinates: {
            x: 21.575758,
            y: -93.737374,
            z: -5.111111,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a2955',
              to: 10,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2954',
              to: 12,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2953',
              to: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2952',
              to: 14,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2951',
              to: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2950',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a294f',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d7a294e',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a294d',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a294c',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a294b',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d7a294a',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2949',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2948',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2947',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2946',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2945',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2944',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2943',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2942',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2941',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2940',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a293f',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a293e',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a293d',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a293c',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a293b',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a293a',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2939',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2938',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2937',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2936',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2935',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2934',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2933',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2932',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2931',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2930',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a292f',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a292e',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a292d',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a292c',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a292b',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a292a',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2929',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2928',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2927',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2926',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2925',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2924',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2923',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2922',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2921',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2920',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a291f',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a291e',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a291d',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a299e',
              id: 0,
              frequency: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a299d',
              id: 1,
              frequency: 920,
            },
            {
              _id: '5d6615769bcb6d0e6d7a299c',
              id: 2,
              frequency: 576,
            },
            {
              _id: '5d6615769bcb6d0e6d7a299b',
              id: 3,
              frequency: 1135,
            },
            {
              _id: '5d6615769bcb6d0e6d7a299a',
              id: 4,
              frequency: 7304,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2999',
              id: 5,
              frequency: 13241,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2998',
              id: 6,
              frequency: 3298,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2997',
              id: 7,
              frequency: 1207,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2996',
              id: 8,
              frequency: 2462,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2995',
              id: 9,
              frequency: 5081,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2994',
              id: 10,
              frequency: 18087,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2993',
              id: 11,
              frequency: 8951,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2992',
              id: 12,
              frequency: 8554,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2991',
              id: 13,
              frequency: 11309,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2990',
              id: 14,
              frequency: 11042,
            },
            {
              _id: '5d6615769bcb6d0e6d7a298f',
              id: 15,
              frequency: 33864,
            },
            {
              _id: '5d6615769bcb6d0e6d7a298e',
              id: 16,
              frequency: 58573,
            },
            {
              _id: '5d6615769bcb6d0e6d7a298d',
              id: 17,
              frequency: 38595,
            },
            {
              _id: '5d6615769bcb6d0e6d7a298c',
              id: 18,
              frequency: 9073,
            },
            {
              _id: '5d6615769bcb6d0e6d7a298b',
              id: 19,
              frequency: 31128,
            },
            {
              _id: '5d6615769bcb6d0e6d7a298a',
              id: 20,
              frequency: 36190,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2989',
              id: 21,
              frequency: 26683,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2988',
              id: 22,
              frequency: 3952,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2987',
              id: 23,
              frequency: 597,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2986',
              id: 24,
              frequency: 29600,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2985',
              id: 25,
              frequency: 37323,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2984',
              id: 26,
              frequency: 82328,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2983',
              id: 27,
              frequency: 26197,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2982',
              id: 28,
              frequency: 59721,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2981',
              id: 29,
              frequency: 108287,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2980',
              id: 30,
              frequency: 85761,
            },
            {
              _id: '5d6615769bcb6d0e6d7a297f',
              id: 31,
              frequency: 19557,
            },
            {
              _id: '5d6615769bcb6d0e6d7a297e',
              id: 32,
              frequency: 35320,
            },
            {
              _id: '5d6615769bcb6d0e6d7a297d',
              id: 33,
              frequency: 11640,
            },
            {
              _id: '5d6615769bcb6d0e6d7a297c',
              id: 34,
              frequency: 19803,
            },
            {
              _id: '5d6615769bcb6d0e6d7a297b',
              id: 35,
              frequency: 5467,
            },
            {
              _id: '5d6615769bcb6d0e6d7a297a',
              id: 36,
              frequency: 7682,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2979',
              id: 37,
              frequency: 25275,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2978',
              id: 38,
              frequency: 12406,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2977',
              id: 39,
              frequency: 15300,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2976',
              id: 40,
              frequency: 64941,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2975',
              id: 41,
              frequency: 39536,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2974',
              id: 42,
              frequency: 31328,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2973',
              id: 43,
              frequency: 64333,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2972',
              id: 44,
              frequency: 17234,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2971',
              id: 45,
              frequency: 22317,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2970',
              id: 46,
              frequency: 34780,
            },
            {
              _id: '5d6615769bcb6d0e6d7a296f',
              id: 47,
              frequency: 59874,
            },
            {
              _id: '5d6615769bcb6d0e6d7a296e',
              id: 48,
              frequency: 146095,
            },
            {
              _id: '5d6615769bcb6d0e6d7a296d',
              id: 49,
              frequency: 1842,
            },
            {
              _id: '5d6615769bcb6d0e6d7a296c',
              id: 50,
              frequency: 1145,
            },
            {
              _id: '5d6615769bcb6d0e6d7a296b',
              id: 51,
              frequency: 29916,
            },
            {
              _id: '5d6615769bcb6d0e6d7a296a',
              id: 52,
              frequency: 17206,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2969',
              id: 53,
              frequency: 44933,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2968',
              id: 54,
              frequency: 12937,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2967',
              id: 55,
              frequency: 10596,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2966',
              id: 56,
              frequency: 15578,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2965',
              id: 57,
              frequency: 155097,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2964',
              id: 58,
              frequency: 42178,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2963',
              id: 59,
              frequency: 67914,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2962',
              id: 60,
              frequency: 111933,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2961',
              id: 61,
              frequency: 52435,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2960',
              id: 62,
              frequency: 6033,
            },
            {
              _id: '5d6615769bcb6d0e6d7a295f',
              id: 63,
              frequency: 14376,
            },
            {
              _id: '5d6615769bcb6d0e6d7a295e',
              id: 64,
              frequency: 21213,
            },
            {
              _id: '5d6615769bcb6d0e6d7a295d',
              id: 65,
              frequency: 30374,
            },
            {
              _id: '5d6615769bcb6d0e6d7a295c',
              id: 66,
              frequency: 106989,
            },
            {
              _id: '5d6615769bcb6d0e6d7a295b',
              id: 67,
              frequency: 114980,
            },
            {
              _id: '5d6615769bcb6d0e6d7a295a',
              id: 68,
              frequency: 29595,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2959',
              id: 69,
              frequency: 9726,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2958',
              id: 70,
              frequency: 45072,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2957',
              id: 71,
              frequency: 98227,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2956',
              id: 72,
              frequency: 66185,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a28bd',
          id: 10,
          abbrevName: '11',
          fullName: '11_R_Cerebellum',
          coordinates: {
            x: 36.666667,
            y: -44.553191,
            z: -45.716312,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a28d2',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28d1',
              to: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28d0',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28cf',
              to: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28ce',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28cd',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28cc',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28cb',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28ca',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28c9',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28c8',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28c7',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28c6',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28c5',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28c4',
              to: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28c3',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28c2',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28c1',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28c0',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28bf',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28be',
              to: 73,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a291b',
              id: 0,
              frequency: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a291a',
              id: 1,
              frequency: 912,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2919',
              id: 2,
              frequency: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2918',
              id: 3,
              frequency: 235,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2917',
              id: 4,
              frequency: 12556,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2916',
              id: 5,
              frequency: 2888,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2915',
              id: 6,
              frequency: 6881,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2914',
              id: 7,
              frequency: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2913',
              id: 8,
              frequency: 817,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2912',
              id: 9,
              frequency: 10571,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2911',
              id: 10,
              frequency: 7362,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2910',
              id: 11,
              frequency: 334,
            },
            {
              _id: '5d6615769bcb6d0e6d7a290f',
              id: 12,
              frequency: 5002,
            },
            {
              _id: '5d6615769bcb6d0e6d7a290e',
              id: 13,
              frequency: 773,
            },
            {
              _id: '5d6615769bcb6d0e6d7a290d',
              id: 14,
              frequency: 1175,
            },
            {
              _id: '5d6615769bcb6d0e6d7a290c',
              id: 15,
              frequency: 100845,
            },
            {
              _id: '5d6615769bcb6d0e6d7a290b',
              id: 16,
              frequency: 18625,
            },
            {
              _id: '5d6615769bcb6d0e6d7a290a',
              id: 17,
              frequency: 19405,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2909',
              id: 18,
              frequency: 32378,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2908',
              id: 19,
              frequency: 123115,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2907',
              id: 20,
              frequency: 12288,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2906',
              id: 21,
              frequency: 753,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2905',
              id: 22,
              frequency: 12590,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2904',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2903',
              id: 24,
              frequency: 126282,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2902',
              id: 25,
              frequency: 34523,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2901',
              id: 26,
              frequency: 4589,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2900',
              id: 27,
              frequency: 70866,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28ff',
              id: 28,
              frequency: 23349,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28fe',
              id: 29,
              frequency: 65241,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28fd',
              id: 30,
              frequency: 5279,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28fc',
              id: 31,
              frequency: 81144,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28fb',
              id: 32,
              frequency: 23460,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28fa',
              id: 33,
              frequency: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28f9',
              id: 34,
              frequency: 9217,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28f8',
              id: 35,
              frequency: 25223,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28f7',
              id: 36,
              frequency: 4014,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28f6',
              id: 37,
              frequency: 16235,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28f5',
              id: 38,
              frequency: 384,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28f4',
              id: 39,
              frequency: 71119,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28f3',
              id: 40,
              frequency: 72061,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28f2',
              id: 41,
              frequency: 4745,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28f1',
              id: 42,
              frequency: 167,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28f0',
              id: 43,
              frequency: 46569,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28ef',
              id: 44,
              frequency: 235,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28ee',
              id: 45,
              frequency: 76314,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28ed',
              id: 46,
              frequency: 32645,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28ec',
              id: 47,
              frequency: 5351,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28eb',
              id: 48,
              frequency: 16100,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28ea',
              id: 49,
              frequency: 1658,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28e9',
              id: 50,
              frequency: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28e8',
              id: 51,
              frequency: 19546,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28e7',
              id: 52,
              frequency: 15818,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28e6',
              id: 53,
              frequency: 4044,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28e5',
              id: 54,
              frequency: 18892,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28e4',
              id: 55,
              frequency: 149,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28e3',
              id: 56,
              frequency: 62422,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28e2',
              id: 57,
              frequency: 27074,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28e1',
              id: 58,
              frequency: 522,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28e0',
              id: 59,
              frequency: 74544,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28df',
              id: 60,
              frequency: 18157,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28de',
              id: 61,
              frequency: 704,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28dd',
              id: 62,
              frequency: 4243,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28dc',
              id: 63,
              frequency: 2197,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28db',
              id: 64,
              frequency: 3363,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28da',
              id: 65,
              frequency: 40605,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28d9',
              id: 66,
              frequency: 28036,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28d8',
              id: 67,
              frequency: 3020,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28d7',
              id: 68,
              frequency: 6459,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28d6',
              id: 69,
              frequency: 271,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28d5',
              id: 70,
              frequency: 16129,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28d4',
              id: 71,
              frequency: 3930,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28d3',
              id: 72,
              frequency: 3612,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a2849',
          id: 11,
          abbrevName: '12',
          fullName: '12_R_Frontal_pole__ifg_pars_triangularis',
          coordinates: {
            x: 45.005525,
            y: 42.685083,
            z: 8.353591,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a2873',
              to: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2872',
              to: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2871',
              to: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2870',
              to: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d7a286f',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a286e',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d7a286d',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a286c',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d7a286b',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a286a',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2869',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2868',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2867',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2866',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2865',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2864',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2863',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2862',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2861',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2860',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a285f',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a285e',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a285d',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a285c',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a285b',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a285a',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2859',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2858',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2857',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2856',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2855',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2854',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2853',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2852',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2851',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2850',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a284f',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a284e',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a284d',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a284c',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a284b',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a284a',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a28bc',
              id: 0,
              frequency: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28bb',
              id: 1,
              frequency: 962,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28ba',
              id: 2,
              frequency: 343,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28b9',
              id: 3,
              frequency: 738,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28b8',
              id: 4,
              frequency: 12750,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28b7',
              id: 5,
              frequency: 9672,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28b6',
              id: 6,
              frequency: 2806,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28b5',
              id: 7,
              frequency: 380,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28b4',
              id: 8,
              frequency: 2305,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28b3',
              id: 9,
              frequency: 8165,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28b2',
              id: 10,
              frequency: 14522,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28b1',
              id: 11,
              frequency: 4178,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28b0',
              id: 12,
              frequency: 7724,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28af',
              id: 13,
              frequency: 5939,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28ae',
              id: 14,
              frequency: 5718,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28ad',
              id: 15,
              frequency: 77817,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28ac',
              id: 16,
              frequency: 69608,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28ab',
              id: 17,
              frequency: 36277,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28aa',
              id: 18,
              frequency: 32847,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28a9',
              id: 19,
              frequency: 37771,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28a8',
              id: 20,
              frequency: 17970,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28a7',
              id: 21,
              frequency: 9690,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28a6',
              id: 22,
              frequency: 2319,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28a5',
              id: 23,
              frequency: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28a4',
              id: 24,
              frequency: 81708,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28a3',
              id: 25,
              frequency: 31586,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28a2',
              id: 26,
              frequency: 44734,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28a1',
              id: 27,
              frequency: 71921,
            },
            {
              _id: '5d6615769bcb6d0e6d7a28a0',
              id: 28,
              frequency: 59622,
            },
            {
              _id: '5d6615769bcb6d0e6d7a289f',
              id: 29,
              frequency: 142609,
            },
            {
              _id: '5d6615769bcb6d0e6d7a289e',
              id: 30,
              frequency: 45829,
            },
            {
              _id: '5d6615769bcb6d0e6d7a289d',
              id: 31,
              frequency: 18341,
            },
            {
              _id: '5d6615769bcb6d0e6d7a289c',
              id: 32,
              frequency: 24595,
            },
            {
              _id: '5d6615769bcb6d0e6d7a289b',
              id: 33,
              frequency: 2154,
            },
            {
              _id: '5d6615769bcb6d0e6d7a289a',
              id: 34,
              frequency: 23737,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2899',
              id: 35,
              frequency: 9855,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2898',
              id: 36,
              frequency: 14457,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2897',
              id: 37,
              frequency: 18940,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2896',
              id: 38,
              frequency: 5882,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2895',
              id: 39,
              frequency: 27167,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2894',
              id: 40,
              frequency: 49299,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2893',
              id: 41,
              frequency: 22685,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2892',
              id: 42,
              frequency: 8958,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2891',
              id: 43,
              frequency: 74617,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2890',
              id: 44,
              frequency: 6482,
            },
            {
              _id: '5d6615769bcb6d0e6d7a288f',
              id: 45,
              frequency: 60706,
            },
            {
              _id: '5d6615769bcb6d0e6d7a288e',
              id: 46,
              frequency: 59344,
            },
            {
              _id: '5d6615769bcb6d0e6d7a288d',
              id: 47,
              frequency: 36210,
            },
            {
              _id: '5d6615769bcb6d0e6d7a288c',
              id: 48,
              frequency: 93205,
            },
            {
              _id: '5d6615769bcb6d0e6d7a288b',
              id: 49,
              frequency: 1156,
            },
            {
              _id: '5d6615769bcb6d0e6d7a288a',
              id: 50,
              frequency: 830,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2889',
              id: 51,
              frequency: 44144,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2888',
              id: 52,
              frequency: 21779,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2887',
              id: 53,
              frequency: 29668,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2886',
              id: 54,
              frequency: 7980,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2885',
              id: 55,
              frequency: 3166,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2884',
              id: 56,
              frequency: 40661,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2883',
              id: 57,
              frequency: 95332,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2882',
              id: 58,
              frequency: 14738,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2881',
              id: 59,
              frequency: 91505,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2880',
              id: 60,
              frequency: 72411,
            },
            {
              _id: '5d6615769bcb6d0e6d7a287f',
              id: 61,
              frequency: 22123,
            },
            {
              _id: '5d6615769bcb6d0e6d7a287e',
              id: 62,
              frequency: 9004,
            },
            {
              _id: '5d6615769bcb6d0e6d7a287d',
              id: 63,
              frequency: 12716,
            },
            {
              _id: '5d6615769bcb6d0e6d7a287c',
              id: 64,
              frequency: 15863,
            },
            {
              _id: '5d6615769bcb6d0e6d7a287b',
              id: 65,
              frequency: 43847,
            },
            {
              _id: '5d6615769bcb6d0e6d7a287a',
              id: 66,
              frequency: 72856,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2879',
              id: 67,
              frequency: 47220,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2878',
              id: 68,
              frequency: 24390,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2877',
              id: 69,
              frequency: 4766,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2876',
              id: 70,
              frequency: 34869,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2875',
              id: 71,
              frequency: 42555,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2874',
              id: 72,
              frequency: 26131,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a27d6',
          id: 12,
          abbrevName: '13',
          fullName: '13_L_LOC_inferior',
          coordinates: {
            x: -42.391489,
            y: -79.225532,
            z: -1.361702,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a27ff',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27fe',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27fd',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27fc',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27fb',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27fa',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27f9',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27f8',
              to: 13,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27f7',
              to: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27f6',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27f5',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27f4',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27f3',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27f2',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27f1',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27f0',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27ef',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27ee',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27ed',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27ec',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27eb',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27ea',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27e9',
              to: 99,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27e8',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27e7',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27e6',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27e5',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27e4',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27e3',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27e2',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27e1',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27e0',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27df',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27de',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27dd',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27dc',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27db',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27da',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27d9',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27d8',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27d7',
              to: 63,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a2848',
              id: 0,
              frequency: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2847',
              id: 1,
              frequency: 906,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2846',
              id: 2,
              frequency: 197,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2845',
              id: 3,
              frequency: 706,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2844',
              id: 4,
              frequency: 13248,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2843',
              id: 5,
              frequency: 5956,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2842',
              id: 6,
              frequency: 3392,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2841',
              id: 7,
              frequency: 160,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2840',
              id: 8,
              frequency: 1414,
            },
            {
              _id: '5d6615769bcb6d0e6d7a283f',
              id: 9,
              frequency: 7371,
            },
            {
              _id: '5d6615769bcb6d0e6d7a283e',
              id: 10,
              frequency: 14968,
            },
            {
              _id: '5d6615769bcb6d0e6d7a283d',
              id: 11,
              frequency: 1834,
            },
            {
              _id: '5d6615769bcb6d0e6d7a283c',
              id: 12,
              frequency: 7150,
            },
            {
              _id: '5d6615769bcb6d0e6d7a283b',
              id: 13,
              frequency: 3929,
            },
            {
              _id: '5d6615769bcb6d0e6d7a283a',
              id: 14,
              frequency: 6418,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2839',
              id: 15,
              frequency: 93079,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2838',
              id: 16,
              frequency: 46459,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2837',
              id: 17,
              frequency: 22822,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2836',
              id: 18,
              frequency: 34401,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2835',
              id: 19,
              frequency: 51138,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2834',
              id: 20,
              frequency: 16166,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2833',
              id: 21,
              frequency: 4744,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2832',
              id: 22,
              frequency: 3570,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2831',
              id: 23,
              frequency: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2830',
              id: 24,
              frequency: 81026,
            },
            {
              _id: '5d6615769bcb6d0e6d7a282f',
              id: 25,
              frequency: 38453,
            },
            {
              _id: '5d6615769bcb6d0e6d7a282e',
              id: 26,
              frequency: 21605,
            },
            {
              _id: '5d6615769bcb6d0e6d7a282d',
              id: 27,
              frequency: 78455,
            },
            {
              _id: '5d6615769bcb6d0e6d7a282c',
              id: 28,
              frequency: 37589,
            },
            {
              _id: '5d6615769bcb6d0e6d7a282b',
              id: 29,
              frequency: 160443,
            },
            {
              _id: '5d6615769bcb6d0e6d7a282a',
              id: 30,
              frequency: 23779,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2829',
              id: 31,
              frequency: 24571,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2828',
              id: 32,
              frequency: 32082,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2827',
              id: 33,
              frequency: 704,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2826',
              id: 34,
              frequency: 14605,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2825',
              id: 35,
              frequency: 14471,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2824',
              id: 36,
              frequency: 9581,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2823',
              id: 37,
              frequency: 15732,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2822',
              id: 38,
              frequency: 2356,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2821',
              id: 39,
              frequency: 30163,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2820',
              id: 40,
              frequency: 56958,
            },
            {
              _id: '5d6615769bcb6d0e6d7a281f',
              id: 41,
              frequency: 17695,
            },
            {
              _id: '5d6615769bcb6d0e6d7a281e',
              id: 42,
              frequency: 3201,
            },
            {
              _id: '5d6615769bcb6d0e6d7a281d',
              id: 43,
              frequency: 75359,
            },
            {
              _id: '5d6615769bcb6d0e6d7a281c',
              id: 44,
              frequency: 1440,
            },
            {
              _id: '5d6615769bcb6d0e6d7a281b',
              id: 45,
              frequency: 61252,
            },
            {
              _id: '5d6615769bcb6d0e6d7a281a',
              id: 46,
              frequency: 67054,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2819',
              id: 47,
              frequency: 14494,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2818',
              id: 48,
              frequency: 70938,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2817',
              id: 49,
              frequency: 1136,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2816',
              id: 50,
              frequency: 346,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2815',
              id: 51,
              frequency: 27431,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2814',
              id: 52,
              frequency: 23908,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2813',
              id: 53,
              frequency: 13865,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2812',
              id: 54,
              frequency: 9627,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2811',
              id: 55,
              frequency: 1715,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2810',
              id: 56,
              frequency: 33131,
            },
            {
              _id: '5d6615769bcb6d0e6d7a280f',
              id: 57,
              frequency: 122468,
            },
            {
              _id: '5d6615769bcb6d0e6d7a280e',
              id: 58,
              frequency: 6043,
            },
            {
              _id: '5d6615769bcb6d0e6d7a280d',
              id: 59,
              frequency: 91787,
            },
            {
              _id: '5d6615769bcb6d0e6d7a280c',
              id: 60,
              frequency: 47042,
            },
            {
              _id: '5d6615769bcb6d0e6d7a280b',
              id: 61,
              frequency: 7313,
            },
            {
              _id: '5d6615769bcb6d0e6d7a280a',
              id: 62,
              frequency: 4843,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2809',
              id: 63,
              frequency: 6576,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2808',
              id: 64,
              frequency: 10706,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2807',
              id: 65,
              frequency: 33865,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2806',
              id: 66,
              frequency: 79250,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2805',
              id: 67,
              frequency: 27035,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2804',
              id: 68,
              frequency: 16857,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2803',
              id: 69,
              frequency: 2133,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2802',
              id: 70,
              frequency: 37358,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2801',
              id: 71,
              frequency: 35793,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2800',
              id: 72,
              frequency: 38014,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a274a',
          id: 13,
          abbrevName: '14',
          fullName: '14_L_SFG_mfg',
          coordinates: {
            x: -23.76,
            y: -1.06,
            z: 62.84,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a278c',
              to: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d7a278b',
              to: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d7a278a',
              to: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2789',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2788',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2787',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2786',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2785',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2784',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2783',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2782',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2781',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2780',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a277f',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a277e',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d7a277d',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a277c',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a277b',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a277a',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2779',
              to: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2778',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2777',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2776',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2775',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2774',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2773',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2772',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2771',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2770',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a276f',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a276e',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a276d',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a276c',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a276b',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a276a',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2769',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2768',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2767',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2766',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2765',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2764',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2763',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2762',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2761',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2760',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a275f',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a275e',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a275d',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a275c',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a275b',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a275a',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2759',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2758',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2757',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2756',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2755',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2754',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2753',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2752',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2751',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2750',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a274f',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a274e',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a274d',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a274c',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a274b',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a27d5',
              id: 0,
              frequency: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27d4',
              id: 1,
              frequency: 610,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27d3',
              id: 2,
              frequency: 1199,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27d2',
              id: 3,
              frequency: 1651,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27d1',
              id: 4,
              frequency: 3317,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27d0',
              id: 5,
              frequency: 13493,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27cf',
              id: 6,
              frequency: 976,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27ce',
              id: 7,
              frequency: 4282,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27cd',
              id: 8,
              frequency: 2652,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27cc',
              id: 9,
              frequency: 2241,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27cb',
              id: 10,
              frequency: 13825,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27ca',
              id: 11,
              frequency: 26427,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27c9',
              id: 12,
              frequency: 6564,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27c8',
              id: 13,
              frequency: 23026,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27c7',
              id: 14,
              frequency: 16565,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27c6',
              id: 15,
              frequency: 9082,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27c5',
              id: 16,
              frequency: 51303,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27c4',
              id: 17,
              frequency: 12999,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27c3',
              id: 18,
              frequency: 4154,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27c2',
              id: 19,
              frequency: 4458,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27c1',
              id: 20,
              frequency: 16550,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27c0',
              id: 21,
              frequency: 49227,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27bf',
              id: 22,
              frequency: 498,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27be',
              id: 23,
              frequency: 4065,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27bd',
              id: 24,
              frequency: 8801,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27bc',
              id: 25,
              frequency: 9366,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27bb',
              id: 26,
              frequency: 142657,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27ba',
              id: 27,
              frequency: 7429,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27b9',
              id: 28,
              frequency: 41051,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27b8',
              id: 29,
              frequency: 60240,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27b7',
              id: 30,
              frequency: 114477,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27b6',
              id: 31,
              frequency: 3249,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27b5',
              id: 32,
              frequency: 13995,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27b4',
              id: 33,
              frequency: 64197,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27b3',
              id: 34,
              frequency: 9077,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27b2',
              id: 35,
              frequency: 1102,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27b1',
              id: 36,
              frequency: 7451,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27b0',
              id: 37,
              frequency: 10884,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27af',
              id: 38,
              frequency: 21047,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27ae',
              id: 39,
              frequency: 4558,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27ad',
              id: 40,
              frequency: 21587,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27ac',
              id: 41,
              frequency: 51124,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27ab',
              id: 42,
              frequency: 139229,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27aa',
              id: 43,
              frequency: 33958,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27a9',
              id: 44,
              frequency: 88649,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27a8',
              id: 45,
              frequency: 5851,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27a7',
              id: 46,
              frequency: 19483,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27a6',
              id: 47,
              frequency: 79788,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27a5',
              id: 48,
              frequency: 146695,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27a4',
              id: 49,
              frequency: 826,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27a3',
              id: 50,
              frequency: 1996,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27a2',
              id: 51,
              frequency: 18935,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27a1',
              id: 52,
              frequency: 6149,
            },
            {
              _id: '5d6615769bcb6d0e6d7a27a0',
              id: 53,
              frequency: 67037,
            },
            {
              _id: '5d6615769bcb6d0e6d7a279f',
              id: 54,
              frequency: 4266,
            },
            {
              _id: '5d6615769bcb6d0e6d7a279e',
              id: 55,
              frequency: 28703,
            },
            {
              _id: '5d6615769bcb6d0e6d7a279d',
              id: 56,
              frequency: 4540,
            },
            {
              _id: '5d6615769bcb6d0e6d7a279c',
              id: 57,
              frequency: 122049,
            },
            {
              _id: '5d6615769bcb6d0e6d7a279b',
              id: 58,
              frequency: 161726,
            },
            {
              _id: '5d6615769bcb6d0e6d7a279a',
              id: 59,
              frequency: 33977,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2799',
              id: 60,
              frequency: 113015,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2798',
              id: 61,
              frequency: 194402,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2797',
              id: 62,
              frequency: 4151,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2796',
              id: 63,
              frequency: 23713,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2795',
              id: 64,
              frequency: 20301,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2794',
              id: 65,
              frequency: 15926,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2793',
              id: 66,
              frequency: 83349,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2792',
              id: 67,
              frequency: 293741,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2791',
              id: 68,
              frequency: 34449,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2790',
              id: 69,
              frequency: 27410,
            },
            {
              _id: '5d6615769bcb6d0e6d7a278f',
              id: 70,
              frequency: 38991,
            },
            {
              _id: '5d6615769bcb6d0e6d7a278e',
              id: 71,
              frequency: 184817,
            },
            {
              _id: '5d6615769bcb6d0e6d7a278d',
              id: 72,
              frequency: 96036,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a26ce',
          id: 14,
          abbrevName: '15',
          fullName: '15_R_HC_phc',
          coordinates: {
            x: 24.38835,
            y: -9.572816,
            z: -23.533981,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a2700',
              to: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26ff',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26fe',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26fd',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26fc',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26fb',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26fa',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26f9',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26f8',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26f7',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26f6',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26f5',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26f4',
              to: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26f3',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26f2',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26f1',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26f0',
              to: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26ef',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26ee',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26ed',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26ec',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26eb',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26ea',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26e9',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26e8',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26e7',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26e6',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26e5',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26e4',
              to: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26e3',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26e2',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26e1',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26e0',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26df',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26de',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26dd',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26dc',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26db',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26da',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26d9',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26d8',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26d7',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26d6',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26d5',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26d4',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26d3',
              to: 93,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26d2',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26d1',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26d0',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26cf',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a2749',
              id: 0,
              frequency: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2748',
              id: 1,
              frequency: 994,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2747',
              id: 2,
              frequency: 629,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2746',
              id: 3,
              frequency: 967,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2745',
              id: 4,
              frequency: 9001,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2744',
              id: 5,
              frequency: 14815,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2743',
              id: 6,
              frequency: 3087,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2742',
              id: 7,
              frequency: 1986,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2741',
              id: 8,
              frequency: 2744,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2740',
              id: 9,
              frequency: 6631,
            },
            {
              _id: '5d6615769bcb6d0e6d7a273f',
              id: 10,
              frequency: 16887,
            },
            {
              _id: '5d6615769bcb6d0e6d7a273e',
              id: 11,
              frequency: 9404,
            },
            {
              _id: '5d6615769bcb6d0e6d7a273d',
              id: 12,
              frequency: 9237,
            },
            {
              _id: '5d6615769bcb6d0e6d7a273c',
              id: 13,
              frequency: 9829,
            },
            {
              _id: '5d6615769bcb6d0e6d7a273b',
              id: 14,
              frequency: 8041,
            },
            {
              _id: '5d6615769bcb6d0e6d7a273a',
              id: 15,
              frequency: 43210,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2739',
              id: 16,
              frequency: 85078,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2738',
              id: 17,
              frequency: 48355,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2737',
              id: 18,
              frequency: 12120,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2736',
              id: 19,
              frequency: 33505,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2735',
              id: 20,
              frequency: 29711,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2734',
              id: 21,
              frequency: 46699,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2733',
              id: 22,
              frequency: 2378,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2732',
              id: 23,
              frequency: 2111,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2731',
              id: 24,
              frequency: 45663,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2730',
              id: 25,
              frequency: 43468,
            },
            {
              _id: '5d6615769bcb6d0e6d7a272f',
              id: 26,
              frequency: 104447,
            },
            {
              _id: '5d6615769bcb6d0e6d7a272e',
              id: 27,
              frequency: 38274,
            },
            {
              _id: '5d6615769bcb6d0e6d7a272d',
              id: 28,
              frequency: 78509,
            },
            {
              _id: '5d6615769bcb6d0e6d7a272c',
              id: 29,
              frequency: 109799,
            },
            {
              _id: '5d6615769bcb6d0e6d7a272b',
              id: 30,
              frequency: 73296,
            },
            {
              _id: '5d6615769bcb6d0e6d7a272a',
              id: 31,
              frequency: 18621,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2729',
              id: 32,
              frequency: 26573,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2728',
              id: 33,
              frequency: 22212,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2727',
              id: 34,
              frequency: 20905,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2726',
              id: 35,
              frequency: 6799,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2725',
              id: 36,
              frequency: 9962,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2724',
              id: 37,
              frequency: 25460,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2723',
              id: 38,
              frequency: 18217,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2722',
              id: 39,
              frequency: 19269,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2721',
              id: 40,
              frequency: 64948,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2720',
              id: 41,
              frequency: 41428,
            },
            {
              _id: '5d6615769bcb6d0e6d7a271f',
              id: 42,
              frequency: 41868,
            },
            {
              _id: '5d6615769bcb6d0e6d7a271e',
              id: 43,
              frequency: 69214,
            },
            {
              _id: '5d6615769bcb6d0e6d7a271d',
              id: 44,
              frequency: 17720,
            },
            {
              _id: '5d6615769bcb6d0e6d7a271c',
              id: 45,
              frequency: 35700,
            },
            {
              _id: '5d6615769bcb6d0e6d7a271b',
              id: 46,
              frequency: 43492,
            },
            {
              _id: '5d6615769bcb6d0e6d7a271a',
              id: 47,
              frequency: 76054,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2719',
              id: 48,
              frequency: 126896,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2718',
              id: 49,
              frequency: 1615,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2717',
              id: 50,
              frequency: 1214,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2716',
              id: 51,
              frequency: 39556,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2715',
              id: 52,
              frequency: 18893,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2714',
              id: 53,
              frequency: 43770,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2713',
              id: 54,
              frequency: 11475,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2712',
              id: 55,
              frequency: 12508,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2711',
              id: 56,
              frequency: 25294,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2710',
              id: 57,
              frequency: 114807,
            },
            {
              _id: '5d6615769bcb6d0e6d7a270f',
              id: 58,
              frequency: 40624,
            },
            {
              _id: '5d6615769bcb6d0e6d7a270e',
              id: 59,
              frequency: 83119,
            },
            {
              _id: '5d6615769bcb6d0e6d7a270d',
              id: 60,
              frequency: 111180,
            },
            {
              _id: '5d6615769bcb6d0e6d7a270c',
              id: 61,
              frequency: 46338,
            },
            {
              _id: '5d6615769bcb6d0e6d7a270b',
              id: 62,
              frequency: 8554,
            },
            {
              _id: '5d6615769bcb6d0e6d7a270a',
              id: 63,
              frequency: 16852,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2709',
              id: 64,
              frequency: 20076,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2708',
              id: 65,
              frequency: 41915,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2707',
              id: 66,
              frequency: 94935,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2706',
              id: 67,
              frequency: 94228,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2705',
              id: 68,
              frequency: 31511,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2704',
              id: 69,
              frequency: 7741,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2703',
              id: 70,
              frequency: 48664,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2702',
              id: 71,
              frequency: 69639,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2701',
              id: 72,
              frequency: 40021,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a265f',
          id: 15,
          abbrevName: '16',
          fullName: '16_R_SFG_mfg',
          coordinates: {
            x: 26.505051,
            y: 20.808081,
            z: 53.414141,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a2684',
              to: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2683',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2682',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2681',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2680',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a267f',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d7a267e',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a267d',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a267c',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d7a267b',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a267a',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2679',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2678',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2677',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2676',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2675',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2674',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2673',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2672',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2671',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2670',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a266f',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a266e',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a266d',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a266c',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a266b',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a266a',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2669',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2668',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2667',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2666',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2665',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2664',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2663',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2662',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2661',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2660',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a26cd',
              id: 0,
              frequency: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26cc',
              id: 1,
              frequency: 978,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26cb',
              id: 2,
              frequency: 346,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26ca',
              id: 3,
              frequency: 600,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26c9',
              id: 4,
              frequency: 14925,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26c8',
              id: 5,
              frequency: 10251,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26c7',
              id: 6,
              frequency: 2864,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26c6',
              id: 7,
              frequency: 548,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26c5',
              id: 8,
              frequency: 2585,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26c4',
              id: 9,
              frequency: 8781,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26c3',
              id: 10,
              frequency: 12447,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26c2',
              id: 11,
              frequency: 4236,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26c1',
              id: 12,
              frequency: 7093,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26c0',
              id: 13,
              frequency: 4416,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26bf',
              id: 14,
              frequency: 4044,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26be',
              id: 15,
              frequency: 91792,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26bd',
              id: 16,
              frequency: 84773,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26bc',
              id: 17,
              frequency: 40037,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26bb',
              id: 18,
              frequency: 35880,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26ba',
              id: 19,
              frequency: 43061,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26b9',
              id: 20,
              frequency: 17406,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26b8',
              id: 21,
              frequency: 14777,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26b7',
              id: 22,
              frequency: 2159,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26b6',
              id: 23,
              frequency: 149,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26b5',
              id: 24,
              frequency: 90781,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26b4',
              id: 25,
              frequency: 30359,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26b3',
              id: 26,
              frequency: 48943,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26b2',
              id: 27,
              frequency: 98677,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26b1',
              id: 28,
              frequency: 65562,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26b0',
              id: 29,
              frequency: 133337,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26af',
              id: 30,
              frequency: 49365,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26ae',
              id: 31,
              frequency: 17982,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26ad',
              id: 32,
              frequency: 19410,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26ac',
              id: 33,
              frequency: 3912,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26ab',
              id: 34,
              frequency: 29348,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26aa',
              id: 35,
              frequency: 14040,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26a9',
              id: 36,
              frequency: 19134,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26a8',
              id: 37,
              frequency: 21561,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26a7',
              id: 38,
              frequency: 8770,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26a6',
              id: 39,
              frequency: 29641,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26a5',
              id: 40,
              frequency: 44499,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26a4',
              id: 41,
              frequency: 19309,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26a3',
              id: 42,
              frequency: 11241,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26a2',
              id: 43,
              frequency: 64540,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26a1',
              id: 44,
              frequency: 7145,
            },
            {
              _id: '5d6615769bcb6d0e6d7a26a0',
              id: 45,
              frequency: 81017,
            },
            {
              _id: '5d6615769bcb6d0e6d7a269f',
              id: 46,
              frequency: 67466,
            },
            {
              _id: '5d6615769bcb6d0e6d7a269e',
              id: 47,
              frequency: 37930,
            },
            {
              _id: '5d6615769bcb6d0e6d7a269d',
              id: 48,
              frequency: 71797,
            },
            {
              _id: '5d6615769bcb6d0e6d7a269c',
              id: 49,
              frequency: 1491,
            },
            {
              _id: '5d6615769bcb6d0e6d7a269b',
              id: 50,
              frequency: 1427,
            },
            {
              _id: '5d6615769bcb6d0e6d7a269a',
              id: 51,
              frequency: 53593,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2699',
              id: 52,
              frequency: 22869,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2698',
              id: 53,
              frequency: 30117,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2697',
              id: 54,
              frequency: 8647,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2696',
              id: 55,
              frequency: 2807,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2695',
              id: 56,
              frequency: 47134,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2694',
              id: 57,
              frequency: 71041,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2693',
              id: 58,
              frequency: 15425,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2692',
              id: 59,
              frequency: 92438,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2691',
              id: 60,
              frequency: 58001,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2690',
              id: 61,
              frequency: 17732,
            },
            {
              _id: '5d6615769bcb6d0e6d7a268f',
              id: 62,
              frequency: 10311,
            },
            {
              _id: '5d6615769bcb6d0e6d7a268e',
              id: 63,
              frequency: 15925,
            },
            {
              _id: '5d6615769bcb6d0e6d7a268d',
              id: 64,
              frequency: 11263,
            },
            {
              _id: '5d6615769bcb6d0e6d7a268c',
              id: 65,
              frequency: 40414,
            },
            {
              _id: '5d6615769bcb6d0e6d7a268b',
              id: 66,
              frequency: 55345,
            },
            {
              _id: '5d6615769bcb6d0e6d7a268a',
              id: 67,
              frequency: 33051,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2689',
              id: 68,
              frequency: 22289,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2688',
              id: 69,
              frequency: 2271,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2687',
              id: 70,
              frequency: 28709,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2686',
              id: 71,
              frequency: 25372,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2685',
              id: 72,
              frequency: 16646,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a25eb',
          id: 16,
          abbrevName: '17',
          fullName: '17_R_SMG_ant',
          coordinates: {
            x: 23.530686,
            y: -63.574007,
            z: -54.151625,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a2615',
              to: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2614',
              to: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2613',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2612',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2611',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2610',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a260f',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a260e',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d7a260d',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a260c',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a260b',
              to: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d7a260a',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2609',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2608',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2607',
              to: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2606',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2605',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2604',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2603',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2602',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2601',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2600',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25ff',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25fe',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25fd',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25fc',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25fb',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25fa',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25f9',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25f8',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25f7',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25f6',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25f5',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25f4',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25f3',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25f2',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25f1',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25f0',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25ef',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25ee',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25ed',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25ec',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a265e',
              id: 0,
              frequency: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a265d',
              id: 1,
              frequency: 1087,
            },
            {
              _id: '5d6615769bcb6d0e6d7a265c',
              id: 2,
              frequency: 552,
            },
            {
              _id: '5d6615769bcb6d0e6d7a265b',
              id: 3,
              frequency: 774,
            },
            {
              _id: '5d6615769bcb6d0e6d7a265a',
              id: 4,
              frequency: 11248,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2659',
              id: 5,
              frequency: 14040,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2658',
              id: 6,
              frequency: 3838,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2657',
              id: 7,
              frequency: 1508,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2656',
              id: 8,
              frequency: 3854,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2655',
              id: 9,
              frequency: 8026,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2654',
              id: 10,
              frequency: 13677,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2653',
              id: 11,
              frequency: 7917,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2652',
              id: 12,
              frequency: 10006,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2651',
              id: 13,
              frequency: 7242,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2650',
              id: 14,
              frequency: 5433,
            },
            {
              _id: '5d6615769bcb6d0e6d7a264f',
              id: 15,
              frequency: 63139,
            },
            {
              _id: '5d6615769bcb6d0e6d7a264e',
              id: 16,
              frequency: 84900,
            },
            {
              _id: '5d6615769bcb6d0e6d7a264d',
              id: 17,
              frequency: 52799,
            },
            {
              _id: '5d6615769bcb6d0e6d7a264c',
              id: 18,
              frequency: 20886,
            },
            {
              _id: '5d6615769bcb6d0e6d7a264b',
              id: 19,
              frequency: 47226,
            },
            {
              _id: '5d6615769bcb6d0e6d7a264a',
              id: 20,
              frequency: 27704,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2649',
              id: 21,
              frequency: 35436,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2648',
              id: 22,
              frequency: 3195,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2647',
              id: 23,
              frequency: 1158,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2646',
              id: 24,
              frequency: 72059,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2645',
              id: 25,
              frequency: 35280,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2644',
              id: 26,
              frequency: 79180,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2643',
              id: 27,
              frequency: 48994,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2642',
              id: 28,
              frequency: 71192,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2641',
              id: 29,
              frequency: 98116,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2640',
              id: 30,
              frequency: 68495,
            },
            {
              _id: '5d6615769bcb6d0e6d7a263f',
              id: 31,
              frequency: 24264,
            },
            {
              _id: '5d6615769bcb6d0e6d7a263e',
              id: 32,
              frequency: 20875,
            },
            {
              _id: '5d6615769bcb6d0e6d7a263d',
              id: 33,
              frequency: 15494,
            },
            {
              _id: '5d6615769bcb6d0e6d7a263c',
              id: 34,
              frequency: 26832,
            },
            {
              _id: '5d6615769bcb6d0e6d7a263b',
              id: 35,
              frequency: 10710,
            },
            {
              _id: '5d6615769bcb6d0e6d7a263a',
              id: 36,
              frequency: 19269,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2639',
              id: 37,
              frequency: 37357,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2638',
              id: 38,
              frequency: 19610,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2637',
              id: 39,
              frequency: 29600,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2636',
              id: 40,
              frequency: 72952,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2635',
              id: 41,
              frequency: 28767,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2634',
              id: 42,
              frequency: 31234,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2633',
              id: 43,
              frequency: 53688,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2632',
              id: 44,
              frequency: 16007,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2631',
              id: 45,
              frequency: 44914,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2630',
              id: 46,
              frequency: 54093,
            },
            {
              _id: '5d6615769bcb6d0e6d7a262f',
              id: 47,
              frequency: 70535,
            },
            {
              _id: '5d6615769bcb6d0e6d7a262e',
              id: 48,
              frequency: 87562,
            },
            {
              _id: '5d6615769bcb6d0e6d7a262d',
              id: 49,
              frequency: 2799,
            },
            {
              _id: '5d6615769bcb6d0e6d7a262c',
              id: 50,
              frequency: 2767,
            },
            {
              _id: '5d6615769bcb6d0e6d7a262b',
              id: 51,
              frequency: 59343,
            },
            {
              _id: '5d6615769bcb6d0e6d7a262a',
              id: 52,
              frequency: 18001,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2629',
              id: 53,
              frequency: 49964,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2628',
              id: 54,
              frequency: 15626,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2627',
              id: 55,
              frequency: 7038,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2626',
              id: 56,
              frequency: 31069,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2625',
              id: 57,
              frequency: 72062,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2624',
              id: 58,
              frequency: 31668,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2623',
              id: 59,
              frequency: 94899,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2622',
              id: 60,
              frequency: 97142,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2621',
              id: 61,
              frequency: 36488,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2620',
              id: 62,
              frequency: 12595,
            },
            {
              _id: '5d6615769bcb6d0e6d7a261f',
              id: 63,
              frequency: 28902,
            },
            {
              _id: '5d6615769bcb6d0e6d7a261e',
              id: 64,
              frequency: 15629,
            },
            {
              _id: '5d6615769bcb6d0e6d7a261d',
              id: 65,
              frequency: 52507,
            },
            {
              _id: '5d6615769bcb6d0e6d7a261c',
              id: 66,
              frequency: 68543,
            },
            {
              _id: '5d6615769bcb6d0e6d7a261b',
              id: 67,
              frequency: 62469,
            },
            {
              _id: '5d6615769bcb6d0e6d7a261a',
              id: 68,
              frequency: 41392,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2619',
              id: 69,
              frequency: 5437,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2618',
              id: 70,
              frequency: 50798,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2617',
              id: 71,
              frequency: 41424,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2616',
              id: 72,
              frequency: 22308,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a257f',
          id: 17,
          abbrevName: '18',
          fullName: '18_R_Parietal_operuculum_smg_posterior',
          coordinates: {
            x: 58.959184,
            y: -35.183673,
            z: 34.857143,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a25a1',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25a0',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a259f',
              to: 19,
            },
            {
              _id: '5d6615769bcb6d0e6d7a259e',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a259d',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d7a259c',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a259b',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a259a',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2599',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2598',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2597',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2596',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2595',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2594',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2593',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2592',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2591',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2590',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a258f',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a258e',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a258d',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a258c',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a258b',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a258a',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2589',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2588',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2587',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2586',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2585',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2584',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2583',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2582',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2581',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2580',
              to: 63,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a25ea',
              id: 0,
              frequency: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25e9',
              id: 1,
              frequency: 978,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25e8',
              id: 2,
              frequency: 281,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25e7',
              id: 3,
              frequency: 622,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25e6',
              id: 4,
              frequency: 13509,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25e5',
              id: 5,
              frequency: 8400,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25e4',
              id: 6,
              frequency: 3614,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25e3',
              id: 7,
              frequency: 227,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25e2',
              id: 8,
              frequency: 2295,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25e1',
              id: 9,
              frequency: 8727,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25e0',
              id: 10,
              frequency: 12794,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25df',
              id: 11,
              frequency: 3254,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25de',
              id: 12,
              frequency: 7646,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25dd',
              id: 13,
              frequency: 4332,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25dc',
              id: 14,
              frequency: 4528,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25db',
              id: 15,
              frequency: 95407,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25da',
              id: 16,
              frequency: 64981,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25d9',
              id: 17,
              frequency: 30992,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25d8',
              id: 18,
              frequency: 36757,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25d7',
              id: 19,
              frequency: 48949,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25d6',
              id: 20,
              frequency: 19558,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25d5',
              id: 21,
              frequency: 5410,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25d4',
              id: 22,
              frequency: 3517,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25d3',
              id: 23,
              frequency: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25d2',
              id: 24,
              frequency: 91272,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25d1',
              id: 25,
              frequency: 29481,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25d0',
              id: 26,
              frequency: 33905,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25cf',
              id: 27,
              frequency: 77259,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25ce',
              id: 28,
              frequency: 54741,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25cd',
              id: 29,
              frequency: 131123,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25cc',
              id: 30,
              frequency: 37181,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25cb',
              id: 31,
              frequency: 29451,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25ca',
              id: 32,
              frequency: 23775,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25c9',
              id: 33,
              frequency: 1208,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25c8',
              id: 34,
              frequency: 21887,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25c7',
              id: 35,
              frequency: 13476,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25c6',
              id: 36,
              frequency: 13729,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25c5',
              id: 37,
              frequency: 24365,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25c4',
              id: 38,
              frequency: 4380,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25c3',
              id: 39,
              frequency: 37231,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25c2',
              id: 40,
              frequency: 58454,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25c1',
              id: 41,
              frequency: 16919,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25c0',
              id: 42,
              frequency: 4999,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25bf',
              id: 43,
              frequency: 67381,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25be',
              id: 44,
              frequency: 5149,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25bd',
              id: 45,
              frequency: 64657,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25bc',
              id: 46,
              frequency: 62866,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25bb',
              id: 47,
              frequency: 30035,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25ba',
              id: 48,
              frequency: 69126,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25b9',
              id: 49,
              frequency: 2323,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25b8',
              id: 50,
              frequency: 599,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25b7',
              id: 51,
              frequency: 41392,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25b6',
              id: 52,
              frequency: 20244,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25b5',
              id: 53,
              frequency: 27692,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25b4',
              id: 54,
              frequency: 10495,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25b3',
              id: 55,
              frequency: 1597,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25b2',
              id: 56,
              frequency: 43801,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25b1',
              id: 57,
              frequency: 75876,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25b0',
              id: 58,
              frequency: 11636,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25af',
              id: 59,
              frequency: 92430,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25ae',
              id: 60,
              frequency: 59665,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25ad',
              id: 61,
              frequency: 14674,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25ac',
              id: 62,
              frequency: 10487,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25ab',
              id: 63,
              frequency: 12744,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25aa',
              id: 64,
              frequency: 12616,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25a9',
              id: 65,
              frequency: 44808,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25a8',
              id: 66,
              frequency: 61672,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25a7',
              id: 67,
              frequency: 32894,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25a6',
              id: 68,
              frequency: 22122,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25a5',
              id: 69,
              frequency: 2967,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25a4',
              id: 70,
              frequency: 35042,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25a3',
              id: 71,
              frequency: 28243,
            },
            {
              _id: '5d6615769bcb6d0e6d7a25a2',
              id: 72,
              frequency: 20026,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a2507',
          id: 18,
          abbrevName: '19',
          fullName: '19_L_Cerebellum_anterior',
          coordinates: {
            x: -19.05098,
            y: -45.639216,
            z: -37.929412,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a2535',
              to: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2534',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2533',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2532',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2531',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2530',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a252f',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a252e',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d7a252d',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a252c',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a252b',
              to: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d7a252a',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2529',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2528',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2527',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2526',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2525',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2524',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2523',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2522',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2521',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2520',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a251f',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a251e',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a251d',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a251c',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a251b',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a251a',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2519',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2518',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2517',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2516',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2515',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2514',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2513',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2512',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2511',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2510',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a250f',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a250e',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a250d',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a250c',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a250b',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a250a',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2509',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2508',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a257e',
              id: 0,
              frequency: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a257d',
              id: 1,
              frequency: 1004,
            },
            {
              _id: '5d6615769bcb6d0e6d7a257c',
              id: 2,
              frequency: 644,
            },
            {
              _id: '5d6615769bcb6d0e6d7a257b',
              id: 3,
              frequency: 1009,
            },
            {
              _id: '5d6615769bcb6d0e6d7a257a',
              id: 4,
              frequency: 8485,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2579',
              id: 5,
              frequency: 14483,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2578',
              id: 6,
              frequency: 2988,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2577',
              id: 7,
              frequency: 1641,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2576',
              id: 8,
              frequency: 3441,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2575',
              id: 9,
              frequency: 6384,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2574',
              id: 10,
              frequency: 16015,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2573',
              id: 11,
              frequency: 10052,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2572',
              id: 12,
              frequency: 9924,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2571',
              id: 13,
              frequency: 11037,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2570',
              id: 14,
              frequency: 8126,
            },
            {
              _id: '5d6615769bcb6d0e6d7a256f',
              id: 15,
              frequency: 34553,
            },
            {
              _id: '5d6615769bcb6d0e6d7a256e',
              id: 16,
              frequency: 70490,
            },
            {
              _id: '5d6615769bcb6d0e6d7a256d',
              id: 17,
              frequency: 47982,
            },
            {
              _id: '5d6615769bcb6d0e6d7a256c',
              id: 18,
              frequency: 14374,
            },
            {
              _id: '5d6615769bcb6d0e6d7a256b',
              id: 19,
              frequency: 33068,
            },
            {
              _id: '5d6615769bcb6d0e6d7a256a',
              id: 20,
              frequency: 27167,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2569',
              id: 21,
              frequency: 34478,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2568',
              id: 22,
              frequency: 2120,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2567',
              id: 23,
              frequency: 1121,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2566',
              id: 24,
              frequency: 43417,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2565',
              id: 25,
              frequency: 37420,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2564',
              id: 26,
              frequency: 90236,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2563',
              id: 27,
              frequency: 31918,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2562',
              id: 28,
              frequency: 67465,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2561',
              id: 29,
              frequency: 98085,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2560',
              id: 30,
              frequency: 81588,
            },
            {
              _id: '5d6615769bcb6d0e6d7a255f',
              id: 31,
              frequency: 17589,
            },
            {
              _id: '5d6615769bcb6d0e6d7a255e',
              id: 32,
              frequency: 23473,
            },
            {
              _id: '5d6615769bcb6d0e6d7a255d',
              id: 33,
              frequency: 16886,
            },
            {
              _id: '5d6615769bcb6d0e6d7a255c',
              id: 34,
              frequency: 21390,
            },
            {
              _id: '5d6615769bcb6d0e6d7a255b',
              id: 35,
              frequency: 4911,
            },
            {
              _id: '5d6615769bcb6d0e6d7a255a',
              id: 36,
              frequency: 12786,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2559',
              id: 37,
              frequency: 28904,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2558',
              id: 38,
              frequency: 18065,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2557',
              id: 39,
              frequency: 18223,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2556',
              id: 40,
              frequency: 62858,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2555',
              id: 41,
              frequency: 39459,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2554',
              id: 42,
              frequency: 40155,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2553',
              id: 43,
              frequency: 57975,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2552',
              id: 44,
              frequency: 20973,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2551',
              id: 45,
              frequency: 29344,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2550',
              id: 46,
              frequency: 43809,
            },
            {
              _id: '5d6615769bcb6d0e6d7a254f',
              id: 47,
              frequency: 74273,
            },
            {
              _id: '5d6615769bcb6d0e6d7a254e',
              id: 48,
              frequency: 126274,
            },
            {
              _id: '5d6615769bcb6d0e6d7a254d',
              id: 49,
              frequency: 1973,
            },
            {
              _id: '5d6615769bcb6d0e6d7a254c',
              id: 50,
              frequency: 2061,
            },
            {
              _id: '5d6615769bcb6d0e6d7a254b',
              id: 51,
              frequency: 45888,
            },
            {
              _id: '5d6615769bcb6d0e6d7a254a',
              id: 52,
              frequency: 15853,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2549',
              id: 53,
              frequency: 55614,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2548',
              id: 54,
              frequency: 11984,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2547',
              id: 55,
              frequency: 11844,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2546',
              id: 56,
              frequency: 22257,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2545',
              id: 57,
              frequency: 103438,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2544',
              id: 58,
              frequency: 41997,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2543',
              id: 59,
              frequency: 81506,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2542',
              id: 60,
              frequency: 122116,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2541',
              id: 61,
              frequency: 61347,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2540',
              id: 62,
              frequency: 10229,
            },
            {
              _id: '5d6615769bcb6d0e6d7a253f',
              id: 63,
              frequency: 25273,
            },
            {
              _id: '5d6615769bcb6d0e6d7a253e',
              id: 64,
              frequency: 20385,
            },
            {
              _id: '5d6615769bcb6d0e6d7a253d',
              id: 65,
              frequency: 45298,
            },
            {
              _id: '5d6615769bcb6d0e6d7a253c',
              id: 66,
              frequency: 88018,
            },
            {
              _id: '5d6615769bcb6d0e6d7a253b',
              id: 67,
              frequency: 106201,
            },
            {
              _id: '5d6615769bcb6d0e6d7a253a',
              id: 68,
              frequency: 41903,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2539',
              id: 69,
              frequency: 11488,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2538',
              id: 70,
              frequency: 54086,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2537',
              id: 71,
              frequency: 75150,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2536',
              id: 72,
              frequency: 37108,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a2497',
          id: 19,
          abbrevName: '20',
          fullName: '20_R_Frontal_pole',
          coordinates: {
            x: 36.891304,
            y: 42.76087,
            z: -12.956522,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a24bd',
              to: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24bc',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24bb',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24ba',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24b9',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24b8',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24b7',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24b6',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24b5',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24b4',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24b3',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24b2',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24b1',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24b0',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24af',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24ae',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24ad',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24ac',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24ab',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24aa',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24a9',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24a8',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24a7',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24a6',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24a5',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24a4',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24a3',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24a2',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24a1',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24a0',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a249f',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a249e',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a249d',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a249c',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a249b',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a249a',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2499',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2498',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a2506',
              id: 0,
              frequency: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2505',
              id: 1,
              frequency: 1033,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2504',
              id: 2,
              frequency: 374,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2503',
              id: 3,
              frequency: 754,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2502',
              id: 4,
              frequency: 10943,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2501',
              id: 5,
              frequency: 11088,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2500',
              id: 6,
              frequency: 4083,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24ff',
              id: 7,
              frequency: 482,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24fe',
              id: 8,
              frequency: 2438,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24fd',
              id: 9,
              frequency: 8372,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24fc',
              id: 10,
              frequency: 15615,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24fb',
              id: 11,
              frequency: 4721,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24fa',
              id: 12,
              frequency: 8486,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24f9',
              id: 13,
              frequency: 6316,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24f8',
              id: 14,
              frequency: 5777,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24f7',
              id: 15,
              frequency: 63568,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24f6',
              id: 16,
              frequency: 63331,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24f5',
              id: 17,
              frequency: 45485,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24f4',
              id: 18,
              frequency: 23549,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24f3',
              id: 19,
              frequency: 47873,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24f2',
              id: 20,
              frequency: 28921,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24f1',
              id: 21,
              frequency: 12545,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24f0',
              id: 22,
              frequency: 4668,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24ef',
              id: 23,
              frequency: 127,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24ee',
              id: 24,
              frequency: 68189,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24ed',
              id: 25,
              frequency: 43240,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24ec',
              id: 26,
              frequency: 53283,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24eb',
              id: 27,
              frequency: 53518,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24ea',
              id: 28,
              frequency: 68653,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24e9',
              id: 29,
              frequency: 116566,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24e8',
              id: 30,
              frequency: 53722,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24e7',
              id: 31,
              frequency: 30408,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24e6',
              id: 32,
              frequency: 31973,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24e5',
              id: 33,
              frequency: 3104,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24e4',
              id: 34,
              frequency: 22065,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24e3',
              id: 35,
              frequency: 9721,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24e2',
              id: 36,
              frequency: 10308,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24e1',
              id: 37,
              frequency: 28360,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24e0',
              id: 38,
              frequency: 7583,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24df',
              id: 39,
              frequency: 33463,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24de',
              id: 40,
              frequency: 70531,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24dd',
              id: 41,
              frequency: 26952,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24dc',
              id: 42,
              frequency: 11373,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24db',
              id: 43,
              frequency: 77479,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24da',
              id: 44,
              frequency: 7540,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24d9',
              id: 45,
              frequency: 46223,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24d8',
              id: 46,
              frequency: 47216,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24d7',
              id: 47,
              frequency: 43482,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24d6',
              id: 48,
              frequency: 100991,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24d5',
              id: 49,
              frequency: 2051,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24d4',
              id: 50,
              frequency: 700,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24d3',
              id: 51,
              frequency: 41291,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24d2',
              id: 52,
              frequency: 20500,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24d1',
              id: 53,
              frequency: 34368,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24d0',
              id: 54,
              frequency: 14007,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24cf',
              id: 55,
              frequency: 3601,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24ce',
              id: 56,
              frequency: 40043,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24cd',
              id: 57,
              frequency: 99288,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24cc',
              id: 58,
              frequency: 17363,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24cb',
              id: 59,
              frequency: 92955,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24ca',
              id: 60,
              frequency: 86742,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24c9',
              id: 61,
              frequency: 25030,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24c8',
              id: 62,
              frequency: 9798,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24c7',
              id: 63,
              frequency: 13006,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24c6',
              id: 64,
              frequency: 15839,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24c5',
              id: 65,
              frequency: 46755,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24c4',
              id: 66,
              frequency: 79374,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24c3',
              id: 67,
              frequency: 51182,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24c2',
              id: 68,
              frequency: 26246,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24c1',
              id: 69,
              frequency: 5512,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24c0',
              id: 70,
              frequency: 38420,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24bf',
              id: 71,
              frequency: 43786,
            },
            {
              _id: '5d6615769bcb6d0e6d7a24be',
              id: 72,
              frequency: 25962,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a242c',
          id: 20,
          abbrevName: '21',
          fullName: '21_R_Precuneous_lingual',
          coordinates: {
            x: 13.379845,
            y: -59.348837,
            z: 9.534884,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a244d',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a244c',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a244b',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a244a',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2449',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2448',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2447',
              to: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2446',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2445',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2444',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2443',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2442',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2441',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2440',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d7a243f',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a243e',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a243d',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a243c',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a243b',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a243a',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2439',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2438',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2437',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2436',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2435',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2434',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2433',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2432',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2431',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2430',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a242f',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a242e',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a242d',
              to: 61,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a2496',
              id: 0,
              frequency: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2495',
              id: 1,
              frequency: 1062,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2494',
              id: 2,
              frequency: 268,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2493',
              id: 3,
              frequency: 593,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2492',
              id: 4,
              frequency: 12614,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2491',
              id: 5,
              frequency: 8822,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2490',
              id: 6,
              frequency: 5162,
            },
            {
              _id: '5d6615769bcb6d0e6d7a248f',
              id: 7,
              frequency: 328,
            },
            {
              _id: '5d6615769bcb6d0e6d7a248e',
              id: 8,
              frequency: 2088,
            },
            {
              _id: '5d6615769bcb6d0e6d7a248d',
              id: 9,
              frequency: 8963,
            },
            {
              _id: '5d6615769bcb6d0e6d7a248c',
              id: 10,
              frequency: 13602,
            },
            {
              _id: '5d6615769bcb6d0e6d7a248b',
              id: 11,
              frequency: 2969,
            },
            {
              _id: '5d6615769bcb6d0e6d7a248a',
              id: 12,
              frequency: 8471,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2489',
              id: 13,
              frequency: 3798,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2488',
              id: 14,
              frequency: 4385,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2487',
              id: 15,
              frequency: 85799,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2486',
              id: 16,
              frequency: 57987,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2485',
              id: 17,
              frequency: 45842,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2484',
              id: 18,
              frequency: 26849,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2483',
              id: 19,
              frequency: 73540,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2482',
              id: 20,
              frequency: 24507,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2481',
              id: 21,
              frequency: 9551,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2480',
              id: 22,
              frequency: 7266,
            },
            {
              _id: '5d6615769bcb6d0e6d7a247f',
              id: 23,
              frequency: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d7a247e',
              id: 24,
              frequency: 88974,
            },
            {
              _id: '5d6615769bcb6d0e6d7a247d',
              id: 25,
              frequency: 47043,
            },
            {
              _id: '5d6615769bcb6d0e6d7a247c',
              id: 26,
              frequency: 36213,
            },
            {
              _id: '5d6615769bcb6d0e6d7a247b',
              id: 27,
              frequency: 62422,
            },
            {
              _id: '5d6615769bcb6d0e6d7a247a',
              id: 28,
              frequency: 53373,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2479',
              id: 29,
              frequency: 107243,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2478',
              id: 30,
              frequency: 35489,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2477',
              id: 31,
              frequency: 42070,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2476',
              id: 32,
              frequency: 32224,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2475',
              id: 33,
              frequency: 2198,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2474',
              id: 34,
              frequency: 21019,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2473',
              id: 35,
              frequency: 16223,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2472',
              id: 36,
              frequency: 10597,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2471',
              id: 37,
              frequency: 28285,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2470',
              id: 38,
              frequency: 5886,
            },
            {
              _id: '5d6615769bcb6d0e6d7a246f',
              id: 39,
              frequency: 40944,
            },
            {
              _id: '5d6615769bcb6d0e6d7a246e',
              id: 40,
              frequency: 86374,
            },
            {
              _id: '5d6615769bcb6d0e6d7a246d',
              id: 41,
              frequency: 19205,
            },
            {
              _id: '5d6615769bcb6d0e6d7a246c',
              id: 42,
              frequency: 6271,
            },
            {
              _id: '5d6615769bcb6d0e6d7a246b',
              id: 43,
              frequency: 65262,
            },
            {
              _id: '5d6615769bcb6d0e6d7a246a',
              id: 44,
              frequency: 4064,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2469',
              id: 45,
              frequency: 57786,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2468',
              id: 46,
              frequency: 54990,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2467',
              id: 47,
              frequency: 33376,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2466',
              id: 48,
              frequency: 63003,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2465',
              id: 49,
              frequency: 2264,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2464',
              id: 50,
              frequency: 542,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2463',
              id: 51,
              frequency: 38066,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2462',
              id: 52,
              frequency: 21044,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2461',
              id: 53,
              frequency: 23573,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2460',
              id: 54,
              frequency: 17862,
            },
            {
              _id: '5d6615769bcb6d0e6d7a245f',
              id: 55,
              frequency: 2017,
            },
            {
              _id: '5d6615769bcb6d0e6d7a245e',
              id: 56,
              frequency: 39563,
            },
            {
              _id: '5d6615769bcb6d0e6d7a245d',
              id: 57,
              frequency: 80837,
            },
            {
              _id: '5d6615769bcb6d0e6d7a245c',
              id: 58,
              frequency: 10439,
            },
            {
              _id: '5d6615769bcb6d0e6d7a245b',
              id: 59,
              frequency: 98578,
            },
            {
              _id: '5d6615769bcb6d0e6d7a245a',
              id: 60,
              frequency: 61487,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2459',
              id: 61,
              frequency: 11359,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2458',
              id: 62,
              frequency: 8042,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2457',
              id: 63,
              frequency: 10231,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2456',
              id: 64,
              frequency: 10996,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2455',
              id: 65,
              frequency: 48060,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2454',
              id: 66,
              frequency: 68864,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2453',
              id: 67,
              frequency: 28562,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2452',
              id: 68,
              frequency: 20977,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2451',
              id: 69,
              frequency: 1590,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2450',
              id: 70,
              frequency: 40976,
            },
            {
              _id: '5d6615769bcb6d0e6d7a244f',
              id: 71,
              frequency: 24799,
            },
            {
              _id: '5d6615769bcb6d0e6d7a244e',
              id: 72,
              frequency: 20604,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a23bd',
          id: 21,
          abbrevName: '22',
          fullName: '22_L_Thalamus',
          coordinates: {
            x: -10.568421,
            y: -18.315789,
            z: 7.284211,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a23e2',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23e1',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23e0',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23df',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23de',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23dd',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23dc',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23db',
              to: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23da',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23d9',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23d8',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23d7',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23d6',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23d5',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23d4',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23d3',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23d2',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23d1',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23d0',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23cf',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23ce',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23cd',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23cc',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23cb',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23ca',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23c9',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23c8',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23c7',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23c6',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23c5',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23c4',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23c3',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23c2',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23c1',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23c0',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23bf',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23be',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a242b',
              id: 0,
              frequency: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a242a',
              id: 1,
              frequency: 1095,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2429',
              id: 2,
              frequency: 570,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2428',
              id: 3,
              frequency: 808,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2427',
              id: 4,
              frequency: 10128,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2426',
              id: 5,
              frequency: 14626,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2425',
              id: 6,
              frequency: 4068,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2424',
              id: 7,
              frequency: 1540,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2423',
              id: 8,
              frequency: 3987,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2422',
              id: 9,
              frequency: 8130,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2421',
              id: 10,
              frequency: 14748,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2420',
              id: 11,
              frequency: 8235,
            },
            {
              _id: '5d6615769bcb6d0e6d7a241f',
              id: 12,
              frequency: 9796,
            },
            {
              _id: '5d6615769bcb6d0e6d7a241e',
              id: 13,
              frequency: 7980,
            },
            {
              _id: '5d6615769bcb6d0e6d7a241d',
              id: 14,
              frequency: 5671,
            },
            {
              _id: '5d6615769bcb6d0e6d7a241c',
              id: 15,
              frequency: 46715,
            },
            {
              _id: '5d6615769bcb6d0e6d7a241b',
              id: 16,
              frequency: 74083,
            },
            {
              _id: '5d6615769bcb6d0e6d7a241a',
              id: 17,
              frequency: 54747,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2419',
              id: 18,
              frequency: 16533,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2418',
              id: 19,
              frequency: 46487,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2417',
              id: 20,
              frequency: 31046,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2416',
              id: 21,
              frequency: 35605,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2415',
              id: 22,
              frequency: 4349,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2414',
              id: 23,
              frequency: 1294,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2413',
              id: 24,
              frequency: 56160,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2412',
              id: 25,
              frequency: 38099,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2411',
              id: 26,
              frequency: 83918,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2410',
              id: 27,
              frequency: 44745,
            },
            {
              _id: '5d6615769bcb6d0e6d7a240f',
              id: 28,
              frequency: 77682,
            },
            {
              _id: '5d6615769bcb6d0e6d7a240e',
              id: 29,
              frequency: 92796,
            },
            {
              _id: '5d6615769bcb6d0e6d7a240d',
              id: 30,
              frequency: 73045,
            },
            {
              _id: '5d6615769bcb6d0e6d7a240c',
              id: 31,
              frequency: 28063,
            },
            {
              _id: '5d6615769bcb6d0e6d7a240b',
              id: 32,
              frequency: 25950,
            },
            {
              _id: '5d6615769bcb6d0e6d7a240a',
              id: 33,
              frequency: 15396,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2409',
              id: 34,
              frequency: 24988,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2408',
              id: 35,
              frequency: 8410,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2407',
              id: 36,
              frequency: 15475,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2406',
              id: 37,
              frequency: 40093,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2405',
              id: 38,
              frequency: 21153,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2404',
              id: 39,
              frequency: 28157,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2403',
              id: 40,
              frequency: 74481,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2402',
              id: 41,
              frequency: 30992,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2401',
              id: 42,
              frequency: 32586,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2400',
              id: 43,
              frequency: 61069,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23ff',
              id: 44,
              frequency: 17028,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23fe',
              id: 45,
              frequency: 39597,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23fd',
              id: 46,
              frequency: 46115,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23fc',
              id: 47,
              frequency: 70839,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23fb',
              id: 48,
              frequency: 101095,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23fa',
              id: 49,
              frequency: 3532,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23f9',
              id: 50,
              frequency: 2630,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23f8',
              id: 51,
              frequency: 59811,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23f7',
              id: 52,
              frequency: 16601,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23f6',
              id: 53,
              frequency: 56247,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23f5',
              id: 54,
              frequency: 16451,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23f4',
              id: 55,
              frequency: 8446,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23f3',
              id: 56,
              frequency: 35340,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23f2',
              id: 57,
              frequency: 80321,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23f1',
              id: 58,
              frequency: 31211,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23f0',
              id: 59,
              frequency: 93608,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23ef',
              id: 60,
              frequency: 103382,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23ee',
              id: 61,
              frequency: 41801,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23ed',
              id: 62,
              frequency: 13504,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23ec',
              id: 63,
              frequency: 28723,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23eb',
              id: 64,
              frequency: 18515,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23ea',
              id: 65,
              frequency: 51791,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23e9',
              id: 66,
              frequency: 73925,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23e8',
              id: 67,
              frequency: 70439,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23e7',
              id: 68,
              frequency: 42086,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23e6',
              id: 69,
              frequency: 6193,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23e5',
              id: 70,
              frequency: 46185,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23e4',
              id: 71,
              frequency: 45912,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23e3',
              id: 72,
              frequency: 22519,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a2350',
          id: 22,
          abbrevName: '23',
          fullName: '23_L_SFG_anterior',
          coordinates: {
            x: -57.193133,
            y: -37.450644,
            z: 35.896996,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a2373',
              to: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2372',
              to: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2371',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2370',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d7a236f',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a236e',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a236d',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a236c',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a236b',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a236a',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2369',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2368',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2367',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2366',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2365',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2364',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2363',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2362',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2361',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2360',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a235f',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a235e',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a235d',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a235c',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a235b',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a235a',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2359',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2358',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2357',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2356',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2355',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2354',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2353',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2352',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2351',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a23bc',
              id: 0,
              frequency: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23bb',
              id: 1,
              frequency: 970,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23ba',
              id: 2,
              frequency: 302,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23b9',
              id: 3,
              frequency: 688,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23b8',
              id: 4,
              frequency: 13530,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23b7',
              id: 5,
              frequency: 9044,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23b6',
              id: 6,
              frequency: 3258,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23b5',
              id: 7,
              frequency: 218,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23b4',
              id: 8,
              frequency: 1904,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23b3',
              id: 9,
              frequency: 8039,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23b2',
              id: 10,
              frequency: 13676,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23b1',
              id: 11,
              frequency: 3597,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23b0',
              id: 12,
              frequency: 8076,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23af',
              id: 13,
              frequency: 5138,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23ae',
              id: 14,
              frequency: 5237,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23ad',
              id: 15,
              frequency: 88687,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23ac',
              id: 16,
              frequency: 71560,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23ab',
              id: 17,
              frequency: 34960,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23aa',
              id: 18,
              frequency: 36202,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23a9',
              id: 19,
              frequency: 45340,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23a8',
              id: 20,
              frequency: 18971,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23a7',
              id: 21,
              frequency: 5468,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23a6',
              id: 22,
              frequency: 3126,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23a5',
              id: 23,
              frequency: 8,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23a4',
              id: 24,
              frequency: 85684,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23a3',
              id: 25,
              frequency: 33111,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23a2',
              id: 26,
              frequency: 37686,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23a1',
              id: 27,
              frequency: 77670,
            },
            {
              _id: '5d6615769bcb6d0e6d7a23a0',
              id: 28,
              frequency: 56520,
            },
            {
              _id: '5d6615769bcb6d0e6d7a239f',
              id: 29,
              frequency: 135530,
            },
            {
              _id: '5d6615769bcb6d0e6d7a239e',
              id: 30,
              frequency: 42865,
            },
            {
              _id: '5d6615769bcb6d0e6d7a239d',
              id: 31,
              frequency: 22528,
            },
            {
              _id: '5d6615769bcb6d0e6d7a239c',
              id: 32,
              frequency: 23289,
            },
            {
              _id: '5d6615769bcb6d0e6d7a239b',
              id: 33,
              frequency: 1031,
            },
            {
              _id: '5d6615769bcb6d0e6d7a239a',
              id: 34,
              frequency: 24896,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2399',
              id: 35,
              frequency: 12953,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2398',
              id: 36,
              frequency: 12466,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2397',
              id: 37,
              frequency: 20148,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2396',
              id: 38,
              frequency: 3918,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2395',
              id: 39,
              frequency: 30078,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2394',
              id: 40,
              frequency: 57882,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2393',
              id: 41,
              frequency: 21444,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2392',
              id: 42,
              frequency: 5301,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2391',
              id: 43,
              frequency: 65728,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2390',
              id: 44,
              frequency: 5795,
            },
            {
              _id: '5d6615769bcb6d0e6d7a238f',
              id: 45,
              frequency: 64059,
            },
            {
              _id: '5d6615769bcb6d0e6d7a238e',
              id: 46,
              frequency: 68800,
            },
            {
              _id: '5d6615769bcb6d0e6d7a238d',
              id: 47,
              frequency: 35155,
            },
            {
              _id: '5d6615769bcb6d0e6d7a238c',
              id: 48,
              frequency: 80991,
            },
            {
              _id: '5d6615769bcb6d0e6d7a238b',
              id: 49,
              frequency: 1309,
            },
            {
              _id: '5d6615769bcb6d0e6d7a238a',
              id: 50,
              frequency: 315,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2389',
              id: 51,
              frequency: 35054,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2388',
              id: 52,
              frequency: 23161,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2387',
              id: 53,
              frequency: 24466,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2386',
              id: 54,
              frequency: 10222,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2385',
              id: 55,
              frequency: 1761,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2384',
              id: 56,
              frequency: 37496,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2383',
              id: 57,
              frequency: 85485,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2382',
              id: 58,
              frequency: 12874,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2381',
              id: 59,
              frequency: 94530,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2380',
              id: 60,
              frequency: 70937,
            },
            {
              _id: '5d6615769bcb6d0e6d7a237f',
              id: 61,
              frequency: 18108,
            },
            {
              _id: '5d6615769bcb6d0e6d7a237e',
              id: 62,
              frequency: 6734,
            },
            {
              _id: '5d6615769bcb6d0e6d7a237d',
              id: 63,
              frequency: 9392,
            },
            {
              _id: '5d6615769bcb6d0e6d7a237c',
              id: 64,
              frequency: 11547,
            },
            {
              _id: '5d6615769bcb6d0e6d7a237b',
              id: 65,
              frequency: 44208,
            },
            {
              _id: '5d6615769bcb6d0e6d7a237a',
              id: 66,
              frequency: 68518,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2379',
              id: 67,
              frequency: 40392,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2378',
              id: 68,
              frequency: 22212,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2377',
              id: 69,
              frequency: 4115,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2376',
              id: 70,
              frequency: 39614,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2375',
              id: 71,
              frequency: 35876,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2374',
              id: 72,
              frequency: 23734,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a22ce',
          id: 23,
          abbrevName: '24',
          fullName: '24_R_MTG_mtg_posterior',
          coordinates: {
            x: 61.072961,
            y: -29.914163,
            z: 0.995708,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a2306',
              to: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2305',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2304',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2303',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2302',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2301',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2300',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22ff',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22fe',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22fd',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22fc',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22fb',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22fa',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22f9',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22f8',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22f7',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22f6',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22f5',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22f4',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22f3',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22f2',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22f1',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22f0',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22ef',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22ee',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22ed',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22ec',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22eb',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22ea',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22e9',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22e8',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22e7',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22e6',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22e5',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22e4',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22e3',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22e2',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22e1',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22e0',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22df',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22de',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22dd',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22dc',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22db',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22da',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22d9',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22d8',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22d7',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22d6',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22d5',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22d4',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22d3',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22d2',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22d1',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22d0',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22cf',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a234f',
              id: 0,
              frequency: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a234e',
              id: 1,
              frequency: 788,
            },
            {
              _id: '5d6615769bcb6d0e6d7a234d',
              id: 2,
              frequency: 984,
            },
            {
              _id: '5d6615769bcb6d0e6d7a234c',
              id: 3,
              frequency: 1431,
            },
            {
              _id: '5d6615769bcb6d0e6d7a234b',
              id: 4,
              frequency: 4718,
            },
            {
              _id: '5d6615769bcb6d0e6d7a234a',
              id: 5,
              frequency: 15092,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2349',
              id: 6,
              frequency: 1761,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2348',
              id: 7,
              frequency: 3130,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2347',
              id: 8,
              frequency: 3588,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2346',
              id: 9,
              frequency: 3251,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2345',
              id: 10,
              frequency: 15764,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2344',
              id: 11,
              frequency: 19906,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2343',
              id: 12,
              frequency: 8170,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2342',
              id: 13,
              frequency: 17710,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2341',
              id: 14,
              frequency: 13994,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2340',
              id: 15,
              frequency: 14182,
            },
            {
              _id: '5d6615769bcb6d0e6d7a233f',
              id: 16,
              frequency: 51480,
            },
            {
              _id: '5d6615769bcb6d0e6d7a233e',
              id: 17,
              frequency: 28478,
            },
            {
              _id: '5d6615769bcb6d0e6d7a233d',
              id: 18,
              frequency: 5726,
            },
            {
              _id: '5d6615769bcb6d0e6d7a233c',
              id: 19,
              frequency: 11605,
            },
            {
              _id: '5d6615769bcb6d0e6d7a233b',
              id: 20,
              frequency: 25674,
            },
            {
              _id: '5d6615769bcb6d0e6d7a233a',
              id: 21,
              frequency: 43158,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2339',
              id: 22,
              frequency: 1348,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2338',
              id: 23,
              frequency: 2153,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2337',
              id: 24,
              frequency: 14712,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2336',
              id: 25,
              frequency: 22518,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2335',
              id: 26,
              frequency: 122618,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2334',
              id: 27,
              frequency: 11700,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2333',
              id: 28,
              frequency: 45609,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2332',
              id: 29,
              frequency: 67749,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2331',
              id: 30,
              frequency: 120514,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2330',
              id: 31,
              frequency: 7049,
            },
            {
              _id: '5d6615769bcb6d0e6d7a232f',
              id: 32,
              frequency: 20288,
            },
            {
              _id: '5d6615769bcb6d0e6d7a232e',
              id: 33,
              frequency: 42111,
            },
            {
              _id: '5d6615769bcb6d0e6d7a232d',
              id: 34,
              frequency: 15243,
            },
            {
              _id: '5d6615769bcb6d0e6d7a232c',
              id: 35,
              frequency: 2106,
            },
            {
              _id: '5d6615769bcb6d0e6d7a232b',
              id: 36,
              frequency: 9770,
            },
            {
              _id: '5d6615769bcb6d0e6d7a232a',
              id: 37,
              frequency: 20891,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2329',
              id: 38,
              frequency: 25949,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2328',
              id: 39,
              frequency: 7067,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2327',
              id: 40,
              frequency: 37702,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2326',
              id: 41,
              frequency: 46114,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2325',
              id: 42,
              frequency: 95111,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2324',
              id: 43,
              frequency: 37855,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2323',
              id: 44,
              frequency: 63245,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2322',
              id: 45,
              frequency: 9974,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2321',
              id: 46,
              frequency: 27466,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2320',
              id: 47,
              frequency: 88369,
            },
            {
              _id: '5d6615769bcb6d0e6d7a231f',
              id: 48,
              frequency: 150577,
            },
            {
              _id: '5d6615769bcb6d0e6d7a231e',
              id: 49,
              frequency: 1478,
            },
            {
              _id: '5d6615769bcb6d0e6d7a231d',
              id: 50,
              frequency: 3131,
            },
            {
              _id: '5d6615769bcb6d0e6d7a231c',
              id: 51,
              frequency: 31158,
            },
            {
              _id: '5d6615769bcb6d0e6d7a231b',
              id: 52,
              frequency: 10667,
            },
            {
              _id: '5d6615769bcb6d0e6d7a231a',
              id: 53,
              frequency: 77582,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2319',
              id: 54,
              frequency: 6999,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2318',
              id: 55,
              frequency: 21765,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2317',
              id: 56,
              frequency: 7147,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2316',
              id: 57,
              frequency: 133878,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2315',
              id: 58,
              frequency: 112899,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2314',
              id: 59,
              frequency: 48863,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2313',
              id: 60,
              frequency: 119499,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2312',
              id: 61,
              frequency: 126481,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2311',
              id: 62,
              frequency: 7630,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2310',
              id: 63,
              frequency: 32455,
            },
            {
              _id: '5d6615769bcb6d0e6d7a230f',
              id: 64,
              frequency: 24936,
            },
            {
              _id: '5d6615769bcb6d0e6d7a230e',
              id: 65,
              frequency: 22787,
            },
            {
              _id: '5d6615769bcb6d0e6d7a230d',
              id: 66,
              frequency: 95910,
            },
            {
              _id: '5d6615769bcb6d0e6d7a230c',
              id: 67,
              frequency: 214619,
            },
            {
              _id: '5d6615769bcb6d0e6d7a230b',
              id: 68,
              frequency: 41214,
            },
            {
              _id: '5d6615769bcb6d0e6d7a230a',
              id: 69,
              frequency: 15577,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2309',
              id: 70,
              frequency: 45633,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2308',
              id: 71,
              frequency: 140828,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2307',
              id: 72,
              frequency: 82106,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a2268',
          id: 24,
          abbrevName: '25',
          fullName: '25_L_Frontal_pole',
          coordinates: {
            x: -39.700483,
            y: 47.004831,
            z: 7.613527,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a2284',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2283',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2282',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2281',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2280',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a227f',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a227e',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a227d',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a227c',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a227b',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a227a',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2279',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2278',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2277',
              to: 99,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2276',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2275',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2274',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2273',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2272',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2271',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2270',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a226f',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a226e',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a226d',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a226c',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a226b',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a226a',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2269',
              to: 65,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a22cd',
              id: 0,
              frequency: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22cc',
              id: 1,
              frequency: 979,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22cb',
              id: 2,
              frequency: 255,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22ca',
              id: 3,
              frequency: 606,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22c9',
              id: 4,
              frequency: 13764,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22c8',
              id: 5,
              frequency: 8338,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22c7',
              id: 6,
              frequency: 3514,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22c6',
              id: 7,
              frequency: 256,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22c5',
              id: 8,
              frequency: 2009,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22c4',
              id: 9,
              frequency: 8803,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22c3',
              id: 10,
              frequency: 13853,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22c2',
              id: 11,
              frequency: 2675,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22c1',
              id: 12,
              frequency: 6965,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22c0',
              id: 13,
              frequency: 4082,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22bf',
              id: 14,
              frequency: 4467,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22be',
              id: 15,
              frequency: 82686,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22bd',
              id: 16,
              frequency: 57574,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22bc',
              id: 17,
              frequency: 38669,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22bb',
              id: 18,
              frequency: 34754,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22ba',
              id: 19,
              frequency: 54535,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22b9',
              id: 20,
              frequency: 20144,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22b8',
              id: 21,
              frequency: 7177,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22b7',
              id: 22,
              frequency: 3642,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22b6',
              id: 23,
              frequency: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22b5',
              id: 24,
              frequency: 89950,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22b4',
              id: 25,
              frequency: 41300,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22b3',
              id: 26,
              frequency: 32324,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22b2',
              id: 27,
              frequency: 86920,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22b1',
              id: 28,
              frequency: 54788,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22b0',
              id: 29,
              frequency: 135336,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22af',
              id: 30,
              frequency: 34928,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22ae',
              id: 31,
              frequency: 25127,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22ad',
              id: 32,
              frequency: 27116,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22ac',
              id: 33,
              frequency: 1346,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22ab',
              id: 34,
              frequency: 21982,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22aa',
              id: 35,
              frequency: 11884,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22a9',
              id: 36,
              frequency: 12312,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22a8',
              id: 37,
              frequency: 21331,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22a7',
              id: 38,
              frequency: 4838,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22a6',
              id: 39,
              frequency: 31858,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22a5',
              id: 40,
              frequency: 54539,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22a4',
              id: 41,
              frequency: 17673,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22a3',
              id: 42,
              frequency: 5147,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22a2',
              id: 43,
              frequency: 72767,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22a1',
              id: 44,
              frequency: 3521,
            },
            {
              _id: '5d6615769bcb6d0e6d7a22a0',
              id: 45,
              frequency: 72506,
            },
            {
              _id: '5d6615769bcb6d0e6d7a229f',
              id: 46,
              frequency: 56967,
            },
            {
              _id: '5d6615769bcb6d0e6d7a229e',
              id: 47,
              frequency: 26000,
            },
            {
              _id: '5d6615769bcb6d0e6d7a229d',
              id: 48,
              frequency: 76847,
            },
            {
              _id: '5d6615769bcb6d0e6d7a229c',
              id: 49,
              frequency: 1332,
            },
            {
              _id: '5d6615769bcb6d0e6d7a229b',
              id: 50,
              frequency: 710,
            },
            {
              _id: '5d6615769bcb6d0e6d7a229a',
              id: 51,
              frequency: 42782,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2299',
              id: 52,
              frequency: 25307,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2298',
              id: 53,
              frequency: 22538,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2297',
              id: 54,
              frequency: 9140,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2296',
              id: 55,
              frequency: 2077,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2295',
              id: 56,
              frequency: 47926,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2294',
              id: 57,
              frequency: 86995,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2293',
              id: 58,
              frequency: 8217,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2292',
              id: 59,
              frequency: 95496,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2291',
              id: 60,
              frequency: 55925,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2290',
              id: 61,
              frequency: 11676,
            },
            {
              _id: '5d6615769bcb6d0e6d7a228f',
              id: 62,
              frequency: 8455,
            },
            {
              _id: '5d6615769bcb6d0e6d7a228e',
              id: 63,
              frequency: 9824,
            },
            {
              _id: '5d6615769bcb6d0e6d7a228d',
              id: 64,
              frequency: 13008,
            },
            {
              _id: '5d6615769bcb6d0e6d7a228c',
              id: 65,
              frequency: 39090,
            },
            {
              _id: '5d6615769bcb6d0e6d7a228b',
              id: 66,
              frequency: 65567,
            },
            {
              _id: '5d6615769bcb6d0e6d7a228a',
              id: 67,
              frequency: 29252,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2289',
              id: 68,
              frequency: 18198,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2288',
              id: 69,
              frequency: 2334,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2287',
              id: 70,
              frequency: 28296,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2286',
              id: 71,
              frequency: 28314,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2285',
              id: 72,
              frequency: 20029,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a21e6',
          id: 25,
          abbrevName: '26',
          fullName: '26_BI_PCC_middle',
          coordinates: {
            x: 0.666667,
            y: -22.9,
            z: 43.25,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a221e',
              to: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a221d',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d7a221c',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a221b',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a221a',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2219',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2218',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2217',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2216',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2215',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2214',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2213',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2212',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2211',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2210',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a220f',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a220e',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a220d',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a220c',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a220b',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a220a',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2209',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2208',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2207',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2206',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2205',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2204',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2203',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2202',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2201',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2200',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21ff',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21fe',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21fd',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21fc',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21fb',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21fa',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21f9',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21f8',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21f7',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21f6',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21f5',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21f4',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21f3',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21f2',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21f1',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21f0',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21ef',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21ee',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21ed',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21ec',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21eb',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21ea',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21e9',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21e8',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21e7',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a2267',
              id: 0,
              frequency: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2266',
              id: 1,
              frequency: 707,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2265',
              id: 2,
              frequency: 1240,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2264',
              id: 3,
              frequency: 1610,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2263',
              id: 4,
              frequency: 2302,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2262',
              id: 5,
              frequency: 15059,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2261',
              id: 6,
              frequency: 1606,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2260',
              id: 7,
              frequency: 4769,
            },
            {
              _id: '5d6615769bcb6d0e6d7a225f',
              id: 8,
              frequency: 3585,
            },
            {
              _id: '5d6615769bcb6d0e6d7a225e',
              id: 9,
              frequency: 1701,
            },
            {
              _id: '5d6615769bcb6d0e6d7a225d',
              id: 10,
              frequency: 13632,
            },
            {
              _id: '5d6615769bcb6d0e6d7a225c',
              id: 11,
              frequency: 27320,
            },
            {
              _id: '5d6615769bcb6d0e6d7a225b',
              id: 12,
              frequency: 8582,
            },
            {
              _id: '5d6615769bcb6d0e6d7a225a',
              id: 13,
              frequency: 22813,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2259',
              id: 14,
              frequency: 15398,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2258',
              id: 15,
              frequency: 5342,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2257',
              id: 16,
              frequency: 27248,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2256',
              id: 17,
              frequency: 33370,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2255',
              id: 18,
              frequency: 2034,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2254',
              id: 19,
              frequency: 7192,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2253',
              id: 20,
              frequency: 22057,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2252',
              id: 21,
              frequency: 54803,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2251',
              id: 22,
              frequency: 1388,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2250',
              id: 23,
              frequency: 4215,
            },
            {
              _id: '5d6615769bcb6d0e6d7a224f',
              id: 24,
              frequency: 5722,
            },
            {
              _id: '5d6615769bcb6d0e6d7a224e',
              id: 25,
              frequency: 20323,
            },
            {
              _id: '5d6615769bcb6d0e6d7a224d',
              id: 26,
              frequency: 134762,
            },
            {
              _id: '5d6615769bcb6d0e6d7a224c',
              id: 27,
              frequency: 2580,
            },
            {
              _id: '5d6615769bcb6d0e6d7a224b',
              id: 28,
              frequency: 25255,
            },
            {
              _id: '5d6615769bcb6d0e6d7a224a',
              id: 29,
              frequency: 30071,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2249',
              id: 30,
              frequency: 124051,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2248',
              id: 31,
              frequency: 4215,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2247',
              id: 32,
              frequency: 16579,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2246',
              id: 33,
              frequency: 71302,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2245',
              id: 34,
              frequency: 8351,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2244',
              id: 35,
              frequency: 888,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2243',
              id: 36,
              frequency: 5522,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2242',
              id: 37,
              frequency: 22021,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2241',
              id: 38,
              frequency: 28253,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2240',
              id: 39,
              frequency: 2906,
            },
            {
              _id: '5d6615769bcb6d0e6d7a223f',
              id: 40,
              frequency: 39371,
            },
            {
              _id: '5d6615769bcb6d0e6d7a223e',
              id: 41,
              frequency: 46435,
            },
            {
              _id: '5d6615769bcb6d0e6d7a223d',
              id: 42,
              frequency: 157710,
            },
            {
              _id: '5d6615769bcb6d0e6d7a223c',
              id: 43,
              frequency: 17477,
            },
            {
              _id: '5d6615769bcb6d0e6d7a223b',
              id: 44,
              frequency: 94561,
            },
            {
              _id: '5d6615769bcb6d0e6d7a223a',
              id: 45,
              frequency: 2248,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2239',
              id: 46,
              frequency: 15074,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2238',
              id: 47,
              frequency: 106796,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2237',
              id: 48,
              frequency: 144138,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2236',
              id: 49,
              frequency: 1531,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2235',
              id: 50,
              frequency: 4060,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2234',
              id: 51,
              frequency: 19177,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2233',
              id: 52,
              frequency: 5396,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2232',
              id: 53,
              frequency: 75138,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2231',
              id: 54,
              frequency: 8680,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2230',
              id: 55,
              frequency: 30963,
            },
            {
              _id: '5d6615769bcb6d0e6d7a222f',
              id: 56,
              frequency: 1768,
            },
            {
              _id: '5d6615769bcb6d0e6d7a222e',
              id: 57,
              frequency: 106681,
            },
            {
              _id: '5d6615769bcb6d0e6d7a222d',
              id: 58,
              frequency: 158514,
            },
            {
              _id: '5d6615769bcb6d0e6d7a222c',
              id: 59,
              frequency: 27468,
            },
            {
              _id: '5d6615769bcb6d0e6d7a222b',
              id: 60,
              frequency: 132522,
            },
            {
              _id: '5d6615769bcb6d0e6d7a222a',
              id: 61,
              frequency: 198527,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2229',
              id: 62,
              frequency: 4050,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2228',
              id: 63,
              frequency: 38756,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2227',
              id: 64,
              frequency: 21206,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2226',
              id: 65,
              frequency: 15049,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2225',
              id: 66,
              frequency: 86782,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2224',
              id: 67,
              frequency: 285496,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2223',
              id: 68,
              frequency: 51001,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2222',
              id: 69,
              frequency: 25945,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2221',
              id: 70,
              frequency: 56070,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2220',
              id: 71,
              frequency: 171462,
            },
            {
              _id: '5d6615769bcb6d0e6d7a221f',
              id: 72,
              frequency: 84280,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a2164',
          id: 26,
          abbrevName: '27',
          fullName: '27_L_Frontal_pole',
          coordinates: {
            x: 51.325843,
            y: 6.94382,
            z: -22.359551,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a219c',
              to: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d7a219b',
              to: 28,
            },
            {
              _id: '5d6615769bcb6d0e6d7a219a',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2199',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2198',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2197',
              to: 33,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2196',
              to: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2195',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2194',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2193',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2192',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2191',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2190',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a218f',
              to: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d7a218e',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a218d',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a218c',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a218b',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a218a',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2189',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2188',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2187',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2186',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2185',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2184',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2183',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2182',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2181',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2180',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a217f',
              to: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d7a217e',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a217d',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a217c',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a217b',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a217a',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2179',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2178',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2177',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2176',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2175',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2174',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2173',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2172',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2171',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2170',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a216f',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a216e',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a216d',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a216c',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a216b',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a216a',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2169',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2168',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2167',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2166',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2165',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a21e5',
              id: 0,
              frequency: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21e4',
              id: 1,
              frequency: 788,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21e3',
              id: 2,
              frequency: 1107,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21e2',
              id: 3,
              frequency: 1378,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21e1',
              id: 4,
              frequency: 6330,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21e0',
              id: 5,
              frequency: 16677,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21df',
              id: 6,
              frequency: 1160,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21de',
              id: 7,
              frequency: 4676,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21dd',
              id: 8,
              frequency: 3288,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21dc',
              id: 9,
              frequency: 3929,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21db',
              id: 10,
              frequency: 15203,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21da',
              id: 11,
              frequency: 22490,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21d9',
              id: 12,
              frequency: 8352,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21d8',
              id: 13,
              frequency: 17375,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21d7',
              id: 14,
              frequency: 12614,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21d6',
              id: 15,
              frequency: 17020,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21d5',
              id: 16,
              frequency: 82994,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21d4',
              id: 17,
              frequency: 21695,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21d3',
              id: 18,
              frequency: 5953,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21d2',
              id: 19,
              frequency: 7089,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21d1',
              id: 20,
              frequency: 16193,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21d0',
              id: 21,
              frequency: 69820,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21cf',
              id: 22,
              frequency: 597,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21ce',
              id: 23,
              frequency: 6007,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21cd',
              id: 24,
              frequency: 15625,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21cc',
              id: 25,
              frequency: 14398,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21cb',
              id: 26,
              frequency: 153279,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21ca',
              id: 27,
              frequency: 24318,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21c9',
              id: 28,
              frequency: 63186,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21c8',
              id: 29,
              frequency: 84872,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21c7',
              id: 30,
              frequency: 119030,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21c6',
              id: 31,
              frequency: 4031,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21c5',
              id: 32,
              frequency: 13126,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21c4',
              id: 33,
              frequency: 70951,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21c3',
              id: 34,
              frequency: 24386,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21c2',
              id: 35,
              frequency: 2685,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21c1',
              id: 36,
              frequency: 11339,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21c0',
              id: 37,
              frequency: 13682,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21bf',
              id: 38,
              frequency: 31030,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21be',
              id: 39,
              frequency: 6774,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21bd',
              id: 40,
              frequency: 26643,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21bc',
              id: 41,
              frequency: 47451,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21bb',
              id: 42,
              frequency: 125666,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21ba',
              id: 43,
              frequency: 45576,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21b9',
              id: 44,
              frequency: 73548,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21b8',
              id: 45,
              frequency: 20655,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21b7',
              id: 46,
              frequency: 38087,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21b6',
              id: 47,
              frequency: 109636,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21b5',
              id: 48,
              frequency: 141785,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21b4',
              id: 49,
              frequency: 885,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21b3',
              id: 50,
              frequency: 2451,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21b2',
              id: 51,
              frequency: 36905,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21b1',
              id: 52,
              frequency: 14721,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21b0',
              id: 53,
              frequency: 72637,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21af',
              id: 54,
              frequency: 4893,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21ae',
              id: 55,
              frequency: 26372,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21ad',
              id: 56,
              frequency: 12123,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21ac',
              id: 57,
              frequency: 117211,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21ab',
              id: 58,
              frequency: 126496,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21aa',
              id: 59,
              frequency: 61263,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21a9',
              id: 60,
              frequency: 123980,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21a8',
              id: 61,
              frequency: 128766,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21a7',
              id: 62,
              frequency: 7045,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21a6',
              id: 63,
              frequency: 27416,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21a5',
              id: 64,
              frequency: 22641,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21a4',
              id: 65,
              frequency: 27005,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21a3',
              id: 66,
              frequency: 91360,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21a2',
              id: 67,
              frequency: 204874,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21a1',
              id: 68,
              frequency: 38379,
            },
            {
              _id: '5d6615769bcb6d0e6d7a21a0',
              id: 69,
              frequency: 14202,
            },
            {
              _id: '5d6615769bcb6d0e6d7a219f',
              id: 70,
              frequency: 49046,
            },
            {
              _id: '5d6615769bcb6d0e6d7a219e',
              id: 71,
              frequency: 126315,
            },
            {
              _id: '5d6615769bcb6d0e6d7a219d',
              id: 72,
              frequency: 68438,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a20ef',
          id: 27,
          abbrevName: '28',
          fullName: '28_L_HC_amygdala',
          coordinates: {
            x: -23.698925,
            y: -10.860215,
            z: -23.655914,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a211a',
              to: 28,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2119',
              to: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2118',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2117',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2116',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2115',
              to: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2114',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2113',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2112',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2111',
              to: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2110',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a210f',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a210e',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a210d',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a210c',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a210b',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a210a',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2109',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2108',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2107',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2106',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2105',
              to: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2104',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2103',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2102',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2101',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2100',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20ff',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20fe',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20fd',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20fc',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20fb',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20fa',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20f9',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20f8',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20f7',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20f6',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20f5',
              to: 93,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20f4',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20f3',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20f2',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20f1',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20f0',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a2163',
              id: 0,
              frequency: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2162',
              id: 1,
              frequency: 1002,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2161',
              id: 2,
              frequency: 654,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2160',
              id: 3,
              frequency: 942,
            },
            {
              _id: '5d6615769bcb6d0e6d7a215f',
              id: 4,
              frequency: 9061,
            },
            {
              _id: '5d6615769bcb6d0e6d7a215e',
              id: 5,
              frequency: 15444,
            },
            {
              _id: '5d6615769bcb6d0e6d7a215d',
              id: 6,
              frequency: 3266,
            },
            {
              _id: '5d6615769bcb6d0e6d7a215c',
              id: 7,
              frequency: 2238,
            },
            {
              _id: '5d6615769bcb6d0e6d7a215b',
              id: 8,
              frequency: 2906,
            },
            {
              _id: '5d6615769bcb6d0e6d7a215a',
              id: 9,
              frequency: 6992,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2159',
              id: 10,
              frequency: 16364,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2158',
              id: 11,
              frequency: 9747,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2157',
              id: 12,
              frequency: 9246,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2156',
              id: 13,
              frequency: 9762,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2155',
              id: 14,
              frequency: 7513,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2154',
              id: 15,
              frequency: 43937,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2153',
              id: 16,
              frequency: 90311,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2152',
              id: 17,
              frequency: 44972,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2151',
              id: 18,
              frequency: 11786,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2150',
              id: 19,
              frequency: 34559,
            },
            {
              _id: '5d6615769bcb6d0e6d7a214f',
              id: 20,
              frequency: 33146,
            },
            {
              _id: '5d6615769bcb6d0e6d7a214e',
              id: 21,
              frequency: 52807,
            },
            {
              _id: '5d6615769bcb6d0e6d7a214d',
              id: 22,
              frequency: 2642,
            },
            {
              _id: '5d6615769bcb6d0e6d7a214c',
              id: 23,
              frequency: 2782,
            },
            {
              _id: '5d6615769bcb6d0e6d7a214b',
              id: 24,
              frequency: 47393,
            },
            {
              _id: '5d6615769bcb6d0e6d7a214a',
              id: 25,
              frequency: 38143,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2149',
              id: 26,
              frequency: 108036,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2148',
              id: 27,
              frequency: 39266,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2147',
              id: 28,
              frequency: 87767,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2146',
              id: 29,
              frequency: 109077,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2145',
              id: 30,
              frequency: 75950,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2144',
              id: 31,
              frequency: 20959,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2143',
              id: 32,
              frequency: 26053,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2142',
              id: 33,
              frequency: 25039,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2141',
              id: 34,
              frequency: 21008,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2140',
              id: 35,
              frequency: 7382,
            },
            {
              _id: '5d6615769bcb6d0e6d7a213f',
              id: 36,
              frequency: 9927,
            },
            {
              _id: '5d6615769bcb6d0e6d7a213e',
              id: 37,
              frequency: 27853,
            },
            {
              _id: '5d6615769bcb6d0e6d7a213d',
              id: 38,
              frequency: 21009,
            },
            {
              _id: '5d6615769bcb6d0e6d7a213c',
              id: 39,
              frequency: 21033,
            },
            {
              _id: '5d6615769bcb6d0e6d7a213b',
              id: 40,
              frequency: 65172,
            },
            {
              _id: '5d6615769bcb6d0e6d7a213a',
              id: 41,
              frequency: 40290,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2139',
              id: 42,
              frequency: 46139,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2138',
              id: 43,
              frequency: 70627,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2137',
              id: 44,
              frequency: 18783,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2136',
              id: 45,
              frequency: 37194,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2135',
              id: 46,
              frequency: 42150,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2134',
              id: 47,
              frequency: 80239,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2133',
              id: 48,
              frequency: 124342,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2132',
              id: 49,
              frequency: 2231,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2131',
              id: 50,
              frequency: 1361,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2130',
              id: 51,
              frequency: 41746,
            },
            {
              _id: '5d6615769bcb6d0e6d7a212f',
              id: 52,
              frequency: 18113,
            },
            {
              _id: '5d6615769bcb6d0e6d7a212e',
              id: 53,
              frequency: 45670,
            },
            {
              _id: '5d6615769bcb6d0e6d7a212d',
              id: 54,
              frequency: 13105,
            },
            {
              _id: '5d6615769bcb6d0e6d7a212c',
              id: 55,
              frequency: 13507,
            },
            {
              _id: '5d6615769bcb6d0e6d7a212b',
              id: 56,
              frequency: 28202,
            },
            {
              _id: '5d6615769bcb6d0e6d7a212a',
              id: 57,
              frequency: 105595,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2129',
              id: 58,
              frequency: 40505,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2128',
              id: 59,
              frequency: 83886,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2127',
              id: 60,
              frequency: 111362,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2126',
              id: 61,
              frequency: 47562,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2125',
              id: 62,
              frequency: 9390,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2124',
              id: 63,
              frequency: 17999,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2123',
              id: 64,
              frequency: 19760,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2122',
              id: 65,
              frequency: 44373,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2121',
              id: 66,
              frequency: 89660,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2120',
              id: 67,
              frequency: 92211,
            },
            {
              _id: '5d6615769bcb6d0e6d7a211f',
              id: 68,
              frequency: 33310,
            },
            {
              _id: '5d6615769bcb6d0e6d7a211e',
              id: 69,
              frequency: 7379,
            },
            {
              _id: '5d6615769bcb6d0e6d7a211d',
              id: 70,
              frequency: 47550,
            },
            {
              _id: '5d6615769bcb6d0e6d7a211c',
              id: 71,
              frequency: 65713,
            },
            {
              _id: '5d6615769bcb6d0e6d7a211b',
              id: 72,
              frequency: 35390,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a2093',
          id: 28,
          abbrevName: '29',
          fullName: '29_L_IFG_anterior_mtg_anteriror',
          coordinates: {
            x: -53.974843,
            y: -5.295597,
            z: -29.63522,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a20a5',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20a4',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20a3',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20a2',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20a1',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20a0',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a209f',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a209e',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a209d',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a209c',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a209b',
              to: 99,
            },
            {
              _id: '5d6615769bcb6d0e6d7a209a',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2099',
              to: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2098',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2097',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2096',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2095',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2094',
              to: 59,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a20ee',
              id: 0,
              frequency: 24,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20ed',
              id: 1,
              frequency: 717,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20ec',
              id: 2,
              frequency: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20eb',
              id: 3,
              frequency: 224,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20ea',
              id: 4,
              frequency: 13641,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20e9',
              id: 5,
              frequency: 1924,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20e8',
              id: 6,
              frequency: 4180,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20e7',
              id: 7,
              frequency: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20e6',
              id: 8,
              frequency: 499,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20e5',
              id: 9,
              frequency: 7818,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20e4',
              id: 10,
              frequency: 6295,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20e3',
              id: 11,
              frequency: 240,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20e2',
              id: 12,
              frequency: 3637,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20e1',
              id: 13,
              frequency: 619,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20e0',
              id: 14,
              frequency: 1150,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20df',
              id: 15,
              frequency: 131385,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20de',
              id: 16,
              frequency: 22762,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20dd',
              id: 17,
              frequency: 9031,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20dc',
              id: 18,
              frequency: 45885,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20db',
              id: 19,
              frequency: 86045,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20da',
              id: 20,
              frequency: 6916,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20d9',
              id: 21,
              frequency: 458,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20d8',
              id: 22,
              frequency: 6927,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20d7',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20d6',
              id: 24,
              frequency: 114214,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20d5',
              id: 25,
              frequency: 22203,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20d4',
              id: 26,
              frequency: 4004,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20d3',
              id: 27,
              frequency: 112120,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20d2',
              id: 28,
              frequency: 16798,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20d1',
              id: 29,
              frequency: 89594,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20d0',
              id: 30,
              frequency: 3647,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20cf',
              id: 31,
              frequency: 43844,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20ce',
              id: 32,
              frequency: 18704,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20cd',
              id: 33,
              frequency: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20cc',
              id: 34,
              frequency: 5021,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20cb',
              id: 35,
              frequency: 22502,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20ca',
              id: 36,
              frequency: 5014,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20c9',
              id: 37,
              frequency: 7836,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20c8',
              id: 38,
              frequency: 280,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20c7',
              id: 39,
              frequency: 46616,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20c6',
              id: 40,
              frequency: 43010,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20c5',
              id: 41,
              frequency: 5036,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20c4',
              id: 42,
              frequency: 145,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20c3',
              id: 43,
              frequency: 41109,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20c2',
              id: 44,
              frequency: 112,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20c1',
              id: 45,
              frequency: 81972,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20c0',
              id: 46,
              frequency: 44094,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20bf',
              id: 47,
              frequency: 2372,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20be',
              id: 48,
              frequency: 11940,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20bd',
              id: 49,
              frequency: 677,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20bc',
              id: 50,
              frequency: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20bb',
              id: 51,
              frequency: 11625,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20ba',
              id: 52,
              frequency: 11870,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20b9',
              id: 53,
              frequency: 2214,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20b8',
              id: 54,
              frequency: 9160,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20b7',
              id: 55,
              frequency: 124,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20b6',
              id: 56,
              frequency: 48416,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20b5',
              id: 57,
              frequency: 27285,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20b4',
              id: 58,
              frequency: 406,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20b3',
              id: 59,
              frequency: 57764,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20b2',
              id: 60,
              frequency: 10656,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20b1',
              id: 61,
              frequency: 473,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20b0',
              id: 62,
              frequency: 2123,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20af',
              id: 63,
              frequency: 1144,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20ae',
              id: 64,
              frequency: 1794,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20ad',
              id: 65,
              frequency: 24136,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20ac',
              id: 66,
              frequency: 20723,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20ab',
              id: 67,
              frequency: 2092,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20aa',
              id: 68,
              frequency: 4243,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20a9',
              id: 69,
              frequency: 153,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20a8',
              id: 70,
              frequency: 12211,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20a7',
              id: 71,
              frequency: 3370,
            },
            {
              _id: '5d6615769bcb6d0e6d7a20a6',
              id: 72,
              frequency: 3728,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a2023',
          id: 29,
          abbrevName: '30',
          fullName: '30_R_Caudate',
          coordinates: {
            x: 13.531532,
            y: 12.45045,
            z: 4.900901,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a2049',
              to: 30,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2048',
              to: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2047',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2046',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2045',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2044',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2043',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2042',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2041',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2040',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a203f',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a203e',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a203d',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a203c',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a203b',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a203a',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2039',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2038',
              to: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2037',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2036',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2035',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2034',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2033',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2032',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2031',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2030',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a202f',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a202e',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a202d',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a202c',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a202b',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a202a',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2029',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2028',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2027',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2026',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2025',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2024',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a2092',
              id: 0,
              frequency: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2091',
              id: 1,
              frequency: 951,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2090',
              id: 2,
              frequency: 686,
            },
            {
              _id: '5d6615769bcb6d0e6d7a208f',
              id: 3,
              frequency: 1025,
            },
            {
              _id: '5d6615769bcb6d0e6d7a208e',
              id: 4,
              frequency: 8668,
            },
            {
              _id: '5d6615769bcb6d0e6d7a208d',
              id: 5,
              frequency: 14994,
            },
            {
              _id: '5d6615769bcb6d0e6d7a208c',
              id: 6,
              frequency: 2706,
            },
            {
              _id: '5d6615769bcb6d0e6d7a208b',
              id: 7,
              frequency: 1840,
            },
            {
              _id: '5d6615769bcb6d0e6d7a208a',
              id: 8,
              frequency: 3200,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2089',
              id: 9,
              frequency: 6610,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2088',
              id: 10,
              frequency: 16650,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2087',
              id: 11,
              frequency: 11171,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2086',
              id: 12,
              frequency: 8557,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2085',
              id: 13,
              frequency: 11240,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2084',
              id: 14,
              frequency: 8258,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2083',
              id: 15,
              frequency: 30974,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2082',
              id: 16,
              frequency: 87585,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2081',
              id: 17,
              frequency: 37152,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2080',
              id: 18,
              frequency: 10170,
            },
            {
              _id: '5d6615769bcb6d0e6d7a207f',
              id: 19,
              frequency: 22413,
            },
            {
              _id: '5d6615769bcb6d0e6d7a207e',
              id: 20,
              frequency: 29189,
            },
            {
              _id: '5d6615769bcb6d0e6d7a207d',
              id: 21,
              frequency: 38758,
            },
            {
              _id: '5d6615769bcb6d0e6d7a207c',
              id: 22,
              frequency: 3061,
            },
            {
              _id: '5d6615769bcb6d0e6d7a207b',
              id: 23,
              frequency: 1400,
            },
            {
              _id: '5d6615769bcb6d0e6d7a207a',
              id: 24,
              frequency: 28358,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2079',
              id: 25,
              frequency: 27676,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2078',
              id: 26,
              frequency: 111559,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2077',
              id: 27,
              frequency: 47990,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2076',
              id: 28,
              frequency: 79151,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2075',
              id: 29,
              frequency: 112071,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2074',
              id: 30,
              frequency: 87235,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2073',
              id: 31,
              frequency: 17739,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2072',
              id: 32,
              frequency: 26250,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2071',
              id: 33,
              frequency: 19098,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2070',
              id: 34,
              frequency: 21857,
            },
            {
              _id: '5d6615769bcb6d0e6d7a206f',
              id: 35,
              frequency: 4259,
            },
            {
              _id: '5d6615769bcb6d0e6d7a206e',
              id: 36,
              frequency: 11745,
            },
            {
              _id: '5d6615769bcb6d0e6d7a206d',
              id: 37,
              frequency: 24642,
            },
            {
              _id: '5d6615769bcb6d0e6d7a206c',
              id: 38,
              frequency: 18905,
            },
            {
              _id: '5d6615769bcb6d0e6d7a206b',
              id: 39,
              frequency: 16621,
            },
            {
              _id: '5d6615769bcb6d0e6d7a206a',
              id: 40,
              frequency: 51827,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2069',
              id: 41,
              frequency: 42782,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2068',
              id: 42,
              frequency: 47431,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2067',
              id: 43,
              frequency: 77083,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2066',
              id: 44,
              frequency: 25661,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2065',
              id: 45,
              frequency: 37247,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2064',
              id: 46,
              frequency: 39800,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2063',
              id: 47,
              frequency: 73120,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2062',
              id: 48,
              frequency: 135655,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2061',
              id: 49,
              frequency: 1814,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2060',
              id: 50,
              frequency: 1635,
            },
            {
              _id: '5d6615769bcb6d0e6d7a205f',
              id: 51,
              frequency: 45071,
            },
            {
              _id: '5d6615769bcb6d0e6d7a205e',
              id: 52,
              frequency: 15312,
            },
            {
              _id: '5d6615769bcb6d0e6d7a205d',
              id: 53,
              frequency: 58506,
            },
            {
              _id: '5d6615769bcb6d0e6d7a205c',
              id: 54,
              frequency: 10706,
            },
            {
              _id: '5d6615769bcb6d0e6d7a205b',
              id: 55,
              frequency: 11813,
            },
            {
              _id: '5d6615769bcb6d0e6d7a205a',
              id: 56,
              frequency: 32271,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2059',
              id: 57,
              frequency: 111885,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2058',
              id: 58,
              frequency: 49435,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2057',
              id: 59,
              frequency: 80589,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2056',
              id: 60,
              frequency: 112902,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2055',
              id: 61,
              frequency: 66211,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2054',
              id: 62,
              frequency: 11104,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2053',
              id: 63,
              frequency: 21144,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2052',
              id: 64,
              frequency: 22554,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2051',
              id: 65,
              frequency: 39639,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2050',
              id: 66,
              frequency: 87993,
            },
            {
              _id: '5d6615769bcb6d0e6d7a204f',
              id: 67,
              frequency: 109147,
            },
            {
              _id: '5d6615769bcb6d0e6d7a204e',
              id: 68,
              frequency: 35242,
            },
            {
              _id: '5d6615769bcb6d0e6d7a204d',
              id: 69,
              frequency: 10904,
            },
            {
              _id: '5d6615769bcb6d0e6d7a204c',
              id: 70,
              frequency: 40702,
            },
            {
              _id: '5d6615769bcb6d0e6d7a204b',
              id: 71,
              frequency: 76119,
            },
            {
              _id: '5d6615769bcb6d0e6d7a204a',
              id: 72,
              frequency: 37907,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1fb3',
          id: 30,
          abbrevName: '31',
          fullName: '31_R_Cerebellum_posterior',
          coordinates: {
            x: 17.234783,
            y: -79.686957,
            z: -36.295652,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1fd9',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fd8',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fd7',
              to: 35,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fd6',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fd5',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fd4',
              to: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fd3',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fd2',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fd1',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fd0',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fcf',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fce',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fcd',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fcc',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fcb',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fca',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fc9',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fc8',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fc7',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fc6',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fc5',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fc4',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fc3',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fc2',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fc1',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fc0',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fbf',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fbe',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fbd',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fbc',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fbb',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fba',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fb9',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fb8',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fb7',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fb6',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fb5',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fb4',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a2022',
              id: 0,
              frequency: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2021',
              id: 1,
              frequency: 977,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2020',
              id: 2,
              frequency: 769,
            },
            {
              _id: '5d6615769bcb6d0e6d7a201f',
              id: 3,
              frequency: 1061,
            },
            {
              _id: '5d6615769bcb6d0e6d7a201e',
              id: 4,
              frequency: 7678,
            },
            {
              _id: '5d6615769bcb6d0e6d7a201d',
              id: 5,
              frequency: 16230,
            },
            {
              _id: '5d6615769bcb6d0e6d7a201c',
              id: 6,
              frequency: 2839,
            },
            {
              _id: '5d6615769bcb6d0e6d7a201b',
              id: 7,
              frequency: 2664,
            },
            {
              _id: '5d6615769bcb6d0e6d7a201a',
              id: 8,
              frequency: 3628,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2019',
              id: 9,
              frequency: 6198,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2018',
              id: 10,
              frequency: 16188,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2017',
              id: 11,
              frequency: 12622,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2016',
              id: 12,
              frequency: 9473,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2015',
              id: 13,
              frequency: 12135,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2014',
              id: 14,
              frequency: 8569,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2013',
              id: 15,
              frequency: 29749,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2012',
              id: 16,
              frequency: 76692,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2011',
              id: 17,
              frequency: 43463,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2010',
              id: 18,
              frequency: 7281,
            },
            {
              _id: '5d6615769bcb6d0e6d7a200f',
              id: 19,
              frequency: 25608,
            },
            {
              _id: '5d6615769bcb6d0e6d7a200e',
              id: 20,
              frequency: 29058,
            },
            {
              _id: '5d6615769bcb6d0e6d7a200d',
              id: 21,
              frequency: 55124,
            },
            {
              _id: '5d6615769bcb6d0e6d7a200c',
              id: 22,
              frequency: 2470,
            },
            {
              _id: '5d6615769bcb6d0e6d7a200b',
              id: 23,
              frequency: 3212,
            },
            {
              _id: '5d6615769bcb6d0e6d7a200a',
              id: 24,
              frequency: 30178,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2009',
              id: 25,
              frequency: 32867,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2008',
              id: 26,
              frequency: 115357,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2007',
              id: 27,
              frequency: 33071,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2006',
              id: 28,
              frequency: 83442,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2005',
              id: 29,
              frequency: 94426,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2004',
              id: 30,
              frequency: 94929,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2003',
              id: 31,
              frequency: 15273,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2002',
              id: 32,
              frequency: 23686,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2001',
              id: 33,
              frequency: 31436,
            },
            {
              _id: '5d6615769bcb6d0e6d7a2000',
              id: 34,
              frequency: 19940,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fff',
              id: 35,
              frequency: 5383,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ffe',
              id: 36,
              frequency: 11739,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ffd',
              id: 37,
              frequency: 28778,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ffc',
              id: 38,
              frequency: 24691,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ffb',
              id: 39,
              frequency: 16148,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ffa',
              id: 40,
              frequency: 58402,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ff9',
              id: 41,
              frequency: 42719,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ff8',
              id: 42,
              frequency: 62519,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ff7',
              id: 43,
              frequency: 62180,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ff6',
              id: 44,
              frequency: 28133,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ff5',
              id: 45,
              frequency: 29443,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ff4',
              id: 46,
              frequency: 38142,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ff3',
              id: 47,
              frequency: 86498,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ff2',
              id: 48,
              frequency: 134656,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ff1',
              id: 49,
              frequency: 2384,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ff0',
              id: 50,
              frequency: 2963,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fef',
              id: 51,
              frequency: 45653,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fee',
              id: 52,
              frequency: 14514,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fed',
              id: 53,
              frequency: 61107,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fec',
              id: 54,
              frequency: 12824,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1feb',
              id: 55,
              frequency: 16273,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fea',
              id: 56,
              frequency: 25351,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fe9',
              id: 57,
              frequency: 107823,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fe8',
              id: 58,
              frequency: 55340,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fe7',
              id: 59,
              frequency: 75239,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fe6',
              id: 60,
              frequency: 123966,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fe5',
              id: 61,
              frequency: 72432,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fe4',
              id: 62,
              frequency: 10502,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fe3',
              id: 63,
              frequency: 28080,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fe2',
              id: 64,
              frequency: 21078,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fe1',
              id: 65,
              frequency: 42181,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fe0',
              id: 66,
              frequency: 88383,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fdf',
              id: 67,
              frequency: 120750,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fde',
              id: 68,
              frequency: 42127,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fdd',
              id: 69,
              frequency: 10957,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fdc',
              id: 70,
              frequency: 49242,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fdb',
              id: 71,
              frequency: 81150,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fda',
              id: 72,
              frequency: 39653,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1f4e',
          id: 31,
          abbrevName: '32',
          fullName: '32_R_LOC_superior',
          coordinates: {
            x: 40.051282,
            y: -69.641026,
            z: 35.521368,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1f69',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f68',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f67',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f66',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f65',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f64',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f63',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f62',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f61',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f60',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f5f',
              to: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f5e',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f5d',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f5c',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f5b',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f5a',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f59',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f58',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f57',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f56',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f55',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f54',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f53',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f52',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f51',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f50',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f4f',
              to: 59,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1fb2',
              id: 0,
              frequency: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fb1',
              id: 1,
              frequency: 1036,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fb0',
              id: 2,
              frequency: 237,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1faf',
              id: 3,
              frequency: 466,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fae',
              id: 4,
              frequency: 14043,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fad',
              id: 5,
              frequency: 8225,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fac',
              id: 6,
              frequency: 4998,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fab',
              id: 7,
              frequency: 238,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1faa',
              id: 8,
              frequency: 2118,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fa9',
              id: 9,
              frequency: 9799,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fa8',
              id: 10,
              frequency: 10835,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fa7',
              id: 11,
              frequency: 2398,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fa6',
              id: 12,
              frequency: 7518,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fa5',
              id: 13,
              frequency: 3022,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fa4',
              id: 14,
              frequency: 2778,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fa3',
              id: 15,
              frequency: 100262,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fa2',
              id: 16,
              frequency: 59606,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fa1',
              id: 17,
              frequency: 43534,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1fa0',
              id: 18,
              frequency: 33941,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f9f',
              id: 19,
              frequency: 75633,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f9e',
              id: 20,
              frequency: 22556,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f9d',
              id: 21,
              frequency: 7394,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f9c',
              id: 22,
              frequency: 6834,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f9b',
              id: 23,
              frequency: 18,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f9a',
              id: 24,
              frequency: 108583,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f99',
              id: 25,
              frequency: 37160,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f98',
              id: 26,
              frequency: 29578,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f97',
              id: 27,
              frequency: 78680,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f96',
              id: 28,
              frequency: 55472,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f95',
              id: 29,
              frequency: 99742,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f94',
              id: 30,
              frequency: 30581,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f93',
              id: 31,
              frequency: 43439,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f92',
              id: 32,
              frequency: 23570,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f91',
              id: 33,
              frequency: 1257,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f90',
              id: 34,
              frequency: 20765,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f8f',
              id: 35,
              frequency: 19495,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f8e',
              id: 36,
              frequency: 13648,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f8d',
              id: 37,
              frequency: 28655,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f8c',
              id: 38,
              frequency: 4225,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f8b',
              id: 39,
              frequency: 47385,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f8a',
              id: 40,
              frequency: 72301,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f89',
              id: 41,
              frequency: 13953,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f88',
              id: 42,
              frequency: 4319,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f87',
              id: 43,
              frequency: 53832,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f86',
              id: 44,
              frequency: 3417,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f85',
              id: 45,
              frequency: 73735,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f84',
              id: 46,
              frequency: 58451,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f83',
              id: 47,
              frequency: 29147,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f82',
              id: 48,
              frequency: 53257,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f81',
              id: 49,
              frequency: 2334,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f80',
              id: 50,
              frequency: 638,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f7f',
              id: 51,
              frequency: 44194,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f7e',
              id: 52,
              frequency: 18179,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f7d',
              id: 53,
              frequency: 19048,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f7c',
              id: 54,
              frequency: 16588,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f7b',
              id: 55,
              frequency: 1425,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f7a',
              id: 56,
              frequency: 49349,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f79',
              id: 57,
              frequency: 50706,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f78',
              id: 58,
              frequency: 6745,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f77',
              id: 59,
              frequency: 93963,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f76',
              id: 60,
              frequency: 51523,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f75',
              id: 61,
              frequency: 9479,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f74',
              id: 62,
              frequency: 8411,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f73',
              id: 63,
              frequency: 11417,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f72',
              id: 64,
              frequency: 8144,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f71',
              id: 65,
              frequency: 49140,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f70',
              id: 66,
              frequency: 45524,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f6f',
              id: 67,
              frequency: 19917,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f6e',
              id: 68,
              frequency: 20083,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f6d',
              id: 69,
              frequency: 1654,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f6c',
              id: 70,
              frequency: 30957,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f6b',
              id: 71,
              frequency: 15884,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f6a',
              id: 72,
              frequency: 9700,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1edd',
          id: 32,
          abbrevName: '33',
          fullName: '33_R_Angular_gyrus_loc_superior',
          coordinates: {
            x: 54.052863,
            y: -53.418502,
            z: 17.23348,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1f04',
              to: 34,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f03',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f02',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f01',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f00',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1eff',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1efe',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1efd',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1efc',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1efb',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1efa',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ef9',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ef8',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ef7',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ef6',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ef5',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ef4',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ef3',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ef2',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ef1',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ef0',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1eef',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1eee',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1eed',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1eec',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1eeb',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1eea',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ee9',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ee8',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ee7',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ee6',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ee5',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ee4',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ee3',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ee2',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ee1',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ee0',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1edf',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ede',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1f4d',
              id: 0,
              frequency: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f4c',
              id: 1,
              frequency: 1010,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f4b',
              id: 2,
              frequency: 719,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f4a',
              id: 3,
              frequency: 1051,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f49',
              id: 4,
              frequency: 7920,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f48',
              id: 5,
              frequency: 15839,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f47',
              id: 6,
              frequency: 3208,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f46',
              id: 7,
              frequency: 2046,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f45',
              id: 8,
              frequency: 3666,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f44',
              id: 9,
              frequency: 5893,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f43',
              id: 10,
              frequency: 16241,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f42',
              id: 11,
              frequency: 12216,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f41',
              id: 12,
              frequency: 10089,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f40',
              id: 13,
              frequency: 11132,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f3f',
              id: 14,
              frequency: 8826,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f3e',
              id: 15,
              frequency: 35983,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f3d',
              id: 16,
              frequency: 68374,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f3c',
              id: 17,
              frequency: 51386,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f3b',
              id: 18,
              frequency: 10892,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f3a',
              id: 19,
              frequency: 29207,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f39',
              id: 20,
              frequency: 30325,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f38',
              id: 21,
              frequency: 40536,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f37',
              id: 22,
              frequency: 2853,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f36',
              id: 23,
              frequency: 1469,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f35',
              id: 24,
              frequency: 37107,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f34',
              id: 25,
              frequency: 35082,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f33',
              id: 26,
              frequency: 104611,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f32',
              id: 27,
              frequency: 26570,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f31',
              id: 28,
              frequency: 67991,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f30',
              id: 29,
              frequency: 85732,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f2f',
              id: 30,
              frequency: 99378,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f2e',
              id: 31,
              frequency: 17274,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f2d',
              id: 32,
              frequency: 26190,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f2c',
              id: 33,
              frequency: 23899,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f2b',
              id: 34,
              frequency: 24650,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f2a',
              id: 35,
              frequency: 6789,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f29',
              id: 36,
              frequency: 12070,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f28',
              id: 37,
              frequency: 32595,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f27',
              id: 38,
              frequency: 23754,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f26',
              id: 39,
              frequency: 17981,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f25',
              id: 40,
              frequency: 67354,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f24',
              id: 41,
              frequency: 40485,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f23',
              id: 42,
              frequency: 51197,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f22',
              id: 43,
              frequency: 53692,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f21',
              id: 44,
              frequency: 30580,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f20',
              id: 45,
              frequency: 24483,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f1f',
              id: 46,
              frequency: 41024,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f1e',
              id: 47,
              frequency: 88418,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f1d',
              id: 48,
              frequency: 122503,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f1c',
              id: 49,
              frequency: 2573,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f1b',
              id: 50,
              frequency: 2405,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f1a',
              id: 51,
              frequency: 44753,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f19',
              id: 52,
              frequency: 16810,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f18',
              id: 53,
              frequency: 64655,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f17',
              id: 54,
              frequency: 13831,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f16',
              id: 55,
              frequency: 11751,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f15',
              id: 56,
              frequency: 18471,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f14',
              id: 57,
              frequency: 110439,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f13',
              id: 58,
              frequency: 59100,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f12',
              id: 59,
              frequency: 79313,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f11',
              id: 60,
              frequency: 122721,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f10',
              id: 61,
              frequency: 66080,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f0f',
              id: 62,
              frequency: 10137,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f0e',
              id: 63,
              frequency: 28279,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f0d',
              id: 64,
              frequency: 18552,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f0c',
              id: 65,
              frequency: 40832,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f0b',
              id: 66,
              frequency: 94268,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f0a',
              id: 67,
              frequency: 114340,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f09',
              id: 68,
              frequency: 41894,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f08',
              id: 69,
              frequency: 9125,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f07',
              id: 70,
              frequency: 55896,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f06',
              id: 71,
              frequency: 75367,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1f05',
              id: 72,
              frequency: 44727,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1e76',
          id: 33,
          abbrevName: '34',
          fullName: '34_R_Precentral_gyrus_postcentral_gyrus_BA6',
          coordinates: {
            x: 59.232227,
            y: -3.175355,
            z: 21.137441,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1e93',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e92',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e91',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e90',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e8f',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e8e',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e8d',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e8c',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e8b',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e8a',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e89',
              to: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e88',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e87',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e86',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e85',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e84',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e83',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e82',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e81',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e80',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e7f',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e7e',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e7d',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e7c',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e7b',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e7a',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e79',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e78',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e77',
              to: 63,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1edc',
              id: 0,
              frequency: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1edb',
              id: 1,
              frequency: 868,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1eda',
              id: 2,
              frequency: 187,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ed9',
              id: 3,
              frequency: 633,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ed8',
              id: 4,
              frequency: 14679,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ed7',
              id: 5,
              frequency: 5265,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ed6',
              id: 6,
              frequency: 2715,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ed5',
              id: 7,
              frequency: 111,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ed4',
              id: 8,
              frequency: 1367,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ed3',
              id: 9,
              frequency: 7451,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ed2',
              id: 10,
              frequency: 12943,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ed1',
              id: 11,
              frequency: 1773,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ed0',
              id: 12,
              frequency: 6889,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ecf',
              id: 13,
              frequency: 3414,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ece',
              id: 14,
              frequency: 5362,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ecd',
              id: 15,
              frequency: 112159,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ecc',
              id: 16,
              frequency: 56767,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ecb',
              id: 17,
              frequency: 18109,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1eca',
              id: 18,
              frequency: 45217,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ec9',
              id: 19,
              frequency: 45517,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ec8',
              id: 20,
              frequency: 8418,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ec7',
              id: 21,
              frequency: 2624,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ec6',
              id: 22,
              frequency: 1797,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ec5',
              id: 23,
              frequency: 7,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ec4',
              id: 24,
              frequency: 95047,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ec3',
              id: 25,
              frequency: 27874,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ec2',
              id: 26,
              frequency: 18977,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ec1',
              id: 27,
              frequency: 95320,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ec0',
              id: 28,
              frequency: 32755,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ebf',
              id: 29,
              frequency: 165778,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ebe',
              id: 30,
              frequency: 19101,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ebd',
              id: 31,
              frequency: 18351,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ebc',
              id: 32,
              frequency: 22313,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ebb',
              id: 33,
              frequency: 446,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1eba',
              id: 34,
              frequency: 14912,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1eb9',
              id: 35,
              frequency: 15231,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1eb8',
              id: 36,
              frequency: 11260,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1eb7',
              id: 37,
              frequency: 12934,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1eb6',
              id: 38,
              frequency: 1795,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1eb5',
              id: 39,
              frequency: 29850,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1eb4',
              id: 40,
              frequency: 47443,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1eb3',
              id: 41,
              frequency: 15240,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1eb2',
              id: 42,
              frequency: 2116,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1eb1',
              id: 43,
              frequency: 68632,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1eb0',
              id: 44,
              frequency: 2036,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1eaf',
              id: 45,
              frequency: 70062,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1eae',
              id: 46,
              frequency: 75824,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ead',
              id: 47,
              frequency: 15183,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1eac',
              id: 48,
              frequency: 54793,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1eab',
              id: 49,
              frequency: 973,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1eaa',
              id: 50,
              frequency: 287,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ea9',
              id: 51,
              frequency: 25943,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ea8',
              id: 52,
              frequency: 22439,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ea7',
              id: 53,
              frequency: 12638,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ea6',
              id: 54,
              frequency: 7773,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ea5',
              id: 55,
              frequency: 1182,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ea4',
              id: 56,
              frequency: 35592,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ea3',
              id: 57,
              frequency: 96619,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ea2',
              id: 58,
              frequency: 5506,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ea1',
              id: 59,
              frequency: 89802,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ea0',
              id: 60,
              frequency: 41521,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e9f',
              id: 61,
              frequency: 6705,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e9e',
              id: 62,
              frequency: 4839,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e9d',
              id: 63,
              frequency: 6259,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e9c',
              id: 64,
              frequency: 9519,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e9b',
              id: 65,
              frequency: 35615,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e9a',
              id: 66,
              frequency: 67046,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e99',
              id: 67,
              frequency: 24178,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e98',
              id: 68,
              frequency: 15982,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e97',
              id: 69,
              frequency: 1479,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e96',
              id: 70,
              frequency: 35566,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e95',
              id: 71,
              frequency: 28194,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e94',
              id: 72,
              frequency: 29421,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1e16',
          id: 34,
          abbrevName: '35',
          fullName: '35_R_Thalamus',
          coordinates: {
            x: 11.402062,
            y: -17.360825,
            z: 7.835052,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1e2c',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e2b',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e2a',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e29',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e28',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e27',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e26',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e25',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e24',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e23',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e22',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e21',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e20',
              to: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e1f',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e1e',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e1d',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e1c',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e1b',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e1a',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e19',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e18',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e17',
              to: 62,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1e75',
              id: 0,
              frequency: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e74',
              id: 1,
              frequency: 1070,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e73',
              id: 2,
              frequency: 306,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e72',
              id: 3,
              frequency: 514,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e71',
              id: 4,
              frequency: 13697,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e70',
              id: 5,
              frequency: 9827,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e6f',
              id: 6,
              frequency: 4580,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e6e',
              id: 7,
              frequency: 472,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e6d',
              id: 8,
              frequency: 2756,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e6c',
              id: 9,
              frequency: 9948,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e6b',
              id: 10,
              frequency: 12055,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e6a',
              id: 11,
              frequency: 3396,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e69',
              id: 12,
              frequency: 7703,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e68',
              id: 13,
              frequency: 3726,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e67',
              id: 14,
              frequency: 3066,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e66',
              id: 15,
              frequency: 85746,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e65',
              id: 16,
              frequency: 66324,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e64',
              id: 17,
              frequency: 47563,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e63',
              id: 18,
              frequency: 30451,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e62',
              id: 19,
              frequency: 70435,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e61',
              id: 20,
              frequency: 24007,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e60',
              id: 21,
              frequency: 13710,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e5f',
              id: 22,
              frequency: 5360,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e5e',
              id: 23,
              frequency: 183,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e5d',
              id: 24,
              frequency: 100004,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e5c',
              id: 25,
              frequency: 42553,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e5b',
              id: 26,
              frequency: 44144,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e5a',
              id: 27,
              frequency: 75016,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e59',
              id: 28,
              frequency: 61813,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e58',
              id: 29,
              frequency: 99248,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e57',
              id: 30,
              frequency: 37344,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e56',
              id: 31,
              frequency: 39139,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e55',
              id: 32,
              frequency: 24466,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e54',
              id: 33,
              frequency: 3136,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e53',
              id: 34,
              frequency: 25638,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e52',
              id: 35,
              frequency: 14520,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e51',
              id: 36,
              frequency: 15118,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e50',
              id: 37,
              frequency: 32007,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e4f',
              id: 38,
              frequency: 8002,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e4e',
              id: 39,
              frequency: 39962,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e4d',
              id: 40,
              frequency: 70584,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e4c',
              id: 41,
              frequency: 19019,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e4b',
              id: 42,
              frequency: 8279,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e4a',
              id: 43,
              frequency: 61049,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e49',
              id: 44,
              frequency: 5533,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e48',
              id: 45,
              frequency: 72506,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e47',
              id: 46,
              frequency: 53027,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e46',
              id: 47,
              frequency: 35698,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e45',
              id: 48,
              frequency: 59680,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e44',
              id: 49,
              frequency: 2190,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e43',
              id: 50,
              frequency: 1124,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e42',
              id: 51,
              frequency: 53684,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e41',
              id: 52,
              frequency: 21389,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e40',
              id: 53,
              frequency: 29976,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e3f',
              id: 54,
              frequency: 13878,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e3e',
              id: 55,
              frequency: 2653,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e3d',
              id: 56,
              frequency: 51871,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e3c',
              id: 57,
              frequency: 55270,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e3b',
              id: 58,
              frequency: 10304,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e3a',
              id: 59,
              frequency: 98280,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e39',
              id: 60,
              frequency: 59945,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e38',
              id: 61,
              frequency: 13508,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e37',
              id: 62,
              frequency: 12274,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e36',
              id: 63,
              frequency: 15351,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e35',
              id: 64,
              frequency: 11619,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e34',
              id: 65,
              frequency: 49273,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e33',
              id: 66,
              frequency: 52292,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e32',
              id: 67,
              frequency: 26158,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e31',
              id: 68,
              frequency: 23813,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e30',
              id: 69,
              frequency: 2179,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e2f',
              id: 70,
              frequency: 29835,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e2e',
              id: 71,
              frequency: 18651,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e2d',
              id: 72,
              frequency: 10686,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1dbc',
          id: 35,
          abbrevName: '36',
          fullName: '36_BI_Frontal_medial_cortex',
          coordinates: {
            x: 0.070352,
            y: 45.819095,
            z: -20.38191,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1dcc',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dcb',
              to: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dca',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dc9',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dc8',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dc7',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dc6',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dc5',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dc4',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dc3',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dc2',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dc1',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dc0',
              to: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dbf',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dbe',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dbd',
              to: 58,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1e15',
              id: 0,
              frequency: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e14',
              id: 1,
              frequency: 673,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e13',
              id: 2,
              frequency: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e12',
              id: 3,
              frequency: 193,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e11',
              id: 4,
              frequency: 12584,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e10',
              id: 5,
              frequency: 1279,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e0f',
              id: 6,
              frequency: 4455,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e0e',
              id: 7,
              frequency: 10,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e0d',
              id: 8,
              frequency: 323,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e0c',
              id: 9,
              frequency: 7482,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e0b',
              id: 10,
              frequency: 5612,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e0a',
              id: 11,
              frequency: 145,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e09',
              id: 12,
              frequency: 3298,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e08',
              id: 13,
              frequency: 440,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e07',
              id: 14,
              frequency: 945,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e06',
              id: 15,
              frequency: 127448,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e05',
              id: 16,
              frequency: 20506,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e04',
              id: 17,
              frequency: 3921,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e03',
              id: 18,
              frequency: 40197,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e02',
              id: 19,
              frequency: 92545,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e01',
              id: 20,
              frequency: 5459,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1e00',
              id: 21,
              frequency: 304,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dff',
              id: 22,
              frequency: 8344,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dfe',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dfd',
              id: 24,
              frequency: 111230,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dfc',
              id: 25,
              frequency: 18930,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dfb',
              id: 26,
              frequency: 2617,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dfa',
              id: 27,
              frequency: 104718,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1df9',
              id: 28,
              frequency: 10478,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1df8',
              id: 29,
              frequency: 79937,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1df7',
              id: 30,
              frequency: 1360,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1df6',
              id: 31,
              frequency: 48670,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1df5',
              id: 32,
              frequency: 18683,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1df4',
              id: 33,
              frequency: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1df3',
              id: 34,
              frequency: 2296,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1df2',
              id: 35,
              frequency: 23208,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1df1',
              id: 36,
              frequency: 3913,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1df0',
              id: 37,
              frequency: 4962,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1def',
              id: 38,
              frequency: 194,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dee',
              id: 39,
              frequency: 50113,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ded',
              id: 40,
              frequency: 42247,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dec',
              id: 41,
              frequency: 4324,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1deb',
              id: 42,
              frequency: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dea',
              id: 43,
              frequency: 40495,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1de9',
              id: 44,
              frequency: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1de8',
              id: 45,
              frequency: 76012,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1de7',
              id: 46,
              frequency: 37133,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1de6',
              id: 47,
              frequency: 1624,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1de5',
              id: 48,
              frequency: 7459,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1de4',
              id: 49,
              frequency: 506,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1de3',
              id: 50,
              frequency: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1de2',
              id: 51,
              frequency: 6157,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1de1',
              id: 52,
              frequency: 9861,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1de0',
              id: 53,
              frequency: 1067,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ddf',
              id: 54,
              frequency: 10596,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dde',
              id: 55,
              frequency: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ddd',
              id: 56,
              frequency: 45686,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ddc',
              id: 57,
              frequency: 23257,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ddb',
              id: 58,
              frequency: 179,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dda',
              id: 59,
              frequency: 51258,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dd9',
              id: 60,
              frequency: 7473,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dd8',
              id: 61,
              frequency: 250,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dd7',
              id: 62,
              frequency: 1356,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dd6',
              id: 63,
              frequency: 623,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dd5',
              id: 64,
              frequency: 971,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dd4',
              id: 65,
              frequency: 23011,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dd3',
              id: 66,
              frequency: 18260,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dd2',
              id: 67,
              frequency: 1342,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dd1',
              id: 68,
              frequency: 2907,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dd0',
              id: 69,
              frequency: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dcf',
              id: 70,
              frequency: 10722,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dce',
              id: 71,
              frequency: 2281,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dcd',
              id: 72,
              frequency: 2968,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1d59',
          id: 36,
          abbrevName: '37',
          fullName: '37_L_Frontal_Operculum_frontal_orbital_Insula',
          coordinates: {
            x: -42.095238,
            y: 19.180952,
            z: 1.52381,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1d72',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d71',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d70',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d6f',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d6e',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d6d',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d6c',
              to: 99,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d6b',
              to: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d6a',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d69',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d68',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d67',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d66',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d65',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d64',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d63',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d62',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d61',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d60',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d5f',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d5e',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d5d',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d5c',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d5b',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d5a',
              to: 63,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1dbb',
              id: 0,
              frequency: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dba',
              id: 1,
              frequency: 1027,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1db9',
              id: 2,
              frequency: 278,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1db8',
              id: 3,
              frequency: 625,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1db7',
              id: 4,
              frequency: 13037,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1db6',
              id: 5,
              frequency: 8969,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1db5',
              id: 6,
              frequency: 4210,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1db4',
              id: 7,
              frequency: 188,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1db3',
              id: 8,
              frequency: 1979,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1db2',
              id: 9,
              frequency: 8811,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1db1',
              id: 10,
              frequency: 13765,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1db0',
              id: 11,
              frequency: 3184,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1daf',
              id: 12,
              frequency: 8221,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dae',
              id: 13,
              frequency: 4466,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dad',
              id: 14,
              frequency: 4503,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dac',
              id: 15,
              frequency: 83404,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1dab',
              id: 16,
              frequency: 62031,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1daa',
              id: 17,
              frequency: 41819,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1da9',
              id: 18,
              frequency: 31796,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1da8',
              id: 19,
              frequency: 61899,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1da7',
              id: 20,
              frequency: 22858,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1da6',
              id: 21,
              frequency: 5092,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1da5',
              id: 22,
              frequency: 4642,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1da4',
              id: 23,
              frequency: 4,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1da3',
              id: 24,
              frequency: 88131,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1da2',
              id: 25,
              frequency: 43249,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1da1',
              id: 26,
              frequency: 36121,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1da0',
              id: 27,
              frequency: 67995,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d9f',
              id: 28,
              frequency: 56028,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d9e',
              id: 29,
              frequency: 116945,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d9d',
              id: 30,
              frequency: 39126,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d9c',
              id: 31,
              frequency: 33166,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d9b',
              id: 32,
              frequency: 28690,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d9a',
              id: 33,
              frequency: 825,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d99',
              id: 34,
              frequency: 24007,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d98',
              id: 35,
              frequency: 13368,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d97',
              id: 36,
              frequency: 10629,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d96',
              id: 37,
              frequency: 23593,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d95',
              id: 38,
              frequency: 3620,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d94',
              id: 39,
              frequency: 35459,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d93',
              id: 40,
              frequency: 71841,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d92',
              id: 41,
              frequency: 20767,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d91',
              id: 42,
              frequency: 4352,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d90',
              id: 43,
              frequency: 67850,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d8f',
              id: 44,
              frequency: 5117,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d8e',
              id: 45,
              frequency: 62696,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d8d',
              id: 46,
              frequency: 58495,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d8c',
              id: 47,
              frequency: 33895,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d8b',
              id: 48,
              frequency: 74467,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d8a',
              id: 49,
              frequency: 1757,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d89',
              id: 50,
              frequency: 319,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d88',
              id: 51,
              frequency: 37236,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d87',
              id: 52,
              frequency: 23099,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d86',
              id: 53,
              frequency: 24002,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d85',
              id: 54,
              frequency: 13162,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d84',
              id: 55,
              frequency: 1502,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d83',
              id: 56,
              frequency: 42159,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d82',
              id: 57,
              frequency: 80069,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d81',
              id: 58,
              frequency: 10896,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d80',
              id: 59,
              frequency: 98882,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d7f',
              id: 60,
              frequency: 69673,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d7e',
              id: 61,
              frequency: 15132,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d7d',
              id: 62,
              frequency: 7569,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d7c',
              id: 63,
              frequency: 9795,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d7b',
              id: 64,
              frequency: 11623,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d7a',
              id: 65,
              frequency: 47464,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d79',
              id: 66,
              frequency: 67592,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d78',
              id: 67,
              frequency: 33586,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d77',
              id: 68,
              frequency: 21347,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d76',
              id: 69,
              frequency: 3375,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d75',
              id: 70,
              frequency: 37804,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d74',
              id: 71,
              frequency: 29423,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d73',
              id: 72,
              frequency: 19198,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1ce5',
          id: 37,
          abbrevName: '38',
          fullName: '38_L_ITG_temporoocciptial',
          coordinates: {
            x: -50.040609,
            y: -56.13198,
            z: -15.269036,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1d0f',
              to: 38,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d0e',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d0d',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d0c',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d0b',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d0a',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d09',
              to: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d08',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d07',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d06',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d05',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d04',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d03',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d02',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d01',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d00',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cff',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cfe',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cfd',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cfc',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cfb',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cfa',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cf9',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cf8',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cf7',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cf6',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cf5',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cf4',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cf3',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cf2',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cf1',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cf0',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cef',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cee',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ced',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cec',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ceb',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cea',
              to: 93,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ce9',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ce8',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ce7',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ce6',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1d58',
              id: 0,
              frequency: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d57',
              id: 1,
              frequency: 897,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d56',
              id: 2,
              frequency: 887,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d55',
              id: 3,
              frequency: 1258,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d54',
              id: 4,
              frequency: 5734,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d53',
              id: 5,
              frequency: 15947,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d52',
              id: 6,
              frequency: 2497,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d51',
              id: 7,
              frequency: 3290,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d50',
              id: 8,
              frequency: 3481,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d4f',
              id: 9,
              frequency: 4214,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d4e',
              id: 10,
              frequency: 16510,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d4d',
              id: 11,
              frequency: 16053,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d4c',
              id: 12,
              frequency: 9443,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d4b',
              id: 13,
              frequency: 14792,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d4a',
              id: 14,
              frequency: 11625,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d49',
              id: 15,
              frequency: 23093,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d48',
              id: 16,
              frequency: 66285,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d47',
              id: 17,
              frequency: 42422,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d46',
              id: 18,
              frequency: 6992,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d45',
              id: 19,
              frequency: 20344,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d44',
              id: 20,
              frequency: 26568,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d43',
              id: 21,
              frequency: 56902,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d42',
              id: 22,
              frequency: 1806,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d41',
              id: 23,
              frequency: 4917,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d40',
              id: 24,
              frequency: 21970,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d3f',
              id: 25,
              frequency: 31616,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d3e',
              id: 26,
              frequency: 125562,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d3d',
              id: 27,
              frequency: 15121,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d3c',
              id: 28,
              frequency: 58610,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d3b',
              id: 29,
              frequency: 78547,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d3a',
              id: 30,
              frequency: 99856,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d39',
              id: 31,
              frequency: 12986,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d38',
              id: 32,
              frequency: 23045,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d37',
              id: 33,
              frequency: 43975,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d36',
              id: 34,
              frequency: 16826,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d35',
              id: 35,
              frequency: 3630,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d34',
              id: 36,
              frequency: 9437,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d33',
              id: 37,
              frequency: 28038,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d32',
              id: 38,
              frequency: 26234,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d31',
              id: 39,
              frequency: 10766,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d30',
              id: 40,
              frequency: 58682,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d2f',
              id: 41,
              frequency: 45086,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d2e',
              id: 42,
              frequency: 81351,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d2d',
              id: 43,
              frequency: 48664,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d2c',
              id: 44,
              frequency: 37572,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d2b',
              id: 45,
              frequency: 13368,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d2a',
              id: 46,
              frequency: 29652,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d29',
              id: 47,
              frequency: 94053,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d28',
              id: 48,
              frequency: 139985,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d27',
              id: 49,
              frequency: 1945,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d26',
              id: 50,
              frequency: 2176,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d25',
              id: 51,
              frequency: 32613,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d24',
              id: 52,
              frequency: 12029,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d23',
              id: 53,
              frequency: 69559,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d22',
              id: 54,
              frequency: 11041,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d21',
              id: 55,
              frequency: 18301,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d20',
              id: 56,
              frequency: 10219,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d1f',
              id: 57,
              frequency: 124599,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d1e',
              id: 58,
              frequency: 85912,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d1d',
              id: 59,
              frequency: 59377,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d1c',
              id: 60,
              frequency: 131412,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d1b',
              id: 61,
              frequency: 94127,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d1a',
              id: 62,
              frequency: 7505,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d19',
              id: 63,
              frequency: 27218,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d18',
              id: 64,
              frequency: 23356,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d17',
              id: 65,
              frequency: 29818,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d16',
              id: 66,
              frequency: 102020,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d15',
              id: 67,
              frequency: 164409,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d14',
              id: 68,
              frequency: 42671,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d13',
              id: 69,
              frequency: 13695,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d12',
              id: 70,
              frequency: 54769,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d11',
              id: 71,
              frequency: 111895,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1d10',
              id: 72,
              frequency: 64566,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1c7f',
          id: 38,
          abbrevName: '39',
          fullName: '39_L_SPL',
          coordinates: {
            x: -36.4,
            y: -48.161702,
            z: 52.885106,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1c9b',
              to: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c9a',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c99',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c98',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c97',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c96',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c95',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c94',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c93',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c92',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c91',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c90',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c8f',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c8e',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c8d',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c8c',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c8b',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c8a',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c89',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c88',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c87',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c86',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c85',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c84',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c83',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c82',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c81',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c80',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1ce4',
              id: 0,
              frequency: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ce3',
              id: 1,
              frequency: 1018,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ce2',
              id: 2,
              frequency: 384,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ce1',
              id: 3,
              frequency: 744,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ce0',
              id: 4,
              frequency: 12194,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cdf',
              id: 5,
              frequency: 10831,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cde',
              id: 6,
              frequency: 3521,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cdd',
              id: 7,
              frequency: 486,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cdc',
              id: 8,
              frequency: 2678,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cdb',
              id: 9,
              frequency: 8101,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cda',
              id: 10,
              frequency: 14115,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cd9',
              id: 11,
              frequency: 5035,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cd8',
              id: 12,
              frequency: 8772,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cd7',
              id: 13,
              frequency: 6136,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cd6',
              id: 14,
              frequency: 5639,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cd5',
              id: 15,
              frequency: 76313,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cd4',
              id: 16,
              frequency: 69263,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cd3',
              id: 17,
              frequency: 42158,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cd2',
              id: 18,
              frequency: 29154,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cd1',
              id: 19,
              frequency: 43049,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cd0',
              id: 20,
              frequency: 24045,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ccf',
              id: 21,
              frequency: 12138,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cce',
              id: 22,
              frequency: 3626,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ccd',
              id: 23,
              frequency: 101,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ccc',
              id: 24,
              frequency: 79259,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ccb',
              id: 25,
              frequency: 35574,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cca',
              id: 26,
              frequency: 50526,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cc9',
              id: 27,
              frequency: 60729,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cc8',
              id: 28,
              frequency: 63186,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cc7',
              id: 29,
              frequency: 120468,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cc6',
              id: 30,
              frequency: 54873,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cc5',
              id: 31,
              frequency: 23892,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cc4',
              id: 32,
              frequency: 24422,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cc3',
              id: 33,
              frequency: 3203,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cc2',
              id: 34,
              frequency: 24054,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cc1',
              id: 35,
              frequency: 11311,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cc0',
              id: 36,
              frequency: 14504,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cbf',
              id: 37,
              frequency: 27175,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cbe',
              id: 38,
              frequency: 7691,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cbd',
              id: 39,
              frequency: 30450,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cbc',
              id: 40,
              frequency: 62631,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cbb',
              id: 41,
              frequency: 23336,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cba',
              id: 42,
              frequency: 11573,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cb9',
              id: 43,
              frequency: 62694,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cb8',
              id: 44,
              frequency: 9257,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cb7',
              id: 45,
              frequency: 53811,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cb6',
              id: 46,
              frequency: 61666,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cb5',
              id: 47,
              frequency: 45953,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cb4',
              id: 48,
              frequency: 90527,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cb3',
              id: 49,
              frequency: 1986,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cb2',
              id: 50,
              frequency: 878,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cb1',
              id: 51,
              frequency: 46792,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cb0',
              id: 52,
              frequency: 20908,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1caf',
              id: 53,
              frequency: 35439,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cae',
              id: 54,
              frequency: 11621,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cad',
              id: 55,
              frequency: 3487,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cac',
              id: 56,
              frequency: 35633,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1cab',
              id: 57,
              frequency: 87317,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1caa',
              id: 58,
              frequency: 18934,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ca9',
              id: 59,
              frequency: 94331,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ca8',
              id: 60,
              frequency: 80424,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ca7',
              id: 61,
              frequency: 25896,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ca6',
              id: 62,
              frequency: 9572,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ca5',
              id: 63,
              frequency: 16693,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ca4',
              id: 64,
              frequency: 14484,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ca3',
              id: 65,
              frequency: 47300,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ca2',
              id: 66,
              frequency: 71050,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ca1',
              id: 67,
              frequency: 51401,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ca0',
              id: 68,
              frequency: 29554,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c9f',
              id: 69,
              frequency: 4351,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c9e',
              id: 70,
              frequency: 43428,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c9d',
              id: 71,
              frequency: 41044,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c9c',
              id: 72,
              frequency: 25333,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1c1a',
          id: 39,
          abbrevName: '40',
          fullName: '40_L_LOC_superior_occipital_pole',
          coordinates: {
            x: -29.522936,
            y: -85.412844,
            z: 23.394495,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1c35',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c34',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c33',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c32',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c31',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c30',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c2f',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c2e',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c2d',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c2c',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c2b',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c2a',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c29',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c28',
              to: 99,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c27',
              to: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c26',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c25',
              to: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c24',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c23',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c22',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c21',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c20',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c1f',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c1e',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c1d',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c1c',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c1b',
              to: 84,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1c7e',
              id: 0,
              frequency: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c7d',
              id: 1,
              frequency: 953,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c7c',
              id: 2,
              frequency: 167,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c7b',
              id: 3,
              frequency: 613,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c7a',
              id: 4,
              frequency: 13168,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c79',
              id: 5,
              frequency: 5465,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c78',
              id: 6,
              frequency: 4344,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c77',
              id: 7,
              frequency: 102,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c76',
              id: 8,
              frequency: 1283,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c75',
              id: 9,
              frequency: 8080,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c74',
              id: 10,
              frequency: 13966,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c73',
              id: 11,
              frequency: 1498,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c72',
              id: 12,
              frequency: 7585,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c71',
              id: 13,
              frequency: 3044,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c70',
              id: 14,
              frequency: 5236,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c6f',
              id: 15,
              frequency: 98507,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c6e',
              id: 16,
              frequency: 42690,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c6d',
              id: 17,
              frequency: 24321,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c6c',
              id: 18,
              frequency: 35035,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c6b',
              id: 19,
              frequency: 67526,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c6a',
              id: 20,
              frequency: 14928,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c69',
              id: 21,
              frequency: 2688,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c68',
              id: 22,
              frequency: 5607,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c67',
              id: 23,
              frequency: 9,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c66',
              id: 24,
              frequency: 91605,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c65',
              id: 25,
              frequency: 42657,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c64',
              id: 26,
              frequency: 18017,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c63',
              id: 27,
              frequency: 72800,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c62',
              id: 28,
              frequency: 36172,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c61',
              id: 29,
              frequency: 139899,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c60',
              id: 30,
              frequency: 19291,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c5f',
              id: 31,
              frequency: 34633,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c5e',
              id: 32,
              frequency: 32377,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c5d',
              id: 33,
              frequency: 373,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c5c',
              id: 34,
              frequency: 13376,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c5b',
              id: 35,
              frequency: 17092,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c5a',
              id: 36,
              frequency: 7621,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c59',
              id: 37,
              frequency: 17430,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c58',
              id: 38,
              frequency: 2109,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c57',
              id: 39,
              frequency: 37989,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c56',
              id: 40,
              frequency: 74157,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c55',
              id: 41,
              frequency: 14234,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c54',
              id: 42,
              frequency: 2009,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c53',
              id: 43,
              frequency: 71933,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c52',
              id: 44,
              frequency: 1115,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c51',
              id: 45,
              frequency: 59617,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c50',
              id: 46,
              frequency: 62084,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c4f',
              id: 47,
              frequency: 14841,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c4e',
              id: 48,
              frequency: 55030,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c4d',
              id: 49,
              frequency: 1277,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c4c',
              id: 50,
              frequency: 164,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c4b',
              id: 51,
              frequency: 24447,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c4a',
              id: 52,
              frequency: 22856,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c49',
              id: 53,
              frequency: 12508,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c48',
              id: 54,
              frequency: 13985,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c47',
              id: 55,
              frequency: 983,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c46',
              id: 56,
              frequency: 36455,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c45',
              id: 57,
              frequency: 102093,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c44',
              id: 58,
              frequency: 5150,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c43',
              id: 59,
              frequency: 94642,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c42',
              id: 60,
              frequency: 44257,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c41',
              id: 61,
              frequency: 5563,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c40',
              id: 62,
              frequency: 4655,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c3f',
              id: 63,
              frequency: 4873,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c3e',
              id: 64,
              frequency: 8621,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c3d',
              id: 65,
              frequency: 39308,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c3c',
              id: 66,
              frequency: 75500,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c3b',
              id: 67,
              frequency: 19626,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c3a',
              id: 68,
              frequency: 15278,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c39',
              id: 69,
              frequency: 1482,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c38',
              id: 70,
              frequency: 39401,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c37',
              id: 71,
              frequency: 25682,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c36',
              id: 72,
              frequency: 29398,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1bc3',
          id: 40,
          abbrevName: '41',
          fullName: '41_BI_Brainstem',
          coordinates: {
            x: 3.032727,
            y: -45.098182,
            z: -55.098182,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1bd0',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bcf',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bce',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bcd',
              to: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bcc',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bcb',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bca',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bc9',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bc8',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bc7',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bc6',
              to: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bc5',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bc4',
              to: 47,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1c19',
              id: 0,
              frequency: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c18',
              id: 1,
              frequency: 766,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c17',
              id: 2,
              frequency: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c16',
              id: 3,
              frequency: 166,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c15',
              id: 4,
              frequency: 12286,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c14',
              id: 5,
              frequency: 2605,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c13',
              id: 6,
              frequency: 5679,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c12',
              id: 7,
              frequency: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c11',
              id: 8,
              frequency: 622,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c10',
              id: 9,
              frequency: 9390,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c0f',
              id: 10,
              frequency: 5541,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c0e',
              id: 11,
              frequency: 371,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c0d',
              id: 12,
              frequency: 3348,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c0c',
              id: 13,
              frequency: 465,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c0b',
              id: 14,
              frequency: 673,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c0a',
              id: 15,
              frequency: 115009,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c09',
              id: 16,
              frequency: 30469,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c08',
              id: 17,
              frequency: 11764,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c07',
              id: 18,
              frequency: 36444,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c06',
              id: 19,
              frequency: 103421,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c05',
              id: 20,
              frequency: 12116,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c04',
              id: 21,
              frequency: 1176,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c03',
              id: 22,
              frequency: 9673,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c02',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c01',
              id: 24,
              frequency: 116490,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1c00',
              id: 25,
              frequency: 24243,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bff',
              id: 26,
              frequency: 8332,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bfe',
              id: 27,
              frequency: 87889,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bfd',
              id: 28,
              frequency: 23515,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bfc',
              id: 29,
              frequency: 56275,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bfb',
              id: 30,
              frequency: 3668,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bfa',
              id: 31,
              frequency: 73107,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bf9',
              id: 32,
              frequency: 19631,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bf8',
              id: 33,
              frequency: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bf7',
              id: 34,
              frequency: 6303,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bf6',
              id: 35,
              frequency: 24561,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bf5',
              id: 36,
              frequency: 5146,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bf4',
              id: 37,
              frequency: 11312,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bf3',
              id: 38,
              frequency: 663,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bf2',
              id: 39,
              frequency: 68804,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bf1',
              id: 40,
              frequency: 49634,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bf0',
              id: 41,
              frequency: 4499,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bef',
              id: 42,
              frequency: 336,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bee',
              id: 43,
              frequency: 41717,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bed',
              id: 44,
              frequency: 220,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bec',
              id: 45,
              frequency: 76569,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1beb',
              id: 46,
              frequency: 26370,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bea',
              id: 47,
              frequency: 5352,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1be9',
              id: 48,
              frequency: 9068,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1be8',
              id: 49,
              frequency: 932,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1be7',
              id: 50,
              frequency: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1be6',
              id: 51,
              frequency: 14112,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1be5',
              id: 52,
              frequency: 12176,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1be4',
              id: 53,
              frequency: 3004,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1be3',
              id: 54,
              frequency: 12351,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1be2',
              id: 55,
              frequency: 123,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1be1',
              id: 56,
              frequency: 60798,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1be0',
              id: 57,
              frequency: 17059,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bdf',
              id: 58,
              frequency: 888,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bde',
              id: 59,
              frequency: 57160,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bdd',
              id: 60,
              frequency: 9978,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bdc',
              id: 61,
              frequency: 604,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bdb',
              id: 62,
              frequency: 3110,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bda',
              id: 63,
              frequency: 1497,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bd9',
              id: 64,
              frequency: 1851,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bd8',
              id: 65,
              frequency: 27233,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bd7',
              id: 66,
              frequency: 16810,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bd6',
              id: 67,
              frequency: 1495,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bd5',
              id: 68,
              frequency: 3706,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bd4',
              id: 69,
              frequency: 106,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bd3',
              id: 70,
              frequency: 8637,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bd2',
              id: 71,
              frequency: 1754,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bd1',
              id: 72,
              frequency: 1724,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1b57',
          id: 41,
          abbrevName: '42',
          fullName: '42_R_SFG__mfg',
          coordinates: {
            x: 26.206573,
            y: -6.131455,
            z: 64.206573,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1b79',
              to: 42,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b78',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b77',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b76',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b75',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b74',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b73',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b72',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b71',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b70',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b6f',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b6e',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b6d',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b6c',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b6b',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b6a',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b69',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b68',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b67',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b66',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b65',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b64',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b63',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b62',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b61',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b60',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b5f',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b5e',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b5d',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b5c',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b5b',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b5a',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b59',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b58',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1bc2',
              id: 0,
              frequency: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bc1',
              id: 1,
              frequency: 839,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bc0',
              id: 2,
              frequency: 438,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bbf',
              id: 3,
              frequency: 1047,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bbe',
              id: 4,
              frequency: 10271,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bbd',
              id: 5,
              frequency: 9697,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bbc',
              id: 6,
              frequency: 2378,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bbb',
              id: 7,
              frequency: 440,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bba',
              id: 8,
              frequency: 1963,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bb9',
              id: 9,
              frequency: 5550,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bb8',
              id: 10,
              frequency: 16987,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bb7',
              id: 11,
              frequency: 6349,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bb6',
              id: 12,
              frequency: 7348,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bb5',
              id: 13,
              frequency: 9196,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bb4',
              id: 14,
              frequency: 10250,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bb3',
              id: 15,
              frequency: 54633,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bb2',
              id: 16,
              frequency: 77538,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bb1',
              id: 17,
              frequency: 20287,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bb0',
              id: 18,
              frequency: 23153,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1baf',
              id: 19,
              frequency: 25978,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bae',
              id: 20,
              frequency: 19541,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bad',
              id: 21,
              frequency: 9154,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bac',
              id: 22,
              frequency: 2225,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1bab',
              id: 23,
              frequency: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1baa',
              id: 24,
              frequency: 45818,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ba9',
              id: 25,
              frequency: 24340,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ba8',
              id: 26,
              frequency: 59601,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ba7',
              id: 27,
              frequency: 53467,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ba6',
              id: 28,
              frequency: 51040,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ba5',
              id: 29,
              frequency: 163027,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ba4',
              id: 30,
              frequency: 55862,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ba3',
              id: 31,
              frequency: 13767,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ba2',
              id: 32,
              frequency: 29722,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ba1',
              id: 33,
              frequency: 2695,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ba0',
              id: 34,
              frequency: 17939,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b9f',
              id: 35,
              frequency: 7819,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b9e',
              id: 36,
              frequency: 11711,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b9d',
              id: 37,
              frequency: 16126,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b9c',
              id: 38,
              frequency: 5122,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b9b',
              id: 39,
              frequency: 18636,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b9a',
              id: 40,
              frequency: 44379,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b99',
              id: 41,
              frequency: 34559,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b98',
              id: 42,
              frequency: 12701,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b97',
              id: 43,
              frequency: 75267,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b96',
              id: 44,
              frequency: 12123,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b95',
              id: 45,
              frequency: 38410,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b94',
              id: 46,
              frequency: 55142,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b93',
              id: 47,
              frequency: 38223,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b92',
              id: 48,
              frequency: 120482,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b91',
              id: 49,
              frequency: 1282,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b90',
              id: 50,
              frequency: 389,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b8f',
              id: 51,
              frequency: 29367,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b8e',
              id: 52,
              frequency: 19194,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b8d',
              id: 53,
              frequency: 34140,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b8c',
              id: 54,
              frequency: 8040,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b8b',
              id: 55,
              frequency: 4585,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b8a',
              id: 56,
              frequency: 21816,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b89',
              id: 57,
              frequency: 152328,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b88',
              id: 58,
              frequency: 29123,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b87',
              id: 59,
              frequency: 76730,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b86',
              id: 60,
              frequency: 82996,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b85',
              id: 61,
              frequency: 37252,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b84',
              id: 62,
              frequency: 5152,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b83',
              id: 63,
              frequency: 11313,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b82',
              id: 64,
              frequency: 18058,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b81',
              id: 65,
              frequency: 28496,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b80',
              id: 66,
              frequency: 96601,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b7f',
              id: 67,
              frequency: 88991,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b7e',
              id: 68,
              frequency: 22926,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b7d',
              id: 69,
              frequency: 8292,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b7c',
              id: 70,
              frequency: 38153,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b7b',
              id: 71,
              frequency: 83041,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b7a',
              id: 72,
              frequency: 62201,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1aec',
          id: 42,
          abbrevName: '43',
          fullName: '43_R_Planum_polare_operculum',
          coordinates: {
            x: 50.172249,
            y: -1.655502,
            z: -3.311005,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1b0d',
              to: 44,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b0c',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b0b',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b0a',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b09',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b08',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b07',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b06',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b05',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b04',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b03',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b02',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b01',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b00',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1aff',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1afe',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1afd',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1afc',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1afb',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1afa',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1af9',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1af8',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1af7',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1af6',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1af5',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1af4',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1af3',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1af2',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1af1',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1af0',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1aef',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1aee',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1aed',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1b56',
              id: 0,
              frequency: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b55',
              id: 1,
              frequency: 963,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b54',
              id: 2,
              frequency: 421,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b53',
              id: 3,
              frequency: 905,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b52',
              id: 4,
              frequency: 10434,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b51',
              id: 5,
              frequency: 11001,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b50',
              id: 6,
              frequency: 3473,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b4f',
              id: 7,
              frequency: 715,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b4e',
              id: 8,
              frequency: 2589,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b4d',
              id: 9,
              frequency: 6776,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b4c',
              id: 10,
              frequency: 16246,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b4b',
              id: 11,
              frequency: 5691,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b4a',
              id: 12,
              frequency: 8344,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b49',
              id: 13,
              frequency: 7523,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b48',
              id: 14,
              frequency: 8171,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b47',
              id: 15,
              frequency: 61525,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b46',
              id: 16,
              frequency: 65882,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b45',
              id: 17,
              frequency: 37188,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b44',
              id: 18,
              frequency: 18997,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b43',
              id: 19,
              frequency: 37858,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b42',
              id: 20,
              frequency: 27088,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b41',
              id: 21,
              frequency: 17323,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b40',
              id: 22,
              frequency: 4562,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b3f',
              id: 23,
              frequency: 174,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b3e',
              id: 24,
              frequency: 56964,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b3d',
              id: 25,
              frequency: 32232,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b3c',
              id: 26,
              frequency: 55185,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b3b',
              id: 27,
              frequency: 48724,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b3a',
              id: 28,
              frequency: 59041,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b39',
              id: 29,
              frequency: 133771,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b38',
              id: 30,
              frequency: 62287,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b37',
              id: 31,
              frequency: 21886,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b36',
              id: 32,
              frequency: 33065,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b35',
              id: 33,
              frequency: 5874,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b34',
              id: 34,
              frequency: 20763,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b33',
              id: 35,
              frequency: 9840,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b32',
              id: 36,
              frequency: 12314,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b31',
              id: 37,
              frequency: 26107,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b30',
              id: 38,
              frequency: 9724,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b2f',
              id: 39,
              frequency: 24843,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b2e',
              id: 40,
              frequency: 63105,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b2d',
              id: 41,
              frequency: 27637,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b2c',
              id: 42,
              frequency: 16557,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b2b',
              id: 43,
              frequency: 71092,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b2a',
              id: 44,
              frequency: 9511,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b29',
              id: 45,
              frequency: 41928,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b28',
              id: 46,
              frequency: 51717,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b27',
              id: 47,
              frequency: 42834,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b26',
              id: 48,
              frequency: 111751,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b25',
              id: 49,
              frequency: 1811,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b24',
              id: 50,
              frequency: 1399,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b23',
              id: 51,
              frequency: 40474,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b22',
              id: 52,
              frequency: 19425,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b21',
              id: 53,
              frequency: 36525,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b20',
              id: 54,
              frequency: 12068,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b1f',
              id: 55,
              frequency: 6034,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b1e',
              id: 56,
              frequency: 26328,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b1d',
              id: 57,
              frequency: 127594,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b1c',
              id: 58,
              frequency: 23790,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b1b',
              id: 59,
              frequency: 83569,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b1a',
              id: 60,
              frequency: 82253,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b19',
              id: 61,
              frequency: 27863,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b18',
              id: 62,
              frequency: 8444,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b17',
              id: 63,
              frequency: 16447,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b16',
              id: 64,
              frequency: 17996,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b15',
              id: 65,
              frequency: 37256,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b14',
              id: 66,
              frequency: 90066,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b13',
              id: 67,
              frequency: 68857,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b12',
              id: 68,
              frequency: 28114,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b11',
              id: 69,
              frequency: 4862,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b10',
              id: 70,
              frequency: 43124,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b0f',
              id: 71,
              frequency: 60540,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1b0e',
              id: 72,
              frequency: 46663,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1a8e',
          id: 43,
          abbrevName: '44',
          fullName: '44_L_Cerebellum_maybe_other',
          coordinates: {
            x: -39.711712,
            y: -47.63964,
            z: -46.216216,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1aa2',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1aa1',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1aa0',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a9f',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a9e',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a9d',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a9c',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a9b',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a9a',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a99',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a98',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a97',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a96',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a95',
              to: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a94',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a93',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a92',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a91',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a90',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a8f',
              to: 62,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1aeb',
              id: 0,
              frequency: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1aea',
              id: 1,
              frequency: 1054,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ae9',
              id: 2,
              frequency: 278,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ae8',
              id: 3,
              frequency: 502,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ae7',
              id: 4,
              frequency: 13354,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ae6',
              id: 5,
              frequency: 8842,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ae5',
              id: 6,
              frequency: 5169,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ae4',
              id: 7,
              frequency: 370,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ae3',
              id: 8,
              frequency: 2739,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ae2',
              id: 9,
              frequency: 9849,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ae1',
              id: 10,
              frequency: 11338,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ae0',
              id: 11,
              frequency: 3058,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1adf',
              id: 12,
              frequency: 7724,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ade',
              id: 13,
              frequency: 3338,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1add',
              id: 14,
              frequency: 3114,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1adc',
              id: 15,
              frequency: 89547,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1adb',
              id: 16,
              frequency: 60959,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ada',
              id: 17,
              frequency: 38147,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ad9',
              id: 18,
              frequency: 31583,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ad8',
              id: 19,
              frequency: 76618,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ad7',
              id: 20,
              frequency: 24922,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ad6',
              id: 21,
              frequency: 10352,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ad5',
              id: 22,
              frequency: 6727,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ad4',
              id: 23,
              frequency: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ad3',
              id: 24,
              frequency: 98364,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ad2',
              id: 25,
              frequency: 32819,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ad1',
              id: 26,
              frequency: 35324,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ad0',
              id: 27,
              frequency: 72578,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1acf',
              id: 28,
              frequency: 57939,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ace',
              id: 29,
              frequency: 105644,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1acd',
              id: 30,
              frequency: 33917,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1acc',
              id: 31,
              frequency: 46400,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1acb',
              id: 32,
              frequency: 24433,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1aca',
              id: 33,
              frequency: 2638,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ac9',
              id: 34,
              frequency: 21050,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ac8',
              id: 35,
              frequency: 17362,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ac7',
              id: 36,
              frequency: 13775,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ac6',
              id: 37,
              frequency: 35457,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ac5',
              id: 38,
              frequency: 6585,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ac4',
              id: 39,
              frequency: 47531,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ac3',
              id: 40,
              frequency: 72629,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ac2',
              id: 41,
              frequency: 15212,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ac1',
              id: 42,
              frequency: 6271,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ac0',
              id: 43,
              frequency: 58929,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1abf',
              id: 44,
              frequency: 4890,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1abe',
              id: 45,
              frequency: 66996,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1abd',
              id: 46,
              frequency: 53129,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1abc',
              id: 47,
              frequency: 32417,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1abb',
              id: 48,
              frequency: 52485,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1aba',
              id: 49,
              frequency: 3665,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ab9',
              id: 50,
              frequency: 1007,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ab8',
              id: 51,
              frequency: 51051,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ab7',
              id: 52,
              frequency: 17955,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ab6',
              id: 53,
              frequency: 28495,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ab5',
              id: 54,
              frequency: 18410,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ab4',
              id: 55,
              frequency: 1943,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ab3',
              id: 56,
              frequency: 50167,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ab2',
              id: 57,
              frequency: 55055,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ab1',
              id: 58,
              frequency: 9849,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1ab0',
              id: 59,
              frequency: 91334,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1aaf',
              id: 60,
              frequency: 53150,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1aae',
              id: 61,
              frequency: 11288,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1aad',
              id: 62,
              frequency: 12826,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1aac',
              id: 63,
              frequency: 16047,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1aab',
              id: 64,
              frequency: 10847,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1aaa',
              id: 65,
              frequency: 49603,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1aa9',
              id: 66,
              frequency: 49581,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1aa8',
              id: 67,
              frequency: 23645,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1aa7',
              id: 68,
              frequency: 23040,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1aa6',
              id: 69,
              frequency: 1570,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1aa5',
              id: 70,
              frequency: 32079,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1aa4',
              id: 71,
              frequency: 17630,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1aa3',
              id: 72,
              frequency: 11616,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1a2d',
          id: 44,
          abbrevName: '45',
          fullName: '45_L_Precentral_gyrus_postcentral_gyrus',
          coordinates: {
            x: -58.374384,
            y: -9.152709,
            z: 23.901478,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1a44',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a43',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a42',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a41',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a40',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a3f',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a3e',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a3d',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a3c',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a3b',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a3a',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a39',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a38',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a37',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a36',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a35',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a34',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a33',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a32',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a31',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a30',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a2f',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a2e',
              to: 63,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1a8d',
              id: 0,
              frequency: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a8c',
              id: 1,
              frequency: 872,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a8b',
              id: 2,
              frequency: 141,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a8a',
              id: 3,
              frequency: 600,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a89',
              id: 4,
              frequency: 14292,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a88',
              id: 5,
              frequency: 4293,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a87',
              id: 6,
              frequency: 3188,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a86',
              id: 7,
              frequency: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a85',
              id: 8,
              frequency: 1002,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a84',
              id: 9,
              frequency: 7672,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a83',
              id: 10,
              frequency: 13149,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a82',
              id: 11,
              frequency: 1134,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a81',
              id: 12,
              frequency: 6845,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a80',
              id: 13,
              frequency: 2811,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a7f',
              id: 14,
              frequency: 5148,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a7e',
              id: 15,
              frequency: 113449,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a7d',
              id: 16,
              frequency: 43019,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a7c',
              id: 17,
              frequency: 16295,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a7b',
              id: 18,
              frequency: 44621,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a7a',
              id: 19,
              frequency: 53989,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a79',
              id: 20,
              frequency: 9015,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a78',
              id: 21,
              frequency: 1233,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a77',
              id: 22,
              frequency: 2599,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a76',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a75',
              id: 24,
              frequency: 96543,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a74',
              id: 25,
              frequency: 33237,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a73',
              id: 26,
              frequency: 13129,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a72',
              id: 27,
              frequency: 89030,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a71',
              id: 28,
              frequency: 29172,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a70',
              id: 29,
              frequency: 160174,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a6f',
              id: 30,
              frequency: 13322,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a6e',
              id: 31,
              frequency: 24404,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a6d',
              id: 32,
              frequency: 25542,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a6c',
              id: 33,
              frequency: 111,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a6b',
              id: 34,
              frequency: 11772,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a6a',
              id: 35,
              frequency: 16452,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a69',
              id: 36,
              frequency: 8107,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a68',
              id: 37,
              frequency: 10798,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a67',
              id: 38,
              frequency: 776,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a66',
              id: 39,
              frequency: 34155,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a65',
              id: 40,
              frequency: 55421,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a64',
              id: 41,
              frequency: 13928,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a63',
              id: 42,
              frequency: 809,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a62',
              id: 43,
              frequency: 72289,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a61',
              id: 44,
              frequency: 1055,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a60',
              id: 45,
              frequency: 66998,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a5f',
              id: 46,
              frequency: 71248,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a5e',
              id: 47,
              frequency: 10443,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a5d',
              id: 48,
              frequency: 48651,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a5c',
              id: 49,
              frequency: 810,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a5b',
              id: 50,
              frequency: 111,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a5a',
              id: 51,
              frequency: 19628,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a59',
              id: 52,
              frequency: 23083,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a58',
              id: 53,
              frequency: 8033,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a57',
              id: 54,
              frequency: 9374,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a56',
              id: 55,
              frequency: 625,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a55',
              id: 56,
              frequency: 37380,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a54',
              id: 57,
              frequency: 98747,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a53',
              id: 58,
              frequency: 2990,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a52',
              id: 59,
              frequency: 91855,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a51',
              id: 60,
              frequency: 37480,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a50',
              id: 61,
              frequency: 4127,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a4f',
              id: 62,
              frequency: 3624,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a4e',
              id: 63,
              frequency: 3575,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a4d',
              id: 64,
              frequency: 7851,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a4c',
              id: 65,
              frequency: 35672,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a4b',
              id: 66,
              frequency: 69084,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a4a',
              id: 67,
              frequency: 17540,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a49',
              id: 68,
              frequency: 12931,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a48',
              id: 69,
              frequency: 1330,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a47',
              id: 70,
              frequency: 35607,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a46',
              id: 71,
              frequency: 24929,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a45',
              id: 72,
              frequency: 28735,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a19c7',
          id: 45,
          abbrevName: '46',
          fullName: '46_L_Precuneous_pcc',
          coordinates: {
            x: -9.727599,
            y: -62.043011,
            z: 11.111111,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a19e3',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19e2',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19e1',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19e0',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19df',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19de',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19dd',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19dc',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19db',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19da',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19d9',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19d8',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19d7',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19d6',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19d5',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19d4',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19d3',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19d2',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19d1',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19d0',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19cf',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19ce',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19cd',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19cc',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19cb',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19ca',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19c9',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19c8',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1a2c',
              id: 0,
              frequency: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a2b',
              id: 1,
              frequency: 1019,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a2a',
              id: 2,
              frequency: 395,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a29',
              id: 3,
              frequency: 733,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a28',
              id: 4,
              frequency: 12169,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a27',
              id: 5,
              frequency: 11165,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a26',
              id: 6,
              frequency: 3704,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a25',
              id: 7,
              frequency: 717,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a24',
              id: 8,
              frequency: 2250,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a23',
              id: 9,
              frequency: 7979,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a22',
              id: 10,
              frequency: 15172,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a21',
              id: 11,
              frequency: 5047,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a20',
              id: 12,
              frequency: 8528,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a1f',
              id: 13,
              frequency: 5925,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a1e',
              id: 14,
              frequency: 5607,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a1d',
              id: 15,
              frequency: 75398,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a1c',
              id: 16,
              frequency: 82763,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a1b',
              id: 17,
              frequency: 45803,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a1a',
              id: 18,
              frequency: 21110,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a19',
              id: 19,
              frequency: 49419,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a18',
              id: 20,
              frequency: 23336,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a17',
              id: 21,
              frequency: 19631,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a16',
              id: 22,
              frequency: 3940,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a15',
              id: 23,
              frequency: 338,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a14',
              id: 24,
              frequency: 71225,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a13',
              id: 25,
              frequency: 44963,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a12',
              id: 26,
              frequency: 61642,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a11',
              id: 27,
              frequency: 65118,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a10',
              id: 28,
              frequency: 65682,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a0f',
              id: 29,
              frequency: 123036,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a0e',
              id: 30,
              frequency: 51199,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a0d',
              id: 31,
              frequency: 25600,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a0c',
              id: 32,
              frequency: 29480,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a0b',
              id: 33,
              frequency: 5779,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a0a',
              id: 34,
              frequency: 23420,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a09',
              id: 35,
              frequency: 12263,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a08',
              id: 36,
              frequency: 13061,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a07',
              id: 37,
              frequency: 23605,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a06',
              id: 38,
              frequency: 9131,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a05',
              id: 39,
              frequency: 28001,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a04',
              id: 40,
              frequency: 69791,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a03',
              id: 41,
              frequency: 31226,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a02',
              id: 42,
              frequency: 14793,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a01',
              id: 43,
              frequency: 71307,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1a00',
              id: 44,
              frequency: 8464,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19ff',
              id: 45,
              frequency: 56389,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19fe',
              id: 46,
              frequency: 56692,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19fd',
              id: 47,
              frequency: 47159,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19fc',
              id: 48,
              frequency: 88068,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19fb',
              id: 49,
              frequency: 1508,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19fa',
              id: 50,
              frequency: 899,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19f9',
              id: 51,
              frequency: 39316,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19f8',
              id: 52,
              frequency: 22728,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19f7',
              id: 53,
              frequency: 29151,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19f6',
              id: 54,
              frequency: 12430,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19f5',
              id: 55,
              frequency: 4562,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19f4',
              id: 56,
              frequency: 35625,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19f3',
              id: 57,
              frequency: 95920,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19f2',
              id: 58,
              frequency: 19051,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19f1',
              id: 59,
              frequency: 95026,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19f0',
              id: 60,
              frequency: 80489,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19ef',
              id: 61,
              frequency: 22784,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19ee',
              id: 62,
              frequency: 7232,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19ed',
              id: 63,
              frequency: 12710,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19ec',
              id: 64,
              frequency: 13097,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19eb',
              id: 65,
              frequency: 44609,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19ea',
              id: 66,
              frequency: 79038,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19e9',
              id: 67,
              frequency: 49394,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19e8',
              id: 68,
              frequency: 24004,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19e7',
              id: 69,
              frequency: 3540,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19e6',
              id: 70,
              frequency: 41628,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19e5',
              id: 71,
              frequency: 39815,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19e4',
              id: 72,
              frequency: 26060,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1968',
          id: 46,
          abbrevName: '47',
          fullName: '47_R_frontal_pole/MFG',
          coordinates: {
            x: 37.418182,
            y: 38.484848,
            z: 29.793939,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a197d',
              to: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a197c',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a197b',
              to: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a197a',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1979',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1978',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1977',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1976',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1975',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1974',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1973',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1972',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1971',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1970',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a196f',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a196e',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a196d',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a196c',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a196b',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a196a',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1969',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a19c6',
              id: 0,
              frequency: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19c5',
              id: 1,
              frequency: 974,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19c4',
              id: 2,
              frequency: 321,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19c3',
              id: 3,
              frequency: 669,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19c2',
              id: 4,
              frequency: 13390,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19c1',
              id: 5,
              frequency: 9640,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19c0',
              id: 6,
              frequency: 2931,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19bf',
              id: 7,
              frequency: 457,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19be',
              id: 8,
              frequency: 2321,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19bd',
              id: 9,
              frequency: 8711,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19bc',
              id: 10,
              frequency: 14058,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19bb',
              id: 11,
              frequency: 3658,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19ba',
              id: 12,
              frequency: 7258,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19b9',
              id: 13,
              frequency: 5116,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19b8',
              id: 14,
              frequency: 4959,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19b7',
              id: 15,
              frequency: 80610,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19b6',
              id: 16,
              frequency: 68184,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19b5',
              id: 17,
              frequency: 37968,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19b4',
              id: 18,
              frequency: 34808,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19b3',
              id: 19,
              frequency: 41537,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19b2',
              id: 20,
              frequency: 18315,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19b1',
              id: 21,
              frequency: 12006,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19b0',
              id: 22,
              frequency: 2484,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19af',
              id: 23,
              frequency: 123,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19ae',
              id: 24,
              frequency: 86354,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19ad',
              id: 25,
              frequency: 34261,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19ac',
              id: 26,
              frequency: 40809,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19ab',
              id: 27,
              frequency: 79687,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19aa',
              id: 28,
              frequency: 63551,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19a9',
              id: 29,
              frequency: 138801,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19a8',
              id: 30,
              frequency: 43576,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19a7',
              id: 31,
              frequency: 20215,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19a6',
              id: 32,
              frequency: 23934,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19a5',
              id: 33,
              frequency: 2822,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19a4',
              id: 34,
              frequency: 25612,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19a3',
              id: 35,
              frequency: 10384,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19a2',
              id: 36,
              frequency: 13697,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19a1',
              id: 37,
              frequency: 20343,
            },
            {
              _id: '5d6615769bcb6d0e6d7a19a0',
              id: 38,
              frequency: 7863,
            },
            {
              _id: '5d6615769bcb6d0e6d7a199f',
              id: 39,
              frequency: 29627,
            },
            {
              _id: '5d6615769bcb6d0e6d7a199e',
              id: 40,
              frequency: 48168,
            },
            {
              _id: '5d6615769bcb6d0e6d7a199d',
              id: 41,
              frequency: 20516,
            },
            {
              _id: '5d6615769bcb6d0e6d7a199c',
              id: 42,
              frequency: 9473,
            },
            {
              _id: '5d6615769bcb6d0e6d7a199b',
              id: 43,
              frequency: 74838,
            },
            {
              _id: '5d6615769bcb6d0e6d7a199a',
              id: 44,
              frequency: 5205,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1999',
              id: 45,
              frequency: 67691,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1998',
              id: 46,
              frequency: 58201,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1997',
              id: 47,
              frequency: 33031,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1996',
              id: 48,
              frequency: 86100,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1995',
              id: 49,
              frequency: 1537,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1994',
              id: 50,
              frequency: 1068,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1993',
              id: 51,
              frequency: 46541,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1992',
              id: 52,
              frequency: 23179,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1991',
              id: 53,
              frequency: 28493,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1990',
              id: 54,
              frequency: 7565,
            },
            {
              _id: '5d6615769bcb6d0e6d7a198f',
              id: 55,
              frequency: 3585,
            },
            {
              _id: '5d6615769bcb6d0e6d7a198e',
              id: 56,
              frequency: 46604,
            },
            {
              _id: '5d6615769bcb6d0e6d7a198d',
              id: 57,
              frequency: 88700,
            },
            {
              _id: '5d6615769bcb6d0e6d7a198c',
              id: 58,
              frequency: 11776,
            },
            {
              _id: '5d6615769bcb6d0e6d7a198b',
              id: 59,
              frequency: 94256,
            },
            {
              _id: '5d6615769bcb6d0e6d7a198a',
              id: 60,
              frequency: 66166,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1989',
              id: 61,
              frequency: 17101,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1988',
              id: 62,
              frequency: 9842,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1987',
              id: 63,
              frequency: 11768,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1986',
              id: 64,
              frequency: 14853,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1985',
              id: 65,
              frequency: 42207,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1984',
              id: 66,
              frequency: 67394,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1983',
              id: 67,
              frequency: 38696,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1982',
              id: 68,
              frequency: 21854,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1981',
              id: 69,
              frequency: 3334,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1980',
              id: 70,
              frequency: 30009,
            },
            {
              _id: '5d6615769bcb6d0e6d7a197f',
              id: 71,
              frequency: 34857,
            },
            {
              _id: '5d6615769bcb6d0e6d7a197e',
              id: 72,
              frequency: 22023,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1910',
          id: 47,
          abbrevName: '48',
          fullName:
            '48_L_Temporal_fusiform_cortex_anterior__temporal_fusiform_posterior',
          coordinates: {
            x: -31.82069,
            y: 2.027586,
            z: -41.02069,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a191e',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a191d',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a191c',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a191b',
              to: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d7a191a',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1919',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1918',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1917',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1916',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1915',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1914',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1913',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1912',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1911',
              to: 55,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1967',
              id: 0,
              frequency: 25,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1966',
              id: 1,
              frequency: 829,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1965',
              id: 2,
              frequency: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1964',
              id: 3,
              frequency: 213,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1963',
              id: 4,
              frequency: 12269,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1962',
              id: 5,
              frequency: 3630,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1961',
              id: 6,
              frequency: 6223,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1960',
              id: 7,
              frequency: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a195f',
              id: 8,
              frequency: 799,
            },
            {
              _id: '5d6615769bcb6d0e6d7a195e',
              id: 9,
              frequency: 9819,
            },
            {
              _id: '5d6615769bcb6d0e6d7a195d',
              id: 10,
              frequency: 6374,
            },
            {
              _id: '5d6615769bcb6d0e6d7a195c',
              id: 11,
              frequency: 510,
            },
            {
              _id: '5d6615769bcb6d0e6d7a195b',
              id: 12,
              frequency: 4147,
            },
            {
              _id: '5d6615769bcb6d0e6d7a195a',
              id: 13,
              frequency: 780,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1959',
              id: 14,
              frequency: 943,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1958',
              id: 15,
              frequency: 109447,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1957',
              id: 16,
              frequency: 34238,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1956',
              id: 17,
              frequency: 16395,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1955',
              id: 18,
              frequency: 32432,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1954',
              id: 19,
              frequency: 108861,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1953',
              id: 20,
              frequency: 18773,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1952',
              id: 21,
              frequency: 2790,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1951',
              id: 22,
              frequency: 12962,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1950',
              id: 23,
              frequency: 9,
            },
            {
              _id: '5d6615769bcb6d0e6d7a194f',
              id: 24,
              frequency: 121071,
            },
            {
              _id: '5d6615769bcb6d0e6d7a194e',
              id: 25,
              frequency: 23131,
            },
            {
              _id: '5d6615769bcb6d0e6d7a194d',
              id: 26,
              frequency: 9419,
            },
            {
              _id: '5d6615769bcb6d0e6d7a194c',
              id: 27,
              frequency: 80372,
            },
            {
              _id: '5d6615769bcb6d0e6d7a194b',
              id: 28,
              frequency: 35213,
            },
            {
              _id: '5d6615769bcb6d0e6d7a194a',
              id: 29,
              frequency: 69540,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1949',
              id: 30,
              frequency: 7139,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1948',
              id: 31,
              frequency: 74459,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1947',
              id: 32,
              frequency: 22247,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1946',
              id: 33,
              frequency: 218,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1945',
              id: 34,
              frequency: 7932,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1944',
              id: 35,
              frequency: 25376,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1943',
              id: 36,
              frequency: 5181,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1942',
              id: 37,
              frequency: 15249,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1941',
              id: 38,
              frequency: 1116,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1940',
              id: 39,
              frequency: 69712,
            },
            {
              _id: '5d6615769bcb6d0e6d7a193f',
              id: 40,
              frequency: 58025,
            },
            {
              _id: '5d6615769bcb6d0e6d7a193e',
              id: 41,
              frequency: 5855,
            },
            {
              _id: '5d6615769bcb6d0e6d7a193d',
              id: 42,
              frequency: 691,
            },
            {
              _id: '5d6615769bcb6d0e6d7a193c',
              id: 43,
              frequency: 45113,
            },
            {
              _id: '5d6615769bcb6d0e6d7a193b',
              id: 44,
              frequency: 317,
            },
            {
              _id: '5d6615769bcb6d0e6d7a193a',
              id: 45,
              frequency: 75918,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1939',
              id: 46,
              frequency: 31203,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1938',
              id: 47,
              frequency: 7326,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1937',
              id: 48,
              frequency: 15758,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1936',
              id: 49,
              frequency: 1515,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1935',
              id: 50,
              frequency: 128,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1934',
              id: 51,
              frequency: 18374,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1933',
              id: 52,
              frequency: 11098,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1932',
              id: 53,
              frequency: 4646,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1931',
              id: 54,
              frequency: 16014,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1930',
              id: 55,
              frequency: 311,
            },
            {
              _id: '5d6615769bcb6d0e6d7a192f',
              id: 56,
              frequency: 60962,
            },
            {
              _id: '5d6615769bcb6d0e6d7a192e',
              id: 57,
              frequency: 22070,
            },
            {
              _id: '5d6615769bcb6d0e6d7a192d',
              id: 58,
              frequency: 894,
            },
            {
              _id: '5d6615769bcb6d0e6d7a192c',
              id: 59,
              frequency: 61476,
            },
            {
              _id: '5d6615769bcb6d0e6d7a192b',
              id: 60,
              frequency: 16925,
            },
            {
              _id: '5d6615769bcb6d0e6d7a192a',
              id: 61,
              frequency: 1090,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1929',
              id: 62,
              frequency: 3927,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1928',
              id: 63,
              frequency: 2183,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1927',
              id: 64,
              frequency: 2239,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1926',
              id: 65,
              frequency: 33813,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1925',
              id: 66,
              frequency: 19763,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1924',
              id: 67,
              frequency: 3272,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1923',
              id: 68,
              frequency: 5626,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1922',
              id: 69,
              frequency: 152,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1921',
              id: 70,
              frequency: 12644,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1920',
              id: 71,
              frequency: 3102,
            },
            {
              _id: '5d6615769bcb6d0e6d7a191f',
              id: 72,
              frequency: 2594,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a18ac',
          id: 48,
          abbrevName: '49',
          fullName: '49_R_ITG_temporooccipital',
          coordinates: {
            x: 52.654028,
            y: -51.516588,
            z: -14.540284,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a18c6',
              to: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18c5',
              to: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18c4',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18c3',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18c2',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18c1',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18c0',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18bf',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18be',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18bd',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18bc',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18bb',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18ba',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18b9',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18b8',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18b7',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18b6',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18b5',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18b4',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18b3',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18b2',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18b1',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18b0',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18af',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18ae',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18ad',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a190f',
              id: 0,
              frequency: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a190e',
              id: 1,
              frequency: 971,
            },
            {
              _id: '5d6615769bcb6d0e6d7a190d',
              id: 2,
              frequency: 442,
            },
            {
              _id: '5d6615769bcb6d0e6d7a190c',
              id: 3,
              frequency: 884,
            },
            {
              _id: '5d6615769bcb6d0e6d7a190b',
              id: 4,
              frequency: 11191,
            },
            {
              _id: '5d6615769bcb6d0e6d7a190a',
              id: 5,
              frequency: 10940,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1909',
              id: 6,
              frequency: 3258,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1908',
              id: 7,
              frequency: 791,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1907',
              id: 8,
              frequency: 2693,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1906',
              id: 9,
              frequency: 6642,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1905',
              id: 10,
              frequency: 15541,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1904',
              id: 11,
              frequency: 6110,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1903',
              id: 12,
              frequency: 8827,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1902',
              id: 13,
              frequency: 7507,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1901',
              id: 14,
              frequency: 7692,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1900',
              id: 15,
              frequency: 61004,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18ff',
              id: 16,
              frequency: 76183,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18fe',
              id: 17,
              frequency: 34551,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18fd',
              id: 18,
              frequency: 24400,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18fc',
              id: 19,
              frequency: 40731,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18fb',
              id: 20,
              frequency: 23003,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18fa',
              id: 21,
              frequency: 18375,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18f9',
              id: 22,
              frequency: 3106,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18f8',
              id: 23,
              frequency: 432,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18f7',
              id: 24,
              frequency: 59004,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18f6',
              id: 25,
              frequency: 35637,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18f5',
              id: 26,
              frequency: 58034,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18f4',
              id: 27,
              frequency: 55357,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18f3',
              id: 28,
              frequency: 55290,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18f2',
              id: 29,
              frequency: 133376,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18f1',
              id: 30,
              frequency: 56927,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18f0',
              id: 31,
              frequency: 20569,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18ef',
              id: 32,
              frequency: 26447,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18ee',
              id: 33,
              frequency: 6861,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18ed',
              id: 34,
              frequency: 22229,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18ec',
              id: 35,
              frequency: 9546,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18eb',
              id: 36,
              frequency: 14227,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18ea',
              id: 37,
              frequency: 26013,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18e9',
              id: 38,
              frequency: 9800,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18e8',
              id: 39,
              frequency: 23268,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18e7',
              id: 40,
              frequency: 62953,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18e6',
              id: 41,
              frequency: 29199,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18e5',
              id: 42,
              frequency: 17535,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18e4',
              id: 43,
              frequency: 62998,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18e3',
              id: 44,
              frequency: 10937,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18e2',
              id: 45,
              frequency: 43640,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18e1',
              id: 46,
              frequency: 59968,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18e0',
              id: 47,
              frequency: 47232,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18df',
              id: 48,
              frequency: 99604,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18de',
              id: 49,
              frequency: 1950,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18dd',
              id: 50,
              frequency: 1043,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18dc',
              id: 51,
              frequency: 41083,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18db',
              id: 52,
              frequency: 19936,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18da',
              id: 53,
              frequency: 39267,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18d9',
              id: 54,
              frequency: 11921,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18d8',
              id: 55,
              frequency: 5774,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18d7',
              id: 56,
              frequency: 25356,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18d6',
              id: 57,
              frequency: 113914,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18d5',
              id: 58,
              frequency: 26097,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18d4',
              id: 59,
              frequency: 87379,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18d3',
              id: 60,
              frequency: 85427,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18d2',
              id: 61,
              frequency: 29375,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18d1',
              id: 62,
              frequency: 8046,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18d0',
              id: 63,
              frequency: 17533,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18cf',
              id: 64,
              frequency: 17093,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18ce',
              id: 65,
              frequency: 37950,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18cd',
              id: 66,
              frequency: 87153,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18cc',
              id: 67,
              frequency: 69809,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18cb',
              id: 68,
              frequency: 30295,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18ca',
              id: 69,
              frequency: 5176,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18c9',
              id: 70,
              frequency: 47805,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18c8',
              id: 71,
              frequency: 56957,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18c7',
              id: 72,
              frequency: 41772,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1853',
          id: 49,
          abbrevName: '50',
          fullName: '50_R_SPL_angular',
          coordinates: {
            x: 41.555556,
            y: -49.62963,
            z: 49.62963,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1862',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1861',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1860',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a185f',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a185e',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a185d',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a185c',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a185b',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a185a',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1859',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1858',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1857',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1856',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1855',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1854',
              to: 65,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a18ab',
              id: 0,
              frequency: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18aa',
              id: 1,
              frequency: 987,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18a9',
              id: 2,
              frequency: 234,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18a8',
              id: 3,
              frequency: 586,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18a7',
              id: 4,
              frequency: 13009,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18a6',
              id: 5,
              frequency: 7675,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18a5',
              id: 6,
              frequency: 3934,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18a4',
              id: 7,
              frequency: 228,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18a3',
              id: 8,
              frequency: 1908,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18a2',
              id: 9,
              frequency: 9047,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18a1',
              id: 10,
              frequency: 13379,
            },
            {
              _id: '5d6615769bcb6d0e6d7a18a0',
              id: 11,
              frequency: 2305,
            },
            {
              _id: '5d6615769bcb6d0e6d7a189f',
              id: 12,
              frequency: 7305,
            },
            {
              _id: '5d6615769bcb6d0e6d7a189e',
              id: 13,
              frequency: 3832,
            },
            {
              _id: '5d6615769bcb6d0e6d7a189d',
              id: 14,
              frequency: 4295,
            },
            {
              _id: '5d6615769bcb6d0e6d7a189c',
              id: 15,
              frequency: 97282,
            },
            {
              _id: '5d6615769bcb6d0e6d7a189b',
              id: 16,
              frequency: 52892,
            },
            {
              _id: '5d6615769bcb6d0e6d7a189a',
              id: 17,
              frequency: 36796,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1899',
              id: 18,
              frequency: 33378,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1898',
              id: 19,
              frequency: 54646,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1897',
              id: 20,
              frequency: 17710,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1896',
              id: 21,
              frequency: 6398,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1895',
              id: 22,
              frequency: 4690,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1894',
              id: 23,
              frequency: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1893',
              id: 24,
              frequency: 96940,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1892',
              id: 25,
              frequency: 39138,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1891',
              id: 26,
              frequency: 26877,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1890',
              id: 27,
              frequency: 74458,
            },
            {
              _id: '5d6615769bcb6d0e6d7a188f',
              id: 28,
              frequency: 53107,
            },
            {
              _id: '5d6615769bcb6d0e6d7a188e',
              id: 29,
              frequency: 130085,
            },
            {
              _id: '5d6615769bcb6d0e6d7a188d',
              id: 30,
              frequency: 28854,
            },
            {
              _id: '5d6615769bcb6d0e6d7a188c',
              id: 31,
              frequency: 30494,
            },
            {
              _id: '5d6615769bcb6d0e6d7a188b',
              id: 32,
              frequency: 26808,
            },
            {
              _id: '5d6615769bcb6d0e6d7a188a',
              id: 33,
              frequency: 1079,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1889',
              id: 34,
              frequency: 19393,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1888',
              id: 35,
              frequency: 13658,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1887',
              id: 36,
              frequency: 10352,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1886',
              id: 37,
              frequency: 22265,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1885',
              id: 38,
              frequency: 4284,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1884',
              id: 39,
              frequency: 38985,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1883',
              id: 40,
              frequency: 63827,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1882',
              id: 41,
              frequency: 15509,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1881',
              id: 42,
              frequency: 4315,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1880',
              id: 43,
              frequency: 74394,
            },
            {
              _id: '5d6615769bcb6d0e6d7a187f',
              id: 44,
              frequency: 2720,
            },
            {
              _id: '5d6615769bcb6d0e6d7a187e',
              id: 45,
              frequency: 63830,
            },
            {
              _id: '5d6615769bcb6d0e6d7a187d',
              id: 46,
              frequency: 52518,
            },
            {
              _id: '5d6615769bcb6d0e6d7a187c',
              id: 47,
              frequency: 24170,
            },
            {
              _id: '5d6615769bcb6d0e6d7a187b',
              id: 48,
              frequency: 69227,
            },
            {
              _id: '5d6615769bcb6d0e6d7a187a',
              id: 49,
              frequency: 1843,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1879',
              id: 50,
              frequency: 562,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1878',
              id: 51,
              frequency: 37395,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1877',
              id: 52,
              frequency: 21849,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1876',
              id: 53,
              frequency: 19641,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1875',
              id: 54,
              frequency: 11532,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1874',
              id: 55,
              frequency: 2007,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1873',
              id: 56,
              frequency: 47269,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1872',
              id: 57,
              frequency: 81498,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1871',
              id: 58,
              frequency: 6711,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1870',
              id: 59,
              frequency: 91764,
            },
            {
              _id: '5d6615769bcb6d0e6d7a186f',
              id: 60,
              frequency: 56168,
            },
            {
              _id: '5d6615769bcb6d0e6d7a186e',
              id: 61,
              frequency: 9834,
            },
            {
              _id: '5d6615769bcb6d0e6d7a186d',
              id: 62,
              frequency: 8139,
            },
            {
              _id: '5d6615769bcb6d0e6d7a186c',
              id: 63,
              frequency: 8614,
            },
            {
              _id: '5d6615769bcb6d0e6d7a186b',
              id: 64,
              frequency: 12521,
            },
            {
              _id: '5d6615769bcb6d0e6d7a186a',
              id: 65,
              frequency: 44471,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1869',
              id: 66,
              frequency: 65406,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1868',
              id: 67,
              frequency: 26121,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1867',
              id: 68,
              frequency: 19052,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1866',
              id: 69,
              frequency: 2387,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1865',
              id: 70,
              frequency: 30811,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1864',
              id: 71,
              frequency: 26911,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1863',
              id: 72,
              frequency: 19139,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a17f5',
          id: 50,
          abbrevName: '51',
          fullName: '51_R_Pallidum',
          coordinates: {
            x: 27.306931,
            y: -2,
            z: 1.762376,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1809',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1808',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1807',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1806',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1805',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1804',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1803',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1802',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1801',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1800',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17ff',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17fe',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17fd',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17fc',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17fb',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17fa',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17f9',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17f8',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17f7',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17f6',
              to: 63,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1852',
              id: 0,
              frequency: 43,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1851',
              id: 1,
              frequency: 1009,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1850',
              id: 2,
              frequency: 256,
            },
            {
              _id: '5d6615769bcb6d0e6d7a184f',
              id: 3,
              frequency: 647,
            },
            {
              _id: '5d6615769bcb6d0e6d7a184e',
              id: 4,
              frequency: 12657,
            },
            {
              _id: '5d6615769bcb6d0e6d7a184d',
              id: 5,
              frequency: 8073,
            },
            {
              _id: '5d6615769bcb6d0e6d7a184c',
              id: 6,
              frequency: 4282,
            },
            {
              _id: '5d6615769bcb6d0e6d7a184b',
              id: 7,
              frequency: 142,
            },
            {
              _id: '5d6615769bcb6d0e6d7a184a',
              id: 8,
              frequency: 1920,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1849',
              id: 9,
              frequency: 8519,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1848',
              id: 10,
              frequency: 13841,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1847',
              id: 11,
              frequency: 2789,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1846',
              id: 12,
              frequency: 8312,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1845',
              id: 13,
              frequency: 4492,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1844',
              id: 14,
              frequency: 4918,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1843',
              id: 15,
              frequency: 86186,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1842',
              id: 16,
              frequency: 55563,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1841',
              id: 17,
              frequency: 36371,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1840',
              id: 18,
              frequency: 32146,
            },
            {
              _id: '5d6615769bcb6d0e6d7a183f',
              id: 19,
              frequency: 61047,
            },
            {
              _id: '5d6615769bcb6d0e6d7a183e',
              id: 20,
              frequency: 21311,
            },
            {
              _id: '5d6615769bcb6d0e6d7a183d',
              id: 21,
              frequency: 3836,
            },
            {
              _id: '5d6615769bcb6d0e6d7a183c',
              id: 22,
              frequency: 5014,
            },
            {
              _id: '5d6615769bcb6d0e6d7a183b',
              id: 23,
              frequency: 4,
            },
            {
              _id: '5d6615769bcb6d0e6d7a183a',
              id: 24,
              frequency: 89874,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1839',
              id: 25,
              frequency: 38680,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1838',
              id: 26,
              frequency: 31442,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1837',
              id: 27,
              frequency: 64788,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1836',
              id: 28,
              frequency: 49484,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1835',
              id: 29,
              frequency: 125102,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1834',
              id: 30,
              frequency: 33542,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1833',
              id: 31,
              frequency: 34387,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1832',
              id: 32,
              frequency: 29859,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1831',
              id: 33,
              frequency: 525,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1830',
              id: 34,
              frequency: 19588,
            },
            {
              _id: '5d6615769bcb6d0e6d7a182f',
              id: 35,
              frequency: 13539,
            },
            {
              _id: '5d6615769bcb6d0e6d7a182e',
              id: 36,
              frequency: 10837,
            },
            {
              _id: '5d6615769bcb6d0e6d7a182d',
              id: 37,
              frequency: 23546,
            },
            {
              _id: '5d6615769bcb6d0e6d7a182c',
              id: 38,
              frequency: 2474,
            },
            {
              _id: '5d6615769bcb6d0e6d7a182b',
              id: 39,
              frequency: 37061,
            },
            {
              _id: '5d6615769bcb6d0e6d7a182a',
              id: 40,
              frequency: 74246,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1829',
              id: 41,
              frequency: 18734,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1828',
              id: 42,
              frequency: 3282,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1827',
              id: 43,
              frequency: 66901,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1826',
              id: 44,
              frequency: 3856,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1825',
              id: 45,
              frequency: 56010,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1824',
              id: 46,
              frequency: 57567,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1823',
              id: 47,
              frequency: 28525,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1822',
              id: 48,
              frequency: 74689,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1821',
              id: 49,
              frequency: 1713,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1820',
              id: 50,
              frequency: 276,
            },
            {
              _id: '5d6615769bcb6d0e6d7a181f',
              id: 51,
              frequency: 36294,
            },
            {
              _id: '5d6615769bcb6d0e6d7a181e',
              id: 52,
              frequency: 20777,
            },
            {
              _id: '5d6615769bcb6d0e6d7a181d',
              id: 53,
              frequency: 21425,
            },
            {
              _id: '5d6615769bcb6d0e6d7a181c',
              id: 54,
              frequency: 13728,
            },
            {
              _id: '5d6615769bcb6d0e6d7a181b',
              id: 55,
              frequency: 1332,
            },
            {
              _id: '5d6615769bcb6d0e6d7a181a',
              id: 56,
              frequency: 38705,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1819',
              id: 57,
              frequency: 84391,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1818',
              id: 58,
              frequency: 9241,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1817',
              id: 59,
              frequency: 97097,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1816',
              id: 60,
              frequency: 66683,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1815',
              id: 61,
              frequency: 13666,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1814',
              id: 62,
              frequency: 6513,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1813',
              id: 63,
              frequency: 9498,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1812',
              id: 64,
              frequency: 12548,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1811',
              id: 65,
              frequency: 47498,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1810',
              id: 66,
              frequency: 70948,
            },
            {
              _id: '5d6615769bcb6d0e6d7a180f',
              id: 67,
              frequency: 33467,
            },
            {
              _id: '5d6615769bcb6d0e6d7a180e',
              id: 68,
              frequency: 22449,
            },
            {
              _id: '5d6615769bcb6d0e6d7a180d',
              id: 69,
              frequency: 3703,
            },
            {
              _id: '5d6615769bcb6d0e6d7a180c',
              id: 70,
              frequency: 40080,
            },
            {
              _id: '5d6615769bcb6d0e6d7a180b',
              id: 71,
              frequency: 31662,
            },
            {
              _id: '5d6615769bcb6d0e6d7a180a',
              id: 72,
              frequency: 22672,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1788',
          id: 51,
          abbrevName: '52',
          fullName: '52_L_Occipital_pole',
          coordinates: {
            x: -15.835749,
            y: -97.536232,
            z: -2.144928,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a17ab',
              to: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17aa',
              to: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17a9',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17a8',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17a7',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17a6',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17a5',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17a4',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17a3',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17a2',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17a1',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17a0',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a179f',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a179e',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a179d',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a179c',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a179b',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a179a',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1799',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1798',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1797',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1796',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1795',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1794',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1793',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1792',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1791',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1790',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a178f',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a178e',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a178d',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a178c',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a178b',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a178a',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1789',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a17f4',
              id: 0,
              frequency: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17f3',
              id: 1,
              frequency: 903,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17f2',
              id: 2,
              frequency: 635,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17f1',
              id: 3,
              frequency: 1195,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17f0',
              id: 4,
              frequency: 6698,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17ef',
              id: 5,
              frequency: 13800,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17ee',
              id: 6,
              frequency: 3078,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17ed',
              id: 7,
              frequency: 1305,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17ec',
              id: 8,
              frequency: 2659,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17eb',
              id: 9,
              frequency: 4685,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17ea',
              id: 10,
              frequency: 17962,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17e9',
              id: 11,
              frequency: 10612,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17e8',
              id: 12,
              frequency: 8550,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17e7',
              id: 13,
              frequency: 12326,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17e6',
              id: 14,
              frequency: 11747,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17e5',
              id: 15,
              frequency: 28663,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17e4',
              id: 16,
              frequency: 57045,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17e3',
              id: 17,
              frequency: 37950,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17e2',
              id: 18,
              frequency: 9179,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17e1',
              id: 19,
              frequency: 27841,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17e0',
              id: 20,
              frequency: 35474,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17df',
              id: 21,
              frequency: 26454,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17de',
              id: 22,
              frequency: 3133,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17dd',
              id: 23,
              frequency: 591,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17dc',
              id: 24,
              frequency: 27188,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17db',
              id: 25,
              frequency: 35142,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17da',
              id: 26,
              frequency: 88718,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17d9',
              id: 27,
              frequency: 20719,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17d8',
              id: 28,
              frequency: 57139,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17d7',
              id: 29,
              frequency: 100385,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17d6',
              id: 30,
              frequency: 97554,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17d5',
              id: 31,
              frequency: 17209,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17d4',
              id: 32,
              frequency: 33726,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17d3',
              id: 33,
              frequency: 12580,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17d2',
              id: 34,
              frequency: 19051,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17d1',
              id: 35,
              frequency: 4759,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17d0',
              id: 36,
              frequency: 7788,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17cf',
              id: 37,
              frequency: 25683,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17ce',
              id: 38,
              frequency: 13887,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17cd',
              id: 39,
              frequency: 13760,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17cc',
              id: 40,
              frequency: 60531,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17cb',
              id: 41,
              frequency: 41152,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17ca',
              id: 42,
              frequency: 36942,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17c9',
              id: 43,
              frequency: 58571,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17c8',
              id: 44,
              frequency: 24115,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17c7',
              id: 45,
              frequency: 18410,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17c6',
              id: 46,
              frequency: 32977,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17c5',
              id: 47,
              frequency: 66339,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17c4',
              id: 48,
              frequency: 148107,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17c3',
              id: 49,
              frequency: 2149,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17c2',
              id: 50,
              frequency: 1236,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17c1',
              id: 51,
              frequency: 30571,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17c0',
              id: 52,
              frequency: 15268,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17bf',
              id: 53,
              frequency: 52150,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17be',
              id: 54,
              frequency: 12484,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17bd',
              id: 55,
              frequency: 11224,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17bc',
              id: 56,
              frequency: 12891,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17bb',
              id: 57,
              frequency: 155816,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17ba',
              id: 58,
              frequency: 54161,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17b9',
              id: 59,
              frequency: 63711,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17b8',
              id: 60,
              frequency: 116757,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17b7',
              id: 61,
              frequency: 63737,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17b6',
              id: 62,
              frequency: 6182,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17b5',
              id: 63,
              frequency: 16802,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17b4',
              id: 64,
              frequency: 22240,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17b3',
              id: 65,
              frequency: 29372,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17b2',
              id: 66,
              frequency: 107805,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17b1',
              id: 67,
              frequency: 130035,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17b0',
              id: 68,
              frequency: 31292,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17af',
              id: 69,
              frequency: 10926,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17ae',
              id: 70,
              frequency: 44721,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17ad',
              id: 71,
              frequency: 106523,
            },
            {
              _id: '5d6615769bcb6d0e6d7a17ac',
              id: 72,
              frequency: 71021,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1725',
          id: 52,
          abbrevName: '53',
          fullName: '53_L_SPL',
          coordinates: {
            x: -12.327869,
            y: -49.606557,
            z: 64.245902,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a173e',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a173d',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a173c',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a173b',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a173a',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1739',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1738',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1737',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1736',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1735',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1734',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1733',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1732',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1731',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1730',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a172f',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a172e',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a172d',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a172c',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a172b',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a172a',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1729',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1728',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1727',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1726',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1787',
              id: 0,
              frequency: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1786',
              id: 1,
              frequency: 877,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1785',
              id: 2,
              frequency: 588,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1784',
              id: 3,
              frequency: 1065,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1783',
              id: 4,
              frequency: 9994,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1782',
              id: 5,
              frequency: 12169,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1781',
              id: 6,
              frequency: 2175,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1780',
              id: 7,
              frequency: 1262,
            },
            {
              _id: '5d6615769bcb6d0e6d7a177f',
              id: 8,
              frequency: 2822,
            },
            {
              _id: '5d6615769bcb6d0e6d7a177e',
              id: 9,
              frequency: 5668,
            },
            {
              _id: '5d6615769bcb6d0e6d7a177d',
              id: 10,
              frequency: 15980,
            },
            {
              _id: '5d6615769bcb6d0e6d7a177c',
              id: 11,
              frequency: 9391,
            },
            {
              _id: '5d6615769bcb6d0e6d7a177b',
              id: 12,
              frequency: 8098,
            },
            {
              _id: '5d6615769bcb6d0e6d7a177a',
              id: 13,
              frequency: 10360,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1779',
              id: 14,
              frequency: 9843,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1778',
              id: 15,
              frequency: 48382,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1777',
              id: 16,
              frequency: 89293,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1776',
              id: 17,
              frequency: 24721,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1775',
              id: 18,
              frequency: 20194,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1774',
              id: 19,
              frequency: 22266,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1773',
              id: 20,
              frequency: 19092,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1772',
              id: 21,
              frequency: 24521,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1771',
              id: 22,
              frequency: 1510,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1770',
              id: 23,
              frequency: 730,
            },
            {
              _id: '5d6615769bcb6d0e6d7a176f',
              id: 24,
              frequency: 43779,
            },
            {
              _id: '5d6615769bcb6d0e6d7a176e',
              id: 25,
              frequency: 20853,
            },
            {
              _id: '5d6615769bcb6d0e6d7a176d',
              id: 26,
              frequency: 79621,
            },
            {
              _id: '5d6615769bcb6d0e6d7a176c',
              id: 27,
              frequency: 49063,
            },
            {
              _id: '5d6615769bcb6d0e6d7a176b',
              id: 28,
              frequency: 59732,
            },
            {
              _id: '5d6615769bcb6d0e6d7a176a',
              id: 29,
              frequency: 139287,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1769',
              id: 30,
              frequency: 75059,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1768',
              id: 31,
              frequency: 11697,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1767',
              id: 32,
              frequency: 23952,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1766',
              id: 33,
              frequency: 12558,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1765',
              id: 34,
              frequency: 23361,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1764',
              id: 35,
              frequency: 7125,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1763',
              id: 36,
              frequency: 14858,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1762',
              id: 37,
              frequency: 19497,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1761',
              id: 38,
              frequency: 13349,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1760',
              id: 39,
              frequency: 17253,
            },
            {
              _id: '5d6615769bcb6d0e6d7a175f',
              id: 40,
              frequency: 42860,
            },
            {
              _id: '5d6615769bcb6d0e6d7a175e',
              id: 41,
              frequency: 35863,
            },
            {
              _id: '5d6615769bcb6d0e6d7a175d',
              id: 42,
              frequency: 32373,
            },
            {
              _id: '5d6615769bcb6d0e6d7a175c',
              id: 43,
              frequency: 65830,
            },
            {
              _id: '5d6615769bcb6d0e6d7a175b',
              id: 44,
              frequency: 19941,
            },
            {
              _id: '5d6615769bcb6d0e6d7a175a',
              id: 45,
              frequency: 36955,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1759',
              id: 46,
              frequency: 55210,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1758',
              id: 47,
              frequency: 56045,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1757',
              id: 48,
              frequency: 119936,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1756',
              id: 49,
              frequency: 1729,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1755',
              id: 50,
              frequency: 1378,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1754',
              id: 51,
              frequency: 39395,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1753',
              id: 52,
              frequency: 17983,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1752',
              id: 53,
              frequency: 50316,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1751',
              id: 54,
              frequency: 7558,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1750',
              id: 55,
              frequency: 9001,
            },
            {
              _id: '5d6615769bcb6d0e6d7a174f',
              id: 56,
              frequency: 21158,
            },
            {
              _id: '5d6615769bcb6d0e6d7a174e',
              id: 57,
              frequency: 131056,
            },
            {
              _id: '5d6615769bcb6d0e6d7a174d',
              id: 58,
              frequency: 46241,
            },
            {
              _id: '5d6615769bcb6d0e6d7a174c',
              id: 59,
              frequency: 78859,
            },
            {
              _id: '5d6615769bcb6d0e6d7a174b',
              id: 60,
              frequency: 93643,
            },
            {
              _id: '5d6615769bcb6d0e6d7a174a',
              id: 61,
              frequency: 51629,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1749',
              id: 62,
              frequency: 7702,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1748',
              id: 63,
              frequency: 19700,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1747',
              id: 64,
              frequency: 19256,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1746',
              id: 65,
              frequency: 31928,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1745',
              id: 66,
              frequency: 89507,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1744',
              id: 67,
              frequency: 104898,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1743',
              id: 68,
              frequency: 31577,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1742',
              id: 69,
              frequency: 8211,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1741',
              id: 70,
              frequency: 43813,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1740',
              id: 71,
              frequency: 82263,
            },
            {
              _id: '5d6615769bcb6d0e6d7a173f',
              id: 72,
              frequency: 56425,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a16c8',
          id: 53,
          abbrevName: '54',
          fullName: '54_R_Frontal_pole',
          coordinates: {
            x: 15.73913,
            y: 46.550725,
            z: 40.434783,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a16db',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16da',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16d9',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16d8',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16d7',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16d6',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16d5',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16d4',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16d3',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16d2',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16d1',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16d0',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16cf',
              to: 99,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16ce',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16cd',
              to: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16cc',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16cb',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16ca',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16c9',
              to: 59,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1724',
              id: 0,
              frequency: 41,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1723',
              id: 1,
              frequency: 978,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1722',
              id: 2,
              frequency: 264,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1721',
              id: 3,
              frequency: 556,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1720',
              id: 4,
              frequency: 13006,
            },
            {
              _id: '5d6615769bcb6d0e6d7a171f',
              id: 5,
              frequency: 8402,
            },
            {
              _id: '5d6615769bcb6d0e6d7a171e',
              id: 6,
              frequency: 4547,
            },
            {
              _id: '5d6615769bcb6d0e6d7a171d',
              id: 7,
              frequency: 369,
            },
            {
              _id: '5d6615769bcb6d0e6d7a171c',
              id: 8,
              frequency: 1903,
            },
            {
              _id: '5d6615769bcb6d0e6d7a171b',
              id: 9,
              frequency: 9101,
            },
            {
              _id: '5d6615769bcb6d0e6d7a171a',
              id: 10,
              frequency: 12696,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1719',
              id: 11,
              frequency: 2673,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1718',
              id: 12,
              frequency: 7108,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1717',
              id: 13,
              frequency: 3843,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1716',
              id: 14,
              frequency: 3775,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1715',
              id: 15,
              frequency: 94860,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1714',
              id: 16,
              frequency: 67578,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1713',
              id: 17,
              frequency: 30640,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1712',
              id: 18,
              frequency: 30332,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1711',
              id: 19,
              frequency: 63644,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1710',
              id: 20,
              frequency: 24894,
            },
            {
              _id: '5d6615769bcb6d0e6d7a170f',
              id: 21,
              frequency: 11321,
            },
            {
              _id: '5d6615769bcb6d0e6d7a170e',
              id: 22,
              frequency: 5021,
            },
            {
              _id: '5d6615769bcb6d0e6d7a170d',
              id: 23,
              frequency: 140,
            },
            {
              _id: '5d6615769bcb6d0e6d7a170c',
              id: 24,
              frequency: 86673,
            },
            {
              _id: '5d6615769bcb6d0e6d7a170b',
              id: 25,
              frequency: 34436,
            },
            {
              _id: '5d6615769bcb6d0e6d7a170a',
              id: 26,
              frequency: 36049,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1709',
              id: 27,
              frequency: 78145,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1708',
              id: 28,
              frequency: 63300,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1707',
              id: 29,
              frequency: 123793,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1706',
              id: 30,
              frequency: 30654,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1705',
              id: 31,
              frequency: 39972,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1704',
              id: 32,
              frequency: 28841,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1703',
              id: 33,
              frequency: 2364,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1702',
              id: 34,
              frequency: 17728,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1701',
              id: 35,
              frequency: 17435,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1700',
              id: 36,
              frequency: 12015,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16ff',
              id: 37,
              frequency: 24903,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16fe',
              id: 38,
              frequency: 5315,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16fd',
              id: 39,
              frequency: 44797,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16fc',
              id: 40,
              frequency: 69504,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16fb',
              id: 41,
              frequency: 19042,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16fa',
              id: 42,
              frequency: 6370,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16f9',
              id: 43,
              frequency: 74949,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16f8',
              id: 44,
              frequency: 2945,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16f7',
              id: 45,
              frequency: 64655,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16f6',
              id: 46,
              frequency: 52758,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16f5',
              id: 47,
              frequency: 27576,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16f4',
              id: 48,
              frequency: 68229,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16f3',
              id: 49,
              frequency: 1983,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16f2',
              id: 50,
              frequency: 718,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16f1',
              id: 51,
              frequency: 37007,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16f0',
              id: 52,
              frequency: 18354,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16ef',
              id: 53,
              frequency: 18805,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16ee',
              id: 54,
              frequency: 14886,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16ed',
              id: 55,
              frequency: 2364,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16ec',
              id: 56,
              frequency: 49194,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16eb',
              id: 57,
              frequency: 72656,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16ea',
              id: 58,
              frequency: 8136,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16e9',
              id: 59,
              frequency: 90152,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16e8',
              id: 60,
              frequency: 54863,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16e7',
              id: 61,
              frequency: 10910,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16e6',
              id: 62,
              frequency: 7119,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16e5',
              id: 63,
              frequency: 9253,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16e4',
              id: 64,
              frequency: 9975,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16e3',
              id: 65,
              frequency: 42197,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16e2',
              id: 66,
              frequency: 56926,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16e1',
              id: 67,
              frequency: 26098,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16e0',
              id: 68,
              frequency: 19462,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16df',
              id: 69,
              frequency: 2618,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16de',
              id: 70,
              frequency: 29890,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16dd',
              id: 71,
              frequency: 24042,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16dc',
              id: 72,
              frequency: 15283,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1662',
          id: 54,
          abbrevName: '55',
          fullName: '55_R_Angular_gyrus_spl',
          coordinates: {
            x: 8.045249,
            y: -28.932127,
            z: 70.027149,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a167e',
              to: 55,
            },
            {
              _id: '5d6615769bcb6d0e6d7a167d',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a167c',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a167b',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a167a',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1679',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1678',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1677',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1676',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1675',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1674',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1673',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1672',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1671',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1670',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a166f',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a166e',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a166d',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a166c',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a166b',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a166a',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1669',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1668',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1667',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1666',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1665',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1664',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1663',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a16c7',
              id: 0,
              frequency: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16c6',
              id: 1,
              frequency: 907,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16c5',
              id: 2,
              frequency: 609,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16c4',
              id: 3,
              frequency: 1102,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16c3',
              id: 4,
              frequency: 8781,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16c2',
              id: 5,
              frequency: 13500,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16c1',
              id: 6,
              frequency: 2429,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16c0',
              id: 7,
              frequency: 1572,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16bf',
              id: 8,
              frequency: 2884,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16be',
              id: 9,
              frequency: 5586,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16bd',
              id: 10,
              frequency: 17116,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16bc',
              id: 11,
              frequency: 9651,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16bb',
              id: 12,
              frequency: 8111,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16ba',
              id: 13,
              frequency: 10695,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16b9',
              id: 14,
              frequency: 10591,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16b8',
              id: 15,
              frequency: 40072,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16b7',
              id: 16,
              frequency: 71288,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16b6',
              id: 17,
              frequency: 34874,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16b5',
              id: 18,
              frequency: 15680,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16b4',
              id: 19,
              frequency: 24280,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16b3',
              id: 20,
              frequency: 26897,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16b2',
              id: 21,
              frequency: 31501,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16b1',
              id: 22,
              frequency: 1862,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16b0',
              id: 23,
              frequency: 1071,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16af',
              id: 24,
              frequency: 39529,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16ae',
              id: 25,
              frequency: 31365,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16ad',
              id: 26,
              frequency: 81004,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16ac',
              id: 27,
              frequency: 35403,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16ab',
              id: 28,
              frequency: 65425,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16aa',
              id: 29,
              frequency: 121438,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16a9',
              id: 30,
              frequency: 91968,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16a8',
              id: 31,
              frequency: 12842,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16a7',
              id: 32,
              frequency: 27394,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16a6',
              id: 33,
              frequency: 16974,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16a5',
              id: 34,
              frequency: 22948,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16a4',
              id: 35,
              frequency: 5782,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16a3',
              id: 36,
              frequency: 11333,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16a2',
              id: 37,
              frequency: 21979,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16a1',
              id: 38,
              frequency: 18784,
            },
            {
              _id: '5d6615769bcb6d0e6d7a16a0',
              id: 39,
              frequency: 16328,
            },
            {
              _id: '5d6615769bcb6d0e6d7a169f',
              id: 40,
              frequency: 45800,
            },
            {
              _id: '5d6615769bcb6d0e6d7a169e',
              id: 41,
              frequency: 37895,
            },
            {
              _id: '5d6615769bcb6d0e6d7a169d',
              id: 42,
              frequency: 38859,
            },
            {
              _id: '5d6615769bcb6d0e6d7a169c',
              id: 43,
              frequency: 62877,
            },
            {
              _id: '5d6615769bcb6d0e6d7a169b',
              id: 44,
              frequency: 18851,
            },
            {
              _id: '5d6615769bcb6d0e6d7a169a',
              id: 45,
              frequency: 29991,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1699',
              id: 46,
              frequency: 46253,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1698',
              id: 47,
              frequency: 58037,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1697',
              id: 48,
              frequency: 132906,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1696',
              id: 49,
              frequency: 1569,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1695',
              id: 50,
              frequency: 1862,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1694',
              id: 51,
              frequency: 39468,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1693',
              id: 52,
              frequency: 20397,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1692',
              id: 53,
              frequency: 52166,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1691',
              id: 54,
              frequency: 7837,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1690',
              id: 55,
              frequency: 10941,
            },
            {
              _id: '5d6615769bcb6d0e6d7a168f',
              id: 56,
              frequency: 19345,
            },
            {
              _id: '5d6615769bcb6d0e6d7a168e',
              id: 57,
              frequency: 146651,
            },
            {
              _id: '5d6615769bcb6d0e6d7a168d',
              id: 58,
              frequency: 48167,
            },
            {
              _id: '5d6615769bcb6d0e6d7a168c',
              id: 59,
              frequency: 75242,
            },
            {
              _id: '5d6615769bcb6d0e6d7a168b',
              id: 60,
              frequency: 102844,
            },
            {
              _id: '5d6615769bcb6d0e6d7a168a',
              id: 61,
              frequency: 49499,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1689',
              id: 62,
              frequency: 8738,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1688',
              id: 63,
              frequency: 19106,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1687',
              id: 64,
              frequency: 19395,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1686',
              id: 65,
              frequency: 31750,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1685',
              id: 66,
              frequency: 99405,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1684',
              id: 67,
              frequency: 109887,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1683',
              id: 68,
              frequency: 30245,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1682',
              id: 69,
              frequency: 7548,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1681',
              id: 70,
              frequency: 40815,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1680',
              id: 71,
              frequency: 89137,
            },
            {
              _id: '5d6615769bcb6d0e6d7a167f',
              id: 72,
              frequency: 64192,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a15fc',
          id: 55,
          abbrevName: '56',
          fullName: '56_L_Frontal_pole',
          coordinates: {
            x: -34.913043,
            y: 38.913043,
            z: -14.326087,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1618',
              to: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1617',
              to: 58,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1616',
              to: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1615',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1614',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1613',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1612',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1611',
              to: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1610',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a160f',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a160e',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a160d',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a160c',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a160b',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a160a',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1609',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1608',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1607',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1606',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1605',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1604',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1603',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1602',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1601',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1600',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15ff',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15fe',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15fd',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1661',
              id: 0,
              frequency: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1660',
              id: 1,
              frequency: 947,
            },
            {
              _id: '5d6615769bcb6d0e6d7a165f',
              id: 2,
              frequency: 760,
            },
            {
              _id: '5d6615769bcb6d0e6d7a165e',
              id: 3,
              frequency: 1070,
            },
            {
              _id: '5d6615769bcb6d0e6d7a165d',
              id: 4,
              frequency: 7592,
            },
            {
              _id: '5d6615769bcb6d0e6d7a165c',
              id: 5,
              frequency: 16094,
            },
            {
              _id: '5d6615769bcb6d0e6d7a165b',
              id: 6,
              frequency: 2850,
            },
            {
              _id: '5d6615769bcb6d0e6d7a165a',
              id: 7,
              frequency: 2409,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1659',
              id: 8,
              frequency: 3098,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1658',
              id: 9,
              frequency: 6450,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1657',
              id: 10,
              frequency: 16492,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1656',
              id: 11,
              frequency: 12838,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1655',
              id: 12,
              frequency: 9019,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1654',
              id: 13,
              frequency: 11937,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1653',
              id: 14,
              frequency: 8806,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1652',
              id: 15,
              frequency: 35699,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1651',
              id: 16,
              frequency: 84311,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1650',
              id: 17,
              frequency: 31801,
            },
            {
              _id: '5d6615769bcb6d0e6d7a164f',
              id: 18,
              frequency: 9956,
            },
            {
              _id: '5d6615769bcb6d0e6d7a164e',
              id: 19,
              frequency: 22855,
            },
            {
              _id: '5d6615769bcb6d0e6d7a164d',
              id: 20,
              frequency: 32923,
            },
            {
              _id: '5d6615769bcb6d0e6d7a164c',
              id: 21,
              frequency: 50664,
            },
            {
              _id: '5d6615769bcb6d0e6d7a164b',
              id: 22,
              frequency: 2019,
            },
            {
              _id: '5d6615769bcb6d0e6d7a164a',
              id: 23,
              frequency: 2329,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1649',
              id: 24,
              frequency: 35332,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1648',
              id: 25,
              frequency: 26454,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1647',
              id: 26,
              frequency: 122030,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1646',
              id: 27,
              frequency: 29438,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1645',
              id: 28,
              frequency: 92290,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1644',
              id: 29,
              frequency: 98413,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1643',
              id: 30,
              frequency: 95722,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1642',
              id: 31,
              frequency: 17446,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1641',
              id: 32,
              frequency: 26632,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1640',
              id: 33,
              frequency: 28473,
            },
            {
              _id: '5d6615769bcb6d0e6d7a163f',
              id: 34,
              frequency: 19684,
            },
            {
              _id: '5d6615769bcb6d0e6d7a163e',
              id: 35,
              frequency: 6286,
            },
            {
              _id: '5d6615769bcb6d0e6d7a163d',
              id: 36,
              frequency: 9219,
            },
            {
              _id: '5d6615769bcb6d0e6d7a163c',
              id: 37,
              frequency: 26252,
            },
            {
              _id: '5d6615769bcb6d0e6d7a163b',
              id: 38,
              frequency: 21588,
            },
            {
              _id: '5d6615769bcb6d0e6d7a163a',
              id: 39,
              frequency: 21305,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1639',
              id: 40,
              frequency: 55001,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1638',
              id: 41,
              frequency: 43392,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1637',
              id: 42,
              frequency: 59556,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1636',
              id: 43,
              frequency: 72528,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1635',
              id: 44,
              frequency: 30839,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1634',
              id: 45,
              frequency: 25912,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1633',
              id: 46,
              frequency: 33777,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1632',
              id: 47,
              frequency: 87734,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1631',
              id: 48,
              frequency: 136869,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1630',
              id: 49,
              frequency: 2547,
            },
            {
              _id: '5d6615769bcb6d0e6d7a162f',
              id: 50,
              frequency: 1504,
            },
            {
              _id: '5d6615769bcb6d0e6d7a162e',
              id: 51,
              frequency: 39890,
            },
            {
              _id: '5d6615769bcb6d0e6d7a162d',
              id: 52,
              frequency: 14948,
            },
            {
              _id: '5d6615769bcb6d0e6d7a162c',
              id: 53,
              frequency: 57747,
            },
            {
              _id: '5d6615769bcb6d0e6d7a162b',
              id: 54,
              frequency: 12549,
            },
            {
              _id: '5d6615769bcb6d0e6d7a162a',
              id: 55,
              frequency: 13904,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1629',
              id: 56,
              frequency: 26010,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1628',
              id: 57,
              frequency: 112056,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1627',
              id: 58,
              frequency: 60043,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1626',
              id: 59,
              frequency: 77650,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1625',
              id: 60,
              frequency: 121484,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1624',
              id: 61,
              frequency: 72533,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1623',
              id: 62,
              frequency: 9167,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1622',
              id: 63,
              frequency: 22003,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1621',
              id: 64,
              frequency: 19978,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1620',
              id: 65,
              frequency: 43154,
            },
            {
              _id: '5d6615769bcb6d0e6d7a161f',
              id: 66,
              frequency: 92023,
            },
            {
              _id: '5d6615769bcb6d0e6d7a161e',
              id: 67,
              frequency: 119995,
            },
            {
              _id: '5d6615769bcb6d0e6d7a161d',
              id: 68,
              frequency: 34951,
            },
            {
              _id: '5d6615769bcb6d0e6d7a161c',
              id: 69,
              frequency: 10655,
            },
            {
              _id: '5d6615769bcb6d0e6d7a161b',
              id: 70,
              frequency: 46325,
            },
            {
              _id: '5d6615769bcb6d0e6d7a161a',
              id: 71,
              frequency: 81701,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1619',
              id: 72,
              frequency: 41827,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1597',
          id: 56,
          abbrevName: '57',
          fullName: '57_L_Precentral_gyrus_postcentral_gyrus',
          coordinates: {
            x: -45.175573,
            y: -15.847328,
            z: 49.267176,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a15b2',
              to: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15b1',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15b0',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15af',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15ae',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15ad',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15ac',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15ab',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15aa',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15a9',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15a8',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15a7',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15a6',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15a5',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15a4',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15a3',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15a2',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15a1',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15a0',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a159f',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a159e',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a159d',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a159c',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a159b',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a159a',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1599',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1598',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a15fb',
              id: 0,
              frequency: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15fa',
              id: 1,
              frequency: 767,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15f9',
              id: 2,
              frequency: 701,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15f8',
              id: 3,
              frequency: 1315,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15f7',
              id: 4,
              frequency: 6837,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15f6',
              id: 5,
              frequency: 12444,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15f5',
              id: 6,
              frequency: 1687,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15f4',
              id: 7,
              frequency: 1403,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15f3',
              id: 8,
              frequency: 2452,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15f2',
              id: 9,
              frequency: 4337,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15f1',
              id: 10,
              frequency: 17033,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15f0',
              id: 11,
              frequency: 12262,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15ef',
              id: 12,
              frequency: 6970,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15ee',
              id: 13,
              frequency: 14729,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15ed',
              id: 14,
              frequency: 13270,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15ec',
              id: 15,
              frequency: 27943,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15eb',
              id: 16,
              frequency: 71769,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15ea',
              id: 17,
              frequency: 18950,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15e9',
              id: 18,
              frequency: 11537,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15e8',
              id: 19,
              frequency: 13939,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15e7',
              id: 20,
              frequency: 21606,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15e6',
              id: 21,
              frequency: 24633,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15e5',
              id: 22,
              frequency: 1189,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15e4',
              id: 23,
              frequency: 394,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15e3',
              id: 24,
              frequency: 26730,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15e2',
              id: 25,
              frequency: 19094,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15e1',
              id: 26,
              frequency: 95371,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15e0',
              id: 27,
              frequency: 25587,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15df',
              id: 28,
              frequency: 58227,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15de',
              id: 29,
              frequency: 120306,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15dd',
              id: 30,
              frequency: 91540,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15dc',
              id: 31,
              frequency: 7945,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15db',
              id: 32,
              frequency: 25395,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15da',
              id: 33,
              frequency: 13455,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15d9',
              id: 34,
              frequency: 14808,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15d8',
              id: 35,
              frequency: 3773,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15d7',
              id: 36,
              frequency: 10216,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15d6',
              id: 37,
              frequency: 14056,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15d5',
              id: 38,
              frequency: 12087,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15d4',
              id: 39,
              frequency: 11277,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15d3',
              id: 40,
              frequency: 32528,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15d2',
              id: 41,
              frequency: 46906,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15d1',
              id: 42,
              frequency: 44409,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15d0',
              id: 43,
              frequency: 63138,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15cf',
              id: 44,
              frequency: 28315,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15ce',
              id: 45,
              frequency: 20769,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15cd',
              id: 46,
              frequency: 35202,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15cc',
              id: 47,
              frequency: 53331,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15cb',
              id: 48,
              frequency: 158742,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15ca',
              id: 49,
              frequency: 862,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15c9',
              id: 50,
              frequency: 1047,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15c8',
              id: 51,
              frequency: 29874,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15c7',
              id: 52,
              frequency: 14317,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15c6',
              id: 53,
              frequency: 50786,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15c5',
              id: 54,
              frequency: 5486,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15c4',
              id: 55,
              frequency: 12688,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15c3',
              id: 56,
              frequency: 14279,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15c2',
              id: 57,
              frequency: 160741,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15c1',
              id: 58,
              frequency: 62744,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15c0',
              id: 59,
              frequency: 59696,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15bf',
              id: 60,
              frequency: 103447,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15be',
              id: 61,
              frequency: 84111,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15bd',
              id: 62,
              frequency: 6109,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15bc',
              id: 63,
              frequency: 18440,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15bb',
              id: 64,
              frequency: 20811,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15ba',
              id: 65,
              frequency: 25039,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15b9',
              id: 66,
              frequency: 95392,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15b8',
              id: 67,
              frequency: 162540,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15b7',
              id: 68,
              frequency: 28319,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15b6',
              id: 69,
              frequency: 15637,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15b5',
              id: 70,
              frequency: 34964,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15b4',
              id: 71,
              frequency: 130073,
            },
            {
              _id: '5d6615769bcb6d0e6d7a15b3',
              id: 72,
              frequency: 81010,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1536',
          id: 57,
          abbrevName: '58',
          fullName: '58_R_Occipital_Fusiform',
          coordinates: {
            x: 23.955224,
            y: -65.223881,
            z: -15.402985,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a154d',
              to: 60,
            },
            {
              _id: '5d6615769bcb6d0e6d7a154c',
              to: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a154b',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a154a',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1549',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1548',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1547',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1546',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1545',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1544',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1543',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1542',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1541',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1540',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a153f',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a153e',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a153d',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a153c',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a153b',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a153a',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1539',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1538',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1537',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1596',
              id: 0,
              frequency: 52,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1595',
              id: 1,
              frequency: 885,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1594',
              id: 2,
              frequency: 344,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1593',
              id: 3,
              frequency: 982,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1592',
              id: 4,
              frequency: 9999,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1591',
              id: 5,
              frequency: 8824,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1590',
              id: 6,
              frequency: 3117,
            },
            {
              _id: '5d6615769bcb6d0e6d7a158f',
              id: 7,
              frequency: 286,
            },
            {
              _id: '5d6615769bcb6d0e6d7a158e',
              id: 8,
              frequency: 1616,
            },
            {
              _id: '5d6615769bcb6d0e6d7a158d',
              id: 9,
              frequency: 5938,
            },
            {
              _id: '5d6615769bcb6d0e6d7a158c',
              id: 10,
              frequency: 18275,
            },
            {
              _id: '5d6615769bcb6d0e6d7a158b',
              id: 11,
              frequency: 4337,
            },
            {
              _id: '5d6615769bcb6d0e6d7a158a',
              id: 12,
              frequency: 7402,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1589',
              id: 13,
              frequency: 7668,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1588',
              id: 14,
              frequency: 9809,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1587',
              id: 15,
              frequency: 58120,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1586',
              id: 16,
              frequency: 60074,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1585',
              id: 17,
              frequency: 26035,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1584',
              id: 18,
              frequency: 18616,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1583',
              id: 19,
              frequency: 36847,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1582',
              id: 20,
              frequency: 24679,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1581',
              id: 21,
              frequency: 7297,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1580',
              id: 22,
              frequency: 3563,
            },
            {
              _id: '5d6615769bcb6d0e6d7a157f',
              id: 23,
              frequency: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a157e',
              id: 24,
              frequency: 46599,
            },
            {
              _id: '5d6615769bcb6d0e6d7a157d',
              id: 25,
              frequency: 40438,
            },
            {
              _id: '5d6615769bcb6d0e6d7a157c',
              id: 26,
              frequency: 47393,
            },
            {
              _id: '5d6615769bcb6d0e6d7a157b',
              id: 27,
              frequency: 49491,
            },
            {
              _id: '5d6615769bcb6d0e6d7a157a',
              id: 28,
              frequency: 48691,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1579',
              id: 29,
              frequency: 156879,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1578',
              id: 30,
              frequency: 47076,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1577',
              id: 31,
              frequency: 20522,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1576',
              id: 32,
              frequency: 38084,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1575',
              id: 33,
              frequency: 1547,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1574',
              id: 34,
              frequency: 15758,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1573',
              id: 35,
              frequency: 8918,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1572',
              id: 36,
              frequency: 8018,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1571',
              id: 37,
              frequency: 16630,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1570',
              id: 38,
              frequency: 3348,
            },
            {
              _id: '5d6615769bcb6d0e6d7a156f',
              id: 39,
              frequency: 20453,
            },
            {
              _id: '5d6615769bcb6d0e6d7a156e',
              id: 40,
              frequency: 57090,
            },
            {
              _id: '5d6615769bcb6d0e6d7a156d',
              id: 41,
              frequency: 33797,
            },
            {
              _id: '5d6615769bcb6d0e6d7a156c',
              id: 42,
              frequency: 7429,
            },
            {
              _id: '5d6615769bcb6d0e6d7a156b',
              id: 43,
              frequency: 81953,
            },
            {
              _id: '5d6615769bcb6d0e6d7a156a',
              id: 44,
              frequency: 6307,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1569',
              id: 45,
              frequency: 37744,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1568',
              id: 46,
              frequency: 47950,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1567',
              id: 47,
              frequency: 28661,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1566',
              id: 48,
              frequency: 117232,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1565',
              id: 49,
              frequency: 1218,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1564',
              id: 50,
              frequency: 270,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1563',
              id: 51,
              frequency: 24992,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1562',
              id: 52,
              frequency: 22468,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1561',
              id: 53,
              frequency: 24865,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1560',
              id: 54,
              frequency: 10024,
            },
            {
              _id: '5d6615769bcb6d0e6d7a155f',
              id: 55,
              frequency: 3407,
            },
            {
              _id: '5d6615769bcb6d0e6d7a155e',
              id: 56,
              frequency: 23413,
            },
            {
              _id: '5d6615769bcb6d0e6d7a155d',
              id: 57,
              frequency: 166416,
            },
            {
              _id: '5d6615769bcb6d0e6d7a155c',
              id: 58,
              frequency: 17615,
            },
            {
              _id: '5d6615769bcb6d0e6d7a155b',
              id: 59,
              frequency: 79616,
            },
            {
              _id: '5d6615769bcb6d0e6d7a155a',
              id: 60,
              frequency: 78946,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1559',
              id: 61,
              frequency: 24289,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1558',
              id: 62,
              frequency: 4567,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1557',
              id: 63,
              frequency: 8028,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1556',
              id: 64,
              frequency: 16519,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1555',
              id: 65,
              frequency: 29226,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1554',
              id: 66,
              frequency: 105925,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1553',
              id: 67,
              frequency: 67910,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1552',
              id: 68,
              frequency: 19202,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1551',
              id: 69,
              frequency: 6312,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1550',
              id: 70,
              frequency: 36712,
            },
            {
              _id: '5d6615769bcb6d0e6d7a154f',
              id: 71,
              frequency: 74218,
            },
            {
              _id: '5d6615769bcb6d0e6d7a154e',
              id: 72,
              frequency: 61670,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a14de',
          id: 58,
          abbrevName: '59',
          fullName: '59_BI_Paracingulate_ACC',
          coordinates: {
            x: 0.510823,
            y: 45.186147,
            z: 3.549784,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a14ec',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14eb',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14ea',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14e9',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14e8',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14e7',
              to: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14e6',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14e5',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14e4',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14e3',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14e2',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14e1',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14e0',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14df',
              to: 85,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1535',
              id: 0,
              frequency: 31,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1534',
              id: 1,
              frequency: 832,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1533',
              id: 2,
              frequency: 128,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1532',
              id: 3,
              frequency: 337,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1531',
              id: 4,
              frequency: 13838,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1530',
              id: 5,
              frequency: 4225,
            },
            {
              _id: '5d6615769bcb6d0e6d7a152f',
              id: 6,
              frequency: 4701,
            },
            {
              _id: '5d6615769bcb6d0e6d7a152e',
              id: 7,
              frequency: 121,
            },
            {
              _id: '5d6615769bcb6d0e6d7a152d',
              id: 8,
              frequency: 959,
            },
            {
              _id: '5d6615769bcb6d0e6d7a152c',
              id: 9,
              frequency: 8483,
            },
            {
              _id: '5d6615769bcb6d0e6d7a152b',
              id: 10,
              frequency: 8775,
            },
            {
              _id: '5d6615769bcb6d0e6d7a152a',
              id: 11,
              frequency: 874,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1529',
              id: 12,
              frequency: 5021,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1528',
              id: 13,
              frequency: 1601,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1527',
              id: 14,
              frequency: 1899,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1526',
              id: 15,
              frequency: 130904,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1525',
              id: 16,
              frequency: 53176,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1524',
              id: 17,
              frequency: 14727,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1523',
              id: 18,
              frequency: 35158,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1522',
              id: 19,
              frequency: 81323,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1521',
              id: 20,
              frequency: 14555,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1520',
              id: 21,
              frequency: 4248,
            },
            {
              _id: '5d6615769bcb6d0e6d7a151f',
              id: 22,
              frequency: 7499,
            },
            {
              _id: '5d6615769bcb6d0e6d7a151e',
              id: 23,
              frequency: 22,
            },
            {
              _id: '5d6615769bcb6d0e6d7a151d',
              id: 24,
              frequency: 105347,
            },
            {
              _id: '5d6615769bcb6d0e6d7a151c',
              id: 25,
              frequency: 25589,
            },
            {
              _id: '5d6615769bcb6d0e6d7a151b',
              id: 26,
              frequency: 15339,
            },
            {
              _id: '5d6615769bcb6d0e6d7a151a',
              id: 27,
              frequency: 105560,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1519',
              id: 28,
              frequency: 34718,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1518',
              id: 29,
              frequency: 111335,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1517',
              id: 30,
              frequency: 8857,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1516',
              id: 31,
              frequency: 46362,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1515',
              id: 32,
              frequency: 23790,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1514',
              id: 33,
              frequency: 488,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1513',
              id: 34,
              frequency: 8690,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1512',
              id: 35,
              frequency: 23056,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1511',
              id: 36,
              frequency: 8447,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1510',
              id: 37,
              frequency: 15016,
            },
            {
              _id: '5d6615769bcb6d0e6d7a150f',
              id: 38,
              frequency: 1364,
            },
            {
              _id: '5d6615769bcb6d0e6d7a150e',
              id: 39,
              frequency: 50206,
            },
            {
              _id: '5d6615769bcb6d0e6d7a150d',
              id: 40,
              frequency: 58185,
            },
            {
              _id: '5d6615769bcb6d0e6d7a150c',
              id: 41,
              frequency: 11779,
            },
            {
              _id: '5d6615769bcb6d0e6d7a150b',
              id: 42,
              frequency: 1494,
            },
            {
              _id: '5d6615769bcb6d0e6d7a150a',
              id: 43,
              frequency: 59801,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1509',
              id: 44,
              frequency: 574,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1508',
              id: 45,
              frequency: 78155,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1507',
              id: 46,
              frequency: 48080,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1506',
              id: 47,
              frequency: 9321,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1505',
              id: 48,
              frequency: 29081,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1504',
              id: 49,
              frequency: 1404,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1503',
              id: 50,
              frequency: 203,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1502',
              id: 51,
              frequency: 18629,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1501',
              id: 52,
              frequency: 14870,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1500',
              id: 53,
              frequency: 5497,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14ff',
              id: 54,
              frequency: 13338,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14fe',
              id: 55,
              frequency: 830,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14fd',
              id: 56,
              frequency: 49101,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14fc',
              id: 57,
              frequency: 42196,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14fb',
              id: 58,
              frequency: 1728,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14fa',
              id: 59,
              frequency: 71826,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14f9',
              id: 60,
              frequency: 25028,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14f8',
              id: 61,
              frequency: 2587,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14f7',
              id: 62,
              frequency: 3344,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14f6',
              id: 63,
              frequency: 3365,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14f5',
              id: 64,
              frequency: 3858,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14f4',
              id: 65,
              frequency: 31414,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14f3',
              id: 66,
              frequency: 31932,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14f2',
              id: 67,
              frequency: 7854,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14f1',
              id: 68,
              frequency: 9753,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14f0',
              id: 69,
              frequency: 620,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14ef',
              id: 70,
              frequency: 18819,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14ee',
              id: 71,
              frequency: 8741,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14ed',
              id: 72,
              frequency: 6527,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1483',
          id: 59,
          abbrevName: '60',
          fullName: '60_R_ITG_posterior_mtg_posterior',
          coordinates: {
            x: 59.098901,
            y: -22.901099,
            z: -20.967033,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1494',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1493',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1492',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1491',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1490',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a148f',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a148e',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a148d',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a148c',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a148b',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a148a',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1489',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1488',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1487',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1486',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1485',
              to: 99,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1484',
              to: 61,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a14dd',
              id: 0,
              frequency: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14dc',
              id: 1,
              frequency: 1036,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14db',
              id: 2,
              frequency: 235,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14da',
              id: 3,
              frequency: 545,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14d9',
              id: 4,
              frequency: 12441,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14d8',
              id: 5,
              frequency: 7984,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14d7',
              id: 6,
              frequency: 5585,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14d6',
              id: 7,
              frequency: 244,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14d5',
              id: 8,
              frequency: 1865,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14d4',
              id: 9,
              frequency: 9147,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14d3',
              id: 10,
              frequency: 13322,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14d2',
              id: 11,
              frequency: 2316,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14d1',
              id: 12,
              frequency: 7684,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14d0',
              id: 13,
              frequency: 3566,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14cf',
              id: 14,
              frequency: 3754,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14ce',
              id: 15,
              frequency: 83209,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14cd',
              id: 16,
              frequency: 54333,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14cc',
              id: 17,
              frequency: 37873,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14cb',
              id: 18,
              frequency: 24891,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14ca',
              id: 19,
              frequency: 80849,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14c9',
              id: 20,
              frequency: 27503,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14c8',
              id: 21,
              frequency: 7696,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14c7',
              id: 22,
              frequency: 9167,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14c6',
              id: 23,
              frequency: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14c5',
              id: 24,
              frequency: 86143,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14c4',
              id: 25,
              frequency: 49291,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14c3',
              id: 26,
              frequency: 31705,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14c2',
              id: 27,
              frequency: 71963,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14c1',
              id: 28,
              frequency: 55963,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14c0',
              id: 29,
              frequency: 113430,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14bf',
              id: 30,
              frequency: 29577,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14be',
              id: 31,
              frequency: 47733,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14bd',
              id: 32,
              frequency: 33800,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14bc',
              id: 33,
              frequency: 1194,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14bb',
              id: 34,
              frequency: 15558,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14ba',
              id: 35,
              frequency: 16411,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14b9',
              id: 36,
              frequency: 9670,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14b8',
              id: 37,
              frequency: 27602,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14b7',
              id: 38,
              frequency: 3991,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14b6',
              id: 39,
              frequency: 42592,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14b5',
              id: 40,
              frequency: 87396,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14b4',
              id: 41,
              frequency: 19924,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14b3',
              id: 42,
              frequency: 4644,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14b2',
              id: 43,
              frequency: 68528,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14b1',
              id: 44,
              frequency: 2532,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14b0',
              id: 45,
              frequency: 62384,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14af',
              id: 46,
              frequency: 49078,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14ae',
              id: 47,
              frequency: 24547,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14ad',
              id: 48,
              frequency: 62427,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14ac',
              id: 49,
              frequency: 2332,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14ab',
              id: 50,
              frequency: 479,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14aa',
              id: 51,
              frequency: 35369,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14a9',
              id: 52,
              frequency: 20373,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14a8',
              id: 53,
              frequency: 19236,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14a7',
              id: 54,
              frequency: 18425,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14a6',
              id: 55,
              frequency: 1808,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14a5',
              id: 56,
              frequency: 46950,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14a4',
              id: 57,
              frequency: 74691,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14a3',
              id: 58,
              frequency: 6941,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14a2',
              id: 59,
              frequency: 92709,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14a1',
              id: 60,
              frequency: 58402,
            },
            {
              _id: '5d6615769bcb6d0e6d7a14a0',
              id: 61,
              frequency: 9884,
            },
            {
              _id: '5d6615769bcb6d0e6d7a149f',
              id: 62,
              frequency: 7125,
            },
            {
              _id: '5d6615769bcb6d0e6d7a149e',
              id: 63,
              frequency: 8360,
            },
            {
              _id: '5d6615769bcb6d0e6d7a149d',
              id: 64,
              frequency: 9936,
            },
            {
              _id: '5d6615769bcb6d0e6d7a149c',
              id: 65,
              frequency: 44957,
            },
            {
              _id: '5d6615769bcb6d0e6d7a149b',
              id: 66,
              frequency: 62682,
            },
            {
              _id: '5d6615769bcb6d0e6d7a149a',
              id: 67,
              frequency: 23297,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1499',
              id: 68,
              frequency: 19550,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1498',
              id: 69,
              frequency: 2326,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1497',
              id: 70,
              frequency: 32967,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1496',
              id: 71,
              frequency: 23104,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1495',
              id: 72,
              frequency: 15613,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a142a',
          id: 60,
          abbrevName: '61',
          fullName: '61_R_Occipital_pole_loc_superior',
          coordinates: {
            x: 27.957447,
            y: -87.617021,
            z: 20.87234,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1439',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1438',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1437',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1436',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1435',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1434',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1433',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1432',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1431',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1430',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a142f',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a142e',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a142d',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a142c',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a142b',
              to: 61,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1482',
              id: 0,
              frequency: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1481',
              id: 1,
              frequency: 890,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1480',
              id: 2,
              frequency: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a147f',
              id: 3,
              frequency: 542,
            },
            {
              _id: '5d6615769bcb6d0e6d7a147e',
              id: 4,
              frequency: 13894,
            },
            {
              _id: '5d6615769bcb6d0e6d7a147d',
              id: 5,
              frequency: 2997,
            },
            {
              _id: '5d6615769bcb6d0e6d7a147c',
              id: 6,
              frequency: 4358,
            },
            {
              _id: '5d6615769bcb6d0e6d7a147b',
              id: 7,
              frequency: 28,
            },
            {
              _id: '5d6615769bcb6d0e6d7a147a',
              id: 8,
              frequency: 739,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1479',
              id: 9,
              frequency: 7774,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1478',
              id: 10,
              frequency: 13029,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1477',
              id: 11,
              frequency: 561,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1476',
              id: 12,
              frequency: 6823,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1475',
              id: 13,
              frequency: 1786,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1474',
              id: 14,
              frequency: 4765,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1473',
              id: 15,
              frequency: 113337,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1472',
              id: 16,
              frequency: 26646,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1471',
              id: 17,
              frequency: 14187,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1470',
              id: 18,
              frequency: 38487,
            },
            {
              _id: '5d6615769bcb6d0e6d7a146f',
              id: 19,
              frequency: 74386,
            },
            {
              _id: '5d6615769bcb6d0e6d7a146e',
              id: 20,
              frequency: 9487,
            },
            {
              _id: '5d6615769bcb6d0e6d7a146d',
              id: 21,
              frequency: 829,
            },
            {
              _id: '5d6615769bcb6d0e6d7a146c',
              id: 22,
              frequency: 5888,
            },
            {
              _id: '5d6615769bcb6d0e6d7a146b',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d7a146a',
              id: 24,
              frequency: 94614,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1469',
              id: 25,
              frequency: 40097,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1468',
              id: 26,
              frequency: 7507,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1467',
              id: 27,
              frequency: 87483,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1466',
              id: 28,
              frequency: 19698,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1465',
              id: 29,
              frequency: 148752,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1464',
              id: 30,
              frequency: 7305,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1463',
              id: 31,
              frequency: 36814,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1462',
              id: 32,
              frequency: 33334,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1461',
              id: 33,
              frequency: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1460',
              id: 34,
              frequency: 8125,
            },
            {
              _id: '5d6615769bcb6d0e6d7a145f',
              id: 35,
              frequency: 20446,
            },
            {
              _id: '5d6615769bcb6d0e6d7a145e',
              id: 36,
              frequency: 5553,
            },
            {
              _id: '5d6615769bcb6d0e6d7a145d',
              id: 37,
              frequency: 10385,
            },
            {
              _id: '5d6615769bcb6d0e6d7a145c',
              id: 38,
              frequency: 529,
            },
            {
              _id: '5d6615769bcb6d0e6d7a145b',
              id: 39,
              frequency: 39650,
            },
            {
              _id: '5d6615769bcb6d0e6d7a145a',
              id: 40,
              frequency: 69876,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1459',
              id: 41,
              frequency: 8419,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1458',
              id: 42,
              frequency: 411,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1457',
              id: 43,
              frequency: 71136,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1456',
              id: 44,
              frequency: 346,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1455',
              id: 45,
              frequency: 66352,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1454',
              id: 46,
              frequency: 66186,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1453',
              id: 47,
              frequency: 5892,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1452',
              id: 48,
              frequency: 35370,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1451',
              id: 49,
              frequency: 898,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1450',
              id: 50,
              frequency: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a144f',
              id: 51,
              frequency: 14639,
            },
            {
              _id: '5d6615769bcb6d0e6d7a144e',
              id: 52,
              frequency: 22537,
            },
            {
              _id: '5d6615769bcb6d0e6d7a144d',
              id: 53,
              frequency: 4595,
            },
            {
              _id: '5d6615769bcb6d0e6d7a144c',
              id: 54,
              frequency: 13826,
            },
            {
              _id: '5d6615769bcb6d0e6d7a144b',
              id: 55,
              frequency: 377,
            },
            {
              _id: '5d6615769bcb6d0e6d7a144a',
              id: 56,
              frequency: 36066,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1449',
              id: 57,
              frequency: 100114,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1448',
              id: 58,
              frequency: 1320,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1447',
              id: 59,
              frequency: 91451,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1446',
              id: 60,
              frequency: 25316,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1445',
              id: 61,
              frequency: 1494,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1444',
              id: 62,
              frequency: 2670,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1443',
              id: 63,
              frequency: 2263,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1442',
              id: 64,
              frequency: 5665,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1441',
              id: 65,
              frequency: 34913,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1440',
              id: 66,
              frequency: 70901,
            },
            {
              _id: '5d6615769bcb6d0e6d7a143f',
              id: 67,
              frequency: 9223,
            },
            {
              _id: '5d6615769bcb6d0e6d7a143e',
              id: 68,
              frequency: 9649,
            },
            {
              _id: '5d6615769bcb6d0e6d7a143d',
              id: 69,
              frequency: 450,
            },
            {
              _id: '5d6615769bcb6d0e6d7a143c',
              id: 70,
              frequency: 36104,
            },
            {
              _id: '5d6615769bcb6d0e6d7a143b',
              id: 71,
              frequency: 17081,
            },
            {
              _id: '5d6615769bcb6d0e6d7a143a',
              id: 72,
              frequency: 28135,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a13ca',
          id: 61,
          abbrevName: '62',
          fullName: '62_LOC_temp_occ_fusiform',
          coordinates: {
            x: -22.214765,
            y: -68.899329,
            z: -15.90604,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a13e0',
              to: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13df',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13de',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13dd',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13dc',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13db',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13da',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13d9',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13d8',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13d7',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13d6',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13d5',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13d4',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13d3',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13d2',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13d1',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13d0',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13cf',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13ce',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13cd',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13cc',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13cb',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1429',
              id: 0,
              frequency: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1428',
              id: 1,
              frequency: 924,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1427',
              id: 2,
              frequency: 543,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1426',
              id: 3,
              frequency: 1053,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1425',
              id: 4,
              frequency: 8940,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1424',
              id: 5,
              frequency: 11950,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1423',
              id: 6,
              frequency: 2898,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1422',
              id: 7,
              frequency: 980,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1421',
              id: 8,
              frequency: 2965,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1420',
              id: 9,
              frequency: 5742,
            },
            {
              _id: '5d6615769bcb6d0e6d7a141f',
              id: 10,
              frequency: 16590,
            },
            {
              _id: '5d6615769bcb6d0e6d7a141e',
              id: 11,
              frequency: 8345,
            },
            {
              _id: '5d6615769bcb6d0e6d7a141d',
              id: 12,
              frequency: 8637,
            },
            {
              _id: '5d6615769bcb6d0e6d7a141c',
              id: 13,
              frequency: 10235,
            },
            {
              _id: '5d6615769bcb6d0e6d7a141b',
              id: 14,
              frequency: 9700,
            },
            {
              _id: '5d6615769bcb6d0e6d7a141a',
              id: 15,
              frequency: 45717,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1419',
              id: 16,
              frequency: 69542,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1418',
              id: 17,
              frequency: 32529,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1417',
              id: 18,
              frequency: 14985,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1416',
              id: 19,
              frequency: 30161,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1415',
              id: 20,
              frequency: 25135,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1414',
              id: 21,
              frequency: 20279,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1413',
              id: 22,
              frequency: 2803,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1412',
              id: 23,
              frequency: 331,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1411',
              id: 24,
              frequency: 41160,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1410',
              id: 25,
              frequency: 31536,
            },
            {
              _id: '5d6615769bcb6d0e6d7a140f',
              id: 26,
              frequency: 74270,
            },
            {
              _id: '5d6615769bcb6d0e6d7a140e',
              id: 27,
              frequency: 37076,
            },
            {
              _id: '5d6615769bcb6d0e6d7a140d',
              id: 28,
              frequency: 57393,
            },
            {
              _id: '5d6615769bcb6d0e6d7a140c',
              id: 29,
              frequency: 120368,
            },
            {
              _id: '5d6615769bcb6d0e6d7a140b',
              id: 30,
              frequency: 73896,
            },
            {
              _id: '5d6615769bcb6d0e6d7a140a',
              id: 31,
              frequency: 16776,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1409',
              id: 32,
              frequency: 29690,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1408',
              id: 33,
              frequency: 8785,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1407',
              id: 34,
              frequency: 18451,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1406',
              id: 35,
              frequency: 6995,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1405',
              id: 36,
              frequency: 12564,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1404',
              id: 37,
              frequency: 25512,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1403',
              id: 38,
              frequency: 11584,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1402',
              id: 39,
              frequency: 18369,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1401',
              id: 40,
              frequency: 56519,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1400',
              id: 41,
              frequency: 37439,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13ff',
              id: 42,
              frequency: 26210,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13fe',
              id: 43,
              frequency: 64573,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13fd',
              id: 44,
              frequency: 16191,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13fc',
              id: 45,
              frequency: 30383,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13fb',
              id: 46,
              frequency: 49389,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13fa',
              id: 47,
              frequency: 50832,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13f9',
              id: 48,
              frequency: 128998,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13f8',
              id: 49,
              frequency: 2067,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13f7',
              id: 50,
              frequency: 1586,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13f6',
              id: 51,
              frequency: 39122,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13f5',
              id: 52,
              frequency: 16619,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13f4',
              id: 53,
              frequency: 45416,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13f3',
              id: 54,
              frequency: 10649,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13f2',
              id: 55,
              frequency: 7816,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13f1',
              id: 56,
              frequency: 20418,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13f0',
              id: 57,
              frequency: 135102,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13ef',
              id: 58,
              frequency: 38300,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13ee',
              id: 59,
              frequency: 77562,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13ed',
              id: 60,
              frequency: 95384,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13ec',
              id: 61,
              frequency: 49655,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13eb',
              id: 62,
              frequency: 8466,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13ea',
              id: 63,
              frequency: 22721,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13e9',
              id: 64,
              frequency: 19843,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13e8',
              id: 65,
              frequency: 32985,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13e7',
              id: 66,
              frequency: 91807,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13e6',
              id: 67,
              frequency: 101666,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13e5',
              id: 68,
              frequency: 36032,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13e4',
              id: 69,
              frequency: 9058,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13e3',
              id: 70,
              frequency: 47409,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13e2',
              id: 71,
              frequency: 82079,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13e1',
              id: 72,
              frequency: 54919,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1371',
          id: 62,
          abbrevName: '63',
          fullName: '63_R_Frontal_oribital_cortex__frontal_operculum',
          coordinates: {
            x: 42.985507,
            y: 20.299517,
            z: -0.328502,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1380',
              to: 63,
            },
            {
              _id: '5d6615769bcb6d0e6d7a137f',
              to: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a137e',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a137d',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a137c',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a137b',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a137a',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1379',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1378',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1377',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1376',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1375',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1374',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1373',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1372',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a13c9',
              id: 0,
              frequency: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13c8',
              id: 1,
              frequency: 1038,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13c7',
              id: 2,
              frequency: 432,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13c6',
              id: 3,
              frequency: 744,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13c5',
              id: 4,
              frequency: 11717,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13c4',
              id: 5,
              frequency: 11768,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13c3',
              id: 6,
              frequency: 3653,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13c2',
              id: 7,
              frequency: 708,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13c1',
              id: 8,
              frequency: 3260,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13c0',
              id: 9,
              frequency: 8560,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13bf',
              id: 10,
              frequency: 14186,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13be',
              id: 11,
              frequency: 5902,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13bd',
              id: 12,
              frequency: 8675,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13bc',
              id: 13,
              frequency: 6376,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13bb',
              id: 14,
              frequency: 5438,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13ba',
              id: 15,
              frequency: 66374,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13b9',
              id: 16,
              frequency: 74774,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13b8',
              id: 17,
              frequency: 42607,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13b7',
              id: 18,
              frequency: 27725,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13b6',
              id: 19,
              frequency: 44968,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13b5',
              id: 20,
              frequency: 24823,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13b4',
              id: 21,
              frequency: 16818,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13b3',
              id: 22,
              frequency: 3071,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13b2',
              id: 23,
              frequency: 247,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13b1',
              id: 24,
              frequency: 73249,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13b0',
              id: 25,
              frequency: 31872,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13af',
              id: 26,
              frequency: 59209,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13ae',
              id: 27,
              frequency: 54745,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13ad',
              id: 28,
              frequency: 69312,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13ac',
              id: 29,
              frequency: 115076,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13ab',
              id: 30,
              frequency: 59964,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13aa',
              id: 31,
              frequency: 27552,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13a9',
              id: 32,
              frequency: 25368,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13a8',
              id: 33,
              frequency: 5726,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13a7',
              id: 34,
              frequency: 24380,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13a6',
              id: 35,
              frequency: 9974,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13a5',
              id: 36,
              frequency: 15758,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13a4',
              id: 37,
              frequency: 31562,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13a3',
              id: 38,
              frequency: 11152,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13a2',
              id: 39,
              frequency: 32172,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13a1',
              id: 40,
              frequency: 62303,
            },
            {
              _id: '5d6615769bcb6d0e6d7a13a0',
              id: 41,
              frequency: 24278,
            },
            {
              _id: '5d6615769bcb6d0e6d7a139f',
              id: 42,
              frequency: 16244,
            },
            {
              _id: '5d6615769bcb6d0e6d7a139e',
              id: 43,
              frequency: 69460,
            },
            {
              _id: '5d6615769bcb6d0e6d7a139d',
              id: 44,
              frequency: 11158,
            },
            {
              _id: '5d6615769bcb6d0e6d7a139c',
              id: 45,
              frequency: 51276,
            },
            {
              _id: '5d6615769bcb6d0e6d7a139b',
              id: 46,
              frequency: 54919,
            },
            {
              _id: '5d6615769bcb6d0e6d7a139a',
              id: 47,
              frequency: 49709,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1399',
              id: 48,
              frequency: 90378,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1398',
              id: 49,
              frequency: 3075,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1397',
              id: 50,
              frequency: 1704,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1396',
              id: 51,
              frequency: 52425,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1395',
              id: 52,
              frequency: 17935,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1394',
              id: 53,
              frequency: 45099,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1393',
              id: 54,
              frequency: 12569,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1392',
              id: 55,
              frequency: 3884,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1391',
              id: 56,
              frequency: 40194,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1390',
              id: 57,
              frequency: 82631,
            },
            {
              _id: '5d6615769bcb6d0e6d7a138f',
              id: 58,
              frequency: 23457,
            },
            {
              _id: '5d6615769bcb6d0e6d7a138e',
              id: 59,
              frequency: 94157,
            },
            {
              _id: '5d6615769bcb6d0e6d7a138d',
              id: 60,
              frequency: 83124,
            },
            {
              _id: '5d6615769bcb6d0e6d7a138c',
              id: 61,
              frequency: 29389,
            },
            {
              _id: '5d6615769bcb6d0e6d7a138b',
              id: 62,
              frequency: 14062,
            },
            {
              _id: '5d6615769bcb6d0e6d7a138a',
              id: 63,
              frequency: 21616,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1389',
              id: 64,
              frequency: 17091,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1388',
              id: 65,
              frequency: 48701,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1387',
              id: 66,
              frequency: 70466,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1386',
              id: 67,
              frequency: 53771,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1385',
              id: 68,
              frequency: 31534,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1384',
              id: 69,
              frequency: 4928,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1383',
              id: 70,
              frequency: 39914,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1382',
              id: 71,
              frequency: 39684,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1381',
              id: 72,
              frequency: 23388,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1315',
          id: 63,
          abbrevName: '64',
          fullName: '64_L_Heschles',
          coordinates: {
            x: -45.182796,
            y: -25.096774,
            z: 14.236559,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1327',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1326',
              to: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1325',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1324',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1323',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1322',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1321',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1320',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a131f',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a131e',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a131d',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a131c',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a131b',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a131a',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1319',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1318',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1317',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1316',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1370',
              id: 0,
              frequency: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a136f',
              id: 1,
              frequency: 967,
            },
            {
              _id: '5d6615769bcb6d0e6d7a136e',
              id: 2,
              frequency: 324,
            },
            {
              _id: '5d6615769bcb6d0e6d7a136d',
              id: 3,
              frequency: 852,
            },
            {
              _id: '5d6615769bcb6d0e6d7a136c',
              id: 4,
              frequency: 10818,
            },
            {
              _id: '5d6615769bcb6d0e6d7a136b',
              id: 5,
              frequency: 9211,
            },
            {
              _id: '5d6615769bcb6d0e6d7a136a',
              id: 6,
              frequency: 3901,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1369',
              id: 7,
              frequency: 404,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1368',
              id: 8,
              frequency: 2045,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1367',
              id: 9,
              frequency: 6854,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1366',
              id: 10,
              frequency: 16695,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1365',
              id: 11,
              frequency: 3884,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1364',
              id: 12,
              frequency: 8210,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1363',
              id: 13,
              frequency: 6248,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1362',
              id: 14,
              frequency: 7888,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1361',
              id: 15,
              frequency: 66552,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1360',
              id: 16,
              frequency: 55050,
            },
            {
              _id: '5d6615769bcb6d0e6d7a135f',
              id: 17,
              frequency: 35859,
            },
            {
              _id: '5d6615769bcb6d0e6d7a135e',
              id: 18,
              frequency: 21451,
            },
            {
              _id: '5d6615769bcb6d0e6d7a135d',
              id: 19,
              frequency: 47355,
            },
            {
              _id: '5d6615769bcb6d0e6d7a135c',
              id: 20,
              frequency: 25935,
            },
            {
              _id: '5d6615769bcb6d0e6d7a135b',
              id: 21,
              frequency: 10589,
            },
            {
              _id: '5d6615769bcb6d0e6d7a135a',
              id: 22,
              frequency: 5551,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1359',
              id: 23,
              frequency: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1358',
              id: 24,
              frequency: 60537,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1357',
              id: 25,
              frequency: 41625,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1356',
              id: 26,
              frequency: 40434,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1355',
              id: 27,
              frequency: 52533,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1354',
              id: 28,
              frequency: 51109,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1353',
              id: 29,
              frequency: 140514,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1352',
              id: 30,
              frequency: 46247,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1351',
              id: 31,
              frequency: 26444,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1350',
              id: 32,
              frequency: 36653,
            },
            {
              _id: '5d6615769bcb6d0e6d7a134f',
              id: 33,
              frequency: 2645,
            },
            {
              _id: '5d6615769bcb6d0e6d7a134e',
              id: 34,
              frequency: 18529,
            },
            {
              _id: '5d6615769bcb6d0e6d7a134d',
              id: 35,
              frequency: 10473,
            },
            {
              _id: '5d6615769bcb6d0e6d7a134c',
              id: 36,
              frequency: 10061,
            },
            {
              _id: '5d6615769bcb6d0e6d7a134b',
              id: 37,
              frequency: 23124,
            },
            {
              _id: '5d6615769bcb6d0e6d7a134a',
              id: 38,
              frequency: 5965,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1349',
              id: 39,
              frequency: 26324,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1348',
              id: 40,
              frequency: 71248,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1347',
              id: 41,
              frequency: 24602,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1346',
              id: 42,
              frequency: 9179,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1345',
              id: 43,
              frequency: 74641,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1344',
              id: 44,
              frequency: 5259,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1343',
              id: 45,
              frequency: 44051,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1342',
              id: 46,
              frequency: 51969,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1341',
              id: 47,
              frequency: 31985,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1340',
              id: 48,
              frequency: 102245,
            },
            {
              _id: '5d6615769bcb6d0e6d7a133f',
              id: 49,
              frequency: 1533,
            },
            {
              _id: '5d6615769bcb6d0e6d7a133e',
              id: 50,
              frequency: 863,
            },
            {
              _id: '5d6615769bcb6d0e6d7a133d',
              id: 51,
              frequency: 33598,
            },
            {
              _id: '5d6615769bcb6d0e6d7a133c',
              id: 52,
              frequency: 22136,
            },
            {
              _id: '5d6615769bcb6d0e6d7a133b',
              id: 53,
              frequency: 26283,
            },
            {
              _id: '5d6615769bcb6d0e6d7a133a',
              id: 54,
              frequency: 13611,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1339',
              id: 55,
              frequency: 3847,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1338',
              id: 56,
              frequency: 26957,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1337',
              id: 57,
              frequency: 133806,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1336',
              id: 58,
              frequency: 14941,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1335',
              id: 59,
              frequency: 84712,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1334',
              id: 60,
              frequency: 74383,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1333',
              id: 61,
              frequency: 18071,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1332',
              id: 62,
              frequency: 6646,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1331',
              id: 63,
              frequency: 11469,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1330',
              id: 64,
              frequency: 16051,
            },
            {
              _id: '5d6615769bcb6d0e6d7a132f',
              id: 65,
              frequency: 35820,
            },
            {
              _id: '5d6615769bcb6d0e6d7a132e',
              id: 66,
              frequency: 96201,
            },
            {
              _id: '5d6615769bcb6d0e6d7a132d',
              id: 67,
              frequency: 53015,
            },
            {
              _id: '5d6615769bcb6d0e6d7a132c',
              id: 68,
              frequency: 22289,
            },
            {
              _id: '5d6615769bcb6d0e6d7a132b',
              id: 69,
              frequency: 3971,
            },
            {
              _id: '5d6615769bcb6d0e6d7a132a',
              id: 70,
              frequency: 42418,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1329',
              id: 71,
              frequency: 54316,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1328',
              id: 72,
              frequency: 46565,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a12bc',
          id: 64,
          abbrevName: '65',
          fullName: '65_L_MTG_temporooccipital__loc_inferio',
          coordinates: {
            x: -1.55814,
            y: 26.27907,
            z: 55.534884,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a12cb',
              to: 67,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12ca',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12c9',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12c8',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12c7',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12c6',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12c5',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12c4',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12c3',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12c2',
              to: 99,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12c1',
              to: 65,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12c0',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12bf',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12be',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12bd',
              to: 85,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1314',
              id: 0,
              frequency: 40,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1313',
              id: 1,
              frequency: 953,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1312',
              id: 2,
              frequency: 243,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1311',
              id: 3,
              frequency: 537,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1310',
              id: 4,
              frequency: 13964,
            },
            {
              _id: '5d6615769bcb6d0e6d7a130f',
              id: 5,
              frequency: 7884,
            },
            {
              _id: '5d6615769bcb6d0e6d7a130e',
              id: 6,
              frequency: 3907,
            },
            {
              _id: '5d6615769bcb6d0e6d7a130d',
              id: 7,
              frequency: 280,
            },
            {
              _id: '5d6615769bcb6d0e6d7a130c',
              id: 8,
              frequency: 1821,
            },
            {
              _id: '5d6615769bcb6d0e6d7a130b',
              id: 9,
              frequency: 8855,
            },
            {
              _id: '5d6615769bcb6d0e6d7a130a',
              id: 10,
              frequency: 12533,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1309',
              id: 11,
              frequency: 2447,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1308',
              id: 12,
              frequency: 6554,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1307',
              id: 13,
              frequency: 3500,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1306',
              id: 14,
              frequency: 3653,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1305',
              id: 15,
              frequency: 99405,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1304',
              id: 16,
              frequency: 65443,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1303',
              id: 17,
              frequency: 32918,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1302',
              id: 18,
              frequency: 33382,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1301',
              id: 19,
              frequency: 57656,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1300',
              id: 20,
              frequency: 20533,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12ff',
              id: 21,
              frequency: 8575,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12fe',
              id: 22,
              frequency: 4378,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12fd',
              id: 23,
              frequency: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12fc',
              id: 24,
              frequency: 91856,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12fb',
              id: 25,
              frequency: 37369,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12fa',
              id: 26,
              frequency: 33109,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12f9',
              id: 27,
              frequency: 96531,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12f8',
              id: 28,
              frequency: 56839,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12f7',
              id: 29,
              frequency: 131426,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12f6',
              id: 30,
              frequency: 29977,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12f5',
              id: 31,
              frequency: 30732,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12f4',
              id: 32,
              frequency: 26934,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12f3',
              id: 33,
              frequency: 1535,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12f2',
              id: 34,
              frequency: 18995,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12f1',
              id: 35,
              frequency: 15857,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12f0',
              id: 36,
              frequency: 12152,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12ef',
              id: 37,
              frequency: 21989,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12ee',
              id: 38,
              frequency: 4436,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12ed',
              id: 39,
              frequency: 39747,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12ec',
              id: 40,
              frequency: 58243,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12eb',
              id: 41,
              frequency: 18052,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12ea',
              id: 42,
              frequency: 5021,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12e9',
              id: 43,
              frequency: 71367,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12e8',
              id: 44,
              frequency: 2969,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12e7',
              id: 45,
              frequency: 73410,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12e6',
              id: 46,
              frequency: 57351,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12e5',
              id: 47,
              frequency: 24378,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12e4',
              id: 48,
              frequency: 65314,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12e3',
              id: 49,
              frequency: 1737,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12e2',
              id: 50,
              frequency: 603,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12e1',
              id: 51,
              frequency: 38296,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12e0',
              id: 52,
              frequency: 21164,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12df',
              id: 53,
              frequency: 18259,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12de',
              id: 54,
              frequency: 10600,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12dd',
              id: 55,
              frequency: 1961,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12dc',
              id: 56,
              frequency: 49558,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12db',
              id: 57,
              frequency: 73208,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12da',
              id: 58,
              frequency: 7291,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12d9',
              id: 59,
              frequency: 90107,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12d8',
              id: 60,
              frequency: 48178,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12d7',
              id: 61,
              frequency: 9968,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12d6',
              id: 62,
              frequency: 7288,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12d5',
              id: 63,
              frequency: 8724,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12d4',
              id: 64,
              frequency: 10251,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12d3',
              id: 65,
              frequency: 37080,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12d2',
              id: 66,
              frequency: 54186,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12d1',
              id: 67,
              frequency: 23742,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12d0',
              id: 68,
              frequency: 16995,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12cf',
              id: 69,
              frequency: 1888,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12ce',
              id: 70,
              frequency: 26532,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12cd',
              id: 71,
              frequency: 21812,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12cc',
              id: 72,
              frequency: 15126,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a125e',
          id: 65,
          abbrevName: '66',
          fullName: '66_R_Frontal_pole',
          coordinates: {
            x: 19.393939,
            y: 62.787879,
            z: -7.414141,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1272',
              to: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1271',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1270',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a126f',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a126e',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a126d',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a126c',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a126b',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a126a',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1269',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1268',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1267',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1266',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1265',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1264',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1263',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1262',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1261',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1260',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a125f',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a12bb',
              id: 0,
              frequency: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12ba',
              id: 1,
              frequency: 917,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12b9',
              id: 2,
              frequency: 702,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12b8',
              id: 3,
              frequency: 1009,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12b7',
              id: 4,
              frequency: 9352,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12b6',
              id: 5,
              frequency: 14920,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12b5',
              id: 6,
              frequency: 2463,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12b4',
              id: 7,
              frequency: 2185,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12b3',
              id: 8,
              frequency: 2821,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12b2',
              id: 9,
              frequency: 6718,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12b1',
              id: 10,
              frequency: 16400,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12b0',
              id: 11,
              frequency: 11345,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12af',
              id: 12,
              frequency: 8112,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12ae',
              id: 13,
              frequency: 10769,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12ad',
              id: 14,
              frequency: 8210,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12ac',
              id: 15,
              frequency: 40565,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12ab',
              id: 16,
              frequency: 105413,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12aa',
              id: 17,
              frequency: 27018,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12a9',
              id: 18,
              frequency: 10962,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12a8',
              id: 19,
              frequency: 22128,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12a7',
              id: 20,
              frequency: 27704,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12a6',
              id: 21,
              frequency: 47061,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12a5',
              id: 22,
              frequency: 1627,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12a4',
              id: 23,
              frequency: 1965,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12a3',
              id: 24,
              frequency: 35316,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12a2',
              id: 25,
              frequency: 23915,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12a1',
              id: 26,
              frequency: 117925,
            },
            {
              _id: '5d6615769bcb6d0e6d7a12a0',
              id: 27,
              frequency: 52445,
            },
            {
              _id: '5d6615769bcb6d0e6d7a129f',
              id: 28,
              frequency: 89247,
            },
            {
              _id: '5d6615769bcb6d0e6d7a129e',
              id: 29,
              frequency: 126445,
            },
            {
              _id: '5d6615769bcb6d0e6d7a129d',
              id: 30,
              frequency: 83669,
            },
            {
              _id: '5d6615769bcb6d0e6d7a129c',
              id: 31,
              frequency: 14546,
            },
            {
              _id: '5d6615769bcb6d0e6d7a129b',
              id: 32,
              frequency: 23911,
            },
            {
              _id: '5d6615769bcb6d0e6d7a129a',
              id: 33,
              frequency: 25008,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1299',
              id: 34,
              frequency: 22295,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1298',
              id: 35,
              frequency: 7684,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1297',
              id: 36,
              frequency: 12393,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1296',
              id: 37,
              frequency: 21139,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1295',
              id: 38,
              frequency: 18340,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1294',
              id: 39,
              frequency: 19655,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1293',
              id: 40,
              frequency: 46388,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1292',
              id: 41,
              frequency: 44370,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1291',
              id: 42,
              frequency: 51727,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1290',
              id: 43,
              frequency: 81951,
            },
            {
              _id: '5d6615769bcb6d0e6d7a128f',
              id: 44,
              frequency: 25749,
            },
            {
              _id: '5d6615769bcb6d0e6d7a128e',
              id: 45,
              frequency: 40131,
            },
            {
              _id: '5d6615769bcb6d0e6d7a128d',
              id: 46,
              frequency: 41499,
            },
            {
              _id: '5d6615769bcb6d0e6d7a128c',
              id: 47,
              frequency: 73348,
            },
            {
              _id: '5d6615769bcb6d0e6d7a128b',
              id: 48,
              frequency: 128536,
            },
            {
              _id: '5d6615769bcb6d0e6d7a128a',
              id: 49,
              frequency: 2007,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1289',
              id: 50,
              frequency: 1486,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1288',
              id: 51,
              frequency: 41445,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1287',
              id: 52,
              frequency: 16959,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1286',
              id: 53,
              frequency: 52480,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1285',
              id: 54,
              frequency: 9849,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1284',
              id: 55,
              frequency: 12757,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1283',
              id: 56,
              frequency: 32559,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1282',
              id: 57,
              frequency: 114515,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1281',
              id: 58,
              frequency: 51649,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1280',
              id: 59,
              frequency: 82821,
            },
            {
              _id: '5d6615769bcb6d0e6d7a127f',
              id: 60,
              frequency: 106663,
            },
            {
              _id: '5d6615769bcb6d0e6d7a127e',
              id: 61,
              frequency: 59880,
            },
            {
              _id: '5d6615769bcb6d0e6d7a127d',
              id: 62,
              frequency: 8461,
            },
            {
              _id: '5d6615769bcb6d0e6d7a127c',
              id: 63,
              frequency: 18625,
            },
            {
              _id: '5d6615769bcb6d0e6d7a127b',
              id: 64,
              frequency: 18680,
            },
            {
              _id: '5d6615769bcb6d0e6d7a127a',
              id: 65,
              frequency: 38629,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1279',
              id: 66,
              frequency: 87033,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1278',
              id: 67,
              frequency: 104147,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1277',
              id: 68,
              frequency: 29589,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1276',
              id: 69,
              frequency: 9135,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1275',
              id: 70,
              frequency: 39179,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1274',
              id: 71,
              frequency: 74236,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1273',
              id: 72,
              frequency: 38873,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a120f',
          id: 66,
          abbrevName: '67',
          fullName: '67_L_Frontal_orbital',
          coordinates: {
            x: -7.508982,
            y: 20.51497,
            z: -16.45509,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1214',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1213',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1212',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1211',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1210',
              to: 88,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a125d',
              id: 0,
              frequency: 16,
            },
            {
              _id: '5d6615769bcb6d0e6d7a125c',
              id: 1,
              frequency: 510,
            },
            {
              _id: '5d6615769bcb6d0e6d7a125b',
              id: 2,
              frequency: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d7a125a',
              id: 3,
              frequency: 103,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1259',
              id: 4,
              frequency: 10672,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1258',
              id: 5,
              frequency: 583,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1257',
              id: 6,
              frequency: 3322,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1256',
              id: 7,
              frequency: 2,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1255',
              id: 8,
              frequency: 147,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1254',
              id: 9,
              frequency: 6133,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1253',
              id: 10,
              frequency: 3101,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1252',
              id: 11,
              frequency: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1251',
              id: 12,
              frequency: 1836,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1250',
              id: 13,
              frequency: 104,
            },
            {
              _id: '5d6615769bcb6d0e6d7a124f',
              id: 14,
              frequency: 390,
            },
            {
              _id: '5d6615769bcb6d0e6d7a124e',
              id: 15,
              frequency: 117319,
            },
            {
              _id: '5d6615769bcb6d0e6d7a124d',
              id: 16,
              frequency: 9891,
            },
            {
              _id: '5d6615769bcb6d0e6d7a124c',
              id: 17,
              frequency: 1874,
            },
            {
              _id: '5d6615769bcb6d0e6d7a124b',
              id: 18,
              frequency: 41667,
            },
            {
              _id: '5d6615769bcb6d0e6d7a124a',
              id: 19,
              frequency: 77451,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1249',
              id: 20,
              frequency: 2506,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1248',
              id: 21,
              frequency: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1247',
              id: 22,
              frequency: 5420,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1246',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1245',
              id: 24,
              frequency: 103699,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1244',
              id: 25,
              frequency: 9934,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1243',
              id: 26,
              frequency: 1522,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1242',
              id: 27,
              frequency: 94269,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1241',
              id: 28,
              frequency: 5042,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1240',
              id: 29,
              frequency: 49539,
            },
            {
              _id: '5d6615769bcb6d0e6d7a123f',
              id: 30,
              frequency: 419,
            },
            {
              _id: '5d6615769bcb6d0e6d7a123e',
              id: 31,
              frequency: 37949,
            },
            {
              _id: '5d6615769bcb6d0e6d7a123d',
              id: 32,
              frequency: 10828,
            },
            {
              _id: '5d6615769bcb6d0e6d7a123c',
              id: 33,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d7a123b',
              id: 34,
              frequency: 1164,
            },
            {
              _id: '5d6615769bcb6d0e6d7a123a',
              id: 35,
              frequency: 19926,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1239',
              id: 36,
              frequency: 2585,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1238',
              id: 37,
              frequency: 1838,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1237',
              id: 38,
              frequency: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1236',
              id: 39,
              frequency: 43874,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1235',
              id: 40,
              frequency: 23290,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1234',
              id: 41,
              frequency: 1046,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1233',
              id: 42,
              frequency: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1232',
              id: 43,
              frequency: 23547,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1231',
              id: 44,
              frequency: 3,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1230',
              id: 45,
              frequency: 67833,
            },
            {
              _id: '5d6615769bcb6d0e6d7a122f',
              id: 46,
              frequency: 24078,
            },
            {
              _id: '5d6615769bcb6d0e6d7a122e',
              id: 47,
              frequency: 862,
            },
            {
              _id: '5d6615769bcb6d0e6d7a122d',
              id: 48,
              frequency: 1934,
            },
            {
              _id: '5d6615769bcb6d0e6d7a122c',
              id: 49,
              frequency: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a122b',
              id: 50,
              frequency: 8,
            },
            {
              _id: '5d6615769bcb6d0e6d7a122a',
              id: 51,
              frequency: 3270,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1229',
              id: 52,
              frequency: 5483,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1228',
              id: 53,
              frequency: 356,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1227',
              id: 54,
              frequency: 5623,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1226',
              id: 55,
              frequency: 5,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1225',
              id: 56,
              frequency: 38972,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1224',
              id: 57,
              frequency: 10002,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1223',
              id: 58,
              frequency: 150,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1222',
              id: 59,
              frequency: 30760,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1221',
              id: 60,
              frequency: 1594,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1220',
              id: 61,
              frequency: 37,
            },
            {
              _id: '5d6615769bcb6d0e6d7a121f',
              id: 62,
              frequency: 578,
            },
            {
              _id: '5d6615769bcb6d0e6d7a121e',
              id: 63,
              frequency: 381,
            },
            {
              _id: '5d6615769bcb6d0e6d7a121d',
              id: 64,
              frequency: 248,
            },
            {
              _id: '5d6615769bcb6d0e6d7a121c',
              id: 65,
              frequency: 14110,
            },
            {
              _id: '5d6615769bcb6d0e6d7a121b',
              id: 66,
              frequency: 7708,
            },
            {
              _id: '5d6615769bcb6d0e6d7a121a',
              id: 67,
              frequency: 254,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1219',
              id: 68,
              frequency: 639,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1218',
              id: 69,
              frequency: 2,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1217',
              id: 70,
              frequency: 4627,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1216',
              id: 71,
              frequency: 363,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1215',
              id: 72,
              frequency: 985,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a11b3',
          id: 67,
          abbrevName: '68',
          fullName: '68_L_MTG_temporooccipital_smg_angular',
          coordinates: {
            x: -56.381818,
            y: -53.563636,
            z: 10.836364,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a11c5',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11c4',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11c3',
              to: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11c2',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11c1',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11c0',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11bf',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11be',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11bd',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11bc',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11bb',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11ba',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11b9',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11b8',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11b7',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11b6',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11b5',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11b4',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a120e',
              id: 0,
              frequency: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a120d',
              id: 1,
              frequency: 1013,
            },
            {
              _id: '5d6615769bcb6d0e6d7a120c',
              id: 2,
              frequency: 631,
            },
            {
              _id: '5d6615769bcb6d0e6d7a120b',
              id: 3,
              frequency: 965,
            },
            {
              _id: '5d6615769bcb6d0e6d7a120a',
              id: 4,
              frequency: 9673,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1209',
              id: 5,
              frequency: 14828,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1208',
              id: 6,
              frequency: 3240,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1207',
              id: 7,
              frequency: 1695,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1206',
              id: 8,
              frequency: 3203,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1205',
              id: 9,
              frequency: 6298,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1204',
              id: 10,
              frequency: 15900,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1203',
              id: 11,
              frequency: 10140,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1202',
              id: 12,
              frequency: 9797,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1201',
              id: 13,
              frequency: 9340,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1200',
              id: 14,
              frequency: 8085,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11ff',
              id: 15,
              frequency: 49934,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11fe',
              id: 16,
              frequency: 83691,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11fd',
              id: 17,
              frequency: 50441,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11fc',
              id: 18,
              frequency: 15359,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11fb',
              id: 19,
              frequency: 32927,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11fa',
              id: 20,
              frequency: 28075,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11f9',
              id: 21,
              frequency: 36615,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11f8',
              id: 22,
              frequency: 3086,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11f7',
              id: 23,
              frequency: 1174,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11f6',
              id: 24,
              frequency: 47780,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11f5',
              id: 25,
              frequency: 34858,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11f4',
              id: 26,
              frequency: 95519,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11f3',
              id: 27,
              frequency: 39871,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11f2',
              id: 28,
              frequency: 67421,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11f1',
              id: 29,
              frequency: 105304,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11f0',
              id: 30,
              frequency: 86035,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11ef',
              id: 31,
              frequency: 18167,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11ee',
              id: 32,
              frequency: 24657,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11ed',
              id: 33,
              frequency: 18789,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11ec',
              id: 34,
              frequency: 27923,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11eb',
              id: 35,
              frequency: 8513,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11ea',
              id: 36,
              frequency: 12942,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11e9',
              id: 37,
              frequency: 29128,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11e8',
              id: 38,
              frequency: 19955,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11e7',
              id: 39,
              frequency: 19814,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11e6',
              id: 40,
              frequency: 68360,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11e5',
              id: 41,
              frequency: 37056,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11e4',
              id: 42,
              frequency: 38839,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11e3',
              id: 43,
              frequency: 57776,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11e2',
              id: 44,
              frequency: 25056,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11e1',
              id: 45,
              frequency: 34709,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11e0',
              id: 46,
              frequency: 50260,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11df',
              id: 47,
              frequency: 80732,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11de',
              id: 48,
              frequency: 111335,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11dd',
              id: 49,
              frequency: 1916,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11dc',
              id: 50,
              frequency: 1749,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11db',
              id: 51,
              frequency: 43800,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11da',
              id: 52,
              frequency: 20619,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11d9',
              id: 53,
              frequency: 53414,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11d8',
              id: 54,
              frequency: 13694,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11d7',
              id: 55,
              frequency: 10417,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11d6',
              id: 56,
              frequency: 21320,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11d5',
              id: 57,
              frequency: 108496,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11d4',
              id: 58,
              frequency: 47638,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11d3',
              id: 59,
              frequency: 85405,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11d2',
              id: 60,
              frequency: 108598,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11d1',
              id: 61,
              frequency: 47922,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11d0',
              id: 62,
              frequency: 9272,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11cf',
              id: 63,
              frequency: 21815,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11ce',
              id: 64,
              frequency: 17403,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11cd',
              id: 65,
              frequency: 39871,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11cc',
              id: 66,
              frequency: 89862,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11cb',
              id: 67,
              frequency: 93322,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11ca',
              id: 68,
              frequency: 36516,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11c9',
              id: 69,
              frequency: 5567,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11c8',
              id: 70,
              frequency: 54932,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11c7',
              id: 71,
              frequency: 64757,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11c6',
              id: 72,
              frequency: 41529,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a115a',
          id: 68,
          abbrevName: '69',
          fullName: '69_BI_ACC_M_AMCC',
          coordinates: {
            x: 0.349776,
            y: 8.547085,
            z: 39.408072,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1169',
              to: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1168',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1167',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1166',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1165',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1164',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1163',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1162',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1161',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1160',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a115f',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a115e',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a115d',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a115c',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a115b',
              to: 97,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a11b2',
              id: 0,
              frequency: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11b1',
              id: 1,
              frequency: 1001,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11b0',
              id: 2,
              frequency: 428,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11af',
              id: 3,
              frequency: 797,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11ae',
              id: 4,
              frequency: 11769,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11ad',
              id: 5,
              frequency: 11247,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11ac',
              id: 6,
              frequency: 3363,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11ab',
              id: 7,
              frequency: 651,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11aa',
              id: 8,
              frequency: 2935,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11a9',
              id: 9,
              frequency: 7748,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11a8',
              id: 10,
              frequency: 14384,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11a7',
              id: 11,
              frequency: 5868,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11a6',
              id: 12,
              frequency: 8774,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11a5',
              id: 13,
              frequency: 6855,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11a4',
              id: 14,
              frequency: 6226,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11a3',
              id: 15,
              frequency: 70259,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11a2',
              id: 16,
              frequency: 76993,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11a1',
              id: 17,
              frequency: 39280,
            },
            {
              _id: '5d6615769bcb6d0e6d7a11a0',
              id: 18,
              frequency: 26506,
            },
            {
              _id: '5d6615769bcb6d0e6d7a119f',
              id: 19,
              frequency: 39953,
            },
            {
              _id: '5d6615769bcb6d0e6d7a119e',
              id: 20,
              frequency: 22933,
            },
            {
              _id: '5d6615769bcb6d0e6d7a119d',
              id: 21,
              frequency: 15541,
            },
            {
              _id: '5d6615769bcb6d0e6d7a119c',
              id: 22,
              frequency: 3136,
            },
            {
              _id: '5d6615769bcb6d0e6d7a119b',
              id: 23,
              frequency: 158,
            },
            {
              _id: '5d6615769bcb6d0e6d7a119a',
              id: 24,
              frequency: 71531,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1199',
              id: 25,
              frequency: 28485,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1198',
              id: 26,
              frequency: 56198,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1197',
              id: 27,
              frequency: 58077,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1196',
              id: 28,
              frequency: 61343,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1195',
              id: 29,
              frequency: 125264,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1194',
              id: 30,
              frequency: 58863,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1193',
              id: 31,
              frequency: 23083,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1192',
              id: 32,
              frequency: 26390,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1191',
              id: 33,
              frequency: 5170,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1190',
              id: 34,
              frequency: 24141,
            },
            {
              _id: '5d6615769bcb6d0e6d7a118f',
              id: 35,
              frequency: 10394,
            },
            {
              _id: '5d6615769bcb6d0e6d7a118e',
              id: 36,
              frequency: 16021,
            },
            {
              _id: '5d6615769bcb6d0e6d7a118d',
              id: 37,
              frequency: 27904,
            },
            {
              _id: '5d6615769bcb6d0e6d7a118c',
              id: 38,
              frequency: 9459,
            },
            {
              _id: '5d6615769bcb6d0e6d7a118b',
              id: 39,
              frequency: 28875,
            },
            {
              _id: '5d6615769bcb6d0e6d7a118a',
              id: 40,
              frequency: 60570,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1189',
              id: 41,
              frequency: 25277,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1188',
              id: 42,
              frequency: 15395,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1187',
              id: 43,
              frequency: 65849,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1186',
              id: 44,
              frequency: 10702,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1185',
              id: 45,
              frequency: 49716,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1184',
              id: 46,
              frequency: 59449,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1183',
              id: 47,
              frequency: 49075,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1182',
              id: 48,
              frequency: 95497,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1181',
              id: 49,
              frequency: 2012,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1180',
              id: 50,
              frequency: 1271,
            },
            {
              _id: '5d6615769bcb6d0e6d7a117f',
              id: 51,
              frequency: 48241,
            },
            {
              _id: '5d6615769bcb6d0e6d7a117e',
              id: 52,
              frequency: 17850,
            },
            {
              _id: '5d6615769bcb6d0e6d7a117d',
              id: 53,
              frequency: 39531,
            },
            {
              _id: '5d6615769bcb6d0e6d7a117c',
              id: 54,
              frequency: 11483,
            },
            {
              _id: '5d6615769bcb6d0e6d7a117b',
              id: 55,
              frequency: 4230,
            },
            {
              _id: '5d6615769bcb6d0e6d7a117a',
              id: 56,
              frequency: 33129,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1179',
              id: 57,
              frequency: 91884,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1178',
              id: 58,
              frequency: 24004,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1177',
              id: 59,
              frequency: 91261,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1176',
              id: 60,
              frequency: 82754,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1175',
              id: 61,
              frequency: 30266,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1174',
              id: 62,
              frequency: 10336,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1173',
              id: 63,
              frequency: 19631,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1172',
              id: 64,
              frequency: 16948,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1171',
              id: 65,
              frequency: 46143,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1170',
              id: 66,
              frequency: 74117,
            },
            {
              _id: '5d6615769bcb6d0e6d7a116f',
              id: 67,
              frequency: 59314,
            },
            {
              _id: '5d6615769bcb6d0e6d7a116e',
              id: 68,
              frequency: 31867,
            },
            {
              _id: '5d6615769bcb6d0e6d7a116d',
              id: 69,
              frequency: 5678,
            },
            {
              _id: '5d6615769bcb6d0e6d7a116c',
              id: 70,
              frequency: 43947,
            },
            {
              _id: '5d6615769bcb6d0e6d7a116b',
              id: 71,
              frequency: 46114,
            },
            {
              _id: '5d6615769bcb6d0e6d7a116a',
              id: 72,
              frequency: 29269,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a1102',
          id: 69,
          abbrevName: '70',
          fullName: '70_R_LOC_inferior',
          coordinates: {
            x: 45.423256,
            y: -75.060465,
            z: -0.669767,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1110',
              to: 70,
            },
            {
              _id: '5d6615769bcb6d0e6d7a110f',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a110e',
              to: 74,
            },
            {
              _id: '5d6615769bcb6d0e6d7a110d',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a110c',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a110b',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a110a',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1109',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1108',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1107',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1106',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1105',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1104',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1103',
              to: 95,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1159',
              id: 0,
              frequency: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1158',
              id: 1,
              frequency: 911,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1157',
              id: 2,
              frequency: 210,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1156',
              id: 3,
              frequency: 780,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1155',
              id: 4,
              frequency: 11914,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1154',
              id: 5,
              frequency: 6250,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1153',
              id: 6,
              frequency: 3735,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1152',
              id: 7,
              frequency: 169,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1151',
              id: 8,
              frequency: 1329,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1150',
              id: 9,
              frequency: 6999,
            },
            {
              _id: '5d6615769bcb6d0e6d7a114f',
              id: 10,
              frequency: 16712,
            },
            {
              _id: '5d6615769bcb6d0e6d7a114e',
              id: 11,
              frequency: 2031,
            },
            {
              _id: '5d6615769bcb6d0e6d7a114d',
              id: 12,
              frequency: 7232,
            },
            {
              _id: '5d6615769bcb6d0e6d7a114c',
              id: 13,
              frequency: 4461,
            },
            {
              _id: '5d6615769bcb6d0e6d7a114b',
              id: 14,
              frequency: 7529,
            },
            {
              _id: '5d6615769bcb6d0e6d7a114a',
              id: 15,
              frequency: 82365,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1149',
              id: 16,
              frequency: 47000,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1148',
              id: 17,
              frequency: 23235,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1147',
              id: 18,
              frequency: 26992,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1146',
              id: 19,
              frequency: 51708,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1145',
              id: 20,
              frequency: 18577,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1144',
              id: 21,
              frequency: 4709,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1143',
              id: 22,
              frequency: 4501,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1142',
              id: 23,
              frequency: 21,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1141',
              id: 24,
              frequency: 68211,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1140',
              id: 25,
              frequency: 42763,
            },
            {
              _id: '5d6615769bcb6d0e6d7a113f',
              id: 26,
              frequency: 23714,
            },
            {
              _id: '5d6615769bcb6d0e6d7a113e',
              id: 27,
              frequency: 65663,
            },
            {
              _id: '5d6615769bcb6d0e6d7a113d',
              id: 28,
              frequency: 38951,
            },
            {
              _id: '5d6615769bcb6d0e6d7a113c',
              id: 29,
              frequency: 164922,
            },
            {
              _id: '5d6615769bcb6d0e6d7a113b',
              id: 30,
              frequency: 25383,
            },
            {
              _id: '5d6615769bcb6d0e6d7a113a',
              id: 31,
              frequency: 27795,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1139',
              id: 32,
              frequency: 39256,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1138',
              id: 33,
              frequency: 830,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1137',
              id: 34,
              frequency: 13542,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1136',
              id: 35,
              frequency: 13291,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1135',
              id: 36,
              frequency: 7381,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1134',
              id: 37,
              frequency: 16077,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1133',
              id: 38,
              frequency: 2558,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1132',
              id: 39,
              frequency: 29587,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1131',
              id: 40,
              frequency: 65236,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1130',
              id: 41,
              frequency: 20462,
            },
            {
              _id: '5d6615769bcb6d0e6d7a112f',
              id: 42,
              frequency: 3360,
            },
            {
              _id: '5d6615769bcb6d0e6d7a112e',
              id: 43,
              frequency: 84475,
            },
            {
              _id: '5d6615769bcb6d0e6d7a112d',
              id: 44,
              frequency: 1707,
            },
            {
              _id: '5d6615769bcb6d0e6d7a112c',
              id: 45,
              frequency: 50982,
            },
            {
              _id: '5d6615769bcb6d0e6d7a112b',
              id: 46,
              frequency: 55098,
            },
            {
              _id: '5d6615769bcb6d0e6d7a112a',
              id: 47,
              frequency: 15827,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1129',
              id: 48,
              frequency: 78609,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1128',
              id: 49,
              frequency: 1322,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1127',
              id: 50,
              frequency: 276,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1126',
              id: 51,
              frequency: 23050,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1125',
              id: 52,
              frequency: 24633,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1124',
              id: 53,
              frequency: 15215,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1123',
              id: 54,
              frequency: 11275,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1122',
              id: 55,
              frequency: 1994,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1121',
              id: 56,
              frequency: 29881,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1120',
              id: 57,
              frequency: 144637,
            },
            {
              _id: '5d6615769bcb6d0e6d7a111f',
              id: 58,
              frequency: 7160,
            },
            {
              _id: '5d6615769bcb6d0e6d7a111e',
              id: 59,
              frequency: 87936,
            },
            {
              _id: '5d6615769bcb6d0e6d7a111d',
              id: 60,
              frequency: 54258,
            },
            {
              _id: '5d6615769bcb6d0e6d7a111c',
              id: 61,
              frequency: 8363,
            },
            {
              _id: '5d6615769bcb6d0e6d7a111b',
              id: 62,
              frequency: 4451,
            },
            {
              _id: '5d6615769bcb6d0e6d7a111a',
              id: 63,
              frequency: 5653,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1119',
              id: 64,
              frequency: 12100,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1118',
              id: 65,
              frequency: 32321,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1117',
              id: 66,
              frequency: 96211,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1116',
              id: 67,
              frequency: 31888,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1115',
              id: 68,
              frequency: 15140,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1114',
              id: 69,
              frequency: 2547,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1113',
              id: 70,
              frequency: 36249,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1112',
              id: 71,
              frequency: 43665,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1111',
              id: 72,
              frequency: 47460,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a10a9',
          id: 70,
          abbrevName: '71',
          fullName: '71_R_PostcentraL_precentral',
          coordinates: {
            x: 48.042194,
            y: -13.544304,
            z: 46.78481,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a10b8',
              to: 71,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10b7',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10b6',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10b5',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10b4',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10b3',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10b2',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10b1',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10b0',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10af',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10ae',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10ad',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10ac',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10ab',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10aa',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a1101',
              id: 0,
              frequency: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1100',
              id: 1,
              frequency: 876,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10ff',
              id: 2,
              frequency: 377,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10fe',
              id: 3,
              frequency: 898,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10fd',
              id: 4,
              frequency: 12018,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10fc',
              id: 5,
              frequency: 8722,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10fb',
              id: 6,
              frequency: 2631,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10fa',
              id: 7,
              frequency: 396,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10f9',
              id: 8,
              frequency: 2155,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10f8',
              id: 9,
              frequency: 6347,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10f7',
              id: 10,
              frequency: 15366,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10f6',
              id: 11,
              frequency: 5062,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10f5',
              id: 12,
              frequency: 7701,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10f4',
              id: 13,
              frequency: 7161,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10f3',
              id: 14,
              frequency: 8206,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10f2',
              id: 15,
              frequency: 76309,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10f1',
              id: 16,
              frequency: 80432,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10f0',
              id: 17,
              frequency: 20035,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10ef',
              id: 18,
              frequency: 27877,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10ee',
              id: 19,
              frequency: 32109,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10ed',
              id: 20,
              frequency: 16285,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10ec',
              id: 21,
              frequency: 8060,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10eb',
              id: 22,
              frequency: 2212,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10ea',
              id: 23,
              frequency: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10e9',
              id: 24,
              frequency: 59294,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10e8',
              id: 25,
              frequency: 22508,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10e7',
              id: 26,
              frequency: 48736,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10e6',
              id: 27,
              frequency: 68391,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10e5',
              id: 28,
              frequency: 48000,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10e4',
              id: 29,
              frequency: 165434,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10e3',
              id: 30,
              frequency: 45451,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10e2',
              id: 31,
              frequency: 16604,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10e1',
              id: 32,
              frequency: 26587,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10e0',
              id: 33,
              frequency: 2430,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10df',
              id: 34,
              frequency: 18028,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10de',
              id: 35,
              frequency: 11368,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10dd',
              id: 36,
              frequency: 15334,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10dc',
              id: 37,
              frequency: 18488,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10db',
              id: 38,
              frequency: 5080,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10da',
              id: 39,
              frequency: 24041,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10d9',
              id: 40,
              frequency: 48634,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10d8',
              id: 41,
              frequency: 28514,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10d7',
              id: 42,
              frequency: 10617,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10d6',
              id: 43,
              frequency: 73274,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10d5',
              id: 44,
              frequency: 8396,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10d4',
              id: 45,
              frequency: 47463,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10d3',
              id: 46,
              frequency: 66031,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10d2',
              id: 47,
              frequency: 32510,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10d1',
              id: 48,
              frequency: 94778,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10d0',
              id: 49,
              frequency: 1625,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10cf',
              id: 50,
              frequency: 590,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10ce',
              id: 51,
              frequency: 33289,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10cd',
              id: 52,
              frequency: 19091,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10cc',
              id: 53,
              frequency: 29992,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10cb',
              id: 54,
              frequency: 9153,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10ca',
              id: 55,
              frequency: 3387,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10c9',
              id: 56,
              frequency: 26466,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10c8',
              id: 57,
              frequency: 125990,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10c7',
              id: 58,
              frequency: 21740,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10c6',
              id: 59,
              frequency: 84777,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10c5',
              id: 60,
              frequency: 71670,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10c4',
              id: 61,
              frequency: 26853,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10c3',
              id: 62,
              frequency: 5944,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10c2',
              id: 63,
              frequency: 13695,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10c1',
              id: 64,
              frequency: 15455,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10c0',
              id: 65,
              frequency: 33061,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10bf',
              id: 66,
              frequency: 83920,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10be',
              id: 67,
              frequency: 64372,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10bd',
              id: 68,
              frequency: 25908,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10bc',
              id: 69,
              frequency: 5396,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10bb',
              id: 70,
              frequency: 41246,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10ba',
              id: 71,
              frequency: 59458,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10b9',
              id: 72,
              frequency: 47215,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a104e',
          id: 71,
          abbrevName: '72',
          fullName: '72_R_Planum_polare_central_operculum',
          coordinates: {
            x: -50.432432,
            y: 0.054054,
            z: -4.648649,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a105f',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a105e',
              to: 77,
            },
            {
              _id: '5d6615769bcb6d0e6d7a105d',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a105c',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a105b',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a105a',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1059',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1058',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1057',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1056',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1055',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1054',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1053',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1052',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1051',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1050',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a104f',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a10a8',
              id: 0,
              frequency: 64,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10a7',
              id: 1,
              frequency: 856,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10a6',
              id: 2,
              frequency: 785,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10a5',
              id: 3,
              frequency: 1231,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10a4',
              id: 4,
              frequency: 7377,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10a3',
              id: 5,
              frequency: 14682,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10a2',
              id: 6,
              frequency: 2063,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10a1',
              id: 7,
              frequency: 2302,
            },
            {
              _id: '5d6615769bcb6d0e6d7a10a0',
              id: 8,
              frequency: 3212,
            },
            {
              _id: '5d6615769bcb6d0e6d7a109f',
              id: 9,
              frequency: 4776,
            },
            {
              _id: '5d6615769bcb6d0e6d7a109e',
              id: 10,
              frequency: 16400,
            },
            {
              _id: '5d6615769bcb6d0e6d7a109d',
              id: 11,
              frequency: 14112,
            },
            {
              _id: '5d6615769bcb6d0e6d7a109c',
              id: 12,
              frequency: 8211,
            },
            {
              _id: '5d6615769bcb6d0e6d7a109b',
              id: 13,
              frequency: 13540,
            },
            {
              _id: '5d6615769bcb6d0e6d7a109a',
              id: 14,
              frequency: 11710,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1099',
              id: 15,
              frequency: 30052,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1098',
              id: 16,
              frequency: 78498,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1097',
              id: 17,
              frequency: 29335,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1096',
              id: 18,
              frequency: 11025,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1095',
              id: 19,
              frequency: 16357,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1094',
              id: 20,
              frequency: 24659,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1093',
              id: 21,
              frequency: 41642,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1092',
              id: 22,
              frequency: 1524,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1091',
              id: 23,
              frequency: 1402,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1090',
              id: 24,
              frequency: 29868,
            },
            {
              _id: '5d6615769bcb6d0e6d7a108f',
              id: 25,
              frequency: 20631,
            },
            {
              _id: '5d6615769bcb6d0e6d7a108e',
              id: 26,
              frequency: 108402,
            },
            {
              _id: '5d6615769bcb6d0e6d7a108d',
              id: 27,
              frequency: 26319,
            },
            {
              _id: '5d6615769bcb6d0e6d7a108c',
              id: 28,
              frequency: 62196,
            },
            {
              _id: '5d6615769bcb6d0e6d7a108b',
              id: 29,
              frequency: 106659,
            },
            {
              _id: '5d6615769bcb6d0e6d7a108a',
              id: 30,
              frequency: 106278,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1089',
              id: 31,
              frequency: 9878,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1088',
              id: 32,
              frequency: 23508,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1087',
              id: 33,
              frequency: 29608,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1086',
              id: 34,
              frequency: 20533,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1085',
              id: 35,
              frequency: 4724,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1084',
              id: 36,
              frequency: 13072,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1083',
              id: 37,
              frequency: 21307,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1082',
              id: 38,
              frequency: 20381,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1081',
              id: 39,
              frequency: 12966,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1080',
              id: 40,
              frequency: 41093,
            },
            {
              _id: '5d6615769bcb6d0e6d7a107f',
              id: 41,
              frequency: 42487,
            },
            {
              _id: '5d6615769bcb6d0e6d7a107e',
              id: 42,
              frequency: 61887,
            },
            {
              _id: '5d6615769bcb6d0e6d7a107d',
              id: 43,
              frequency: 57818,
            },
            {
              _id: '5d6615769bcb6d0e6d7a107c',
              id: 44,
              frequency: 34138,
            },
            {
              _id: '5d6615769bcb6d0e6d7a107b',
              id: 45,
              frequency: 23550,
            },
            {
              _id: '5d6615769bcb6d0e6d7a107a',
              id: 46,
              frequency: 39906,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1079',
              id: 47,
              frequency: 74331,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1078',
              id: 48,
              frequency: 141726,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1077',
              id: 49,
              frequency: 1620,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1076',
              id: 50,
              frequency: 2319,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1075',
              id: 51,
              frequency: 38485,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1074',
              id: 52,
              frequency: 14503,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1073',
              id: 53,
              frequency: 63271,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1072',
              id: 54,
              frequency: 8081,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1071',
              id: 55,
              frequency: 13711,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1070',
              id: 56,
              frequency: 14703,
            },
            {
              _id: '5d6615769bcb6d0e6d7a106f',
              id: 57,
              frequency: 136093,
            },
            {
              _id: '5d6615769bcb6d0e6d7a106e',
              id: 58,
              frequency: 77324,
            },
            {
              _id: '5d6615769bcb6d0e6d7a106d',
              id: 59,
              frequency: 65081,
            },
            {
              _id: '5d6615769bcb6d0e6d7a106c',
              id: 60,
              frequency: 111621,
            },
            {
              _id: '5d6615769bcb6d0e6d7a106b',
              id: 61,
              frequency: 80801,
            },
            {
              _id: '5d6615769bcb6d0e6d7a106a',
              id: 62,
              frequency: 8116,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1069',
              id: 63,
              frequency: 25861,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1068',
              id: 64,
              frequency: 21485,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1067',
              id: 65,
              frequency: 30538,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1066',
              id: 66,
              frequency: 95825,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1065',
              id: 67,
              frequency: 147716,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1064',
              id: 68,
              frequency: 35328,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1063',
              id: 69,
              frequency: 12316,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1062',
              id: 70,
              frequency: 43596,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1061',
              id: 71,
              frequency: 108311,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1060',
              id: 72,
              frequency: 68162,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0ff6',
          id: 72,
          abbrevName: '73',
          fullName: '73_L_Frontal_pole',
          coordinates: {
            x: -15.54717,
            y: 53.566038,
            z: 30.358491,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a1004',
              to: 73,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1003',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1002',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1001',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1000',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fff',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ffe',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ffd',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ffc',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ffb',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ffa',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ff9',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ff8',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ff7',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a104d',
              id: 0,
              frequency: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a104c',
              id: 1,
              frequency: 943,
            },
            {
              _id: '5d6615769bcb6d0e6d7a104b',
              id: 2,
              frequency: 342,
            },
            {
              _id: '5d6615769bcb6d0e6d7a104a',
              id: 3,
              frequency: 693,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1049',
              id: 4,
              frequency: 12052,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1048',
              id: 5,
              frequency: 9773,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1047',
              id: 6,
              frequency: 3482,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1046',
              id: 7,
              frequency: 606,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1045',
              id: 8,
              frequency: 1876,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1044',
              id: 9,
              frequency: 8503,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1043',
              id: 10,
              frequency: 14882,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1042',
              id: 11,
              frequency: 3853,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1041',
              id: 12,
              frequency: 7014,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1040',
              id: 13,
              frequency: 5524,
            },
            {
              _id: '5d6615769bcb6d0e6d7a103f',
              id: 14,
              frequency: 5197,
            },
            {
              _id: '5d6615769bcb6d0e6d7a103e',
              id: 15,
              frequency: 83015,
            },
            {
              _id: '5d6615769bcb6d0e6d7a103d',
              id: 16,
              frequency: 78990,
            },
            {
              _id: '5d6615769bcb6d0e6d7a103c',
              id: 17,
              frequency: 29173,
            },
            {
              _id: '5d6615769bcb6d0e6d7a103b',
              id: 18,
              frequency: 23641,
            },
            {
              _id: '5d6615769bcb6d0e6d7a103a',
              id: 19,
              frequency: 42791,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1039',
              id: 20,
              frequency: 24509,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1038',
              id: 21,
              frequency: 17595,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1037',
              id: 22,
              frequency: 2994,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1036',
              id: 23,
              frequency: 322,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1035',
              id: 24,
              frequency: 73203,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1034',
              id: 25,
              frequency: 34790,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1033',
              id: 26,
              frequency: 51729,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1032',
              id: 27,
              frequency: 73860,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1031',
              id: 28,
              frequency: 73875,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1030',
              id: 29,
              frequency: 143829,
            },
            {
              _id: '5d6615769bcb6d0e6d7a102f',
              id: 30,
              frequency: 40738,
            },
            {
              _id: '5d6615769bcb6d0e6d7a102e',
              id: 31,
              frequency: 26902,
            },
            {
              _id: '5d6615769bcb6d0e6d7a102d',
              id: 32,
              frequency: 31002,
            },
            {
              _id: '5d6615769bcb6d0e6d7a102c',
              id: 33,
              frequency: 4217,
            },
            {
              _id: '5d6615769bcb6d0e6d7a102b',
              id: 34,
              frequency: 17672,
            },
            {
              _id: '5d6615769bcb6d0e6d7a102a',
              id: 35,
              frequency: 13314,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1029',
              id: 36,
              frequency: 11004,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1028',
              id: 37,
              frequency: 19816,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1027',
              id: 38,
              frequency: 6989,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1026',
              id: 39,
              frequency: 36943,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1025',
              id: 40,
              frequency: 57617,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1024',
              id: 41,
              frequency: 29395,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1023',
              id: 42,
              frequency: 11497,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1022',
              id: 43,
              frequency: 88477,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1021',
              id: 44,
              frequency: 4941,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1020',
              id: 45,
              frequency: 58026,
            },
            {
              _id: '5d6615769bcb6d0e6d7a101f',
              id: 46,
              frequency: 47771,
            },
            {
              _id: '5d6615769bcb6d0e6d7a101e',
              id: 47,
              frequency: 32424,
            },
            {
              _id: '5d6615769bcb6d0e6d7a101d',
              id: 48,
              frequency: 90983,
            },
            {
              _id: '5d6615769bcb6d0e6d7a101c',
              id: 49,
              frequency: 1547,
            },
            {
              _id: '5d6615769bcb6d0e6d7a101b',
              id: 50,
              frequency: 662,
            },
            {
              _id: '5d6615769bcb6d0e6d7a101a',
              id: 51,
              frequency: 36356,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1019',
              id: 52,
              frequency: 20181,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1018',
              id: 53,
              frequency: 23298,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1017',
              id: 54,
              frequency: 10326,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1016',
              id: 55,
              frequency: 4839,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1015',
              id: 56,
              frequency: 46077,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1014',
              id: 57,
              frequency: 98455,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1013',
              id: 58,
              frequency: 12475,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1012',
              id: 59,
              frequency: 89909,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1011',
              id: 60,
              frequency: 68510,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1010',
              id: 61,
              frequency: 17845,
            },
            {
              _id: '5d6615769bcb6d0e6d7a100f',
              id: 62,
              frequency: 6422,
            },
            {
              _id: '5d6615769bcb6d0e6d7a100e',
              id: 63,
              frequency: 9245,
            },
            {
              _id: '5d6615769bcb6d0e6d7a100d',
              id: 64,
              frequency: 12629,
            },
            {
              _id: '5d6615769bcb6d0e6d7a100c',
              id: 65,
              frequency: 40587,
            },
            {
              _id: '5d6615769bcb6d0e6d7a100b',
              id: 66,
              frequency: 69665,
            },
            {
              _id: '5d6615769bcb6d0e6d7a100a',
              id: 67,
              frequency: 41372,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1009',
              id: 68,
              frequency: 19152,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1008',
              id: 69,
              frequency: 4016,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1007',
              id: 70,
              frequency: 30156,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1006',
              id: 71,
              frequency: 38510,
            },
            {
              _id: '5d6615769bcb6d0e6d7a1005',
              id: 72,
              frequency: 23151,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0f99',
          id: 73,
          abbrevName: '74',
          fullName: '74_R_Cerebellum_posterior',
          coordinates: {
            x: 40.693878,
            y: -67.714286,
            z: -37.322449,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0fac',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fab',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0faa',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fa9',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fa8',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fa7',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fa6',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fa5',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fa4',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fa3',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fa2',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fa1',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fa0',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f9f',
              to: 93,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f9e',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f9d',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f9c',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f9b',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f9a',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0ff5',
              id: 0,
              frequency: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ff4',
              id: 1,
              frequency: 1037,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ff3',
              id: 2,
              frequency: 494,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ff2',
              id: 3,
              frequency: 781,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ff1',
              id: 4,
              frequency: 10609,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ff0',
              id: 5,
              frequency: 13211,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fef',
              id: 6,
              frequency: 4157,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fee',
              id: 7,
              frequency: 1360,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fed',
              id: 8,
              frequency: 2650,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fec',
              id: 9,
              frequency: 7910,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0feb',
              id: 10,
              frequency: 15685,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fea',
              id: 11,
              frequency: 6522,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fe9',
              id: 12,
              frequency: 8827,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fe8',
              id: 13,
              frequency: 7082,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fe7',
              id: 14,
              frequency: 5861,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fe6',
              id: 15,
              frequency: 59665,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fe5',
              id: 16,
              frequency: 83935,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fe4',
              id: 17,
              frequency: 46314,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fe3',
              id: 18,
              frequency: 15587,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fe2',
              id: 19,
              frequency: 49409,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fe1',
              id: 20,
              frequency: 33717,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fe0',
              id: 21,
              frequency: 36713,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fdf',
              id: 22,
              frequency: 4553,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fde',
              id: 23,
              frequency: 1551,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fdd',
              id: 24,
              frequency: 55276,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fdc',
              id: 25,
              frequency: 43018,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fdb',
              id: 26,
              frequency: 82249,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fda',
              id: 27,
              frequency: 56228,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fd9',
              id: 28,
              frequency: 81573,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fd8',
              id: 29,
              frequency: 116581,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fd7',
              id: 30,
              frequency: 57322,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fd6',
              id: 31,
              frequency: 29127,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fd5',
              id: 32,
              frequency: 29800,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fd4',
              id: 33,
              frequency: 12772,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fd3',
              id: 34,
              frequency: 21642,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fd2',
              id: 35,
              frequency: 10441,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fd1',
              id: 36,
              frequency: 11068,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fd0',
              id: 37,
              frequency: 30147,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fcf',
              id: 38,
              frequency: 13707,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fce',
              id: 39,
              frequency: 29300,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fcd',
              id: 40,
              frequency: 76412,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fcc',
              id: 41,
              frequency: 34801,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fcb',
              id: 42,
              frequency: 25579,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fca',
              id: 43,
              frequency: 75063,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fc9',
              id: 44,
              frequency: 10740,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fc8',
              id: 45,
              frequency: 45889,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fc7',
              id: 46,
              frequency: 46522,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fc6',
              id: 47,
              frequency: 58937,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fc5',
              id: 48,
              frequency: 99153,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fc4',
              id: 49,
              frequency: 2591,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fc3',
              id: 50,
              frequency: 1113,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fc2',
              id: 51,
              frequency: 42110,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fc1',
              id: 52,
              frequency: 19451,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fc0',
              id: 53,
              frequency: 37654,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fbf',
              id: 54,
              frequency: 16296,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fbe',
              id: 55,
              frequency: 7953,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fbd',
              id: 56,
              frequency: 37633,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fbc',
              id: 57,
              frequency: 94481,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fbb',
              id: 58,
              frequency: 24859,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fba',
              id: 59,
              frequency: 90458,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fb9',
              id: 60,
              frequency: 94925,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fb8',
              id: 61,
              frequency: 29065,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fb7',
              id: 62,
              frequency: 8562,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fb6',
              id: 63,
              frequency: 15084,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fb5',
              id: 64,
              frequency: 16352,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fb4',
              id: 65,
              frequency: 44586,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fb3',
              id: 66,
              frequency: 81658,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fb2',
              id: 67,
              frequency: 60687,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fb1',
              id: 68,
              frequency: 28630,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fb0',
              id: 69,
              frequency: 4848,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0faf',
              id: 70,
              frequency: 41553,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fae',
              id: 71,
              frequency: 45801,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0fad',
              id: 72,
              frequency: 26045,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0f40',
          id: 74,
          abbrevName: '75',
          fullName: '75_L_LOC_superior',
          coordinates: {
            x: -14.808664,
            y: -73.263538,
            z: 45.906137,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0f4f',
              to: 75,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f4e',
              to: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f4d',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f4c',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f4b',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f4a',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f49',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f48',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f47',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f46',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f45',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f44',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f43',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f42',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f41',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0f98',
              id: 0,
              frequency: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f97',
              id: 1,
              frequency: 957,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f96',
              id: 2,
              frequency: 653,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f95',
              id: 3,
              frequency: 1058,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f94',
              id: 4,
              frequency: 8782,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f93',
              id: 5,
              frequency: 14285,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f92',
              id: 6,
              frequency: 2566,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f91',
              id: 7,
              frequency: 1563,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f90',
              id: 8,
              frequency: 3021,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f8f',
              id: 9,
              frequency: 5910,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f8e',
              id: 10,
              frequency: 16279,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f8d',
              id: 11,
              frequency: 10658,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f8c',
              id: 12,
              frequency: 9450,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f8b',
              id: 13,
              frequency: 11216,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f8a',
              id: 14,
              frequency: 9072,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f89',
              id: 15,
              frequency: 41514,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f88',
              id: 16,
              frequency: 76271,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f87',
              id: 17,
              frequency: 42348,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f86',
              id: 18,
              frequency: 15641,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f85',
              id: 19,
              frequency: 25788,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f84',
              id: 20,
              frequency: 23953,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f83',
              id: 21,
              frequency: 31464,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f82',
              id: 22,
              frequency: 2037,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f81',
              id: 23,
              frequency: 942,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f80',
              id: 24,
              frequency: 41727,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f7f',
              id: 25,
              frequency: 32614,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f7e',
              id: 26,
              frequency: 95946,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f7d',
              id: 27,
              frequency: 33191,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f7c',
              id: 28,
              frequency: 66033,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f7b',
              id: 29,
              frequency: 102645,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f7a',
              id: 30,
              frequency: 86605,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f79',
              id: 31,
              frequency: 14483,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f78',
              id: 32,
              frequency: 23882,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f77',
              id: 33,
              frequency: 16444,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f76',
              id: 34,
              frequency: 24733,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f75',
              id: 35,
              frequency: 5829,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f74',
              id: 36,
              frequency: 12335,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f73',
              id: 37,
              frequency: 23763,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f72',
              id: 38,
              frequency: 16570,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f71',
              id: 39,
              frequency: 16519,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f70',
              id: 40,
              frequency: 55594,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f6f',
              id: 41,
              frequency: 40157,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f6e',
              id: 42,
              frequency: 39668,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f6d',
              id: 43,
              frequency: 58935,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f6c',
              id: 44,
              frequency: 24718,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f6b',
              id: 45,
              frequency: 29304,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f6a',
              id: 46,
              frequency: 48786,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f69',
              id: 47,
              frequency: 74977,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f68',
              id: 48,
              frequency: 129428,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f67',
              id: 49,
              frequency: 1572,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f66',
              id: 50,
              frequency: 1484,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f65',
              id: 51,
              frequency: 40731,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f64',
              id: 52,
              frequency: 17999,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f63',
              id: 53,
              frequency: 52317,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f62',
              id: 54,
              frequency: 9246,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f61',
              id: 55,
              frequency: 11204,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f60',
              id: 56,
              frequency: 20213,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f5f',
              id: 57,
              frequency: 114622,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f5e',
              id: 58,
              frequency: 48944,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f5d',
              id: 59,
              frequency: 82003,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f5c',
              id: 60,
              frequency: 117322,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f5b',
              id: 61,
              frequency: 62510,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f5a',
              id: 62,
              frequency: 7964,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f59',
              id: 63,
              frequency: 21029,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f58',
              id: 64,
              frequency: 19016,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f57',
              id: 65,
              frequency: 39575,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f56',
              id: 66,
              frequency: 92650,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f55',
              id: 67,
              frequency: 113900,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f54',
              id: 68,
              frequency: 37784,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f53',
              id: 69,
              frequency: 10203,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f52',
              id: 70,
              frequency: 52368,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f51',
              id: 71,
              frequency: 80592,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f50',
              id: 72,
              frequency: 46001,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0ee7',
          id: 75,
          abbrevName: '76',
          fullName: '76_BI_Lingual_gyrus_intracalcarine',
          coordinates: {
            x: 1.066079,
            y: -81.982379,
            z: -1.092511,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0ef6',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ef5',
              to: 80,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ef4',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ef3',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ef2',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ef1',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ef0',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0eef',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0eee',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0eed',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0eec',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0eeb',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0eea',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ee9',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ee8',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0f3f',
              id: 0,
              frequency: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f3e',
              id: 1,
              frequency: 877,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f3d',
              id: 2,
              frequency: 558,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f3c',
              id: 3,
              frequency: 1153,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f3b',
              id: 4,
              frequency: 7664,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f3a',
              id: 5,
              frequency: 12096,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f39',
              id: 6,
              frequency: 2666,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f38',
              id: 7,
              frequency: 974,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f37',
              id: 8,
              frequency: 2306,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f36',
              id: 9,
              frequency: 5044,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f35',
              id: 10,
              frequency: 18194,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f34',
              id: 11,
              frequency: 8680,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f33',
              id: 12,
              frequency: 7982,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f32',
              id: 13,
              frequency: 11524,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f31',
              id: 14,
              frequency: 11331,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f30',
              id: 15,
              frequency: 36376,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f2f',
              id: 16,
              frequency: 67172,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f2e',
              id: 17,
              frequency: 33232,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f2d',
              id: 18,
              frequency: 10985,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f2c',
              id: 19,
              frequency: 26361,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f2b',
              id: 20,
              frequency: 24780,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f2a',
              id: 21,
              frequency: 20478,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f29',
              id: 22,
              frequency: 2525,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f28',
              id: 23,
              frequency: 260,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f27',
              id: 24,
              frequency: 31962,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f26',
              id: 25,
              frequency: 35616,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f25',
              id: 26,
              frequency: 81745,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f24',
              id: 27,
              frequency: 30281,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f23',
              id: 28,
              frequency: 56515,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f22',
              id: 29,
              frequency: 121127,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f21',
              id: 30,
              frequency: 75849,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f20',
              id: 31,
              frequency: 14855,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f1f',
              id: 32,
              frequency: 32247,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f1e',
              id: 33,
              frequency: 8378,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f1d',
              id: 34,
              frequency: 17606,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f1c',
              id: 35,
              frequency: 5139,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f1b',
              id: 36,
              frequency: 8304,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f1a',
              id: 37,
              frequency: 20923,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f19',
              id: 38,
              frequency: 10121,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f18',
              id: 39,
              frequency: 13969,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f17',
              id: 40,
              frequency: 54072,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f16',
              id: 41,
              frequency: 43732,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f15',
              id: 42,
              frequency: 27265,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f14',
              id: 43,
              frequency: 70726,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f13',
              id: 44,
              frequency: 17046,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f12',
              id: 45,
              frequency: 24909,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f11',
              id: 46,
              frequency: 37218,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f10',
              id: 47,
              frequency: 51058,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f0f',
              id: 48,
              frequency: 146273,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f0e',
              id: 49,
              frequency: 1540,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f0d',
              id: 50,
              frequency: 754,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f0c',
              id: 51,
              frequency: 28578,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f0b',
              id: 52,
              frequency: 16762,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f0a',
              id: 53,
              frequency: 42040,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f09',
              id: 54,
              frequency: 9763,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f08',
              id: 55,
              frequency: 9483,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f07',
              id: 56,
              frequency: 17249,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f06',
              id: 57,
              frequency: 160487,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f05',
              id: 58,
              frequency: 40514,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f04',
              id: 59,
              frequency: 67855,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f03',
              id: 60,
              frequency: 104402,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f02',
              id: 61,
              frequency: 53981,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f01',
              id: 62,
              frequency: 5669,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0f00',
              id: 63,
              frequency: 13745,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0eff',
              id: 64,
              frequency: 21378,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0efe',
              id: 65,
              frequency: 28770,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0efd',
              id: 66,
              frequency: 105702,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0efc',
              id: 67,
              frequency: 117106,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0efb',
              id: 68,
              frequency: 28151,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0efa',
              id: 69,
              frequency: 10927,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ef9',
              id: 70,
              frequency: 41255,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ef8',
              id: 71,
              frequency: 101874,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ef7',
              id: 72,
              frequency: 68292,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0e93',
          id: 76,
          abbrevName: '77',
          fullName: '77_L_MGC_sfg',
          coordinates: {
            x: -28.557078,
            y: 22.931507,
            z: 48.913242,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0e9d',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e9c',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e9b',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e9a',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e99',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e98',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e97',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e96',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e95',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e94',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0ee6',
              id: 0,
              frequency: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ee5',
              id: 1,
              frequency: 968,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ee4',
              id: 2,
              frequency: 338,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ee3',
              id: 3,
              frequency: 697,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ee2',
              id: 4,
              frequency: 12728,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ee1',
              id: 5,
              frequency: 9889,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ee0',
              id: 6,
              frequency: 3515,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0edf',
              id: 7,
              frequency: 433,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ede',
              id: 8,
              frequency: 1967,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0edd',
              id: 9,
              frequency: 8206,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0edc',
              id: 10,
              frequency: 14823,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0edb',
              id: 11,
              frequency: 4026,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0eda',
              id: 12,
              frequency: 7457,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ed9',
              id: 13,
              frequency: 5521,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ed8',
              id: 14,
              frequency: 5200,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ed7',
              id: 15,
              frequency: 75203,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ed6',
              id: 16,
              frequency: 78762,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ed5',
              id: 17,
              frequency: 34451,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ed4',
              id: 18,
              frequency: 25981,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ed3',
              id: 19,
              frequency: 46047,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ed2',
              id: 20,
              frequency: 23881,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ed1',
              id: 21,
              frequency: 12077,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ed0',
              id: 22,
              frequency: 4044,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ecf',
              id: 23,
              frequency: 137,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ece',
              id: 24,
              frequency: 72859,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ecd',
              id: 25,
              frequency: 38348,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ecc',
              id: 26,
              frequency: 51629,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ecb',
              id: 27,
              frequency: 81151,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0eca',
              id: 28,
              frequency: 66350,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ec9',
              id: 29,
              frequency: 140236,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ec8',
              id: 30,
              frequency: 44577,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ec7',
              id: 31,
              frequency: 25559,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ec6',
              id: 32,
              frequency: 29073,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ec5',
              id: 33,
              frequency: 2682,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ec4',
              id: 34,
              frequency: 21579,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ec3',
              id: 35,
              frequency: 12207,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ec2',
              id: 36,
              frequency: 11926,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ec1',
              id: 37,
              frequency: 20827,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ec0',
              id: 38,
              frequency: 6018,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ebf',
              id: 39,
              frequency: 31178,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ebe',
              id: 40,
              frequency: 60086,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ebd',
              id: 41,
              frequency: 27549,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ebc',
              id: 42,
              frequency: 9411,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ebb',
              id: 43,
              frequency: 77854,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0eba',
              id: 44,
              frequency: 5869,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0eb9',
              id: 45,
              frequency: 62299,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0eb8',
              id: 46,
              frequency: 55142,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0eb7',
              id: 47,
              frequency: 34998,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0eb6',
              id: 48,
              frequency: 89638,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0eb5',
              id: 49,
              frequency: 1489,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0eb4',
              id: 50,
              frequency: 566,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0eb3',
              id: 51,
              frequency: 37765,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0eb2',
              id: 52,
              frequency: 22218,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0eb1',
              id: 53,
              frequency: 25996,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0eb0',
              id: 54,
              frequency: 10665,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0eaf',
              id: 55,
              frequency: 3296,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0eae',
              id: 56,
              frequency: 42852,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ead',
              id: 57,
              frequency: 95025,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0eac',
              id: 58,
              frequency: 14365,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0eab',
              id: 59,
              frequency: 94267,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0eaa',
              id: 60,
              frequency: 72513,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ea9',
              id: 61,
              frequency: 20289,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ea8',
              id: 62,
              frequency: 6718,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ea7',
              id: 63,
              frequency: 9295,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ea6',
              id: 64,
              frequency: 12969,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ea5',
              id: 65,
              frequency: 39799,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ea4',
              id: 66,
              frequency: 70675,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ea3',
              id: 67,
              frequency: 41783,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ea2',
              id: 68,
              frequency: 21277,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ea1',
              id: 69,
              frequency: 4415,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ea0',
              id: 70,
              frequency: 32691,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e9f',
              id: 71,
              frequency: 38150,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e9e',
              id: 72,
              frequency: 22788,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0e40',
          id: 77,
          abbrevName: '78',
          fullName: '78_R_Orbital_frontal_Cortex',
          coordinates: {
            x: 18.62585,
            y: 21.020408,
            z: -19.047619,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0e49',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e48',
              to: 79,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e47',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e46',
              to: 78,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e45',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e44',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e43',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e42',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e41',
              to: 94,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0e92',
              id: 0,
              frequency: 32,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e91',
              id: 1,
              frequency: 899,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e90',
              id: 2,
              frequency: 164,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e8f',
              id: 3,
              frequency: 332,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e8e',
              id: 4,
              frequency: 13929,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e8d',
              id: 5,
              frequency: 5831,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e8c',
              id: 6,
              frequency: 4882,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e8b',
              id: 7,
              frequency: 212,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e8a',
              id: 8,
              frequency: 1357,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e89',
              id: 9,
              frequency: 9545,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e88',
              id: 10,
              frequency: 8932,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e87',
              id: 11,
              frequency: 1258,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e86',
              id: 12,
              frequency: 5196,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e85',
              id: 13,
              frequency: 1768,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e84',
              id: 14,
              frequency: 1722,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e83',
              id: 15,
              frequency: 115473,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e82',
              id: 16,
              frequency: 58966,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e81',
              id: 17,
              frequency: 24585,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e80',
              id: 18,
              frequency: 35480,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e7f',
              id: 19,
              frequency: 86698,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e7e',
              id: 20,
              frequency: 20737,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e7d',
              id: 21,
              frequency: 7316,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e7c',
              id: 22,
              frequency: 6094,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e7b',
              id: 23,
              frequency: 62,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e7a',
              id: 24,
              frequency: 116870,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e79',
              id: 25,
              frequency: 31611,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e78',
              id: 26,
              frequency: 20214,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e77',
              id: 27,
              frequency: 98638,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e76',
              id: 28,
              frequency: 48149,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e75',
              id: 29,
              frequency: 99437,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e74',
              id: 30,
              frequency: 15419,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e73',
              id: 31,
              frequency: 45918,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e72',
              id: 32,
              frequency: 22689,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e71',
              id: 33,
              frequency: 1007,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e70',
              id: 34,
              frequency: 12932,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e6f',
              id: 35,
              frequency: 22137,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e6e',
              id: 36,
              frequency: 10163,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e6d',
              id: 37,
              frequency: 19772,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e6c',
              id: 38,
              frequency: 3635,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e6b',
              id: 39,
              frequency: 54829,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e6a',
              id: 40,
              frequency: 59160,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e69',
              id: 41,
              frequency: 12761,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e68',
              id: 42,
              frequency: 2739,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e67',
              id: 43,
              frequency: 57918,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e66',
              id: 44,
              frequency: 1018,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e65',
              id: 45,
              frequency: 80583,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e64',
              id: 46,
              frequency: 44410,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e63',
              id: 47,
              frequency: 14114,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e62',
              id: 48,
              frequency: 31728,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e61',
              id: 49,
              frequency: 1922,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e60',
              id: 50,
              frequency: 336,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e5f',
              id: 51,
              frequency: 29366,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e5e',
              id: 52,
              frequency: 15799,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e5d',
              id: 53,
              frequency: 10762,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e5c',
              id: 54,
              frequency: 12570,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e5b',
              id: 55,
              frequency: 1147,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e5a',
              id: 56,
              frequency: 55491,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e59',
              id: 57,
              frequency: 37440,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e58',
              id: 58,
              frequency: 2764,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e57',
              id: 59,
              frequency: 77422,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e56',
              id: 60,
              frequency: 31258,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e55',
              id: 61,
              frequency: 3760,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e54',
              id: 62,
              frequency: 6320,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e53',
              id: 63,
              frequency: 4615,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e52',
              id: 64,
              frequency: 5231,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e51',
              id: 65,
              frequency: 35200,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e50',
              id: 66,
              frequency: 31567,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e4f',
              id: 67,
              frequency: 9106,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e4e',
              id: 68,
              frequency: 10844,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e4d',
              id: 69,
              frequency: 737,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e4c',
              id: 70,
              frequency: 17546,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e4b',
              id: 71,
              frequency: 8206,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e4a',
              id: 72,
              frequency: 5414,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0dea',
          id: 78,
          abbrevName: '79',
          fullName: '79_BI_Cerebellum_anterior_culmen',
          coordinates: {
            x: 4.773333,
            y: -56.357333,
            z: -29.226667,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0df6',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0df5',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0df4',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0df3',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0df2',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0df1',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0df0',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0def',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dee',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ded',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dec',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0deb',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0e3f',
              id: 0,
              frequency: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e3e',
              id: 1,
              frequency: 1080,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e3d',
              id: 2,
              frequency: 358,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e3c',
              id: 3,
              frequency: 632,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e3b',
              id: 4,
              frequency: 11934,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e3a',
              id: 5,
              frequency: 10732,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e39',
              id: 6,
              frequency: 4442,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e38',
              id: 7,
              frequency: 724,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e37',
              id: 8,
              frequency: 2829,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e36',
              id: 9,
              frequency: 9355,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e35',
              id: 10,
              frequency: 13738,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e34',
              id: 11,
              frequency: 4021,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e33',
              id: 12,
              frequency: 8696,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e32',
              id: 13,
              frequency: 5180,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e31',
              id: 14,
              frequency: 4265,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e30',
              id: 15,
              frequency: 75581,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e2f',
              id: 16,
              frequency: 66406,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e2e',
              id: 17,
              frequency: 49225,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e2d',
              id: 18,
              frequency: 25093,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e2c',
              id: 19,
              frequency: 60978,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e2b',
              id: 20,
              frequency: 24890,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e2a',
              id: 21,
              frequency: 20115,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e29',
              id: 22,
              frequency: 3952,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e28',
              id: 23,
              frequency: 476,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e27',
              id: 24,
              frequency: 87242,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e26',
              id: 25,
              frequency: 46905,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e25',
              id: 26,
              frequency: 47508,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e24',
              id: 27,
              frequency: 55409,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e23',
              id: 28,
              frequency: 66696,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e22',
              id: 29,
              frequency: 103140,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e21',
              id: 30,
              frequency: 41697,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e20',
              id: 31,
              frequency: 35682,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e1f',
              id: 32,
              frequency: 27080,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e1e',
              id: 33,
              frequency: 5397,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e1d',
              id: 34,
              frequency: 21329,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e1c',
              id: 35,
              frequency: 12344,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e1b',
              id: 36,
              frequency: 13435,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e1a',
              id: 37,
              frequency: 32449,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e19',
              id: 38,
              frequency: 11106,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e18',
              id: 39,
              frequency: 39022,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e17',
              id: 40,
              frequency: 75563,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e16',
              id: 41,
              frequency: 25319,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e15',
              id: 42,
              frequency: 12655,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e14',
              id: 43,
              frequency: 67056,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e13',
              id: 44,
              frequency: 5587,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e12',
              id: 45,
              frequency: 53753,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e11',
              id: 46,
              frequency: 50882,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e10',
              id: 47,
              frequency: 40873,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e0f',
              id: 48,
              frequency: 79170,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e0e',
              id: 49,
              frequency: 2741,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e0d',
              id: 50,
              frequency: 1462,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e0c',
              id: 51,
              frequency: 49991,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e0b',
              id: 52,
              frequency: 18533,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e0a',
              id: 53,
              frequency: 29949,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e09',
              id: 54,
              frequency: 14992,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e08',
              id: 55,
              frequency: 5055,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e07',
              id: 56,
              frequency: 43177,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e06',
              id: 57,
              frequency: 73371,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e05',
              id: 58,
              frequency: 12232,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e04',
              id: 59,
              frequency: 97201,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e03',
              id: 60,
              frequency: 77267,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e02',
              id: 61,
              frequency: 17657,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e01',
              id: 62,
              frequency: 11428,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0e00',
              id: 63,
              frequency: 16271,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dff',
              id: 64,
              frequency: 14458,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dfe',
              id: 65,
              frequency: 53910,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dfd',
              id: 66,
              frequency: 65272,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dfc',
              id: 67,
              frequency: 38420,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dfb',
              id: 68,
              frequency: 29206,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dfa',
              id: 69,
              frequency: 4002,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0df9',
              id: 70,
              frequency: 38611,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0df8',
              id: 71,
              frequency: 30789,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0df7',
              id: 72,
              frequency: 16725,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0d95',
          id: 79,
          abbrevName: '80',
          fullName: '80_L_Frontal_pole',
          coordinates: {
            x: -20.545455,
            y: 61.593583,
            z: -7.336898,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0da0',
              to: 81,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d9f',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d9e',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d9d',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d9c',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d9b',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d9a',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d99',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d98',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d97',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d96',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0de9',
              id: 0,
              frequency: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0de8',
              id: 1,
              frequency: 911,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0de7',
              id: 2,
              frequency: 423,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0de6',
              id: 3,
              frequency: 753,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0de5',
              id: 4,
              frequency: 12192,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0de4',
              id: 5,
              frequency: 10964,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0de3',
              id: 6,
              frequency: 3098,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0de2',
              id: 7,
              frequency: 943,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0de1',
              id: 8,
              frequency: 1986,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0de0',
              id: 9,
              frequency: 7970,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ddf',
              id: 10,
              frequency: 14926,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dde',
              id: 11,
              frequency: 5299,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ddd',
              id: 12,
              frequency: 6933,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ddc',
              id: 13,
              frequency: 6454,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ddb',
              id: 14,
              frequency: 5728,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dda',
              id: 15,
              frequency: 77704,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dd9',
              id: 16,
              frequency: 99661,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dd8',
              id: 17,
              frequency: 22904,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dd7',
              id: 18,
              frequency: 21169,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dd6',
              id: 19,
              frequency: 34816,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dd5',
              id: 20,
              frequency: 27213,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dd4',
              id: 21,
              frequency: 25633,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dd3',
              id: 22,
              frequency: 2560,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dd2',
              id: 23,
              frequency: 591,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dd1',
              id: 24,
              frequency: 62413,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dd0',
              id: 25,
              frequency: 26719,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dcf',
              id: 26,
              frequency: 68816,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dce',
              id: 27,
              frequency: 82801,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dcd',
              id: 28,
              frequency: 81685,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dcc',
              id: 29,
              frequency: 155265,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dcb',
              id: 30,
              frequency: 48846,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dca',
              id: 31,
              frequency: 22899,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dc9',
              id: 32,
              frequency: 28379,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dc8',
              id: 33,
              frequency: 7785,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dc7',
              id: 34,
              frequency: 18712,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dc6',
              id: 35,
              frequency: 13242,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dc5',
              id: 36,
              frequency: 12756,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dc4',
              id: 37,
              frequency: 19346,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dc3',
              id: 38,
              frequency: 9212,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dc2',
              id: 39,
              frequency: 32918,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dc1',
              id: 40,
              frequency: 50802,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dc0',
              id: 41,
              frequency: 32536,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dbf',
              id: 42,
              frequency: 18829,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dbe',
              id: 43,
              frequency: 87435,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dbd',
              id: 44,
              frequency: 8444,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dbc',
              id: 45,
              frequency: 58061,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dbb',
              id: 46,
              frequency: 51240,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dba',
              id: 47,
              frequency: 40902,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0db9',
              id: 48,
              frequency: 97554,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0db8',
              id: 49,
              frequency: 1610,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0db7',
              id: 50,
              frequency: 945,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0db6',
              id: 51,
              frequency: 37113,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0db5',
              id: 52,
              frequency: 19631,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0db4',
              id: 53,
              frequency: 27366,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0db3',
              id: 54,
              frequency: 9872,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0db2',
              id: 55,
              frequency: 6615,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0db1',
              id: 56,
              frequency: 43310,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0db0',
              id: 57,
              frequency: 100751,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0daf',
              id: 58,
              frequency: 19020,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dae',
              id: 59,
              frequency: 88499,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dad',
              id: 60,
              frequency: 72386,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dac',
              id: 61,
              frequency: 23696,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0dab',
              id: 62,
              frequency: 6262,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0daa',
              id: 63,
              frequency: 10254,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0da9',
              id: 64,
              frequency: 13312,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0da8',
              id: 65,
              frequency: 37652,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0da7',
              id: 66,
              frequency: 71101,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0da6',
              id: 67,
              frequency: 52298,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0da5',
              id: 68,
              frequency: 20109,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0da4',
              id: 69,
              frequency: 4369,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0da3',
              id: 70,
              frequency: 30330,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0da2',
              id: 71,
              frequency: 44373,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0da1',
              id: 72,
              frequency: 25856,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0d41',
          id: 80,
          abbrevName: '81',
          fullName: '81_L_LOC_superior_angular_gyrus',
          coordinates: {
            x: 34.173077,
            y: -31.5,
            z: 59.480769,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0d4b',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d4a',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d49',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d48',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d47',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d46',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d45',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d44',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d43',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d42',
              to: 95,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0d94',
              id: 0,
              frequency: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d93',
              id: 1,
              frequency: 859,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d92',
              id: 2,
              frequency: 246,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d91',
              id: 3,
              frequency: 835,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d90',
              id: 4,
              frequency: 12317,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d8f',
              id: 5,
              frequency: 6520,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d8e',
              id: 6,
              frequency: 2842,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d8d',
              id: 7,
              frequency: 135,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d8c',
              id: 8,
              frequency: 1297,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d8b',
              id: 9,
              frequency: 6521,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d8a',
              id: 10,
              frequency: 16308,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d89',
              id: 11,
              frequency: 2623,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d88',
              id: 12,
              frequency: 7046,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d87',
              id: 13,
              frequency: 5419,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d86',
              id: 14,
              frequency: 8038,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d85',
              id: 15,
              frequency: 85124,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d84',
              id: 16,
              frequency: 59194,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d83',
              id: 17,
              frequency: 19317,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d82',
              id: 18,
              frequency: 31654,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d81',
              id: 19,
              frequency: 38794,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d80',
              id: 20,
              frequency: 14476,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d7f',
              id: 21,
              frequency: 3332,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d7e',
              id: 22,
              frequency: 2808,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d7d',
              id: 23,
              frequency: 9,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d7c',
              id: 24,
              frequency: 67212,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d7b',
              id: 25,
              frequency: 32028,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d7a',
              id: 26,
              frequency: 29704,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d79',
              id: 27,
              frequency: 72423,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d78',
              id: 28,
              frequency: 39567,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d77',
              id: 29,
              frequency: 179368,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d76',
              id: 30,
              frequency: 26968,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d75',
              id: 31,
              frequency: 19068,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d74',
              id: 32,
              frequency: 32708,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d73',
              id: 33,
              frequency: 508,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d72',
              id: 34,
              frequency: 14744,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d71',
              id: 35,
              frequency: 12000,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d70',
              id: 36,
              frequency: 8998,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d6f',
              id: 37,
              frequency: 12630,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d6e',
              id: 38,
              frequency: 1773,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d6d',
              id: 39,
              frequency: 25636,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d6c',
              id: 40,
              frequency: 51656,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d6b',
              id: 41,
              frequency: 23990,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d6a',
              id: 42,
              frequency: 3113,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d69',
              id: 43,
              frequency: 82671,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d68',
              id: 44,
              frequency: 3256,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d67',
              id: 45,
              frequency: 50833,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d66',
              id: 46,
              frequency: 62099,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d65',
              id: 47,
              frequency: 19461,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d64',
              id: 48,
              frequency: 85660,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d63',
              id: 49,
              frequency: 949,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d62',
              id: 50,
              frequency: 140,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d61',
              id: 51,
              frequency: 22738,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d60',
              id: 52,
              frequency: 23440,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d5f',
              id: 53,
              frequency: 16082,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d5e',
              id: 54,
              frequency: 8682,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d5d',
              id: 55,
              frequency: 1775,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d5c',
              id: 56,
              frequency: 28709,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d5b',
              id: 57,
              frequency: 143066,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d5a',
              id: 58,
              frequency: 9211,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d59',
              id: 59,
              frequency: 86720,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d58',
              id: 60,
              frequency: 58886,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d57',
              id: 61,
              frequency: 12536,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d56',
              id: 62,
              frequency: 3828,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d55',
              id: 63,
              frequency: 5712,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d54',
              id: 64,
              frequency: 12772,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d53',
              id: 65,
              frequency: 30307,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d52',
              id: 66,
              frequency: 91936,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d51',
              id: 67,
              frequency: 42441,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d50',
              id: 68,
              frequency: 15894,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d4f',
              id: 69,
              frequency: 3903,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d4e',
              id: 70,
              frequency: 36429,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d4d',
              id: 71,
              frequency: 52216,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d4c',
              id: 72,
              frequency: 49397,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0ce9',
          id: 81,
          abbrevName: '82',
          fullName: '82_L_Temporal_pole',
          coordinates: {
            x: -37.980392,
            y: 15.098039,
            z: -25.568627,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0cf7',
              to: 82,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cf6',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cf5',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cf4',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cf3',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cf2',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cf1',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cf0',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cef',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cee',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ced',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cec',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ceb',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cea',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0d40',
              id: 0,
              frequency: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d3f',
              id: 1,
              frequency: 942,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d3e',
              id: 2,
              frequency: 701,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d3d',
              id: 3,
              frequency: 1010,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d3c',
              id: 4,
              frequency: 9473,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d3b',
              id: 5,
              frequency: 15620,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d3a',
              id: 6,
              frequency: 2495,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d39',
              id: 7,
              frequency: 2266,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d38',
              id: 8,
              frequency: 2874,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d37',
              id: 9,
              frequency: 6677,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d36',
              id: 10,
              frequency: 15802,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d35',
              id: 11,
              frequency: 11159,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d34',
              id: 12,
              frequency: 8733,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d33',
              id: 13,
              frequency: 10841,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d32',
              id: 14,
              frequency: 8243,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d31',
              id: 15,
              frequency: 42358,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d30',
              id: 16,
              frequency: 96997,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d2f',
              id: 17,
              frequency: 30851,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d2e',
              id: 18,
              frequency: 13974,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d2d',
              id: 19,
              frequency: 23732,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d2c',
              id: 20,
              frequency: 29927,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d2b',
              id: 21,
              frequency: 50960,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d2a',
              id: 22,
              frequency: 1382,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d29',
              id: 23,
              frequency: 2221,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d28',
              id: 24,
              frequency: 44695,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d27',
              id: 25,
              frequency: 26166,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d26',
              id: 26,
              frequency: 104568,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d25',
              id: 27,
              frequency: 43920,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d24',
              id: 28,
              frequency: 91358,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d23',
              id: 29,
              frequency: 117836,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d22',
              id: 30,
              frequency: 93598,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d21',
              id: 31,
              frequency: 14560,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d20',
              id: 32,
              frequency: 21356,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d1f',
              id: 33,
              frequency: 25962,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d1e',
              id: 34,
              frequency: 24330,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d1d',
              id: 35,
              frequency: 7432,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d1c',
              id: 36,
              frequency: 12660,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d1b',
              id: 37,
              frequency: 21915,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d1a',
              id: 38,
              frequency: 20261,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d19',
              id: 39,
              frequency: 20099,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d18',
              id: 40,
              frequency: 46832,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d17',
              id: 41,
              frequency: 40850,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d16',
              id: 42,
              frequency: 51190,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d15',
              id: 43,
              frequency: 67289,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d14',
              id: 44,
              frequency: 25774,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d13',
              id: 45,
              frequency: 39608,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d12',
              id: 46,
              frequency: 48155,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d11',
              id: 47,
              frequency: 83526,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d10',
              id: 48,
              frequency: 131253,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d0f',
              id: 49,
              frequency: 1706,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d0e',
              id: 50,
              frequency: 1601,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d0d',
              id: 51,
              frequency: 44087,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d0c',
              id: 52,
              frequency: 19039,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d0b',
              id: 53,
              frequency: 48131,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d0a',
              id: 54,
              frequency: 10634,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d09',
              id: 55,
              frequency: 14898,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d08',
              id: 56,
              frequency: 26959,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d07',
              id: 57,
              frequency: 109723,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d06',
              id: 58,
              frequency: 48080,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d05',
              id: 59,
              frequency: 82146,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d04',
              id: 60,
              frequency: 109698,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d03',
              id: 61,
              frequency: 57963,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d02',
              id: 62,
              frequency: 8426,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d01',
              id: 63,
              frequency: 20188,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0d00',
              id: 64,
              frequency: 18233,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cff',
              id: 65,
              frequency: 42767,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cfe',
              id: 66,
              frequency: 84726,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cfd',
              id: 67,
              frequency: 107338,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cfc',
              id: 68,
              frequency: 32014,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cfb',
              id: 69,
              frequency: 8105,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cfa',
              id: 70,
              frequency: 45205,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cf9',
              id: 71,
              frequency: 74095,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cf8',
              id: 72,
              frequency: 39500,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0c95',
          id: 82,
          abbrevName: '83',
          fullName:
            '83_R_Temporal_fusiform_posterior__temporal_occiptal_fusiform',
          coordinates: {
            x: 28.222222,
            y: -36.572391,
            z: -18.707071,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0c9f',
              to: 83,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c9e',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c9d',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c9c',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c9b',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c9a',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c99',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c98',
              to: 93,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c97',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c96',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0ce8',
              id: 0,
              frequency: 61,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ce7',
              id: 1,
              frequency: 887,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ce6',
              id: 2,
              frequency: 713,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ce5',
              id: 3,
              frequency: 1117,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ce4',
              id: 4,
              frequency: 8631,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ce3',
              id: 5,
              frequency: 14182,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ce2',
              id: 6,
              frequency: 1964,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ce1',
              id: 7,
              frequency: 2348,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ce0',
              id: 8,
              frequency: 2696,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cdf',
              id: 9,
              frequency: 5500,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cde',
              id: 10,
              frequency: 17278,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cdd',
              id: 11,
              frequency: 11686,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cdc',
              id: 12,
              frequency: 8184,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cdb',
              id: 13,
              frequency: 11651,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cda',
              id: 14,
              frequency: 10305,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cd9',
              id: 15,
              frequency: 39296,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cd8',
              id: 16,
              frequency: 91725,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cd7',
              id: 17,
              frequency: 36072,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cd6',
              id: 18,
              frequency: 11027,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cd5',
              id: 19,
              frequency: 19540,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cd4',
              id: 20,
              frequency: 19737,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cd3',
              id: 21,
              frequency: 48096,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cd2',
              id: 22,
              frequency: 926,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cd1',
              id: 23,
              frequency: 2786,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cd0',
              id: 24,
              frequency: 33508,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ccf',
              id: 25,
              frequency: 30823,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cce',
              id: 26,
              frequency: 117835,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ccd',
              id: 27,
              frequency: 39723,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ccc',
              id: 28,
              frequency: 67878,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ccb',
              id: 29,
              frequency: 125077,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cca',
              id: 30,
              frequency: 80553,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cc9',
              id: 31,
              frequency: 10709,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cc8',
              id: 32,
              frequency: 20122,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cc7',
              id: 33,
              frequency: 28604,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cc6',
              id: 34,
              frequency: 22136,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cc5',
              id: 35,
              frequency: 5022,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cc4',
              id: 36,
              frequency: 11758,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cc3',
              id: 37,
              frequency: 18080,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cc2',
              id: 38,
              frequency: 17548,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cc1',
              id: 39,
              frequency: 13516,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cc0',
              id: 40,
              frequency: 43487,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cbf',
              id: 41,
              frequency: 48246,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cbe',
              id: 42,
              frequency: 53565,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cbd',
              id: 43,
              frequency: 73416,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cbc',
              id: 44,
              frequency: 23456,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cbb',
              id: 45,
              frequency: 32541,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cba',
              id: 46,
              frequency: 42229,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cb9',
              id: 47,
              frequency: 69161,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cb8',
              id: 48,
              frequency: 133297,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cb7',
              id: 49,
              frequency: 1254,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cb6',
              id: 50,
              frequency: 1569,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cb5',
              id: 51,
              frequency: 36294,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cb4',
              id: 52,
              frequency: 18879,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cb3',
              id: 53,
              frequency: 49779,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cb2',
              id: 54,
              frequency: 6953,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cb1',
              id: 55,
              frequency: 14267,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cb0',
              id: 56,
              frequency: 20227,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0caf',
              id: 57,
              frequency: 136622,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cae',
              id: 58,
              frequency: 59135,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cad',
              id: 59,
              frequency: 74760,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cac',
              id: 60,
              frequency: 105111,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0cab',
              id: 61,
              frequency: 60161,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0caa',
              id: 62,
              frequency: 7379,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ca9',
              id: 63,
              frequency: 17671,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ca8',
              id: 64,
              frequency: 21365,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ca7',
              id: 65,
              frequency: 31447,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ca6',
              id: 66,
              frequency: 100457,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ca5',
              id: 67,
              frequency: 121899,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ca4',
              id: 68,
              frequency: 30323,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ca3',
              id: 69,
              frequency: 8894,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ca2',
              id: 70,
              frequency: 43270,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ca1',
              id: 71,
              frequency: 89848,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ca0',
              id: 72,
              frequency: 59240,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0c44',
          id: 83,
          abbrevName: '84',
          fullName: '84_R_Precuneous__cuneal_cortex',
          coordinates: {
            x: 14.669145,
            y: -73.97026,
            z: 42.156134,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0c4b',
              to: 84,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c4a',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c49',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c48',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c47',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c46',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c45',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0c94',
              id: 0,
              frequency: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c93',
              id: 1,
              frequency: 988,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c92',
              id: 2,
              frequency: 302,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c91',
              id: 3,
              frequency: 779,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c90',
              id: 4,
              frequency: 11426,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c8f',
              id: 5,
              frequency: 8849,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c8e',
              id: 6,
              frequency: 4000,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c8d',
              id: 7,
              frequency: 244,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c8c',
              id: 8,
              frequency: 1727,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c8b',
              id: 9,
              frequency: 7470,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c8a',
              id: 10,
              frequency: 15991,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c89',
              id: 11,
              frequency: 3592,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c88',
              id: 12,
              frequency: 8577,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c87',
              id: 13,
              frequency: 5674,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c86',
              id: 14,
              frequency: 6705,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c85',
              id: 15,
              frequency: 75292,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c84',
              id: 16,
              frequency: 59880,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c83',
              id: 17,
              frequency: 35420,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c82',
              id: 18,
              frequency: 26921,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c81',
              id: 19,
              frequency: 52174,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c80',
              id: 20,
              frequency: 22327,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c7f',
              id: 21,
              frequency: 6589,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c7e',
              id: 22,
              frequency: 4499,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c7d',
              id: 23,
              frequency: 27,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c7c',
              id: 24,
              frequency: 69848,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c7b',
              id: 25,
              frequency: 43972,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c7a',
              id: 26,
              frequency: 41424,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c79',
              id: 27,
              frequency: 54230,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c78',
              id: 28,
              frequency: 52514,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c77',
              id: 29,
              frequency: 132139,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c76',
              id: 30,
              frequency: 39592,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c75',
              id: 31,
              frequency: 30138,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c74',
              id: 32,
              frequency: 34160,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c73',
              id: 33,
              frequency: 1294,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c72',
              id: 34,
              frequency: 20074,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c71',
              id: 35,
              frequency: 11876,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c70',
              id: 36,
              frequency: 8280,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c6f',
              id: 37,
              frequency: 20811,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c6e',
              id: 38,
              frequency: 3660,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c6d',
              id: 39,
              frequency: 30845,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c6c',
              id: 40,
              frequency: 76482,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c6b',
              id: 41,
              frequency: 25344,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c6a',
              id: 42,
              frequency: 5684,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c69',
              id: 43,
              frequency: 74369,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c68',
              id: 44,
              frequency: 5061,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c67',
              id: 45,
              frequency: 44724,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c66',
              id: 46,
              frequency: 55016,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c65',
              id: 47,
              frequency: 33362,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c64',
              id: 48,
              frequency: 88555,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c63',
              id: 49,
              frequency: 1624,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c62',
              id: 50,
              frequency: 283,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c61',
              id: 51,
              frequency: 28803,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c60',
              id: 52,
              frequency: 22088,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c5f',
              id: 53,
              frequency: 23658,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c5e',
              id: 54,
              frequency: 13486,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c5d',
              id: 55,
              frequency: 2356,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c5c',
              id: 56,
              frequency: 30416,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c5b',
              id: 57,
              frequency: 114573,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c5a',
              id: 58,
              frequency: 13854,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c59',
              id: 59,
              frequency: 93858,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c58',
              id: 60,
              frequency: 78162,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c57',
              id: 61,
              frequency: 18161,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c56',
              id: 62,
              frequency: 5533,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c55',
              id: 63,
              frequency: 7568,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c54',
              id: 64,
              frequency: 13545,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c53',
              id: 65,
              frequency: 41505,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c52',
              id: 66,
              frequency: 90436,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c51',
              id: 67,
              frequency: 45964,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c50',
              id: 68,
              frequency: 20867,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c4f',
              id: 69,
              frequency: 4491,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c4e',
              id: 70,
              frequency: 44901,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c4d',
              id: 71,
              frequency: 45345,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c4c',
              id: 72,
              frequency: 36128,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0bf0',
          id: 84,
          abbrevName: '85',
          fullName: '85_L_IFG_pars_opercularis__precentral',
          coordinates: {
            x: -47.138075,
            y: 11.991632,
            z: 31.330544,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0bfa',
              to: 85,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bf9',
              to: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bf8',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bf7',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bf6',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bf5',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bf4',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bf3',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bf2',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bf1',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0c43',
              id: 0,
              frequency: 66,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c42',
              id: 1,
              frequency: 918,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c41',
              id: 2,
              frequency: 878,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c40',
              id: 3,
              frequency: 1267,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c3f',
              id: 4,
              frequency: 4922,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c3e',
              id: 5,
              frequency: 15944,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c3d',
              id: 6,
              frequency: 2768,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c3c',
              id: 7,
              frequency: 2474,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c3b',
              id: 8,
              frequency: 3990,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c3a',
              id: 9,
              frequency: 4409,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c39',
              id: 10,
              frequency: 15762,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c38',
              id: 11,
              frequency: 16515,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c37',
              id: 12,
              frequency: 9992,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c36',
              id: 13,
              frequency: 15740,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c35',
              id: 14,
              frequency: 11031,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c34',
              id: 15,
              frequency: 17816,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c33',
              id: 16,
              frequency: 48542,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c32',
              id: 17,
              frequency: 41730,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c31',
              id: 18,
              frequency: 6605,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c30',
              id: 19,
              frequency: 17293,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c2f',
              id: 20,
              frequency: 31999,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c2e',
              id: 21,
              frequency: 40400,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c2d',
              id: 22,
              frequency: 3297,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c2c',
              id: 23,
              frequency: 1514,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c2b',
              id: 24,
              frequency: 21427,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c2a',
              id: 25,
              frequency: 26638,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c29',
              id: 26,
              frequency: 115642,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c28',
              id: 27,
              frequency: 11635,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c27',
              id: 28,
              frequency: 56538,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c26',
              id: 29,
              frequency: 61107,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c25',
              id: 30,
              frequency: 113449,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c24',
              id: 31,
              frequency: 13754,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c23',
              id: 32,
              frequency: 25602,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c22',
              id: 33,
              frequency: 29110,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c21',
              id: 34,
              frequency: 13533,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c20',
              id: 35,
              frequency: 2320,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c1f',
              id: 36,
              frequency: 9618,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c1e',
              id: 37,
              frequency: 32134,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c1d',
              id: 38,
              frequency: 23448,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c1c',
              id: 39,
              frequency: 11348,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c1b',
              id: 40,
              frequency: 59455,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c1a',
              id: 41,
              frequency: 41771,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c19',
              id: 42,
              frequency: 75054,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c18',
              id: 43,
              frequency: 43386,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c17',
              id: 44,
              frequency: 45619,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c16',
              id: 45,
              frequency: 11084,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c15',
              id: 46,
              frequency: 26058,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c14',
              id: 47,
              frequency: 96472,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c13',
              id: 48,
              frequency: 148820,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c12',
              id: 49,
              frequency: 2413,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c11',
              id: 50,
              frequency: 3608,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c10',
              id: 51,
              frequency: 37538,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c0f',
              id: 52,
              frequency: 8863,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c0e',
              id: 53,
              frequency: 72385,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c0d',
              id: 54,
              frequency: 12952,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c0c',
              id: 55,
              frequency: 16532,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c0b',
              id: 56,
              frequency: 11533,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c0a',
              id: 57,
              frequency: 110430,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c09',
              id: 58,
              frequency: 82719,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c08',
              id: 59,
              frequency: 56599,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c07',
              id: 60,
              frequency: 136031,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c06',
              id: 61,
              frequency: 114734,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c05',
              id: 62,
              frequency: 9476,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c04',
              id: 63,
              frequency: 36562,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c03',
              id: 64,
              frequency: 23516,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c02',
              id: 65,
              frequency: 36786,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c01',
              id: 66,
              frequency: 92228,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0c00',
              id: 67,
              frequency: 172016,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bff',
              id: 68,
              frequency: 52063,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bfe',
              id: 69,
              frequency: 17278,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bfd',
              id: 70,
              frequency: 58023,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bfc',
              id: 71,
              frequency: 112179,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bfb',
              id: 72,
              frequency: 53965,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0ba3',
          id: 85,
          abbrevName: '86',
          fullName: '86_L_LOC_superior',
          coordinates: {
            x: -43.357401,
            y: -66.707581,
            z: 35.855596,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0ba6',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ba5',
              to: 99,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ba4',
              to: 96,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0bef',
              id: 0,
              frequency: 29,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bee',
              id: 1,
              frequency: 856,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bed',
              id: 2,
              frequency: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bec',
              id: 3,
              frequency: 316,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0beb',
              id: 4,
              frequency: 13780,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bea',
              id: 5,
              frequency: 3375,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0be9',
              id: 6,
              frequency: 5246,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0be8',
              id: 7,
              frequency: 36,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0be7',
              id: 8,
              frequency: 937,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0be6',
              id: 9,
              frequency: 8933,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0be5',
              id: 10,
              frequency: 8583,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0be4',
              id: 11,
              frequency: 498,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0be3',
              id: 12,
              frequency: 5068,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0be2',
              id: 13,
              frequency: 1326,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0be1',
              id: 14,
              frequency: 1794,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0be0',
              id: 15,
              frequency: 119540,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bdf',
              id: 16,
              frequency: 33621,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bde',
              id: 17,
              frequency: 15507,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bdd',
              id: 18,
              frequency: 38010,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bdc',
              id: 19,
              frequency: 93160,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bdb',
              id: 20,
              frequency: 12962,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bda',
              id: 21,
              frequency: 1146,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bd9',
              id: 22,
              frequency: 8935,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bd8',
              id: 23,
              frequency: 2,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bd7',
              id: 24,
              frequency: 108295,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bd6',
              id: 25,
              frequency: 30505,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bd5',
              id: 26,
              frequency: 7680,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bd4',
              id: 27,
              frequency: 99249,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bd3',
              id: 28,
              frequency: 28062,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bd2',
              id: 29,
              frequency: 102744,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bd1',
              id: 30,
              frequency: 6759,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bd0',
              id: 31,
              frequency: 55211,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bcf',
              id: 32,
              frequency: 24693,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bce',
              id: 33,
              frequency: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bcd',
              id: 34,
              frequency: 7328,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bcc',
              id: 35,
              frequency: 23157,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bcb',
              id: 36,
              frequency: 7474,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bca',
              id: 37,
              frequency: 15343,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bc9',
              id: 38,
              frequency: 747,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bc8',
              id: 39,
              frequency: 53043,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bc7',
              id: 40,
              frequency: 63568,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bc6',
              id: 41,
              frequency: 7583,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bc5',
              id: 42,
              frequency: 444,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bc4',
              id: 43,
              frequency: 52925,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bc3',
              id: 44,
              frequency: 211,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bc2',
              id: 45,
              frequency: 79639,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bc1',
              id: 46,
              frequency: 49115,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bc0',
              id: 47,
              frequency: 5827,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bbf',
              id: 48,
              frequency: 27116,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bbe',
              id: 49,
              frequency: 1688,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bbd',
              id: 50,
              frequency: 107,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bbc',
              id: 51,
              frequency: 19509,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bbb',
              id: 52,
              frequency: 14046,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bba',
              id: 53,
              frequency: 4882,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bb9',
              id: 54,
              frequency: 13473,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bb8',
              id: 55,
              frequency: 340,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bb7',
              id: 56,
              frequency: 52212,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bb6',
              id: 57,
              frequency: 40424,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bb5',
              id: 58,
              frequency: 830,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bb4',
              id: 59,
              frequency: 74040,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bb3',
              id: 60,
              frequency: 22489,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bb2',
              id: 61,
              frequency: 1590,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bb1',
              id: 62,
              frequency: 4498,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bb0',
              id: 63,
              frequency: 2463,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0baf',
              id: 64,
              frequency: 4807,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bae',
              id: 65,
              frequency: 33296,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bad',
              id: 66,
              frequency: 31973,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bac',
              id: 67,
              frequency: 5402,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0bab',
              id: 68,
              frequency: 9616,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0baa',
              id: 69,
              frequency: 793,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ba9',
              id: 70,
              frequency: 18284,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ba8',
              id: 71,
              frequency: 7928,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ba7',
              id: 72,
              frequency: 6139,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0b53',
          id: 86,
          abbrevName: '87',
          fullName: '87_L_Cerebellum',
          coordinates: {
            x: -22.35249,
            y: -61.938697,
            z: -55.969349,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0b59',
              to: 87,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b58',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b57',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b56',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b55',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b54',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0ba2',
              id: 0,
              frequency: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ba1',
              id: 1,
              frequency: 931,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ba0',
              id: 2,
              frequency: 609,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b9f',
              id: 3,
              frequency: 987,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b9e',
              id: 4,
              frequency: 10828,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b9d',
              id: 5,
              frequency: 12681,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b9c',
              id: 6,
              frequency: 2358,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b9b',
              id: 7,
              frequency: 1280,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b9a',
              id: 8,
              frequency: 3400,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b99',
              id: 9,
              frequency: 6163,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b98',
              id: 10,
              frequency: 14341,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b97',
              id: 11,
              frequency: 9799,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b96',
              id: 12,
              frequency: 9157,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b95',
              id: 13,
              frequency: 10057,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b94',
              id: 14,
              frequency: 8124,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b93',
              id: 15,
              frequency: 55136,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b92',
              id: 16,
              frequency: 93053,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b91',
              id: 17,
              frequency: 29744,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b90',
              id: 18,
              frequency: 21561,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b8f',
              id: 19,
              frequency: 24881,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b8e',
              id: 20,
              frequency: 21118,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b8d',
              id: 21,
              frequency: 24812,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b8c',
              id: 22,
              frequency: 1666,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b8b',
              id: 23,
              frequency: 400,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b8a',
              id: 24,
              frequency: 50120,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b89',
              id: 25,
              frequency: 22186,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b88',
              id: 26,
              frequency: 81042,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b87',
              id: 27,
              frequency: 54486,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b86',
              id: 28,
              frequency: 61159,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b85',
              id: 29,
              frequency: 128029,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b84',
              id: 30,
              frequency: 76195,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b83',
              id: 31,
              frequency: 12388,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b82',
              id: 32,
              frequency: 18216,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b81',
              id: 33,
              frequency: 13040,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b80',
              id: 34,
              frequency: 21654,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b7f',
              id: 35,
              frequency: 8025,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b7e',
              id: 36,
              frequency: 21401,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b7d',
              id: 37,
              frequency: 23599,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b7c',
              id: 38,
              frequency: 13577,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b7b',
              id: 39,
              frequency: 18920,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b7a',
              id: 40,
              frequency: 46067,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b79',
              id: 41,
              frequency: 33191,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b78',
              id: 42,
              frequency: 33430,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b77',
              id: 43,
              frequency: 54869,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b76',
              id: 44,
              frequency: 22357,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b75',
              id: 45,
              frequency: 41431,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b74',
              id: 46,
              frequency: 68036,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b73',
              id: 47,
              frequency: 63960,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b72',
              id: 48,
              frequency: 110291,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b71',
              id: 49,
              frequency: 1768,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b70',
              id: 50,
              frequency: 2054,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b6f',
              id: 51,
              frequency: 48266,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b6e',
              id: 52,
              frequency: 16439,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b6d',
              id: 53,
              frequency: 50930,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b6c',
              id: 54,
              frequency: 9756,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b6b',
              id: 55,
              frequency: 8010,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b6a',
              id: 56,
              frequency: 23668,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b69',
              id: 57,
              frequency: 95813,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b68',
              id: 58,
              frequency: 44879,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b67',
              id: 59,
              frequency: 81960,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b66',
              id: 60,
              frequency: 98104,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b65',
              id: 61,
              frequency: 56897,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b64',
              id: 62,
              frequency: 10161,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b63',
              id: 63,
              frequency: 28887,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b62',
              id: 64,
              frequency: 18148,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b61',
              id: 65,
              frequency: 39276,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b60',
              id: 66,
              frequency: 77042,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b5f',
              id: 67,
              frequency: 98347,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b5e',
              id: 68,
              frequency: 40409,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b5d',
              id: 69,
              frequency: 9176,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b5c',
              id: 70,
              frequency: 51608,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b5b',
              id: 71,
              frequency: 69213,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b5a',
              id: 72,
              frequency: 39261,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0b00',
          id: 87,
          abbrevName: '88',
          fullName: '88_L_IFG_pars_opercularis_juxtapositional_lobule_smc',
          coordinates: {
            x: 1.178378,
            y: -1.718919,
            z: 60.972973,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0b09',
              to: 88,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b08',
              to: 89,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b07',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b06',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b05',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b04',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b03',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b02',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b01',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0b52',
              id: 0,
              frequency: 59,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b51',
              id: 1,
              frequency: 937,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b50',
              id: 2,
              frequency: 622,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b4f',
              id: 3,
              frequency: 1089,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b4e',
              id: 4,
              frequency: 8441,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b4d',
              id: 5,
              frequency: 13707,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b4c',
              id: 6,
              frequency: 2793,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b4b',
              id: 7,
              frequency: 1343,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b4a',
              id: 8,
              frequency: 3121,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b49',
              id: 9,
              frequency: 5644,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b48',
              id: 10,
              frequency: 16339,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b47',
              id: 11,
              frequency: 10097,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b46',
              id: 12,
              frequency: 9029,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b45',
              id: 13,
              frequency: 11231,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b44',
              id: 14,
              frequency: 9838,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b43',
              id: 15,
              frequency: 38450,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b42',
              id: 16,
              frequency: 69789,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b41',
              id: 17,
              frequency: 38587,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b40',
              id: 18,
              frequency: 14353,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b3f',
              id: 19,
              frequency: 27420,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b3e',
              id: 20,
              frequency: 28450,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b3d',
              id: 21,
              frequency: 27794,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b3c',
              id: 22,
              frequency: 2527,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b3b',
              id: 23,
              frequency: 453,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b3a',
              id: 24,
              frequency: 41117,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b39',
              id: 25,
              frequency: 28893,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b38',
              id: 26,
              frequency: 83150,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b37',
              id: 27,
              frequency: 30351,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b36',
              id: 28,
              frequency: 61627,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b35',
              id: 29,
              frequency: 107698,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b34',
              id: 30,
              frequency: 90881,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b33',
              id: 31,
              frequency: 14797,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b32',
              id: 32,
              frequency: 27641,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b31',
              id: 33,
              frequency: 13345,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b30',
              id: 34,
              frequency: 21973,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b2f',
              id: 35,
              frequency: 6249,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b2e',
              id: 36,
              frequency: 12806,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b2d',
              id: 37,
              frequency: 25962,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b2c',
              id: 38,
              frequency: 15002,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b2b',
              id: 39,
              frequency: 17432,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b2a',
              id: 40,
              frequency: 54867,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b29',
              id: 41,
              frequency: 36611,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b28',
              id: 42,
              frequency: 35892,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b27',
              id: 43,
              frequency: 58766,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b26',
              id: 44,
              frequency: 23102,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b25',
              id: 45,
              frequency: 27900,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b24',
              id: 46,
              frequency: 47020,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b23',
              id: 47,
              frequency: 66746,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b22',
              id: 48,
              frequency: 134663,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b21',
              id: 49,
              frequency: 1829,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b20',
              id: 50,
              frequency: 1907,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b1f',
              id: 51,
              frequency: 41200,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b1e',
              id: 52,
              frequency: 15614,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b1d',
              id: 53,
              frequency: 52814,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b1c',
              id: 54,
              frequency: 10708,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b1b',
              id: 55,
              frequency: 10814,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b1a',
              id: 56,
              frequency: 18153,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b19',
              id: 57,
              frequency: 126068,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b18',
              id: 58,
              frequency: 47288,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b17',
              id: 59,
              frequency: 76065,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b16',
              id: 60,
              frequency: 109826,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b15',
              id: 61,
              frequency: 58845,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b14',
              id: 62,
              frequency: 8342,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b13',
              id: 63,
              frequency: 22821,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b12',
              id: 64,
              frequency: 20907,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b11',
              id: 65,
              frequency: 36505,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b10',
              id: 66,
              frequency: 91849,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b0f',
              id: 67,
              frequency: 114996,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b0e',
              id: 68,
              frequency: 37811,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b0d',
              id: 69,
              frequency: 10015,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b0c',
              id: 70,
              frequency: 49263,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b0b',
              id: 71,
              frequency: 86430,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0b0a',
              id: 72,
              frequency: 53946,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0ab2',
          id: 88,
          abbrevName: '89',
          fullName: '89_R_Temporal_fusiform_cortex_anterior__itg_anterior',
          coordinates: {
            x: 40.509804,
            y: -5.895425,
            z: -39.869281,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0ab6',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ab5',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ab4',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ab3',
              to: 89,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0aff',
              id: 0,
              frequency: 39,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0afe',
              id: 1,
              frequency: 982,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0afd',
              id: 2,
              frequency: 254,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0afc',
              id: 3,
              frequency: 487,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0afb',
              id: 4,
              frequency: 12851,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0afa',
              id: 5,
              frequency: 8410,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0af9',
              id: 6,
              frequency: 5150,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0af8',
              id: 7,
              frequency: 442,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0af7',
              id: 8,
              frequency: 1771,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0af6',
              id: 9,
              frequency: 9613,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0af5',
              id: 10,
              frequency: 11968,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0af4',
              id: 11,
              frequency: 2450,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0af3',
              id: 12,
              frequency: 6698,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0af2',
              id: 13,
              frequency: 3172,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0af1',
              id: 14,
              frequency: 3075,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0af0',
              id: 15,
              frequency: 94415,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0aef',
              id: 16,
              frequency: 70327,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0aee',
              id: 17,
              frequency: 30874,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0aed',
              id: 18,
              frequency: 27061,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0aec',
              id: 19,
              frequency: 75999,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0aeb',
              id: 20,
              frequency: 29579,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0aea',
              id: 21,
              frequency: 14419,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ae9',
              id: 22,
              frequency: 6696,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ae8',
              id: 23,
              frequency: 225,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ae7',
              id: 24,
              frequency: 96615,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ae6',
              id: 25,
              frequency: 34427,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ae5',
              id: 26,
              frequency: 36774,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ae4',
              id: 27,
              frequency: 77521,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ae3',
              id: 28,
              frequency: 68134,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ae2',
              id: 29,
              frequency: 117795,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ae1',
              id: 30,
              frequency: 28249,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ae0',
              id: 31,
              frequency: 48749,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0adf',
              id: 32,
              frequency: 31353,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ade',
              id: 33,
              frequency: 2739,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0add',
              id: 34,
              frequency: 15599,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0adc',
              id: 35,
              frequency: 18992,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0adb',
              id: 36,
              frequency: 9785,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ada',
              id: 37,
              frequency: 24639,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ad9',
              id: 38,
              frequency: 6362,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ad8',
              id: 39,
              frequency: 49311,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ad7',
              id: 40,
              frequency: 71375,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ad6',
              id: 41,
              frequency: 19295,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ad5',
              id: 42,
              frequency: 6829,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ad4',
              id: 43,
              frequency: 73072,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ad3',
              id: 44,
              frequency: 2752,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ad2',
              id: 45,
              frequency: 68697,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ad1',
              id: 46,
              frequency: 45163,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ad0',
              id: 47,
              frequency: 26376,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0acf',
              id: 48,
              frequency: 54699,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ace',
              id: 49,
              frequency: 2509,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0acd',
              id: 50,
              frequency: 556,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0acc',
              id: 51,
              frequency: 34736,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0acb',
              id: 52,
              frequency: 18683,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0aca',
              id: 53,
              frequency: 18163,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ac9',
              id: 54,
              frequency: 16868,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ac8',
              id: 55,
              frequency: 2705,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ac7',
              id: 56,
              frequency: 52524,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ac6',
              id: 57,
              frequency: 62025,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ac5',
              id: 58,
              frequency: 6794,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ac4',
              id: 59,
              frequency: 87020,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ac3',
              id: 60,
              frequency: 50722,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ac2',
              id: 61,
              frequency: 8511,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ac1',
              id: 62,
              frequency: 7928,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ac0',
              id: 63,
              frequency: 7604,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0abf',
              id: 64,
              frequency: 8375,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0abe',
              id: 65,
              frequency: 43238,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0abd',
              id: 66,
              frequency: 51534,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0abc',
              id: 67,
              frequency: 20652,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0abb',
              id: 68,
              frequency: 15751,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0aba',
              id: 69,
              frequency: 1358,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ab9',
              id: 70,
              frequency: 26696,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ab8',
              id: 71,
              frequency: 17745,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ab7',
              id: 72,
              frequency: 11941,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0a60',
          id: 89,
          abbrevName: '90',
          fullName: '90_L_Temporal_fusiform_gyrus_posterior_pcc_phc_hc',
          coordinates: {
            x: -23.992395,
            y: -38.197719,
            z: -14.768061,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0a68',
              to: 90,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a67',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a66',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a65',
              to: 93,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a64',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a63',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a62',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a61',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0ab1',
              id: 0,
              frequency: 72,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0ab0',
              id: 1,
              frequency: 766,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0aaf',
              id: 2,
              frequency: 1141,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0aae',
              id: 3,
              frequency: 1415,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0aad',
              id: 4,
              frequency: 5285,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0aac',
              id: 5,
              frequency: 16801,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0aab',
              id: 6,
              frequency: 1175,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0aaa',
              id: 7,
              frequency: 5508,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0aa9',
              id: 8,
              frequency: 3049,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0aa8',
              id: 9,
              frequency: 3751,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0aa7',
              id: 10,
              frequency: 15829,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0aa6',
              id: 11,
              frequency: 22644,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0aa5',
              id: 12,
              frequency: 7829,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0aa4',
              id: 13,
              frequency: 18058,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0aa3',
              id: 14,
              frequency: 13430,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0aa2',
              id: 15,
              frequency: 17888,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0aa1',
              id: 16,
              frequency: 75707,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0aa0',
              id: 17,
              frequency: 27031,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a9f',
              id: 18,
              frequency: 3574,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a9e',
              id: 19,
              frequency: 6574,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a9d',
              id: 20,
              frequency: 16601,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a9c',
              id: 21,
              frequency: 81310,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a9b',
              id: 22,
              frequency: 440,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a9a',
              id: 23,
              frequency: 10090,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a99',
              id: 24,
              frequency: 14113,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a98',
              id: 25,
              frequency: 16329,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a97',
              id: 26,
              frequency: 165087,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a96',
              id: 27,
              frequency: 18761,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a95',
              id: 28,
              frequency: 65816,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a94',
              id: 29,
              frequency: 83235,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a93',
              id: 30,
              frequency: 115643,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a92',
              id: 31,
              frequency: 4438,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a91',
              id: 32,
              frequency: 12334,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a90',
              id: 33,
              frequency: 87066,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a8f',
              id: 34,
              frequency: 18841,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a8e',
              id: 35,
              frequency: 2316,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a8d',
              id: 36,
              frequency: 7869,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a8c',
              id: 37,
              frequency: 14607,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a8b',
              id: 38,
              frequency: 31854,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a8a',
              id: 39,
              frequency: 7029,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a89',
              id: 40,
              frequency: 27997,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a88',
              id: 41,
              frequency: 50058,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a87',
              id: 42,
              frequency: 135801,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a86',
              id: 43,
              frequency: 52604,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a85',
              id: 44,
              frequency: 63807,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a84',
              id: 45,
              frequency: 15319,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a83',
              id: 46,
              frequency: 26527,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a82',
              id: 47,
              frequency: 104807,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a81',
              id: 48,
              frequency: 150953,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a80',
              id: 49,
              frequency: 1006,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a7f',
              id: 50,
              frequency: 2502,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a7e',
              id: 51,
              frequency: 30874,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a7d',
              id: 52,
              frequency: 12599,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a7c',
              id: 53,
              frequency: 69205,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a7b',
              id: 54,
              frequency: 4937,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a7a',
              id: 55,
              frequency: 29759,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a79',
              id: 56,
              frequency: 11447,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a78',
              id: 57,
              frequency: 126734,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a77',
              id: 58,
              frequency: 130195,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a76',
              id: 59,
              frequency: 53747,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a75',
              id: 60,
              frequency: 123597,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a74',
              id: 61,
              frequency: 127825,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a73',
              id: 62,
              frequency: 6815,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a72',
              id: 63,
              frequency: 23538,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a71',
              id: 64,
              frequency: 23843,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a70',
              id: 65,
              frequency: 24825,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a6f',
              id: 66,
              frequency: 98959,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a6e',
              id: 67,
              frequency: 215239,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a6d',
              id: 68,
              frequency: 33946,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a6c',
              id: 69,
              frequency: 15560,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a6b',
              id: 70,
              frequency: 43079,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a6a',
              id: 71,
              frequency: 136278,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a69',
              id: 72,
              frequency: 77170,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0a12',
          id: 90,
          abbrevName: '91',
          fullName: '91_BI_Occipital_pole_cuneal_cortex',
          coordinates: {
            x: 0.280374,
            y: -88,
            z: 21.981308,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0a16',
              to: 91,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a15',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a14',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a13',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0a5f',
              id: 0,
              frequency: 50,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a5e',
              id: 1,
              frequency: 972,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a5d',
              id: 2,
              frequency: 338,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a5c',
              id: 3,
              frequency: 887,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a5b',
              id: 4,
              frequency: 9965,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a5a',
              id: 5,
              frequency: 9177,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a59',
              id: 6,
              frequency: 4150,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a58',
              id: 7,
              frequency: 349,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a57',
              id: 8,
              frequency: 2152,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a56',
              id: 9,
              frequency: 6671,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a55',
              id: 10,
              frequency: 17409,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a54',
              id: 11,
              frequency: 4333,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a53',
              id: 12,
              frequency: 8369,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a52',
              id: 13,
              frequency: 6511,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a51',
              id: 14,
              frequency: 8407,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a50',
              id: 15,
              frequency: 60975,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a4f',
              id: 16,
              frequency: 54818,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a4e',
              id: 17,
              frequency: 32798,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a4d',
              id: 18,
              frequency: 18547,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a4c',
              id: 19,
              frequency: 50716,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a4b',
              id: 20,
              frequency: 26078,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a4a',
              id: 21,
              frequency: 8808,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a49',
              id: 22,
              frequency: 5268,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a48',
              id: 23,
              frequency: 49,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a47',
              id: 24,
              frequency: 54310,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a46',
              id: 25,
              frequency: 45019,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a45',
              id: 26,
              frequency: 46411,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a44',
              id: 27,
              frequency: 42843,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a43',
              id: 28,
              frequency: 50679,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a42',
              id: 29,
              frequency: 134027,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a41',
              id: 30,
              frequency: 46625,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a40',
              id: 31,
              frequency: 28974,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a3f',
              id: 32,
              frequency: 39903,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a3e',
              id: 33,
              frequency: 2091,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a3d',
              id: 34,
              frequency: 16022,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a3c',
              id: 35,
              frequency: 10351,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a3b',
              id: 36,
              frequency: 8503,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a3a',
              id: 37,
              frequency: 26386,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a39',
              id: 38,
              frequency: 5155,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a38',
              id: 39,
              frequency: 26943,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a37',
              id: 40,
              frequency: 75695,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a36',
              id: 41,
              frequency: 27408,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a35',
              id: 42,
              frequency: 8370,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a34',
              id: 43,
              frequency: 77692,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a33',
              id: 44,
              frequency: 7286,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a32',
              id: 45,
              frequency: 35611,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a31',
              id: 46,
              frequency: 46787,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a30',
              id: 47,
              frequency: 32471,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a2f',
              id: 48,
              frequency: 101737,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a2e',
              id: 49,
              frequency: 2393,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a2d',
              id: 50,
              frequency: 546,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a2c',
              id: 51,
              frequency: 31215,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a2b',
              id: 52,
              frequency: 20848,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a2a',
              id: 53,
              frequency: 29964,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a29',
              id: 54,
              frequency: 15251,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a28',
              id: 55,
              frequency: 3655,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a27',
              id: 56,
              frequency: 25087,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a26',
              id: 57,
              frequency: 143624,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a25',
              id: 58,
              frequency: 18280,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a24',
              id: 59,
              frequency: 83905,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a23',
              id: 60,
              frequency: 76266,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a22',
              id: 61,
              frequency: 20529,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a21',
              id: 62,
              frequency: 6582,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a20',
              id: 63,
              frequency: 12441,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a1f',
              id: 64,
              frequency: 17231,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a1e',
              id: 65,
              frequency: 35112,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a1d',
              id: 66,
              frequency: 102364,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a1c',
              id: 67,
              frequency: 57687,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a1b',
              id: 68,
              frequency: 24426,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a1a',
              id: 69,
              frequency: 3773,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a19',
              id: 70,
              frequency: 43106,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a18',
              id: 71,
              frequency: 57579,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a17',
              id: 72,
              frequency: 51001,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a09c1',
          id: 91,
          abbrevName: '92',
          fullName: '92_BI_Brainstem',
          coordinates: {
            x: 2.840183,
            y: -38.255708,
            z: -12.200913,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a09c8',
              to: 92,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09c7',
              to: 94,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09c6',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09c5',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09c4',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09c3',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09c2',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0a11',
              id: 0,
              frequency: 76,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a10',
              id: 1,
              frequency: 663,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a0f',
              id: 2,
              frequency: 1241,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a0e',
              id: 3,
              frequency: 1609,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a0d',
              id: 4,
              frequency: 3008,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a0c',
              id: 5,
              frequency: 15648,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a0b',
              id: 6,
              frequency: 980,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a0a',
              id: 7,
              frequency: 5578,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a09',
              id: 8,
              frequency: 2550,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a08',
              id: 9,
              frequency: 2413,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a07',
              id: 10,
              frequency: 14605,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a06',
              id: 11,
              frequency: 26157,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a05',
              id: 12,
              frequency: 7186,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a04',
              id: 13,
              frequency: 22786,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a03',
              id: 14,
              frequency: 15779,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a02',
              id: 15,
              frequency: 6644,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a01',
              id: 16,
              frequency: 45262,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0a00',
              id: 17,
              frequency: 26312,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09ff',
              id: 18,
              frequency: 1283,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09fe',
              id: 19,
              frequency: 5095,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09fd',
              id: 20,
              frequency: 15768,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09fc',
              id: 21,
              frequency: 71746,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09fb',
              id: 22,
              frequency: 394,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09fa',
              id: 23,
              frequency: 7861,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09f9',
              id: 24,
              frequency: 6084,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09f8',
              id: 25,
              frequency: 16160,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09f7',
              id: 26,
              frequency: 152550,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09f6',
              id: 27,
              frequency: 7812,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09f5',
              id: 28,
              frequency: 45835,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09f4',
              id: 29,
              frequency: 52590,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09f3',
              id: 30,
              frequency: 123640,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09f2',
              id: 31,
              frequency: 3282,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09f1',
              id: 32,
              frequency: 11407,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09f0',
              id: 33,
              frequency: 86976,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09ef',
              id: 34,
              frequency: 11920,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09ee',
              id: 35,
              frequency: 726,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09ed',
              id: 36,
              frequency: 3984,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09ec',
              id: 37,
              frequency: 11516,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09eb',
              id: 38,
              frequency: 26744,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09ea',
              id: 39,
              frequency: 3010,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09e9',
              id: 40,
              frequency: 24897,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09e8',
              id: 41,
              frequency: 49995,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09e7',
              id: 42,
              frequency: 163669,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09e6',
              id: 43,
              frequency: 36292,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09e5',
              id: 44,
              frequency: 80164,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09e4',
              id: 45,
              frequency: 6889,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09e3',
              id: 46,
              frequency: 14389,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09e2',
              id: 47,
              frequency: 102489,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09e1',
              id: 48,
              frequency: 162043,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09e0',
              id: 49,
              frequency: 620,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09df',
              id: 50,
              frequency: 1748,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09de',
              id: 51,
              frequency: 19787,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09dd',
              id: 52,
              frequency: 6759,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09dc',
              id: 53,
              frequency: 64716,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09db',
              id: 54,
              frequency: 4336,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09da',
              id: 55,
              frequency: 38129,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09d9',
              id: 56,
              frequency: 5648,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09d8',
              id: 57,
              frequency: 123986,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09d7',
              id: 58,
              frequency: 149278,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09d6',
              id: 59,
              frequency: 33857,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09d5',
              id: 60,
              frequency: 129405,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09d4',
              id: 61,
              frequency: 179174,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09d3',
              id: 62,
              frequency: 4448,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09d2',
              id: 63,
              frequency: 18767,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09d1',
              id: 64,
              frequency: 22083,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09d0',
              id: 65,
              frequency: 18154,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09cf',
              id: 66,
              frequency: 89964,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09ce',
              id: 67,
              frequency: 281333,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09cd',
              id: 68,
              frequency: 32379,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09cc',
              id: 69,
              frequency: 25823,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09cb',
              id: 70,
              frequency: 42127,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09ca',
              id: 71,
              frequency: 180508,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09c9',
              id: 72,
              frequency: 90060,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0975',
          id: 92,
          abbrevName: '93',
          fullName: '93_R_LOC__R_SPL',
          coordinates: {
            x: 16.382222,
            y: -55.386667,
            z: 62.24,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0977',
              to: 95,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0976',
              to: 98,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a09c0',
              id: 0,
              frequency: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09bf',
              id: 1,
              frequency: 835,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09be',
              id: 2,
              frequency: 497,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09bd',
              id: 3,
              frequency: 1043,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09bc',
              id: 4,
              frequency: 10870,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09bb',
              id: 5,
              frequency: 10253,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09ba',
              id: 6,
              frequency: 2076,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09b9',
              id: 7,
              frequency: 776,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09b8',
              id: 8,
              frequency: 2210,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09b7',
              id: 9,
              frequency: 5472,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09b6',
              id: 10,
              frequency: 16202,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09b5',
              id: 11,
              frequency: 7511,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09b4',
              id: 12,
              frequency: 7525,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09b3',
              id: 13,
              frequency: 9488,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09b2',
              id: 14,
              frequency: 9945,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09b1',
              id: 15,
              frequency: 56487,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09b0',
              id: 16,
              frequency: 92109,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09af',
              id: 17,
              frequency: 19504,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09ae',
              id: 18,
              frequency: 23568,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09ad',
              id: 19,
              frequency: 23337,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09ac',
              id: 20,
              frequency: 15911,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09ab',
              id: 21,
              frequency: 14910,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09aa',
              id: 22,
              frequency: 1294,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09a9',
              id: 23,
              frequency: 289,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09a8',
              id: 24,
              frequency: 44676,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09a7',
              id: 25,
              frequency: 20278,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09a6',
              id: 26,
              frequency: 68772,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09a5',
              id: 27,
              frequency: 61135,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09a4',
              id: 28,
              frequency: 51895,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09a3',
              id: 29,
              frequency: 163735,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09a2',
              id: 30,
              frequency: 58443,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09a1',
              id: 31,
              frequency: 11184,
            },
            {
              _id: '5d6615769bcb6d0e6d7a09a0',
              id: 32,
              frequency: 23759,
            },
            {
              _id: '5d6615769bcb6d0e6d7a099f',
              id: 33,
              frequency: 6754,
            },
            {
              _id: '5d6615769bcb6d0e6d7a099e',
              id: 34,
              frequency: 20898,
            },
            {
              _id: '5d6615769bcb6d0e6d7a099d',
              id: 35,
              frequency: 8305,
            },
            {
              _id: '5d6615769bcb6d0e6d7a099c',
              id: 36,
              frequency: 14760,
            },
            {
              _id: '5d6615769bcb6d0e6d7a099b',
              id: 37,
              frequency: 16006,
            },
            {
              _id: '5d6615769bcb6d0e6d7a099a',
              id: 38,
              frequency: 7527,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0999',
              id: 39,
              frequency: 17042,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0998',
              id: 40,
              frequency: 40124,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0997',
              id: 41,
              frequency: 36191,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0996',
              id: 42,
              frequency: 20118,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0995',
              id: 43,
              frequency: 72313,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0994',
              id: 44,
              frequency: 14661,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0993',
              id: 45,
              frequency: 41427,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0992',
              id: 46,
              frequency: 61870,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0991',
              id: 47,
              frequency: 43872,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0990',
              id: 48,
              frequency: 113784,
            },
            {
              _id: '5d6615769bcb6d0e6d7a098f',
              id: 49,
              frequency: 1557,
            },
            {
              _id: '5d6615769bcb6d0e6d7a098e',
              id: 50,
              frequency: 799,
            },
            {
              _id: '5d6615769bcb6d0e6d7a098d',
              id: 51,
              frequency: 30774,
            },
            {
              _id: '5d6615769bcb6d0e6d7a098c',
              id: 52,
              frequency: 18970,
            },
            {
              _id: '5d6615769bcb6d0e6d7a098b',
              id: 53,
              frequency: 37733,
            },
            {
              _id: '5d6615769bcb6d0e6d7a098a',
              id: 54,
              frequency: 7633,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0989',
              id: 55,
              frequency: 6346,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0988',
              id: 56,
              frequency: 21617,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0987',
              id: 57,
              frequency: 139330,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0986',
              id: 58,
              frequency: 35846,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0985',
              id: 59,
              frequency: 78236,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0984',
              id: 60,
              frequency: 83869,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0983',
              id: 61,
              frequency: 41999,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0982',
              id: 62,
              frequency: 5451,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0981',
              id: 63,
              frequency: 13866,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0980',
              id: 64,
              frequency: 18031,
            },
            {
              _id: '5d6615769bcb6d0e6d7a097f',
              id: 65,
              frequency: 28420,
            },
            {
              _id: '5d6615769bcb6d0e6d7a097e',
              id: 66,
              frequency: 91823,
            },
            {
              _id: '5d6615769bcb6d0e6d7a097d',
              id: 67,
              frequency: 94159,
            },
            {
              _id: '5d6615769bcb6d0e6d7a097c',
              id: 68,
              frequency: 25920,
            },
            {
              _id: '5d6615769bcb6d0e6d7a097b',
              id: 69,
              frequency: 7603,
            },
            {
              _id: '5d6615769bcb6d0e6d7a097a',
              id: 70,
              frequency: 40360,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0979',
              id: 71,
              frequency: 80490,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0978',
              id: 72,
              frequency: 59025,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a092a',
          id: 93,
          abbrevName: '94',
          fullName: '94_L_ITG_posterior_ifg_temporooccipital',
          coordinates: {
            x: -49.82716,
            y: -31.283951,
            z: -24.148148,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a092b',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0974',
              id: 0,
              frequency: 8,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0973',
              id: 1,
              frequency: 426,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0972',
              id: 2,
              frequency: 2,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0971',
              id: 3,
              frequency: 26,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0970',
              id: 4,
              frequency: 6488,
            },
            {
              _id: '5d6615769bcb6d0e6d7a096f',
              id: 5,
              frequency: 86,
            },
            {
              _id: '5d6615769bcb6d0e6d7a096e',
              id: 6,
              frequency: 4728,
            },
            {
              _id: '5d6615769bcb6d0e6d7a096d',
              id: 7,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d7a096c',
              id: 8,
              frequency: 57,
            },
            {
              _id: '5d6615769bcb6d0e6d7a096b',
              id: 9,
              frequency: 6574,
            },
            {
              _id: '5d6615769bcb6d0e6d7a096a',
              id: 10,
              frequency: 876,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0969',
              id: 11,
              frequency: 1,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0968',
              id: 12,
              frequency: 953,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0967',
              id: 13,
              frequency: 10,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0966',
              id: 14,
              frequency: 45,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0965',
              id: 15,
              frequency: 53616,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0964',
              id: 16,
              frequency: 743,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0963',
              id: 17,
              frequency: 688,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0962',
              id: 18,
              frequency: 18286,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0961',
              id: 19,
              frequency: 95269,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0960',
              id: 20,
              frequency: 355,
            },
            {
              _id: '5d6615769bcb6d0e6d7a095f',
              id: 21,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d7a095e',
              id: 22,
              frequency: 14224,
            },
            {
              _id: '5d6615769bcb6d0e6d7a095d',
              id: 23,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d7a095c',
              id: 24,
              frequency: 95144,
            },
            {
              _id: '5d6615769bcb6d0e6d7a095b',
              id: 25,
              frequency: 5370,
            },
            {
              _id: '5d6615769bcb6d0e6d7a095a',
              id: 26,
              frequency: 17,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0959',
              id: 27,
              frequency: 39603,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0958',
              id: 28,
              frequency: 541,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0957',
              id: 29,
              frequency: 7683,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0956',
              id: 30,
              frequency: 14,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0955',
              id: 31,
              frequency: 72416,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0954',
              id: 32,
              frequency: 3075,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0953',
              id: 33,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0952',
              id: 34,
              frequency: 231,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0951',
              id: 35,
              frequency: 18873,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0950',
              id: 36,
              frequency: 450,
            },
            {
              _id: '5d6615769bcb6d0e6d7a094f',
              id: 37,
              frequency: 1144,
            },
            {
              _id: '5d6615769bcb6d0e6d7a094e',
              id: 38,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d7a094d',
              id: 39,
              frequency: 63854,
            },
            {
              _id: '5d6615769bcb6d0e6d7a094c',
              id: 40,
              frequency: 15718,
            },
            {
              _id: '5d6615769bcb6d0e6d7a094b',
              id: 41,
              frequency: 56,
            },
            {
              _id: '5d6615769bcb6d0e6d7a094a',
              id: 42,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0949',
              id: 43,
              frequency: 5217,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0948',
              id: 44,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0947',
              id: 45,
              frequency: 53931,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0946',
              id: 46,
              frequency: 7746,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0945',
              id: 47,
              frequency: 15,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0944',
              id: 48,
              frequency: 175,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0943',
              id: 49,
              frequency: 224,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0942',
              id: 50,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0941',
              id: 51,
              frequency: 1304,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0940',
              id: 52,
              frequency: 1998,
            },
            {
              _id: '5d6615769bcb6d0e6d7a093f',
              id: 53,
              frequency: 11,
            },
            {
              _id: '5d6615769bcb6d0e6d7a093e',
              id: 54,
              frequency: 6178,
            },
            {
              _id: '5d6615769bcb6d0e6d7a093d',
              id: 55,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d7a093c',
              id: 56,
              frequency: 48711,
            },
            {
              _id: '5d6615769bcb6d0e6d7a093b',
              id: 57,
              frequency: 1019,
            },
            {
              _id: '5d6615769bcb6d0e6d7a093a',
              id: 58,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0939',
              id: 59,
              frequency: 14836,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0938',
              id: 60,
              frequency: 255,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0937',
              id: 61,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0936',
              id: 62,
              frequency: 560,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0935',
              id: 63,
              frequency: 23,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0934',
              id: 64,
              frequency: 48,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0933',
              id: 65,
              frequency: 11500,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0932',
              id: 66,
              frequency: 1276,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0931',
              id: 67,
              frequency: 5,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0930',
              id: 68,
              frequency: 237,
            },
            {
              _id: '5d6615769bcb6d0e6d7a092f',
              id: 69,
              frequency: 0,
            },
            {
              _id: '5d6615769bcb6d0e6d7a092e',
              id: 70,
              frequency: 1225,
            },
            {
              _id: '5d6615769bcb6d0e6d7a092d',
              id: 71,
              frequency: 20,
            },
            {
              _id: '5d6615769bcb6d0e6d7a092c',
              id: 72,
              frequency: 45,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a08dc',
          id: 94,
          abbrevName: '95',
          fullName: '95_BI_Paracingulate_ACC',
          coordinates: {
            x: 0.406639,
            y: 34.033195,
            z: 26.755187,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a08e0',
              to: 96,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08df',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08de',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08dd',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0929',
              id: 0,
              frequency: 51,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0928',
              id: 1,
              frequency: 998,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0927',
              id: 2,
              frequency: 474,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0926',
              id: 3,
              frequency: 801,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0925',
              id: 4,
              frequency: 11707,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0924',
              id: 5,
              frequency: 12596,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0923',
              id: 6,
              frequency: 3342,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0922',
              id: 7,
              frequency: 1018,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0921',
              id: 8,
              frequency: 2766,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0920',
              id: 9,
              frequency: 7824,
            },
            {
              _id: '5d6615769bcb6d0e6d7a091f',
              id: 10,
              frequency: 15364,
            },
            {
              _id: '5d6615769bcb6d0e6d7a091e',
              id: 11,
              frequency: 6427,
            },
            {
              _id: '5d6615769bcb6d0e6d7a091d',
              id: 12,
              frequency: 8204,
            },
            {
              _id: '5d6615769bcb6d0e6d7a091c',
              id: 13,
              frequency: 7318,
            },
            {
              _id: '5d6615769bcb6d0e6d7a091b',
              id: 14,
              frequency: 6062,
            },
            {
              _id: '5d6615769bcb6d0e6d7a091a',
              id: 15,
              frequency: 56337,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0919',
              id: 16,
              frequency: 88408,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0918',
              id: 17,
              frequency: 41371,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0917',
              id: 18,
              frequency: 19842,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0916',
              id: 19,
              frequency: 39073,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0915',
              id: 20,
              frequency: 27789,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0914',
              id: 21,
              frequency: 25456,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0913',
              id: 22,
              frequency: 3299,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0912',
              id: 23,
              frequency: 582,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0911',
              id: 24,
              frequency: 53441,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0910',
              id: 25,
              frequency: 32426,
            },
            {
              _id: '5d6615769bcb6d0e6d7a090f',
              id: 26,
              frequency: 71076,
            },
            {
              _id: '5d6615769bcb6d0e6d7a090e',
              id: 27,
              frequency: 70393,
            },
            {
              _id: '5d6615769bcb6d0e6d7a090d',
              id: 28,
              frequency: 72436,
            },
            {
              _id: '5d6615769bcb6d0e6d7a090c',
              id: 29,
              frequency: 127387,
            },
            {
              _id: '5d6615769bcb6d0e6d7a090b',
              id: 30,
              frequency: 62890,
            },
            {
              _id: '5d6615769bcb6d0e6d7a090a',
              id: 31,
              frequency: 24778,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0909',
              id: 32,
              frequency: 27661,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0908',
              id: 33,
              frequency: 9046,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0907',
              id: 34,
              frequency: 27126,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0906',
              id: 35,
              frequency: 8643,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0905',
              id: 36,
              frequency: 15245,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0904',
              id: 37,
              frequency: 26009,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0903',
              id: 38,
              frequency: 12906,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0902',
              id: 39,
              frequency: 25771,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0901',
              id: 40,
              frequency: 57715,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0900',
              id: 41,
              frequency: 31040,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08ff',
              id: 42,
              frequency: 21745,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08fe',
              id: 43,
              frequency: 76595,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08fd',
              id: 44,
              frequency: 11499,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08fc',
              id: 45,
              frequency: 54884,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08fb',
              id: 46,
              frequency: 51933,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08fa',
              id: 47,
              frequency: 53549,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08f9',
              id: 48,
              frequency: 106685,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08f8',
              id: 49,
              frequency: 1954,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08f7',
              id: 50,
              frequency: 1261,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08f6',
              id: 51,
              frequency: 47026,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08f5',
              id: 52,
              frequency: 20625,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08f4',
              id: 53,
              frequency: 40490,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08f3',
              id: 54,
              frequency: 12009,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08f2',
              id: 55,
              frequency: 6699,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08f1',
              id: 56,
              frequency: 38851,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08f0',
              id: 57,
              frequency: 97237,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08ef',
              id: 58,
              frequency: 24318,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08ee',
              id: 59,
              frequency: 92671,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08ed',
              id: 60,
              frequency: 89351,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08ec',
              id: 61,
              frequency: 32406,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08eb',
              id: 62,
              frequency: 9202,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08ea',
              id: 63,
              frequency: 16386,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08e9',
              id: 64,
              frequency: 17537,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08e8',
              id: 65,
              frequency: 42034,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08e7',
              id: 66,
              frequency: 76803,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08e6',
              id: 67,
              frequency: 63152,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08e5',
              id: 68,
              frequency: 28046,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08e4',
              id: 69,
              frequency: 5633,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08e3',
              id: 70,
              frequency: 36605,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08e2',
              id: 71,
              frequency: 47887,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08e1',
              id: 72,
              frequency: 26933,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0891',
          id: 95,
          abbrevName: '96',
          fullName: '96_R_Heschels__parietal_operculum_BA41',
          coordinates: {
            x: 45.586207,
            y: -21.425287,
            z: 15.011494,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0892',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a08db',
              id: 0,
              frequency: 47,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08da',
              id: 1,
              frequency: 949,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08d9',
              id: 2,
              frequency: 280,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08d8',
              id: 3,
              frequency: 801,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08d7',
              id: 4,
              frequency: 11685,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08d6',
              id: 5,
              frequency: 8139,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08d5',
              id: 6,
              frequency: 3765,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08d4',
              id: 7,
              frequency: 334,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08d3',
              id: 8,
              frequency: 1726,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08d2',
              id: 9,
              frequency: 7028,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08d1',
              id: 10,
              frequency: 16419,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08d0',
              id: 11,
              frequency: 3133,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08cf',
              id: 12,
              frequency: 7822,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08ce',
              id: 13,
              frequency: 5332,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08cd',
              id: 14,
              frequency: 7416,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08cc',
              id: 15,
              frequency: 75945,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08cb',
              id: 16,
              frequency: 57544,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08ca',
              id: 17,
              frequency: 32114,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08c9',
              id: 18,
              frequency: 24350,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08c8',
              id: 19,
              frequency: 49530,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08c7',
              id: 20,
              frequency: 21772,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08c6',
              id: 21,
              frequency: 8934,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08c5',
              id: 22,
              frequency: 5218,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08c4',
              id: 23,
              frequency: 69,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08c3',
              id: 24,
              frequency: 66745,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08c2',
              id: 25,
              frequency: 41799,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08c1',
              id: 26,
              frequency: 34690,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08c0',
              id: 27,
              frequency: 61982,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08bf',
              id: 28,
              frequency: 46997,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08be',
              id: 29,
              frequency: 150408,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08bd',
              id: 30,
              frequency: 37551,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08bc',
              id: 31,
              frequency: 25798,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08bb',
              id: 32,
              frequency: 35564,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08ba',
              id: 33,
              frequency: 2231,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08b9',
              id: 34,
              frequency: 17704,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08b8',
              id: 35,
              frequency: 11917,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08b7',
              id: 36,
              frequency: 9466,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08b6',
              id: 37,
              frequency: 19884,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08b5',
              id: 38,
              frequency: 5049,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08b4',
              id: 39,
              frequency: 27188,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08b3',
              id: 40,
              frequency: 68398,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08b2',
              id: 41,
              frequency: 23729,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08b1',
              id: 42,
              frequency: 6724,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08b0',
              id: 43,
              frequency: 78389,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08af',
              id: 44,
              frequency: 3702,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08ae',
              id: 45,
              frequency: 50277,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08ad',
              id: 46,
              frequency: 54675,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08ac',
              id: 47,
              frequency: 26121,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08ab',
              id: 48,
              frequency: 89376,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08aa',
              id: 49,
              frequency: 1376,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08a9',
              id: 50,
              frequency: 601,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08a8',
              id: 51,
              frequency: 29368,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08a7',
              id: 52,
              frequency: 24112,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08a6',
              id: 53,
              frequency: 21381,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08a5',
              id: 54,
              frequency: 12410,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08a4',
              id: 55,
              frequency: 3234,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08a3',
              id: 56,
              frequency: 29096,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08a2',
              id: 57,
              frequency: 132672,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08a1',
              id: 58,
              frequency: 11931,
            },
            {
              _id: '5d6615769bcb6d0e6d7a08a0',
              id: 59,
              frequency: 88276,
            },
            {
              _id: '5d6615769bcb6d0e6d7a089f',
              id: 60,
              frequency: 65498,
            },
            {
              _id: '5d6615769bcb6d0e6d7a089e',
              id: 61,
              frequency: 13107,
            },
            {
              _id: '5d6615769bcb6d0e6d7a089d',
              id: 62,
              frequency: 5566,
            },
            {
              _id: '5d6615769bcb6d0e6d7a089c',
              id: 63,
              frequency: 8592,
            },
            {
              _id: '5d6615769bcb6d0e6d7a089b',
              id: 64,
              frequency: 13683,
            },
            {
              _id: '5d6615769bcb6d0e6d7a089a',
              id: 65,
              frequency: 34563,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0899',
              id: 66,
              frequency: 93871,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0898',
              id: 67,
              frequency: 43127,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0897',
              id: 68,
              frequency: 18570,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0896',
              id: 69,
              frequency: 3021,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0895',
              id: 70,
              frequency: 40256,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0894',
              id: 71,
              frequency: 46815,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0893',
              id: 72,
              frequency: 44404,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0844',
          id: 96,
          abbrevName: '97',
          fullName: '97_L_BI_Frontal_pole_BA10',
          coordinates: {
            x: -3.131579,
            y: 63.815789,
            z: 7.236842,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a0847',
              to: 97,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0846',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0845',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0890',
              id: 0,
              frequency: 46,
            },
            {
              _id: '5d6615769bcb6d0e6d7a088f',
              id: 1,
              frequency: 901,
            },
            {
              _id: '5d6615769bcb6d0e6d7a088e',
              id: 2,
              frequency: 336,
            },
            {
              _id: '5d6615769bcb6d0e6d7a088d',
              id: 3,
              frequency: 699,
            },
            {
              _id: '5d6615769bcb6d0e6d7a088c',
              id: 4,
              frequency: 12625,
            },
            {
              _id: '5d6615769bcb6d0e6d7a088b',
              id: 5,
              frequency: 9388,
            },
            {
              _id: '5d6615769bcb6d0e6d7a088a',
              id: 6,
              frequency: 3128,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0889',
              id: 7,
              frequency: 624,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0888',
              id: 8,
              frequency: 1493,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0887',
              id: 9,
              frequency: 8045,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0886',
              id: 10,
              frequency: 14875,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0885',
              id: 11,
              frequency: 3671,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0884',
              id: 12,
              frequency: 6648,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0883',
              id: 13,
              frequency: 5570,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0882',
              id: 14,
              frequency: 5315,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0881',
              id: 15,
              frequency: 84694,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0880',
              id: 16,
              frequency: 89053,
            },
            {
              _id: '5d6615769bcb6d0e6d7a087f',
              id: 17,
              frequency: 24617,
            },
            {
              _id: '5d6615769bcb6d0e6d7a087e',
              id: 18,
              frequency: 24487,
            },
            {
              _id: '5d6615769bcb6d0e6d7a087d',
              id: 19,
              frequency: 40708,
            },
            {
              _id: '5d6615769bcb6d0e6d7a087c',
              id: 20,
              frequency: 22841,
            },
            {
              _id: '5d6615769bcb6d0e6d7a087b',
              id: 21,
              frequency: 18725,
            },
            {
              _id: '5d6615769bcb6d0e6d7a087a',
              id: 22,
              frequency: 2745,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0879',
              id: 23,
              frequency: 341,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0878',
              id: 24,
              frequency: 73185,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0877',
              id: 25,
              frequency: 32548,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0876',
              id: 26,
              frequency: 51304,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0875',
              id: 27,
              frequency: 85164,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0874',
              id: 28,
              frequency: 72424,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0873',
              id: 29,
              frequency: 158853,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0872',
              id: 30,
              frequency: 37417,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0871',
              id: 31,
              frequency: 22890,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0870',
              id: 32,
              frequency: 29692,
            },
            {
              _id: '5d6615769bcb6d0e6d7a086f',
              id: 33,
              frequency: 4378,
            },
            {
              _id: '5d6615769bcb6d0e6d7a086e',
              id: 34,
              frequency: 17263,
            },
            {
              _id: '5d6615769bcb6d0e6d7a086d',
              id: 35,
              frequency: 13758,
            },
            {
              _id: '5d6615769bcb6d0e6d7a086c',
              id: 36,
              frequency: 9726,
            },
            {
              _id: '5d6615769bcb6d0e6d7a086b',
              id: 37,
              frequency: 16108,
            },
            {
              _id: '5d6615769bcb6d0e6d7a086a',
              id: 38,
              frequency: 6233,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0869',
              id: 39,
              frequency: 31665,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0868',
              id: 40,
              frequency: 51385,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0867',
              id: 41,
              frequency: 31462,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0866',
              id: 42,
              frequency: 11700,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0865',
              id: 43,
              frequency: 88352,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0864',
              id: 44,
              frequency: 3994,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0863',
              id: 45,
              frequency: 65080,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0862',
              id: 46,
              frequency: 52379,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0861',
              id: 47,
              frequency: 30233,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0860',
              id: 48,
              frequency: 90927,
            },
            {
              _id: '5d6615769bcb6d0e6d7a085f',
              id: 49,
              frequency: 1106,
            },
            {
              _id: '5d6615769bcb6d0e6d7a085e',
              id: 50,
              frequency: 408,
            },
            {
              _id: '5d6615769bcb6d0e6d7a085d',
              id: 51,
              frequency: 29404,
            },
            {
              _id: '5d6615769bcb6d0e6d7a085c',
              id: 52,
              frequency: 22232,
            },
            {
              _id: '5d6615769bcb6d0e6d7a085b',
              id: 53,
              frequency: 18391,
            },
            {
              _id: '5d6615769bcb6d0e6d7a085a',
              id: 54,
              frequency: 9261,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0859',
              id: 55,
              frequency: 5012,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0858',
              id: 56,
              frequency: 43758,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0857',
              id: 57,
              frequency: 100892,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0856',
              id: 58,
              frequency: 11595,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0855',
              id: 59,
              frequency: 87615,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0854',
              id: 60,
              frequency: 67234,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0853',
              id: 61,
              frequency: 16981,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0852',
              id: 62,
              frequency: 4717,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0851',
              id: 63,
              frequency: 6623,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0850',
              id: 64,
              frequency: 10754,
            },
            {
              _id: '5d6615769bcb6d0e6d7a084f',
              id: 65,
              frequency: 37398,
            },
            {
              _id: '5d6615769bcb6d0e6d7a084e',
              id: 66,
              frequency: 70214,
            },
            {
              _id: '5d6615769bcb6d0e6d7a084d',
              id: 67,
              frequency: 40974,
            },
            {
              _id: '5d6615769bcb6d0e6d7a084c',
              id: 68,
              frequency: 15844,
            },
            {
              _id: '5d6615769bcb6d0e6d7a084b',
              id: 69,
              frequency: 4289,
            },
            {
              _id: '5d6615769bcb6d0e6d7a084a',
              id: 70,
              frequency: 28840,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0849',
              id: 71,
              frequency: 39854,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0848',
              id: 72,
              frequency: 24067,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a07f8',
          id: 97,
          abbrevName: '98',
          fullName: '98_L_Caudate_accumbens_putamen',
          coordinates: {
            x: -15.074627,
            y: 11.164179,
            z: 3.19403,
          },
          edges: [
            {
              _id: '5d6615769bcb6d0e6d7a07fa',
              to: 98,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07f9',
              to: 99,
            },
          ],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a0843',
              id: 0,
              frequency: 53,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0842',
              id: 1,
              frequency: 1003,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0841',
              id: 2,
              frequency: 507,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0840',
              id: 3,
              frequency: 871,
            },
            {
              _id: '5d6615769bcb6d0e6d7a083f',
              id: 4,
              frequency: 10383,
            },
            {
              _id: '5d6615769bcb6d0e6d7a083e',
              id: 5,
              frequency: 13103,
            },
            {
              _id: '5d6615769bcb6d0e6d7a083d',
              id: 6,
              frequency: 3492,
            },
            {
              _id: '5d6615769bcb6d0e6d7a083c',
              id: 7,
              frequency: 1051,
            },
            {
              _id: '5d6615769bcb6d0e6d7a083b',
              id: 8,
              frequency: 2770,
            },
            {
              _id: '5d6615769bcb6d0e6d7a083a',
              id: 9,
              frequency: 7351,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0839',
              id: 10,
              frequency: 16283,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0838',
              id: 11,
              frequency: 7133,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0837',
              id: 12,
              frequency: 8615,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0836',
              id: 13,
              frequency: 8438,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0835',
              id: 14,
              frequency: 6804,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0834',
              id: 15,
              frequency: 45494,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0833',
              id: 16,
              frequency: 81327,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0832',
              id: 17,
              frequency: 44344,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0831',
              id: 18,
              frequency: 14968,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0830',
              id: 19,
              frequency: 38060,
            },
            {
              _id: '5d6615769bcb6d0e6d7a082f',
              id: 20,
              frequency: 30714,
            },
            {
              _id: '5d6615769bcb6d0e6d7a082e',
              id: 21,
              frequency: 25813,
            },
            {
              _id: '5d6615769bcb6d0e6d7a082d',
              id: 22,
              frequency: 4093,
            },
            {
              _id: '5d6615769bcb6d0e6d7a082c',
              id: 23,
              frequency: 542,
            },
            {
              _id: '5d6615769bcb6d0e6d7a082b',
              id: 24,
              frequency: 44049,
            },
            {
              _id: '5d6615769bcb6d0e6d7a082a',
              id: 25,
              frequency: 36605,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0829',
              id: 26,
              frequency: 78706,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0828',
              id: 27,
              frequency: 58937,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0827',
              id: 28,
              frequency: 71203,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0826',
              id: 29,
              frequency: 119660,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0825',
              id: 30,
              frequency: 67095,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0824',
              id: 31,
              frequency: 24752,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0823',
              id: 32,
              frequency: 30118,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0822',
              id: 33,
              frequency: 9236,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0821',
              id: 34,
              frequency: 24709,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0820',
              id: 35,
              frequency: 6888,
            },
            {
              _id: '5d6615769bcb6d0e6d7a081f',
              id: 36,
              frequency: 13290,
            },
            {
              _id: '5d6615769bcb6d0e6d7a081e',
              id: 37,
              frequency: 26795,
            },
            {
              _id: '5d6615769bcb6d0e6d7a081d',
              id: 38,
              frequency: 12511,
            },
            {
              _id: '5d6615769bcb6d0e6d7a081c',
              id: 39,
              frequency: 22193,
            },
            {
              _id: '5d6615769bcb6d0e6d7a081b',
              id: 40,
              frequency: 63989,
            },
            {
              _id: '5d6615769bcb6d0e6d7a081a',
              id: 41,
              frequency: 34826,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0819',
              id: 42,
              frequency: 24321,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0818',
              id: 43,
              frequency: 76176,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0817',
              id: 44,
              frequency: 13071,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0816',
              id: 45,
              frequency: 46742,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0815',
              id: 46,
              frequency: 45768,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0814',
              id: 47,
              frequency: 57704,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0813',
              id: 48,
              frequency: 118998,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0812',
              id: 49,
              frequency: 1954,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0811',
              id: 50,
              frequency: 1109,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0810',
              id: 51,
              frequency: 43698,
            },
            {
              _id: '5d6615769bcb6d0e6d7a080f',
              id: 52,
              frequency: 18992,
            },
            {
              _id: '5d6615769bcb6d0e6d7a080e',
              id: 53,
              frequency: 43556,
            },
            {
              _id: '5d6615769bcb6d0e6d7a080d',
              id: 54,
              frequency: 13030,
            },
            {
              _id: '5d6615769bcb6d0e6d7a080c',
              id: 55,
              frequency: 7589,
            },
            {
              _id: '5d6615769bcb6d0e6d7a080b',
              id: 56,
              frequency: 35235,
            },
            {
              _id: '5d6615769bcb6d0e6d7a080a',
              id: 57,
              frequency: 106076,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0809',
              id: 58,
              frequency: 27620,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0808',
              id: 59,
              frequency: 89713,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0807',
              id: 60,
              frequency: 100747,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0806',
              id: 61,
              frequency: 39834,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0805',
              id: 62,
              frequency: 8824,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0804',
              id: 63,
              frequency: 15939,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0803',
              id: 64,
              frequency: 19403,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0802',
              id: 65,
              frequency: 41907,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0801',
              id: 66,
              frequency: 83908,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0800',
              id: 67,
              frequency: 74724,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07ff',
              id: 68,
              frequency: 30595,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07fe',
              id: 69,
              frequency: 7590,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07fd',
              id: 70,
              frequency: 39959,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07fc',
              id: 71,
              frequency: 57668,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07fb',
              id: 72,
              frequency: 30630,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a07ae',
          id: 98,
          abbrevName: '99',
          fullName: '99_L_Cerebellum_Crus',
          coordinates: {
            x: -12.514286,
            y: -79.077551,
            z: -37.469388,
          },
          edges: [],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a07f7',
              id: 0,
              frequency: 68,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07f6',
              id: 1,
              frequency: 854,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07f5',
              id: 2,
              frequency: 945,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07f4',
              id: 3,
              frequency: 1333,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07f3',
              id: 4,
              frequency: 4952,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07f2',
              id: 5,
              frequency: 16386,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07f1',
              id: 6,
              frequency: 1905,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07f0',
              id: 7,
              frequency: 3140,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07ef',
              id: 8,
              frequency: 3089,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07ee',
              id: 9,
              frequency: 4159,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07ed',
              id: 10,
              frequency: 16214,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07ec',
              id: 11,
              frequency: 17800,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07eb',
              id: 12,
              frequency: 9220,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07ea',
              id: 13,
              frequency: 17350,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07e9',
              id: 14,
              frequency: 11826,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07e8',
              id: 15,
              frequency: 14600,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07e7',
              id: 16,
              frequency: 54707,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07e6',
              id: 17,
              frequency: 40835,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07e5',
              id: 18,
              frequency: 4895,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07e4',
              id: 19,
              frequency: 12910,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07e3',
              id: 20,
              frequency: 24352,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07e2',
              id: 21,
              frequency: 54441,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07e1',
              id: 22,
              frequency: 1686,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07e0',
              id: 23,
              frequency: 2841,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07df',
              id: 24,
              frequency: 15287,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07de',
              id: 25,
              frequency: 26749,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07dd',
              id: 26,
              frequency: 133354,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07dc',
              id: 27,
              frequency: 15457,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07db',
              id: 28,
              frequency: 62165,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07da',
              id: 29,
              frequency: 67805,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07d9',
              id: 30,
              frequency: 113831,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07d8',
              id: 31,
              frequency: 8838,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07d7',
              id: 32,
              frequency: 20347,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07d6',
              id: 33,
              frequency: 39566,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07d5',
              id: 34,
              frequency: 16341,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07d4',
              id: 35,
              frequency: 1803,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07d3',
              id: 36,
              frequency: 7681,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07d2',
              id: 37,
              frequency: 19789,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07d1',
              id: 38,
              frequency: 22181,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07d0',
              id: 39,
              frequency: 7674,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07cf',
              id: 40,
              frequency: 44955,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07ce',
              id: 41,
              frequency: 48702,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07cd',
              id: 42,
              frequency: 90869,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07cc',
              id: 43,
              frequency: 47892,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07cb',
              id: 44,
              frequency: 48023,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07ca',
              id: 45,
              frequency: 13089,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07c9',
              id: 46,
              frequency: 25683,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07c8',
              id: 47,
              frequency: 100337,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07c7',
              id: 48,
              frequency: 158210,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07c6',
              id: 49,
              frequency: 1059,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07c5',
              id: 50,
              frequency: 1852,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07c4',
              id: 51,
              frequency: 32017,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07c3',
              id: 52,
              frequency: 10401,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07c2',
              id: 53,
              frequency: 65018,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07c1',
              id: 54,
              frequency: 8037,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07c0',
              id: 55,
              frequency: 22735,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07bf',
              id: 56,
              frequency: 12887,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07be',
              id: 57,
              frequency: 117049,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07bd',
              id: 58,
              frequency: 87211,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07bc',
              id: 59,
              frequency: 57043,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07bb',
              id: 60,
              frequency: 143314,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07ba',
              id: 61,
              frequency: 124199,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07b9',
              id: 62,
              frequency: 6661,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07b8',
              id: 63,
              frequency: 23843,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07b7',
              id: 64,
              frequency: 22074,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07b6',
              id: 65,
              frequency: 33107,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07b5',
              id: 66,
              frequency: 97289,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07b4',
              id: 67,
              frequency: 194007,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07b3',
              id: 68,
              frequency: 41359,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07b2',
              id: 69,
              frequency: 20051,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07b1',
              id: 70,
              frequency: 53673,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07b0',
              id: 71,
              frequency: 126030,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07af',
              id: 72,
              frequency: 58853,
            },
          ],
        },
        {
          _id: '5d6615769bcb6d0e6d7a0764',
          id: 99,
          abbrevName: '100',
          fullName: '100_L_Postcentral_precentral',
          coordinates: {
            x: -25.484444,
            y: -26.533333,
            z: 66.915556,
          },
          edges: [],
          orbits: [
            {
              _id: '5d6615769bcb6d0e6d7a07ad',
              id: 0,
              frequency: 54,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07ac',
              id: 1,
              frequency: 1065,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07ab',
              id: 2,
              frequency: 552,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07aa',
              id: 3,
              frequency: 879,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07a9',
              id: 4,
              frequency: 9076,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07a8',
              id: 5,
              frequency: 14406,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07a7',
              id: 6,
              frequency: 4304,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07a6',
              id: 7,
              frequency: 1459,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07a5',
              id: 8,
              frequency: 2980,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07a4',
              id: 9,
              frequency: 7230,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07a3',
              id: 10,
              frequency: 16101,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07a2',
              id: 11,
              frequency: 7931,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07a1',
              id: 12,
              frequency: 9989,
            },
            {
              _id: '5d6615769bcb6d0e6d7a07a0',
              id: 13,
              frequency: 8465,
            },
            {
              _id: '5d6615769bcb6d0e6d7a079f',
              id: 14,
              frequency: 6949,
            },
            {
              _id: '5d6615769bcb6d0e6d7a079e',
              id: 15,
              frequency: 48769,
            },
            {
              _id: '5d6615769bcb6d0e6d7a079d',
              id: 16,
              frequency: 71306,
            },
            {
              _id: '5d6615769bcb6d0e6d7a079c',
              id: 17,
              frequency: 53291,
            },
            {
              _id: '5d6615769bcb6d0e6d7a079b',
              id: 18,
              frequency: 13696,
            },
            {
              _id: '5d6615769bcb6d0e6d7a079a',
              id: 19,
              frequency: 44514,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0799',
              id: 20,
              frequency: 35756,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0798',
              id: 21,
              frequency: 35399,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0797',
              id: 22,
              frequency: 5013,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0796',
              id: 23,
              frequency: 1377,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0795',
              id: 24,
              frequency: 51999,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0794',
              id: 25,
              frequency: 44711,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0793',
              id: 26,
              frequency: 83424,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0792',
              id: 27,
              frequency: 33811,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0791',
              id: 28,
              frequency: 77622,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0790',
              id: 29,
              frequency: 96372,
            },
            {
              _id: '5d6615769bcb6d0e6d7a078f',
              id: 30,
              frequency: 71641,
            },
            {
              _id: '5d6615769bcb6d0e6d7a078e',
              id: 31,
              frequency: 28236,
            },
            {
              _id: '5d6615769bcb6d0e6d7a078d',
              id: 32,
              frequency: 31107,
            },
            {
              _id: '5d6615769bcb6d0e6d7a078c',
              id: 33,
              frequency: 14778,
            },
            {
              _id: '5d6615769bcb6d0e6d7a078b',
              id: 34,
              frequency: 22723,
            },
            {
              _id: '5d6615769bcb6d0e6d7a078a',
              id: 35,
              frequency: 9527,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0789',
              id: 36,
              frequency: 10393,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0788',
              id: 37,
              frequency: 34511,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0787',
              id: 38,
              frequency: 16667,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0786',
              id: 39,
              frequency: 27218,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0785',
              id: 40,
              frequency: 85502,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0784',
              id: 41,
              frequency: 34195,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0783',
              id: 42,
              frequency: 30700,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0782',
              id: 43,
              frequency: 63116,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0781',
              id: 44,
              frequency: 14768,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0780',
              id: 45,
              frequency: 32163,
            },
            {
              _id: '5d6615769bcb6d0e6d7a077f',
              id: 46,
              frequency: 41925,
            },
            {
              _id: '5d6615769bcb6d0e6d7a077e',
              id: 47,
              frequency: 74249,
            },
            {
              _id: '5d6615769bcb6d0e6d7a077d',
              id: 48,
              frequency: 112985,
            },
            {
              _id: '5d6615769bcb6d0e6d7a077c',
              id: 49,
              frequency: 2643,
            },
            {
              _id: '5d6615769bcb6d0e6d7a077b',
              id: 50,
              frequency: 1412,
            },
            {
              _id: '5d6615769bcb6d0e6d7a077a',
              id: 51,
              frequency: 41692,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0779',
              id: 52,
              frequency: 17651,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0778',
              id: 53,
              frequency: 44958,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0777',
              id: 54,
              frequency: 17975,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0776',
              id: 55,
              frequency: 8645,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0775',
              id: 56,
              frequency: 26264,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0774',
              id: 57,
              frequency: 101925,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0773',
              id: 58,
              frequency: 32863,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0772',
              id: 59,
              frequency: 86274,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0771',
              id: 60,
              frequency: 111833,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0770',
              id: 61,
              frequency: 39272,
            },
            {
              _id: '5d6615769bcb6d0e6d7a076f',
              id: 62,
              frequency: 8762,
            },
            {
              _id: '5d6615769bcb6d0e6d7a076e',
              id: 63,
              frequency: 18258,
            },
            {
              _id: '5d6615769bcb6d0e6d7a076d',
              id: 64,
              frequency: 17462,
            },
            {
              _id: '5d6615769bcb6d0e6d7a076c',
              id: 65,
              frequency: 48481,
            },
            {
              _id: '5d6615769bcb6d0e6d7a076b',
              id: 66,
              frequency: 88444,
            },
            {
              _id: '5d6615769bcb6d0e6d7a076a',
              id: 67,
              frequency: 77320,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0769',
              id: 68,
              frequency: 35121,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0768',
              id: 69,
              frequency: 6573,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0767',
              id: 70,
              frequency: 52134,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0766',
              id: 71,
              frequency: 57802,
            },
            {
              _id: '5d6615769bcb6d0e6d7a0765',
              id: 72,
              frequency: 32153,
            },
          ],
        },
      ],
    },
  },
  created: '2019-08-28T05:47:34.915Z',
  __v: 0,
};
